/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);
var isBuffer = __webpack_require__(24);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(20)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(26);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(8);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(8);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',

    data: function data() {
        return {
            name: '',
            email: '',
            tel: '',
            card_name: '',
            card_number: '',
            card_exp_m: '',
            card_exp_y: '',
            card_sec: '',
            member_type: '',
            donation: '',
            description: '',
            price_table: { '0': '10,000円', '1': '5,000円', '10': '20,000円', '11': '7,000円' },
            year: new Date().getYear() - 100,
            errors: {},
            items: {
                name: { label: 'お名前' },
                email: { label: 'メールアドレス' },
                tel: { label: '電話番号' },
                member_type: { label: '会員種別' },
                card_name: { label: 'クレジットカードのお名前' },
                card_number: { label: 'クレジットカード番号' },
                card_exp_m: { label: '有効期限(月)' },
                card_exp_y: { label: '有効期限(年)' },
                card_sec: { label: 'セキュリティコード' },
                donation: { label: '寄付金' }
            },
            isPush: false,
            loading: false
        };
    },


    methods: {
        loading_open: function loading_open() {
            this.loading = this.$loading.open({});
        },
        loading_close: function loading_close() {
            this.loading.close();
        },

        redirect: function redirect() {
            location.href = "/";
        },
        exec: function exec() {

            // 本来はajax通信をする
            var $form = document.getElementById('form');
            $form.addEventListener('submit', function (e) {
                e.preventDefault();
                // $form.submit(); or ajaxする など
            });

            var isValid = $form.checkValidity();

            if (isValid) {
                this.isPush = true;

                // AJAX     
                var card = {
                    name: this.card_name,
                    number: this.card_number,
                    cvc: this.card_sec,
                    exp_month: this.card_exp_m,
                    exp_year: String(this.card_exp_y)
                };

                Payjp.createToken(card, function (status, response) {
                    if (status == 200) {
                        console.log(response);
                        // handle token object and send back to your server. You can get token id from "response.id".
                        var params = {
                            name: this.name,
                            card_name: this.card_name,
                            email: this.email,
                            tel: this.tel,
                            member_type: this.member_type,
                            donation: this.donation,
                            description: this.description,
                            token: response.id
                        };

                        var t = location.search.substring(1).split('=');
                        if (t[0] == 'test') {
                            params.test = true;
                        }

                        if (window.confirm('送信します')) {
                            this.loading_open();

                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://nipponsaisei.jp/payment', params)
                            //axios.post('http://localhost:3000/payment',params)
                            .then(function (res) {
                                var _this = this;

                                //vueにバインドされている値を書き換えると表示に反映される
                                console.log(res);
                                this.loading_close();
                                this.$dialog.alert({
                                    title: '',
                                    hasIcon: true,
                                    message: 'お支払いが完了しました',
                                    confirmText: 'OK',
                                    icon: 'check-square',
                                    iconPack: 'fa',
                                    type: 'is-success',
                                    onConfirm: function onConfirm() {
                                        return _this.redirect();
                                    }
                                });
                            }.bind(this)).catch(function (res) {
                                this.loading_close();
                                //vueにバインドされている値を書き換えると表示に反映される
                                this.$dialog.alert({
                                    title: 'エラー',
                                    message: 'システムエラー',
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'times-circle',
                                    iconPack: 'fa'
                                });
                            }.bind(this));
                        } else {
                            this.isPush = false;
                        }
                    } else {
                        // handle error like displaying error message.
                        console.log('error');

                        var error = 'カード情報を確認して下さい';
                        if (response.error.code == 'card_declined') {
                            error = 'このカードはご利用できません(利用不可)';
                        } else if (response.error.code == 'expired_card') {
                            error = 'このカードはご利用できません（有効期限切れ）';
                        } else if (response.error.code == 'invalid_cvc') {
                            error = 'セキュリティコードを確認してください';
                        } else if (response.error.code == 'processing_error') {
                            error = 'プロセスエラー　もう一度入力してください';
                        } else {
                            error = 'エラー: ' + response.error.code;
                        };
                        this.isPush = false;

                        this.$dialog.alert({
                            title: 'エラー',
                            message: error,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa'
                        });
                        this.isPush = false;
                    };
                }.bind(this));
            } else {
                this.isPush = false;
            }
        },
        modal: function modal() {
            this.$modal.open('<p class="image is-4by3">\n                        <img src="./assets/img02.jpg">\n                    </p>');
        }
    },
    computed: {
        member_price: function member_price() {
            return this.price_table[this.member_type];
        }
    },

    mounted: function mounted() {

        document.getElementById('modal_on').addEventListener('click', function (event) {
            event.preventDefault();
            var modal = document.querySelector('.modal'); // assuming you have only 1
            var html = document.querySelector('html');
            modal.classList.add('is-active');
            html.classList.add('is-clipped');
        });

        var modal = document.querySelector('.modal'); // assuming you have only 1
        var html = document.querySelector('html');

        modal.querySelector('.modal-background').addEventListener('click', function (e) {
            e.preventDefault();
            modal.classList.remove('is-active');
            html.classList.remove('is-clipped');
        });
    }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(27);
var buildURL = __webpack_require__(29);
var parseHeaders = __webpack_require__(30);
var isURLSameOrigin = __webpack_require__(31);
var createError = __webpack_require__(9);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(32);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(33);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(28);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.10.0
(function() {
  var QJ, rreturn, rtrim;

  QJ = function(selector) {
    if (QJ.isDOMElement(selector)) {
      return selector;
    }
    return document.querySelectorAll(selector);
  };

  QJ.isDOMElement = function(el) {
    return el && (el.nodeName != null);
  };

  rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

  QJ.trim = function(text) {
    if (text === null) {
      return "";
    } else {
      return (text + "").replace(rtrim, "");
    }
  };

  rreturn = /\r/g;

  QJ.val = function(el, val) {
    var ret;
    if (arguments.length > 1) {
      return el.value = val;
    } else {
      ret = el.value;
      if (typeof ret === "string") {
        return ret.replace(rreturn, "");
      } else {
        if (ret === null) {
          return "";
        } else {
          return ret;
        }
      }
    }
  };

  QJ.preventDefault = function(eventObject) {
    if (typeof eventObject.preventDefault === "function") {
      eventObject.preventDefault();
      return;
    }
    eventObject.returnValue = false;
    return false;
  };

  QJ.normalizeEvent = function(e) {
    var original;
    original = e;
    e = {
      which: original.which != null ? original.which : void 0,
      target: original.target || original.srcElement,
      preventDefault: function() {
        return QJ.preventDefault(original);
      },
      originalEvent: original,
      data: original.data || original.detail
    };
    if (e.which == null) {
      e.which = original.charCode != null ? original.charCode : original.keyCode;
    }
    return e;
  };

  QJ.on = function(element, eventName, callback) {
    var el, i, j, len, len1, multEventName, originalCallback, ref;
    if (element.length) {
      for (i = 0, len = element.length; i < len; i++) {
        el = element[i];
        QJ.on(el, eventName, callback);
      }
      return;
    }
    if (eventName.match(" ")) {
      ref = eventName.split(" ");
      for (j = 0, len1 = ref.length; j < len1; j++) {
        multEventName = ref[j];
        QJ.on(element, multEventName, callback);
      }
      return;
    }
    originalCallback = callback;
    callback = function(e) {
      e = QJ.normalizeEvent(e);
      return originalCallback(e);
    };
    if (element.addEventListener) {
      return element.addEventListener(eventName, callback, false);
    }
    if (element.attachEvent) {
      eventName = "on" + eventName;
      return element.attachEvent(eventName, callback);
    }
    element['on' + eventName] = callback;
  };

  QJ.addClass = function(el, className) {
    var e;
    if (el.length) {
      return (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = el.length; i < len; i++) {
          e = el[i];
          results.push(QJ.addClass(e, className));
        }
        return results;
      })();
    }
    if (el.classList) {
      return el.classList.add(className);
    } else {
      return el.className += ' ' + className;
    }
  };

  QJ.hasClass = function(el, className) {
    var e, hasClass, i, len;
    if (el.length) {
      hasClass = true;
      for (i = 0, len = el.length; i < len; i++) {
        e = el[i];
        hasClass = hasClass && QJ.hasClass(e, className);
      }
      return hasClass;
    }
    if (el.classList) {
      return el.classList.contains(className);
    } else {
      return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
    }
  };

  QJ.removeClass = function(el, className) {
    var cls, e, i, len, ref, results;
    if (el.length) {
      return (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = el.length; i < len; i++) {
          e = el[i];
          results.push(QJ.removeClass(e, className));
        }
        return results;
      })();
    }
    if (el.classList) {
      ref = className.split(' ');
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        cls = ref[i];
        results.push(el.classList.remove(cls));
      }
      return results;
    } else {
      return el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  };

  QJ.toggleClass = function(el, className, bool) {
    var e;
    if (el.length) {
      return (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = el.length; i < len; i++) {
          e = el[i];
          results.push(QJ.toggleClass(e, className, bool));
        }
        return results;
      })();
    }
    if (bool) {
      if (!QJ.hasClass(el, className)) {
        return QJ.addClass(el, className);
      }
    } else {
      return QJ.removeClass(el, className);
    }
  };

  QJ.append = function(el, toAppend) {
    var e;
    if (el.length) {
      return (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = el.length; i < len; i++) {
          e = el[i];
          results.push(QJ.append(e, toAppend));
        }
        return results;
      })();
    }
    return el.insertAdjacentHTML('beforeend', toAppend);
  };

  QJ.find = function(el, selector) {
    if (el instanceof NodeList || el instanceof Array) {
      el = el[0];
    }
    return el.querySelectorAll(selector);
  };

  QJ.trigger = function(el, name, data) {
    var e, error, ev;
    try {
      ev = new CustomEvent(name, {
        detail: data
      });
    } catch (error) {
      e = error;
      ev = document.createEvent('CustomEvent');
      if (ev.initCustomEvent) {
        ev.initCustomEvent(name, true, true, data);
      } else {
        ev.initEvent(name, true, true, data);
      }
    }
    return el.dispatchEvent(ev);
  };

  module.exports = QJ;

}).call(this);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy_lib_buefy_css__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy_lib_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_buefy_lib_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise_auto__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_card__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(56);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_buefy___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.17
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.17';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(15).setImmediate))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(16);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e50b0fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(41);
function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var normalizeComponent = __webpack_require__(21)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e50b0fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(19);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("377a32cc", content, true, {});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;margin-top:60px}h1,h2{font-weight:400}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}a{color:#42b983}.dirty{border-color:#228b22;background:#f5fffa}.error{border-color:red;background:#ffe4e1}@media (max-width:430px){.input-middle,.input-small{width:100%}}.input-middle{width:20em}.input-small{width:16em}.input-tiny{width:5em}/*! bulma.io v0.7.1 | MIT License | github.com/jgthms/bulma */@keyframes spinAround{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.b-checkbox.checkbox,.b-radio.radio,.breadcrumb,.button,.delete,.file,.icon,.is-unselectable,.modal-close,.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous,.switch,.tabs{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.navbar-link:after,.select:not(.is-multiple):not(.is-loading):after{border:3px solid transparent;border-radius:2px;border-right:0;border-top:0;content:\" \";display:block;height:.625em;margin-top:-.4375em;pointer-events:none;position:absolute;top:50%;transform:rotate(-45deg);transform-origin:center;width:.625em}.block:not(:last-child),.box:not(:last-child),.breadcrumb:not(:last-child),.content:not(:last-child),.highlight:not(:last-child),.level:not(:last-child),.message:not(:last-child),.notification:not(:last-child),.progress:not(:last-child),.subtitle:not(:last-child),.table-container:not(:last-child),.table:not(:last-child),.tabs:not(:last-child),.title:not(:last-child){margin-bottom:1.5rem}.delete,.modal-close{-moz-appearance:none;-webkit-appearance:none;background-color:hsla(0,0%,4%,.2);border:none;border-radius:290486px;cursor:pointer;display:inline-block;flex-grow:0;flex-shrink:0;font-size:0;height:20px;max-height:20px;max-width:20px;min-height:20px;min-width:20px;outline:none;position:relative;vertical-align:top;width:20px}.delete:after,.delete:before,.modal-close:after,.modal-close:before{background-color:#fff;content:\"\";display:block;left:50%;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%) rotate(45deg);transform-origin:center center}.delete:before,.modal-close:before{height:2px;width:50%}.delete:after,.modal-close:after{height:50%;width:2px}.delete:focus,.delete:hover,.modal-close:focus,.modal-close:hover{background-color:hsla(0,0%,4%,.3)}.delete:active,.modal-close:active{background-color:hsla(0,0%,4%,.4)}.is-small.delete,.is-small.modal-close{height:16px;max-height:16px;max-width:16px;min-height:16px;min-width:16px;width:16px}.is-medium.delete,.is-medium.modal-close{height:24px;max-height:24px;max-width:24px;min-height:24px;min-width:24px;width:24px}.is-large.delete,.is-large.modal-close{height:32px;max-height:32px;max-width:32px;min-height:32px;min-width:32px;width:32px}.b-table.is-loading:after,.button.is-loading:after,.control.is-loading:after,.loader,.loading-overlay .loading-icon:after,.select.is-loading:after,.upload .upload-draggable.is-loading:after{animation:spinAround .5s infinite linear;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em}.dropdown .background,.hero-video,.image.is-1by1 img,.image.is-1by2 img,.image.is-1by3 img,.image.is-2by1 img,.image.is-2by3 img,.image.is-3by1 img,.image.is-3by2 img,.image.is-3by4 img,.image.is-3by5 img,.image.is-4by3 img,.image.is-4by5 img,.image.is-5by3 img,.image.is-5by4 img,.image.is-9by16 img,.image.is-16by9 img,.image.is-square img,.is-overlay,.loading-overlay,.loading-overlay .loading-background,.modal,.modal-background{bottom:0;left:0;position:absolute;right:0;top:0}.button,.file-cta,.file-name,.input,.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous,.select select,.taginput .taginput-container.is-focusable,.textarea{-moz-appearance:none;-webkit-appearance:none;align-items:center;border:1px solid transparent;border-radius:4px;box-shadow:none;display:inline-flex;font-size:1rem;height:2.25em;justify-content:flex-start;line-height:1.5;padding:calc(.375em - 1px) calc(.625em - 1px);position:relative;vertical-align:top}.button:active,.button:focus,.file-cta:active,.file-cta:focus,.file-name:active,.file-name:focus,.input:active,.input:focus,.is-active.button,.is-active.file-cta,.is-active.file-name,.is-active.input,.is-active.pagination-ellipsis,.is-active.pagination-link,.is-active.pagination-next,.is-active.pagination-previous,.is-active.textarea,.is-focused.button,.is-focused.file-cta,.is-focused.file-name,.is-focused.input,.is-focused.pagination-ellipsis,.is-focused.pagination-link,.is-focused.pagination-next,.is-focused.pagination-previous,.is-focused.textarea,.pagination-ellipsis:active,.pagination-ellipsis:focus,.pagination-link:active,.pagination-link:focus,.pagination-next:active,.pagination-next:focus,.pagination-previous:active,.pagination-previous:focus,.select select.is-active,.select select.is-focused,.select select:active,.select select:focus,.taginput .is-active.taginput-container.is-focusable,.taginput .is-focused.taginput-container.is-focusable,.taginput .taginput-container.is-focusable:active,.taginput .taginput-container.is-focusable:focus,.textarea:active,.textarea:focus{outline:none}.button[disabled],.file-cta[disabled],.file-name[disabled],.input[disabled],.pagination-ellipsis[disabled],.pagination-link[disabled],.pagination-next[disabled],.pagination-previous[disabled],.select select[disabled],.taginput .taginput-container.is-focusable[disabled],.textarea[disabled]{cursor:not-allowed}/*! minireset.css v0.0.3 | MIT License | github.com/jgthms/minireset.css */blockquote,body,dd,dl,dt,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,html,iframe,legend,li,ol,p,pre,textarea,ul{margin:0;padding:0}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}ul{list-style:none}button,input,select,textarea{margin:0}html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}audio,img,video{height:auto;max-width:100%}iframe{border:0}table{border-collapse:collapse;border-spacing:0}td,th{padding:0;text-align:left}html{background-color:#fff;font-size:16px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;min-width:300px;overflow-x:hidden;overflow-y:scroll;text-rendering:optimizeLegibility;text-size-adjust:100%}article,aside,figure,footer,header,hgroup,section{display:block}body,button,input,select,textarea{font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif}code,pre{-moz-osx-font-smoothing:auto;-webkit-font-smoothing:auto;font-family:monospace}body{color:#4a4a4a;font-size:1rem;font-weight:400;line-height:1.5}a{color:#3273dc;cursor:pointer;text-decoration:none}a strong{color:currentColor}a:hover{color:#363636}code{color:#ff3860;font-size:.875em;font-weight:400;padding:.25em .5em}code,hr{background-color:#f5f5f5}hr{border:none;display:block;height:2px;margin:1.5rem 0}img{height:auto;max-width:100%}input[type=checkbox],input[type=radio]{vertical-align:baseline}small{font-size:.875em}span{font-style:inherit;font-weight:inherit}strong{color:#363636;font-weight:700}pre{-webkit-overflow-scrolling:touch;background-color:#f5f5f5;color:#4a4a4a;font-size:.875em;overflow-x:auto;padding:1.25rem 1.5rem;white-space:pre;word-wrap:normal}pre code{background-color:transparent;color:currentColor;font-size:1em;padding:0}table td,table th{text-align:left;vertical-align:top}table th{color:#363636}.is-clearfix:after{clear:both;content:\" \";display:table}.is-pulled-left{float:left!important}.is-pulled-right{float:right!important}.is-clipped{overflow:hidden!important}.is-size-1{font-size:3rem!important}.is-size-2{font-size:2.5rem!important}.is-size-3{font-size:2rem!important}.is-size-4{font-size:1.5rem!important}.is-size-5{font-size:1.25rem!important}.is-size-6{font-size:1rem!important}.is-size-7{font-size:.75rem!important}@media screen and (max-width:768px){.is-size-1-mobile{font-size:3rem!important}.is-size-2-mobile{font-size:2.5rem!important}.is-size-3-mobile{font-size:2rem!important}.is-size-4-mobile{font-size:1.5rem!important}.is-size-5-mobile{font-size:1.25rem!important}.is-size-6-mobile{font-size:1rem!important}.is-size-7-mobile{font-size:.75rem!important}}@media print,screen and (min-width:769px){.is-size-1-tablet{font-size:3rem!important}.is-size-2-tablet{font-size:2.5rem!important}.is-size-3-tablet{font-size:2rem!important}.is-size-4-tablet{font-size:1.5rem!important}.is-size-5-tablet{font-size:1.25rem!important}.is-size-6-tablet{font-size:1rem!important}.is-size-7-tablet{font-size:.75rem!important}}@media screen and (max-width:1087px){.is-size-1-touch{font-size:3rem!important}.is-size-2-touch{font-size:2.5rem!important}.is-size-3-touch{font-size:2rem!important}.is-size-4-touch{font-size:1.5rem!important}.is-size-5-touch{font-size:1.25rem!important}.is-size-6-touch{font-size:1rem!important}.is-size-7-touch{font-size:.75rem!important}}@media screen and (min-width:1088px){.is-size-1-desktop{font-size:3rem!important}.is-size-2-desktop{font-size:2.5rem!important}.is-size-3-desktop{font-size:2rem!important}.is-size-4-desktop{font-size:1.5rem!important}.is-size-5-desktop{font-size:1.25rem!important}.is-size-6-desktop{font-size:1rem!important}.is-size-7-desktop{font-size:.75rem!important}}@media screen and (min-width:1280px){.is-size-1-widescreen{font-size:3rem!important}.is-size-2-widescreen{font-size:2.5rem!important}.is-size-3-widescreen{font-size:2rem!important}.is-size-4-widescreen{font-size:1.5rem!important}.is-size-5-widescreen{font-size:1.25rem!important}.is-size-6-widescreen{font-size:1rem!important}.is-size-7-widescreen{font-size:.75rem!important}}@media screen and (min-width:1472px){.is-size-1-fullhd{font-size:3rem!important}.is-size-2-fullhd{font-size:2.5rem!important}.is-size-3-fullhd{font-size:2rem!important}.is-size-4-fullhd{font-size:1.5rem!important}.is-size-5-fullhd{font-size:1.25rem!important}.is-size-6-fullhd{font-size:1rem!important}.is-size-7-fullhd{font-size:.75rem!important}}.has-text-centered{text-align:center!important}.has-text-justified{text-align:justify!important}.has-text-left{text-align:left!important}.has-text-right{text-align:right!important}@media screen and (max-width:768px){.has-text-centered-mobile{text-align:center!important}}@media print,screen and (min-width:769px){.has-text-centered-tablet{text-align:center!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-centered-tablet-only{text-align:center!important}}@media screen and (max-width:1087px){.has-text-centered-touch{text-align:center!important}}@media screen and (min-width:1088px){.has-text-centered-desktop{text-align:center!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-centered-desktop-only{text-align:center!important}}@media screen and (min-width:1280px){.has-text-centered-widescreen{text-align:center!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-centered-widescreen-only{text-align:center!important}}@media screen and (min-width:1472px){.has-text-centered-fullhd{text-align:center!important}}@media screen and (max-width:768px){.has-text-justified-mobile{text-align:justify!important}}@media print,screen and (min-width:769px){.has-text-justified-tablet{text-align:justify!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-justified-tablet-only{text-align:justify!important}}@media screen and (max-width:1087px){.has-text-justified-touch{text-align:justify!important}}@media screen and (min-width:1088px){.has-text-justified-desktop{text-align:justify!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-justified-desktop-only{text-align:justify!important}}@media screen and (min-width:1280px){.has-text-justified-widescreen{text-align:justify!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-justified-widescreen-only{text-align:justify!important}}@media screen and (min-width:1472px){.has-text-justified-fullhd{text-align:justify!important}}@media screen and (max-width:768px){.has-text-left-mobile{text-align:left!important}}@media print,screen and (min-width:769px){.has-text-left-tablet{text-align:left!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-left-tablet-only{text-align:left!important}}@media screen and (max-width:1087px){.has-text-left-touch{text-align:left!important}}@media screen and (min-width:1088px){.has-text-left-desktop{text-align:left!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-left-desktop-only{text-align:left!important}}@media screen and (min-width:1280px){.has-text-left-widescreen{text-align:left!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-left-widescreen-only{text-align:left!important}}@media screen and (min-width:1472px){.has-text-left-fullhd{text-align:left!important}}@media screen and (max-width:768px){.has-text-right-mobile{text-align:right!important}}@media print,screen and (min-width:769px){.has-text-right-tablet{text-align:right!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-right-tablet-only{text-align:right!important}}@media screen and (max-width:1087px){.has-text-right-touch{text-align:right!important}}@media screen and (min-width:1088px){.has-text-right-desktop{text-align:right!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-right-desktop-only{text-align:right!important}}@media screen and (min-width:1280px){.has-text-right-widescreen{text-align:right!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-right-widescreen-only{text-align:right!important}}@media screen and (min-width:1472px){.has-text-right-fullhd{text-align:right!important}}.is-capitalized{text-transform:capitalize!important}.is-lowercase{text-transform:lowercase!important}.is-uppercase{text-transform:uppercase!important}.is-italic{font-style:italic!important}.has-text-white{color:#fff!important}a.has-text-white:focus,a.has-text-white:hover{color:#e6e6e6!important}.has-background-white{background-color:#fff!important}.has-text-black{color:#0a0a0a!important}a.has-text-black:focus,a.has-text-black:hover{color:#000!important}.has-background-black{background-color:#0a0a0a!important}.has-text-light{color:#f5f5f5!important}a.has-text-light:focus,a.has-text-light:hover{color:#dbdbdb!important}.has-background-light{background-color:#f5f5f5!important}.has-text-dark{color:#363636!important}a.has-text-dark:focus,a.has-text-dark:hover{color:#1c1c1c!important}.has-background-dark{background-color:#363636!important}.has-text-primary{color:#00d1b2!important}a.has-text-primary:focus,a.has-text-primary:hover{color:#009e86!important}.has-background-primary{background-color:#00d1b2!important}.has-text-info{color:#209cee!important}a.has-text-info:focus,a.has-text-info:hover{color:#0f81cc!important}.has-background-info{background-color:#209cee!important}.has-text-success{color:#23d160!important}a.has-text-success:focus,a.has-text-success:hover{color:#1ca64c!important}.has-background-success{background-color:#23d160!important}.has-text-warning{color:#ffdd57!important}a.has-text-warning:focus,a.has-text-warning:hover{color:#ffd324!important}.has-background-warning{background-color:#ffdd57!important}.has-text-danger{color:#ff3860!important}a.has-text-danger:focus,a.has-text-danger:hover{color:#ff0537!important}.has-background-danger{background-color:#ff3860!important}.has-text-twitter{color:#4099ff!important}a.has-text-twitter:focus,a.has-text-twitter:hover{color:#0d7eff!important}.has-background-twitter{background-color:#4099ff!important}.has-text-black-bis{color:#121212!important}.has-background-black-bis{background-color:#121212!important}.has-text-black-ter{color:#242424!important}.has-background-black-ter{background-color:#242424!important}.has-text-grey-darker{color:#363636!important}.has-background-grey-darker{background-color:#363636!important}.has-text-grey-dark{color:#4a4a4a!important}.has-background-grey-dark{background-color:#4a4a4a!important}.has-text-grey{color:#7a7a7a!important}.has-background-grey{background-color:#7a7a7a!important}.has-text-grey-light{color:#b5b5b5!important}.has-background-grey-light{background-color:#b5b5b5!important}.has-text-grey-lighter{color:#dbdbdb!important}.has-background-grey-lighter{background-color:#dbdbdb!important}.has-text-white-ter{color:#f5f5f5!important}.has-background-white-ter{background-color:#f5f5f5!important}.has-text-white-bis{color:#fafafa!important}.has-background-white-bis{background-color:#fafafa!important}.has-text-weight-light{font-weight:300!important}.has-text-weight-normal{font-weight:400!important}.has-text-weight-semibold{font-weight:600!important}.has-text-weight-bold{font-weight:700!important}.is-block{display:block!important}@media screen and (max-width:768px){.is-block-mobile{display:block!important}}@media print,screen and (min-width:769px){.is-block-tablet{display:block!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-block-tablet-only{display:block!important}}@media screen and (max-width:1087px){.is-block-touch{display:block!important}}@media screen and (min-width:1088px){.is-block-desktop{display:block!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-block-desktop-only{display:block!important}}@media screen and (min-width:1280px){.is-block-widescreen{display:block!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-block-widescreen-only{display:block!important}}@media screen and (min-width:1472px){.is-block-fullhd{display:block!important}}.is-flex{display:flex!important}@media screen and (max-width:768px){.is-flex-mobile{display:flex!important}}@media print,screen and (min-width:769px){.is-flex-tablet{display:flex!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-flex-tablet-only{display:flex!important}}@media screen and (max-width:1087px){.is-flex-touch{display:flex!important}}@media screen and (min-width:1088px){.is-flex-desktop{display:flex!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-flex-desktop-only{display:flex!important}}@media screen and (min-width:1280px){.is-flex-widescreen{display:flex!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-flex-widescreen-only{display:flex!important}}@media screen and (min-width:1472px){.is-flex-fullhd{display:flex!important}}.is-inline{display:inline!important}@media screen and (max-width:768px){.is-inline-mobile{display:inline!important}}@media print,screen and (min-width:769px){.is-inline-tablet{display:inline!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-inline-tablet-only{display:inline!important}}@media screen and (max-width:1087px){.is-inline-touch{display:inline!important}}@media screen and (min-width:1088px){.is-inline-desktop{display:inline!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-inline-desktop-only{display:inline!important}}@media screen and (min-width:1280px){.is-inline-widescreen{display:inline!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-inline-widescreen-only{display:inline!important}}@media screen and (min-width:1472px){.is-inline-fullhd{display:inline!important}}.is-inline-block{display:inline-block!important}@media screen and (max-width:768px){.is-inline-block-mobile{display:inline-block!important}}@media print,screen and (min-width:769px){.is-inline-block-tablet{display:inline-block!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-inline-block-tablet-only{display:inline-block!important}}@media screen and (max-width:1087px){.is-inline-block-touch{display:inline-block!important}}@media screen and (min-width:1088px){.is-inline-block-desktop{display:inline-block!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-inline-block-desktop-only{display:inline-block!important}}@media screen and (min-width:1280px){.is-inline-block-widescreen{display:inline-block!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-inline-block-widescreen-only{display:inline-block!important}}@media screen and (min-width:1472px){.is-inline-block-fullhd{display:inline-block!important}}.is-inline-flex{display:inline-flex!important}@media screen and (max-width:768px){.is-inline-flex-mobile{display:inline-flex!important}}@media print,screen and (min-width:769px){.is-inline-flex-tablet{display:inline-flex!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-inline-flex-tablet-only{display:inline-flex!important}}@media screen and (max-width:1087px){.is-inline-flex-touch{display:inline-flex!important}}@media screen and (min-width:1088px){.is-inline-flex-desktop{display:inline-flex!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-inline-flex-desktop-only{display:inline-flex!important}}@media screen and (min-width:1280px){.is-inline-flex-widescreen{display:inline-flex!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-inline-flex-widescreen-only{display:inline-flex!important}}@media screen and (min-width:1472px){.is-inline-flex-fullhd{display:inline-flex!important}}.is-hidden{display:none!important}@media screen and (max-width:768px){.is-hidden-mobile{display:none!important}}@media print,screen and (min-width:769px){.is-hidden-tablet{display:none!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-hidden-tablet-only{display:none!important}}@media screen and (max-width:1087px){.is-hidden-touch{display:none!important}}@media screen and (min-width:1088px){.is-hidden-desktop{display:none!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-hidden-desktop-only{display:none!important}}@media screen and (min-width:1280px){.is-hidden-widescreen{display:none!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-hidden-widescreen-only{display:none!important}}@media screen and (min-width:1472px){.is-hidden-fullhd{display:none!important}}.is-invisible{visibility:hidden!important}@media screen and (max-width:768px){.is-invisible-mobile{visibility:hidden!important}}@media print,screen and (min-width:769px){.is-invisible-tablet{visibility:hidden!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-invisible-tablet-only{visibility:hidden!important}}@media screen and (max-width:1087px){.is-invisible-touch{visibility:hidden!important}}@media screen and (min-width:1088px){.is-invisible-desktop{visibility:hidden!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-invisible-desktop-only{visibility:hidden!important}}@media screen and (min-width:1280px){.is-invisible-widescreen{visibility:hidden!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-invisible-widescreen-only{visibility:hidden!important}}@media screen and (min-width:1472px){.is-invisible-fullhd{visibility:hidden!important}}.is-marginless{margin:0!important}.is-paddingless{padding:0!important}.is-radiusless{border-radius:0!important}.is-shadowless{box-shadow:none!important}.box{background-color:#fff;border-radius:6px;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);color:#4a4a4a;display:block;padding:1.25rem}a.box:focus,a.box:hover{box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px #3273dc}a.box:active{box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2),0 0 0 1px #3273dc}.button{background-color:#fff;border-color:#dbdbdb;border-width:1px;color:#363636;cursor:pointer;justify-content:center;padding:calc(.375em - 1px) .75em;text-align:center;white-space:nowrap}.button strong{color:inherit}.button .icon,.button .icon.is-large,.button .icon.is-medium,.button .icon.is-small{height:1.5em;width:1.5em}.button .icon:first-child:not(:last-child){margin-left:calc(-.375em - 1px);margin-right:.1875em}.button .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:calc(-.375em - 1px)}.button .icon:first-child:last-child{margin-left:calc(-.375em - 1px);margin-right:calc(-.375em - 1px)}.button.is-hovered,.button:hover{border-color:#b5b5b5;color:#363636}.button.is-focused,.button:focus{border-color:#3273dc;color:#363636}.button.is-focused:not(:active),.button:focus:not(:active){box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.button.is-active,.button:active{border-color:#4a4a4a;color:#363636}.button.is-text{background-color:transparent;border-color:transparent;color:#4a4a4a;text-decoration:underline}.button.is-text.is-focused,.button.is-text.is-hovered,.button.is-text:focus,.button.is-text:hover{background-color:#f5f5f5;color:#363636}.button.is-text.is-active,.button.is-text:active{background-color:#e8e8e8;color:#363636}.button.is-text[disabled]{background-color:transparent;border-color:transparent;box-shadow:none}.button.is-white{background-color:#fff;border-color:transparent;color:#0a0a0a}.button.is-white.is-hovered,.button.is-white:hover{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.button.is-white.is-focused,.button.is-white:focus{border-color:transparent;color:#0a0a0a}.button.is-white.is-focused:not(:active),.button.is-white:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.button.is-white.is-active,.button.is-white:active{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.button.is-white[disabled]{background-color:#fff;border-color:transparent;box-shadow:none}.button.is-white.is-inverted{background-color:#0a0a0a;color:#fff}.button.is-white.is-inverted:hover{background-color:#000}.button.is-white.is-inverted[disabled]{background-color:#0a0a0a;border-color:transparent;box-shadow:none;color:#fff}.button.is-white.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.button.is-white.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-white.is-outlined:focus,.button.is-white.is-outlined:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.button.is-white.is-outlined.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-white.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-white.is-inverted.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.button.is-white.is-inverted.is-outlined:focus,.button.is-white.is-inverted.is-outlined:hover{background-color:#0a0a0a;color:#fff}.button.is-white.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#0a0a0a;box-shadow:none;color:#0a0a0a}.button.is-black{background-color:#0a0a0a;border-color:transparent;color:#fff}.button.is-black.is-hovered,.button.is-black:hover{background-color:#040404;border-color:transparent;color:#fff}.button.is-black.is-focused,.button.is-black:focus{border-color:transparent;color:#fff}.button.is-black.is-focused:not(:active),.button.is-black:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.button.is-black.is-active,.button.is-black:active{background-color:#000;border-color:transparent;color:#fff}.button.is-black[disabled]{background-color:#0a0a0a;border-color:transparent;box-shadow:none}.button.is-black.is-inverted{background-color:#fff;color:#0a0a0a}.button.is-black.is-inverted:hover{background-color:#f2f2f2}.button.is-black.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#0a0a0a}.button.is-black.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-black.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.button.is-black.is-outlined:focus,.button.is-black.is-outlined:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.button.is-black.is-outlined.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.button.is-black.is-outlined[disabled]{background-color:transparent;border-color:#0a0a0a;box-shadow:none;color:#0a0a0a}.button.is-black.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-black.is-inverted.is-outlined:focus,.button.is-black.is-inverted.is-outlined:hover{background-color:#fff;color:#0a0a0a}.button.is-black.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-light{background-color:#f5f5f5;border-color:transparent;color:#363636}.button.is-light.is-hovered,.button.is-light:hover{background-color:#eee;border-color:transparent;color:#363636}.button.is-light.is-focused,.button.is-light:focus{border-color:transparent;color:#363636}.button.is-light.is-focused:not(:active),.button.is-light:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.button.is-light.is-active,.button.is-light:active{background-color:#e8e8e8;border-color:transparent;color:#363636}.button.is-light[disabled]{background-color:#f5f5f5;border-color:transparent;box-shadow:none}.button.is-light.is-inverted{background-color:#363636;color:#f5f5f5}.button.is-light.is-inverted:hover{background-color:#292929}.button.is-light.is-inverted[disabled]{background-color:#363636;border-color:transparent;box-shadow:none;color:#f5f5f5}.button.is-light.is-loading:after{border-color:transparent transparent #363636 #363636!important}.button.is-light.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.button.is-light.is-outlined:focus,.button.is-light.is-outlined:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.button.is-light.is-outlined.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.button.is-light.is-outlined[disabled]{background-color:transparent;border-color:#f5f5f5;box-shadow:none;color:#f5f5f5}.button.is-light.is-inverted.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.button.is-light.is-inverted.is-outlined:focus,.button.is-light.is-inverted.is-outlined:hover{background-color:#363636;color:#f5f5f5}.button.is-light.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#363636;box-shadow:none;color:#363636}.button.is-dark{background-color:#363636;border-color:transparent;color:#f5f5f5}.button.is-dark.is-hovered,.button.is-dark:hover{background-color:#2f2f2f;border-color:transparent;color:#f5f5f5}.button.is-dark.is-focused,.button.is-dark:focus{border-color:transparent;color:#f5f5f5}.button.is-dark.is-focused:not(:active),.button.is-dark:focus:not(:active){box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.button.is-dark.is-active,.button.is-dark:active{background-color:#292929;border-color:transparent;color:#f5f5f5}.button.is-dark[disabled]{background-color:#363636;border-color:transparent;box-shadow:none}.button.is-dark.is-inverted{background-color:#f5f5f5;color:#363636}.button.is-dark.is-inverted:hover{background-color:#e8e8e8}.button.is-dark.is-inverted[disabled]{background-color:#f5f5f5;border-color:transparent;box-shadow:none;color:#363636}.button.is-dark.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.button.is-dark.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.button.is-dark.is-outlined:focus,.button.is-dark.is-outlined:hover{background-color:#363636;border-color:#363636;color:#f5f5f5}.button.is-dark.is-outlined.is-loading:after{border-color:transparent transparent #363636 #363636!important}.button.is-dark.is-outlined[disabled]{background-color:transparent;border-color:#363636;box-shadow:none;color:#363636}.button.is-dark.is-inverted.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.button.is-dark.is-inverted.is-outlined:focus,.button.is-dark.is-inverted.is-outlined:hover{background-color:#f5f5f5;color:#363636}.button.is-dark.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#f5f5f5;box-shadow:none;color:#f5f5f5}.button.is-primary{background-color:#00d1b2;border-color:transparent;color:#fff}.button.is-primary.is-hovered,.button.is-primary:hover{background-color:#00c4a7;border-color:transparent;color:#fff}.button.is-primary.is-focused,.button.is-primary:focus{border-color:transparent;color:#fff}.button.is-primary.is-focused:not(:active),.button.is-primary:focus:not(:active){box-shadow:0 0 0 .125em rgba(0,209,178,.25)}.button.is-primary.is-active,.button.is-primary:active{background-color:#00b89c;border-color:transparent;color:#fff}.button.is-primary[disabled]{background-color:#00d1b2;border-color:transparent;box-shadow:none}.button.is-primary.is-inverted{background-color:#fff;color:#00d1b2}.button.is-primary.is-inverted:hover{background-color:#f2f2f2}.button.is-primary.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#00d1b2}.button.is-primary.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-primary.is-outlined{background-color:transparent;border-color:#00d1b2;color:#00d1b2}.button.is-primary.is-outlined:focus,.button.is-primary.is-outlined:hover{background-color:#00d1b2;border-color:#00d1b2;color:#fff}.button.is-primary.is-outlined.is-loading:after{border-color:transparent transparent #00d1b2 #00d1b2!important}.button.is-primary.is-outlined[disabled]{background-color:transparent;border-color:#00d1b2;box-shadow:none;color:#00d1b2}.button.is-primary.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-primary.is-inverted.is-outlined:focus,.button.is-primary.is-inverted.is-outlined:hover{background-color:#fff;color:#00d1b2}.button.is-primary.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-info{background-color:#209cee;border-color:transparent;color:#fff}.button.is-info.is-hovered,.button.is-info:hover{background-color:#1496ed;border-color:transparent;color:#fff}.button.is-info.is-focused,.button.is-info:focus{border-color:transparent;color:#fff}.button.is-info.is-focused:not(:active),.button.is-info:focus:not(:active){box-shadow:0 0 0 .125em rgba(32,156,238,.25)}.button.is-info.is-active,.button.is-info:active{background-color:#118fe4;border-color:transparent;color:#fff}.button.is-info[disabled]{background-color:#209cee;border-color:transparent;box-shadow:none}.button.is-info.is-inverted{background-color:#fff;color:#209cee}.button.is-info.is-inverted:hover{background-color:#f2f2f2}.button.is-info.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#209cee}.button.is-info.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-info.is-outlined{background-color:transparent;border-color:#209cee;color:#209cee}.button.is-info.is-outlined:focus,.button.is-info.is-outlined:hover{background-color:#209cee;border-color:#209cee;color:#fff}.button.is-info.is-outlined.is-loading:after{border-color:transparent transparent #209cee #209cee!important}.button.is-info.is-outlined[disabled]{background-color:transparent;border-color:#209cee;box-shadow:none;color:#209cee}.button.is-info.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-info.is-inverted.is-outlined:focus,.button.is-info.is-inverted.is-outlined:hover{background-color:#fff;color:#209cee}.button.is-info.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-success{background-color:#23d160;border-color:transparent;color:#fff}.button.is-success.is-hovered,.button.is-success:hover{background-color:#22c65b;border-color:transparent;color:#fff}.button.is-success.is-focused,.button.is-success:focus{border-color:transparent;color:#fff}.button.is-success.is-focused:not(:active),.button.is-success:focus:not(:active){box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.button.is-success.is-active,.button.is-success:active{background-color:#20bc56;border-color:transparent;color:#fff}.button.is-success[disabled]{background-color:#23d160;border-color:transparent;box-shadow:none}.button.is-success.is-inverted{background-color:#fff;color:#23d160}.button.is-success.is-inverted:hover{background-color:#f2f2f2}.button.is-success.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#23d160}.button.is-success.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-success.is-outlined{background-color:transparent;border-color:#23d160;color:#23d160}.button.is-success.is-outlined:focus,.button.is-success.is-outlined:hover{background-color:#23d160;border-color:#23d160;color:#fff}.button.is-success.is-outlined.is-loading:after{border-color:transparent transparent #23d160 #23d160!important}.button.is-success.is-outlined[disabled]{background-color:transparent;border-color:#23d160;box-shadow:none;color:#23d160}.button.is-success.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-success.is-inverted.is-outlined:focus,.button.is-success.is-inverted.is-outlined:hover{background-color:#fff;color:#23d160}.button.is-success.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-warning{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-hovered,.button.is-warning:hover{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-focused,.button.is-warning:focus{border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-focused:not(:active),.button.is-warning:focus:not(:active){box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.button.is-warning.is-active,.button.is-warning:active{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning[disabled]{background-color:#ffdd57;border-color:transparent;box-shadow:none}.button.is-warning.is-inverted{color:#ffdd57}.button.is-warning.is-inverted,.button.is-warning.is-inverted:hover{background-color:rgba(0,0,0,.7)}.button.is-warning.is-inverted[disabled]{background-color:rgba(0,0,0,.7);border-color:transparent;box-shadow:none;color:#ffdd57}.button.is-warning.is-loading:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.button.is-warning.is-outlined{background-color:transparent;border-color:#ffdd57;color:#ffdd57}.button.is-warning.is-outlined:focus,.button.is-warning.is-outlined:hover{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.button.is-warning.is-outlined.is-loading:after{border-color:transparent transparent #ffdd57 #ffdd57!important}.button.is-warning.is-outlined[disabled]{background-color:transparent;border-color:#ffdd57;box-shadow:none;color:#ffdd57}.button.is-warning.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);color:rgba(0,0,0,.7)}.button.is-warning.is-inverted.is-outlined:focus,.button.is-warning.is-inverted.is-outlined:hover{background-color:rgba(0,0,0,.7);color:#ffdd57}.button.is-warning.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:rgba(0,0,0,.7);box-shadow:none;color:rgba(0,0,0,.7)}.button.is-danger{background-color:#ff3860;border-color:transparent;color:#fff}.button.is-danger.is-hovered,.button.is-danger:hover{background-color:#ff2b56;border-color:transparent;color:#fff}.button.is-danger.is-focused,.button.is-danger:focus{border-color:transparent;color:#fff}.button.is-danger.is-focused:not(:active),.button.is-danger:focus:not(:active){box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.button.is-danger.is-active,.button.is-danger:active{background-color:#ff1f4b;border-color:transparent;color:#fff}.button.is-danger[disabled]{background-color:#ff3860;border-color:transparent;box-shadow:none}.button.is-danger.is-inverted{background-color:#fff;color:#ff3860}.button.is-danger.is-inverted:hover{background-color:#f2f2f2}.button.is-danger.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#ff3860}.button.is-danger.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-danger.is-outlined{background-color:transparent;border-color:#ff3860;color:#ff3860}.button.is-danger.is-outlined:focus,.button.is-danger.is-outlined:hover{background-color:#ff3860;border-color:#ff3860;color:#fff}.button.is-danger.is-outlined.is-loading:after{border-color:transparent transparent #ff3860 #ff3860!important}.button.is-danger.is-outlined[disabled]{background-color:transparent;border-color:#ff3860;box-shadow:none;color:#ff3860}.button.is-danger.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-danger.is-inverted.is-outlined:focus,.button.is-danger.is-inverted.is-outlined:hover{background-color:#fff;color:#ff3860}.button.is-danger.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-twitter{background-color:#4099ff;border-color:transparent;color:#fff}.button.is-twitter.is-hovered,.button.is-twitter:hover{background-color:#3392ff;border-color:transparent;color:#fff}.button.is-twitter.is-focused,.button.is-twitter:focus{border-color:transparent;color:#fff}.button.is-twitter.is-focused:not(:active),.button.is-twitter:focus:not(:active){box-shadow:0 0 0 .125em rgba(64,153,255,.25)}.button.is-twitter.is-active,.button.is-twitter:active{background-color:#278bff;border-color:transparent;color:#fff}.button.is-twitter[disabled]{background-color:#4099ff;border-color:transparent;box-shadow:none}.button.is-twitter.is-inverted{background-color:#fff;color:#4099ff}.button.is-twitter.is-inverted:hover{background-color:#f2f2f2}.button.is-twitter.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#4099ff}.button.is-twitter.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-twitter.is-outlined{background-color:transparent;border-color:#4099ff;color:#4099ff}.button.is-twitter.is-outlined:focus,.button.is-twitter.is-outlined:hover{background-color:#4099ff;border-color:#4099ff;color:#fff}.button.is-twitter.is-outlined.is-loading:after{border-color:transparent transparent #4099ff #4099ff!important}.button.is-twitter.is-outlined[disabled]{background-color:transparent;border-color:#4099ff;box-shadow:none;color:#4099ff}.button.is-twitter.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-twitter.is-inverted.is-outlined:focus,.button.is-twitter.is-inverted.is-outlined:hover{background-color:#fff;color:#4099ff}.button.is-twitter.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-small{border-radius:2px;font-size:.75rem}.button.is-medium{font-size:1.25rem}.button.is-large{font-size:1.5rem}.button[disabled]{background-color:#fff;border-color:#dbdbdb;box-shadow:none;opacity:.5}.button.is-fullwidth{display:flex;width:100%}.button.is-loading{color:transparent!important;pointer-events:none}.button.is-loading:after{position:absolute;left:calc(50% - 0.5em);top:calc(50% - 0.5em);position:absolute!important}.button.is-static{background-color:#f5f5f5;border-color:#dbdbdb;color:#7a7a7a;box-shadow:none;pointer-events:none}.button.is-rounded{border-radius:290486px;padding-left:1em;padding-right:1em}.buttons{align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start}.buttons .button{margin-bottom:.5rem}.buttons .button:not(:last-child){margin-right:.5rem}.buttons:last-child{margin-bottom:-.5rem}.buttons:not(:last-child){margin-bottom:1rem}.buttons.has-addons .button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.buttons.has-addons .button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.buttons.has-addons .button:last-child{margin-right:0}.buttons.has-addons .button.is-hovered,.buttons.has-addons .button:hover{z-index:2}.buttons.has-addons .button.is-active,.buttons.has-addons .button.is-focused,.buttons.has-addons .button.is-selected,.buttons.has-addons .button:active,.buttons.has-addons .button:focus{z-index:3}.buttons.has-addons .button.is-active:hover,.buttons.has-addons .button.is-focused:hover,.buttons.has-addons .button.is-selected:hover,.buttons.has-addons .button:active:hover,.buttons.has-addons .button:focus:hover{z-index:4}.buttons.has-addons .button.is-expanded{flex-grow:1}.buttons.is-centered{justify-content:center}.buttons.is-right{justify-content:flex-end}.container{margin:0 auto;position:relative}@media screen and (min-width:1088px){.container{max-width:960px;width:960px}.container.is-fluid{margin-left:64px;margin-right:64px;max-width:none;width:auto}}@media screen and (max-width:1279px){.container.is-widescreen{max-width:1152px;width:auto}}@media screen and (max-width:1471px){.container.is-fullhd{max-width:1344px;width:auto}}@media screen and (min-width:1280px){.container{max-width:1152px;width:1152px}}@media screen and (min-width:1472px){.container{max-width:1344px;width:1344px}}.content li+li{margin-top:.25em}.content blockquote:not(:last-child),.content dl:not(:last-child),.content ol:not(:last-child),.content p:not(:last-child),.content pre:not(:last-child),.content table:not(:last-child),.content ul:not(:last-child){margin-bottom:1em}.content h1,.content h2,.content h3,.content h4,.content h5,.content h6{color:#363636;font-weight:600;line-height:1.125}.content h1{font-size:2em;margin-bottom:.5em}.content h1:not(:first-child){margin-top:1em}.content h2{font-size:1.75em;margin-bottom:.5714em}.content h2:not(:first-child){margin-top:1.1428em}.content h3{font-size:1.5em;margin-bottom:.6666em}.content h3:not(:first-child){margin-top:1.3333em}.content h4{font-size:1.25em;margin-bottom:.8em}.content h5{font-size:1.125em;margin-bottom:.8888em}.content h6{font-size:1em;margin-bottom:1em}.content blockquote{background-color:#f5f5f5;border-left:5px solid #dbdbdb;padding:1.25em 1.5em}.content ol{list-style:decimal outside}.content ol,.content ul{margin-left:2em;margin-top:1em}.content ul{list-style:disc outside}.content ul ul{list-style-type:circle;margin-top:.5em}.content ul ul ul{list-style-type:square}.content dd{margin-left:2em}.content figure{margin-left:2em;margin-right:2em;text-align:center}.content figure:not(:first-child){margin-top:2em}.content figure:not(:last-child){margin-bottom:2em}.content figure img{display:inline-block}.content figure figcaption{font-style:italic}.content pre{-webkit-overflow-scrolling:touch;overflow-x:auto;padding:1.25em 1.5em;white-space:pre;word-wrap:normal}.content sub,.content sup{font-size:75%}.content table{width:100%}.content table td,.content table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.content table th{color:#363636;text-align:left}.content table thead td,.content table thead th{border-width:0 0 2px;color:#363636}.content table tfoot td,.content table tfoot th{border-width:2px 0 0;color:#363636}.content table tbody tr:last-child td,.content table tbody tr:last-child th{border-bottom-width:0}.content.is-small{font-size:.75rem}.content.is-medium{font-size:1.25rem}.content.is-large{font-size:1.5rem}.input,.taginput .taginput-container.is-focusable,.textarea{background-color:#fff;border-color:#dbdbdb;color:#363636;box-shadow:inset 0 1px 2px hsla(0,0%,4%,.1);max-width:100%;width:100%}.input::-moz-placeholder,.taginput .taginput-container.is-focusable::-moz-placeholder,.textarea::-moz-placeholder{color:rgba(54,54,54,.3)}.input::-webkit-input-placeholder,.taginput .taginput-container.is-focusable::-webkit-input-placeholder,.textarea::-webkit-input-placeholder{color:rgba(54,54,54,.3)}.input:-moz-placeholder,.taginput .taginput-container.is-focusable:-moz-placeholder,.textarea:-moz-placeholder{color:rgba(54,54,54,.3)}.input:-ms-input-placeholder,.taginput .taginput-container.is-focusable:-ms-input-placeholder,.textarea:-ms-input-placeholder{color:rgba(54,54,54,.3)}.input.is-hovered,.input:hover,.taginput .is-hovered.taginput-container.is-focusable,.taginput .taginput-container.is-focusable:hover,.textarea.is-hovered,.textarea:hover{border-color:#b5b5b5}.input.is-active,.input.is-focused,.input:active,.input:focus,.taginput .is-active.taginput-container.is-focusable,.taginput .is-focused.taginput-container.is-focusable,.taginput .taginput-container.is-focusable:active,.taginput .taginput-container.is-focusable:focus,.textarea.is-active,.textarea.is-focused,.textarea:active,.textarea:focus{border-color:#3273dc;box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.input[disabled],.taginput .taginput-container.is-focusable[disabled],.textarea[disabled]{background-color:#f5f5f5;border-color:#f5f5f5;box-shadow:none;color:#7a7a7a}.input[disabled]::-moz-placeholder,.taginput .taginput-container.is-focusable[disabled]::-moz-placeholder,.textarea[disabled]::-moz-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]::-webkit-input-placeholder,.taginput .taginput-container.is-focusable[disabled]::-webkit-input-placeholder,.textarea[disabled]::-webkit-input-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]:-moz-placeholder,.taginput .taginput-container.is-focusable[disabled]:-moz-placeholder,.textarea[disabled]:-moz-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]:-ms-input-placeholder,.taginput .taginput-container.is-focusable[disabled]:-ms-input-placeholder,.textarea[disabled]:-ms-input-placeholder{color:hsla(0,0%,48%,.3)}.input[readonly],.taginput .taginput-container.is-focusable[readonly],.textarea[readonly]{box-shadow:none}.input.is-white,.taginput .is-white.taginput-container.is-focusable,.textarea.is-white{border-color:#fff}.input.is-white.is-active,.input.is-white.is-focused,.input.is-white:active,.input.is-white:focus,.taginput .is-white.is-active.taginput-container.is-focusable,.taginput .is-white.is-focused.taginput-container.is-focusable,.taginput .is-white.taginput-container.is-focusable:active,.taginput .is-white.taginput-container.is-focusable:focus,.textarea.is-white.is-active,.textarea.is-white.is-focused,.textarea.is-white:active,.textarea.is-white:focus{box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.input.is-black,.taginput .is-black.taginput-container.is-focusable,.textarea.is-black{border-color:#0a0a0a}.input.is-black.is-active,.input.is-black.is-focused,.input.is-black:active,.input.is-black:focus,.taginput .is-black.is-active.taginput-container.is-focusable,.taginput .is-black.is-focused.taginput-container.is-focusable,.taginput .is-black.taginput-container.is-focusable:active,.taginput .is-black.taginput-container.is-focusable:focus,.textarea.is-black.is-active,.textarea.is-black.is-focused,.textarea.is-black:active,.textarea.is-black:focus{box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.input.is-light,.taginput .is-light.taginput-container.is-focusable,.textarea.is-light{border-color:#f5f5f5}.input.is-light.is-active,.input.is-light.is-focused,.input.is-light:active,.input.is-light:focus,.taginput .is-light.is-active.taginput-container.is-focusable,.taginput .is-light.is-focused.taginput-container.is-focusable,.taginput .is-light.taginput-container.is-focusable:active,.taginput .is-light.taginput-container.is-focusable:focus,.textarea.is-light.is-active,.textarea.is-light.is-focused,.textarea.is-light:active,.textarea.is-light:focus{box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.input.is-dark,.taginput .is-dark.taginput-container.is-focusable,.textarea.is-dark{border-color:#363636}.input.is-dark.is-active,.input.is-dark.is-focused,.input.is-dark:active,.input.is-dark:focus,.taginput .is-dark.is-active.taginput-container.is-focusable,.taginput .is-dark.is-focused.taginput-container.is-focusable,.taginput .is-dark.taginput-container.is-focusable:active,.taginput .is-dark.taginput-container.is-focusable:focus,.textarea.is-dark.is-active,.textarea.is-dark.is-focused,.textarea.is-dark:active,.textarea.is-dark:focus{box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.input.is-primary,.taginput .is-primary.taginput-container.is-focusable,.textarea.is-primary{border-color:#00d1b2}.input.is-primary.is-active,.input.is-primary.is-focused,.input.is-primary:active,.input.is-primary:focus,.taginput .is-primary.is-active.taginput-container.is-focusable,.taginput .is-primary.is-focused.taginput-container.is-focusable,.taginput .is-primary.taginput-container.is-focusable:active,.taginput .is-primary.taginput-container.is-focusable:focus,.textarea.is-primary.is-active,.textarea.is-primary.is-focused,.textarea.is-primary:active,.textarea.is-primary:focus{box-shadow:0 0 0 .125em rgba(0,209,178,.25)}.input.is-info,.taginput .is-info.taginput-container.is-focusable,.textarea.is-info{border-color:#209cee}.input.is-info.is-active,.input.is-info.is-focused,.input.is-info:active,.input.is-info:focus,.taginput .is-info.is-active.taginput-container.is-focusable,.taginput .is-info.is-focused.taginput-container.is-focusable,.taginput .is-info.taginput-container.is-focusable:active,.taginput .is-info.taginput-container.is-focusable:focus,.textarea.is-info.is-active,.textarea.is-info.is-focused,.textarea.is-info:active,.textarea.is-info:focus{box-shadow:0 0 0 .125em rgba(32,156,238,.25)}.input.is-success,.taginput .is-success.taginput-container.is-focusable,.textarea.is-success{border-color:#23d160}.input.is-success.is-active,.input.is-success.is-focused,.input.is-success:active,.input.is-success:focus,.taginput .is-success.is-active.taginput-container.is-focusable,.taginput .is-success.is-focused.taginput-container.is-focusable,.taginput .is-success.taginput-container.is-focusable:active,.taginput .is-success.taginput-container.is-focusable:focus,.textarea.is-success.is-active,.textarea.is-success.is-focused,.textarea.is-success:active,.textarea.is-success:focus{box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.input.is-warning,.taginput .is-warning.taginput-container.is-focusable,.textarea.is-warning{border-color:#ffdd57}.input.is-warning.is-active,.input.is-warning.is-focused,.input.is-warning:active,.input.is-warning:focus,.taginput .is-warning.is-active.taginput-container.is-focusable,.taginput .is-warning.is-focused.taginput-container.is-focusable,.taginput .is-warning.taginput-container.is-focusable:active,.taginput .is-warning.taginput-container.is-focusable:focus,.textarea.is-warning.is-active,.textarea.is-warning.is-focused,.textarea.is-warning:active,.textarea.is-warning:focus{box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.input.is-danger,.taginput .is-danger.taginput-container.is-focusable,.textarea.is-danger{border-color:#ff3860}.input.is-danger.is-active,.input.is-danger.is-focused,.input.is-danger:active,.input.is-danger:focus,.taginput .is-danger.is-active.taginput-container.is-focusable,.taginput .is-danger.is-focused.taginput-container.is-focusable,.taginput .is-danger.taginput-container.is-focusable:active,.taginput .is-danger.taginput-container.is-focusable:focus,.textarea.is-danger.is-active,.textarea.is-danger.is-focused,.textarea.is-danger:active,.textarea.is-danger:focus{box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.input.is-twitter,.taginput .is-twitter.taginput-container.is-focusable,.textarea.is-twitter{border-color:#4099ff}.input.is-twitter.is-active,.input.is-twitter.is-focused,.input.is-twitter:active,.input.is-twitter:focus,.taginput .is-twitter.is-active.taginput-container.is-focusable,.taginput .is-twitter.is-focused.taginput-container.is-focusable,.taginput .is-twitter.taginput-container.is-focusable:active,.taginput .is-twitter.taginput-container.is-focusable:focus,.textarea.is-twitter.is-active,.textarea.is-twitter.is-focused,.textarea.is-twitter:active,.textarea.is-twitter:focus{box-shadow:0 0 0 .125em rgba(64,153,255,.25)}.input.is-small,.taginput .is-small.taginput-container.is-focusable,.textarea.is-small{border-radius:2px;font-size:.75rem}.input.is-medium,.taginput .is-medium.taginput-container.is-focusable,.textarea.is-medium{font-size:1.25rem}.input.is-large,.taginput .is-large.taginput-container.is-focusable,.textarea.is-large{font-size:1.5rem}.input.is-fullwidth,.taginput .is-fullwidth.taginput-container.is-focusable,.textarea.is-fullwidth{display:block;width:100%}.input.is-inline,.taginput .is-inline.taginput-container.is-focusable,.textarea.is-inline{display:inline;width:auto}.input.is-rounded,.taginput .is-rounded.taginput-container.is-focusable{border-radius:290486px;padding-left:1em;padding-right:1em}.input.is-static,.taginput .is-static.taginput-container.is-focusable{background-color:transparent;border-color:transparent;box-shadow:none;padding-left:0;padding-right:0}.textarea{display:block;max-width:100%;min-width:100%;padding:.625em;resize:vertical}.textarea:not([rows]){max-height:600px;min-height:120px}.textarea[rows]{height:auto}.textarea.has-fixed-size{resize:none}.checkbox,.radio{cursor:pointer;display:inline-block;line-height:1.25;position:relative}.checkbox input,.radio input{cursor:pointer}.checkbox:hover,.radio:hover{color:#363636}.checkbox[disabled],.radio[disabled]{color:#7a7a7a;cursor:not-allowed}.radio+.radio{margin-left:.5em}.select{display:inline-block;max-width:100%;position:relative;vertical-align:top}.select:not(.is-multiple){height:2.25em}.select:not(.is-multiple):not(.is-loading):after{border-color:#3273dc;right:1.125em;z-index:4}.select.is-rounded select{border-radius:290486px;padding-left:1em}.select select{background-color:#fff;border-color:#dbdbdb;color:#363636;cursor:pointer;display:block;font-size:1em;max-width:100%;outline:none}.select select::-moz-placeholder{color:rgba(54,54,54,.3)}.select select::-webkit-input-placeholder{color:rgba(54,54,54,.3)}.select select:-moz-placeholder{color:rgba(54,54,54,.3)}.select select:-ms-input-placeholder{color:rgba(54,54,54,.3)}.select select.is-hovered,.select select:hover{border-color:#b5b5b5}.select select.is-active,.select select.is-focused,.select select:active,.select select:focus{border-color:#3273dc;box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.select select[disabled]{background-color:#f5f5f5;border-color:#f5f5f5;box-shadow:none;color:#7a7a7a}.select select[disabled]::-moz-placeholder{color:hsla(0,0%,48%,.3)}.select select[disabled]::-webkit-input-placeholder{color:hsla(0,0%,48%,.3)}.select select[disabled]:-moz-placeholder{color:hsla(0,0%,48%,.3)}.select select[disabled]:-ms-input-placeholder{color:hsla(0,0%,48%,.3)}.select select::-ms-expand{display:none}.select select[disabled]:hover{border-color:#f5f5f5}.select select:not([multiple]){padding-right:2.5em}.select select[multiple]{height:auto;padding:0}.select select[multiple] option{padding:.5em 1em}.select:not(.is-multiple):not(.is-loading):hover:after{border-color:#363636}.select.is-white:not(:hover):after,.select.is-white select{border-color:#fff}.select.is-white select.is-hovered,.select.is-white select:hover{border-color:#f2f2f2}.select.is-white select.is-active,.select.is-white select.is-focused,.select.is-white select:active,.select.is-white select:focus{box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.select.is-black:not(:hover):after,.select.is-black select{border-color:#0a0a0a}.select.is-black select.is-hovered,.select.is-black select:hover{border-color:#000}.select.is-black select.is-active,.select.is-black select.is-focused,.select.is-black select:active,.select.is-black select:focus{box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.select.is-light:not(:hover):after,.select.is-light select{border-color:#f5f5f5}.select.is-light select.is-hovered,.select.is-light select:hover{border-color:#e8e8e8}.select.is-light select.is-active,.select.is-light select.is-focused,.select.is-light select:active,.select.is-light select:focus{box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.select.is-dark:not(:hover):after,.select.is-dark select{border-color:#363636}.select.is-dark select.is-hovered,.select.is-dark select:hover{border-color:#292929}.select.is-dark select.is-active,.select.is-dark select.is-focused,.select.is-dark select:active,.select.is-dark select:focus{box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.select.is-primary:not(:hover):after,.select.is-primary select{border-color:#00d1b2}.select.is-primary select.is-hovered,.select.is-primary select:hover{border-color:#00b89c}.select.is-primary select.is-active,.select.is-primary select.is-focused,.select.is-primary select:active,.select.is-primary select:focus{box-shadow:0 0 0 .125em rgba(0,209,178,.25)}.select.is-info:not(:hover):after,.select.is-info select{border-color:#209cee}.select.is-info select.is-hovered,.select.is-info select:hover{border-color:#118fe4}.select.is-info select.is-active,.select.is-info select.is-focused,.select.is-info select:active,.select.is-info select:focus{box-shadow:0 0 0 .125em rgba(32,156,238,.25)}.select.is-success:not(:hover):after,.select.is-success select{border-color:#23d160}.select.is-success select.is-hovered,.select.is-success select:hover{border-color:#20bc56}.select.is-success select.is-active,.select.is-success select.is-focused,.select.is-success select:active,.select.is-success select:focus{box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.select.is-warning:not(:hover):after,.select.is-warning select{border-color:#ffdd57}.select.is-warning select.is-hovered,.select.is-warning select:hover{border-color:#ffd83d}.select.is-warning select.is-active,.select.is-warning select.is-focused,.select.is-warning select:active,.select.is-warning select:focus{box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.select.is-danger:not(:hover):after,.select.is-danger select{border-color:#ff3860}.select.is-danger select.is-hovered,.select.is-danger select:hover{border-color:#ff1f4b}.select.is-danger select.is-active,.select.is-danger select.is-focused,.select.is-danger select:active,.select.is-danger select:focus{box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.select.is-twitter:not(:hover):after,.select.is-twitter select{border-color:#4099ff}.select.is-twitter select.is-hovered,.select.is-twitter select:hover{border-color:#278bff}.select.is-twitter select.is-active,.select.is-twitter select.is-focused,.select.is-twitter select:active,.select.is-twitter select:focus{box-shadow:0 0 0 .125em rgba(64,153,255,.25)}.select.is-small{border-radius:2px;font-size:.75rem}.select.is-medium{font-size:1.25rem}.select.is-large{font-size:1.5rem}.select.is-disabled:after{border-color:#7a7a7a}.select.is-fullwidth,.select.is-fullwidth select{width:100%}.select.is-loading:after{margin-top:0;position:absolute;right:.625em;top:.625em;transform:none}.select.is-loading.is-small:after{font-size:.75rem}.select.is-loading.is-medium:after{font-size:1.25rem}.select.is-loading.is-large:after{font-size:1.5rem}.file{align-items:stretch;display:flex;justify-content:flex-start;position:relative}.file.is-white .file-cta{background-color:#fff;border-color:transparent;color:#0a0a0a}.file.is-white.is-hovered .file-cta,.file.is-white:hover .file-cta{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.file.is-white.is-focused .file-cta,.file.is-white:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,100%,.25);color:#0a0a0a}.file.is-white.is-active .file-cta,.file.is-white:active .file-cta{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.file.is-black .file-cta{background-color:#0a0a0a;border-color:transparent;color:#fff}.file.is-black.is-hovered .file-cta,.file.is-black:hover .file-cta{background-color:#040404;border-color:transparent;color:#fff}.file.is-black.is-focused .file-cta,.file.is-black:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,4%,.25);color:#fff}.file.is-black.is-active .file-cta,.file.is-black:active .file-cta{background-color:#000;border-color:transparent;color:#fff}.file.is-light .file-cta{background-color:#f5f5f5;border-color:transparent;color:#363636}.file.is-light.is-hovered .file-cta,.file.is-light:hover .file-cta{background-color:#eee;border-color:transparent;color:#363636}.file.is-light.is-focused .file-cta,.file.is-light:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,96%,.25);color:#363636}.file.is-light.is-active .file-cta,.file.is-light:active .file-cta{background-color:#e8e8e8;border-color:transparent;color:#363636}.file.is-dark .file-cta{background-color:#363636;border-color:transparent;color:#f5f5f5}.file.is-dark.is-hovered .file-cta,.file.is-dark:hover .file-cta{background-color:#2f2f2f;border-color:transparent;color:#f5f5f5}.file.is-dark.is-focused .file-cta,.file.is-dark:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(54,54,54,.25);color:#f5f5f5}.file.is-dark.is-active .file-cta,.file.is-dark:active .file-cta{background-color:#292929;border-color:transparent;color:#f5f5f5}.file.is-primary .file-cta{background-color:#00d1b2;border-color:transparent;color:#fff}.file.is-primary.is-hovered .file-cta,.file.is-primary:hover .file-cta{background-color:#00c4a7;border-color:transparent;color:#fff}.file.is-primary.is-focused .file-cta,.file.is-primary:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(0,209,178,.25);color:#fff}.file.is-primary.is-active .file-cta,.file.is-primary:active .file-cta{background-color:#00b89c;border-color:transparent;color:#fff}.file.is-info .file-cta{background-color:#209cee;border-color:transparent;color:#fff}.file.is-info.is-hovered .file-cta,.file.is-info:hover .file-cta{background-color:#1496ed;border-color:transparent;color:#fff}.file.is-info.is-focused .file-cta,.file.is-info:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(32,156,238,.25);color:#fff}.file.is-info.is-active .file-cta,.file.is-info:active .file-cta{background-color:#118fe4;border-color:transparent;color:#fff}.file.is-success .file-cta{background-color:#23d160;border-color:transparent;color:#fff}.file.is-success.is-hovered .file-cta,.file.is-success:hover .file-cta{background-color:#22c65b;border-color:transparent;color:#fff}.file.is-success.is-focused .file-cta,.file.is-success:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(35,209,96,.25);color:#fff}.file.is-success.is-active .file-cta,.file.is-success:active .file-cta{background-color:#20bc56;border-color:transparent;color:#fff}.file.is-warning .file-cta{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-warning.is-hovered .file-cta,.file.is-warning:hover .file-cta{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-warning.is-focused .file-cta,.file.is-warning:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(255,221,87,.25);color:rgba(0,0,0,.7)}.file.is-warning.is-active .file-cta,.file.is-warning:active .file-cta{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-danger .file-cta{background-color:#ff3860;border-color:transparent;color:#fff}.file.is-danger.is-hovered .file-cta,.file.is-danger:hover .file-cta{background-color:#ff2b56;border-color:transparent;color:#fff}.file.is-danger.is-focused .file-cta,.file.is-danger:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(255,56,96,.25);color:#fff}.file.is-danger.is-active .file-cta,.file.is-danger:active .file-cta{background-color:#ff1f4b;border-color:transparent;color:#fff}.file.is-twitter .file-cta{background-color:#4099ff;border-color:transparent;color:#fff}.file.is-twitter.is-hovered .file-cta,.file.is-twitter:hover .file-cta{background-color:#3392ff;border-color:transparent;color:#fff}.file.is-twitter.is-focused .file-cta,.file.is-twitter:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(64,153,255,.25);color:#fff}.file.is-twitter.is-active .file-cta,.file.is-twitter:active .file-cta{background-color:#278bff;border-color:transparent;color:#fff}.file.is-small{font-size:.75rem}.file.is-medium{font-size:1.25rem}.file.is-medium .file-icon .fa{font-size:21px}.file.is-large{font-size:1.5rem}.file.is-large .file-icon .fa{font-size:28px}.file.has-name .file-cta{border-bottom-right-radius:0;border-top-right-radius:0}.file.has-name .file-name{border-bottom-left-radius:0;border-top-left-radius:0}.file.has-name.is-empty .file-cta{border-radius:4px}.file.has-name.is-empty .file-name{display:none}.file.is-boxed .file-label{flex-direction:column}.file.is-boxed .file-cta{flex-direction:column;height:auto;padding:1em 3em}.file.is-boxed .file-name{border-width:0 1px 1px}.file.is-boxed .file-icon{height:1.5em;width:1.5em}.file.is-boxed .file-icon .fa{font-size:21px}.file.is-boxed.is-small .file-icon .fa{font-size:14px}.file.is-boxed.is-medium .file-icon .fa{font-size:28px}.file.is-boxed.is-large .file-icon .fa{font-size:35px}.file.is-boxed.has-name .file-cta{border-radius:4px 4px 0 0}.file.is-boxed.has-name .file-name{border-radius:0 0 4px 4px;border-width:0 1px 1px}.file.is-centered{justify-content:center}.file.is-fullwidth .file-label{width:100%}.file.is-fullwidth .file-name{flex-grow:1;max-width:none}.file.is-right{justify-content:flex-end}.file.is-right .file-cta{border-radius:0 4px 4px 0}.file.is-right .file-name{border-radius:4px 0 0 4px;border-width:1px 0 1px 1px;order:-1}.file-label{align-items:stretch;display:flex;cursor:pointer;justify-content:flex-start;overflow:hidden;position:relative}.file-label:hover .file-cta{background-color:#eee;color:#363636}.file-label:hover .file-name{border-color:#d5d5d5}.file-label:active .file-cta{background-color:#e8e8e8;color:#363636}.file-label:active .file-name{border-color:#cfcfcf}.file-input{height:.01em;left:0;outline:none;position:absolute;top:0;width:.01em}.file-cta,.file-name{border-color:#dbdbdb;border-radius:4px;font-size:1em;padding-left:1em;padding-right:1em;white-space:nowrap}.file-cta{background-color:#f5f5f5;color:#4a4a4a}.file-name{border-color:#dbdbdb;border-style:solid;border-width:1px 1px 1px 0;display:block;max-width:16em;overflow:hidden;text-align:left;text-overflow:ellipsis}.file-icon{align-items:center;display:flex;height:1em;justify-content:center;margin-right:.5em;width:1em}.file-icon .fa{font-size:14px}.label{color:#363636;display:block;font-size:1rem;font-weight:700}.label:not(:last-child){margin-bottom:.5em}.label.is-small{font-size:.75rem}.label.is-medium{font-size:1.25rem}.label.is-large{font-size:1.5rem}.help{display:block;font-size:.75rem;margin-top:.25rem}.help.is-white{color:#fff}.help.is-black{color:#0a0a0a}.help.is-light{color:#f5f5f5}.help.is-dark{color:#363636}.help.is-primary{color:#00d1b2}.help.is-info{color:#209cee}.help.is-success{color:#23d160}.help.is-warning{color:#ffdd57}.help.is-danger{color:#ff3860}.help.is-twitter{color:#4099ff}.field:not(:last-child){margin-bottom:.75rem}.field.has-addons{display:flex;justify-content:flex-start}.field.has-addons .control:not(:last-child){margin-right:-1px}.field.has-addons .control:not(:first-child):not(:last-child) .button,.field.has-addons .control:not(:first-child):not(:last-child) .input,.field.has-addons .control:not(:first-child):not(:last-child) .select select,.field.has-addons .control:not(:first-child):not(:last-child) .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:not(:first-child):not(:last-child) .taginput-container.is-focusable{border-radius:0}.field.has-addons .control:first-child .button,.field.has-addons .control:first-child .input,.field.has-addons .control:first-child .select select,.field.has-addons .control:first-child .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:first-child .taginput-container.is-focusable{border-bottom-right-radius:0;border-top-right-radius:0}.field.has-addons .control:last-child .button,.field.has-addons .control:last-child .input,.field.has-addons .control:last-child .select select,.field.has-addons .control:last-child .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:last-child .taginput-container.is-focusable{border-bottom-left-radius:0;border-top-left-radius:0}.field.has-addons .control .button.is-hovered,.field.has-addons .control .button:hover,.field.has-addons .control .input.is-hovered,.field.has-addons .control .input:hover,.field.has-addons .control .select select.is-hovered,.field.has-addons .control .select select:hover,.field.has-addons .control .taginput .is-hovered.taginput-container.is-focusable,.field.has-addons .control .taginput .taginput-container.is-focusable:hover,.taginput .field.has-addons .control .is-hovered.taginput-container.is-focusable,.taginput .field.has-addons .control .taginput-container.is-focusable:hover{z-index:2}.field.has-addons .control .button.is-active,.field.has-addons .control .button.is-focused,.field.has-addons .control .button:active,.field.has-addons .control .button:focus,.field.has-addons .control .input.is-active,.field.has-addons .control .input.is-focused,.field.has-addons .control .input:active,.field.has-addons .control .input:focus,.field.has-addons .control .select select.is-active,.field.has-addons .control .select select.is-focused,.field.has-addons .control .select select:active,.field.has-addons .control .select select:focus,.field.has-addons .control .taginput .is-active.taginput-container.is-focusable,.field.has-addons .control .taginput .is-focused.taginput-container.is-focusable,.field.has-addons .control .taginput .taginput-container.is-focusable:active,.field.has-addons .control .taginput .taginput-container.is-focusable:focus,.taginput .field.has-addons .control .is-active.taginput-container.is-focusable,.taginput .field.has-addons .control .is-focused.taginput-container.is-focusable,.taginput .field.has-addons .control .taginput-container.is-focusable:active,.taginput .field.has-addons .control .taginput-container.is-focusable:focus{z-index:3}.field.has-addons .control .button.is-active:hover,.field.has-addons .control .button.is-focused:hover,.field.has-addons .control .button:active:hover,.field.has-addons .control .button:focus:hover,.field.has-addons .control .input.is-active:hover,.field.has-addons .control .input.is-focused:hover,.field.has-addons .control .input:active:hover,.field.has-addons .control .input:focus:hover,.field.has-addons .control .select select.is-active:hover,.field.has-addons .control .select select.is-focused:hover,.field.has-addons .control .select select:active:hover,.field.has-addons .control .select select:focus:hover,.field.has-addons .control .taginput .is-active.taginput-container.is-focusable:hover,.field.has-addons .control .taginput .is-focused.taginput-container.is-focusable:hover,.field.has-addons .control .taginput .taginput-container.is-focusable:active:hover,.field.has-addons .control .taginput .taginput-container.is-focusable:focus:hover,.taginput .field.has-addons .control .is-active.taginput-container.is-focusable:hover,.taginput .field.has-addons .control .is-focused.taginput-container.is-focusable:hover,.taginput .field.has-addons .control .taginput-container.is-focusable:active:hover,.taginput .field.has-addons .control .taginput-container.is-focusable:focus:hover{z-index:4}.field.has-addons .control.is-expanded{flex-grow:1}.field.has-addons.has-addons-centered{justify-content:center}.field.has-addons.has-addons-right{justify-content:flex-end}.field.has-addons.has-addons-fullwidth .control{flex-grow:1;flex-shrink:0}.field.is-grouped{display:flex;justify-content:flex-start}.field.is-grouped>.control{flex-shrink:0}.field.is-grouped>.control:not(:last-child){margin-bottom:0;margin-right:.75rem}.field.is-grouped>.control.is-expanded{flex-grow:1;flex-shrink:1}.field.is-grouped.is-grouped-centered{justify-content:center}.field.is-grouped.is-grouped-right{justify-content:flex-end}.field.is-grouped.is-grouped-multiline{flex-wrap:wrap}.field.is-grouped.is-grouped-multiline>.control:last-child,.field.is-grouped.is-grouped-multiline>.control:not(:last-child){margin-bottom:.75rem}.field.is-grouped.is-grouped-multiline:last-child{margin-bottom:-.75rem}.field.is-grouped.is-grouped-multiline:not(:last-child){margin-bottom:0}@media print,screen and (min-width:769px){.field.is-horizontal{display:flex}}.field-label .label{font-size:inherit}@media screen and (max-width:768px){.field-label{margin-bottom:.5rem}}@media print,screen and (min-width:769px){.field-label{flex-basis:0;flex-grow:1;flex-shrink:0;margin-right:1.5rem;text-align:right}.field-label.is-small{font-size:.75rem;padding-top:.375em}.field-label.is-normal{padding-top:.375em}.field-label.is-medium{font-size:1.25rem;padding-top:.375em}.field-label.is-large{font-size:1.5rem;padding-top:.375em}}.field-body .field .field{margin-bottom:0}@media print,screen and (min-width:769px){.field-body{display:flex;flex-basis:0;flex-grow:5;flex-shrink:1}.field-body .field{margin-bottom:0}.field-body>.field{flex-shrink:1}.field-body>.field:not(.is-narrow){flex-grow:1}.field-body>.field:not(:last-child){margin-right:.75rem}}.control{font-size:1rem;position:relative;text-align:left}.control.has-icon .icon{color:#dbdbdb;height:2.25em;pointer-events:none;position:absolute;top:0;width:2.25em;z-index:4}.control.has-icon .input:focus+.icon,.control.has-icon .taginput .taginput-container.is-focusable:focus+.icon,.taginput .control.has-icon .taginput-container.is-focusable:focus+.icon{color:#7a7a7a}.control.has-icon .input.is-small+.icon,.control.has-icon .taginput .is-small.taginput-container.is-focusable+.icon,.taginput .control.has-icon .is-small.taginput-container.is-focusable+.icon{font-size:.75rem}.control.has-icon .input.is-medium+.icon,.control.has-icon .taginput .is-medium.taginput-container.is-focusable+.icon,.taginput .control.has-icon .is-medium.taginput-container.is-focusable+.icon{font-size:1.25rem}.control.has-icon .input.is-large+.icon,.control.has-icon .taginput .is-large.taginput-container.is-focusable+.icon,.taginput .control.has-icon .is-large.taginput-container.is-focusable+.icon{font-size:1.5rem}.control.has-icon:not(.has-icon-right) .icon{left:0}.control.has-icon:not(.has-icon-right) .input,.control.has-icon:not(.has-icon-right) .taginput .taginput-container.is-focusable,.taginput .control.has-icon:not(.has-icon-right) .taginput-container.is-focusable{padding-left:2.25em}.control.has-icon.has-icon-right .icon{right:0}.control.has-icon.has-icon-right .input,.control.has-icon.has-icon-right .taginput .taginput-container.is-focusable,.taginput .control.has-icon.has-icon-right .taginput-container.is-focusable{padding-right:2.25em}.control.has-icons-left .input:focus~.icon,.control.has-icons-left .select:focus~.icon,.control.has-icons-left .taginput .taginput-container.is-focusable:focus~.icon,.control.has-icons-right .input:focus~.icon,.control.has-icons-right .select:focus~.icon,.control.has-icons-right .taginput .taginput-container.is-focusable:focus~.icon,.taginput .control.has-icons-left .taginput-container.is-focusable:focus~.icon,.taginput .control.has-icons-right .taginput-container.is-focusable:focus~.icon{color:#7a7a7a}.control.has-icons-left .input.is-small~.icon,.control.has-icons-left .select.is-small~.icon,.control.has-icons-left .taginput .is-small.taginput-container.is-focusable~.icon,.control.has-icons-right .input.is-small~.icon,.control.has-icons-right .select.is-small~.icon,.control.has-icons-right .taginput .is-small.taginput-container.is-focusable~.icon,.taginput .control.has-icons-left .is-small.taginput-container.is-focusable~.icon,.taginput .control.has-icons-right .is-small.taginput-container.is-focusable~.icon{font-size:.75rem}.control.has-icons-left .input.is-medium~.icon,.control.has-icons-left .select.is-medium~.icon,.control.has-icons-left .taginput .is-medium.taginput-container.is-focusable~.icon,.control.has-icons-right .input.is-medium~.icon,.control.has-icons-right .select.is-medium~.icon,.control.has-icons-right .taginput .is-medium.taginput-container.is-focusable~.icon,.taginput .control.has-icons-left .is-medium.taginput-container.is-focusable~.icon,.taginput .control.has-icons-right .is-medium.taginput-container.is-focusable~.icon{font-size:1.25rem}.control.has-icons-left .input.is-large~.icon,.control.has-icons-left .select.is-large~.icon,.control.has-icons-left .taginput .is-large.taginput-container.is-focusable~.icon,.control.has-icons-right .input.is-large~.icon,.control.has-icons-right .select.is-large~.icon,.control.has-icons-right .taginput .is-large.taginput-container.is-focusable~.icon,.taginput .control.has-icons-left .is-large.taginput-container.is-focusable~.icon,.taginput .control.has-icons-right .is-large.taginput-container.is-focusable~.icon{font-size:1.5rem}.control.has-icons-left .icon,.control.has-icons-right .icon{color:#dbdbdb;height:2.25em;pointer-events:none;position:absolute;top:0;width:2.25em;z-index:4}.control.has-icons-left .input,.control.has-icons-left .select select,.control.has-icons-left .taginput .taginput-container.is-focusable,.taginput .control.has-icons-left .taginput-container.is-focusable{padding-left:2.25em}.control.has-icons-left .icon.is-left{left:0}.control.has-icons-right .input,.control.has-icons-right .select select,.control.has-icons-right .taginput .taginput-container.is-focusable,.taginput .control.has-icons-right .taginput-container.is-focusable{padding-right:2.25em}.control.has-icons-right .icon.is-right{right:0}.control.is-loading:after{position:absolute!important;right:.625em;top:.625em;z-index:4}.control.is-loading.is-small:after{font-size:.75rem}.control.is-loading.is-medium:after{font-size:1.25rem}.control.is-loading.is-large:after{font-size:1.5rem}.icon{align-items:center;display:inline-flex;justify-content:center;height:1.5rem;width:1.5rem}.icon.is-small{height:1rem;width:1rem}.icon.is-medium{height:2rem;width:2rem}.icon.is-large{height:3rem;width:3rem}.image{display:block;position:relative}.image img{display:block;height:auto;width:100%}.image img.is-rounded{border-radius:290486px}.image.is-1by1 img,.image.is-1by2 img,.image.is-1by3 img,.image.is-2by1 img,.image.is-2by3 img,.image.is-3by1 img,.image.is-3by2 img,.image.is-3by4 img,.image.is-3by5 img,.image.is-4by3 img,.image.is-4by5 img,.image.is-5by3 img,.image.is-5by4 img,.image.is-9by16 img,.image.is-16by9 img,.image.is-square img{height:100%;width:100%}.image.is-1by1,.image.is-square{padding-top:100%}.image.is-5by4{padding-top:80%}.image.is-4by3{padding-top:75%}.image.is-3by2{padding-top:66.6666%}.image.is-5by3{padding-top:60%}.image.is-16by9{padding-top:56.25%}.image.is-2by1{padding-top:50%}.image.is-3by1{padding-top:33.3333%}.image.is-4by5{padding-top:125%}.image.is-3by4{padding-top:133.3333%}.image.is-2by3{padding-top:150%}.image.is-3by5{padding-top:166.6666%}.image.is-9by16{padding-top:177.7777%}.image.is-1by2{padding-top:200%}.image.is-1by3{padding-top:300%}.image.is-16x16{height:16px;width:16px}.image.is-24x24{height:24px;width:24px}.image.is-32x32{height:32px;width:32px}.image.is-48x48{height:48px;width:48px}.image.is-64x64{height:64px;width:64px}.image.is-96x96{height:96px;width:96px}.image.is-128x128{height:128px;width:128px}.notification{background-color:#f5f5f5;border-radius:4px;padding:1.25rem 2.5rem 1.25rem 1.5rem;position:relative}.notification a:not(.button){color:currentColor;text-decoration:underline}.notification strong{color:currentColor}.notification code,.notification pre{background:#fff}.notification pre code{background:transparent}.notification>.delete{position:absolute;right:.5rem;top:.5rem}.notification .content,.notification .subtitle,.notification .title{color:currentColor}.notification.is-white{background-color:#fff;color:#0a0a0a}.notification.is-black{background-color:#0a0a0a;color:#fff}.notification.is-light{background-color:#f5f5f5;color:#363636}.notification.is-dark{background-color:#363636;color:#f5f5f5}.notification.is-primary{background-color:#00d1b2;color:#fff}.notification.is-info{background-color:#209cee;color:#fff}.notification.is-success{background-color:#23d160;color:#fff}.notification.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.notification.is-danger{background-color:#ff3860;color:#fff}.notification.is-twitter{background-color:#4099ff;color:#fff}.progress{-moz-appearance:none;-webkit-appearance:none;border:none;border-radius:290486px;display:block;height:1rem;overflow:hidden;padding:0;width:100%}.progress::-webkit-progress-bar{background-color:#dbdbdb}.progress::-webkit-progress-value{background-color:#4a4a4a}.progress::-moz-progress-bar{background-color:#4a4a4a}.progress::-ms-fill{background-color:#4a4a4a;border:none}.progress.is-white::-webkit-progress-value{background-color:#fff}.progress.is-white::-moz-progress-bar{background-color:#fff}.progress.is-white::-ms-fill{background-color:#fff}.progress.is-black::-webkit-progress-value{background-color:#0a0a0a}.progress.is-black::-moz-progress-bar{background-color:#0a0a0a}.progress.is-black::-ms-fill{background-color:#0a0a0a}.progress.is-light::-webkit-progress-value{background-color:#f5f5f5}.progress.is-light::-moz-progress-bar{background-color:#f5f5f5}.progress.is-light::-ms-fill{background-color:#f5f5f5}.progress.is-dark::-webkit-progress-value{background-color:#363636}.progress.is-dark::-moz-progress-bar{background-color:#363636}.progress.is-dark::-ms-fill{background-color:#363636}.progress.is-primary::-webkit-progress-value{background-color:#00d1b2}.progress.is-primary::-moz-progress-bar{background-color:#00d1b2}.progress.is-primary::-ms-fill{background-color:#00d1b2}.progress.is-info::-webkit-progress-value{background-color:#209cee}.progress.is-info::-moz-progress-bar{background-color:#209cee}.progress.is-info::-ms-fill{background-color:#209cee}.progress.is-success::-webkit-progress-value{background-color:#23d160}.progress.is-success::-moz-progress-bar{background-color:#23d160}.progress.is-success::-ms-fill{background-color:#23d160}.progress.is-warning::-webkit-progress-value{background-color:#ffdd57}.progress.is-warning::-moz-progress-bar{background-color:#ffdd57}.progress.is-warning::-ms-fill{background-color:#ffdd57}.progress.is-danger::-webkit-progress-value{background-color:#ff3860}.progress.is-danger::-moz-progress-bar{background-color:#ff3860}.progress.is-danger::-ms-fill{background-color:#ff3860}.progress.is-twitter::-webkit-progress-value{background-color:#4099ff}.progress.is-twitter::-moz-progress-bar{background-color:#4099ff}.progress.is-twitter::-ms-fill{background-color:#4099ff}.progress.is-small{height:.75rem}.progress.is-medium{height:1.25rem}.progress.is-large{height:1.5rem}.table{background-color:#fff;color:#363636}.table td,.table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.table td.is-white,.table th.is-white{background-color:#fff;border-color:#fff;color:#0a0a0a}.table td.is-black,.table th.is-black{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.table td.is-light,.table th.is-light{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.table td.is-dark,.table th.is-dark{background-color:#363636;border-color:#363636;color:#f5f5f5}.table td.is-primary,.table th.is-primary{background-color:#00d1b2;border-color:#00d1b2;color:#fff}.table td.is-info,.table th.is-info{background-color:#209cee;border-color:#209cee;color:#fff}.table td.is-success,.table th.is-success{background-color:#23d160;border-color:#23d160;color:#fff}.table td.is-warning,.table th.is-warning{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.table td.is-danger,.table th.is-danger{background-color:#ff3860;border-color:#ff3860;color:#fff}.table td.is-twitter,.table th.is-twitter{background-color:#4099ff;border-color:#4099ff;color:#fff}.table td.is-narrow,.table th.is-narrow{white-space:nowrap;width:1%}.table td.is-selected,.table th.is-selected{background-color:#00d1b2;color:#fff}.table td.is-selected a,.table td.is-selected strong,.table th.is-selected a,.table th.is-selected strong{color:currentColor}.table th{color:#363636;text-align:left}.table tr.is-selected{background-color:#00d1b2;color:#fff}.table tr.is-selected a,.table tr.is-selected strong{color:currentColor}.table tr.is-selected td,.table tr.is-selected th{border-color:#fff;color:currentColor}.table thead td,.table thead th{border-width:0 0 2px;color:#363636}.table tfoot td,.table tfoot th{border-width:2px 0 0;color:#363636}.table tbody tr:last-child td,.table tbody tr:last-child th{border-bottom-width:0}.table.is-bordered td,.table.is-bordered th{border-width:1px}.table.is-bordered tr:last-child td,.table.is-bordered tr:last-child th{border-bottom-width:1px}.table.is-fullwidth{width:100%}.table.is-hoverable tbody tr:not(.is-selected):hover{background-color:#fafafa}.table.is-hoverable.is-striped tbody tr:not(.is-selected):hover{background-color:#f5f5f5}.table.is-narrow td,.table.is-narrow th{padding:.25em .5em}.table.is-striped tbody tr:not(.is-selected):nth-child(2n){background-color:#fafafa}.table-container{-webkit-overflow-scrolling:touch;overflow:auto;overflow-y:hidden;max-width:100%}.tags{align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start}.tags .tag{margin-bottom:.5rem}.tags .tag:not(:last-child){margin-right:.5rem}.tags:last-child{margin-bottom:-.5rem}.tags:not(:last-child){margin-bottom:1rem}.tags.has-addons .tag{margin-right:0}.tags.has-addons .tag:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.tags.has-addons .tag:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.tags.is-centered{justify-content:center}.tags.is-centered .tag{margin-right:.25rem;margin-left:.25rem}.tags.is-right{justify-content:flex-end}.tags.is-right .tag:not(:first-child){margin-left:.5rem}.tags.is-right .tag:not(:last-child){margin-right:0}.tag:not(body){align-items:center;background-color:#f5f5f5;border-radius:4px;color:#4a4a4a;display:inline-flex;font-size:.75rem;height:2em;justify-content:center;line-height:1.5;padding-left:.75em;padding-right:.75em;white-space:nowrap}.tag:not(body) .delete{margin-left:.25rem;margin-right:-.375rem}.tag:not(body).is-white{background-color:#fff;color:#0a0a0a}.tag:not(body).is-black{background-color:#0a0a0a;color:#fff}.tag:not(body).is-light{background-color:#f5f5f5;color:#363636}.tag:not(body).is-dark{background-color:#363636;color:#f5f5f5}.tag:not(body).is-primary{background-color:#00d1b2;color:#fff}.tag:not(body).is-info{background-color:#209cee;color:#fff}.tag:not(body).is-success{background-color:#23d160;color:#fff}.tag:not(body).is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.tag:not(body).is-danger{background-color:#ff3860;color:#fff}.tag:not(body).is-twitter{background-color:#4099ff;color:#fff}.tag:not(body).is-medium{font-size:1rem}.tag:not(body).is-large{font-size:1.25rem}.tag:not(body) .icon:first-child:not(:last-child){margin-left:-.375em;margin-right:.1875em}.tag:not(body) .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:-.375em}.tag:not(body) .icon:first-child:last-child{margin-left:-.375em;margin-right:-.375em}.tag:not(body).is-delete{margin-left:1px;padding:0;position:relative;width:2em}.tag:not(body).is-delete:after,.tag:not(body).is-delete:before{background-color:currentColor;content:\"\";display:block;left:50%;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%) rotate(45deg);transform-origin:center center}.tag:not(body).is-delete:before{height:1px;width:50%}.tag:not(body).is-delete:after{height:50%;width:1px}.tag:not(body).is-delete:focus,.tag:not(body).is-delete:hover{background-color:#e8e8e8}.tag:not(body).is-delete:active{background-color:#dbdbdb}.tag:not(body).is-rounded{border-radius:290486px}a.tag:hover{text-decoration:underline}.subtitle,.title{word-break:break-word}.subtitle em,.subtitle span,.title em,.title span{font-weight:inherit}.subtitle sub,.subtitle sup,.title sub,.title sup{font-size:.75em}.subtitle .tag,.title .tag{vertical-align:middle}.title{color:#363636;font-size:2rem;font-weight:600;line-height:1.125}.title strong{color:inherit;font-weight:inherit}.title+.highlight{margin-top:-.75rem}.title:not(.is-spaced)+.subtitle{margin-top:-1.25rem}.title.is-1{font-size:3rem}.title.is-2{font-size:2.5rem}.title.is-3{font-size:2rem}.title.is-4{font-size:1.5rem}.title.is-5{font-size:1.25rem}.title.is-6{font-size:1rem}.title.is-7{font-size:.75rem}.subtitle{color:#4a4a4a;font-size:1.25rem;font-weight:400;line-height:1.25}.subtitle strong{color:#363636;font-weight:600}.subtitle:not(.is-spaced)+.title{margin-top:-1.25rem}.subtitle.is-1{font-size:3rem}.subtitle.is-2{font-size:2.5rem}.subtitle.is-3{font-size:2rem}.subtitle.is-4{font-size:1.5rem}.subtitle.is-5{font-size:1.25rem}.subtitle.is-6{font-size:1rem}.subtitle.is-7{font-size:.75rem}.heading{display:block;font-size:11px;letter-spacing:1px;margin-bottom:5px;text-transform:uppercase}.highlight{font-weight:400;max-width:100%;overflow:hidden;padding:0}.highlight pre{overflow:auto;max-width:100%}.number{align-items:center;background-color:#f5f5f5;border-radius:290486px;display:inline-flex;font-size:1.25rem;height:2em;justify-content:center;margin-right:1.5rem;min-width:2.5em;padding:.25rem .5rem;text-align:center;vertical-align:top}.breadcrumb{font-size:1rem;white-space:nowrap}.breadcrumb a{align-items:center;color:#3273dc;display:flex;justify-content:center;padding:0 .75em}.breadcrumb a:hover{color:#363636}.breadcrumb li{align-items:center;display:flex}.breadcrumb li:first-child a{padding-left:0}.breadcrumb li.is-active a{color:#363636;cursor:default;pointer-events:none}.breadcrumb li+li:before{color:#b5b5b5;content:\"/\"}.breadcrumb ol,.breadcrumb ul{align-items:flex-start;display:flex;flex-wrap:wrap;justify-content:flex-start}.breadcrumb .icon:first-child{margin-right:.5em}.breadcrumb .icon:last-child{margin-left:.5em}.breadcrumb.is-centered ol,.breadcrumb.is-centered ul{justify-content:center}.breadcrumb.is-right ol,.breadcrumb.is-right ul{justify-content:flex-end}.breadcrumb.is-small{font-size:.75rem}.breadcrumb.is-medium{font-size:1.25rem}.breadcrumb.is-large{font-size:1.5rem}.breadcrumb.has-arrow-separator li+li:before{content:\"\\2192\"}.breadcrumb.has-bullet-separator li+li:before{content:\"\\2022\"}.breadcrumb.has-dot-separator li+li:before{content:\"\\B7\"}.breadcrumb.has-succeeds-separator li+li:before{content:\"\\227B\"}.card{background-color:#fff;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);color:#4a4a4a;max-width:100%;position:relative}.card-header{background-color:none;align-items:stretch;box-shadow:0 1px 2px hsla(0,0%,4%,.1);display:flex}.card-header-title{align-items:center;color:#363636;display:flex;flex-grow:1;font-weight:700;padding:.75rem}.card-header-icon,.card-header-title.is-centered{justify-content:center}.card-header-icon{align-items:center;cursor:pointer;display:flex;padding:.75rem}.card-image{display:block;position:relative}.card-content{background-color:none;padding:1.5rem}.card-footer{background-color:none;border-top:1px solid #dbdbdb;align-items:stretch;display:flex}.card-footer-item{align-items:center;display:flex;flex-basis:0;flex-grow:1;flex-shrink:0;justify-content:center;padding:.75rem}.card-footer-item:not(:last-child){border-right:1px solid #dbdbdb}.card .media:not(:last-child){margin-bottom:.75rem}.dropdown{display:inline-flex;position:relative;vertical-align:top}.dropdown.is-active .dropdown-menu,.dropdown.is-hoverable:hover .dropdown-menu{display:block}.dropdown.is-right .dropdown-menu{left:auto;right:0}.dropdown.is-up .dropdown-menu{bottom:100%;padding-bottom:4px;padding-top:0;top:auto}.dropdown-menu{display:none;left:0;min-width:12rem;padding-top:4px;position:absolute;top:100%;z-index:20}.dropdown-content{background-color:#fff;border-radius:4px;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);padding-bottom:.5rem;padding-top:.5rem}.dropdown-item,.dropdown .dropdown-menu .has-link a{color:#4a4a4a;display:block;font-size:.875rem;line-height:1.5;padding:.375rem 1rem;position:relative}.dropdown .dropdown-menu .has-link a,a.dropdown-item{padding-right:3rem;white-space:nowrap}.dropdown .dropdown-menu .has-link a:hover,a.dropdown-item:hover{background-color:#f5f5f5;color:#0a0a0a}.dropdown .dropdown-menu .has-link a.is-active,a.dropdown-item.is-active{background-color:#3273dc;color:#fff}.dropdown-divider{background-color:#dbdbdb;border:none;display:block;height:1px;margin:.5rem 0}.level{align-items:center;justify-content:space-between}.level code{border-radius:4px}.level img{display:inline-block;vertical-align:top}.level.is-mobile,.level.is-mobile .level-left,.level.is-mobile .level-right{display:flex}.level.is-mobile .level-left+.level-right{margin-top:0}.level.is-mobile .level-item{margin-right:.75rem}.level.is-mobile .level-item:not(:last-child){margin-bottom:0}.level.is-mobile .level-item:not(.is-narrow){flex-grow:1}@media print,screen and (min-width:769px){.level{display:flex}.level>.level-item:not(.is-narrow){flex-grow:1}}.level-item{align-items:center;display:flex;flex-basis:auto;flex-grow:0;flex-shrink:0;justify-content:center}.level-item .subtitle,.level-item .title{margin-bottom:0}@media screen and (max-width:768px){.level-item:not(:last-child){margin-bottom:.75rem}}.level-left,.level-right{flex-basis:auto;flex-grow:0;flex-shrink:0}.level-left .level-item.is-flexible,.level-right .level-item.is-flexible{flex-grow:1}@media print,screen and (min-width:769px){.level-left .level-item:not(:last-child),.level-right .level-item:not(:last-child){margin-right:.75rem}}.level-left{align-items:center;justify-content:flex-start}@media screen and (max-width:768px){.level-left+.level-right{margin-top:1.5rem}}@media print,screen and (min-width:769px){.level-left{display:flex}}.level-right{align-items:center;justify-content:flex-end}@media print,screen and (min-width:769px){.level-right{display:flex}}.media{align-items:flex-start;display:flex;text-align:left}.media .content:not(:last-child){margin-bottom:.75rem}.media .media{border-top:1px solid hsla(0,0%,86%,.5);display:flex;padding-top:.75rem}.media .media .content:not(:last-child),.media .media .control:not(:last-child){margin-bottom:.5rem}.media .media .media{padding-top:.5rem}.media .media .media+.media{margin-top:.5rem}.media+.media{border-top:1px solid hsla(0,0%,86%,.5);margin-top:1rem;padding-top:1rem}.media.is-large+.media{margin-top:1.5rem;padding-top:1.5rem}.media-left,.media-right{flex-basis:auto;flex-grow:0;flex-shrink:0}.media-left{margin-right:1rem}.media-right{margin-left:1rem}.media-content{flex-basis:auto;flex-grow:1;flex-shrink:1;text-align:left}.menu{font-size:1rem}.menu.is-small{font-size:.75rem}.menu.is-medium{font-size:1.25rem}.menu.is-large{font-size:1.5rem}.menu-list{line-height:1.25}.menu-list a{border-radius:2px;color:#4a4a4a;display:block;padding:.5em .75em}.menu-list a:hover{background-color:#f5f5f5;color:#363636}.menu-list a.is-active{background-color:#3273dc;color:#fff}.menu-list li ul{border-left:1px solid #dbdbdb;margin:.75em;padding-left:.75em}.menu-label{color:#7a7a7a;font-size:.75em;letter-spacing:.1em;text-transform:uppercase}.menu-label:not(:first-child){margin-top:1em}.menu-label:not(:last-child){margin-bottom:1em}.message{background-color:#f5f5f5;border-radius:4px;font-size:1rem}.message strong{color:currentColor}.message a:not(.button):not(.tag){color:currentColor;text-decoration:underline}.message.is-small{font-size:.75rem}.message.is-medium{font-size:1.25rem}.message.is-large{font-size:1.5rem}.message.is-white{background-color:#fff}.message.is-white .message-header{background-color:#fff;color:#0a0a0a}.message.is-white .message-body{border-color:#fff;color:#4d4d4d}.message.is-black{background-color:#fafafa}.message.is-black .message-header{background-color:#0a0a0a;color:#fff}.message.is-black .message-body{border-color:#0a0a0a;color:#090909}.message.is-light{background-color:#fafafa}.message.is-light .message-header{background-color:#f5f5f5;color:#363636}.message.is-light .message-body{border-color:#f5f5f5;color:#505050}.message.is-dark{background-color:#fafafa}.message.is-dark .message-header{background-color:#363636;color:#f5f5f5}.message.is-dark .message-body{border-color:#363636;color:#2a2a2a}.message.is-primary{background-color:#f5fffd}.message.is-primary .message-header{background-color:#00d1b2;color:#fff}.message.is-primary .message-body{border-color:#00d1b2;color:#021310}.message.is-info{background-color:#f6fbfe}.message.is-info .message-header{background-color:#209cee;color:#fff}.message.is-info .message-body{border-color:#209cee;color:#12537e}.message.is-success{background-color:#f6fef9}.message.is-success .message-header{background-color:#23d160;color:#fff}.message.is-success .message-body{border-color:#23d160;color:#0e301a}.message.is-warning{background-color:#fffdf5}.message.is-warning .message-header{background-color:#ffdd57;color:rgba(0,0,0,.7)}.message.is-warning .message-body{border-color:#ffdd57;color:#3b3108}.message.is-danger{background-color:#fff5f7}.message.is-danger .message-header{background-color:#ff3860;color:#fff}.message.is-danger .message-body{border-color:#ff3860;color:#cd0930}.message.is-twitter{background-color:#f5faff}.message.is-twitter .message-header{background-color:#4099ff;color:#fff}.message.is-twitter .message-body{border-color:#4099ff;color:#0a59b2}.message-header{align-items:center;background-color:#4a4a4a;border-radius:4px 4px 0 0;color:#fff;display:flex;font-weight:700;justify-content:space-between;line-height:1.25;padding:.75em 1em;position:relative}.message-header .delete{flex-grow:0;flex-shrink:0;margin-left:.75em}.message-header+.message-body{border-width:0;border-top-left-radius:0;border-top-right-radius:0}.message-body{border-color:#dbdbdb;border-radius:4px;border-style:solid;border-width:0 0 0 4px;color:#4a4a4a;padding:1.25em 1.5em}.message-body code,.message-body pre{background-color:#fff}.message-body pre code{background-color:transparent}.modal{align-items:center;display:none;justify-content:center;overflow:hidden;position:fixed;z-index:40}.modal.is-active{display:flex}.modal-background{background-color:hsla(0,0%,4%,.86)}.modal-card,.modal-content{margin:0 20px;max-height:calc(100vh - 160px);overflow:auto;position:relative;width:100%}@media print,screen and (min-width:769px){.modal-card,.modal-content{margin:0 auto;max-height:calc(100vh - 40px);width:640px}}.modal-close{background:none;height:40px;position:fixed;right:20px;top:20px;width:40px}.modal-card{display:flex;flex-direction:column;max-height:calc(100vh - 40px);overflow:hidden}.modal-card-foot,.modal-card-head{align-items:center;background-color:#f5f5f5;display:flex;flex-shrink:0;justify-content:flex-start;padding:20px;position:relative}.modal-card-head{border-bottom:1px solid #dbdbdb;border-top-left-radius:6px;border-top-right-radius:6px}.modal-card-title{color:#363636;flex-grow:1;flex-shrink:0;font-size:1.5rem;line-height:1}.modal-card-foot{border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:1px solid #dbdbdb}.modal-card-foot .button:not(:last-child){margin-right:10px}.modal-card-body{-webkit-overflow-scrolling:touch;background-color:#fff;flex-grow:1;flex-shrink:1;overflow:auto;padding:20px}.navbar{background-color:#fff;min-height:3.25rem;position:relative;z-index:30}.navbar.is-white{background-color:#fff;color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link,.navbar.is-white .navbar-brand>.navbar-item{color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link.is-active,.navbar.is-white .navbar-brand .navbar-link:hover,.navbar.is-white .navbar-brand>a.navbar-item.is-active,.navbar.is-white .navbar-brand>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link:after{border-color:#0a0a0a}@media screen and (min-width:1088px){.navbar.is-white .navbar-end .navbar-link,.navbar.is-white .navbar-end>.navbar-item,.navbar.is-white .navbar-start .navbar-link,.navbar.is-white .navbar-start>.navbar-item{color:#0a0a0a}.navbar.is-white .navbar-end .navbar-link.is-active,.navbar.is-white .navbar-end .navbar-link:hover,.navbar.is-white .navbar-end>a.navbar-item.is-active,.navbar.is-white .navbar-end>a.navbar-item:hover,.navbar.is-white .navbar-start .navbar-link.is-active,.navbar.is-white .navbar-start .navbar-link:hover,.navbar.is-white .navbar-start>a.navbar-item.is-active,.navbar.is-white .navbar-start>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-end .navbar-link:after,.navbar.is-white .navbar-start .navbar-link:after{border-color:#0a0a0a}.navbar.is-white .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-white .navbar-item.has-dropdown:hover .navbar-link{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-dropdown a.navbar-item.is-active{background-color:#fff;color:#0a0a0a}}.navbar.is-black{background-color:#0a0a0a;color:#fff}.navbar.is-black .navbar-brand .navbar-link,.navbar.is-black .navbar-brand>.navbar-item{color:#fff}.navbar.is-black .navbar-brand .navbar-link.is-active,.navbar.is-black .navbar-brand .navbar-link:hover,.navbar.is-black .navbar-brand>a.navbar-item.is-active,.navbar.is-black .navbar-brand>a.navbar-item:hover{background-color:#000;color:#fff}.navbar.is-black .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-black .navbar-end .navbar-link,.navbar.is-black .navbar-end>.navbar-item,.navbar.is-black .navbar-start .navbar-link,.navbar.is-black .navbar-start>.navbar-item{color:#fff}.navbar.is-black .navbar-end .navbar-link.is-active,.navbar.is-black .navbar-end .navbar-link:hover,.navbar.is-black .navbar-end>a.navbar-item.is-active,.navbar.is-black .navbar-end>a.navbar-item:hover,.navbar.is-black .navbar-start .navbar-link.is-active,.navbar.is-black .navbar-start .navbar-link:hover,.navbar.is-black .navbar-start>a.navbar-item.is-active,.navbar.is-black .navbar-start>a.navbar-item:hover{background-color:#000;color:#fff}.navbar.is-black .navbar-end .navbar-link:after,.navbar.is-black .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-black .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-black .navbar-item.has-dropdown:hover .navbar-link{background-color:#000;color:#fff}.navbar.is-black .navbar-dropdown a.navbar-item.is-active{background-color:#0a0a0a;color:#fff}}.navbar.is-light{background-color:#f5f5f5;color:#363636}.navbar.is-light .navbar-brand .navbar-link,.navbar.is-light .navbar-brand>.navbar-item{color:#363636}.navbar.is-light .navbar-brand .navbar-link.is-active,.navbar.is-light .navbar-brand .navbar-link:hover,.navbar.is-light .navbar-brand>a.navbar-item.is-active,.navbar.is-light .navbar-brand>a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-brand .navbar-link:after{border-color:#363636}@media screen and (min-width:1088px){.navbar.is-light .navbar-end .navbar-link,.navbar.is-light .navbar-end>.navbar-item,.navbar.is-light .navbar-start .navbar-link,.navbar.is-light .navbar-start>.navbar-item{color:#363636}.navbar.is-light .navbar-end .navbar-link.is-active,.navbar.is-light .navbar-end .navbar-link:hover,.navbar.is-light .navbar-end>a.navbar-item.is-active,.navbar.is-light .navbar-end>a.navbar-item:hover,.navbar.is-light .navbar-start .navbar-link.is-active,.navbar.is-light .navbar-start .navbar-link:hover,.navbar.is-light .navbar-start>a.navbar-item.is-active,.navbar.is-light .navbar-start>a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-end .navbar-link:after,.navbar.is-light .navbar-start .navbar-link:after{border-color:#363636}.navbar.is-light .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-light .navbar-item.has-dropdown:hover .navbar-link{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#363636}}.navbar.is-dark{background-color:#363636;color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link,.navbar.is-dark .navbar-brand>.navbar-item{color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link.is-active,.navbar.is-dark .navbar-brand .navbar-link:hover,.navbar.is-dark .navbar-brand>a.navbar-item.is-active,.navbar.is-dark .navbar-brand>a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link:after{border-color:#f5f5f5}@media screen and (min-width:1088px){.navbar.is-dark .navbar-end .navbar-link,.navbar.is-dark .navbar-end>.navbar-item,.navbar.is-dark .navbar-start .navbar-link,.navbar.is-dark .navbar-start>.navbar-item{color:#f5f5f5}.navbar.is-dark .navbar-end .navbar-link.is-active,.navbar.is-dark .navbar-end .navbar-link:hover,.navbar.is-dark .navbar-end>a.navbar-item.is-active,.navbar.is-dark .navbar-end>a.navbar-item:hover,.navbar.is-dark .navbar-start .navbar-link.is-active,.navbar.is-dark .navbar-start .navbar-link:hover,.navbar.is-dark .navbar-start>a.navbar-item.is-active,.navbar.is-dark .navbar-start>a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-end .navbar-link:after,.navbar.is-dark .navbar-start .navbar-link:after{border-color:#f5f5f5}.navbar.is-dark .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-dark .navbar-item.has-dropdown:hover .navbar-link{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-dropdown a.navbar-item.is-active{background-color:#363636;color:#f5f5f5}}.navbar.is-primary{background-color:#00d1b2;color:#fff}.navbar.is-primary .navbar-brand .navbar-link,.navbar.is-primary .navbar-brand>.navbar-item{color:#fff}.navbar.is-primary .navbar-brand .navbar-link.is-active,.navbar.is-primary .navbar-brand .navbar-link:hover,.navbar.is-primary .navbar-brand>a.navbar-item.is-active,.navbar.is-primary .navbar-brand>a.navbar-item:hover{background-color:#00b89c;color:#fff}.navbar.is-primary .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-primary .navbar-end .navbar-link,.navbar.is-primary .navbar-end>.navbar-item,.navbar.is-primary .navbar-start .navbar-link,.navbar.is-primary .navbar-start>.navbar-item{color:#fff}.navbar.is-primary .navbar-end .navbar-link.is-active,.navbar.is-primary .navbar-end .navbar-link:hover,.navbar.is-primary .navbar-end>a.navbar-item.is-active,.navbar.is-primary .navbar-end>a.navbar-item:hover,.navbar.is-primary .navbar-start .navbar-link.is-active,.navbar.is-primary .navbar-start .navbar-link:hover,.navbar.is-primary .navbar-start>a.navbar-item.is-active,.navbar.is-primary .navbar-start>a.navbar-item:hover{background-color:#00b89c;color:#fff}.navbar.is-primary .navbar-end .navbar-link:after,.navbar.is-primary .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link{background-color:#00b89c;color:#fff}.navbar.is-primary .navbar-dropdown a.navbar-item.is-active{background-color:#00d1b2;color:#fff}}.navbar.is-info{background-color:#209cee;color:#fff}.navbar.is-info .navbar-brand .navbar-link,.navbar.is-info .navbar-brand>.navbar-item{color:#fff}.navbar.is-info .navbar-brand .navbar-link.is-active,.navbar.is-info .navbar-brand .navbar-link:hover,.navbar.is-info .navbar-brand>a.navbar-item.is-active,.navbar.is-info .navbar-brand>a.navbar-item:hover{background-color:#118fe4;color:#fff}.navbar.is-info .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-info .navbar-end .navbar-link,.navbar.is-info .navbar-end>.navbar-item,.navbar.is-info .navbar-start .navbar-link,.navbar.is-info .navbar-start>.navbar-item{color:#fff}.navbar.is-info .navbar-end .navbar-link.is-active,.navbar.is-info .navbar-end .navbar-link:hover,.navbar.is-info .navbar-end>a.navbar-item.is-active,.navbar.is-info .navbar-end>a.navbar-item:hover,.navbar.is-info .navbar-start .navbar-link.is-active,.navbar.is-info .navbar-start .navbar-link:hover,.navbar.is-info .navbar-start>a.navbar-item.is-active,.navbar.is-info .navbar-start>a.navbar-item:hover{background-color:#118fe4;color:#fff}.navbar.is-info .navbar-end .navbar-link:after,.navbar.is-info .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-info .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-info .navbar-item.has-dropdown:hover .navbar-link{background-color:#118fe4;color:#fff}.navbar.is-info .navbar-dropdown a.navbar-item.is-active{background-color:#209cee;color:#fff}}.navbar.is-success{background-color:#23d160;color:#fff}.navbar.is-success .navbar-brand .navbar-link,.navbar.is-success .navbar-brand>.navbar-item{color:#fff}.navbar.is-success .navbar-brand .navbar-link.is-active,.navbar.is-success .navbar-brand .navbar-link:hover,.navbar.is-success .navbar-brand>a.navbar-item.is-active,.navbar.is-success .navbar-brand>a.navbar-item:hover{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-success .navbar-end .navbar-link,.navbar.is-success .navbar-end>.navbar-item,.navbar.is-success .navbar-start .navbar-link,.navbar.is-success .navbar-start>.navbar-item{color:#fff}.navbar.is-success .navbar-end .navbar-link.is-active,.navbar.is-success .navbar-end .navbar-link:hover,.navbar.is-success .navbar-end>a.navbar-item.is-active,.navbar.is-success .navbar-end>a.navbar-item:hover,.navbar.is-success .navbar-start .navbar-link.is-active,.navbar.is-success .navbar-start .navbar-link:hover,.navbar.is-success .navbar-start>a.navbar-item.is-active,.navbar.is-success .navbar-start>a.navbar-item:hover{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-end .navbar-link:after,.navbar.is-success .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-success .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-success .navbar-item.has-dropdown:hover .navbar-link{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-dropdown a.navbar-item.is-active{background-color:#23d160;color:#fff}}.navbar.is-warning{background-color:#ffdd57}.navbar.is-warning,.navbar.is-warning .navbar-brand .navbar-link,.navbar.is-warning .navbar-brand>.navbar-item{color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-brand .navbar-link.is-active,.navbar.is-warning .navbar-brand .navbar-link:hover,.navbar.is-warning .navbar-brand>a.navbar-item.is-active,.navbar.is-warning .navbar-brand>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-brand .navbar-link:after{border-color:rgba(0,0,0,.7)}@media screen and (min-width:1088px){.navbar.is-warning .navbar-end .navbar-link,.navbar.is-warning .navbar-end>.navbar-item,.navbar.is-warning .navbar-start .navbar-link,.navbar.is-warning .navbar-start>.navbar-item{color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-end .navbar-link.is-active,.navbar.is-warning .navbar-end .navbar-link:hover,.navbar.is-warning .navbar-end>a.navbar-item.is-active,.navbar.is-warning .navbar-end>a.navbar-item:hover,.navbar.is-warning .navbar-start .navbar-link.is-active,.navbar.is-warning .navbar-start .navbar-link:hover,.navbar.is-warning .navbar-start>a.navbar-item.is-active,.navbar.is-warning .navbar-start>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-end .navbar-link:after,.navbar.is-warning .navbar-start .navbar-link:after{border-color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-warning .navbar-item.has-dropdown:hover .navbar-link{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-dropdown a.navbar-item.is-active{background-color:#ffdd57;color:rgba(0,0,0,.7)}}.navbar.is-danger{background-color:#ff3860;color:#fff}.navbar.is-danger .navbar-brand .navbar-link,.navbar.is-danger .navbar-brand>.navbar-item{color:#fff}.navbar.is-danger .navbar-brand .navbar-link.is-active,.navbar.is-danger .navbar-brand .navbar-link:hover,.navbar.is-danger .navbar-brand>a.navbar-item.is-active,.navbar.is-danger .navbar-brand>a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-danger .navbar-end .navbar-link,.navbar.is-danger .navbar-end>.navbar-item,.navbar.is-danger .navbar-start .navbar-link,.navbar.is-danger .navbar-start>.navbar-item{color:#fff}.navbar.is-danger .navbar-end .navbar-link.is-active,.navbar.is-danger .navbar-end .navbar-link:hover,.navbar.is-danger .navbar-end>a.navbar-item.is-active,.navbar.is-danger .navbar-end>a.navbar-item:hover,.navbar.is-danger .navbar-start .navbar-link.is-active,.navbar.is-danger .navbar-start .navbar-link:hover,.navbar.is-danger .navbar-start>a.navbar-item.is-active,.navbar.is-danger .navbar-start>a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-end .navbar-link:after,.navbar.is-danger .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-danger .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-danger .navbar-item.has-dropdown:hover .navbar-link{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-dropdown a.navbar-item.is-active{background-color:#ff3860;color:#fff}}.navbar.is-twitter{background-color:#4099ff;color:#fff}.navbar.is-twitter .navbar-brand .navbar-link,.navbar.is-twitter .navbar-brand>.navbar-item{color:#fff}.navbar.is-twitter .navbar-brand .navbar-link.is-active,.navbar.is-twitter .navbar-brand .navbar-link:hover,.navbar.is-twitter .navbar-brand>a.navbar-item.is-active,.navbar.is-twitter .navbar-brand>a.navbar-item:hover{background-color:#278bff;color:#fff}.navbar.is-twitter .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-twitter .navbar-end .navbar-link,.navbar.is-twitter .navbar-end>.navbar-item,.navbar.is-twitter .navbar-start .navbar-link,.navbar.is-twitter .navbar-start>.navbar-item{color:#fff}.navbar.is-twitter .navbar-end .navbar-link.is-active,.navbar.is-twitter .navbar-end .navbar-link:hover,.navbar.is-twitter .navbar-end>a.navbar-item.is-active,.navbar.is-twitter .navbar-end>a.navbar-item:hover,.navbar.is-twitter .navbar-start .navbar-link.is-active,.navbar.is-twitter .navbar-start .navbar-link:hover,.navbar.is-twitter .navbar-start>a.navbar-item.is-active,.navbar.is-twitter .navbar-start>a.navbar-item:hover{background-color:#278bff;color:#fff}.navbar.is-twitter .navbar-end .navbar-link:after,.navbar.is-twitter .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-twitter .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-twitter .navbar-item.has-dropdown:hover .navbar-link{background-color:#278bff;color:#fff}.navbar.is-twitter .navbar-dropdown a.navbar-item.is-active{background-color:#4099ff;color:#fff}}.navbar>.container{align-items:stretch;display:flex;min-height:3.25rem;width:100%}.navbar.has-shadow{box-shadow:0 2px 0 0 #f5f5f5}.navbar.is-fixed-bottom,.navbar.is-fixed-top{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom{bottom:0}.navbar.is-fixed-bottom.has-shadow{box-shadow:0 -2px 0 0 #f5f5f5}.navbar.is-fixed-top{top:0}body.has-navbar-fixed-top,html.has-navbar-fixed-top{padding-top:3.25rem}body.has-navbar-fixed-bottom,html.has-navbar-fixed-bottom{padding-bottom:3.25rem}.navbar-brand,.navbar-tabs{align-items:stretch;display:flex;flex-shrink:0;min-height:3.25rem}.navbar-brand a.navbar-item:hover{background-color:transparent}.navbar-tabs{-webkit-overflow-scrolling:touch;max-width:100vw;overflow-x:auto;overflow-y:hidden}.navbar-burger{cursor:pointer;display:block;height:3.25rem;position:relative;width:3.25rem;margin-left:auto}.navbar-burger span{background-color:currentColor;display:block;height:1px;left:calc(50% - 8px);position:absolute;transform-origin:center;transition-duration:86ms;transition-property:background-color,opacity,transform;transition-timing-function:ease-out;width:16px}.navbar-burger span:first-child{top:calc(50% - 6px)}.navbar-burger span:nth-child(2){top:calc(50% - 1px)}.navbar-burger span:nth-child(3){top:calc(50% + 4px)}.navbar-burger:hover{background-color:rgba(0,0,0,.05)}.navbar-burger.is-active span:first-child{transform:translateY(5px) rotate(45deg)}.navbar-burger.is-active span:nth-child(2){opacity:0}.navbar-burger.is-active span:nth-child(3){transform:translateY(-5px) rotate(-45deg)}.navbar-menu{display:none}.navbar-item,.navbar-link{color:#4a4a4a;display:block;line-height:1.5;padding:.5rem .75rem;position:relative}.navbar-item .icon:only-child,.navbar-link .icon:only-child{margin-left:-.25rem;margin-right:-.25rem}.navbar-link,a.navbar-item{cursor:pointer}.navbar-link.is-active,.navbar-link:hover,a.navbar-item.is-active,a.navbar-item:hover{background-color:#fafafa;color:#3273dc}.navbar-item{display:block;flex-grow:0;flex-shrink:0}.navbar-item img{max-height:1.75rem}.navbar-item.has-dropdown{padding:0}.navbar-item.is-expanded{flex-grow:1;flex-shrink:1}.navbar-item.is-tab{border-bottom:1px solid transparent;min-height:3.25rem;padding-bottom:calc(.5rem - 1px)}.navbar-item.is-tab.is-active,.navbar-item.is-tab:hover{background-color:transparent;border-bottom-color:#3273dc}.navbar-item.is-tab.is-active{border-bottom-style:solid;border-bottom-width:3px;color:#3273dc;padding-bottom:calc(.5rem - 3px)}.navbar-content{flex-grow:1;flex-shrink:1}.navbar-link{padding-right:2.5em}.navbar-link:after{border-color:#3273dc;margin-top:-.375em;right:1.125em}.navbar-dropdown{font-size:.875rem;padding-bottom:.5rem;padding-top:.5rem}.navbar-dropdown .navbar-item{padding-left:1.5rem;padding-right:1.5rem}.navbar-divider{background-color:#f5f5f5;border:none;display:none;height:2px;margin:.5rem 0}@media screen and (max-width:1087px){.navbar>.container{display:block}.navbar-brand .navbar-item,.navbar-tabs .navbar-item{align-items:center;display:flex}.navbar-link:after{display:none}.navbar-menu{background-color:#fff;box-shadow:0 8px 16px hsla(0,0%,4%,.1);padding:.5rem 0}.navbar-menu.is-active{display:block}.navbar.is-fixed-bottom-touch,.navbar.is-fixed-top-touch{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom-touch{bottom:0}.navbar.is-fixed-bottom-touch.has-shadow{box-shadow:0 -2px 3px hsla(0,0%,4%,.1)}.navbar.is-fixed-top-touch{top:0}.navbar.is-fixed-top-touch .navbar-menu,.navbar.is-fixed-top .navbar-menu{-webkit-overflow-scrolling:touch;max-height:calc(100vh - 3.25rem);overflow:auto}body.has-navbar-fixed-top-touch,html.has-navbar-fixed-top-touch{padding-top:3.25rem}body.has-navbar-fixed-bottom-touch,html.has-navbar-fixed-bottom-touch{padding-bottom:3.25rem}}@media screen and (min-width:1088px){.navbar,.navbar-end,.navbar-menu,.navbar-start{align-items:stretch;display:flex}.navbar{min-height:3.25rem}.navbar.is-spaced{padding:1rem 2rem}.navbar.is-spaced .navbar-end,.navbar.is-spaced .navbar-start{align-items:center}.navbar.is-spaced .navbar-link,.navbar.is-spaced a.navbar-item{border-radius:4px}.navbar.is-transparent .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:hover .navbar-link,.navbar.is-transparent .navbar-link.is-active,.navbar.is-transparent .navbar-link:hover,.navbar.is-transparent a.navbar-item.is-active,.navbar.is-transparent a.navbar-item:hover{background-color:transparent!important}.navbar.is-transparent .navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.navbar.is-transparent .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#3273dc}.navbar-burger{display:none}.navbar-item,.navbar-link{align-items:center;display:flex}.navbar-item{display:flex}.navbar-item.has-dropdown{align-items:stretch}.navbar-item.has-dropdown-up .navbar-link:after{transform:rotate(135deg) translate(.25em,-.25em)}.navbar-item.has-dropdown-up .navbar-dropdown{border-bottom:2px solid #dbdbdb;border-radius:6px 6px 0 0;border-top:none;bottom:100%;box-shadow:0 -8px 8px hsla(0,0%,4%,.1);top:auto}.navbar-item.is-active .navbar-dropdown,.navbar-item.is-hoverable:hover .navbar-dropdown{display:block}.navbar-item.is-active .navbar-dropdown.is-boxed,.navbar-item.is-hoverable:hover .navbar-dropdown.is-boxed,.navbar.is-spaced .navbar-item.is-active .navbar-dropdown,.navbar.is-spaced .navbar-item.is-hoverable:hover .navbar-dropdown{opacity:1;pointer-events:auto;transform:translateY(0)}.navbar-menu{flex-grow:1;flex-shrink:0}.navbar-start{justify-content:flex-start;margin-right:auto}.navbar-end{justify-content:flex-end;margin-left:auto}.navbar-dropdown{background-color:#fff;border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:2px solid #dbdbdb;box-shadow:0 8px 8px hsla(0,0%,4%,.1);display:none;font-size:.875rem;left:0;min-width:100%;position:absolute;top:100%;z-index:20}.navbar-dropdown .navbar-item{padding:.375rem 1rem;white-space:nowrap}.navbar-dropdown a.navbar-item{padding-right:3rem}.navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#3273dc}.navbar-dropdown.is-boxed,.navbar.is-spaced .navbar-dropdown{border-radius:6px;border-top:none;box-shadow:0 8px 8px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);display:block;opacity:0;pointer-events:none;top:calc(100% + -4px);transform:translateY(-5px);transition-duration:86ms;transition-property:opacity,transform}.navbar-dropdown.is-right{left:auto;right:0}.navbar-divider{display:block}.container>.navbar .navbar-brand,.navbar>.container .navbar-brand{margin-left:-1rem}.container>.navbar .navbar-menu,.navbar>.container .navbar-menu{margin-right:-1rem}.navbar.is-fixed-bottom-desktop,.navbar.is-fixed-top-desktop{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom-desktop{bottom:0}.navbar.is-fixed-bottom-desktop.has-shadow{box-shadow:0 -2px 3px hsla(0,0%,4%,.1)}.navbar.is-fixed-top-desktop{top:0}body.has-navbar-fixed-top-desktop,html.has-navbar-fixed-top-desktop{padding-top:3.25rem}body.has-navbar-fixed-bottom-desktop,html.has-navbar-fixed-bottom-desktop{padding-bottom:3.25rem}body.has-spaced-navbar-fixed-top,html.has-spaced-navbar-fixed-top{padding-top:5.25rem}body.has-spaced-navbar-fixed-bottom,html.has-spaced-navbar-fixed-bottom{padding-bottom:5.25rem}.navbar-link.is-active,a.navbar-item.is-active{color:#0a0a0a}.navbar-link.is-active:not(:hover),a.navbar-item.is-active:not(:hover){background-color:transparent}.navbar-item.has-dropdown.is-active .navbar-link,.navbar-item.has-dropdown:hover .navbar-link{background-color:#fafafa}}.pagination{font-size:1rem;margin:-.25rem}.pagination.is-small{font-size:.75rem}.pagination.is-medium{font-size:1.25rem}.pagination.is-large{font-size:1.5rem}.pagination.is-rounded .pagination-next,.pagination.is-rounded .pagination-previous{padding-left:1em;padding-right:1em;border-radius:290486px}.pagination.is-rounded .pagination-link{border-radius:290486px}.pagination,.pagination-list{align-items:center;display:flex;justify-content:center;text-align:center}.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous{font-size:1em;padding-left:.5em;padding-right:.5em;justify-content:center;margin:.25rem;text-align:center}.pagination-link,.pagination-next,.pagination-previous{border-color:#dbdbdb;color:#363636;min-width:2.25em}.pagination-link:hover,.pagination-next:hover,.pagination-previous:hover{border-color:#b5b5b5;color:#363636}.pagination-link:focus,.pagination-next:focus,.pagination-previous:focus{border-color:#3273dc}.pagination-link:active,.pagination-next:active,.pagination-previous:active{box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2)}.pagination-link[disabled],.pagination-next[disabled],.pagination-previous[disabled]{background-color:#dbdbdb;border-color:#dbdbdb;box-shadow:none;color:#7a7a7a;opacity:.5}.pagination-next,.pagination-previous{padding-left:.75em;padding-right:.75em;white-space:nowrap}.pagination-link.is-current{background-color:#3273dc;border-color:#3273dc;color:#fff}.pagination-ellipsis{color:#b5b5b5;pointer-events:none}.pagination-list{flex-wrap:wrap}@media screen and (max-width:768px){.pagination{flex-wrap:wrap}.pagination-list li,.pagination-next,.pagination-previous{flex-grow:1;flex-shrink:1}}@media print,screen and (min-width:769px){.pagination-list{flex-grow:1;flex-shrink:1;justify-content:flex-start;order:1}.pagination-previous{order:2}.pagination-next{order:3}.pagination{justify-content:space-between}.pagination.is-centered .pagination-previous{order:1}.pagination.is-centered .pagination-list{justify-content:center;order:2}.pagination.is-centered .pagination-next{order:3}.pagination.is-right .pagination-previous{order:1}.pagination.is-right .pagination-next{order:2}.pagination.is-right .pagination-list{justify-content:flex-end;order:3}}.panel{font-size:1rem}.panel:not(:last-child){margin-bottom:1.5rem}.panel-block,.panel-heading,.panel-tabs{border-bottom:1px solid #dbdbdb;border-left:1px solid #dbdbdb;border-right:1px solid #dbdbdb}.panel-block:first-child,.panel-heading:first-child,.panel-tabs:first-child{border-top:1px solid #dbdbdb}.panel-heading{background-color:#f5f5f5;border-radius:4px 4px 0 0;color:#363636;font-size:1.25em;font-weight:300;line-height:1.25;padding:.5em .75em}.panel-tabs{align-items:flex-end;display:flex;font-size:.875em;justify-content:center}.panel-tabs a{border-bottom:1px solid #dbdbdb;margin-bottom:-1px;padding:.5em}.panel-tabs a.is-active{border-bottom-color:#4a4a4a;color:#363636}.panel-list a{color:#4a4a4a}.panel-list a:hover{color:#3273dc}.panel-block{align-items:center;color:#363636;display:flex;justify-content:flex-start;padding:.5em .75em}.panel-block input[type=checkbox]{margin-right:.75em}.panel-block>.control{flex-grow:1;flex-shrink:1;width:100%}.panel-block.is-wrapped{flex-wrap:wrap}.panel-block.is-active{border-left-color:#3273dc;color:#363636}.panel-block.is-active .panel-icon{color:#3273dc}a.panel-block,label.panel-block{cursor:pointer}a.panel-block:hover,label.panel-block:hover{background-color:#f5f5f5}.panel-icon{display:inline-block;font-size:14px;height:1em;line-height:1em;text-align:center;vertical-align:top;width:1em;color:#7a7a7a;margin-right:.75em}.panel-icon .fa{font-size:inherit;line-height:inherit}.tabs{-webkit-overflow-scrolling:touch;align-items:stretch;display:flex;font-size:1rem;justify-content:space-between;overflow:hidden;overflow-x:auto;white-space:nowrap}.tabs a{align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;color:#4a4a4a;display:flex;justify-content:center;margin-bottom:-1px;padding:.5em 1em;vertical-align:top}.tabs a:hover{border-bottom-color:#363636;color:#363636}.tabs li{display:block}.tabs li.is-active a{border-bottom-color:#3273dc;color:#3273dc}.tabs ul{align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;display:flex;flex-grow:1;flex-shrink:0;justify-content:flex-start}.tabs ul.is-center,.tabs ul.is-left{padding-right:.75em}.tabs ul.is-center{flex:none;justify-content:center;padding-left:.75em}.tabs ul.is-right{justify-content:flex-end;padding-left:.75em}.tabs .icon:first-child{margin-right:.5em}.tabs .icon:last-child{margin-left:.5em}.tabs.is-centered ul{justify-content:center}.tabs.is-right ul{justify-content:flex-end}.tabs.is-boxed a{border:1px solid transparent;border-radius:4px 4px 0 0}.tabs.is-boxed a:hover{background-color:#f5f5f5;border-bottom-color:#dbdbdb}.tabs.is-boxed li.is-active a{background-color:#fff;border-color:#dbdbdb;border-bottom-color:transparent!important}.tabs.is-fullwidth li{flex-grow:1;flex-shrink:0}.tabs.is-toggle a{border:1px solid #dbdbdb;margin-bottom:0;position:relative}.tabs.is-toggle a:hover{background-color:#f5f5f5;border-color:#b5b5b5;z-index:2}.tabs.is-toggle li+li{margin-left:-1px}.tabs.is-toggle li:first-child a{border-radius:4px 0 0 4px}.tabs.is-toggle li:last-child a{border-radius:0 4px 4px 0}.tabs.is-toggle li.is-active a{background-color:#3273dc;border-color:#3273dc;color:#fff;z-index:1}.tabs.is-toggle ul{border-bottom:none}.tabs.is-toggle.is-toggle-rounded li:first-child a{border-bottom-left-radius:290486px;border-top-left-radius:290486px;padding-left:1.25em}.tabs.is-toggle.is-toggle-rounded li:last-child a{border-bottom-right-radius:290486px;border-top-right-radius:290486px;padding-right:1.25em}.tabs.is-small{font-size:.75rem}.tabs.is-medium{font-size:1.25rem}.tabs.is-large{font-size:1.5rem}.column{display:block;flex-basis:0;flex-grow:1;flex-shrink:1;padding:.75rem}.columns.is-mobile>.column.is-narrow{flex:none}.columns.is-mobile>.column.is-full{flex:none;width:100%}.columns.is-mobile>.column.is-three-quarters{flex:none;width:75%}.columns.is-mobile>.column.is-two-thirds{flex:none;width:66.6666%}.columns.is-mobile>.column.is-half{flex:none;width:50%}.columns.is-mobile>.column.is-one-third{flex:none;width:33.3333%}.columns.is-mobile>.column.is-one-quarter{flex:none;width:25%}.columns.is-mobile>.column.is-one-fifth{flex:none;width:20%}.columns.is-mobile>.column.is-two-fifths{flex:none;width:40%}.columns.is-mobile>.column.is-three-fifths{flex:none;width:60%}.columns.is-mobile>.column.is-four-fifths{flex:none;width:80%}.columns.is-mobile>.column.is-offset-three-quarters{margin-left:75%}.columns.is-mobile>.column.is-offset-two-thirds{margin-left:66.6666%}.columns.is-mobile>.column.is-offset-half{margin-left:50%}.columns.is-mobile>.column.is-offset-one-third{margin-left:33.3333%}.columns.is-mobile>.column.is-offset-one-quarter{margin-left:25%}.columns.is-mobile>.column.is-offset-one-fifth{margin-left:20%}.columns.is-mobile>.column.is-offset-two-fifths{margin-left:40%}.columns.is-mobile>.column.is-offset-three-fifths{margin-left:60%}.columns.is-mobile>.column.is-offset-four-fifths{margin-left:80%}.columns.is-mobile>.column.is-1{flex:none;width:8.33333%}.columns.is-mobile>.column.is-offset-1{margin-left:8.33333%}.columns.is-mobile>.column.is-2{flex:none;width:16.66667%}.columns.is-mobile>.column.is-offset-2{margin-left:16.66667%}.columns.is-mobile>.column.is-3{flex:none;width:25%}.columns.is-mobile>.column.is-offset-3{margin-left:25%}.columns.is-mobile>.column.is-4{flex:none;width:33.33333%}.columns.is-mobile>.column.is-offset-4{margin-left:33.33333%}.columns.is-mobile>.column.is-5{flex:none;width:41.66667%}.columns.is-mobile>.column.is-offset-5{margin-left:41.66667%}.columns.is-mobile>.column.is-6{flex:none;width:50%}.columns.is-mobile>.column.is-offset-6{margin-left:50%}.columns.is-mobile>.column.is-7{flex:none;width:58.33333%}.columns.is-mobile>.column.is-offset-7{margin-left:58.33333%}.columns.is-mobile>.column.is-8{flex:none;width:66.66667%}.columns.is-mobile>.column.is-offset-8{margin-left:66.66667%}.columns.is-mobile>.column.is-9{flex:none;width:75%}.columns.is-mobile>.column.is-offset-9{margin-left:75%}.columns.is-mobile>.column.is-10{flex:none;width:83.33333%}.columns.is-mobile>.column.is-offset-10{margin-left:83.33333%}.columns.is-mobile>.column.is-11{flex:none;width:91.66667%}.columns.is-mobile>.column.is-offset-11{margin-left:91.66667%}.columns.is-mobile>.column.is-12{flex:none;width:100%}.columns.is-mobile>.column.is-offset-12{margin-left:100%}@media screen and (max-width:768px){.column.is-narrow-mobile{flex:none}.column.is-full-mobile{flex:none;width:100%}.column.is-three-quarters-mobile{flex:none;width:75%}.column.is-two-thirds-mobile{flex:none;width:66.6666%}.column.is-half-mobile{flex:none;width:50%}.column.is-one-third-mobile{flex:none;width:33.3333%}.column.is-one-quarter-mobile{flex:none;width:25%}.column.is-one-fifth-mobile{flex:none;width:20%}.column.is-two-fifths-mobile{flex:none;width:40%}.column.is-three-fifths-mobile{flex:none;width:60%}.column.is-four-fifths-mobile{flex:none;width:80%}.column.is-offset-three-quarters-mobile{margin-left:75%}.column.is-offset-two-thirds-mobile{margin-left:66.6666%}.column.is-offset-half-mobile{margin-left:50%}.column.is-offset-one-third-mobile{margin-left:33.3333%}.column.is-offset-one-quarter-mobile{margin-left:25%}.column.is-offset-one-fifth-mobile{margin-left:20%}.column.is-offset-two-fifths-mobile{margin-left:40%}.column.is-offset-three-fifths-mobile{margin-left:60%}.column.is-offset-four-fifths-mobile{margin-left:80%}.column.is-1-mobile{flex:none;width:8.33333%}.column.is-offset-1-mobile{margin-left:8.33333%}.column.is-2-mobile{flex:none;width:16.66667%}.column.is-offset-2-mobile{margin-left:16.66667%}.column.is-3-mobile{flex:none;width:25%}.column.is-offset-3-mobile{margin-left:25%}.column.is-4-mobile{flex:none;width:33.33333%}.column.is-offset-4-mobile{margin-left:33.33333%}.column.is-5-mobile{flex:none;width:41.66667%}.column.is-offset-5-mobile{margin-left:41.66667%}.column.is-6-mobile{flex:none;width:50%}.column.is-offset-6-mobile{margin-left:50%}.column.is-7-mobile{flex:none;width:58.33333%}.column.is-offset-7-mobile{margin-left:58.33333%}.column.is-8-mobile{flex:none;width:66.66667%}.column.is-offset-8-mobile{margin-left:66.66667%}.column.is-9-mobile{flex:none;width:75%}.column.is-offset-9-mobile{margin-left:75%}.column.is-10-mobile{flex:none;width:83.33333%}.column.is-offset-10-mobile{margin-left:83.33333%}.column.is-11-mobile{flex:none;width:91.66667%}.column.is-offset-11-mobile{margin-left:91.66667%}.column.is-12-mobile{flex:none;width:100%}.column.is-offset-12-mobile{margin-left:100%}}@media print,screen and (min-width:769px){.column.is-narrow,.column.is-narrow-tablet{flex:none}.column.is-full,.column.is-full-tablet{flex:none;width:100%}.column.is-three-quarters,.column.is-three-quarters-tablet{flex:none;width:75%}.column.is-two-thirds,.column.is-two-thirds-tablet{flex:none;width:66.6666%}.column.is-half,.column.is-half-tablet{flex:none;width:50%}.column.is-one-third,.column.is-one-third-tablet{flex:none;width:33.3333%}.column.is-one-quarter,.column.is-one-quarter-tablet{flex:none;width:25%}.column.is-one-fifth,.column.is-one-fifth-tablet{flex:none;width:20%}.column.is-two-fifths,.column.is-two-fifths-tablet{flex:none;width:40%}.column.is-three-fifths,.column.is-three-fifths-tablet{flex:none;width:60%}.column.is-four-fifths,.column.is-four-fifths-tablet{flex:none;width:80%}.column.is-offset-three-quarters,.column.is-offset-three-quarters-tablet{margin-left:75%}.column.is-offset-two-thirds,.column.is-offset-two-thirds-tablet{margin-left:66.6666%}.column.is-offset-half,.column.is-offset-half-tablet{margin-left:50%}.column.is-offset-one-third,.column.is-offset-one-third-tablet{margin-left:33.3333%}.column.is-offset-one-quarter,.column.is-offset-one-quarter-tablet{margin-left:25%}.column.is-offset-one-fifth,.column.is-offset-one-fifth-tablet{margin-left:20%}.column.is-offset-two-fifths,.column.is-offset-two-fifths-tablet{margin-left:40%}.column.is-offset-three-fifths,.column.is-offset-three-fifths-tablet{margin-left:60%}.column.is-offset-four-fifths,.column.is-offset-four-fifths-tablet{margin-left:80%}.column.is-1,.column.is-1-tablet{flex:none;width:8.33333%}.column.is-offset-1,.column.is-offset-1-tablet{margin-left:8.33333%}.column.is-2,.column.is-2-tablet{flex:none;width:16.66667%}.column.is-offset-2,.column.is-offset-2-tablet{margin-left:16.66667%}.column.is-3,.column.is-3-tablet{flex:none;width:25%}.column.is-offset-3,.column.is-offset-3-tablet{margin-left:25%}.column.is-4,.column.is-4-tablet{flex:none;width:33.33333%}.column.is-offset-4,.column.is-offset-4-tablet{margin-left:33.33333%}.column.is-5,.column.is-5-tablet{flex:none;width:41.66667%}.column.is-offset-5,.column.is-offset-5-tablet{margin-left:41.66667%}.column.is-6,.column.is-6-tablet{flex:none;width:50%}.column.is-offset-6,.column.is-offset-6-tablet{margin-left:50%}.column.is-7,.column.is-7-tablet{flex:none;width:58.33333%}.column.is-offset-7,.column.is-offset-7-tablet{margin-left:58.33333%}.column.is-8,.column.is-8-tablet{flex:none;width:66.66667%}.column.is-offset-8,.column.is-offset-8-tablet{margin-left:66.66667%}.column.is-9,.column.is-9-tablet{flex:none;width:75%}.column.is-offset-9,.column.is-offset-9-tablet{margin-left:75%}.column.is-10,.column.is-10-tablet{flex:none;width:83.33333%}.column.is-offset-10,.column.is-offset-10-tablet{margin-left:83.33333%}.column.is-11,.column.is-11-tablet{flex:none;width:91.66667%}.column.is-offset-11,.column.is-offset-11-tablet{margin-left:91.66667%}.column.is-12,.column.is-12-tablet{flex:none;width:100%}.column.is-offset-12,.column.is-offset-12-tablet{margin-left:100%}}@media screen and (max-width:1087px){.column.is-narrow-touch{flex:none}.column.is-full-touch{flex:none;width:100%}.column.is-three-quarters-touch{flex:none;width:75%}.column.is-two-thirds-touch{flex:none;width:66.6666%}.column.is-half-touch{flex:none;width:50%}.column.is-one-third-touch{flex:none;width:33.3333%}.column.is-one-quarter-touch{flex:none;width:25%}.column.is-one-fifth-touch{flex:none;width:20%}.column.is-two-fifths-touch{flex:none;width:40%}.column.is-three-fifths-touch{flex:none;width:60%}.column.is-four-fifths-touch{flex:none;width:80%}.column.is-offset-three-quarters-touch{margin-left:75%}.column.is-offset-two-thirds-touch{margin-left:66.6666%}.column.is-offset-half-touch{margin-left:50%}.column.is-offset-one-third-touch{margin-left:33.3333%}.column.is-offset-one-quarter-touch{margin-left:25%}.column.is-offset-one-fifth-touch{margin-left:20%}.column.is-offset-two-fifths-touch{margin-left:40%}.column.is-offset-three-fifths-touch{margin-left:60%}.column.is-offset-four-fifths-touch{margin-left:80%}.column.is-1-touch{flex:none;width:8.33333%}.column.is-offset-1-touch{margin-left:8.33333%}.column.is-2-touch{flex:none;width:16.66667%}.column.is-offset-2-touch{margin-left:16.66667%}.column.is-3-touch{flex:none;width:25%}.column.is-offset-3-touch{margin-left:25%}.column.is-4-touch{flex:none;width:33.33333%}.column.is-offset-4-touch{margin-left:33.33333%}.column.is-5-touch{flex:none;width:41.66667%}.column.is-offset-5-touch{margin-left:41.66667%}.column.is-6-touch{flex:none;width:50%}.column.is-offset-6-touch{margin-left:50%}.column.is-7-touch{flex:none;width:58.33333%}.column.is-offset-7-touch{margin-left:58.33333%}.column.is-8-touch{flex:none;width:66.66667%}.column.is-offset-8-touch{margin-left:66.66667%}.column.is-9-touch{flex:none;width:75%}.column.is-offset-9-touch{margin-left:75%}.column.is-10-touch{flex:none;width:83.33333%}.column.is-offset-10-touch{margin-left:83.33333%}.column.is-11-touch{flex:none;width:91.66667%}.column.is-offset-11-touch{margin-left:91.66667%}.column.is-12-touch{flex:none;width:100%}.column.is-offset-12-touch{margin-left:100%}}@media screen and (min-width:1088px){.column.is-narrow-desktop{flex:none}.column.is-full-desktop{flex:none;width:100%}.column.is-three-quarters-desktop{flex:none;width:75%}.column.is-two-thirds-desktop{flex:none;width:66.6666%}.column.is-half-desktop{flex:none;width:50%}.column.is-one-third-desktop{flex:none;width:33.3333%}.column.is-one-quarter-desktop{flex:none;width:25%}.column.is-one-fifth-desktop{flex:none;width:20%}.column.is-two-fifths-desktop{flex:none;width:40%}.column.is-three-fifths-desktop{flex:none;width:60%}.column.is-four-fifths-desktop{flex:none;width:80%}.column.is-offset-three-quarters-desktop{margin-left:75%}.column.is-offset-two-thirds-desktop{margin-left:66.6666%}.column.is-offset-half-desktop{margin-left:50%}.column.is-offset-one-third-desktop{margin-left:33.3333%}.column.is-offset-one-quarter-desktop{margin-left:25%}.column.is-offset-one-fifth-desktop{margin-left:20%}.column.is-offset-two-fifths-desktop{margin-left:40%}.column.is-offset-three-fifths-desktop{margin-left:60%}.column.is-offset-four-fifths-desktop{margin-left:80%}.column.is-1-desktop{flex:none;width:8.33333%}.column.is-offset-1-desktop{margin-left:8.33333%}.column.is-2-desktop{flex:none;width:16.66667%}.column.is-offset-2-desktop{margin-left:16.66667%}.column.is-3-desktop{flex:none;width:25%}.column.is-offset-3-desktop{margin-left:25%}.column.is-4-desktop{flex:none;width:33.33333%}.column.is-offset-4-desktop{margin-left:33.33333%}.column.is-5-desktop{flex:none;width:41.66667%}.column.is-offset-5-desktop{margin-left:41.66667%}.column.is-6-desktop{flex:none;width:50%}.column.is-offset-6-desktop{margin-left:50%}.column.is-7-desktop{flex:none;width:58.33333%}.column.is-offset-7-desktop{margin-left:58.33333%}.column.is-8-desktop{flex:none;width:66.66667%}.column.is-offset-8-desktop{margin-left:66.66667%}.column.is-9-desktop{flex:none;width:75%}.column.is-offset-9-desktop{margin-left:75%}.column.is-10-desktop{flex:none;width:83.33333%}.column.is-offset-10-desktop{margin-left:83.33333%}.column.is-11-desktop{flex:none;width:91.66667%}.column.is-offset-11-desktop{margin-left:91.66667%}.column.is-12-desktop{flex:none;width:100%}.column.is-offset-12-desktop{margin-left:100%}}@media screen and (min-width:1280px){.column.is-narrow-widescreen{flex:none}.column.is-full-widescreen{flex:none;width:100%}.column.is-three-quarters-widescreen{flex:none;width:75%}.column.is-two-thirds-widescreen{flex:none;width:66.6666%}.column.is-half-widescreen{flex:none;width:50%}.column.is-one-third-widescreen{flex:none;width:33.3333%}.column.is-one-quarter-widescreen{flex:none;width:25%}.column.is-one-fifth-widescreen{flex:none;width:20%}.column.is-two-fifths-widescreen{flex:none;width:40%}.column.is-three-fifths-widescreen{flex:none;width:60%}.column.is-four-fifths-widescreen{flex:none;width:80%}.column.is-offset-three-quarters-widescreen{margin-left:75%}.column.is-offset-two-thirds-widescreen{margin-left:66.6666%}.column.is-offset-half-widescreen{margin-left:50%}.column.is-offset-one-third-widescreen{margin-left:33.3333%}.column.is-offset-one-quarter-widescreen{margin-left:25%}.column.is-offset-one-fifth-widescreen{margin-left:20%}.column.is-offset-two-fifths-widescreen{margin-left:40%}.column.is-offset-three-fifths-widescreen{margin-left:60%}.column.is-offset-four-fifths-widescreen{margin-left:80%}.column.is-1-widescreen{flex:none;width:8.33333%}.column.is-offset-1-widescreen{margin-left:8.33333%}.column.is-2-widescreen{flex:none;width:16.66667%}.column.is-offset-2-widescreen{margin-left:16.66667%}.column.is-3-widescreen{flex:none;width:25%}.column.is-offset-3-widescreen{margin-left:25%}.column.is-4-widescreen{flex:none;width:33.33333%}.column.is-offset-4-widescreen{margin-left:33.33333%}.column.is-5-widescreen{flex:none;width:41.66667%}.column.is-offset-5-widescreen{margin-left:41.66667%}.column.is-6-widescreen{flex:none;width:50%}.column.is-offset-6-widescreen{margin-left:50%}.column.is-7-widescreen{flex:none;width:58.33333%}.column.is-offset-7-widescreen{margin-left:58.33333%}.column.is-8-widescreen{flex:none;width:66.66667%}.column.is-offset-8-widescreen{margin-left:66.66667%}.column.is-9-widescreen{flex:none;width:75%}.column.is-offset-9-widescreen{margin-left:75%}.column.is-10-widescreen{flex:none;width:83.33333%}.column.is-offset-10-widescreen{margin-left:83.33333%}.column.is-11-widescreen{flex:none;width:91.66667%}.column.is-offset-11-widescreen{margin-left:91.66667%}.column.is-12-widescreen{flex:none;width:100%}.column.is-offset-12-widescreen{margin-left:100%}}@media screen and (min-width:1472px){.column.is-narrow-fullhd{flex:none}.column.is-full-fullhd{flex:none;width:100%}.column.is-three-quarters-fullhd{flex:none;width:75%}.column.is-two-thirds-fullhd{flex:none;width:66.6666%}.column.is-half-fullhd{flex:none;width:50%}.column.is-one-third-fullhd{flex:none;width:33.3333%}.column.is-one-quarter-fullhd{flex:none;width:25%}.column.is-one-fifth-fullhd{flex:none;width:20%}.column.is-two-fifths-fullhd{flex:none;width:40%}.column.is-three-fifths-fullhd{flex:none;width:60%}.column.is-four-fifths-fullhd{flex:none;width:80%}.column.is-offset-three-quarters-fullhd{margin-left:75%}.column.is-offset-two-thirds-fullhd{margin-left:66.6666%}.column.is-offset-half-fullhd{margin-left:50%}.column.is-offset-one-third-fullhd{margin-left:33.3333%}.column.is-offset-one-quarter-fullhd{margin-left:25%}.column.is-offset-one-fifth-fullhd{margin-left:20%}.column.is-offset-two-fifths-fullhd{margin-left:40%}.column.is-offset-three-fifths-fullhd{margin-left:60%}.column.is-offset-four-fifths-fullhd{margin-left:80%}.column.is-1-fullhd{flex:none;width:8.33333%}.column.is-offset-1-fullhd{margin-left:8.33333%}.column.is-2-fullhd{flex:none;width:16.66667%}.column.is-offset-2-fullhd{margin-left:16.66667%}.column.is-3-fullhd{flex:none;width:25%}.column.is-offset-3-fullhd{margin-left:25%}.column.is-4-fullhd{flex:none;width:33.33333%}.column.is-offset-4-fullhd{margin-left:33.33333%}.column.is-5-fullhd{flex:none;width:41.66667%}.column.is-offset-5-fullhd{margin-left:41.66667%}.column.is-6-fullhd{flex:none;width:50%}.column.is-offset-6-fullhd{margin-left:50%}.column.is-7-fullhd{flex:none;width:58.33333%}.column.is-offset-7-fullhd{margin-left:58.33333%}.column.is-8-fullhd{flex:none;width:66.66667%}.column.is-offset-8-fullhd{margin-left:66.66667%}.column.is-9-fullhd{flex:none;width:75%}.column.is-offset-9-fullhd{margin-left:75%}.column.is-10-fullhd{flex:none;width:83.33333%}.column.is-offset-10-fullhd{margin-left:83.33333%}.column.is-11-fullhd{flex:none;width:91.66667%}.column.is-offset-11-fullhd{margin-left:91.66667%}.column.is-12-fullhd{flex:none;width:100%}.column.is-offset-12-fullhd{margin-left:100%}}.columns{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.columns:last-child{margin-bottom:-.75rem}.columns:not(:last-child){margin-bottom:0.75rem}.columns.is-centered{justify-content:center}.columns.is-gapless{margin-left:0;margin-right:0;margin-top:0}.columns.is-gapless>.column{margin:0;padding:0!important}.columns.is-gapless:not(:last-child){margin-bottom:1.5rem}.columns.is-gapless:last-child{margin-bottom:0}.columns.is-mobile{display:flex}.columns.is-multiline{flex-wrap:wrap}.columns.is-vcentered{align-items:center}@media print,screen and (min-width:769px){.columns:not(.is-desktop){display:flex}}@media screen and (min-width:1088px){.columns.is-desktop{display:flex}}.columns.is-variable{--columnGap:0.75rem;margin-left:calc(-1 * var(--columnGap));margin-right:calc(-1 * var(--columnGap))}.columns.is-variable .column{padding-left:var(--columnGap);padding-right:var(--columnGap)}.columns.is-variable.is-0{--columnGap:0rem}.columns.is-variable.is-1{--columnGap:.25rem}.columns.is-variable.is-2{--columnGap:.5rem}.columns.is-variable.is-3{--columnGap:.75rem}.columns.is-variable.is-4{--columnGap:1rem}.columns.is-variable.is-5{--columnGap:1.25rem}.columns.is-variable.is-6{--columnGap:1.5rem}.columns.is-variable.is-7{--columnGap:1.75rem}.columns.is-variable.is-8{--columnGap:2rem}.tile{align-items:stretch;display:block;flex-basis:0;flex-grow:1;flex-shrink:1;min-height:min-content}.tile.is-ancestor{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.tile.is-ancestor:last-child{margin-bottom:-.75rem}.tile.is-ancestor:not(:last-child){margin-bottom:.75rem}.tile.is-child{margin:0!important}.tile.is-parent{padding:.75rem}.tile.is-vertical{flex-direction:column}.tile.is-vertical>.tile.is-child:not(:last-child){margin-bottom:1.5rem!important}@media print,screen and (min-width:769px){.tile:not(.is-child){display:flex}.tile.is-1{flex:none;width:8.33333%}.tile.is-2{flex:none;width:16.66667%}.tile.is-3{flex:none;width:25%}.tile.is-4{flex:none;width:33.33333%}.tile.is-5{flex:none;width:41.66667%}.tile.is-6{flex:none;width:50%}.tile.is-7{flex:none;width:58.33333%}.tile.is-8{flex:none;width:66.66667%}.tile.is-9{flex:none;width:75%}.tile.is-10{flex:none;width:83.33333%}.tile.is-11{flex:none;width:91.66667%}.tile.is-12{flex:none;width:100%}}.hero{align-items:stretch;display:flex;flex-direction:column;justify-content:space-between}.hero .navbar{background:none}.hero .tabs ul{border-bottom:none}.hero.is-white{background-color:#fff;color:#0a0a0a}.hero.is-white a:not(.button):not(.dropdown-item):not(.tag),.hero.is-white strong{color:inherit}.hero.is-white .title{color:#0a0a0a}.hero.is-white .subtitle{color:hsla(0,0%,4%,.9)}.hero.is-white .subtitle a:not(.button),.hero.is-white .subtitle strong{color:#0a0a0a}@media screen and (max-width:1087px){.hero.is-white .navbar-menu{background-color:#fff}}.hero.is-white .navbar-item,.hero.is-white .navbar-link{color:hsla(0,0%,4%,.7)}.hero.is-white .navbar-link.is-active,.hero.is-white .navbar-link:hover,.hero.is-white a.navbar-item.is-active,.hero.is-white a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.hero.is-white .tabs a{color:#0a0a0a;opacity:.9}.hero.is-white .tabs a:hover,.hero.is-white .tabs li.is-active a{opacity:1}.hero.is-white .tabs.is-boxed a,.hero.is-white .tabs.is-toggle a{color:#0a0a0a}.hero.is-white .tabs.is-boxed a:hover,.hero.is-white .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-white .tabs.is-boxed li.is-active a,.hero.is-white .tabs.is-boxed li.is-active a:hover,.hero.is-white .tabs.is-toggle li.is-active a,.hero.is-white .tabs.is-toggle li.is-active a:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.hero.is-white.is-bold{background-image:linear-gradient(141deg,#e6e6e6,#fff 71%,#fff)}@media screen and (max-width:768px){.hero.is-white.is-bold .navbar-menu{background-image:linear-gradient(141deg,#e6e6e6,#fff 71%,#fff)}}.hero.is-black{background-color:#0a0a0a;color:#fff}.hero.is-black a:not(.button):not(.dropdown-item):not(.tag),.hero.is-black strong{color:inherit}.hero.is-black .title{color:#fff}.hero.is-black .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-black .subtitle a:not(.button),.hero.is-black .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-black .navbar-menu{background-color:#0a0a0a}}.hero.is-black .navbar-item,.hero.is-black .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-black .navbar-link.is-active,.hero.is-black .navbar-link:hover,.hero.is-black a.navbar-item.is-active,.hero.is-black a.navbar-item:hover{background-color:#000;color:#fff}.hero.is-black .tabs a{color:#fff;opacity:.9}.hero.is-black .tabs a:hover,.hero.is-black .tabs li.is-active a{opacity:1}.hero.is-black .tabs.is-boxed a,.hero.is-black .tabs.is-toggle a{color:#fff}.hero.is-black .tabs.is-boxed a:hover,.hero.is-black .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-black .tabs.is-boxed li.is-active a,.hero.is-black .tabs.is-boxed li.is-active a:hover,.hero.is-black .tabs.is-toggle li.is-active a,.hero.is-black .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.hero.is-black.is-bold{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}@media screen and (max-width:768px){.hero.is-black.is-bold .navbar-menu{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}}.hero.is-light{background-color:#f5f5f5;color:#363636}.hero.is-light a:not(.button):not(.dropdown-item):not(.tag),.hero.is-light strong{color:inherit}.hero.is-light .title{color:#363636}.hero.is-light .subtitle{color:rgba(54,54,54,.9)}.hero.is-light .subtitle a:not(.button),.hero.is-light .subtitle strong{color:#363636}@media screen and (max-width:1087px){.hero.is-light .navbar-menu{background-color:#f5f5f5}}.hero.is-light .navbar-item,.hero.is-light .navbar-link{color:rgba(54,54,54,.7)}.hero.is-light .navbar-link.is-active,.hero.is-light .navbar-link:hover,.hero.is-light a.navbar-item.is-active,.hero.is-light a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.hero.is-light .tabs a{color:#363636;opacity:.9}.hero.is-light .tabs a:hover,.hero.is-light .tabs li.is-active a{opacity:1}.hero.is-light .tabs.is-boxed a,.hero.is-light .tabs.is-toggle a{color:#363636}.hero.is-light .tabs.is-boxed a:hover,.hero.is-light .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-light .tabs.is-boxed li.is-active a,.hero.is-light .tabs.is-boxed li.is-active a:hover,.hero.is-light .tabs.is-toggle li.is-active a,.hero.is-light .tabs.is-toggle li.is-active a:hover{background-color:#363636;border-color:#363636;color:#f5f5f5}.hero.is-light.is-bold{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}@media screen and (max-width:768px){.hero.is-light.is-bold .navbar-menu{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}}.hero.is-dark{background-color:#363636;color:#f5f5f5}.hero.is-dark a:not(.button):not(.dropdown-item):not(.tag),.hero.is-dark strong{color:inherit}.hero.is-dark .title{color:#f5f5f5}.hero.is-dark .subtitle{color:hsla(0,0%,96%,.9)}.hero.is-dark .subtitle a:not(.button),.hero.is-dark .subtitle strong{color:#f5f5f5}@media screen and (max-width:1087px){.hero.is-dark .navbar-menu{background-color:#363636}}.hero.is-dark .navbar-item,.hero.is-dark .navbar-link{color:hsla(0,0%,96%,.7)}.hero.is-dark .navbar-link.is-active,.hero.is-dark .navbar-link:hover,.hero.is-dark a.navbar-item.is-active,.hero.is-dark a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.hero.is-dark .tabs a{color:#f5f5f5;opacity:.9}.hero.is-dark .tabs a:hover,.hero.is-dark .tabs li.is-active a{opacity:1}.hero.is-dark .tabs.is-boxed a,.hero.is-dark .tabs.is-toggle a{color:#f5f5f5}.hero.is-dark .tabs.is-boxed a:hover,.hero.is-dark .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-dark .tabs.is-boxed li.is-active a,.hero.is-dark .tabs.is-boxed li.is-active a:hover,.hero.is-dark .tabs.is-toggle li.is-active a,.hero.is-dark .tabs.is-toggle li.is-active a:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.hero.is-dark.is-bold{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}@media screen and (max-width:768px){.hero.is-dark.is-bold .navbar-menu{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}}.hero.is-primary{background-color:#00d1b2;color:#fff}.hero.is-primary a:not(.button):not(.dropdown-item):not(.tag),.hero.is-primary strong{color:inherit}.hero.is-primary .title{color:#fff}.hero.is-primary .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-primary .subtitle a:not(.button),.hero.is-primary .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-primary .navbar-menu{background-color:#00d1b2}}.hero.is-primary .navbar-item,.hero.is-primary .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-primary .navbar-link.is-active,.hero.is-primary .navbar-link:hover,.hero.is-primary a.navbar-item.is-active,.hero.is-primary a.navbar-item:hover{background-color:#00b89c;color:#fff}.hero.is-primary .tabs a{color:#fff;opacity:.9}.hero.is-primary .tabs a:hover,.hero.is-primary .tabs li.is-active a{opacity:1}.hero.is-primary .tabs.is-boxed a,.hero.is-primary .tabs.is-toggle a{color:#fff}.hero.is-primary .tabs.is-boxed a:hover,.hero.is-primary .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-primary .tabs.is-boxed li.is-active a,.hero.is-primary .tabs.is-boxed li.is-active a:hover,.hero.is-primary .tabs.is-toggle li.is-active a,.hero.is-primary .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#00d1b2}.hero.is-primary.is-bold{background-image:linear-gradient(141deg,#009e6c,#00d1b2 71%,#00e7eb)}@media screen and (max-width:768px){.hero.is-primary.is-bold .navbar-menu{background-image:linear-gradient(141deg,#009e6c,#00d1b2 71%,#00e7eb)}}.hero.is-info{background-color:#209cee;color:#fff}.hero.is-info a:not(.button):not(.dropdown-item):not(.tag),.hero.is-info strong{color:inherit}.hero.is-info .title{color:#fff}.hero.is-info .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-info .subtitle a:not(.button),.hero.is-info .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-info .navbar-menu{background-color:#209cee}}.hero.is-info .navbar-item,.hero.is-info .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-info .navbar-link.is-active,.hero.is-info .navbar-link:hover,.hero.is-info a.navbar-item.is-active,.hero.is-info a.navbar-item:hover{background-color:#118fe4;color:#fff}.hero.is-info .tabs a{color:#fff;opacity:.9}.hero.is-info .tabs a:hover,.hero.is-info .tabs li.is-active a{opacity:1}.hero.is-info .tabs.is-boxed a,.hero.is-info .tabs.is-toggle a{color:#fff}.hero.is-info .tabs.is-boxed a:hover,.hero.is-info .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-info .tabs.is-boxed li.is-active a,.hero.is-info .tabs.is-boxed li.is-active a:hover,.hero.is-info .tabs.is-toggle li.is-active a,.hero.is-info .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#209cee}.hero.is-info.is-bold{background-image:linear-gradient(141deg,#04a6d7,#209cee 71%,#3287f5)}@media screen and (max-width:768px){.hero.is-info.is-bold .navbar-menu{background-image:linear-gradient(141deg,#04a6d7,#209cee 71%,#3287f5)}}.hero.is-success{background-color:#23d160;color:#fff}.hero.is-success a:not(.button):not(.dropdown-item):not(.tag),.hero.is-success strong{color:inherit}.hero.is-success .title{color:#fff}.hero.is-success .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-success .subtitle a:not(.button),.hero.is-success .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-success .navbar-menu{background-color:#23d160}}.hero.is-success .navbar-item,.hero.is-success .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-success .navbar-link.is-active,.hero.is-success .navbar-link:hover,.hero.is-success a.navbar-item.is-active,.hero.is-success a.navbar-item:hover{background-color:#20bc56;color:#fff}.hero.is-success .tabs a{color:#fff;opacity:.9}.hero.is-success .tabs a:hover,.hero.is-success .tabs li.is-active a{opacity:1}.hero.is-success .tabs.is-boxed a,.hero.is-success .tabs.is-toggle a{color:#fff}.hero.is-success .tabs.is-boxed a:hover,.hero.is-success .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-success .tabs.is-boxed li.is-active a,.hero.is-success .tabs.is-boxed li.is-active a:hover,.hero.is-success .tabs.is-toggle li.is-active a,.hero.is-success .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#23d160}.hero.is-success.is-bold{background-image:linear-gradient(141deg,#12af2f,#23d160 71%,#2ce28a)}@media screen and (max-width:768px){.hero.is-success.is-bold .navbar-menu{background-image:linear-gradient(141deg,#12af2f,#23d160 71%,#2ce28a)}}.hero.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.hero.is-warning a:not(.button):not(.dropdown-item):not(.tag),.hero.is-warning strong{color:inherit}.hero.is-warning .title{color:rgba(0,0,0,.7)}.hero.is-warning .subtitle{color:rgba(0,0,0,.9)}.hero.is-warning .subtitle a:not(.button),.hero.is-warning .subtitle strong{color:rgba(0,0,0,.7)}@media screen and (max-width:1087px){.hero.is-warning .navbar-menu{background-color:#ffdd57}}.hero.is-warning .navbar-item,.hero.is-warning .navbar-link{color:rgba(0,0,0,.7)}.hero.is-warning .navbar-link.is-active,.hero.is-warning .navbar-link:hover,.hero.is-warning a.navbar-item.is-active,.hero.is-warning a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.hero.is-warning .tabs a{color:rgba(0,0,0,.7);opacity:.9}.hero.is-warning .tabs a:hover,.hero.is-warning .tabs li.is-active a{opacity:1}.hero.is-warning .tabs.is-boxed a,.hero.is-warning .tabs.is-toggle a{color:rgba(0,0,0,.7)}.hero.is-warning .tabs.is-boxed a:hover,.hero.is-warning .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-warning .tabs.is-boxed li.is-active a,.hero.is-warning .tabs.is-boxed li.is-active a:hover,.hero.is-warning .tabs.is-toggle li.is-active a,.hero.is-warning .tabs.is-toggle li.is-active a:hover{background-color:rgba(0,0,0,.7);border-color:rgba(0,0,0,.7);color:#ffdd57}.hero.is-warning.is-bold{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}@media screen and (max-width:768px){.hero.is-warning.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}}.hero.is-danger{background-color:#ff3860;color:#fff}.hero.is-danger a:not(.button):not(.dropdown-item):not(.tag),.hero.is-danger strong{color:inherit}.hero.is-danger .title{color:#fff}.hero.is-danger .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-danger .subtitle a:not(.button),.hero.is-danger .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-danger .navbar-menu{background-color:#ff3860}}.hero.is-danger .navbar-item,.hero.is-danger .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-danger .navbar-link.is-active,.hero.is-danger .navbar-link:hover,.hero.is-danger a.navbar-item.is-active,.hero.is-danger a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.hero.is-danger .tabs a{color:#fff;opacity:.9}.hero.is-danger .tabs a:hover,.hero.is-danger .tabs li.is-active a{opacity:1}.hero.is-danger .tabs.is-boxed a,.hero.is-danger .tabs.is-toggle a{color:#fff}.hero.is-danger .tabs.is-boxed a:hover,.hero.is-danger .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-danger .tabs.is-boxed li.is-active a,.hero.is-danger .tabs.is-boxed li.is-active a:hover,.hero.is-danger .tabs.is-toggle li.is-active a,.hero.is-danger .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#ff3860}.hero.is-danger.is-bold{background-image:linear-gradient(141deg,#ff0561,#ff3860 71%,#ff5257)}@media screen and (max-width:768px){.hero.is-danger.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ff0561,#ff3860 71%,#ff5257)}}.hero.is-twitter{background-color:#4099ff;color:#fff}.hero.is-twitter a:not(.button):not(.dropdown-item):not(.tag),.hero.is-twitter strong{color:inherit}.hero.is-twitter .title{color:#fff}.hero.is-twitter .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-twitter .subtitle a:not(.button),.hero.is-twitter .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-twitter .navbar-menu{background-color:#4099ff}}.hero.is-twitter .navbar-item,.hero.is-twitter .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-twitter .navbar-link.is-active,.hero.is-twitter .navbar-link:hover,.hero.is-twitter a.navbar-item.is-active,.hero.is-twitter a.navbar-item:hover{background-color:#278bff;color:#fff}.hero.is-twitter .tabs a{color:#fff;opacity:.9}.hero.is-twitter .tabs a:hover,.hero.is-twitter .tabs li.is-active a{opacity:1}.hero.is-twitter .tabs.is-boxed a,.hero.is-twitter .tabs.is-toggle a{color:#fff}.hero.is-twitter .tabs.is-boxed a:hover,.hero.is-twitter .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-twitter .tabs.is-boxed li.is-active a,.hero.is-twitter .tabs.is-boxed li.is-active a:hover,.hero.is-twitter .tabs.is-toggle li.is-active a,.hero.is-twitter .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#4099ff}.hero.is-twitter.is-bold{background-image:linear-gradient(141deg,#0da6ff,#4099ff 71%,#5a8bff)}@media screen and (max-width:768px){.hero.is-twitter.is-bold .navbar-menu{background-image:linear-gradient(141deg,#0da6ff,#4099ff 71%,#5a8bff)}}.hero.is-small .hero-body{padding-bottom:1.5rem;padding-top:1.5rem}@media print,screen and (min-width:769px){.hero.is-medium .hero-body{padding-bottom:9rem;padding-top:9rem}}@media print,screen and (min-width:769px){.hero.is-large .hero-body{padding-bottom:18rem;padding-top:18rem}}.hero.is-fullheight .hero-body,.hero.is-halfheight .hero-body{align-items:center;display:flex}.hero.is-fullheight .hero-body>.container,.hero.is-halfheight .hero-body>.container{flex-grow:1;flex-shrink:1}.hero.is-halfheight{min-height:50vh}.hero.is-fullheight{min-height:100vh}.hero-video{overflow:hidden}.hero-video video{left:50%;min-height:100%;min-width:100%;position:absolute;top:50%;transform:translate3d(-50%,-50%,0)}.hero-video.is-transparent{opacity:.3}@media screen and (max-width:768px){.hero-video{display:none}}.hero-buttons{margin-top:1.5rem}@media screen and (max-width:768px){.hero-buttons .button{display:flex}.hero-buttons .button:not(:last-child){margin-bottom:.75rem}}@media print,screen and (min-width:769px){.hero-buttons{display:flex;justify-content:center}.hero-buttons .button:not(:last-child){margin-right:1.5rem}}.hero-foot,.hero-head{flex-grow:0;flex-shrink:0}.hero-body{flex-grow:1;flex-shrink:0}.hero-body,.section{padding:3rem 1.5rem}@media screen and (min-width:1088px){.section.is-medium{padding:9rem 1.5rem}.section.is-large{padding:18rem 1.5rem}}.footer{background-color:#fafafa;padding:3rem 1.5rem 6rem}.is-noscroll{position:fixed;overflow-y:hidden;width:100%;bottom:0}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;transform:translate3d(0,100%,0)}}.fadeOutDown{animation-name:fadeOutDown}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;transform:translate3d(0,-100%,0)}}.fadeOutUp{animation-name:fadeOutUp}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{animation-name:fadeIn}@keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-100%,0)}to{opacity:1;transform:none}}.fadeInDown{animation-name:fadeInDown}@keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,100%,0)}to{opacity:1;transform:none}}.fadeInUp{animation-name:fadeInUp}.fade-enter-active,.fade-leave-active{transition:opacity .15s ease-out}.fade-enter,.fade-leave-to{opacity:0}.zoom-in-enter-active,.zoom-in-leave-active{transition:opacity .15s ease-out}.zoom-in-enter-active .animation-content,.zoom-in-leave-active .animation-content{transition:transform .15s ease-out}.zoom-in-enter,.zoom-in-leave-active{opacity:0}.zoom-in-enter .animation-content,.zoom-in-leave-active .animation-content{transform:scale(.95)}.zoom-out-enter-active,.zoom-out-leave-active{transition:opacity .15s ease-out}.zoom-out-enter-active .animation-content,.zoom-out-leave-active .animation-content{transition:transform .15s ease-out}.zoom-out-enter,.zoom-out-leave-active{opacity:0}.zoom-out-enter .animation-content,.zoom-out-leave-active .animation-content{transform:scale(1.05)}.slide-next-enter-active,.slide-next-leave-active,.slide-prev-enter-active,.slide-prev-leave-active{transition:transform .25s cubic-bezier(.785,.135,.15,.86)}.slide-next-enter,.slide-prev-leave-to{transform:translate3d(-100%,0,0);position:absolute;width:100%}.slide-next-leave-to,.slide-prev-enter{transform:translate3d(100%,0,0);position:absolute;width:100%}.autocomplete{position:relative}.autocomplete .dropdown-menu{display:block;min-width:100%}.autocomplete .dropdown-menu.is-opened-top{top:auto;bottom:100%}.autocomplete .dropdown-content{overflow:auto;max-height:200px}.autocomplete .dropdown-item.is-hovered,.autocomplete .dropdown .dropdown-menu .has-link a.is-hovered,.dropdown .dropdown-menu .has-link .autocomplete a.is-hovered{background:#f5f5f5;color:#0a0a0a}.autocomplete .dropdown-item.is-disabled,.autocomplete .dropdown .dropdown-menu .has-link a.is-disabled,.dropdown .dropdown-menu .has-link .autocomplete a.is-disabled{opacity:.5;cursor:not-allowed}.autocomplete.is-small{border-radius:2px;font-size:.75rem}.autocomplete.is-medium{font-size:1.25rem}.autocomplete.is-large{font-size:1.5rem}.b-checkbox.checkbox{outline:none;display:inline-flex;align-items:center}.b-checkbox.checkbox+.checkbox{margin-left:.5em}.b-checkbox.checkbox input[type=checkbox]{display:none}.b-checkbox.checkbox input[type=checkbox]+.check{width:1.25em;height:1.25em;flex-shrink:0;border-radius:4px;border:2px solid #7a7a7a;transition:background .15s ease-out}.b-checkbox.checkbox input[type=checkbox]:checked+.check{background:#00d1b2 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#00d1b2}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-white{background:#fff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%230a0a0a'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#fff}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-black{background:#0a0a0a url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#0a0a0a}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-light{background:#f5f5f5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23363636'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#f5f5f5}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-dark{background:#363636 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23f5f5f5'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#363636}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-primary{background:#00d1b2 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#00d1b2}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-info{background:#209cee url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#209cee}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-success{background:#23d160 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#23d160}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-warning{background:#ffdd57 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='rgba(0,0,0,.7)'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ffdd57}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-danger{background:#ff3860 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ff3860}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-twitter{background:#4099ff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#4099ff}.b-checkbox.checkbox .control-label{padding-left:.5em}.b-checkbox.checkbox[disabled]{opacity:.5}.b-checkbox.checkbox:hover input[type=checkbox]+.check{border-color:#00d1b2}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-white{border-color:#fff}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-black{border-color:#0a0a0a}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-light{border-color:#f5f5f5}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-dark{border-color:#363636}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-primary{border-color:#00d1b2}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-info{border-color:#209cee}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-success{border-color:#23d160}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-warning{border-color:#ffdd57}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-danger{border-color:#ff3860}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-twitter{border-color:#4099ff}.b-checkbox.checkbox:focus input[type=checkbox]+.check{box-shadow:0 0 .5em hsla(0,0%,48%,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check{box-shadow:0 0 .5em rgba(0,209,178,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-white{box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-black{box-shadow:0 0 .5em hsla(0,0%,4%,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-light{box-shadow:0 0 .5em hsla(0,0%,96%,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-dark{box-shadow:0 0 .5em rgba(54,54,54,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-primary{box-shadow:0 0 .5em rgba(0,209,178,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-info{box-shadow:0 0 .5em rgba(32,156,238,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-success{box-shadow:0 0 .5em rgba(35,209,96,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-warning{box-shadow:0 0 .5em rgba(255,221,87,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-danger{box-shadow:0 0 .5em rgba(255,56,96,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-twitter{box-shadow:0 0 .5em rgba(64,153,255,.8)}.b-checkbox.checkbox.is-small{border-radius:2px;font-size:.75rem}.b-checkbox.checkbox.is-medium{font-size:1.25rem}.b-checkbox.checkbox.is-large{font-size:1.5rem}.collapse .collapse-trigger{display:inline;cursor:pointer}.collapse .collapse-content{display:inherit}.datepicker{font-size:.875rem}.datepicker .dropdown,.datepicker .dropdown-trigger{width:100%}.datepicker .dropdown-item,.datepicker .dropdown .dropdown-menu .has-link a,.dropdown .dropdown-menu .has-link .datepicker a{font-size:inherit}.datepicker .datepicker-header{padding-bottom:.875rem;margin-bottom:.875rem;border-bottom:1px solid #dbdbdb}.datepicker .datepicker-footer{padding-top:.875rem;border-top:1px solid #dbdbdb}.datepicker .datepicker-table{display:table;margin:0 auto .875rem}.datepicker .datepicker-table .datepicker-cell{text-align:center;vertical-align:middle;display:table-cell;border-radius:4px;padding:.5rem .75rem}.datepicker .datepicker-table .datepicker-header{display:table-header-group}.datepicker .datepicker-table .datepicker-header .datepicker-cell{color:#7a7a7a;font-weight:600}.datepicker .datepicker-table .datepicker-body{display:table-row-group}.datepicker .datepicker-table .datepicker-body .datepicker-row{display:table-row}.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-unselectable{color:#b5b5b5}.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-today{border:1px solid rgba(0,209,178,.5)}.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selectable{color:#4a4a4a}.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selectable:focus:not(.is-selected),.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selectable:hover:not(.is-selected){background-color:#f5f5f5;color:#0a0a0a;cursor:pointer}.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selected{background-color:#00d1b2;color:#fff}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell{padding:.3rem .75rem .75rem}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event{position:relative}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events{bottom:.425rem;display:flex;justify-content:center;left:0;padding:0 .35rem;position:absolute;width:100%}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-white{background-color:#fff}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-black{background-color:#0a0a0a}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-light{background-color:#f5f5f5}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-dark{background-color:#363636}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-primary{background-color:#00d1b2}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-info{background-color:#209cee}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-success{background-color:#23d160}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-warning{background-color:#ffdd57}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-danger{background-color:#ff3860}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-twitter{background-color:#4099ff}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event.dots .event{border-radius:50%;height:.35em;margin:0 .1em;width:.35em}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event.bars .event{height:.25em;width:100%}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.is-selected{overflow:hidden}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.is-selected .events .event.is-primary{background-color:#1fffdd}.datepicker.is-small{border-radius:2px;font-size:.75rem}.datepicker.is-medium{font-size:1.25rem}.datepicker.is-large{font-size:1.5rem}@media screen and (min-width:769px) and (max-width:1087px){.datepicker .datepicker-table .datepicker-cell{padding:.75rem 1rem}}@media screen and (max-width:768px){.datepicker .datepicker-table .datepicker-cell{padding:.25rem .5rem}}.dialog .modal-card{max-width:460px;width:auto}.dialog .modal-card .modal-card-head{font-size:1.25rem;font-weight:600}.dialog .modal-card .modal-card-body .field{margin-top:16px}.dialog .modal-card .modal-card-body.is-titleless{border-top-left-radius:6px;border-top-right-radius:6px}.dialog .modal-card .modal-card-foot{justify-content:flex-end}.dialog .modal-card .modal-card-foot .button{display:inline;min-width:5em;font-weight:600}@media print,screen and (min-width:769px){.dialog .modal-card{min-width:320px}}.dialog.is-small .button,.dialog.is-small .input,.dialog.is-small .modal-card,.dialog.is-small .taginput .taginput-container.is-focusable,.taginput .dialog.is-small .taginput-container.is-focusable{border-radius:2px;font-size:.75rem}.dialog.is-medium .button,.dialog.is-medium .input,.dialog.is-medium .modal-card,.dialog.is-medium .taginput .taginput-container.is-focusable,.taginput .dialog.is-medium .taginput-container.is-focusable{font-size:1.25rem}.dialog.is-large .button,.dialog.is-large .input,.dialog.is-large .modal-card,.dialog.is-large .taginput .taginput-container.is-focusable,.taginput .dialog.is-large .taginput-container.is-focusable{font-size:1.5rem}.dropdown+.dropdown{margin-left:.5em}.dropdown .background{position:fixed;background-color:hsla(0,0%,4%,.86);z-index:10;cursor:pointer}@media screen and (min-width:1088px){.dropdown .background{display:none}}.dropdown .dropdown-menu .dropdown-item.is-disabled,.dropdown .dropdown-menu .has-link a.is-disabled{cursor:not-allowed}.dropdown .dropdown-menu .dropdown-item.is-disabled:hover,.dropdown .dropdown-menu .has-link a.is-disabled:hover{background:inherit;color:inherit}.dropdown .dropdown-menu .has-link a{padding-right:3rem;white-space:nowrap}.dropdown:not(.is-disabled) .dropdown-menu .dropdown-item.is-disabled,.dropdown:not(.is-disabled) .dropdown-menu .has-link a.is-disabled{opacity:.5}.dropdown .navbar-item{height:100%}.dropdown.is-disabled{opacity:.5;cursor:not-allowed}.dropdown.is-disabled .dropdown-trigger{pointer-events:none}.dropdown.is-inline .dropdown-menu{position:static;display:inline-block;padding:0}.dropdown.is-top-right .dropdown-menu{top:auto;bottom:100%}.dropdown.is-top-left .dropdown-menu{top:auto;bottom:100%;right:0;left:auto}.dropdown.is-bottom-left .dropdown-menu{right:0;left:auto}@media screen and (max-width:1087px){.dropdown.is-mobile-modal .dropdown-menu{position:fixed;width:calc(100vw - 40px);max-width:460px;max-height:calc(100vh - 120px);top:25%!important;left:50%!important;bottom:auto!important;right:auto!important;transform:translate3d(-50%,-25%,0);white-space:normal;overflow-y:auto}.dropdown.is-mobile-modal .dropdown-menu .dropdown-item,.dropdown.is-mobile-modal .dropdown-menu .has-link a{padding:1rem 1.5rem}}.label{font-weight:600}.field.is-grouped .field{flex-shrink:0}.field.is-grouped .field+.field{margin-left:.75rem}.field.is-grouped .field.is-expanded{flex-grow:1;flex-shrink:1}.field.has-addons .control:first-child .control .button,.field.has-addons .control:first-child .control .input,.field.has-addons .control:first-child .control .select select,.field.has-addons .control:first-child .control .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:first-child .control .taginput-container.is-focusable{border-bottom-left-radius:4px;border-top-left-radius:4px}.field.has-addons .control:last-child .control .button,.field.has-addons .control:last-child .control .input,.field.has-addons .control:last-child .control .select select,.field.has-addons .control:last-child .control .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:last-child .control .taginput-container.is-focusable{border-bottom-right-radius:4px;border-top-right-radius:4px}.field.has-addons .control .control .button,.field.has-addons .control .control .input,.field.has-addons .control .control .select select,.field.has-addons .control .control .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control .control .taginput-container.is-focusable{border-radius:0}.control .help.counter{float:right;margin-left:.5em}.control .icon.is-clickable{pointer-events:auto;cursor:pointer}.icon{cursor:inherit}.icon svg{background-color:transparent;fill:currentColor;stroke-width:0;stroke:currentColor;pointer-events:none;width:1.5rem;height:1.5rem}.loading-overlay{align-items:center;display:none;justify-content:center;overflow:hidden;z-index:999}.loading-overlay.is-active{display:flex}.loading-overlay.is-full-page{position:fixed}.loading-overlay.is-full-page .loading-icon:after{top:calc(50% - 2.5em);left:calc(50% - 2.5em);width:5em;height:5em}.loading-overlay .loading-background{background:#7f7f7f;background:hsla(0,0%,100%,.5)}.loading-overlay .loading-icon{position:relative}.loading-overlay .loading-icon:after{position:absolute;top:calc(50% - 1.5em);left:calc(50% - 1.5em);width:3em;height:3em;border-width:.25em}.message .media,.notification .media{padding-top:0;border:0}.notification>.delete{right:.5rem!important;top:.5rem!important}.modal .animation-content{margin:0 20px}.modal .animation-content .modal-card{margin:0}@media screen and (max-width:768px){.modal .animation-content{width:100%}}.notices{position:fixed;display:flex;top:0;bottom:0;left:0;right:0;padding:2em;overflow:hidden;z-index:1000;pointer-events:none}.notices .toast{display:inline-flex;animation-duration:.15s;margin:.5em 0;text-align:center;box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);border-radius:2em;padding:.75em 1.5em;pointer-events:auto;opacity:.92}.notices .toast.is-white{color:#0a0a0a;background:#fff}.notices .toast.is-black{color:#fff;background:#0a0a0a}.notices .toast.is-light{color:#363636;background:#f5f5f5}.notices .toast.is-dark{color:#f5f5f5;background:#363636}.notices .toast.is-primary{color:#fff;background:#00d1b2}.notices .toast.is-info{color:#fff;background:#209cee}.notices .toast.is-success{color:#fff;background:#23d160}.notices .toast.is-warning{color:rgba(0,0,0,.7);background:#ffdd57}.notices .toast.is-danger{color:#fff;background:#ff3860}.notices .toast.is-twitter{color:#fff;background:#4099ff}.notices .snackbar{display:inline-flex;align-items:center;justify-content:space-around;animation-duration:.15s;margin:.5em 0;box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);border-radius:4px;pointer-events:auto;background:#363636;color:#f5f5f5;min-height:3em}.notices .snackbar .text{padding:.5em 1em}.notices .snackbar .action{margin-left:auto;padding:.5em;padding-left:0}.notices .snackbar .action .button{font-weight:600;text-transform:uppercase}.notices .snackbar .action.is-white .button{color:#fff}.notices .snackbar .action.is-black .button{color:#0a0a0a}.notices .snackbar .action.is-light .button{color:#f5f5f5}.notices .snackbar .action.is-dark .button{color:#363636}.notices .snackbar .action.is-primary .button{color:#00d1b2}.notices .snackbar .action.is-info .button{color:#209cee}.notices .snackbar .action.is-success .button{color:#23d160}.notices .snackbar .action.is-warning .button{color:#ffdd57}.notices .snackbar .action.is-danger .button{color:#ff3860}.notices .snackbar .action.is-twitter .button{color:#4099ff}@media screen and (max-width:768px){.notices .snackbar{width:100%;margin:0;border-radius:0}}@media print,screen and (min-width:769px){.notices .snackbar{min-width:350px;max-width:600px;overflow:hidden}}.notices .snackbar.is-bottom,.notices .snackbar.is-top,.notices .toast.is-bottom,.notices .toast.is-top{align-self:center}.notices .snackbar.is-bottom-right,.notices .snackbar.is-top-right,.notices .toast.is-bottom-right,.notices .toast.is-top-right{align-self:flex-end}.notices .snackbar.is-bottom-left,.notices .snackbar.is-top-left,.notices .toast.is-bottom-left,.notices .toast.is-top-left{align-self:flex-start}.notices .snackbar.is-toast,.notices .toast.is-toast{opacity:.92}.notices.is-top{flex-direction:column}.notices.is-bottom{flex-direction:column-reverse}.notices.has-custom-container{position:absolute}@media screen and (max-width:768px){.notices{padding:0;position:fixed!important}}.pagination .pagination-next,.pagination .pagination-previous{padding-left:.25em;padding-right:.25em}.pagination .pagination-next.is-disabled,.pagination .pagination-previous.is-disabled{pointer-events:none;cursor:not-allowed;opacity:.5}.pagination.is-simple{justify-content:normal}.pagination .is-current{pointer-events:none;cursor:not-allowed}.panel .panel-heading.is-collapsible{cursor:pointer}.panel .panel-content{width:100%}.b-radio.radio{outline:none;display:inline-flex;align-items:center}.b-radio.radio+.radio{margin-left:.5em}.b-radio.radio input[type=radio]{display:none}.b-radio.radio input[type=radio]+.check{display:flex;align-items:center;justify-content:center;width:1.25em;height:1.25em;border:2px solid #7a7a7a;border-radius:50%;transition:background .15s ease-out}.b-radio.radio input[type=radio]+.check:before{content:\"\";border-radius:50%;width:.625em;height:.625em;background:#00d1b2;transform:scale(0);transition:transform .15s ease-out}.b-radio.radio input[type=radio]+.check.is-white:before{background:#fff}.b-radio.radio input[type=radio]+.check.is-black:before{background:#0a0a0a}.b-radio.radio input[type=radio]+.check.is-light:before{background:#f5f5f5}.b-radio.radio input[type=radio]+.check.is-dark:before{background:#363636}.b-radio.radio input[type=radio]+.check.is-primary:before{background:#00d1b2}.b-radio.radio input[type=radio]+.check.is-info:before{background:#209cee}.b-radio.radio input[type=radio]+.check.is-success:before{background:#23d160}.b-radio.radio input[type=radio]+.check.is-warning:before{background:#ffdd57}.b-radio.radio input[type=radio]+.check.is-danger:before{background:#ff3860}.b-radio.radio input[type=radio]+.check.is-twitter:before{background:#4099ff}.b-radio.radio input[type=radio]:checked+.check{border-color:#00d1b2}.b-radio.radio input[type=radio]:checked+.check.is-white{border-color:#fff}.b-radio.radio input[type=radio]:checked+.check.is-black{border-color:#0a0a0a}.b-radio.radio input[type=radio]:checked+.check.is-light{border-color:#f5f5f5}.b-radio.radio input[type=radio]:checked+.check.is-dark{border-color:#363636}.b-radio.radio input[type=radio]:checked+.check.is-primary{border-color:#00d1b2}.b-radio.radio input[type=radio]:checked+.check.is-info{border-color:#209cee}.b-radio.radio input[type=radio]:checked+.check.is-success{border-color:#23d160}.b-radio.radio input[type=radio]:checked+.check.is-warning{border-color:#ffdd57}.b-radio.radio input[type=radio]:checked+.check.is-danger{border-color:#ff3860}.b-radio.radio input[type=radio]:checked+.check.is-twitter{border-color:#4099ff}.b-radio.radio input[type=radio]:checked+.check:before{transform:scale(1)}.b-radio.radio .control-label{padding-left:.5em}.b-radio.radio[disabled]{opacity:.5}.b-radio.radio:hover input[type=radio]+.check{border-color:#00d1b2}.b-radio.radio:hover input[type=radio]+.check.is-white{border-color:#fff}.b-radio.radio:hover input[type=radio]+.check.is-black{border-color:#0a0a0a}.b-radio.radio:hover input[type=radio]+.check.is-light{border-color:#f5f5f5}.b-radio.radio:hover input[type=radio]+.check.is-dark{border-color:#363636}.b-radio.radio:hover input[type=radio]+.check.is-primary{border-color:#00d1b2}.b-radio.radio:hover input[type=radio]+.check.is-info{border-color:#209cee}.b-radio.radio:hover input[type=radio]+.check.is-success{border-color:#23d160}.b-radio.radio:hover input[type=radio]+.check.is-warning{border-color:#ffdd57}.b-radio.radio:hover input[type=radio]+.check.is-danger{border-color:#ff3860}.b-radio.radio:hover input[type=radio]+.check.is-twitter{border-color:#4099ff}.b-radio.radio:focus input[type=radio]+.check{box-shadow:0 0 .5em hsla(0,0%,48%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check{box-shadow:0 0 .5em rgba(0,209,178,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-white{box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-black{box-shadow:0 0 .5em hsla(0,0%,4%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-light{box-shadow:0 0 .5em hsla(0,0%,96%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-dark{box-shadow:0 0 .5em rgba(54,54,54,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-primary{box-shadow:0 0 .5em rgba(0,209,178,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-info{box-shadow:0 0 .5em rgba(32,156,238,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-success{box-shadow:0 0 .5em rgba(35,209,96,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-warning{box-shadow:0 0 .5em rgba(255,221,87,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-danger{box-shadow:0 0 .5em rgba(255,56,96,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-twitter{box-shadow:0 0 .5em rgba(64,153,255,.8)}.b-radio.radio.is-small{border-radius:2px;font-size:.75rem}.b-radio.radio.is-medium{font-size:1.25rem}.b-radio.radio.is-large{font-size:1.5rem}.select select{padding-right:2.5em}.select select option{color:#4a4a4a;padding:.25em .5em}.select select option:disabled{cursor:not-allowed;opacity:.5}.select select optgroup{color:#b5b5b5;font-weight:400;font-style:normal;padding:.25em 0}.select.is-empty select{color:hsla(0,0%,48%,.7)}.switch{cursor:pointer;display:inline-flex;align-items:center}.switch+.switch{margin-left:.5em}.switch input[type=checkbox]{display:none}.switch input[type=checkbox]+.check{display:flex;align-items:center;width:2.75em;height:1.575em;padding:.2em;background:#b5b5b5;border-radius:1em;transition:background .15s ease-out}.switch input[type=checkbox]+.check:before{content:\"\";border-radius:1em;width:1.175em;height:1.175em;background:#f5f5f5;box-shadow:0 3px 1px 0 rgba(0,0,0,.05),0 2px 2px 0 rgba(0,0,0,.1),0 3px 3px 0 rgba(0,0,0,.05);transition:transform .15s ease-out,width .15s ease-out;will-change:transform}.switch input[type=checkbox]+.check.is-elastic:before{width:1.75em}.switch input[type=checkbox]:checked+.check{background:#00d1b2}.switch input[type=checkbox]:checked+.check.is-white{background:#fff}.switch input[type=checkbox]:checked+.check.is-black{background:#0a0a0a}.switch input[type=checkbox]:checked+.check.is-light{background:#f5f5f5}.switch input[type=checkbox]:checked+.check.is-dark{background:#363636}.switch input[type=checkbox]:checked+.check.is-primary{background:#00d1b2}.switch input[type=checkbox]:checked+.check.is-info{background:#209cee}.switch input[type=checkbox]:checked+.check.is-success{background:#23d160}.switch input[type=checkbox]:checked+.check.is-warning{background:#ffdd57}.switch input[type=checkbox]:checked+.check.is-danger{background:#ff3860}.switch input[type=checkbox]:checked+.check.is-twitter{background:#4099ff}.switch input[type=checkbox]:checked+.check:before{transform:translate3d(100%,0,0)}.switch input[type=checkbox]:checked+.check.is-elastic:before{transform:translate3d(36.36364%,0,0)}.switch .control-label{padding-left:.5em}.switch:hover input[type=checkbox]+.check{background:hsla(0,0%,71%,.9)}.switch:hover input[type=checkbox]:checked+.check{background:rgba(0,209,178,.9)}.switch:hover input[type=checkbox]:checked+.check.is-white{background:hsla(0,0%,100%,.9)}.switch:hover input[type=checkbox]:checked+.check.is-black{background:hsla(0,0%,4%,.9)}.switch:hover input[type=checkbox]:checked+.check.is-light{background:hsla(0,0%,96%,.9)}.switch:hover input[type=checkbox]:checked+.check.is-dark{background:rgba(54,54,54,.9)}.switch:hover input[type=checkbox]:checked+.check.is-primary{background:rgba(0,209,178,.9)}.switch:hover input[type=checkbox]:checked+.check.is-info{background:rgba(32,156,238,.9)}.switch:hover input[type=checkbox]:checked+.check.is-success{background:rgba(35,209,96,.9)}.switch:hover input[type=checkbox]:checked+.check.is-warning{background:rgba(255,221,87,.9)}.switch:hover input[type=checkbox]:checked+.check.is-danger{background:rgba(255,56,96,.9)}.switch:hover input[type=checkbox]:checked+.check.is-twitter{background:rgba(64,153,255,.9)}.switch:focus{outline:none}.switch:focus input[type=checkbox]+.check{box-shadow:0 0 .5em hsla(0,0%,48%,.6)}.switch:focus input[type=checkbox]:checked+.check{box-shadow:0 0 .5em rgba(0,209,178,.8)}.switch:focus input[type=checkbox]:checked+.check.is-white{box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.switch:focus input[type=checkbox]:checked+.check.is-black{box-shadow:0 0 .5em hsla(0,0%,4%,.8)}.switch:focus input[type=checkbox]:checked+.check.is-light{box-shadow:0 0 .5em hsla(0,0%,96%,.8)}.switch:focus input[type=checkbox]:checked+.check.is-dark{box-shadow:0 0 .5em rgba(54,54,54,.8)}.switch:focus input[type=checkbox]:checked+.check.is-primary{box-shadow:0 0 .5em rgba(0,209,178,.8)}.switch:focus input[type=checkbox]:checked+.check.is-info{box-shadow:0 0 .5em rgba(32,156,238,.8)}.switch:focus input[type=checkbox]:checked+.check.is-success{box-shadow:0 0 .5em rgba(35,209,96,.8)}.switch:focus input[type=checkbox]:checked+.check.is-warning{box-shadow:0 0 .5em rgba(255,221,87,.8)}.switch:focus input[type=checkbox]:checked+.check.is-danger{box-shadow:0 0 .5em rgba(255,56,96,.8)}.switch:focus input[type=checkbox]:checked+.check.is-twitter{box-shadow:0 0 .5em rgba(64,153,255,.8)}.switch.is-small{border-radius:2px;font-size:.75rem}.switch.is-medium{font-size:1.25rem}.switch.is-large{font-size:1.5rem}.switch[disabled]{opacity:.5;cursor:not-allowed;color:#7a7a7a}.table-wrapper .table{margin-bottom:0}.table-wrapper:not(:last-child){margin-bottom:1.5rem}@media screen and (max-width:1087px){.table-wrapper{overflow-x:auto}}.b-table{transition:opacity 86ms ease-out}@media print,screen and (min-width:769px){.b-table .table-mobile-sort{display:none}}.b-table .icon{transition:transform .15s ease-out,opacity 86ms ease-out}.b-table .icon.is-desc{transform:rotate(180deg)}.b-table .icon.is-expanded{transform:rotate(90deg)}.b-table .table{width:100%;border:1px solid transparent;border-radius:4px;border-collapse:separate}.b-table .table th{font-weight:600}.b-table .table th .th-wrap{display:flex;align-items:center}.b-table .table th .th-wrap .icon{margin-left:.5rem;margin-right:0;font-size:1rem}.b-table .table th .th-wrap.is-numeric{flex-direction:row-reverse;text-align:right}.b-table .table th .th-wrap.is-numeric .icon{margin-left:0;margin-right:.5rem}.b-table .table th .th-wrap.is-centered{justify-content:center;text-align:center}.b-table .table th.is-current-sort{border-color:#7a7a7a;font-weight:700}.b-table .table th.is-sortable:hover{border-color:#7a7a7a}.b-table .table th.is-sortable,.b-table .table th.is-sortable .th-wrap{cursor:pointer}.b-table .table tr.is-selected .checkbox input:checked+.check{background:#fff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%2300d1b2'/%3E%3C/svg%3E\") no-repeat 50%}.b-table .table tr.is-selected .checkbox input+.check{border-color:#fff}.b-table .table tr.is-empty:hover{background-color:transparent}.b-table .table .chevron-cell{vertical-align:middle}.b-table .table .checkbox-cell{width:40px}.b-table .table .checkbox-cell .checkbox{vertical-align:middle}.b-table .table .checkbox-cell .checkbox .check{transition:none}.b-table .table tr.detail{box-shadow:inset 0 1px 3px #dbdbdb;background:#fafafa}.b-table .table tr.detail .detail-container{padding:1rem}.b-table .table:focus{border-color:#3273dc;box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.b-table .table.is-bordered th.is-current-sort,.b-table .table.is-bordered th.is-sortable:hover{border-color:#dbdbdb;background:#f5f5f5}@media screen and (max-width:768px){.b-table .table.has-mobile-cards thead{display:none}.b-table .table.has-mobile-cards tfoot th{border:0;display:inherit}.b-table .table.has-mobile-cards tr{box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);max-width:100%;position:relative;display:block}.b-table .table.has-mobile-cards tr td{border:0;display:inherit}.b-table .table.has-mobile-cards tr td:last-child{border-bottom:0}.b-table .table.has-mobile-cards tr:not(:last-child){margin-bottom:1rem}.b-table .table.has-mobile-cards tr:not([class*=is-]){background:inherit}.b-table .table.has-mobile-cards tr:not([class*=is-]):hover{background-color:inherit}.b-table .table.has-mobile-cards tr.detail{margin-top:-1rem}.b-table .table.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td{display:flex;width:auto;justify-content:space-between;text-align:right;border-bottom:1px solid #f5f5f5}.b-table .table.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td:before{content:attr(data-label);font-weight:600;padding-right:.5em;text-align:left}}.b-table .level{padding-bottom:1.5rem}.b-table.is-loading{position:relative;pointer-events:none;opacity:.5}.b-table.is-loading:after{position:absolute;top:4em;left:calc(50% - 2.5em);width:5em;height:5em;border-width:.25em}.b-tabs .tabs{margin-bottom:0;flex-shrink:0}.b-tabs .is-disabled{pointer-events:none;cursor:not-allowed;opacity:.5}.b-tabs .tab-content{position:relative;overflow:hidden;display:flex;flex-direction:column;padding:1rem}.b-tabs .tab-content .tab-item{flex-shrink:0;flex-basis:auto}.b-tabs:not(:last-child){margin-bottom:1.5rem}.b-tabs.is-fullwidth{width:100%}.tag .has-ellipsis{max-width:10em;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.taginput .taginput-container.is-focusable{padding-bottom:0;padding-top:calc(.275em - 1px);align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start;height:auto;cursor:text}.taginput .taginput-container>.tag,.taginput .taginput-container>.tags{margin-bottom:calc(.275em - 1px);font-size:.9em;height:1.7em}.taginput .taginput-container>.tag .tag,.taginput .taginput-container>.tags .tag{margin-bottom:0;font-size:.9em;height:1.7em}.taginput .taginput-container>.tag:not(:last-child),.taginput .taginput-container>.tags:not(:last-child){margin-right:.275rem}.taginput .taginput-container .autocomplete{flex:1}.taginput .taginput-container .autocomplete input{height:1.7em;margin-bottom:calc(.275em - 1px);padding-top:0;padding-bottom:0;border:none;box-shadow:none;min-width:8em}.taginput .taginput-container .autocomplete input:focus{box-shadow:none!important}.taginput .taginput-container .autocomplete .icon{height:1.7em}.timepicker .dropdown,.timepicker .dropdown-trigger{width:100%}.dropdown .dropdown-menu .has-link .timepicker a,.timepicker .dropdown-item,.timepicker .dropdown .dropdown-menu .has-link a{font-size:inherit}.timepicker .timepicker-footer{padding-top:.875rem}.timepicker .control .select{font-size:2.5rem}.timepicker .control .select select{font-weight:600;padding-right:calc(.625em - 1px)}.timepicker .control .select select option{font-size:1.5rem}.timepicker .control .select select option:disabled{color:hsla(0,0%,48%,.7)}.timepicker .control .select:after{display:none}.timepicker .control:first-child .select select{border-right:none}.timepicker .control:first-child .select:before{content:\":\";color:#b5b5b5;display:inline-block;position:absolute;z-index:6;font-size:3rem;right:-.325rem;top:.25rem}.timepicker .control:nth-child(2) .select select{border-left:none}.timepicker.is-small{border-radius:2px;font-size:.75rem}.timepicker.is-medium{font-size:1.25rem}.timepicker.is-large{font-size:1.5rem}.tooltip{position:relative;display:inline-flex}.tooltip.is-top:after,.tooltip.is-top:before{top:auto;right:auto;bottom:calc(100% + 5px + 2px);left:50%;transform:translateX(-50%)}.tooltip.is-top.is-white:before{border-top:5px solid #fff}.tooltip.is-top.is-black:before,.tooltip.is-top.is-white:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.tooltip.is-top.is-black:before{border-top:5px solid #0a0a0a}.tooltip.is-top.is-light:before{border-top:5px solid #f5f5f5}.tooltip.is-top.is-dark:before,.tooltip.is-top.is-light:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.tooltip.is-top.is-dark:before{border-top:5px solid #363636}.tooltip.is-top.is-primary:before{border-top:5px solid #00d1b2}.tooltip.is-top.is-info:before,.tooltip.is-top.is-primary:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.tooltip.is-top.is-info:before{border-top:5px solid #209cee}.tooltip.is-top.is-success:before{border-top:5px solid #23d160}.tooltip.is-top.is-success:before,.tooltip.is-top.is-warning:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.tooltip.is-top.is-warning:before{border-top:5px solid #ffdd57}.tooltip.is-top.is-danger:before{border-top:5px solid #ff3860}.tooltip.is-top.is-danger:before,.tooltip.is-top.is-twitter:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.tooltip.is-top.is-twitter:before{border-top:5px solid #4099ff}.tooltip.is-top.is-multiline.is-small:after{width:180px}.tooltip.is-top.is-multiline.is-medium:after{width:240px}.tooltip.is-top.is-multiline.is-large:after{width:300px}.tooltip.is-right:after,.tooltip.is-right:before{top:50%;right:auto;bottom:auto;left:calc(100% + 5px + 2px);transform:translateY(-50%)}.tooltip.is-right.is-white:before{border-right:5px solid #fff}.tooltip.is-right.is-black:before,.tooltip.is-right.is-white:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.tooltip.is-right.is-black:before{border-right:5px solid #0a0a0a}.tooltip.is-right.is-light:before{border-right:5px solid #f5f5f5}.tooltip.is-right.is-dark:before,.tooltip.is-right.is-light:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.tooltip.is-right.is-dark:before{border-right:5px solid #363636}.tooltip.is-right.is-primary:before{border-right:5px solid #00d1b2}.tooltip.is-right.is-info:before,.tooltip.is-right.is-primary:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.tooltip.is-right.is-info:before{border-right:5px solid #209cee}.tooltip.is-right.is-success:before{border-right:5px solid #23d160}.tooltip.is-right.is-success:before,.tooltip.is-right.is-warning:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.tooltip.is-right.is-warning:before{border-right:5px solid #ffdd57}.tooltip.is-right.is-danger:before{border-right:5px solid #ff3860}.tooltip.is-right.is-danger:before,.tooltip.is-right.is-twitter:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.tooltip.is-right.is-twitter:before{border-right:5px solid #4099ff}.tooltip.is-right.is-multiline.is-small:after{width:180px}.tooltip.is-right.is-multiline.is-medium:after{width:240px}.tooltip.is-right.is-multiline.is-large:after{width:300px}.tooltip.is-bottom:after,.tooltip.is-bottom:before{top:calc(100% + 5px + 2px);right:auto;bottom:auto;left:50%;transform:translateX(-50%)}.tooltip.is-bottom.is-white:before{border-bottom:5px solid #fff}.tooltip.is-bottom.is-black:before,.tooltip.is-bottom.is-white:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.tooltip.is-bottom.is-black:before{border-bottom:5px solid #0a0a0a}.tooltip.is-bottom.is-light:before{border-bottom:5px solid #f5f5f5}.tooltip.is-bottom.is-dark:before,.tooltip.is-bottom.is-light:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.tooltip.is-bottom.is-dark:before{border-bottom:5px solid #363636}.tooltip.is-bottom.is-primary:before{border-bottom:5px solid #00d1b2}.tooltip.is-bottom.is-info:before,.tooltip.is-bottom.is-primary:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.tooltip.is-bottom.is-info:before{border-bottom:5px solid #209cee}.tooltip.is-bottom.is-success:before{border-bottom:5px solid #23d160}.tooltip.is-bottom.is-success:before,.tooltip.is-bottom.is-warning:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.tooltip.is-bottom.is-warning:before{border-bottom:5px solid #ffdd57}.tooltip.is-bottom.is-danger:before{border-bottom:5px solid #ff3860}.tooltip.is-bottom.is-danger:before,.tooltip.is-bottom.is-twitter:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.tooltip.is-bottom.is-twitter:before{border-bottom:5px solid #4099ff}.tooltip.is-bottom.is-multiline.is-small:after{width:180px}.tooltip.is-bottom.is-multiline.is-medium:after{width:240px}.tooltip.is-bottom.is-multiline.is-large:after{width:300px}.tooltip.is-left:after,.tooltip.is-left:before{top:50%;right:calc(100% + 5px + 2px);bottom:auto;left:auto;transform:translateY(-50%)}.tooltip.is-left.is-white:before{border-left:5px solid #fff}.tooltip.is-left.is-black:before,.tooltip.is-left.is-white:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.tooltip.is-left.is-black:before{border-left:5px solid #0a0a0a}.tooltip.is-left.is-light:before{border-left:5px solid #f5f5f5}.tooltip.is-left.is-dark:before,.tooltip.is-left.is-light:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.tooltip.is-left.is-dark:before{border-left:5px solid #363636}.tooltip.is-left.is-primary:before{border-left:5px solid #00d1b2}.tooltip.is-left.is-info:before,.tooltip.is-left.is-primary:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.tooltip.is-left.is-info:before{border-left:5px solid #209cee}.tooltip.is-left.is-success:before{border-left:5px solid #23d160}.tooltip.is-left.is-success:before,.tooltip.is-left.is-warning:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.tooltip.is-left.is-warning:before{border-left:5px solid #ffdd57}.tooltip.is-left.is-danger:before{border-left:5px solid #ff3860}.tooltip.is-left.is-danger:before,.tooltip.is-left.is-twitter:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.tooltip.is-left.is-twitter:before{border-left:5px solid #4099ff}.tooltip.is-left.is-multiline.is-small:after{width:180px}.tooltip.is-left.is-multiline.is-medium:after{width:240px}.tooltip.is-left.is-multiline.is-large:after{width:300px}.tooltip:after,.tooltip:before{position:absolute;content:\"\";opacity:0;visibility:hidden;pointer-events:none}.tooltip:before{z-index:889}.tooltip:after{content:attr(data-label);width:auto;padding:.35rem .75rem;border-radius:6px;font-size:.85rem;font-weight:400;box-shadow:0 1px 2px 1px rgba(0,1,0,.2);z-index:888;white-space:nowrap}.tooltip:not([data-label=\"\"]):hover:after,.tooltip:not([data-label=\"\"]):hover:before{opacity:1;visibility:visible}.tooltip.is-white:after{background:#fff;color:#0a0a0a}.tooltip.is-black:after{background:#0a0a0a;color:#fff}.tooltip.is-light:after{background:#f5f5f5;color:#363636}.tooltip.is-dark:after{background:#363636;color:#f5f5f5}.tooltip.is-primary:after{background:#00d1b2;color:#fff}.tooltip.is-info:after{background:#209cee;color:#fff}.tooltip.is-success:after{background:#23d160;color:#fff}.tooltip.is-warning:after{background:#ffdd57;color:rgba(0,0,0,.7)}.tooltip.is-danger:after{background:#ff3860;color:#fff}.tooltip.is-twitter:after{background:#4099ff;color:#fff}.tooltip:not([data-label=\"\"]).is-always:after,.tooltip:not([data-label=\"\"]).is-always:before{opacity:1;visibility:visible}.tooltip.is-multiline:after{display:flex-block;text-align:center;white-space:normal}.tooltip.is-dashed{border-bottom:1px dashed #b5b5b5;cursor:default}.tooltip.is-square:after{border-radius:0}.tooltip.is-animated:after,.tooltip.is-animated:before{transition:opacity 86ms ease-out,visibility 86ms ease-out}.upload{position:relative}.upload input[type=file]{position:absolute;top:0;left:0;width:100%;opacity:0;outline:none;z-index:-1}.upload .upload-draggable{display:inline-block;cursor:pointer;padding:.25em;border:1px dashed #b5b5b5;border-radius:6px}.upload .upload-draggable.is-disabled{opacity:.5;cursor:not-allowed}.upload .upload-draggable.is-loading{position:relative;pointer-events:none;opacity:.5}.upload .upload-draggable.is-loading:after{top:0;left:calc(50% - 1.5em);width:3em;height:3em;border-width:.25em}.upload .upload-draggable.is-hovered.is-white,.upload .upload-draggable:hover.is-white{border-color:#fff;background:hsla(0,0%,100%,.05)}.upload .upload-draggable.is-hovered.is-black,.upload .upload-draggable:hover.is-black{border-color:#0a0a0a;background:hsla(0,0%,4%,.05)}.upload .upload-draggable.is-hovered.is-light,.upload .upload-draggable:hover.is-light{border-color:#f5f5f5;background:hsla(0,0%,96%,.05)}.upload .upload-draggable.is-hovered.is-dark,.upload .upload-draggable:hover.is-dark{border-color:#363636;background:rgba(54,54,54,.05)}.upload .upload-draggable.is-hovered.is-primary,.upload .upload-draggable:hover.is-primary{border-color:#00d1b2;background:rgba(0,209,178,.05)}.upload .upload-draggable.is-hovered.is-info,.upload .upload-draggable:hover.is-info{border-color:#209cee;background:rgba(32,156,238,.05)}.upload .upload-draggable.is-hovered.is-success,.upload .upload-draggable:hover.is-success{border-color:#23d160;background:rgba(35,209,96,.05)}.upload .upload-draggable.is-hovered.is-warning,.upload .upload-draggable:hover.is-warning{border-color:#ffdd57;background:rgba(255,221,87,.05)}.upload .upload-draggable.is-hovered.is-danger,.upload .upload-draggable:hover.is-danger{border-color:#ff3860;background:rgba(255,56,96,.05)}.upload .upload-draggable.is-hovered.is-twitter,.upload .upload-draggable:hover.is-twitter{border-color:#4099ff;background:rgba(64,153,255,.05)}", ""]);

// exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(23);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(7);
var Axios = __webpack_require__(25);
var defaults = __webpack_require__(5);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(11);
axios.CancelToken = __webpack_require__(39);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(40);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(5);
var utils = __webpack_require__(0);
var InterceptorManager = __webpack_require__(34);
var dispatchRequest = __webpack_require__(35);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(9);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(36);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(5);
var isAbsoluteURL = __webpack_require__(37);
var combineURLs = __webpack_require__(38);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(11);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('section',[_c('div',{staticClass:"columns is-mobile is-centered"},[_c('div',{staticClass:"column is-four-fifths"},[_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{attrs:{"id":"form"}},[_c('b-field',{attrs:{"label":_vm.items.name.label}},[_c('b-input',{staticClass:"input-middle",attrs:{"required":"","placeholder":"お名前または法人名を入力してください"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":_vm.items.email.label}},[_c('b-input',{staticClass:"input-middle",attrs:{"required":"","type":"email","placeholder":"メールアドレスを入力してください"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":_vm.items.tel.label}},[_c('b-input',{staticClass:"input-middle",attrs:{"type":"text","required":""},model:{value:(_vm.tel),callback:function ($$v) {_vm.tel=$$v},expression:"tel"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":_vm.items.member_type.label}},[_c('b-select',{attrs:{"required":"","placeholder":"選択してください"},model:{value:(_vm.member_type),callback:function ($$v) {_vm.member_type=$$v},expression:"member_type"}},[_c('option',{attrs:{"value":"0"}},[_vm._v("個人正会員")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("個人賛助会員")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("法人正会員")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("法人賛助会員")])])],1),_vm._v(" "),_c('b-field',{attrs:{"label":"年会費"}},[_c('p',[_vm._v("\n                     "+_vm._s(_vm.member_price)+"\n                ")])]),_vm._v(" "),_c('b-field',{attrs:{"label":"寄付金","message":"同時にご寄付がある場合のみご入力ください"}},[_c('b-input',{staticClass:"input-small",attrs:{"placeholder":"数字のみ入力してください","type":"number"},model:{value:(_vm.donation),callback:function ($$v) {_vm.donation=$$v},expression:"donation"}})],1),_vm._v(" "),(_vm.member_type)?_c('span',[_vm._v("\n                    上記金額をクレジットカードで支払いします。\n                    ")]):_vm._e(),_vm._v(" "),_c('b-field',{attrs:{"label":"ご質問、ご要望"}},[_c('b-input',{staticClass:"input-middle",attrs:{"type":"textarea","maxlength":"1000","placeholder":"NSPへご質問、ご要望がございましたらこちらにご記入ください"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(42),"width":"200"}}),_vm._v(" "),_c('b-field',{staticClass:"input-middle",attrs:{"label":_vm.items.card_name.label}},[_c('b-input',{attrs:{"required":"","placeholder":"アルファベットで入力してください"},model:{value:(_vm.card_name),callback:function ($$v) {_vm.card_name=$$v},expression:"card_name"}})],1),_vm._v(" "),_c('b-field',{staticClass:"input-small",attrs:{"label":_vm.items.card_number.label}},[_c('b-input',{attrs:{"required":"","placeholder":"数字のみで入力してください"},model:{value:(_vm.card_number),callback:function ($$v) {_vm.card_number=$$v},expression:"card_number"}})],1),_vm._v(" "),_c('b-field',{attrs:{"grouped":""}},[_c('b-field',{attrs:{"label":_vm.items.card_exp_m.label,"required":""}},[_c('b-select',{model:{value:(_vm.card_exp_m),callback:function ($$v) {_vm.card_exp_m=$$v},expression:"card_exp_m"}},[_c('option',[_vm._v("01")]),_vm._v(" "),_c('option',[_vm._v("02")]),_vm._v(" "),_c('option',[_vm._v("03")]),_vm._v(" "),_c('option',[_vm._v("04")]),_vm._v(" "),_c('option',[_vm._v("05")]),_vm._v(" "),_c('option',[_vm._v("06")]),_vm._v(" "),_c('option',[_vm._v("07")]),_vm._v(" "),_c('option',[_vm._v("08")]),_vm._v(" "),_c('option',[_vm._v("09")]),_vm._v(" "),_c('option',[_vm._v("10")]),_vm._v(" "),_c('option',[_vm._v("11")]),_vm._v(" "),_c('option',[_vm._v("12")])])],1),_vm._v(" "),_c('b-field',{attrs:{"label":_vm.items.card_exp_y.label,"required":""}},[_c('b-select',{model:{value:(_vm.card_exp_y),callback:function ($$v) {_vm.card_exp_y=$$v},expression:"card_exp_y"}},_vm._l((12),function(n){return _c('option',{domProps:{"value":n - 1 + _vm.year + 2000}},[_vm._v("\n                    "+_vm._s(n - 1 + _vm.year)+"\n                 ")])}))],1)],1),_vm._v(" "),_c('b-field',{attrs:{"label":_vm.items.card_sec.label,"message":"VISA,Master,JCBは裏面の３桁、AMEXは面面の４桁のコード<i id='modal_on' class='fa fa-info-circle'></i>"}},[_c('b-input',{staticClass:"input-tiny",attrs:{"required":""},model:{value:(_vm.card_sec),callback:function ($$v) {_vm.card_sec=$$v},expression:"card_sec"}})],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-field',[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",attrs:{"disabled":_vm.isPush},on:{"click":_vm.exec}},[_vm._v("\n                  支払い\n                ")])])])]),_vm._v(" "),_c('br')],1)])])]),_vm._v(" "),_vm._m(3)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("\n        認定NPO法人日本再生プログラム推進フォーラム\n      ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("\n        クレジットカード支払いフォーム\n      ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\nNPO法人日本再生プログラム推進フォーラムの年会費お支払いフォームです。"),_c('br'),_vm._v("\nこの通信は暗号化され、クレジットカード情報は決済会社にのみ送信されます。\n\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",attrs:{"id":"modal"}},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('p',{staticClass:"image"},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})])]),_vm._v(" "),_c('button',{staticClass:"modal-close is-large",attrs:{"aria-label":"close","onclick":"document.getElementById('modal').classList.toggle('is-active');"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v("\n             \n© 認定NPO法人日本再生プログラム推進フォーラム　"),_c('br')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

(function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.Buefy=t():e.Buefy=t()})(this,function(){return function(e){function t(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return e[i].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,i){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:i})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=239)}([function(e,t){e.exports=function(e,t,n,i,r){var a,o=e=e||{},s=typeof e.default;"object"!==s&&"function"!==s||(a=e,o=e.default);var l="function"==typeof o?o.options:o;t&&(l.render=t.render,l.staticRenderFns=t.staticRenderFns),i&&(l._scopeId=i);var c;if(r?(c=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),n&&n.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(r)},l._ssrRegister=c):n&&(c=n),c){var u=l.functional,d=u?l.render:l.beforeCreate;u?l.render=function(e,t){return c.call(t),d(e,t)}:l.beforeCreate=d?[].concat(d,c):[c]}return{esModule:a,exports:o,options:l}}},function(e,t,n){"use strict";n.d(t,"a",function(){return r});var i={defaultContainerElement:null,defaultIconPack:"mdi",defaultDialogConfirmText:null,defaultDialogCancelText:null,defaultSnackbarDuration:3500,defaultToastDuration:2e3,defaultTooltipType:"is-primary",defaultTooltipAnimated:!1,defaultInputAutocomplete:"on",defaultDateFormatter:null,defaultDateParser:null,defaultDayNames:null,defaultMonthNames:null,defaultFirstDayOfWeek:null,defaultUnselectableDaysOfWeek:null,defaultTimeFormatter:null,defaultTimeParser:null,defaultModalScroll:null,defaultDatepickerMobileNative:!0,defaultTimepickerMobileNative:!0,defaultNoticeQueue:!0};t.b=i;var r=function(e){i=e}},function(e,t,n){"use strict";var i=n(179),r=n.n(i);t.a=r.a},function(e,t,n){e.exports={default:n(133),__esModule:!0}},function(e,t,n){var i=n(37)("wks"),r=n(27),a=n(8).Symbol,o="function"==typeof a;(e.exports=function(e){return i[e]||(i[e]=o&&a[e]||(o?a:r)("Symbol."+e))}).store=i},function(e,t,n){"use strict";function i(e,t){return t.split(".").reduce(function(e,t){return e[t]},e)}function r(e,t,n){if(!e)return-1;if(!n||"function"!=typeof n)return e.indexOf(t);for(var i=0;i<e.length;i++)if(n(e[i],t))return i;return-1}function a(e){void 0!==e.remove?e.remove():e.parentNode.removeChild(e)}function o(e){return e?e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&"):e}t.c=i,t.d=r,n.d(t,"b",function(){return s}),t.a=a,t.e=o;var s={Android:function(){return"undefined"!=typeof window&&window.navigator.userAgent.match(/Android/i)},BlackBerry:function(){return"undefined"!=typeof window&&window.navigator.userAgent.match(/BlackBerry/i)},iOS:function(){return"undefined"!=typeof window&&window.navigator.userAgent.match(/iPhone|iPad|iPod/i)},Opera:function(){return"undefined"!=typeof window&&window.navigator.userAgent.match(/Opera Mini/i)},Windows:function(){return"undefined"!=typeof window&&window.navigator.userAgent.match(/IEMobile/i)},any:function(){return s.Android()||s.BlackBerry()||s.iOS()||s.Opera()||s.Windows()}}},function(e,t,n){"use strict";t.__esModule=!0;var i=n(126),r=function(e){return e&&e.__esModule?e:{default:e}}(i);t.default=function(e,t,n){return t in e?(0,r.default)(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}},function(e,t){var n=e.exports={version:"2.5.3"};"number"==typeof __e&&(__e=n)},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t,n){var i=n(14),r=n(55),a=n(40),o=Object.defineProperty;t.f=n(11)?Object.defineProperty:function(e,t,n){if(i(e),t=a(t,!0),i(n),r)try{return o(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){"use strict";var i=n(1);t.a={props:{size:String,expanded:Boolean,loading:Boolean,rounded:Boolean,icon:String,iconPack:String,autocomplete:String,maxlength:[Number,String]},data:function(){return{isValid:!0,isFocused:!1,newIconPack:this.iconPack||i.b.defaultIconPack}},computed:{parentField:function(){for(var e=this.$parent,t=0;t<3;t++)e&&!e.$data._isField&&(e=e.$parent);return e},statusType:function(){if(this.parentField)return this.parentField.newType},statusMessage:function(){if(this.parentField)return this.parentField.newMessage},iconSize:function(){switch(this.size){case"is-small":return this.size;case"is-medium":return;case"is-large":return"mdi"===this.newIconPack?"is-medium":""}}},methods:{focus:function(){var e=this;void 0!==this.$data._elementRef&&this.$nextTick(function(){return e.$el.querySelector(e.$data._elementRef).focus()})},onBlur:function(e){this.isFocused=!1,this.$emit("blur",e),this.checkHtml5Validity()},onFocus:function(e){this.isFocused=!0,this.$emit("focus",e)},checkHtml5Validity:function(){if(void 0!==this.$refs[this.$data._elementRef]){var e=this.$el.querySelector(this.$data._elementRef),t=null,n=null,i=!0;return e.checkValidity()||(t="is-danger",n=e.validationMessage,i=!1),this.isValid=i,this.parentField&&(this.parentField.type||(this.parentField.newType=t),this.parentField.message||(this.parentField.newMessage=n)),this.isValid}}}}},function(e,t,n){e.exports=!n(18)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){e.exports={default:n(131),__esModule:!0}},function(e,t,n){var i=n(19);e.exports=function(e){if(!i(e))throw TypeError(e+" is not an object!");return e}},function(e,t,n){var i=n(9),r=n(21);e.exports=n(11)?function(e,t,n){return i.f(e,t,r(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){var i=n(56),r=n(31);e.exports=function(e){return i(r(e))}},function(e,t,n){var i=n(8),r=n(7),a=n(53),o=n(15),s=function(e,t,n){var l,c,u,d=e&s.F,f=e&s.G,p=e&s.S,h=e&s.P,v=e&s.B,m=e&s.W,y=f?r:r[t]||(r[t]={}),g=y.prototype,b=f?i:p?i[t]:(i[t]||{}).prototype;f&&(n=t);for(l in n)(c=!d&&b&&void 0!==b[l])&&l in y||(u=c?b[l]:n[l],y[l]=f&&"function"!=typeof b[l]?n[l]:v&&c?a(u,i):m&&b[l]==u?function(e){var t=function(t,n,i){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,i)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(u):h&&"function"==typeof u?a(Function.call,u):u,h&&((y.virtual||(y.virtual={}))[l]=u,e&s.R&&g&&!g[l]&&o(g,l,u)))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,e.exports=s},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t){e.exports={}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,n){"use strict";(function(e,n){function i(e){return void 0===e||null===e}function r(e){return void 0!==e&&null!==e}function a(e){return!0===e}function o(e){return!1===e}function s(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e||"boolean"==typeof e}function l(e){return null!==e&&"object"==typeof e}function c(e){return"[object Object]"===pi.call(e)}function u(e){return"[object RegExp]"===pi.call(e)}function d(e){var t=parseFloat(String(e));return t>=0&&Math.floor(t)===t&&isFinite(e)}function f(e){return null==e?"":"object"==typeof e?JSON.stringify(e,null,2):String(e)}function p(e){var t=parseFloat(e);return isNaN(t)?e:t}function h(e,t){for(var n=Object.create(null),i=e.split(","),r=0;r<i.length;r++)n[i[r]]=!0;return t?function(e){return n[e.toLowerCase()]}:function(e){return n[e]}}function v(e,t){if(e.length){var n=e.indexOf(t);if(n>-1)return e.splice(n,1)}}function m(e,t){return vi.call(e,t)}function y(e){var t=Object.create(null);return function(n){return t[n]||(t[n]=e(n))}}function g(e,t){function n(n){var i=arguments.length;return i?i>1?e.apply(t,arguments):e.call(t,n):e.call(t)}return n._length=e.length,n}function b(e,t){t=t||0;for(var n=e.length-t,i=new Array(n);n--;)i[n]=e[n+t];return i}function _(e,t){for(var n in t)e[n]=t[n];return e}function w(e){for(var t={},n=0;n<e.length;n++)e[n]&&_(t,e[n]);return t}function k(e,t,n){}function C(e,t){if(e===t)return!0;var n=l(e),i=l(t);if(!n||!i)return!n&&!i&&String(e)===String(t);try{var r=Array.isArray(e),a=Array.isArray(t);if(r&&a)return e.length===t.length&&e.every(function(e,n){return C(e,t[n])});if(r||a)return!1;var o=Object.keys(e),s=Object.keys(t);return o.length===s.length&&o.every(function(n){return C(e[n],t[n])})}catch(e){return!1}}function x(e,t){for(var n=0;n<e.length;n++)if(C(e[n],t))return n;return-1}function S(e){var t=!1;return function(){t||(t=!0,e.apply(this,arguments))}}function D(e){var t=(e+"").charCodeAt(0);return 36===t||95===t}function $(e,t,n,i){Object.defineProperty(e,t,{value:n,enumerable:!!i,writable:!0,configurable:!0})}function A(e){if(!$i.test(e)){var t=e.split(".");return function(e){for(var n=0;n<t.length;n++){if(!e)return;e=e[t[n]]}return e}}}function O(e){return"function"==typeof e&&/native code/.test(e.toString())}function T(e){Ki.target&&Gi.push(Ki.target),Ki.target=e}function M(){Ki.target=Gi.pop()}function P(e){return new Ji(void 0,void 0,void 0,String(e))}function B(e,t){var n=e.componentOptions,i=new Ji(e.tag,e.data,e.children,e.text,e.elm,e.context,n,e.asyncFactory);return i.ns=e.ns,i.isStatic=e.isStatic,i.key=e.key,i.isComment=e.isComment,i.fnContext=e.fnContext,i.fnOptions=e.fnOptions,i.fnScopeId=e.fnScopeId,i.isCloned=!0,t&&(e.children&&(i.children=F(e.children,!0)),n&&n.children&&(n.children=F(n.children,!0))),i}function F(e,t){for(var n=e.length,i=new Array(n),r=0;r<n;r++)i[r]=B(e[r],t);return i}function V(e,t,n){e.__proto__=t}function I(e,t,n){for(var i=0,r=n.length;i<r;i++){var a=n[i];$(e,a,t[a])}}function E(e,t){if(l(e)&&!(e instanceof Ji)){var n;return m(e,"__ob__")&&e.__ob__ instanceof ir?n=e.__ob__:nr.shouldConvert&&!Hi()&&(Array.isArray(e)||c(e))&&Object.isExtensible(e)&&!e._isVue&&(n=new ir(e)),t&&n&&n.vmCount++,n}}function N(e,t,n,i,r){var a=new Ki,o=Object.getOwnPropertyDescriptor(e,t);if(!o||!1!==o.configurable){var s=o&&o.get,l=o&&o.set,c=!r&&E(n);Object.defineProperty(e,t,{enumerable:!0,configurable:!0,get:function(){var t=s?s.call(e):n;return Ki.target&&(a.depend(),c&&(c.dep.depend(),Array.isArray(t)&&L(t))),t},set:function(t){var i=s?s.call(e):n;t===i||t!==t&&i!==i||(l?l.call(e,t):n=t,c=!r&&E(t),a.notify())}})}}function j(e,t,n){if(Array.isArray(e)&&d(t))return e.length=Math.max(e.length,t),e.splice(t,1,n),n;if(t in e&&!(t in Object.prototype))return e[t]=n,n;var i=e.__ob__;return e._isVue||i&&i.vmCount?n:i?(N(i.value,t,n),i.dep.notify(),n):(e[t]=n,n)}function R(e,t){if(Array.isArray(e)&&d(t))return void e.splice(t,1);var n=e.__ob__;e._isVue||n&&n.vmCount||m(e,t)&&(delete e[t],n&&n.dep.notify())}function L(e){for(var t=void 0,n=0,i=e.length;n<i;n++)t=e[n],t&&t.__ob__&&t.__ob__.dep.depend(),Array.isArray(t)&&L(t)}function z(e,t){if(!t)return e;for(var n,i,r,a=Object.keys(t),o=0;o<a.length;o++)n=a[o],i=e[n],r=t[n],m(e,n)?c(i)&&c(r)&&z(i,r):j(e,n,r);return e}function H(e,t,n){return n?function(){var i="function"==typeof t?t.call(n,n):t,r="function"==typeof e?e.call(n,n):e;return i?z(i,r):r}:t?e?function(){return z("function"==typeof t?t.call(this,this):t,"function"==typeof e?e.call(this,this):e)}:t:e}function W(e,t){return t?e?e.concat(t):Array.isArray(t)?t:[t]:e}function q(e,t,n,i){var r=Object.create(e||null);return t?_(r,t):r}function Y(e,t){var n=e.props;if(n){var i,r,a,o={};if(Array.isArray(n))for(i=n.length;i--;)"string"==typeof(r=n[i])&&(a=yi(r),o[a]={type:null});else if(c(n))for(var s in n)r=n[s],a=yi(s),o[a]=c(r)?r:{type:r};e.props=o}}function U(e,t){var n=e.inject;if(n){var i=e.inject={};if(Array.isArray(n))for(var r=0;r<n.length;r++)i[n[r]]={from:n[r]};else if(c(n))for(var a in n){var o=n[a];i[a]=c(o)?_({from:a},o):{from:o}}}}function K(e){var t=e.directives;if(t)for(var n in t){var i=t[n];"function"==typeof i&&(t[n]={bind:i,update:i})}}function G(e,t,n){function i(i){var r=rr[i]||sr;l[i]=r(e[i],t[i],n,i)}"function"==typeof t&&(t=t.options),Y(t,n),U(t,n),K(t);var r=t.extends;if(r&&(e=G(e,r,n)),t.mixins)for(var a=0,o=t.mixins.length;a<o;a++)e=G(e,t.mixins[a],n);var s,l={};for(s in e)i(s);for(s in t)m(e,s)||i(s);return l}function J(e,t,n,i){if("string"==typeof n){var r=e[t];if(m(r,n))return r[n];var a=yi(n);if(m(r,a))return r[a];var o=gi(a);if(m(r,o))return r[o];return r[n]||r[a]||r[o]}}function X(e,t,n,i){var r=t[e],a=!m(n,e),o=n[e];if(ee(Boolean,r.type)&&(a&&!m(r,"default")?o=!1:ee(String,r.type)||""!==o&&o!==_i(e)||(o=!0)),void 0===o){o=Q(i,r,e);var s=nr.shouldConvert;nr.shouldConvert=!0,E(o),nr.shouldConvert=s}return o}function Q(e,t,n){if(m(t,"default")){var i=t.default;return e&&e.$options.propsData&&void 0===e.$options.propsData[n]&&void 0!==e._props[n]?e._props[n]:"function"==typeof i&&"Function"!==Z(t.type)?i.call(e):i}}function Z(e){var t=e&&e.toString().match(/^\s*function (\w+)/);return t?t[1]:""}function ee(e,t){if(!Array.isArray(t))return Z(t)===Z(e);for(var n=0,i=t.length;n<i;n++)if(Z(t[n])===Z(e))return!0;return!1}function te(e,t,n){if(t)for(var i=t;i=i.$parent;){var r=i.$options.errorCaptured;if(r)for(var a=0;a<r.length;a++)try{var o=!1===r[a].call(i,e,t,n);if(o)return}catch(e){ne(e,i,"errorCaptured hook")}}ne(e,t,n)}function ne(e,t,n){if(Di.errorHandler)try{return Di.errorHandler.call(null,e,t,n)}catch(e){ie(e,null,"config.errorHandler")}ie(e,t,n)}function ie(e,t,n){if(!Oi&&!Ti||"undefined"==typeof console)throw e;console.error(e)}function re(){cr=!1;var e=lr.slice(0);lr.length=0;for(var t=0;t<e.length;t++)e[t]()}function ae(e){return e._withTask||(e._withTask=function(){ur=!0;var t=e.apply(null,arguments);return ur=!1,t})}function oe(e,t){var n;if(lr.push(function(){if(e)try{e.call(t)}catch(e){te(e,t,"nextTick")}else n&&n(t)}),cr||(cr=!0,ur?or():ar()),!e&&"undefined"!=typeof Promise)return new Promise(function(e){n=e})}function se(e){le(e,vr),vr.clear()}function le(e,t){var n,i,r=Array.isArray(e);if((r||l(e))&&!Object.isFrozen(e)){if(e.__ob__){var a=e.__ob__.dep.id;if(t.has(a))return;t.add(a)}if(r)for(n=e.length;n--;)le(e[n],t);else for(i=Object.keys(e),n=i.length;n--;)le(e[i[n]],t)}}function ce(e){function t(){var e=arguments,n=t.fns;if(!Array.isArray(n))return n.apply(null,arguments);for(var i=n.slice(),r=0;r<i.length;r++)i[r].apply(null,e)}return t.fns=e,t}function ue(e,t,n,r,a){var o,s,l,c;for(o in e)s=e[o],l=t[o],c=mr(o),i(s)||(i(l)?(i(s.fns)&&(s=e[o]=ce(s)),n(c.name,s,c.once,c.capture,c.passive,c.params)):s!==l&&(l.fns=s,e[o]=l));for(o in t)i(e[o])&&(c=mr(o),r(c.name,t[o],c.capture))}function de(e,t,n){function o(){n.apply(this,arguments),v(s.fns,o)}e instanceof Ji&&(e=e.data.hook||(e.data.hook={}));var s,l=e[t];i(l)?s=ce([o]):r(l.fns)&&a(l.merged)?(s=l,s.fns.push(o)):s=ce([l,o]),s.merged=!0,e[t]=s}function fe(e,t,n){var a=t.options.props;if(!i(a)){var o={},s=e.attrs,l=e.props;if(r(s)||r(l))for(var c in a){var u=_i(c);pe(o,l,c,u,!0)||pe(o,s,c,u,!1)}return o}}function pe(e,t,n,i,a){if(r(t)){if(m(t,n))return e[n]=t[n],a||delete t[n],!0;if(m(t,i))return e[n]=t[i],a||delete t[i],!0}return!1}function he(e){for(var t=0;t<e.length;t++)if(Array.isArray(e[t]))return Array.prototype.concat.apply([],e);return e}function ve(e){return s(e)?[P(e)]:Array.isArray(e)?ye(e):void 0}function me(e){return r(e)&&r(e.text)&&o(e.isComment)}function ye(e,t){var n,o,l,c,u=[];for(n=0;n<e.length;n++)o=e[n],i(o)||"boolean"==typeof o||(l=u.length-1,c=u[l],Array.isArray(o)?o.length>0&&(o=ye(o,(t||"")+"_"+n),me(o[0])&&me(c)&&(u[l]=P(c.text+o[0].text),o.shift()),u.push.apply(u,o)):s(o)?me(c)?u[l]=P(c.text+o):""!==o&&u.push(P(o)):me(o)&&me(c)?u[l]=P(c.text+o.text):(a(e._isVList)&&r(o.tag)&&i(o.key)&&r(t)&&(o.key="__vlist"+t+"_"+n+"__"),u.push(o)));return u}function ge(e,t){return(e.__esModule||qi&&"Module"===e[Symbol.toStringTag])&&(e=e.default),l(e)?t.extend(e):e}function be(e,t,n,i,r){var a=Qi();return a.asyncFactory=e,a.asyncMeta={data:t,context:n,children:i,tag:r},a}function _e(e,t,n){if(a(e.error)&&r(e.errorComp))return e.errorComp;if(r(e.resolved))return e.resolved;if(a(e.loading)&&r(e.loadingComp))return e.loadingComp;if(!r(e.contexts)){var o=e.contexts=[n],s=!0,c=function(){for(var e=0,t=o.length;e<t;e++)o[e].$forceUpdate()},u=S(function(n){e.resolved=ge(n,t),s||c()}),d=S(function(t){r(e.errorComp)&&(e.error=!0,c())}),f=e(u,d);return l(f)&&("function"==typeof f.then?i(e.resolved)&&f.then(u,d):r(f.component)&&"function"==typeof f.component.then&&(f.component.then(u,d),r(f.error)&&(e.errorComp=ge(f.error,t)),r(f.loading)&&(e.loadingComp=ge(f.loading,t),0===f.delay?e.loading=!0:setTimeout(function(){i(e.resolved)&&i(e.error)&&(e.loading=!0,c())},f.delay||200)),r(f.timeout)&&setTimeout(function(){i(e.resolved)&&d(null)},f.timeout))),s=!1,e.loading?e.loadingComp:e.resolved}e.contexts.push(n)}function we(e){return e.isComment&&e.asyncFactory}function ke(e){if(Array.isArray(e))for(var t=0;t<e.length;t++){var n=e[t];if(r(n)&&(r(n.componentOptions)||we(n)))return n}}function Ce(e){e._events=Object.create(null),e._hasHookEvent=!1;var t=e.$options._parentListeners;t&&De(e,t)}function xe(e,t,n){n?hr.$once(e,t):hr.$on(e,t)}function Se(e,t){hr.$off(e,t)}function De(e,t,n){hr=e,ue(t,n||{},xe,Se,e),hr=void 0}function $e(e,t){var n={};if(!e)return n;for(var i=0,r=e.length;i<r;i++){var a=e[i],o=a.data;if(o&&o.attrs&&o.attrs.slot&&delete o.attrs.slot,a.context!==t&&a.fnContext!==t||!o||null==o.slot)(n.default||(n.default=[])).push(a);else{var s=o.slot,l=n[s]||(n[s]=[]);"template"===a.tag?l.push.apply(l,a.children||[]):l.push(a)}}for(var c in n)n[c].every(Ae)&&delete n[c];return n}function Ae(e){return e.isComment&&!e.asyncFactory||" "===e.text}function Oe(e,t){t=t||{};for(var n=0;n<e.length;n++)Array.isArray(e[n])?Oe(e[n],t):t[e[n].key]=e[n].fn;return t}function Te(e){var t=e.$options,n=t.parent;if(n&&!t.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(e)}e.$parent=n,e.$root=n?n.$root:e,e.$children=[],e.$refs={},e._watcher=null,e._inactive=null,e._directInactive=!1,e._isMounted=!1,e._isDestroyed=!1,e._isBeingDestroyed=!1}function Me(e,t,n){e.$el=t,e.$options.render||(e.$options.render=Qi),Ie(e,"beforeMount");var i;return i=function(){e._update(e._render(),n)},new Sr(e,i,k,null,!0),n=!1,null==e.$vnode&&(e._isMounted=!0,Ie(e,"mounted")),e}function Pe(e,t,n,i,r){var a=!!(r||e.$options._renderChildren||i.data.scopedSlots||e.$scopedSlots!==fi);if(e.$options._parentVnode=i,e.$vnode=i,e._vnode&&(e._vnode.parent=i),e.$options._renderChildren=r,e.$attrs=i.data&&i.data.attrs||fi,e.$listeners=n||fi,t&&e.$options.props){nr.shouldConvert=!1;for(var o=e._props,s=e.$options._propKeys||[],l=0;l<s.length;l++){var c=s[l];o[c]=X(c,e.$options.props,t,e)}nr.shouldConvert=!0,e.$options.propsData=t}if(n){var u=e.$options._parentListeners;e.$options._parentListeners=n,De(e,n,u)}a&&(e.$slots=$e(r,i.context),e.$forceUpdate())}function Be(e){for(;e&&(e=e.$parent);)if(e._inactive)return!0;return!1}function Fe(e,t){if(t){if(e._directInactive=!1,Be(e))return}else if(e._directInactive)return;if(e._inactive||null===e._inactive){e._inactive=!1;for(var n=0;n<e.$children.length;n++)Fe(e.$children[n]);Ie(e,"activated")}}function Ve(e,t){if(!(t&&(e._directInactive=!0,Be(e))||e._inactive)){e._inactive=!0;for(var n=0;n<e.$children.length;n++)Ve(e.$children[n]);Ie(e,"deactivated")}}function Ie(e,t){var n=e.$options[t];if(n)for(var i=0,r=n.length;i<r;i++)try{n[i].call(e)}catch(n){te(n,e,t+" hook")}e._hasHookEvent&&e.$emit("hook:"+t)}function Ee(){Cr=gr.length=br.length=0,_r={},wr=kr=!1}function Ne(){kr=!0;var e,t;for(gr.sort(function(e,t){return e.id-t.id}),Cr=0;Cr<gr.length;Cr++)e=gr[Cr],t=e.id,_r[t]=null,e.run();var n=br.slice(),i=gr.slice();Ee(),Le(n),je(i),Wi&&Di.devtools&&Wi.emit("flush")}function je(e){for(var t=e.length;t--;){var n=e[t],i=n.vm;i._watcher===n&&i._isMounted&&Ie(i,"updated")}}function Re(e){e._inactive=!1,br.push(e)}function Le(e){for(var t=0;t<e.length;t++)e[t]._inactive=!0,Fe(e[t],!0)}function ze(e){var t=e.id;if(null==_r[t]){if(_r[t]=!0,kr){for(var n=gr.length-1;n>Cr&&gr[n].id>e.id;)n--;gr.splice(n+1,0,e)}else gr.push(e);wr||(wr=!0,oe(Ne))}}function He(e,t,n){Dr.get=function(){return this[t][n]},Dr.set=function(e){this[t][n]=e},Object.defineProperty(e,n,Dr)}function We(e){e._watchers=[];var t=e.$options;t.props&&qe(e,t.props),t.methods&&Xe(e,t.methods),t.data?Ye(e):E(e._data={},!0),t.computed&&Ke(e,t.computed),t.watch&&t.watch!==Ni&&Qe(e,t.watch)}function qe(e,t){var n=e.$options.propsData||{},i=e._props={},r=e.$options._propKeys=[],a=!e.$parent;nr.shouldConvert=a;for(var o in t)(function(a){r.push(a);var o=X(a,t,n,e);N(i,a,o),a in e||He(e,"_props",a)})(o);nr.shouldConvert=!0}function Ye(e){var t=e.$options.data;t=e._data="function"==typeof t?Ue(t,e):t||{},c(t)||(t={});for(var n=Object.keys(t),i=e.$options.props,r=(e.$options.methods,n.length);r--;){var a=n[r];i&&m(i,a)||D(a)||He(e,"_data",a)}E(t,!0)}function Ue(e,t){try{return e.call(t,t)}catch(e){return te(e,t,"data()"),{}}}function Ke(e,t){var n=e._computedWatchers=Object.create(null),i=Hi();for(var r in t){var a=t[r],o="function"==typeof a?a:a.get;i||(n[r]=new Sr(e,o||k,k,$r)),r in e||Ge(e,r,a)}}function Ge(e,t,n){var i=!Hi();"function"==typeof n?(Dr.get=i?Je(t):n,Dr.set=k):(Dr.get=n.get?i&&!1!==n.cache?Je(t):n.get:k,Dr.set=n.set?n.set:k),Object.defineProperty(e,t,Dr)}function Je(e){return function(){var t=this._computedWatchers&&this._computedWatchers[e];if(t)return t.dirty&&t.evaluate(),Ki.target&&t.depend(),t.value}}function Xe(e,t){e.$options.props;for(var n in t)e[n]=null==t[n]?k:g(t[n],e)}function Qe(e,t){for(var n in t){var i=t[n];if(Array.isArray(i))for(var r=0;r<i.length;r++)Ze(e,n,i[r]);else Ze(e,n,i)}}function Ze(e,t,n,i){return c(n)&&(i=n,n=n.handler),"string"==typeof n&&(n=e[n]),e.$watch(t,n,i)}function et(e){var t=e.$options.provide;t&&(e._provided="function"==typeof t?t.call(e):t)}function tt(e){var t=nt(e.$options.inject,e);t&&(nr.shouldConvert=!1,Object.keys(t).forEach(function(n){N(e,n,t[n])}),nr.shouldConvert=!0)}function nt(e,t){if(e){for(var n=Object.create(null),i=qi?Reflect.ownKeys(e).filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}):Object.keys(e),r=0;r<i.length;r++){for(var a=i[r],o=e[a].from,s=t;s;){if(s._provided&&o in s._provided){n[a]=s._provided[o];break}s=s.$parent}if(!s&&"default"in e[a]){var l=e[a].default;n[a]="function"==typeof l?l.call(t):l}}return n}}function it(e,t){var n,i,a,o,s;if(Array.isArray(e)||"string"==typeof e)for(n=new Array(e.length),i=0,a=e.length;i<a;i++)n[i]=t(e[i],i);else if("number"==typeof e)for(n=new Array(e),i=0;i<e;i++)n[i]=t(i+1,i);else if(l(e))for(o=Object.keys(e),n=new Array(o.length),i=0,a=o.length;i<a;i++)s=o[i],n[i]=t(e[s],s,i);return r(n)&&(n._isVList=!0),n}function rt(e,t,n,i){var r,a=this.$scopedSlots[e];if(a)n=n||{},i&&(n=_(_({},i),n)),r=a(n)||t;else{var o=this.$slots[e];o&&(o._rendered=!0),r=o||t}var s=n&&n.slot;return s?this.$createElement("template",{slot:s},r):r}function at(e){return J(this.$options,"filters",e,!0)||ki}function ot(e,t,n,i){var r=Di.keyCodes[t]||n;return r?Array.isArray(r)?-1===r.indexOf(e):r!==e:i?_i(i)!==t:void 0}function st(e,t,n,i,r){if(n)if(l(n)){Array.isArray(n)&&(n=w(n));var a;for(var o in n)(function(o){if("class"===o||"style"===o||hi(o))a=e;else{var s=e.attrs&&e.attrs.type;a=i||Di.mustUseProp(t,s,o)?e.domProps||(e.domProps={}):e.attrs||(e.attrs={})}if(!(o in a)&&(a[o]=n[o],r)){(e.on||(e.on={}))["update:"+o]=function(e){n[o]=e}}})(o)}else;return e}function lt(e,t){var n=this._staticTrees||(this._staticTrees=[]),i=n[e];return i&&!t?Array.isArray(i)?F(i):B(i):(i=n[e]=this.$options.staticRenderFns[e].call(this._renderProxy,null,this),ut(i,"__static__"+e,!1),i)}function ct(e,t,n){return ut(e,"__once__"+t+(n?"_"+n:""),!0),e}function ut(e,t,n){if(Array.isArray(e))for(var i=0;i<e.length;i++)e[i]&&"string"!=typeof e[i]&&dt(e[i],t+"_"+i,n);else dt(e,t,n)}function dt(e,t,n){e.isStatic=!0,e.key=t,e.isOnce=n}function ft(e,t){if(t)if(c(t)){var n=e.on=e.on?_({},e.on):{};for(var i in t){var r=n[i],a=t[i];n[i]=r?[].concat(r,a):a}}else;return e}function pt(e){e._o=ct,e._n=p,e._s=f,e._l=it,e._t=rt,e._q=C,e._i=x,e._m=lt,e._f=at,e._k=ot,e._b=st,e._v=P,e._e=Qi,e._u=Oe,e._g=ft}function ht(e,t,n,i,r){var o=r.options;this.data=e,this.props=t,this.children=n,this.parent=i,this.listeners=e.on||fi,this.injections=nt(o.inject,i),this.slots=function(){return $e(n,i)};var s=Object.create(i),l=a(o._compiled),c=!l;l&&(this.$options=o,this.$slots=this.slots(),this.$scopedSlots=e.scopedSlots||fi),o._scopeId?this._c=function(e,t,n,r){var a=kt(s,e,t,n,r,c);return a&&(a.fnScopeId=o._scopeId,a.fnContext=i),a}:this._c=function(e,t,n,i){return kt(s,e,t,n,i,c)}}function vt(e,t,n,i,a){var o=e.options,s={},l=o.props;if(r(l))for(var c in l)s[c]=X(c,l,t||fi);else r(n.attrs)&&mt(s,n.attrs),r(n.props)&&mt(s,n.props);var u=new ht(n,s,a,i,e),d=o.render.call(null,u._c,u);return d instanceof Ji&&(d.fnContext=i,d.fnOptions=o,n.slot&&((d.data||(d.data={})).slot=n.slot)),d}function mt(e,t){for(var n in t)e[yi(n)]=t[n]}function yt(e,t,n,o,s){if(!i(e)){var c=n.$options._base;if(l(e)&&(e=c.extend(e)),"function"==typeof e){var u;if(i(e.cid)&&(u=e,void 0===(e=_e(u,c,n))))return be(u,t,n,o,s);t=t||{},$t(e),r(t.model)&&wt(e.options,t);var d=fe(t,e,s);if(a(e.options.functional))return vt(e,d,t,n,o);var f=t.on;if(t.on=t.nativeOn,a(e.options.abstract)){var p=t.slot;t={},p&&(t.slot=p)}bt(t);var h=e.options.name||s;return new Ji("vue-component-"+e.cid+(h?"-"+h:""),t,void 0,void 0,void 0,n,{Ctor:e,propsData:d,listeners:f,tag:s,children:o},u)}}}function gt(e,t,n,i){var a={_isComponent:!0,parent:t,_parentVnode:e,_parentElm:n||null,_refElm:i||null},o=e.data.inlineTemplate;return r(o)&&(a.render=o.render,a.staticRenderFns=o.staticRenderFns),new e.componentOptions.Ctor(a)}function bt(e){e.hook||(e.hook={});for(var t=0;t<Or.length;t++){var n=Or[t],i=e.hook[n],r=Ar[n];e.hook[n]=i?_t(r,i):r}}function _t(e,t){return function(n,i,r,a){e(n,i,r,a),t(n,i,r,a)}}function wt(e,t){var n=e.model&&e.model.prop||"value",i=e.model&&e.model.event||"input";(t.props||(t.props={}))[n]=t.model.value;var a=t.on||(t.on={});r(a[i])?a[i]=[t.model.callback].concat(a[i]):a[i]=t.model.callback}function kt(e,t,n,i,r,o){return(Array.isArray(n)||s(n))&&(r=i,i=n,n=void 0),a(o)&&(r=Mr),Ct(e,t,n,i,r)}function Ct(e,t,n,i,a){if(r(n)&&r(n.__ob__))return Qi();if(r(n)&&r(n.is)&&(t=n.is),!t)return Qi();Array.isArray(i)&&"function"==typeof i[0]&&(n=n||{},n.scopedSlots={default:i[0]},i.length=0),a===Mr?i=ve(i):a===Tr&&(i=he(i));var o,s;if("string"==typeof t){var l;s=e.$vnode&&e.$vnode.ns||Di.getTagNamespace(t),o=Di.isReservedTag(t)?new Ji(Di.parsePlatformTagName(t),n,i,void 0,void 0,e):r(l=J(e.$options,"components",t))?yt(l,n,e,i,t):new Ji(t,n,i,void 0,void 0,e)}else o=yt(t,n,e,i);return r(o)?(s&&xt(o,s),o):Qi()}function xt(e,t,n){if(e.ns=t,"foreignObject"===e.tag&&(t=void 0,n=!0),r(e.children))for(var o=0,s=e.children.length;o<s;o++){var l=e.children[o];r(l.tag)&&(i(l.ns)||a(n))&&xt(l,t,n)}}function St(e){e._vnode=null,e._staticTrees=null;var t=e.$options,n=e.$vnode=t._parentVnode,i=n&&n.context;e.$slots=$e(t._renderChildren,i),e.$scopedSlots=fi,e._c=function(t,n,i,r){return kt(e,t,n,i,r,!1)},e.$createElement=function(t,n,i,r){return kt(e,t,n,i,r,!0)};var r=n&&n.data;N(e,"$attrs",r&&r.attrs||fi,null,!0),N(e,"$listeners",t._parentListeners||fi,null,!0)}function Dt(e,t){var n=e.$options=Object.create(e.constructor.options),i=t._parentVnode;n.parent=t.parent,n._parentVnode=i,n._parentElm=t._parentElm,n._refElm=t._refElm;var r=i.componentOptions;n.propsData=r.propsData,n._parentListeners=r.listeners,n._renderChildren=r.children,n._componentTag=r.tag,t.render&&(n.render=t.render,n.staticRenderFns=t.staticRenderFns)}function $t(e){var t=e.options;if(e.super){var n=$t(e.super);if(n!==e.superOptions){e.superOptions=n;var i=At(e);i&&_(e.extendOptions,i),t=e.options=G(n,e.extendOptions),t.name&&(t.components[t.name]=e)}}return t}function At(e){var t,n=e.options,i=e.extendOptions,r=e.sealedOptions;for(var a in n)n[a]!==r[a]&&(t||(t={}),t[a]=Ot(n[a],i[a],r[a]));return t}function Ot(e,t,n){if(Array.isArray(e)){var i=[];n=Array.isArray(n)?n:[n],t=Array.isArray(t)?t:[t];for(var r=0;r<e.length;r++)(t.indexOf(e[r])>=0||n.indexOf(e[r])<0)&&i.push(e[r]);return i}return e}function Tt(e){this._init(e)}function Mt(e){e.use=function(e){var t=this._installedPlugins||(this._installedPlugins=[]);if(t.indexOf(e)>-1)return this;var n=b(arguments,1);return n.unshift(this),"function"==typeof e.install?e.install.apply(e,n):"function"==typeof e&&e.apply(null,n),t.push(e),this}}function Pt(e){e.mixin=function(e){return this.options=G(this.options,e),this}}function Bt(e){e.cid=0;var t=1;e.extend=function(e){e=e||{};var n=this,i=n.cid,r=e._Ctor||(e._Ctor={});if(r[i])return r[i];var a=e.name||n.options.name,o=function(e){this._init(e)};return o.prototype=Object.create(n.prototype),o.prototype.constructor=o,o.cid=t++,o.options=G(n.options,e),o.super=n,o.options.props&&Ft(o),o.options.computed&&Vt(o),o.extend=n.extend,o.mixin=n.mixin,o.use=n.use,xi.forEach(function(e){o[e]=n[e]}),a&&(o.options.components[a]=o),o.superOptions=n.options,o.extendOptions=e,o.sealedOptions=_({},o.options),r[i]=o,o}}function Ft(e){var t=e.options.props;for(var n in t)He(e.prototype,"_props",n)}function Vt(e){var t=e.options.computed;for(var n in t)Ge(e.prototype,n,t[n])}function It(e){xi.forEach(function(t){e[t]=function(e,n){return n?("component"===t&&c(n)&&(n.name=n.name||e,n=this.options._base.extend(n)),"directive"===t&&"function"==typeof n&&(n={bind:n,update:n}),this.options[t+"s"][e]=n,n):this.options[t+"s"][e]}})}function Et(e){return e&&(e.Ctor.options.name||e.tag)}function Nt(e,t){return Array.isArray(e)?e.indexOf(t)>-1:"string"==typeof e?e.split(",").indexOf(t)>-1:!!u(e)&&e.test(t)}function jt(e,t){var n=e.cache,i=e.keys,r=e._vnode;for(var a in n){var o=n[a];if(o){var s=Et(o.componentOptions);s&&!t(s)&&Rt(n,a,i,r)}}}function Rt(e,t,n,i){var r=e[t];!r||i&&r.tag===i.tag||r.componentInstance.$destroy(),e[t]=null,v(n,t)}function Lt(e){for(var t=e.data,n=e,i=e;r(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(t=zt(i.data,t));for(;r(n=n.parent);)n&&n.data&&(t=zt(t,n.data));return Ht(t.staticClass,t.class)}function zt(e,t){return{staticClass:Wt(e.staticClass,t.staticClass),class:r(e.class)?[e.class,t.class]:t.class}}function Ht(e,t){return r(e)||r(t)?Wt(e,qt(t)):""}function Wt(e,t){return e?t?e+" "+t:e:t||""}function qt(e){return Array.isArray(e)?Yt(e):l(e)?Ut(e):"string"==typeof e?e:""}function Yt(e){for(var t,n="",i=0,a=e.length;i<a;i++)r(t=qt(e[i]))&&""!==t&&(n&&(n+=" "),n+=t);return n}function Ut(e){var t="";for(var n in e)e[n]&&(t&&(t+=" "),t+=n);return t}function Kt(e){return Gr(e)?"svg":"math"===e?"math":void 0}function Gt(e){if(!Oi)return!0;if(Jr(e))return!1;if(e=e.toLowerCase(),null!=Xr[e])return Xr[e];var t=document.createElement(e);return e.indexOf("-")>-1?Xr[e]=t.constructor===window.HTMLUnknownElement||t.constructor===window.HTMLElement:Xr[e]=/HTMLUnknownElement/.test(t.toString())}function Jt(e){if("string"==typeof e){var t=document.querySelector(e);return t||document.createElement("div")}return e}function Xt(e,t){var n=document.createElement(e);return"select"!==e?n:(t.data&&t.data.attrs&&void 0!==t.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)}function Qt(e,t){return document.createElementNS(Ur[e],t)}function Zt(e){return document.createTextNode(e)}function en(e){return document.createComment(e)}function tn(e,t,n){e.insertBefore(t,n)}function nn(e,t){e.removeChild(t)}function rn(e,t){e.appendChild(t)}function an(e){return e.parentNode}function on(e){return e.nextSibling}function sn(e){return e.tagName}function ln(e,t){e.textContent=t}function cn(e,t,n){e.setAttribute(t,n)}function un(e,t){var n=e.data.ref;if(n){var i=e.context,r=e.componentInstance||e.elm,a=i.$refs;t?Array.isArray(a[n])?v(a[n],r):a[n]===r&&(a[n]=void 0):e.data.refInFor?Array.isArray(a[n])?a[n].indexOf(r)<0&&a[n].push(r):a[n]=[r]:a[n]=r}}function dn(e,t){return e.key===t.key&&(e.tag===t.tag&&e.isComment===t.isComment&&r(e.data)===r(t.data)&&fn(e,t)||a(e.isAsyncPlaceholder)&&e.asyncFactory===t.asyncFactory&&i(t.asyncFactory.error))}function fn(e,t){if("input"!==e.tag)return!0;var n,i=r(n=e.data)&&r(n=n.attrs)&&n.type,a=r(n=t.data)&&r(n=n.attrs)&&n.type;return i===a||Qr(i)&&Qr(a)}function pn(e,t,n){var i,a,o={};for(i=t;i<=n;++i)a=e[i].key,r(a)&&(o[a]=i);return o}function hn(e,t){(e.data.directives||t.data.directives)&&vn(e,t)}function vn(e,t){var n,i,r,a=e===ta,o=t===ta,s=mn(e.data.directives,e.context),l=mn(t.data.directives,t.context),c=[],u=[];for(n in l)i=s[n],r=l[n],i?(r.oldValue=i.value,gn(r,"update",t,e),r.def&&r.def.componentUpdated&&u.push(r)):(gn(r,"bind",t,e),r.def&&r.def.inserted&&c.push(r));if(c.length){var d=function(){for(var n=0;n<c.length;n++)gn(c[n],"inserted",t,e)};a?de(t,"insert",d):d()}if(u.length&&de(t,"postpatch",function(){for(var n=0;n<u.length;n++)gn(u[n],"componentUpdated",t,e)}),!a)for(n in s)l[n]||gn(s[n],"unbind",e,e,o)}function mn(e,t){var n=Object.create(null);if(!e)return n;var i,r;for(i=0;i<e.length;i++)r=e[i],r.modifiers||(r.modifiers=ra),n[yn(r)]=r,r.def=J(t.$options,"directives",r.name,!0);return n}function yn(e){return e.rawName||e.name+"."+Object.keys(e.modifiers||{}).join(".")}function gn(e,t,n,i,r){var a=e.def&&e.def[t];if(a)try{a(n.elm,e,n,i,r)}catch(i){te(i,n.context,"directive "+e.name+" "+t+" hook")}}function bn(e,t){var n=t.componentOptions;if(!(r(n)&&!1===n.Ctor.options.inheritAttrs||i(e.data.attrs)&&i(t.data.attrs))){var a,o,s=t.elm,l=e.data.attrs||{},c=t.data.attrs||{};r(c.__ob__)&&(c=t.data.attrs=_({},c));for(a in c)o=c[a],l[a]!==o&&_n(s,a,o);(Bi||Vi)&&c.value!==l.value&&_n(s,"value",c.value);for(a in l)i(c[a])&&(Wr(a)?s.removeAttributeNS(Hr,qr(a)):Lr(a)||s.removeAttribute(a))}}function _n(e,t,n){if(zr(t))Yr(n)?e.removeAttribute(t):(n="allowfullscreen"===t&&"EMBED"===e.tagName?"true":t,e.setAttribute(t,n));else if(Lr(t))e.setAttribute(t,Yr(n)||"false"===n?"false":"true");else if(Wr(t))Yr(n)?e.removeAttributeNS(Hr,qr(t)):e.setAttributeNS(Hr,t,n);else if(Yr(n))e.removeAttribute(t);else{if(Bi&&!Fi&&"TEXTAREA"===e.tagName&&"placeholder"===t&&!e.__ieph){var i=function(t){t.stopImmediatePropagation(),e.removeEventListener("input",i)};e.addEventListener("input",i),e.__ieph=!0}e.setAttribute(t,n)}}function wn(e,t){var n=t.elm,a=t.data,o=e.data;if(!(i(a.staticClass)&&i(a.class)&&(i(o)||i(o.staticClass)&&i(o.class)))){var s=Lt(t),l=n._transitionClasses;r(l)&&(s=Wt(s,qt(l))),s!==n._prevClass&&(n.setAttribute("class",s),n._prevClass=s)}}function kn(e){if(r(e[la])){var t=Bi?"change":"input";e[t]=[].concat(e[la],e[t]||[]),delete e[la]}r(e[ca])&&(e.change=[].concat(e[ca],e.change||[]),delete e[ca])}function Cn(e,t,n){var i=Ir;return function r(){null!==e.apply(null,arguments)&&Sn(t,r,n,i)}}function xn(e,t,n,i,r){t=ae(t),n&&(t=Cn(t,e,i)),Ir.addEventListener(e,t,ji?{capture:i,passive:r}:i)}function Sn(e,t,n,i){(i||Ir).removeEventListener(e,t._withTask||t,n)}function Dn(e,t){if(!i(e.data.on)||!i(t.data.on)){var n=t.data.on||{},r=e.data.on||{};Ir=t.elm,kn(n),ue(n,r,xn,Sn,t.context),Ir=void 0}}function $n(e,t){if(!i(e.data.domProps)||!i(t.data.domProps)){var n,a,o=t.elm,s=e.data.domProps||{},l=t.data.domProps||{};r(l.__ob__)&&(l=t.data.domProps=_({},l));for(n in s)i(l[n])&&(o[n]="");for(n in l){if(a=l[n],"textContent"===n||"innerHTML"===n){if(t.children&&(t.children.length=0),a===s[n])continue;1===o.childNodes.length&&o.removeChild(o.childNodes[0])}if("value"===n){o._value=a;var c=i(a)?"":String(a);An(o,c)&&(o.value=c)}else o[n]=a}}}function An(e,t){return!e.composing&&("OPTION"===e.tagName||On(e,t)||Tn(e,t))}function On(e,t){var n=!0;try{n=document.activeElement!==e}catch(e){}return n&&e.value!==t}function Tn(e,t){var n=e.value,i=e._vModifiers;if(r(i)){if(i.lazy)return!1;if(i.number)return p(n)!==p(t);if(i.trim)return n.trim()!==t.trim()}return n!==t}function Mn(e){var t=Pn(e.style);return e.staticStyle?_(e.staticStyle,t):t}function Pn(e){return Array.isArray(e)?w(e):"string"==typeof e?fa(e):e}function Bn(e,t){var n,i={};if(t)for(var r=e;r.componentInstance;)(r=r.componentInstance._vnode)&&r.data&&(n=Mn(r.data))&&_(i,n);(n=Mn(e.data))&&_(i,n);for(var a=e;a=a.parent;)a.data&&(n=Mn(a.data))&&_(i,n);return i}function Fn(e,t){var n=t.data,a=e.data;if(!(i(n.staticStyle)&&i(n.style)&&i(a.staticStyle)&&i(a.style))){var o,s,l=t.elm,c=a.staticStyle,u=a.normalizedStyle||a.style||{},d=c||u,f=Pn(t.data.style)||{};t.data.normalizedStyle=r(f.__ob__)?_({},f):f;var p=Bn(t,!0);for(s in d)i(p[s])&&va(l,s,"");for(s in p)(o=p[s])!==d[s]&&va(l,s,null==o?"":o)}}function Vn(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(/\s+/).forEach(function(t){return e.classList.add(t)}):e.classList.add(t);else{var n=" "+(e.getAttribute("class")||"")+" ";n.indexOf(" "+t+" ")<0&&e.setAttribute("class",(n+t).trim())}}function In(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(/\s+/).forEach(function(t){return e.classList.remove(t)}):e.classList.remove(t),e.classList.length||e.removeAttribute("class");else{for(var n=" "+(e.getAttribute("class")||"")+" ",i=" "+t+" ";n.indexOf(i)>=0;)n=n.replace(i," ");n=n.trim(),n?e.setAttribute("class",n):e.removeAttribute("class")}}function En(e){if(e){if("object"==typeof e){var t={};return!1!==e.css&&_(t,ba(e.name||"v")),_(t,e),t}return"string"==typeof e?ba(e):void 0}}function Nn(e){$a(function(){$a(e)})}function jn(e,t){var n=e._transitionClasses||(e._transitionClasses=[]);n.indexOf(t)<0&&(n.push(t),Vn(e,t))}function Rn(e,t){e._transitionClasses&&v(e._transitionClasses,t),In(e,t)}function Ln(e,t,n){var i=zn(e,t),r=i.type,a=i.timeout,o=i.propCount;if(!r)return n();var s=r===wa?xa:Da,l=0,c=function(){e.removeEventListener(s,u),n()},u=function(t){t.target===e&&++l>=o&&c()};setTimeout(function(){l<o&&c()},a+1),e.addEventListener(s,u)}function zn(e,t){var n,i=window.getComputedStyle(e),r=i[Ca+"Delay"].split(", "),a=i[Ca+"Duration"].split(", "),o=Hn(r,a),s=i[Sa+"Delay"].split(", "),l=i[Sa+"Duration"].split(", "),c=Hn(s,l),u=0,d=0;return t===wa?o>0&&(n=wa,u=o,d=a.length):t===ka?c>0&&(n=ka,u=c,d=l.length):(u=Math.max(o,c),n=u>0?o>c?wa:ka:null,d=n?n===wa?a.length:l.length:0),{type:n,timeout:u,propCount:d,hasTransform:n===wa&&Aa.test(i[Ca+"Property"])}}function Hn(e,t){for(;e.length<t.length;)e=e.concat(e);return Math.max.apply(null,t.map(function(t,n){return Wn(t)+Wn(e[n])}))}function Wn(e){return 1e3*Number(e.slice(0,-1))}function qn(e,t){var n=e.elm;r(n._leaveCb)&&(n._leaveCb.cancelled=!0,n._leaveCb());var a=En(e.data.transition);if(!i(a)&&!r(n._enterCb)&&1===n.nodeType){for(var o=a.css,s=a.type,c=a.enterClass,u=a.enterToClass,d=a.enterActiveClass,f=a.appearClass,h=a.appearToClass,v=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,b=a.enterCancelled,_=a.beforeAppear,w=a.appear,k=a.afterAppear,C=a.appearCancelled,x=a.duration,D=yr,$=yr.$vnode;$&&$.parent;)$=$.parent,D=$.context;var A=!D._isMounted||!e.isRootInsert;if(!A||w||""===w){var O=A&&f?f:c,T=A&&v?v:d,M=A&&h?h:u,P=A?_||m:m,B=A&&"function"==typeof w?w:y,F=A?k||g:g,V=A?C||b:b,I=p(l(x)?x.enter:x),E=!1!==o&&!Fi,N=Kn(B),j=n._enterCb=S(function(){E&&(Rn(n,M),Rn(n,T)),j.cancelled?(E&&Rn(n,O),V&&V(n)):F&&F(n),n._enterCb=null});e.data.show||de(e,"insert",function(){var t=n.parentNode,i=t&&t._pending&&t._pending[e.key];i&&i.tag===e.tag&&i.elm._leaveCb&&i.elm._leaveCb(),B&&B(n,j)}),P&&P(n),E&&(jn(n,O),jn(n,T),Nn(function(){jn(n,M),Rn(n,O),j.cancelled||N||(Un(I)?setTimeout(j,I):Ln(n,s,j))})),e.data.show&&(t&&t(),B&&B(n,j)),E||N||j()}}}function Yn(e,t){function n(){C.cancelled||(e.data.show||((a.parentNode._pending||(a.parentNode._pending={}))[e.key]=e),h&&h(a),_&&(jn(a,u),jn(a,f),Nn(function(){jn(a,d),Rn(a,u),C.cancelled||w||(Un(k)?setTimeout(C,k):Ln(a,c,C))})),v&&v(a,C),_||w||C())}var a=e.elm;r(a._enterCb)&&(a._enterCb.cancelled=!0,a._enterCb());var o=En(e.data.transition);if(i(o)||1!==a.nodeType)return t();if(!r(a._leaveCb)){var s=o.css,c=o.type,u=o.leaveClass,d=o.leaveToClass,f=o.leaveActiveClass,h=o.beforeLeave,v=o.leave,m=o.afterLeave,y=o.leaveCancelled,g=o.delayLeave,b=o.duration,_=!1!==s&&!Fi,w=Kn(v),k=p(l(b)?b.leave:b),C=a._leaveCb=S(function(){a.parentNode&&a.parentNode._pending&&(a.parentNode._pending[e.key]=null),_&&(Rn(a,d),Rn(a,f)),C.cancelled?(_&&Rn(a,u),y&&y(a)):(t(),m&&m(a)),a._leaveCb=null});g?g(n):n()}}function Un(e){return"number"==typeof e&&!isNaN(e)}function Kn(e){if(i(e))return!1;var t=e.fns;return r(t)?Kn(Array.isArray(t)?t[0]:t):(e._length||e.length)>1}function Gn(e,t){!0!==t.data.show&&qn(t)}function Jn(e,t,n){Xn(e,t,n),(Bi||Vi)&&setTimeout(function(){Xn(e,t,n)},0)}function Xn(e,t,n){var i=t.value,r=e.multiple;if(!r||Array.isArray(i)){for(var a,o,s=0,l=e.options.length;s<l;s++)if(o=e.options[s],r)a=x(i,Zn(o))>-1,o.selected!==a&&(o.selected=a);else if(C(Zn(o),i))return void(e.selectedIndex!==s&&(e.selectedIndex=s));r||(e.selectedIndex=-1)}}function Qn(e,t){return t.every(function(t){return!C(t,e)})}function Zn(e){return"_value"in e?e._value:e.value}function ei(e){e.target.composing=!0}function ti(e){e.target.composing&&(e.target.composing=!1,ni(e.target,"input"))}function ni(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!0,!0),e.dispatchEvent(n)}function ii(e){return!e.componentInstance||e.data&&e.data.transition?e:ii(e.componentInstance._vnode)}function ri(e){var t=e&&e.componentOptions;return t&&t.Ctor.options.abstract?ri(ke(t.children)):e}function ai(e){var t={},n=e.$options;for(var i in n.propsData)t[i]=e[i];var r=n._parentListeners;for(var a in r)t[yi(a)]=r[a];return t}function oi(e,t){if(/\d-keep-alive$/.test(t.tag))return e("keep-alive",{props:t.componentOptions.propsData})}function si(e){for(;e=e.parent;)if(e.data.transition)return!0}function li(e,t){return t.key===e.key&&t.tag===e.tag}function ci(e){e.elm._moveCb&&e.elm._moveCb(),e.elm._enterCb&&e.elm._enterCb()}function ui(e){e.data.newPos=e.elm.getBoundingClientRect()}function di(e){var t=e.data.pos,n=e.data.newPos,i=t.left-n.left,r=t.top-n.top;if(i||r){e.data.moved=!0;var a=e.elm.style;a.transform=a.WebkitTransform="translate("+i+"px,"+r+"px)",a.transitionDuration="0s"}}var fi=Object.freeze({}),pi=Object.prototype.toString,hi=(h("slot,component",!0),h("key,ref,slot,slot-scope,is")),vi=Object.prototype.hasOwnProperty,mi=/-(\w)/g,yi=y(function(e){return e.replace(mi,function(e,t){return t?t.toUpperCase():""})}),gi=y(function(e){return e.charAt(0).toUpperCase()+e.slice(1)}),bi=/\B([A-Z])/g,_i=y(function(e){return e.replace(bi,"-$1").toLowerCase()}),wi=function(e,t,n){return!1},ki=function(e){return e},Ci="data-server-rendered",xi=["component","directive","filter"],Si=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured"],Di={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:wi,isReservedAttr:wi,isUnknownElement:wi,getTagNamespace:k,parsePlatformTagName:ki,mustUseProp:wi,_lifecycleHooks:Si},$i=/[^\w.$]/,Ai="__proto__"in{},Oi="undefined"!=typeof window,Ti="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,Mi=Ti&&WXEnvironment.platform.toLowerCase(),Pi=Oi&&window.navigator.userAgent.toLowerCase(),Bi=Pi&&/msie|trident/.test(Pi),Fi=Pi&&Pi.indexOf("msie 9.0")>0,Vi=Pi&&Pi.indexOf("edge/")>0,Ii=Pi&&Pi.indexOf("android")>0||"android"===Mi,Ei=Pi&&/iphone|ipad|ipod|ios/.test(Pi)||"ios"===Mi,Ni=(Pi&&/chrome\/\d+/.test(Pi),{}.watch),ji=!1;if(Oi)try{var Ri={};Object.defineProperty(Ri,"passive",{get:function(){ji=!0}}),window.addEventListener("test-passive",null,Ri)}catch(e){}var Li,zi,Hi=function(){return void 0===Li&&(Li=!Oi&&void 0!==e&&"server"===e.process.env.VUE_ENV),Li},Wi=Oi&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__,qi="undefined"!=typeof Symbol&&O(Symbol)&&"undefined"!=typeof Reflect&&O(Reflect.ownKeys);zi="undefined"!=typeof Set&&O(Set)?Set:function(){function e(){this.set=Object.create(null)}return e.prototype.has=function(e){return!0===this.set[e]},e.prototype.add=function(e){this.set[e]=!0},e.prototype.clear=function(){this.set=Object.create(null)},e}();var Yi=k,Ui=0,Ki=function(){this.id=Ui++,this.subs=[]};Ki.prototype.addSub=function(e){this.subs.push(e)},Ki.prototype.removeSub=function(e){v(this.subs,e)},Ki.prototype.depend=function(){Ki.target&&Ki.target.addDep(this)},Ki.prototype.notify=function(){for(var e=this.subs.slice(),t=0,n=e.length;t<n;t++)e[t].update()},Ki.target=null;var Gi=[],Ji=function(e,t,n,i,r,a,o,s){this.tag=e,this.data=t,this.children=n,this.text=i,this.elm=r,this.ns=void 0,this.context=a,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=t&&t.key,this.componentOptions=o,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},Xi={child:{configurable:!0}};Xi.child.get=function(){return this.componentInstance},Object.defineProperties(Ji.prototype,Xi);var Qi=function(e){void 0===e&&(e="");var t=new Ji;return t.text=e,t.isComment=!0,t},Zi=Array.prototype,er=Object.create(Zi);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(e){var t=Zi[e];$(er,e,function(){for(var n=[],i=arguments.length;i--;)n[i]=arguments[i];var r,a=t.apply(this,n),o=this.__ob__;switch(e){case"push":case"unshift":r=n;break;case"splice":r=n.slice(2)}return r&&o.observeArray(r),o.dep.notify(),a})});var tr=Object.getOwnPropertyNames(er),nr={shouldConvert:!0},ir=function(e){if(this.value=e,this.dep=new Ki,this.vmCount=0,$(e,"__ob__",this),Array.isArray(e)){(Ai?V:I)(e,er,tr),this.observeArray(e)}else this.walk(e)};ir.prototype.walk=function(e){for(var t=Object.keys(e),n=0;n<t.length;n++)N(e,t[n],e[t[n]])},ir.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)E(e[t])};var rr=Di.optionMergeStrategies;rr.data=function(e,t,n){return n?H(e,t,n):t&&"function"!=typeof t?e:H(e,t)},Si.forEach(function(e){rr[e]=W}),xi.forEach(function(e){rr[e+"s"]=q}),rr.watch=function(e,t,n,i){if(e===Ni&&(e=void 0),t===Ni&&(t=void 0),!t)return Object.create(e||null);if(!e)return t;var r={};_(r,e);for(var a in t){var o=r[a],s=t[a];o&&!Array.isArray(o)&&(o=[o]),r[a]=o?o.concat(s):Array.isArray(s)?s:[s]}return r},rr.props=rr.methods=rr.inject=rr.computed=function(e,t,n,i){if(!e)return t;var r=Object.create(null);return _(r,e),t&&_(r,t),r},rr.provide=H;var ar,or,sr=function(e,t){return void 0===t?e:t},lr=[],cr=!1,ur=!1;if(void 0!==n&&O(n))or=function(){n(re)};else if("undefined"==typeof MessageChannel||!O(MessageChannel)&&"[object MessageChannelConstructor]"!==MessageChannel.toString())or=function(){setTimeout(re,0)};else{var dr=new MessageChannel,fr=dr.port2;dr.port1.onmessage=re,or=function(){fr.postMessage(1)}}if("undefined"!=typeof Promise&&O(Promise)){var pr=Promise.resolve();ar=function(){pr.then(re),Ei&&setTimeout(k)}}else ar=or;var hr,vr=new zi,mr=y(function(e){var t="&"===e.charAt(0);e=t?e.slice(1):e;var n="~"===e.charAt(0);e=n?e.slice(1):e;var i="!"===e.charAt(0);return e=i?e.slice(1):e,{name:e,once:n,capture:i,passive:t}}),yr=null,gr=[],br=[],_r={},wr=!1,kr=!1,Cr=0,xr=0,Sr=function(e,t,n,i,r){this.vm=e,r&&(e._watcher=this),e._watchers.push(this),i?(this.deep=!!i.deep,this.user=!!i.user,this.lazy=!!i.lazy,this.sync=!!i.sync):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++xr,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new zi,this.newDepIds=new zi,this.expression="","function"==typeof t?this.getter=t:(this.getter=A(t),this.getter||(this.getter=function(){})),this.value=this.lazy?void 0:this.get()};Sr.prototype.get=function(){T(this);var e,t=this.vm;try{e=this.getter.call(t,t)}catch(e){if(!this.user)throw e;te(e,t,'getter for watcher "'+this.expression+'"')}finally{this.deep&&se(e),M(),this.cleanupDeps()}return e},Sr.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},Sr.prototype.cleanupDeps=function(){for(var e=this,t=this.deps.length;t--;){var n=e.deps[t];e.newDepIds.has(n.id)||n.removeSub(e)}var i=this.depIds;this.depIds=this.newDepIds,this.newDepIds=i,this.newDepIds.clear(),i=this.deps,this.deps=this.newDeps,this.newDeps=i,this.newDeps.length=0},Sr.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():ze(this)},Sr.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||l(e)||this.deep){var t=this.value;if(this.value=e,this.user)try{this.cb.call(this.vm,e,t)}catch(e){te(e,this.vm,'callback for watcher "'+this.expression+'"')}else this.cb.call(this.vm,e,t)}}},Sr.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},Sr.prototype.depend=function(){for(var e=this,t=this.deps.length;t--;)e.deps[t].depend()},Sr.prototype.teardown=function(){var e=this;if(this.active){this.vm._isBeingDestroyed||v(this.vm._watchers,this);for(var t=this.deps.length;t--;)e.deps[t].removeSub(e);this.active=!1}};var Dr={enumerable:!0,configurable:!0,get:k,set:k},$r={lazy:!0};pt(ht.prototype);var Ar={init:function(e,t,n,i){if(!e.componentInstance||e.componentInstance._isDestroyed){(e.componentInstance=gt(e,yr,n,i)).$mount(t?e.elm:void 0,t)}else if(e.data.keepAlive){var r=e;Ar.prepatch(r,r)}},prepatch:function(e,t){var n=t.componentOptions;Pe(t.componentInstance=e.componentInstance,n.propsData,n.listeners,t,n.children)},insert:function(e){var t=e.context,n=e.componentInstance;n._isMounted||(n._isMounted=!0,Ie(n,"mounted")),e.data.keepAlive&&(t._isMounted?Re(n):Fe(n,!0))},destroy:function(e){var t=e.componentInstance;t._isDestroyed||(e.data.keepAlive?Ve(t,!0):t.$destroy())}},Or=Object.keys(Ar),Tr=1,Mr=2,Pr=0;(function(e){e.prototype._init=function(e){var t=this;t._uid=Pr++;t._isVue=!0,e&&e._isComponent?Dt(t,e):t.$options=G($t(t.constructor),e||{},t),t._renderProxy=t,t._self=t,Te(t),Ce(t),St(t),Ie(t,"beforeCreate"),tt(t),We(t),et(t),Ie(t,"created"),t.$options.el&&t.$mount(t.$options.el)}})(Tt),function(e){var t={};t.get=function(){return this._data};var n={};n.get=function(){return this._props},Object.defineProperty(e.prototype,"$data",t),Object.defineProperty(e.prototype,"$props",n),e.prototype.$set=j,e.prototype.$delete=R,e.prototype.$watch=function(e,t,n){var i=this;if(c(t))return Ze(i,e,t,n);n=n||{},n.user=!0;var r=new Sr(i,e,t,n);return n.immediate&&t.call(i,r.value),function(){r.teardown()}}}(Tt),function(e){var t=/^hook:/;e.prototype.$on=function(e,n){var i=this,r=this;if(Array.isArray(e))for(var a=0,o=e.length;a<o;a++)i.$on(e[a],n);else(r._events[e]||(r._events[e]=[])).push(n),t.test(e)&&(r._hasHookEvent=!0);return r},e.prototype.$once=function(e,t){function n(){i.$off(e,n),t.apply(i,arguments)}var i=this;return n.fn=t,i.$on(e,n),i},e.prototype.$off=function(e,t){var n=this,i=this;if(!arguments.length)return i._events=Object.create(null),i;if(Array.isArray(e)){for(var r=0,a=e.length;r<a;r++)n.$off(e[r],t);return i}var o=i._events[e];if(!o)return i;if(!t)return i._events[e]=null,i;if(t)for(var s,l=o.length;l--;)if((s=o[l])===t||s.fn===t){o.splice(l,1);break}return i},e.prototype.$emit=function(e){var t=this,n=t._events[e];if(n){n=n.length>1?b(n):n;for(var i=b(arguments,1),r=0,a=n.length;r<a;r++)try{n[r].apply(t,i)}catch(n){te(n,t,'event handler for "'+e+'"')}}return t}}(Tt),function(e){e.prototype._update=function(e,t){var n=this;n._isMounted&&Ie(n,"beforeUpdate");var i=n.$el,r=n._vnode,a=yr;yr=n,n._vnode=e,r?n.$el=n.__patch__(r,e):(n.$el=n.__patch__(n.$el,e,t,!1,n.$options._parentElm,n.$options._refElm),n.$options._parentElm=n.$options._refElm=null),yr=a,i&&(i.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},e.prototype.$forceUpdate=function(){var e=this;e._watcher&&e._watcher.update()},e.prototype.$destroy=function(){var e=this;if(!e._isBeingDestroyed){Ie(e,"beforeDestroy"),e._isBeingDestroyed=!0;var t=e.$parent;!t||t._isBeingDestroyed||e.$options.abstract||v(t.$children,e),e._watcher&&e._watcher.teardown();for(var n=e._watchers.length;n--;)e._watchers[n].teardown();e._data.__ob__&&e._data.__ob__.vmCount--,e._isDestroyed=!0,e.__patch__(e._vnode,null),Ie(e,"destroyed"),e.$off(),e.$el&&(e.$el.__vue__=null),e.$vnode&&(e.$vnode.parent=null)}}}(Tt),function(e){pt(e.prototype),e.prototype.$nextTick=function(e){return oe(e,this)},e.prototype._render=function(){var e=this,t=e.$options,n=t.render,i=t._parentVnode;if(e._isMounted)for(var r in e.$slots){var a=e.$slots[r];(a._rendered||a[0]&&a[0].elm)&&(e.$slots[r]=F(a,!0))}e.$scopedSlots=i&&i.data.scopedSlots||fi,e.$vnode=i;var o;try{o=n.call(e._renderProxy,e.$createElement)}catch(t){te(t,e,"render"),o=e._vnode}return o instanceof Ji||(o=Qi()),o.parent=i,o}}(Tt);var Br=[String,RegExp,Array],Fr={name:"keep-alive",abstract:!0,props:{include:Br,exclude:Br,max:[String,Number]},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){var e=this;for(var t in e.cache)Rt(e.cache,t,e.keys)},watch:{include:function(e){jt(this,function(t){return Nt(e,t)})},exclude:function(e){jt(this,function(t){return!Nt(e,t)})}},render:function(){var e=this.$slots.default,t=ke(e),n=t&&t.componentOptions;if(n){var i=Et(n),r=this,a=r.include,o=r.exclude;if(a&&(!i||!Nt(a,i))||o&&i&&Nt(o,i))return t;var s=this,l=s.cache,c=s.keys,u=null==t.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):t.key;l[u]?(t.componentInstance=l[u].componentInstance,v(c,u),c.push(u)):(l[u]=t,c.push(u),this.max&&c.length>parseInt(this.max)&&Rt(l,c[0],c,this._vnode)),t.data.keepAlive=!0}return t||e&&e[0]}},Vr={KeepAlive:Fr};(function(e){var t={};t.get=function(){return Di},Object.defineProperty(e,"config",t),e.util={warn:Yi,extend:_,mergeOptions:G,defineReactive:N},e.set=j,e.delete=R,e.nextTick=oe,e.options=Object.create(null),xi.forEach(function(t){e.options[t+"s"]=Object.create(null)}),e.options._base=e,_(e.options.components,Vr),Mt(e),Pt(e),Bt(e),It(e)})(Tt),Object.defineProperty(Tt.prototype,"$isServer",{get:Hi}),Object.defineProperty(Tt.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Tt.version="2.5.13";var Ir,Er,Nr=h("style,class"),jr=h("input,textarea,option,select,progress"),Rr=function(e,t,n){return"value"===n&&jr(e)&&"button"!==t||"selected"===n&&"option"===e||"checked"===n&&"input"===e||"muted"===n&&"video"===e},Lr=h("contenteditable,draggable,spellcheck"),zr=h("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),Hr="http://www.w3.org/1999/xlink",Wr=function(e){return":"===e.charAt(5)&&"xlink"===e.slice(0,5)},qr=function(e){return Wr(e)?e.slice(6,e.length):""},Yr=function(e){return null==e||!1===e},Ur={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Kr=h("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),Gr=h("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Jr=function(e){return Kr(e)||Gr(e)},Xr=Object.create(null),Qr=h("text,number,password,search,email,tel,url"),Zr=Object.freeze({createElement:Xt,createElementNS:Qt,createTextNode:Zt,createComment:en,insertBefore:tn,removeChild:nn,appendChild:rn,parentNode:an,nextSibling:on,tagName:sn,setTextContent:ln,setAttribute:cn}),ea={create:function(e,t){un(t)},update:function(e,t){e.data.ref!==t.data.ref&&(un(e,!0),un(t))},destroy:function(e){un(e,!0)}},ta=new Ji("",{},[]),na=["create","activate","update","remove","destroy"],ia={create:hn,update:hn,destroy:function(e){hn(e,ta)}},ra=Object.create(null),aa=[ea,ia],oa={create:bn,update:bn},sa={create:wn,update:wn},la="__r",ca="__c",ua={create:Dn,update:Dn},da={create:$n,update:$n},fa=y(function(e){var t={},n=/;(?![^(]*\))/g,i=/:(.+)/;return e.split(n).forEach(function(e){if(e){var n=e.split(i);n.length>1&&(t[n[0].trim()]=n[1].trim())}}),t}),pa=/^--/,ha=/\s*!important$/,va=function(e,t,n){if(pa.test(t))e.style.setProperty(t,n);else if(ha.test(n))e.style.setProperty(t,n.replace(ha,""),"important");else{var i=ya(t);if(Array.isArray(n))for(var r=0,a=n.length;r<a;r++)e.style[i]=n[r];else e.style[i]=n}},ma=["Webkit","Moz","ms"],ya=y(function(e){if(Er=Er||document.createElement("div").style,"filter"!==(e=yi(e))&&e in Er)return e;for(var t=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<ma.length;n++){var i=ma[n]+t;if(i in Er)return i}}),ga={create:Fn,update:Fn},ba=y(function(e){return{enterClass:e+"-enter",enterToClass:e+"-enter-to",enterActiveClass:e+"-enter-active",leaveClass:e+"-leave",leaveToClass:e+"-leave-to",leaveActiveClass:e+"-leave-active"}}),_a=Oi&&!Fi,wa="transition",ka="animation",Ca="transition",xa="transitionend",Sa="animation",Da="animationend";_a&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(Ca="WebkitTransition",xa="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Sa="WebkitAnimation",Da="webkitAnimationEnd"));var $a=Oi?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(e){return e()},Aa=/\b(transform|all)(,|$)/,Oa=Oi?{create:Gn,activate:Gn,remove:function(e,t){!0!==e.data.show?Yn(e,t):t()}}:{},Ta=[oa,sa,ua,da,ga,Oa],Ma=Ta.concat(aa),Pa=function(e){function t(e){return new Ji(M.tagName(e).toLowerCase(),{},[],void 0,e)}function n(e,t){function n(){0==--n.listeners&&o(e)}return n.listeners=t,n}function o(e){var t=M.parentNode(e);r(t)&&M.removeChild(t,e)}function l(e,t,n,i,o){if(e.isRootInsert=!o,!c(e,t,n,i)){var s=e.data,l=e.children,u=e.tag;r(u)?(e.elm=e.ns?M.createElementNS(e.ns,u):M.createElement(u,e),y(e),p(e,l,t),r(s)&&m(e,t),f(n,e.elm,i)):a(e.isComment)?(e.elm=M.createComment(e.text),f(n,e.elm,i)):(e.elm=M.createTextNode(e.text),f(n,e.elm,i))}}function c(e,t,n,i){var o=e.data;if(r(o)){var s=r(e.componentInstance)&&o.keepAlive;if(r(o=o.hook)&&r(o=o.init)&&o(e,!1,n,i),r(e.componentInstance))return u(e,t),a(s)&&d(e,t,n,i),!0}}function u(e,t){r(e.data.pendingInsert)&&(t.push.apply(t,e.data.pendingInsert),e.data.pendingInsert=null),e.elm=e.componentInstance.$el,v(e)?(m(e,t),y(e)):(un(e),t.push(e))}function d(e,t,n,i){for(var a,o=e;o.componentInstance;)if(o=o.componentInstance._vnode,r(a=o.data)&&r(a=a.transition)){for(a=0;a<O.activate.length;++a)O.activate[a](ta,o);t.push(o);break}f(n,e.elm,i)}function f(e,t,n){r(e)&&(r(n)?n.parentNode===e&&M.insertBefore(e,t,n):M.appendChild(e,t))}function p(e,t,n){if(Array.isArray(t))for(var i=0;i<t.length;++i)l(t[i],n,e.elm,null,!0);else s(e.text)&&M.appendChild(e.elm,M.createTextNode(String(e.text)))}function v(e){for(;e.componentInstance;)e=e.componentInstance._vnode;return r(e.tag)}function m(e,t){for(var n=0;n<O.create.length;++n)O.create[n](ta,e);$=e.data.hook,r($)&&(r($.create)&&$.create(ta,e),r($.insert)&&t.push(e))}function y(e){var t;if(r(t=e.fnScopeId))M.setAttribute(e.elm,t,"");else for(var n=e;n;)r(t=n.context)&&r(t=t.$options._scopeId)&&M.setAttribute(e.elm,t,""),n=n.parent;r(t=yr)&&t!==e.context&&t!==e.fnContext&&r(t=t.$options._scopeId)&&M.setAttribute(e.elm,t,"")}function g(e,t,n,i,r,a){for(;i<=r;++i)l(n[i],a,e,t)}function b(e){var t,n,i=e.data;if(r(i))for(r(t=i.hook)&&r(t=t.destroy)&&t(e),t=0;t<O.destroy.length;++t)O.destroy[t](e);if(r(t=e.children))for(n=0;n<e.children.length;++n)b(e.children[n])}function _(e,t,n,i){for(;n<=i;++n){var a=t[n];r(a)&&(r(a.tag)?(w(a),b(a)):o(a.elm))}}function w(e,t){if(r(t)||r(e.data)){var i,a=O.remove.length+1;for(r(t)?t.listeners+=a:t=n(e.elm,a),r(i=e.componentInstance)&&r(i=i._vnode)&&r(i.data)&&w(i,t),i=0;i<O.remove.length;++i)O.remove[i](e,t);r(i=e.data.hook)&&r(i=i.remove)?i(e,t):t()}else o(e.elm)}function k(e,t,n,a,o){for(var s,c,u,d,f=0,p=0,h=t.length-1,v=t[0],m=t[h],y=n.length-1,b=n[0],w=n[y],k=!o;f<=h&&p<=y;)i(v)?v=t[++f]:i(m)?m=t[--h]:dn(v,b)?(x(v,b,a),v=t[++f],b=n[++p]):dn(m,w)?(x(m,w,a),m=t[--h],w=n[--y]):dn(v,w)?(x(v,w,a),k&&M.insertBefore(e,v.elm,M.nextSibling(m.elm)),v=t[++f],w=n[--y]):dn(m,b)?(x(m,b,a),k&&M.insertBefore(e,m.elm,v.elm),m=t[--h],b=n[++p]):(i(s)&&(s=pn(t,f,h)),c=r(b.key)?s[b.key]:C(b,t,f,h),i(c)?l(b,a,e,v.elm):(u=t[c],dn(u,b)?(x(u,b,a),t[c]=void 0,k&&M.insertBefore(e,u.elm,v.elm)):l(b,a,e,v.elm)),b=n[++p]);f>h?(d=i(n[y+1])?null:n[y+1].elm,g(e,d,n,p,y,a)):p>y&&_(e,t,f,h)}function C(e,t,n,i){for(var a=n;a<i;a++){var o=t[a];if(r(o)&&dn(e,o))return a}}function x(e,t,n,o){if(e!==t){var s=t.elm=e.elm;if(a(e.isAsyncPlaceholder))return void(r(t.asyncFactory.resolved)?D(e.elm,t,n):t.isAsyncPlaceholder=!0);if(a(t.isStatic)&&a(e.isStatic)&&t.key===e.key&&(a(t.isCloned)||a(t.isOnce)))return void(t.componentInstance=e.componentInstance);var l,c=t.data;r(c)&&r(l=c.hook)&&r(l=l.prepatch)&&l(e,t);var u=e.children,d=t.children;if(r(c)&&v(t)){for(l=0;l<O.update.length;++l)O.update[l](e,t);r(l=c.hook)&&r(l=l.update)&&l(e,t)}i(t.text)?r(u)&&r(d)?u!==d&&k(s,u,d,n,o):r(d)?(r(e.text)&&M.setTextContent(s,""),g(s,null,d,0,d.length-1,n)):r(u)?_(s,u,0,u.length-1):r(e.text)&&M.setTextContent(s,""):e.text!==t.text&&M.setTextContent(s,t.text),r(c)&&r(l=c.hook)&&r(l=l.postpatch)&&l(e,t)}}function S(e,t,n){if(a(n)&&r(e.parent))e.parent.data.pendingInsert=t;else for(var i=0;i<t.length;++i)t[i].data.hook.insert(t[i])}function D(e,t,n,i){var o,s=t.tag,l=t.data,c=t.children;if(i=i||l&&l.pre,t.elm=e,a(t.isComment)&&r(t.asyncFactory))return t.isAsyncPlaceholder=!0,!0;if(r(l)&&(r(o=l.hook)&&r(o=o.init)&&o(t,!0),r(o=t.componentInstance)))return u(t,n),!0;if(r(s)){if(r(c))if(e.hasChildNodes())if(r(o=l)&&r(o=o.domProps)&&r(o=o.innerHTML)){if(o!==e.innerHTML)return!1}else{for(var d=!0,f=e.firstChild,h=0;h<c.length;h++){if(!f||!D(f,c[h],n,i)){d=!1;break}f=f.nextSibling}if(!d||f)return!1}else p(t,c,n);if(r(l)){var v=!1;for(var y in l)if(!P(y)){v=!0,m(t,n);break}!v&&l.class&&se(l.class)}}else e.data!==t.text&&(e.data=t.text);return!0}var $,A,O={},T=e.modules,M=e.nodeOps;for($=0;$<na.length;++$)for(O[na[$]]=[],A=0;A<T.length;++A)r(T[A][na[$]])&&O[na[$]].push(T[A][na[$]]);var P=h("attrs,class,staticClass,staticStyle,key");return function(e,n,o,s,c,u){if(i(n))return void(r(e)&&b(e));var d=!1,f=[];if(i(e))d=!0,l(n,f,c,u);else{var p=r(e.nodeType);if(!p&&dn(e,n))x(e,n,f,s);else{if(p){if(1===e.nodeType&&e.hasAttribute(Ci)&&(e.removeAttribute(Ci),o=!0),a(o)&&D(e,n,f))return S(n,f,!0),e;e=t(e)}var h=e.elm,m=M.parentNode(h);if(l(n,f,h._leaveCb?null:m,M.nextSibling(h)),r(n.parent))for(var y=n.parent,g=v(n);y;){for(var w=0;w<O.destroy.length;++w)O.destroy[w](y);if(y.elm=n.elm,g){for(var k=0;k<O.create.length;++k)O.create[k](ta,y);var C=y.data.hook.insert;if(C.merged)for(var $=1;$<C.fns.length;$++)C.fns[$]()}else un(y);y=y.parent}r(m)?_(m,[e],0,0):r(e.tag)&&b(e)}}return S(n,f,d),n.elm}}({nodeOps:Zr,modules:Ma});Fi&&document.addEventListener("selectionchange",function(){var e=document.activeElement;e&&e.vmodel&&ni(e,"input")});var Ba={inserted:function(e,t,n,i){"select"===n.tag?(i.elm&&!i.elm._vOptions?de(n,"postpatch",function(){Ba.componentUpdated(e,t,n)}):Jn(e,t,n.context),e._vOptions=[].map.call(e.options,Zn)):("textarea"===n.tag||Qr(e.type))&&(e._vModifiers=t.modifiers,t.modifiers.lazy||(e.addEventListener("change",ti),Ii||(e.addEventListener("compositionstart",ei),e.addEventListener("compositionend",ti)),Fi&&(e.vmodel=!0)))},componentUpdated:function(e,t,n){if("select"===n.tag){Jn(e,t,n.context);var i=e._vOptions,r=e._vOptions=[].map.call(e.options,Zn);if(r.some(function(e,t){return!C(e,i[t])})){(e.multiple?t.value.some(function(e){return Qn(e,r)}):t.value!==t.oldValue&&Qn(t.value,r))&&ni(e,"change")}}}},Fa={bind:function(e,t,n){var i=t.value;n=ii(n);var r=n.data&&n.data.transition,a=e.__vOriginalDisplay="none"===e.style.display?"":e.style.display;i&&r?(n.data.show=!0,qn(n,function(){e.style.display=a})):e.style.display=i?a:"none"},update:function(e,t,n){var i=t.value;i!==t.oldValue&&(n=ii(n),n.data&&n.data.transition?(n.data.show=!0,i?qn(n,function(){e.style.display=e.__vOriginalDisplay}):Yn(n,function(){e.style.display="none"})):e.style.display=i?e.__vOriginalDisplay:"none")},unbind:function(e,t,n,i,r){r||(e.style.display=e.__vOriginalDisplay)}},Va={model:Ba,show:Fa},Ia={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]},Ea={name:"transition",props:Ia,abstract:!0,render:function(e){var t=this,n=this.$slots.default;if(n&&(n=n.filter(function(e){return e.tag||we(e)}),n.length)){var i=this.mode,r=n[0];if(si(this.$vnode))return r;var a=ri(r);if(!a)return r;if(this._leaving)return oi(e,r);var o="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?o+"comment":o+a.tag:s(a.key)?0===String(a.key).indexOf(o)?a.key:o+a.key:a.key;var l=(a.data||(a.data={})).transition=ai(this),c=this._vnode,u=ri(c);if(a.data.directives&&a.data.directives.some(function(e){return"show"===e.name})&&(a.data.show=!0),u&&u.data&&!li(a,u)&&!we(u)&&(!u.componentInstance||!u.componentInstance._vnode.isComment)){var d=u.data.transition=_({},l);if("out-in"===i)return this._leaving=!0,de(d,"afterLeave",function(){t._leaving=!1,t.$forceUpdate()}),oi(e,r);if("in-out"===i){if(we(a))return c;var f,p=function(){f()};de(l,"afterEnter",p),de(l,"enterCancelled",p),de(d,"delayLeave",function(e){f=e})}}return r}}},Na=_({tag:String,moveClass:String},Ia);delete Na.mode;var ja={props:Na,render:function(e){for(var t=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),i=this.prevChildren=this.children,r=this.$slots.default||[],a=this.children=[],o=ai(this),s=0;s<r.length;s++){var l=r[s];if(l.tag)if(null!=l.key&&0!==String(l.key).indexOf("__vlist"))a.push(l),n[l.key]=l,(l.data||(l.data={})).transition=o;else;}if(i){for(var c=[],u=[],d=0;d<i.length;d++){var f=i[d];f.data.transition=o,f.data.pos=f.elm.getBoundingClientRect(),n[f.key]?c.push(f):u.push(f)}this.kept=e(t,null,c),this.removed=u}return e(t,null,a)},beforeUpdate:function(){this.__patch__(this._vnode,this.kept,!1,!0),this._vnode=this.kept},updated:function(){var e=this.prevChildren,t=this.moveClass||(this.name||"v")+"-move";e.length&&this.hasMove(e[0].elm,t)&&(e.forEach(ci),e.forEach(ui),e.forEach(di),this._reflow=document.body.offsetHeight,e.forEach(function(e){if(e.data.moved){var n=e.elm,i=n.style;jn(n,t),i.transform=i.WebkitTransform=i.transitionDuration="",n.addEventListener(xa,n._moveCb=function e(i){i&&!/transform$/.test(i.propertyName)||(n.removeEventListener(xa,e),n._moveCb=null,Rn(n,t))})}}))},methods:{hasMove:function(e,t){if(!_a)return!1;if(this._hasMove)return this._hasMove;var n=e.cloneNode();e._transitionClasses&&e._transitionClasses.forEach(function(e){In(n,e)}),Vn(n,t),n.style.display="none",this.$el.appendChild(n);var i=zn(n);return this.$el.removeChild(n),this._hasMove=i.hasTransform}}},Ra={Transition:Ea,TransitionGroup:ja};Tt.config.mustUseProp=Rr,Tt.config.isReservedTag=Jr,Tt.config.isReservedAttr=Nr,Tt.config.getTagNamespace=Kt,Tt.config.isUnknownElement=Gt,_(Tt.options.directives,Va),_(Tt.options.components,Ra),Tt.prototype.__patch__=Oi?Pa:k,Tt.prototype.$mount=function(e,t){return e=e&&Oi?Jt(e):void 0,Me(this,e,t)},Tt.nextTick(function(){Di.devtools&&Wi&&Wi.emit("init",Tt)},0),t.a=Tt}).call(t,n(44),n(167).setImmediate)},function(e,t,n){"use strict";var i=n(180),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(189),r=n.n(i);t.a=r.a},function(e,t,n){var i=n(60),r=n(32);e.exports=Object.keys||function(e){return i(e,r)}},function(e,t){t.f={}.propertyIsEnumerable},function(e,t){var n=0,i=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+i).toString(36))}},function(e,t,n){"use strict";var i=n(176),r=n.n(i),a=n(177),o=n.n(a);n.d(t,"a",function(){return r.a}),n.d(t,"b",function(){return o.a})},function(e,t,n){"use strict";var i=n(178),r=n.n(i),a=n(65);n.n(a);t.a=r.a},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t){e.exports=!0},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,n){var i=n(9).f,r=n(12),a=n(4)("toStringTag");e.exports=function(e,t,n){e&&!r(e=n?e:e.prototype,a)&&i(e,a,{configurable:!0,value:t})}},function(e,t,n){var i=n(37)("keys"),r=n(27);e.exports=function(e){return i[e]||(i[e]=r(e))}},function(e,t,n){var i=n(8),r=i["__core-js_shared__"]||(i["__core-js_shared__"]={});e.exports=function(e){return r[e]||(r[e]={})}},function(e,t){var n=Math.ceil,i=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?i:n)(e)}},function(e,t,n){var i=n(31);e.exports=function(e){return Object(i(e))}},function(e,t,n){var i=n(19);e.exports=function(e,t){if(!i(e))return e;var n,r;if(t&&"function"==typeof(n=e.toString)&&!i(r=n.call(e)))return r;if("function"==typeof(n=e.valueOf)&&!i(r=n.call(e)))return r;if(!t&&"function"==typeof(n=e.toString)&&!i(r=n.call(e)))return r;throw TypeError("Can't convert object to primitive value")}},function(e,t,n){var i=n(8),r=n(7),a=n(33),o=n(42),s=n(9).f;e.exports=function(e){var t=r.Symbol||(r.Symbol=a?{}:i.Symbol||{});"_"==e.charAt(0)||e in t||s(t,e,{value:o.f(e)})}},function(e,t,n){t.f=n(4)},function(e,t,n){"use strict";var i=n(154)(!0);n(57)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=i(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";var i=n(168),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(169),r=n.n(i),a=n(170),o=n.n(a);n.d(t,"a",function(){return r.a}),n.d(t,"b",function(){return o.a})},function(e,t,n){"use strict";var i=n(13),r=n.n(i),a=n(22),o=n(183),s=n.n(o);n.d(t,"a",function(){return s.a}),t.b={open:function(e){var t=void 0,n=void 0;"string"==typeof e&&(t=e);var i={programmatic:!0,content:t};e.parent&&(n=e.parent,delete e.parent);var o=r()(i,e);return new(a.a.extend(s.a))({parent:n,el:document.createElement("div"),propsData:o})}}},function(e,t,n){"use strict";var i=n(185),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(6),r=n.n(i),a=n(2);t.a={components:r()({},a.a.name,a.a),props:{active:{type:Boolean,default:!0},title:String,closable:{type:Boolean,default:!0},type:String,hasIcon:Boolean,size:String,iconSize:String},data:function(){return{isActive:this.active}},watch:{active:function(e){this.isActive=e}},computed:{icon:function(){switch(this.type){case"is-info":return"information";case"is-success":return"check-circle";case"is-warning":return"alert";case"is-danger":return"alert-circle";default:return null}}},methods:{close:function(){this.isActive=!1,this.$emit("close"),this.$emit("update:active",!1)}}}},function(e,t,n){"use strict";var i=n(1),r=n(5);t.a={props:{type:{type:String,default:"is-dark"},message:String,duration:Number,queue:{type:Boolean,default:void 0},position:{type:String,default:"is-top",validator:function(e){return["is-top-right","is-top","is-top-left","is-bottom-right","is-bottom","is-bottom-left"].indexOf(e)>-1}},container:String},data:function(){return{isActive:!1,parentTop:null,parentBottom:null,newContainer:this.container||i.b.defaultContainerElement}},computed:{correctParent:function(){switch(this.position){case"is-top-right":case"is-top":case"is-top-left":return this.parentTop;case"is-bottom-right":case"is-bottom":case"is-bottom-left":return this.parentBottom}},transition:function(){switch(this.position){case"is-top-right":case"is-top":case"is-top-left":return{enter:"fadeInDown",leave:"fadeOut"};case"is-bottom-right":case"is-bottom":case"is-bottom-left":return{enter:"fadeInUp",leave:"fadeOut"}}}},methods:{shouldQueue:function(){return!!(void 0!==this.queue?this.queue:i.b.defaultNoticeQueue)&&(this.parentTop.childElementCount>0||this.parentBottom.childElementCount>0)},close:function(){var e=this;clearTimeout(this.timer),this.isActive=!1,setTimeout(function(){e.$destroy(),n.i(r.a)(e.$el)},150)},showNotice:function(){var e=this;if(this.shouldQueue())return void setTimeout(function(){return e.showNotice()},250);this.correctParent.insertAdjacentElement("afterbegin",this.$el),this.isActive=!0,this.indefinite||(this.timer=setTimeout(function(){return e.close()},this.newDuration))},setupContainer:function(){if(this.parentTop=document.querySelector(".notices.is-top"),this.parentBottom=document.querySelector(".notices.is-bottom"),!this.parentTop||!this.parentBottom){this.parentTop||(this.parentTop=document.createElement("div"),this.parentTop.className="notices is-top"),this.parentBottom||(this.parentBottom=document.createElement("div"),this.parentBottom.className="notices is-bottom");var e=document.querySelector(this.newContainer)||document.body;e.appendChild(this.parentTop),e.appendChild(this.parentBottom),this.newContainer&&(this.parentTop.classList.add("has-custom-container"),this.parentBottom.classList.add("has-custom-container"))}}},beforeMount:function(){this.setupContainer()},mounted:function(){this.showNotice()}}},function(e,t,n){e.exports={default:n(130),__esModule:!0}},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var r=n(127),a=i(r),o=n(3),s=i(o),l="function"==typeof s.default&&"symbol"==typeof a.default?function(e){return typeof e}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":typeof e};t.default="function"==typeof s.default&&"symbol"===l(a.default)?function(e){return void 0===e?"undefined":l(e)}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":void 0===e?"undefined":l(e)}},function(e,t,n){var i=n(135);e.exports=function(e,t,n){if(i(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,i){return e.call(t,n,i)};case 3:return function(n,i,r){return e.call(t,n,i,r)}}return function(){return e.apply(t,arguments)}}},function(e,t,n){var i=n(19),r=n(8).document,a=i(r)&&i(r.createElement);e.exports=function(e){return a?r.createElement(e):{}}},function(e,t,n){e.exports=!n(11)&&!n(18)(function(){return 7!=Object.defineProperty(n(54)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var i=n(30);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==i(e)?e.split(""):Object(e)}},function(e,t,n){"use strict";var i=n(33),r=n(17),a=n(61),o=n(15),s=n(12),l=n(20),c=n(145),u=n(35),d=n(153),f=n(4)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};e.exports=function(e,t,n,v,m,y,g){c(n,t,v);var b,_,w,k=function(e){if(!p&&e in D)return D[e];switch(e){case"keys":case"values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},C=t+" Iterator",x="values"==m,S=!1,D=e.prototype,$=D[f]||D["@@iterator"]||m&&D[m],A=!p&&$||k(m),O=m?x?k("entries"):A:void 0,T="Array"==t?D.entries||$:$;if(T&&(w=d(T.call(new e)))!==Object.prototype&&w.next&&(u(w,C,!0),i||s(w,f)||o(w,f,h)),x&&$&&"values"!==$.name&&(S=!0,A=function(){return $.call(this)}),i&&!g||!p&&!S&&D[f]||o(D,f,A),l[t]=A,l[C]=h,m)if(b={values:x?A:k("values"),keys:y?A:k("keys"),entries:O},g)for(_ in b)_ in D||a(D,_,b[_]);else r(r.P+r.F*(p||S),t,b);return b}},function(e,t,n){var i=n(14),r=n(150),a=n(32),o=n(36)("IE_PROTO"),s=function(){},l=function(){var e,t=n(54)("iframe"),i=a.length;for(t.style.display="none",n(141).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),l=e.F;i--;)delete l.prototype[a[i]];return l()};e.exports=Object.create||function(e,t){var n;return null!==e?(s.prototype=i(e),n=new s,s.prototype=null,n[o]=e):n=l(),void 0===t?n:r(n,t)}},function(e,t,n){var i=n(60),r=n(32).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return i(e,r)}},function(e,t,n){var i=n(12),r=n(16),a=n(137)(!1),o=n(36)("IE_PROTO");e.exports=function(e,t){var n,s=r(e),l=0,c=[];for(n in s)n!=o&&i(s,n)&&c.push(n);for(;t.length>l;)i(s,n=t[l++])&&(~a(c,n)||c.push(n));return c}},function(e,t,n){e.exports=n(15)},function(e,t,n){var i=n(38),r=Math.min;e.exports=function(e){return e>0?r(i(e),9007199254740991):0}},function(e,t,n){var i=n(138),r=n(4)("iterator"),a=n(20);e.exports=n(7).getIteratorMethod=function(e){if(void 0!=e)return e[r]||e["@@iterator"]||a[i(e)]}},function(e,t,n){n(158);for(var i=n(8),r=n(15),a=n(20),o=n(4)("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),l=0;l<s.length;l++){var c=s[l],u=i[c],d=u&&u.prototype;d&&!d[o]&&r(d,o,c),a[c]=a.Array}},function(e,t,n){var i=n(0)(n(79),null,null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(94),n(216),null,null,null);e.exports=i.exports},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=n.n(i),a=n(46),o=n(28),s=n(112),l=n(115),c=n(116),u=n(117),d=n(45),f=n(105),p=n(106),h=n(107),v=n(29),m=n(2),y=n(23),g=n(108),b=n(109),_=n(47),w=n(110),k=n(48),C=n(111),x=n(24),S=n(113),D=n(114),$=n(118),A=n(119),O=n(120),T=n(121),M=n(122),P=n(1);n.d(t,"Dialog",function(){return h.a}),n.d(t,"LoadingProgrammatic",function(){return g.b}),n.d(t,"ModalProgrammatic",function(){return _.b}),n.d(t,"Snackbar",function(){return S.a}),n.d(t,"Toast",function(){return O.a});var B={Autocomplete:d.a,Checkbox:a.a,CheckboxButton:a.b,Collapse:f.a,Datepicker:p.a,Dropdown:o.a,DropdownItem:o.b,Field:v.a,Icon:m.a,Input:y.a,Loading:g.a,Message:b.a,Modal:_.a,Notification:w.a,Pagination:k.a,Panel:C.a,Radio:s.a,RadioButton:s.b,Select:x.a,Switch:D.a,TabItem:c.a,Table:l.a,TableColumn:l.b,Tabs:c.b,Tag:u.a,Taglist:u.b,Taginput:$.a,Timepicker:A.a,Tooltip:T.a,Upload:M.a};B.install=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};n.i(P.a)(r()(P.b,t));for(var i in B){var a=B[i];a&&"install"!==i&&e.component(a.name,a)}e.prototype.$dialog=h.a,e.prototype.$loading=g.b,e.prototype.$modal=_.b,e.prototype.$snackbar=S.a,e.prototype.$toast=O.a},t.default=B},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(52),r=n.n(i),a=n(51),o=n.n(a),s=n(6),l=n.n(s),c=n(5),u=n(10),d=n(23);t.default={name:"BAutocomplete",components:l()({},d.a.name,d.a),mixins:[u.a],inheritAttrs:!1,props:{value:[Number,String],data:{type:Array,default:function(){return[]}},field:{type:String,default:"value"},keepFirst:Boolean,clearOnSelect:Boolean,openOnFocus:Boolean},data:function(){return{selected:null,hovered:null,isActive:!1,newValue:this.value,isListInViewportVertically:!0,hasFocus:!1,_isAutocomplete:!0,_elementRef:"input"}},computed:{whiteList:function(){var e=[];if(e.push(this.$refs.input.$el.querySelector("input")),e.push(this.$refs.dropdown),void 0!==this.$refs.dropdown){var t=this.$refs.dropdown.querySelectorAll("*"),n=!0,i=!1,r=void 0;try{for(var a,s=o()(t);!(n=(a=s.next()).done);n=!0){var l=a.value;e.push(l)}}catch(e){i=!0,r=e}finally{try{!n&&s.return&&s.return()}finally{if(i)throw r}}}return e},hasDefaultSlot:function(){return!!this.$scopedSlots.default},hasEmptySlot:function(){return!!this.$slots.empty},hasHeaderSlot:function(){return!!this.$slots.header}},watch:{isActive:function(e){var t=this;e?this.calcDropdownInViewportVertical():(this.$nextTick(function(){return t.setHovered(null)}),setTimeout(function(){t.calcDropdownInViewportVertical()},100))},newValue:function(e){this.$emit("input",e);var t=this.getValue(this.selected);t&&t!==e&&this.setSelected(null,!1),!this.hasFocus||this.openOnFocus&&!e||(this.isActive=!!e)},value:function(e){this.newValue=e,!this.isValid&&this.$refs.input.checkHtml5Validity()},data:function(e){this.keepFirst&&this.selectFirstOption(e)}},methods:{setHovered:function(e){void 0!==e&&(this.hovered=e)},setSelected:function(e){var t=this,n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];void 0!==e&&(this.selected=e,this.$emit("select",this.selected),null!==this.selected&&(this.newValue=this.clearOnSelect?"":this.getValue(this.selected)),n&&this.$nextTick(function(){t.isActive=!1}))},selectFirstOption:function(e){var t=this;this.$nextTick(function(){e.length?(t.openOnFocus||""!==t.newValue&&t.hovered!==e[0])&&t.setHovered(e[0]):t.setHovered(null)})},enterPressed:function(){null!==this.hovered&&this.setSelected(this.hovered)},tabPressed:function(){if(null===this.hovered)return void(this.isActive=!1);this.setSelected(this.hovered)},clickedOutside:function(e){this.whiteList.indexOf(e.target)<0&&(this.isActive=!1)},getValue:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(e){var i="object"===(void 0===e?"undefined":r()(e))?n.i(c.c)(e,this.field):e,a="string"==typeof this.newValue?n.i(c.e)(this.newValue):this.newValue,o=new RegExp("("+a+")","gi");return t?i.replace(o,"<b>$1</b>"):i}},calcDropdownInViewportVertical:function(){var e=this;this.$nextTick(function(){if(void 0!==e.$refs.dropdown){var t=e.$refs.dropdown.getBoundingClientRect();e.isListInViewportVertically=t.top>=0&&t.bottom<=(window.innerHeight||document.documentElement.clientHeight)}})},keyArrows:function(e){var t="down"===e?1:-1;if(this.isActive){var n=this.data.indexOf(this.hovered)+t;n=n>this.data.length-1?this.data.length:n,n=n<0?0:n,this.setHovered(this.data[n]);var i=this.$refs.dropdown.querySelector(".dropdown-content"),r=i.querySelectorAll(".dropdown-item:not(.is-disabled)")[n];if(!r)return;var a=i.scrollTop,o=i.scrollTop+i.clientHeight-r.clientHeight;r.offsetTop<a?i.scrollTop=r.offsetTop:r.offsetTop>=o&&(i.scrollTop=r.offsetTop-i.clientHeight+r.clientHeight)}else this.isActive=!0},focused:function(e){this.getValue(this.selected)===this.newValue&&this.$el.querySelector("input").select(),this.openOnFocus&&(this.isActive=!0,this.keepFirst&&this.selectFirstOption(this.data)),this.hasFocus=!0,this.$emit("focus",e)},onBlur:function(e){this.hasFocus=!1,this.$emit("blur",e)}},created:function(){"undefined"!=typeof window&&(document.addEventListener("click",this.clickedOutside),window.addEventListener("resize",this.calcDropdownInViewportVertical))},beforeDestroy:function(){"undefined"!=typeof window&&(document.removeEventListener("click",this.clickedOutside),window.removeEventListener("resize",this.calcDropdownInViewportVertical))}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),r=n.n(i);t.default={name:"BCheckbox",props:{value:[String,Number,Boolean,Function,Object,Array,r.a],nativeValue:[String,Number,Boolean,Function,Object,Array,r.a],type:String,disabled:Boolean,name:String,size:String,trueValue:{type:[String,Number,Boolean,Function,Object,Array,r.a],default:!0},falseValue:{type:[String,Number,Boolean,Function,Object,Array,r.a],default:!1}},data:function(){return{newValue:this.value}},watch:{value:function(e){this.newValue=e},newValue:function(e){this.$emit("input",e)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),r=n.n(i);t.default={name:"BCheckboxButton",props:{value:[String,Number,Boolean,Function,Object,Array,r.a],nativeValue:[String,Number,Boolean,Function,Object,Array,r.a],disabled:Boolean,name:String,size:String,type:{type:String,default:"is-primary"}},data:function(){return{newValue:this.value}},computed:{checked:function(){return Array.isArray(this.newValue)?this.newValue.indexOf(this.nativeValue)>=0:this.newValue===this.nativeValue}},watch:{value:function(e){this.newValue=e},newValue:function(e){this.$emit("input",e)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"BCollapse",props:{open:{type:Boolean,default:!0},animation:{type:String,default:"fade"}},data:function(){return{isOpen:this.open}},watch:{open:function(e){this.isOpen=e}},methods:{toggle:function(){this.isOpen=!this.isOpen,this.$emit("update:open",this.isOpen),this.$emit(this.isOpen?"open":"close")}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i,r=n(6),a=n.n(r),o=n(10),s=n(5),l=n(1),c=n(28),u=n(23),d=n(29),f=n(24),p=n(2),h=n(173),v=n.n(h);t.default={name:"BDatepicker",components:(i={},a()(i,v.a.name,v.a),a()(i,u.a.name,u.a),a()(i,d.a.name,d.a),a()(i,f.a.name,f.a),a()(i,p.a.name,p.a),a()(i,c.a.name,c.a),a()(i,c.b.name,c.b),i),mixins:[o.a],inheritAttrs:!1,props:{value:Date,dayNames:{type:Array,default:function(){return Array.isArray(l.b.defaultDayNames)?l.b.defaultDayNames:["Su","M","Tu","W","Th","F","S"]}},monthNames:{type:Array,default:function(){return Array.isArray(l.b.defaultMonthNames)?l.b.defaultMonthNames:["January","February","March","April","May","June","July","August","September","October","November","December"]}},firstDayOfWeek:{type:Number,default:function(){return"number"==typeof l.b.defaultFirstDayOfWeek?l.b.defaultFirstDayOfWeek:0}},inline:Boolean,minDate:Date,maxDate:Date,focusedDate:Date,placeholder:String,readonly:{type:Boolean,default:!0},disabled:{type:Boolean,default:!1},unselectableDates:Array,unselectableDaysOfWeek:{type:Array,default:function(){return l.b.defaultUnselectableDaysOfWeek}},selectableDates:Array,dateFormatter:{type:Function,default:function(e){return"function"==typeof l.b.defaultDateFormatter?l.b.defaultDateFormatter(e):new Date(Date.UTC(e.getFullYear(),e.getMonth(),e.getDate())).toLocaleDateString()}},dateParser:{type:Function,default:function(e){return"function"==typeof l.b.defaultDateParser?l.b.defaultDateParser(e):new Date(Date.parse(e))}},mobileNative:{type:Boolean,default:function(){return l.b.defaultDatepickerMobileNative}},position:String,events:Array,indicators:{type:String,default:"dots"}},data:function(){var e=this.value||this.focusedDate||new Date;return{dateSelected:this.value,focusedDateData:{month:e.getMonth(),year:e.getFullYear()},_elementRef:"input",_isDatepicker:!0}},computed:{listOfYears:function(){for(var e=this.maxDate?this.maxDate.getFullYear():Math.max((new Date).getFullYear(),this.focusedDateData.year)+3,t=this.minDate?this.minDate.getFullYear():1900,n=[],i=t;i<=e;i++)n.push(i);return n.reverse()},isFirstMonth:function(){return!!this.minDate&&new Date(this.focusedDateData.year,this.focusedDateData.month)<=new Date(this.minDate.getFullYear(),this.minDate.getMonth())},isLastMonth:function(){return!!this.maxDate&&new Date(this.focusedDateData.year,this.focusedDateData.month)>=new Date(this.maxDate.getFullYear(),this.maxDate.getMonth())},isMobile:function(){return this.mobileNative&&s.b.any()}},watch:{dateSelected:function(e){var t=e||new Date;this.focusedDateData={month:t.getMonth(),year:t.getFullYear()},this.$emit("input",e),this.$refs.dropdown&&(this.$refs.dropdown.isActive=!1)},value:function(e){this.dateSelected=e,!this.isValid&&this.$refs.input.checkHtml5Validity()},focusedDate:function(e){e&&(this.focusedDateData={month:e.getMonth(),year:e.getFullYear()})},"focusedDateData.month":function(e){this.$emit("change-month",e)},"focusedDateData.year":function(e){this.$emit("change-year",e)}},methods:{updateSelectedDate:function(e){this.dateSelected=e},onChange:function(e){var t=this.dateParser(e);t&&!isNaN(t)?this.dateSelected=t:(this.dateSelected=null,this.$refs.input.newValue=this.dateSelected)},formatValue:function(e){return e&&!isNaN(e)?this.dateFormatter(e):null},decrementMonth:function(){this.disabled||(this.focusedDateData.month>0?this.focusedDateData.month-=1:(this.focusedDateData.month=11,this.focusedDateData.year-=1))},incrementMonth:function(){this.disabled||(this.focusedDateData.month<11?this.focusedDateData.month+=1:(this.focusedDateData.month=0,this.focusedDateData.year+=1))},formatYYYYMMDD:function(e){var t=new Date(e);if(e&&!isNaN(t)){var n=t.getFullYear(),i=t.getMonth()+1,r=t.getDate();return n+"-"+(i<10?"0":"")+i+"-"+(r<10?"0":"")+r}return""},onChangeNativePicker:function(e){var t=e.target.value;this.dateSelected=t?new Date(t):null}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(174),r=n.n(i);t.default={name:"BDatepickerTable",components:{bDatepickerTableRow:r.a},props:{value:Date,dayNames:Array,monthNames:Array,firstDayOfWeek:Number,events:Array,indicators:String,minDate:Date,maxDate:Date,focused:Object,disabled:Boolean,unselectableDates:Array,unselectableDaysOfWeek:Array,selectableDates:Array},computed:{visibleDayNames:function(){for(var e=[],t=this.firstDayOfWeek;e.length<this.dayNames.length;){var n=this.dayNames[t%this.dayNames.length];e.push(n),t++}return e},hasEvents:function(){return this.events&&this.events.length},eventsInThisMonth:function(){if(!this.events)return[];for(var e=[],t=0;t<this.events.length;t++){var n=this.events[t];n.hasOwnProperty("date")||(n={date:n}),n.hasOwnProperty("type")||(n.type="is-primary"),n.date.getMonth()===this.focused.month&&n.date.getFullYear()===this.focused.year&&e.push(n)}return e}},methods:{updateSelectedDate:function(e){this.$emit("input",e)},weekBuilder:function(e,t,n){for(var i=new Date(n,t),r=[],a=new Date(n,t,e).getDay(),o=a>=this.firstDayOfWeek?a-this.firstDayOfWeek:7-this.firstDayOfWeek+a,s=1,l=0;l<o;l++)r.unshift(new Date(i.getFullYear(),i.getMonth(),e-s)),s++;r.push(new Date(n,t,e));for(var c=1;r.length<7;)r.push(new Date(n,t,e+c)),c++;return r},weeksInThisMonth:function(e,t){for(var n=[],i=new Date(t,e+1,0).getDate(),r=1;r<=i+6;){var a=this.weekBuilder(r,e,t),o=!1;a.forEach(function(t){t.getMonth()===e&&(o=!0)}),o&&n.push(a),r+=7}return n},eventsInThisWeek:function(e,t){if(!this.eventsInThisMonth.length)return[];var n=[],i=[];i=this.weeksInThisMonth(this.focused.month,this.focused.year);for(var r=0;r<i[t].length;r++)for(var a=0;a<this.eventsInThisMonth.length;a++){var o=this.eventsInThisMonth[a].date.getTime();o===i[t][r].getTime()&&n.push(this.eventsInThisMonth[a])}return n}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"BDatepickerTableRow",props:{selectedDate:Date,week:{type:Array,required:!0},month:{type:Number,required:!0},minDate:Date,maxDate:Date,disabled:Boolean,unselectableDates:Array,unselectableDaysOfWeek:Array,selectableDates:Array,events:Array,indicators:String},methods:{selectableDate:function(e){var t=[];if(this.minDate&&t.push(e>=this.minDate),this.maxDate&&t.push(e<=this.maxDate),t.push(e.getMonth()===this.month),this.selectableDates)for(var n=0;n<this.selectableDates.length;n++){var i=this.selectableDates[n];if(e.getDate()===i.getDate()&&e.getFullYear()===i.getFullYear()&&e.getMonth()===i.getMonth())return!0;t.push(!1)}if(this.unselectableDates)for(var r=0;r<this.unselectableDates.length;r++){var a=this.unselectableDates[r];t.push(e.getDate()!==a.getDate()||e.getFullYear()!==a.getFullYear()||e.getMonth()!==a.getMonth())}if(this.unselectableDaysOfWeek)for(var o=0;o<this.unselectableDaysOfWeek.length;o++){var s=this.unselectableDaysOfWeek[o];t.push(e.getDay()!==s)}return t.indexOf(!1)<0},emitChosenDate:function(e){this.disabled||this.selectableDate(e)&&this.$emit("select",e)},eventsDateMatch:function(e){if(!this.events.length)return!1;for(var t=[],n=0;n<this.events.length;n++)this.events[n].date.getDay()===e.getDay()&&t.push(this.events[n]);return!!t.length&&t},classObject:function(e){function t(e,t){return!(!e||!t)&&(e.getDate()===t.getDate()&&e.getFullYear()===t.getFullYear()&&e.getMonth()===t.getMonth())}return{"is-selected":t(e,this.selectedDate),"is-today":t(e,new Date),"is-selectable":this.selectableDate(e)&&!this.disabled,"is-unselectable":!this.selectableDate(e)||this.disabled}}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(6),r=n.n(i),a=n(2),o=n(47),s=n(1),l=n(5);t.default={name:"BDialog",components:r()({},a.a.name,a.a),extends:o.a,props:{title:String,message:String,icon:String,iconPack:String,hasIcon:Boolean,type:{type:String,default:"is-primary"},size:String,confirmText:{type:String,default:function(){return s.b.defaultDialogConfirmText?s.b.defaultDialogConfirmText:"OK"}},cancelText:{type:String,default:function(){return s.b.defaultDialogCancelText?s.b.defaultDialogCancelText:"Cancel"}},hasInput:Boolean,inputAttrs:{type:Object,default:function(){return{}}},onConfirm:{type:Function,default:function(){}},focusOn:{type:String,default:"confirm"}},data:function(){return{prompt:this.hasInput?this.inputAttrs.value||"":"",isActive:!1,validationMessage:""}},computed:{iconByType:function(){switch(this.type){case"is-info":return"information";case"is-success":return"check-circle";case"is-warning":return"alert";case"is-danger":return"alert-circle";default:return null}},showCancel:function(){return this.cancelOptions.indexOf("button")>=0}},methods:{confirm:function(){var e=this;if(void 0!==this.$refs.input&&!this.$refs.input.checkValidity())return this.validationMessage=this.$refs.input.validationMessage,void this.$nextTick(function(){return e.$refs.input.select()});this.onConfirm(this.prompt),this.close()},close:function(){var e=this;this.isActive=!1,setTimeout(function(){e.$destroy(),n.i(l.a)(e.$el)},150)}},beforeMount:function(){document.body.appendChild(this.$el)},mounted:function(){var e=this;this.isActive=!0,void 0===this.inputAttrs.required&&this.$set(this.inputAttrs,"required",!0),this.$nextTick(function(){e.hasInput?e.$refs.input.focus():"cancel"===e.focusOn&&e.showCancel?e.$refs.cancelButton.focus():e.$refs.confirmButton.focus()})}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(51),r=n.n(i),a=n(3),o=n.n(a);t.default={name:"BDropdown",props:{value:{type:[String,Number,Boolean,Object,Array,o.a,Function],default:null},disabled:Boolean,hoverable:Boolean,inline:Boolean,position:{type:String,validator:function(e){return["is-top-right","is-top-left","is-bottom-left"].indexOf(e)>-1}},mobileModal:{type:Boolean,default:!0}},data:function(){return{selected:this.value,isActive:!1,_isDropdown:!0}},computed:{rootClasses:function(){return[this.position,{"is-disabled":this.disabled,"is-hoverable":this.hoverable,"is-inline":this.inline,"is-active":this.isActive||this.inline,"is-mobile-modal":this.isMobileModal}]},isMobileModal:function(){return this.mobileModal&&!this.inline&&!this.hoverable}},watch:{value:function(e){this.selected=e},isActive:function(e){this.$emit("active-change",e)}},methods:{selectItem:function(e){this.selected!==e&&(this.$emit("change",e),this.selected=e),this.$emit("input",e),this.isActive=!1},isInWhiteList:function(e){if(e===this.$refs.dropdownMenu)return!0;if(e===this.$refs.trigger)return!0;if(void 0!==this.$refs.dropdownMenu){var t=this.$refs.dropdownMenu.querySelectorAll("*"),n=!0,i=!1,a=void 0;try{for(var o,s=r()(t);!(n=(o=s.next()).done);n=!0){if(e===o.value)return!0}}catch(e){i=!0,a=e}finally{try{!n&&s.return&&s.return()}finally{if(i)throw a}}}if(void 0!==this.$refs.trigger){var l=this.$refs.trigger.querySelectorAll("*"),c=!0,u=!1,d=void 0;try{for(var f,p=r()(l);!(c=(f=p.next()).done);c=!0){if(e===f.value)return!0}}catch(e){u=!0,d=e}finally{try{!c&&p.return&&p.return()}finally{if(u)throw d}}}return!1},clickedOutside:function(e){this.inline||this.isInWhiteList(e.target)||(this.isActive=!1)},toggle:function(){var e=this;this.disabled||this.hoverable||(this.isActive?this.isActive=!this.isActive:this.$nextTick(function(){e.isActive=!e.isActive}))}},created:function(){"undefined"!=typeof window&&document.addEventListener("click",this.clickedOutside)},beforeDestroy:function(){"undefined"!=typeof window&&document.removeEventListener("click",this.clickedOutside)}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),r=n.n(i);t.default={name:"BDropdownItem",props:{value:{type:[String,Number,Boolean,Object,Array,r.a,Function],default:null},separator:Boolean,disabled:Boolean,custom:Boolean,paddingless:Boolean,hasLink:Boolean},computed:{anchorClasses:function(){return{"is-disabled":this.$parent.disabled||this.disabled,"is-paddingless":this.paddingless,"is-active":null!==this.value&&this.value===this.$parent.selected}},itemClasses:function(){return{"dropdown-item":!this.hasLink,"is-disabled":this.disabled,"is-paddingless":this.paddingless,"is-active":null!==this.value&&this.value===this.$parent.selected,"has-link":this.hasLink}},isClickable:function(){return!(this.$parent.disabled||this.separator||this.disabled||this.custom)}},methods:{selectItem:function(){this.isClickable&&(this.$parent.selectItem(this.value),this.$emit("click"))}},created:function(){if(!this.$parent.$data._isDropdown)throw this.$destroy(),new Error("You should wrap bDropdownItem on a bDropdown")}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(65),r=n.n(i);t.default={name:"BField",components:{"b-field-body":r.a},props:{type:String,label:String,labelFor:String,message:[String,Array],grouped:Boolean,groupMultiline:Boolean,position:String,expanded:Boolean,horizontal:Boolean,addons:{type:Boolean,default:!0},customClass:String},data:function(){return{newType:this.type,newMessage:this.message,_isField:!0}},computed:{rootClasses:function(){return[this.newPosition,{"is-expanded":this.expanded,"is-grouped-multiline":this.groupMultiline,"is-horizontal":this.horizontal}]},newPosition:function(){if(void 0!==this.position){var e=this.position.split("-");if(!(e.length<1)){var t=this.grouped?"is-grouped-":"has-addons-";return this.position?t+e[1]:void 0}}},formattedMessage:function(){return this.newMessage&&Array.isArray(this.newMessage)?this.newMessage.filter(function(e){if(e)return e}).join(" <br> "):this.newMessage}},watch:{type:function(e){this.newType=e},message:function(e){this.newMessage=e}},methods:{fieldType:function(){if(this.grouped)return"is-grouped";var e=0;return this.$slots.default&&(e=this.$slots.default.reduce(function(e,t){return t.tag?e+1:e},0)),e>1&&this.addons&&!this.horizontal?"has-addons":void 0}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"BFieldBody",props:{message:{type:[String]},type:{type:[String]}},render:function(e){var t=this;return e("div",{attrs:{class:"field-body"}},this.$slots.default.map(function(n){return n.tag?t.message?e("b-field",{attrs:{message:t.message,type:t.type}},[n]):e("b-field",{attrs:{type:t.type}},[n]):n}))}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(1);t.default={name:"BIcon",props:{type:String,pack:String,icon:String,size:String,customSize:String,customClass:String,both:Boolean},data:function(){return{newPack:this.pack||i.b.defaultIconPack}},computed:{newIcon:function(){return this.both?"mdi"===this.newPack?this.newPack+"-"+this.icon:"fa-"+this.getEquivalentIconOf(this.icon):"mdi"===this.newPack?this.newPack+"-"+this.icon:"fa-"+this.icon},newType:function(){if(this.type){var e=this.type.split("-");if(e.length)return"has-text-"+e[1]}},newCustomSize:function(){return this.customSize||this.customSizeByPack},customSizeByPack:function(){var e="mdi"===this.newPack?"mdi-24px":"fa-lg",t="mdi"===this.newPack?"mdi-36px":"fa-2x",n="mdi"===this.newPack?"mdi-48px":"fa-3x";switch(this.size){case"is-small":return;case"is-medium":return t;case"is-large":return n;default:return e}}},methods:{getEquivalentIconOf:function(e){switch(e){case"check":return"check";case"information":return"info-circle";case"check-circle":return"check-circle";case"alert":return"exclamation-triangle";case"alert-circle":return"exclamation-circle";case"arrow-up":return"arrow-up";case"chevron-right":return"angle-right";case"chevron-left":return"angle-left";case"chevron-down":return"angle-down";case"eye":return"eye";case"eye-off":return"eye-slash";case"menu-down":return"caret-down";case"menu-up":return"caret-up";default:return e}}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(6),r=n.n(i),a=n(2),o=n(1),s=n(10);t.default={name:"BInput",components:r()({},a.a.name,a.a),mixins:[s.a],inheritAttrs:!1,props:{value:[Number,String],type:{type:String,default:"text"},passwordReveal:Boolean,hasCounter:{type:Boolean,default:!0}},data:function(){return{newValue:this.value,newType:this.type,newAutocomplete:this.autocomplete||o.b.defaultInputAutocomplete,isPasswordVisible:!1,_elementRef:"textarea"===this.type?"textarea":"input"}},computed:{rootClasses:function(){return[this.iconPosition,this.size,{"is-expanded":this.expanded,"is-loading":this.loading,"is-clearfix":!this.hasMessage}]},inputClasses:function(){return[this.statusType,this.size,{"is-rounded":this.rounded}]},hasIconRight:function(){return this.passwordReveal||this.loading||this.statusType},iconPosition:function(){return this.icon&&this.hasIconRight?"has-icons-left has-icons-right":!this.icon&&this.hasIconRight?"has-icons-right":this.icon?"has-icons-left":void 0},statusTypeIcon:function(){switch(this.statusType){case"is-success":return"check";case"is-danger":return"alert-circle";case"is-info":return"information";case"is-warning":return"alert"}},hasMessage:function(){return!!this.statusMessage},passwordVisibleIcon:function(){return this.isPasswordVisible?"eye-off":"eye"},valueLength:function(){return"string"==typeof this.newValue?this.newValue.length:"number"==typeof this.newValue?this.newValue.toString().length:0}},watch:{value:function(e){this.newValue=e},newValue:function(e){this.$emit("input",e),!this.isValid&&this.checkHtml5Validity()}},methods:{togglePasswordVisibility:function(){var e=this;this.isPasswordVisible=!this.isPasswordVisible,this.newType=this.isPasswordVisible?"text":"password",this.$nextTick(function(){e.$refs.input.focus()})},onInput:function(e){var t=this;this.$nextTick(function(){t.newValue=e.target.value})}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(5),r=n(124);t.default={name:"BLoading",props:{active:Boolean,programmatic:Boolean,container:[Object,Function,r.a],isFullPage:{type:Boolean,default:!0},animation:{type:String,default:"fade"},canCancel:{type:Boolean,default:!1},onCancel:{type:Function,default:function(){}}},data:function(){return{isActive:this.active||!1}},watch:{active:function(e){this.isActive=e}},methods:{cancel:function(){this.canCancel&&this.close()},close:function(){var e=this;this.onCancel.apply(null,arguments),this.$emit("close"),this.$emit("update:active",!1),this.programmatic&&(this.isActive=!1,setTimeout(function(){e.$destroy(),n.i(i.a)(e.$el)},150))},keyPress:function(e){27===e.keyCode&&this.cancel()}},created:function(){"undefined"!=typeof window&&document.addEventListener("keyup",this.keyPress)},beforeMount:function(){this.programmatic&&(this.container?(this.isFullPage=!1,this.container.appendChild(this.$el)):document.body.appendChild(this.$el))},mounted:function(){this.programmatic&&(this.isActive=!0)},beforeDestroy:function(){"undefined"!=typeof window&&document.removeEventListener("keyup",this.keyPress)}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(49);t.default={name:"BMessage",mixins:[i.a],data:function(){return{newIconSize:this.iconSize||this.size||"is-large"}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(5),r=n(1);t.default={name:"BModal",props:{active:Boolean,component:[Object,Function],content:String,programmatic:Boolean,props:Object,events:Object,width:{type:[String,Number],default:960},hasModalCard:Boolean,animation:{type:String,default:"zoom-out"},canCancel:{type:[Array,Boolean],default:function(){return["escape","x","outside","button"]}},onCancel:{type:Function,default:function(){}},scroll:{type:String,default:function(){return r.b.defaultModalScroll?r.b.defaultModalScroll:"clip"},validator:function(e){return["clip","keep"].indexOf(e)>=0}}},data:function(){return{isActive:this.active||!1,savedScrollTop:null,newWidth:"number"==typeof this.width?this.width+"px":this.width}},computed:{cancelOptions:function(){return"boolean"==typeof this.canCancel?this.canCancel?["escape","x","outside","button"]:[]:this.canCancel},showX:function(){return this.cancelOptions.indexOf("x")>=0}},watch:{active:function(e){this.isActive=e},isActive:function(){this.handleScroll()}},methods:{handleScroll:function(){if("undefined"!=typeof window){if("clip"===this.scroll)return void document.documentElement.classList.toggle("is-clipped",this.isActive);if(this.savedScrollTop=this.savedScrollTop?this.savedScrollTop:document.documentElement.scrollTop,document.body.classList.toggle("is-noscroll",this.isActive),this.isActive)return void(document.body.style.top="-"+this.savedScrollTop+"px");document.documentElement.scrollTop=this.savedScrollTop,document.body.style.top=null,this.savedScrollTop=null}},cancel:function(e){this.cancelOptions.indexOf(e)<0||(this.onCancel.apply(null,arguments),this.close())},close:function(){var e=this;this.$emit("close"),this.$emit("update:active",!1),this.programmatic&&(this.isActive=!1,setTimeout(function(){e.$destroy(),n.i(i.a)(e.$el)},150))},keyPress:function(e){this.isActive&&27===e.keyCode&&this.cancel("escape")}},created:function(){"undefined"!=typeof window&&document.addEventListener("keyup",this.keyPress)},beforeMount:function(){this.programmatic&&document.body.appendChild(this.$el)},mounted:function(){this.programmatic?this.isActive=!0:this.isActive&&this.handleScroll()},beforeDestroy:function(){if("undefined"!=typeof window){document.removeEventListener("keyup",this.keyPress),document.documentElement.classList.toggle("is-clipped",!1);var e=this.savedScrollTop?this.savedScrollTop:document.documentElement.scrollTop;document.body.classList.toggle("is-noscroll",!1),document.documentElement.scrollTop=e,document.body.style.top=null}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(49);t.default={name:"BNotification",mixins:[i.a]}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(6),r=n.n(i),a=n(2);t.default={name:"BPagination",components:r()({},a.a.name,a.a),props:{total:[Number,String],perPage:{type:[Number,String],default:20},current:{type:[Number,String],default:1},size:String,simple:Boolean,rounded:Boolean,order:String},computed:{rootClasses:function(){return[this.order,this.size,{"is-simple":this.simple,"is-rounded":this.rounded}]},pageCount:function(){return Math.ceil(this.total/this.perPage)},firstItem:function(){var e=this.current*this.perPage-this.perPage+1;return e>=0?e:0},hasPrev:function(){return this.current>1},hasFirst:function(){return this.current>=3},hasFirstEllipsis:function(){return this.current>=4},hasLast:function(){return this.current<=this.pageCount-2},hasLastEllipsis:function(){return this.current<this.pageCount-2&&this.current<=this.pageCount-3},hasNext:function(){return this.current<this.pageCount},pagesInRange:function(){var e=this;if(!this.simple){for(var t=Math.max(1,this.current-1),n=Math.min(this.current+1,this.pageCount),i=[],r=t;r<=n;r++)(function(t){i.push({number:t,isCurrent:e.current===t,click:function(n){e.current!==t&&(e.$emit("change",t),e.$emit("update:current",t),e.$nextTick(function(){return n.target.focus()}))}})})(r);return i}}},watch:{pageCount:function(e){this.current>e&&this.last()}},methods:{prev:function(){this.hasPrev&&(this.$emit("change",this.current-1),this.$emit("update:current",this.current-1))},first:function(){this.$emit("change",1),this.$emit("update:current",1)},last:function(){this.$emit("change",this.pageCount),this.$emit("update:current",this.pageCount)},next:function(){this.hasNext&&(this.$emit("change",this.current+1),this.$emit("update:current",this.current+1))}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"BPanel",props:{collapsible:{type:Boolean,default:!1},open:{type:Boolean,default:!0},hasCustomTemplate:{type:Boolean,default:!1},header:String,content:String,animation:{type:String,default:"fade"}},data:function(){return{isOpen:this.open}},watch:{open:function(e){this.isOpen=e}},methods:{toggle:function(){this.collapsible&&(this.isOpen=!this.isOpen,this.$emit("update:open",this.isOpen),this.isOpen?this.$emit("open"):this.$emit("close"))}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),r=n.n(i);t.default={name:"BRadio",props:{value:[String,Number,Boolean,Function,Object,Array,r.a],nativeValue:[String,Number,Boolean,Function,Object,Array,r.a],type:String,disabled:Boolean,name:String,size:String},data:function(){return{newValue:this.value}},watch:{value:function(e){this.newValue=e},newValue:function(e){e===this.nativeValue&&this.$emit("input",e)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),r=n.n(i);t.default={name:"BRadioButton",props:{value:[String,Number,Boolean,Function,Object,Array,r.a],nativeValue:[String,Number,Boolean,Function,Object,Array,r.a],type:{type:String,default:"is-primary"},disabled:Boolean,name:String,size:String},data:function(){return{newValue:this.value}},watch:{value:function(e){this.newValue=e},newValue:function(e){e===this.nativeValue&&this.$emit("input",e)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),r=n.n(i),a=n(10);t.default={name:"BSelect",mixins:[a.a],inheritAttrs:!1,props:{value:{type:[String,Number,Boolean,Object,Array,r.a,Function],default:null},placeholder:String,multiple:Boolean,nativeSize:[String,Number]},data:function(){return{selected:this.value,_isSelect:!0,_elementRef:"select"}},computed:{spanClasses:function(){return[this.size,this.statusType,{"is-fullwidth":this.expanded,"is-loading":this.loading,"is-multiple":this.multiple,"is-rounded":this.rounded,"is-empty":null===this.selected}]}},watch:{value:function(e){this.selected=e,!this.isValid&&this.checkHtml5Validity()},selected:function(e){this.$emit("input",e),!this.isValid&&this.checkHtml5Validity()}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(1),r=n(50);t.default={name:"BSnackbar",mixins:[r.a],props:{actionText:{type:String,default:"OK"},onAction:{type:Function,default:function(){}},indefinite:{type:Boolean,default:!1}},data:function(){return{newDuration:this.duration||i.b.defaultSnackbarDuration}},methods:{action:function(){this.onAction(),this.close()}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),r=n.n(i);t.default={name:"BSwitch",props:{value:[String,Number,Boolean,Function,Object,Array,r.a],nativeValue:[String,Number,Boolean,Function,Object,Array,r.a],disabled:Boolean,type:String,name:String,size:String,trueValue:{type:[String,Number,Boolean,Function,Object,Array,r.a],default:!0},falseValue:{type:[String,Number,Boolean,Function,Object,Array,r.a],default:!1}},data:function(){return{newValue:this.value,isMouseDown:!1}},watch:{value:function(e){this.newValue=e},newValue:function(e){this.$emit("input",e)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(128),r=n.n(i),a=n(5),o=n(46),s=n(48),l=n(2),c=n(193),u=n.n(c),d=n(66),f=n.n(d);t.default={name:"BTable",components:{BPagination:s.a,BIcon:l.a,BCheckbox:o.a,BTableMobileSort:u.a,BTableColumn:f.a},props:{data:{type:Array,default:function(){return[]}},columns:{type:Array,default:function(){return[]}},bordered:Boolean,striped:Boolean,narrowed:Boolean,hoverable:Boolean,loading:Boolean,detailed:Boolean,checkable:Boolean,selected:Object,focusable:Boolean,customIsChecked:Function,isRowCheckable:{type:Function,default:function(){return!0}},checkedRows:{type:Array,default:function(){return[]}},mobileCards:{type:Boolean,default:!0},defaultSort:[String,Array],defaultSortDirection:{type:String,default:"asc"},paginated:Boolean,currentPage:{type:Number,default:1},perPage:{type:[Number,String],default:20},paginationSimple:Boolean,paginationSize:String,backendSorting:Boolean,rowClass:{type:Function,default:function(){return""}},openedDetailed:{type:Array,default:function(){return[]}},hasDetailedVisible:{type:Function,default:function(){return!0}},detailKey:{type:String,default:""},backendPagination:Boolean,total:{type:[Number,String],default:0}},data:function(){return{getValueByPath:a.c,newColumns:[].concat(r()(this.columns)),visibleDetailRows:this.openedDetailed,newData:this.data,newDataTotal:this.backendPagination?this.total:this.data.length,newCheckedRows:[].concat(r()(this.checkedRows)),newCurrentPage:this.currentPage,currentSortColumn:{},isAsc:!0,firstTimeSort:!0,_isTable:!0}},computed:{tableClasses:function(){return{"is-bordered":this.bordered,"is-striped":this.striped,"is-narrow":this.narrowed,"has-mobile-cards":this.mobileCards,"is-hoverable":(this.hoverable||this.focusable)&&this.visibleData.length}},visibleData:function(){if(!this.paginated)return this.newData;var e=this.newCurrentPage,t=this.perPage;if(this.newData.length<=t)return this.newData;var n=(e-1)*t,i=parseInt(n,10)+parseInt(t,10);return this.newData.slice(n,i)},isAllChecked:function(){var e=this;return!this.visibleData.filter(function(t){return e.isRowCheckable(t)}).some(function(t){return n.i(a.d)(e.newCheckedRows,t,e.customIsChecked)<0})},hasSortablenewColumns:function(){return this.newColumns.some(function(e){return e.sortable})},columnCount:function(){var e=this.newColumns.length;return e+=this.checkable?1:0,e+=this.detailed?1:0}},watch:{data:function(e){var t=this,n=this.newColumns;this.newColumns=[],this.newData=e,this.$nextTick(function(){t.newColumns.length||(t.newColumns=n)}),this.backendSorting||this.sort(this.currentSortColumn,!0),this.backendPagination||(this.newDataTotal=e.length)},total:function(e){this.backendPagination&&(this.newDataTotal=e)},checkedRows:function(e){this.newCheckedRows=[].concat(r()(e))},columns:function(e){this.newColumns=[].concat(r()(e))},newColumns:function(e){if(e.length&&this.firstTimeSort)this.initSort(),this.firstTimeSort=!1;else if(e.length)for(var t=0;t<e.length;t++)if(e[t].newKey===this.currentSortColumn.newKey){this.currentSortColumn=e[t];break}},openedDetailed:function(e){this.visibleDetailRows=e},currentPage:function(e){this.newCurrentPage=e}},methods:{sortBy:function(e,t,i,o){return i&&"function"==typeof i?[].concat(r()(e)).sort(function(e,t){return i(e,t,o)}):[].concat(r()(e)).sort(function(e,i){var r=n.i(a.c)(e,t),s=n.i(a.c)(i,t);return r||0===r?s||0===s?r===s?0:(r="string"==typeof r?r.toUpperCase():r,s="string"==typeof s?s.toUpperCase():s,o?r>s?1:-1:r>s?-1:1):-1:1})},sort:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];e&&e.sortable&&(t||(this.isAsc=e===this.currentSortColumn?!this.isAsc:"desc"!==this.defaultSortDirection.toLowerCase()),this.firstTimeSort||this.$emit("sort",e.field,this.isAsc?"asc":"desc"),this.backendSorting||(this.newData=this.sortBy(this.newData,e.field,e.customSort,this.isAsc)),this.currentSortColumn=e)},isRowChecked:function(e){return n.i(a.d)(this.newCheckedRows,e,this.customIsChecked)>=0},removeCheckedRow:function(e){var t=n.i(a.d)(this.newCheckedRows,e,this.customIsChecked);t>=0&&this.newCheckedRows.splice(t,1)},checkAll:function(){var e=this,t=this.isAllChecked;this.visibleData.forEach(function(n){e.removeCheckedRow(n),t||e.isRowCheckable(n)&&e.newCheckedRows.push(n)}),this.$emit("check",this.newCheckedRows),this.$emit("check-all",this.newCheckedRows),this.$emit("update:checkedRows",this.newCheckedRows)},checkRow:function(e){this.isRowChecked(e)?this.removeCheckedRow(e):this.newCheckedRows.push(e),this.$emit("check",this.newCheckedRows,e),this.$emit("update:checkedRows",this.newCheckedRows)},selectRow:function(e,t){this.$emit("click",e),this.selected!==e&&(this.$emit("select",e,this.selected),this.$emit("update:selected",e))},pageChanged:function(e){this.newCurrentPage=e>0?e:1,this.$emit("page-change",this.newCurrentPage),this.$emit("update:currentPage",this.newCurrentPage)},toggleDetails:function(e){this.isVisibleDetailRow(e)?(this.closeDetailRow(e),this.$emit("details-close",e)):(this.openDetailRow(e),this.$emit("details-open",e)),this.$emit("update:openedDetailed",this.visibleDetailRows)},openDetailRow:function(e){var t=this.handleDetailKey(e);this.visibleDetailRows.push(t)},closeDetailRow:function(e){var t=this.handleDetailKey(e),n=this.visibleDetailRows.indexOf(t);this.visibleDetailRows.splice(n,1)},isVisibleDetailRow:function(e){var t=this.handleDetailKey(e);return this.visibleDetailRows.indexOf(t)>=0},handleDetailKey:function(e){var t=this.detailKey;return t.length?e[t]:e},checkPredefinedDetailedRows:function(){if(this.openedDetailed.length>0&&!this.detailKey.length)throw new Error('If you set a predefined opened-detailed, you must provide an unique key using the prop "detail-key"')},hasCustomFooterSlot:function(){if(this.$slots.footer.length>1)return!0;var e=this.$slots.footer[0].tag;return"th"===e||"td"===e},pressedArrow:function(e){if(this.visibleData.length){var t=this.visibleData.indexOf(this.selected)+e;t=t<0?0:t>this.visibleData.length-1?this.visibleData.length-1:t,this.selectRow(this.visibleData[t])}},focus:function(){this.focusable&&this.$el.querySelector("table").focus()},initSort:function(){var e=this;if(this.defaultSort){var t="",n=this.defaultSortDirection;Array.isArray(this.defaultSort)?(t=this.defaultSort[0],this.defaultSort[1]&&(n=this.defaultSort[1])):t=this.defaultSort,this.newColumns.forEach(function(i){i.field===t&&(e.isAsc="desc"!==n.toLowerCase(),e.sort(i,!0))})}}},mounted:function(){this.checkPredefinedDetailedRows()}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),r=n.n(i);t.default={name:"BTableColumn",props:{label:String,customKey:[String,Number],field:String,meta:[String,Number,Boolean,Function,Object,Array,r.a],width:[Number,String],numeric:Boolean,centered:Boolean,sortable:Boolean,visible:{type:Boolean,default:!0},customSort:Function,internal:Boolean},data:function(){return{newKey:this.customKey||this.label}},computed:{rootClasses:function(){return{"has-text-right":this.numeric&&!this.centered,"has-text-centered":this.centered}}},created:function(){var e=this;if(!this.$parent.$data._isTable)throw this.$destroy(),new Error("You should wrap bTableColumn on a bTable");if(!this.internal){!this.$parent.columns.some(function(t){return t.newKey===e.newKey})&&this.$parent.columns.push(this)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(24),r=n(2);t.default={name:"BTableMobileSort",components:{BSelect:i.a,BIcon:r.a},props:{currentSortColumn:Object,isAsc:Boolean,columns:Array},data:function(){return{mobileSort:this.currentSortColumn}},watch:{mobileSort:function(e){this.currentSortColumn!==e&&this.$emit("sort",e)},currentSortColumn:function(e){this.mobileSort=e}},methods:{sort:function(){this.$emit("sort",this.mobileSort)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"BTabItem",props:{label:String,icon:String,iconPack:String,disabled:Boolean,visible:{type:Boolean,default:!0}},data:function(){return{isActive:!1,transitionName:null}},methods:{activate:function(e,t){this.$parent.animated?this.transitionName=t<e?"slide-next":"slide-prev":this.transitionName=null,this.isActive=!0},deactivate:function(e,t){this.$parent.animated?this.transitionName=t<e?"slide-next":"slide-prev":this.transitionName=null,this.isActive=!1}},created:function(){if(!this.$parent.$data._isTabs)throw this.$destroy(),new Error("You should wrap bTabItem on a bTabs");this.$parent.tabItems.push(this)},beforeDestroy:function(){var e=this.$parent.tabItems.indexOf(this);e>=0&&this.$parent.tabItems.splice(e,1)}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i,r=n(6),a=n.n(r),o=n(2),s=n(123);t.default={name:"BTabs",components:(i={},a()(i,o.a.name,o.a),a()(i,s.a.name,s.a),i),props:{value:[String,Number],expanded:Boolean,type:String,size:String,position:String,animated:{type:Boolean,default:!0}},data:function(){return{activeTab:this.value||0,tabItems:[],contentHeight:0,_isTabs:!0}},computed:{navClasses:function(){return[this.type,this.size,this.position,{"is-fullwidth":this.expanded,"is-toggle-rounded is-toggle":"is-toggle-rounded"===this.type}]}},watch:{value:function(e){this.changeTab(e)},tabItems:function(){this.tabItems.length&&(this.tabItems[this.activeTab].isActive=!0)}},methods:{changeTab:function(e){this.activeTab!==e&&(this.tabItems[this.activeTab].deactivate(this.activeTab,e),this.tabItems[e].activate(this.activeTab,e),this.activeTab=e,this.$emit("change",e))},tabClick:function(e){this.$emit("input",e),this.changeTab(e)}},mounted:function(){this.tabItems.length&&(this.tabItems[this.activeTab].isActive=!0)}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"BTag",props:{attached:Boolean,closable:Boolean,type:String,size:String,rounded:Boolean,disabled:Boolean,ellipsis:Boolean,tabstop:{type:Boolean,default:!0}},methods:{close:function(){this.disabled||this.$emit("close")}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"BTaglist",props:{attached:Boolean}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(52),r=n.n(i),a=n(6),o=n.n(a),s=n(5),l=n(45),c=n(10);t.default={name:"BTaginput",components:o()({},l.a.name,l.a),mixins:[c.a],inheritAttrs:!1,props:{value:{type:Array,default:function(){return[]}},data:{type:Array,default:function(){return[]}},type:String,rounded:{type:Boolean,default:!1},attached:{type:Boolean,default:!1},maxtags:{type:[Number,String],required:!1},field:{type:String,default:"value"},autocomplete:Boolean,disabled:Boolean,ellipsis:Boolean,confirmKeyCodes:{type:Array,default:function(){return[13,188]}},removeOnKeys:{type:Array,default:function(){return[8]}},allowNew:Boolean,onPasteSeparators:{type:Array,default:function(){return[","]}},beforeAdding:{type:Function,default:function(){return!0}}},data:function(){return{tags:this.value||[],newTag:"",_elementRef:"input",_isTaginput:!0}},computed:{rootClasses:function(){return{"is-expanded":this.expanded}},containerClasses:function(){return{"is-focused":this.isFocused,"is-focusable":this.hasInput}},valueLength:function(){return this.newTag.trim().length},defaultSlotName:function(){return this.hasDefaultSlot?"default":"dontrender"},emptySlotName:function(){return this.hasEmptySlot?"empty":"dontrender"},hasDefaultSlot:function(){return!!this.$scopedSlots.default},hasEmptySlot:function(){return!!this.$slots.empty},hasInput:function(){return null==this.maxtags||this.tagsLength<this.maxtags},tagsLength:function(){return this.tags.length},separatorsAsRegExp:function(){var e=this.onPasteSeparators;return e.length?new RegExp(e.map(function(e){return e?e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g,"\\$&"):null}).join("|"),"g"):null}},watch:{value:function(e){this.tags=e},newTag:function(e){this.$emit("typing",e.trim())},hasInput:function(){this.hasInput||this.onBlur()}},methods:{addTag:function(e){var t=e||this.newTag.trim();if(t){if(!this.autocomplete){var n=this.separatorsAsRegExp;if(n&&t.match(n))return void t.split(n).map(function(e){return e.trim()}).filter(function(e){return 0!==e.length}).map(this.addTag)}-1===this.tags.indexOf(t)&&this.beforeAdding(t)&&(this.tags.push(t),this.$emit("input",this.tags),this.$emit("add",t))}this.newTag=""},getNormalizedTagText:function(e){return"object"===(void 0===e?"undefined":r()(e))?n.i(s.c)(e,this.field):e},customOnBlur:function(e){this.autocomplete||this.addTag(),this.onBlur(e)},onSelect:function(e){var t=this;e&&(this.addTag(e),this.$nextTick(function(){t.newTag=""}))},removeTag:function(e){var t=this.tags.splice(e,1)[0];return this.$emit("input",this.tags),this.$emit("remove",t),t},removeLastTag:function(){this.tagsLength>0&&this.removeTag(this.tagsLength-1)},keydown:function(e){-1===this.removeOnKeys.indexOf(e.keyCode)||this.newTag.length||this.removeLastTag(),this.autocomplete&&!this.allowNew||this.confirmKeyCodes.indexOf(e.keyCode)>=0&&(e.preventDefault(),this.addTag())}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i,r=n(6),a=n.n(r),o=n(10),s=n(5),l=n(1),c=n(28),u=n(23),d=n(29),f=n(24),p=n(2),h="AM",v="PM",m=function(e){return(e<10?"0":"")+e},y=function(e,t){var n=e.getHours(),i=e.getMinutes(),r=!1;return"12"===t.hourFormat&&(r=n<12,n>12?n-=12:0===n&&(n=12)),m(n)+":"+m(i)+("12"===t.hourFormat?" "+(r?h:v):"")},g=function(e,t){if(e){var n=e,i=!1;if("12"===t.hourFormat){var r=e.split(" ");n=r[0],i=r[1]===h}var a=n.split(":"),o=parseInt(a[0],10),s=parseInt(a[1],10);if(isNaN(o)||o<0||o>23||"12"===t.hourFormat&&(o<1||o>12)||isNaN(s)||s<0||s>59)return null;var l=null;return t.dateSelected&&!isNaN(t.dateSelected)?l=new Date(t.dateSelected):(l=new Date,l.setMilliseconds(0),l.setSeconds(0)),l.setMinutes(s),"12"===t.hourFormat&&(i&&12===o?o=0:i||12===o||(o+=12)),l.setHours(o),l}return null};t.default={name:"BTimepicker",components:(i={},a()(i,u.a.name,u.a),a()(i,d.a.name,d.a),a()(i,f.a.name,f.a),a()(i,p.a.name,p.a),a()(i,c.a.name,c.a),a()(i,c.b.name,c.b),i),mixins:[o.a],inheritAttrs:!1,props:{value:Date,inline:Boolean,minTime:Date,maxTime:Date,placeholder:String,readonly:{type:Boolean,default:!0},disabled:{type:Boolean,default:!1},hourFormat:{type:String,default:"24",validator:function(e){return"24"===e||"12"===e}},incrementMinutes:{type:Number,default:1},timeFormatter:{type:Function,default:function(e,t){return"function"==typeof l.b.defaultTimeFormatter?l.b.defaultTimeFormatter(e):y(e,t)}},timeParser:{type:Function,default:function(e,t){return"function"==typeof l.b.defaultTimeParser?l.b.defaultTimeParser(e):g(e,t)}},mobileNative:{type:Boolean,default:function(){return l.b.defaultTimepickerMobileNative}},position:String,unselectableTimes:Array},data:function(){return{dateSelected:this.value,hoursSelected:null,minutesSelected:null,meridienSelected:null,_elementRef:"input",_isTimepicker:!0}},computed:{hours:function(){for(var e=[],t=this.isHourFormat24?24:12,n=0;n<t;n++){var i=n,r=i;this.isHourFormat24||(i=n+1,r=i,this.meridienSelected===h?12===i&&(i=0):this.meridienSelected===v&&12!==i&&(i+=12)),e.push({label:m(r),value:i})}return e},minutes:function(){for(var e=[],t=0;t<60;t+=this.incrementMinutes)e.push({label:m(t),value:t});return e},meridiens:function(){return[h,v]},isMobile:function(){return this.mobileNative&&s.b.any()},isHourFormat24:function(){return"24"===this.hourFormat}},watch:{hourFormat:function(e){null!==this.hoursSelected&&(this.meridienSelected=this.hoursSelected>=12?v:h)},dateSelected:function(e){this.$emit("input",e)},value:function(e){this.updateInternalState(e),this.dateSelected=e,!this.isValid&&this.$refs.input.checkHtml5Validity()}},methods:{onMeridienChange:function(e){null!==this.hoursSelected&&(e===v?0===this.hoursSelected?this.hoursSelected=12:this.hoursSelected+=12:e===h&&(12===this.hoursSelected?this.hoursSelected=0:this.hoursSelected-=12)),this.updateDateSelected(this.hoursSelected,this.minutesSelected,e)},onHoursChange:function(e){this.updateDateSelected(parseInt(e,10),this.minutesSelected,this.meridienSelected)},onMinutesChange:function(e){this.updateDateSelected(this.hoursSelected,parseInt(e,10),this.meridienSelected)},updateDateSelected:function(e,t,n){null!=e&&null!=t&&(!this.isHourFormat24&&null!==n||this.isHourFormat24)&&(this.dateSelected&&!isNaN(this.dateSelected)?this.dateSelected=new Date(this.dateSelected):(this.dateSelected=new Date,this.dateSelected.setMilliseconds(0),this.dateSelected.setSeconds(0)),this.dateSelected.setHours(e),this.dateSelected.setMinutes(t))},updateInternalState:function(e){e?(this.hoursSelected=e.getHours(),this.minutesSelected=e.getMinutes(),this.meridienSelected=e.getHours()>=12?v:h):(this.hoursSelected=null,this.minutesSelected=null,this.meridienSelected=h)},isHourDisabled:function(e){var t=this,n=!1;if(this.minTime){var i=this.minTime.getHours();n=e<i}if(this.maxTime&&!n){var r=this.maxTime.getHours();n=e>r}if(this.unselectableTimes&&!n)if(null!==this.minutesSelected){var a=this.unselectableTimes.filter(function(n){return n.getHours()===e&&n.getMinutes()===t.minutesSelected});n=a.length>0}else{var o=this.unselectableTimes.filter(function(t){return t.getHours()===e});n=o.length===this.minutes.length}return n},isMinuteDisabled:function(e){var t=this,n=!1;if(null!==this.hoursSelected){if(this.isHourDisabled(this.hoursSelected))n=!0;else{if(this.minTime){var i=this.minTime.getHours(),r=this.minTime.getMinutes();n=this.hoursSelected===i&&e<r}if(this.maxTime&&!n){var a=this.maxTime.getHours(),o=this.maxTime.getMinutes();n=this.hoursSelected===a&&e>o}}if(this.unselectableTimes&&!n){n=this.unselectableTimes.filter(function(n){return n.getHours()===t.hoursSelected&&n.getMinutes()===e}).length>0}}return n},onChange:function(e){var t=this.timeParser(e,this);this.updateInternalState(t),t&&!isNaN(t)?this.dateSelected=t:(this.dateSelected=null,this.$refs.input.newValue=this.dateSelected)},formatValue:function(e){return e&&!isNaN(e)?this.timeFormatter(e,this):null},close:function(){this.$refs.dropdown&&(this.$refs.dropdown.isActive=!1)},formatHHMMSS:function(e){var t=new Date(e);if(e&&!isNaN(t)){var n=t.getHours(),i=t.getMinutes();return m(n)+":"+m(i)+":00"}return""},onChangeNativePicker:function(e){var t=e.target.value;if(t){this.dateSelected&&!isNaN(this.dateSelected)?this.dateSelected=new Date(this.dateSelected):(this.dateSelected=new Date,this.dateSelected.setMilliseconds(0),this.dateSelected.setSeconds(0));var n=t.split(":");this.dateSelected.setHours(parseInt(n[0],10)),this.dateSelected.setMinutes(parseInt(n[1],10))}else this.dateSelected=null}},mounted:function(){this.updateInternalState(this.value)}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(1),r=n(50);t.default={name:"BToast",mixins:[r.a],data:function(){return{newDuration:this.duration||i.b.defaultToastDuration}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(1);t.default={name:"BTooltip",props:{active:{type:Boolean,default:!0},type:String,label:String,position:{type:String,default:"is-top",validator:function(e){return["is-top","is-bottom","is-left","is-right"].indexOf(e)>-1}},always:Boolean,animated:Boolean,square:Boolean,dashed:Boolean,multilined:Boolean,size:{type:String,default:"is-medium"}},computed:{newType:function(){return this.type||i.b.defaultTooltipType},newAnimated:function(){return this.animated||i.b.defaultTooltipAnimated}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(10);t.default={name:"BUpload",mixins:[i.a],inheritAttrs:!1,props:{value:{type:Array,default:function(){return[]}},multiple:Boolean,disabled:Boolean,accept:String,dragDrop:Boolean,type:{type:String,default:"is-primary"},native:{type:Boolean,default:!1}},data:function(){return{newValue:this.value||[],dragDropFocus:!1,_elementRef:"input"}},watch:{value:function(e){this.newValue=e,0===this.newValue.length&&(this.$refs.input.value=null),!this.isValid&&!this.dragDrop&&this.checkHtml5Validity()}},methods:{onFileChange:function(e){if(!this.disabled&&!this.loading){this.dragDrop&&this.updateDragDropFocus(!1);var t=e.target.files||e.dataTransfer.files;if(t&&t.length){if(this.multiple)this.native&&(this.newValue=[]);else if(this.dragDrop){if(1!==t.length)return!1;this.newValue=[]}else this.newValue=[];for(var n=0;n<t.length;n++){var i=t[n];this.checkType(i)&&this.newValue.push(i)}}this.$emit("input",this.newValue),!this.dragDrop&&this.checkHtml5Validity()}},updateDragDropFocus:function(e){this.disabled||this.loading||(this.dragDropFocus=e)},checkType:function(e){if(!this.accept)return!0;var t=this.accept.split(",");if(0===t.length)return!0;for(var n=!1,i=0;i<t.length&&!n;i++){var r=t[i].trim();if(r)if("."===r.substring(0,1)){var a=e.name.lastIndexOf(".");a>=0&&e.name.substring(a)===r&&(n=!0)}else e.type.match(r)&&(n=!0)}return n}}}},function(e,t,n){"use strict";var i=n(171),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(172),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";function i(e){return new(o.a.extend(l.a))({el:document.createElement("div"),propsData:e})}var r=n(13),a=n.n(r),o=n(22),s=n(175),l=n.n(s);t.a={alert:function(e){var t=void 0;"string"==typeof e&&(t=e);var n={canCancel:!1,message:t};return i(a()(n,e))},confirm:function(e){var t={};return i(a()(t,e))},prompt:function(e){var t={hasInput:!0,confirmText:"Done"};return i(a()(t,e))}}},function(e,t,n){"use strict";var i=n(13),r=n.n(i),a=n(22),o=n(181),s=n.n(o);n.d(t,"a",function(){return s.a}),t.b={open:function(e){var t={programmatic:!0},n=r()(t,e);return new(a.a.extend(s.a))({el:document.createElement("div"),propsData:n})}}},function(e,t,n){"use strict";var i=n(182),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(184),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(186),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(187),r=n.n(i),a=n(188),o=n.n(a);n.d(t,"a",function(){return r.a}),n.d(t,"b",function(){return o.a})},function(e,t,n){"use strict";var i=n(13),r=n.n(i),a=n(22),o=n(190),s=n.n(o);t.a={open:function(e){var t=void 0;"string"==typeof e&&(t=e);var n={type:"is-success",position:"is-bottom-right",message:t},i=r()(n,e);return new(a.a.extend(s.a))({el:document.createElement("div"),propsData:i})}}},function(e,t,n){"use strict";var i=n(191),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(192),r=n.n(i),a=n(66),o=n.n(a);n.d(t,"a",function(){return r.a}),n.d(t,"b",function(){return o.a})},function(e,t,n){"use strict";var i=n(195),r=n.n(i),a=n(194),o=n.n(a);n.d(t,"b",function(){return r.a}),n.d(t,"a",function(){return o.a})},function(e,t,n){"use strict";var i=n(196),r=n.n(i),a=n(197),o=n.n(a);n.d(t,"a",function(){return r.a}),n.d(t,"b",function(){return o.a})},function(e,t,n){"use strict";var i=n(198),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(199),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(13),r=n.n(i),a=n(22),o=n(200),s=n.n(o);t.a={open:function(e){var t=void 0;"string"==typeof e&&(t=e);var n={message:t},i=r()(n,e);return new(a.a.extend(s.a))({el:document.createElement("div"),propsData:i})}}},function(e,t,n){"use strict";var i=n(201),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";var i=n(202),r=n.n(i);t.a=r.a},function(e,t,n){"use strict";t.a={name:"BSlotComponent",props:{component:{type:Object,required:!0},name:{type:String,default:"default"},tag:{type:String,default:"div"},event:{type:String,default:"hook:updated"}},methods:{refresh:function(){this.$forceUpdate()},isVueComponent:function(){return this.component&&this.component._isVue}},created:function(){this.isVueComponent()&&this.component.$on(this.event,this.refresh)},beforeDestroy:function(){this.isVueComponent()&&this.component.$off(this.event,this.refresh)},render:function(e){if(this.isVueComponent()){var t=this.component.$slots[this.name];return e(this.tag,{},t)}}}},function(e,t,n){"use strict";n.d(t,"a",function(){return r});var i="undefined"==typeof window,r=i?Object:window.HTMLElement},function(e,t,n){e.exports={default:n(129),__esModule:!0}},function(e,t,n){e.exports={default:n(132),__esModule:!0}},function(e,t,n){e.exports={default:n(134),__esModule:!0}},function(e,t,n){"use strict";t.__esModule=!0;var i=n(125),r=function(e){return e&&e.__esModule?e:{default:e}}(i);t.default=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return(0,r.default)(e)}},function(e,t,n){n(43),n(157),e.exports=n(7).Array.from},function(e,t,n){n(64),n(43),e.exports=n(156)},function(e,t,n){n(159),e.exports=n(7).Object.assign},function(e,t,n){n(160);var i=n(7).Object;e.exports=function(e,t,n){return i.defineProperty(e,t,n)}},function(e,t,n){n(162),n(161),n(163),n(164),e.exports=n(7).Symbol},function(e,t,n){n(43),n(64),e.exports=n(42).f("iterator")},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t){e.exports=function(){}},function(e,t,n){var i=n(16),r=n(62),a=n(155);e.exports=function(e){return function(t,n,o){var s,l=i(t),c=r(l.length),u=a(o,c);if(e&&n!=n){for(;c>u;)if((s=l[u++])!=s)return!0}else for(;c>u;u++)if((e||u in l)&&l[u]===n)return e||u||0;return!e&&-1}}},function(e,t,n){var i=n(30),r=n(4)("toStringTag"),a="Arguments"==i(function(){return arguments}()),o=function(e,t){try{return e[t]}catch(e){}};e.exports=function(e){var t,n,s;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=o(t=Object(e),r))?n:a?i(t):"Object"==(s=i(t))&&"function"==typeof t.callee?"Arguments":s}},function(e,t,n){"use strict";var i=n(9),r=n(21);e.exports=function(e,t,n){t in e?i.f(e,t,r(0,n)):e[t]=n}},function(e,t,n){var i=n(25),r=n(34),a=n(26);e.exports=function(e){var t=i(e),n=r.f;if(n)for(var o,s=n(e),l=a.f,c=0;s.length>c;)l.call(e,o=s[c++])&&t.push(o);return t}},function(e,t,n){var i=n(8).document;e.exports=i&&i.documentElement},function(e,t,n){var i=n(20),r=n(4)("iterator"),a=Array.prototype;e.exports=function(e){return void 0!==e&&(i.Array===e||a[r]===e)}},function(e,t,n){var i=n(30);e.exports=Array.isArray||function(e){return"Array"==i(e)}},function(e,t,n){var i=n(14);e.exports=function(e,t,n,r){try{return r?t(i(n)[0],n[1]):t(n)}catch(t){var a=e.return;throw void 0!==a&&i(a.call(e)),t}}},function(e,t,n){"use strict";var i=n(58),r=n(21),a=n(35),o={};n(15)(o,n(4)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=i(o,{next:r(1,n)}),a(e,t+" Iterator")}},function(e,t,n){var i=n(4)("iterator"),r=!1;try{var a=[7][i]();a.return=function(){r=!0},Array.from(a,function(){throw 2})}catch(e){}e.exports=function(e,t){if(!t&&!r)return!1;var n=!1;try{var a=[7],o=a[i]();o.next=function(){return{done:n=!0}},a[i]=function(){return o},e(a)}catch(e){}return n}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){var i=n(27)("meta"),r=n(19),a=n(12),o=n(9).f,s=0,l=Object.isExtensible||function(){return!0},c=!n(18)(function(){return l(Object.preventExtensions({}))}),u=function(e){o(e,i,{value:{i:"O"+ ++s,w:{}}})},d=function(e,t){if(!r(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!a(e,i)){if(!l(e))return"F";if(!t)return"E";u(e)}return e[i].i},f=function(e,t){if(!a(e,i)){if(!l(e))return!0;if(!t)return!1;u(e)}return e[i].w},p=function(e){return c&&h.NEED&&l(e)&&!a(e,i)&&u(e),e},h=e.exports={KEY:i,NEED:!1,fastKey:d,getWeak:f,onFreeze:p}},function(e,t,n){"use strict";var i=n(25),r=n(34),a=n(26),o=n(39),s=n(56),l=Object.assign;e.exports=!l||n(18)(function(){var e={},t={},n=Symbol(),i="abcdefghijklmnopqrst";return e[n]=7,i.split("").forEach(function(e){t[e]=e}),7!=l({},e)[n]||Object.keys(l({},t)).join("")!=i})?function(e,t){for(var n=o(e),l=arguments.length,c=1,u=r.f,d=a.f;l>c;)for(var f,p=s(arguments[c++]),h=u?i(p).concat(u(p)):i(p),v=h.length,m=0;v>m;)d.call(p,f=h[m++])&&(n[f]=p[f]);return n}:l},function(e,t,n){var i=n(9),r=n(14),a=n(25);e.exports=n(11)?Object.defineProperties:function(e,t){r(e);for(var n,o=a(t),s=o.length,l=0;s>l;)i.f(e,n=o[l++],t[n]);return e}},function(e,t,n){var i=n(26),r=n(21),a=n(16),o=n(40),s=n(12),l=n(55),c=Object.getOwnPropertyDescriptor;t.f=n(11)?c:function(e,t){if(e=a(e),t=o(t,!0),l)try{return c(e,t)}catch(e){}if(s(e,t))return r(!i.f.call(e,t),e[t])}},function(e,t,n){var i=n(16),r=n(59).f,a={}.toString,o="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],s=function(e){try{return r(e)}catch(e){return o.slice()}};e.exports.f=function(e){return o&&"[object Window]"==a.call(e)?s(e):r(i(e))}},function(e,t,n){var i=n(12),r=n(39),a=n(36)("IE_PROTO"),o=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=r(e),i(e,a)?e[a]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?o:null}},function(e,t,n){var i=n(38),r=n(31);e.exports=function(e){return function(t,n){var a,o,s=String(r(t)),l=i(n),c=s.length;return l<0||l>=c?e?"":void 0:(a=s.charCodeAt(l),a<55296||a>56319||l+1===c||(o=s.charCodeAt(l+1))<56320||o>57343?e?s.charAt(l):a:e?s.slice(l,l+2):o-56320+(a-55296<<10)+65536)}}},function(e,t,n){var i=n(38),r=Math.max,a=Math.min;e.exports=function(e,t){return e=i(e),e<0?r(e+t,0):a(e,t)}},function(e,t,n){var i=n(14),r=n(63);e.exports=n(7).getIterator=function(e){var t=r(e);if("function"!=typeof t)throw TypeError(e+" is not iterable!");return i(t.call(e))}},function(e,t,n){"use strict";var i=n(53),r=n(17),a=n(39),o=n(144),s=n(142),l=n(62),c=n(139),u=n(63);r(r.S+r.F*!n(146)(function(e){Array.from(e)}),"Array",{from:function(e){var t,n,r,d,f=a(e),p="function"==typeof this?this:Array,h=arguments.length,v=h>1?arguments[1]:void 0,m=void 0!==v,y=0,g=u(f);if(m&&(v=i(v,h>2?arguments[2]:void 0,2)),void 0==g||p==Array&&s(g))for(t=l(f.length),n=new p(t);t>y;y++)c(n,y,m?v(f[y],y):f[y]);else for(d=g.call(f),n=new p;!(r=d.next()).done;y++)c(n,y,m?o(d,v,[r.value,y],!0):r.value);return n.length=y,n}})},function(e,t,n){"use strict";var i=n(136),r=n(147),a=n(20),o=n(16);e.exports=n(57)(Array,"Array",function(e,t){this._t=o(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,r(1)):"keys"==t?r(0,n):"values"==t?r(0,e[n]):r(0,[n,e[n]])},"values"),a.Arguments=a.Array,i("keys"),i("values"),i("entries")},function(e,t,n){var i=n(17);i(i.S+i.F,"Object",{assign:n(149)})},function(e,t,n){var i=n(17);i(i.S+i.F*!n(11),"Object",{defineProperty:n(9).f})},function(e,t){},function(e,t,n){"use strict";var i=n(8),r=n(12),a=n(11),o=n(17),s=n(61),l=n(148).KEY,c=n(18),u=n(37),d=n(35),f=n(27),p=n(4),h=n(42),v=n(41),m=n(140),y=n(143),g=n(14),b=n(19),_=n(16),w=n(40),k=n(21),C=n(58),x=n(152),S=n(151),D=n(9),$=n(25),A=S.f,O=D.f,T=x.f,M=i.Symbol,P=i.JSON,B=P&&P.stringify,F=p("_hidden"),V=p("toPrimitive"),I={}.propertyIsEnumerable,E=u("symbol-registry"),N=u("symbols"),j=u("op-symbols"),R=Object.prototype,L="function"==typeof M,z=i.QObject,H=!z||!z.prototype||!z.prototype.findChild,W=a&&c(function(){return 7!=C(O({},"a",{get:function(){return O(this,"a",{value:7}).a}})).a})?function(e,t,n){var i=A(R,t);i&&delete R[t],O(e,t,n),i&&e!==R&&O(R,t,i)}:O,q=function(e){var t=N[e]=C(M.prototype);return t._k=e,t},Y=L&&"symbol"==typeof M.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof M},U=function(e,t,n){return e===R&&U(j,t,n),g(e),t=w(t,!0),g(n),r(N,t)?(n.enumerable?(r(e,F)&&e[F][t]&&(e[F][t]=!1),n=C(n,{enumerable:k(0,!1)})):(r(e,F)||O(e,F,k(1,{})),e[F][t]=!0),W(e,t,n)):O(e,t,n)},K=function(e,t){g(e);for(var n,i=m(t=_(t)),r=0,a=i.length;a>r;)U(e,n=i[r++],t[n]);return e},G=function(e,t){return void 0===t?C(e):K(C(e),t)},J=function(e){var t=I.call(this,e=w(e,!0));return!(this===R&&r(N,e)&&!r(j,e))&&(!(t||!r(this,e)||!r(N,e)||r(this,F)&&this[F][e])||t)},X=function(e,t){if(e=_(e),t=w(t,!0),e!==R||!r(N,t)||r(j,t)){var n=A(e,t);return!n||!r(N,t)||r(e,F)&&e[F][t]||(n.enumerable=!0),n}},Q=function(e){for(var t,n=T(_(e)),i=[],a=0;n.length>a;)r(N,t=n[a++])||t==F||t==l||i.push(t);return i},Z=function(e){for(var t,n=e===R,i=T(n?j:_(e)),a=[],o=0;i.length>o;)!r(N,t=i[o++])||n&&!r(R,t)||a.push(N[t]);return a};L||(M=function(){if(this instanceof M)throw TypeError("Symbol is not a constructor!");var e=f(arguments.length>0?arguments[0]:void 0),t=function(n){this===R&&t.call(j,n),r(this,F)&&r(this[F],e)&&(this[F][e]=!1),W(this,e,k(1,n))};return a&&H&&W(R,e,{configurable:!0,set:t}),q(e)},s(M.prototype,"toString",function(){return this._k}),S.f=X,D.f=U,n(59).f=x.f=Q,n(26).f=J,n(34).f=Z,a&&!n(33)&&s(R,"propertyIsEnumerable",J,!0),h.f=function(e){return q(p(e))}),o(o.G+o.W+o.F*!L,{Symbol:M});for(var ee="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),te=0;ee.length>te;)p(ee[te++]);for(var ne=$(p.store),ie=0;ne.length>ie;)v(ne[ie++]);o(o.S+o.F*!L,"Symbol",{for:function(e){return r(E,e+="")?E[e]:E[e]=M(e)},keyFor:function(e){if(!Y(e))throw TypeError(e+" is not a symbol!");for(var t in E)if(E[t]===e)return t},useSetter:function(){H=!0},useSimple:function(){H=!1}}),o(o.S+o.F*!L,"Object",{create:G,defineProperty:U,defineProperties:K,getOwnPropertyDescriptor:X,getOwnPropertyNames:Q,getOwnPropertySymbols:Z}),P&&o(o.S+o.F*(!L||c(function(){var e=M();return"[null]"!=B([e])||"{}"!=B({a:e})||"{}"!=B(Object(e))})),"JSON",{stringify:function(e){for(var t,n,i=[e],r=1;arguments.length>r;)i.push(arguments[r++]);if(n=t=i[1],(b(t)||void 0!==e)&&!Y(e))return y(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!Y(t))return t}),i[1]=t,B.apply(P,i)}}),M.prototype[V]||n(15)(M.prototype,V,M.prototype.valueOf),d(M,"Symbol"),d(Math,"Math",!0),d(i.JSON,"JSON",!0)},function(e,t,n){n(41)("asyncIterator")},function(e,t,n){n(41)("observable")},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function i(){throw new Error("clearTimeout has not been defined")}function r(e){if(u===setTimeout)return setTimeout(e,0);if((u===n||!u)&&setTimeout)return u=setTimeout,setTimeout(e,0);try{return u(e,0)}catch(t){try{return u.call(null,e,0)}catch(t){return u.call(this,e,0)}}}function a(e){if(d===clearTimeout)return clearTimeout(e);if((d===i||!d)&&clearTimeout)return d=clearTimeout,clearTimeout(e);try{return d(e)}catch(t){try{return d.call(null,e)}catch(t){return d.call(this,e)}}}function o(){v&&p&&(v=!1,p.length?h=p.concat(h):m=-1,h.length&&s())}function s(){if(!v){var e=r(o);v=!0;for(var t=h.length;t;){for(p=h,h=[];++m<t;)p&&p[m].run();m=-1,t=h.length}p=null,v=!1,a(e)}}function l(e,t){this.fun=e,this.array=t}function c(){}var u,d,f=e.exports={};(function(){try{u="function"==typeof setTimeout?setTimeout:n}catch(e){u=n}try{d="function"==typeof clearTimeout?clearTimeout:i}catch(e){d=i}})();var p,h=[],v=!1,m=-1;f.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];h.push(new l(e,t)),1!==h.length||v||r(s)},l.prototype.run=function(){this.fun.apply(null,this.array)},f.title="browser",f.browser=!0,f.env={},f.argv=[],f.version="",f.versions={},f.on=c,f.addListener=c,f.once=c,f.off=c,f.removeListener=c,f.removeAllListeners=c,f.emit=c,f.prependListener=c,f.prependOnceListener=c,f.listeners=function(e){return[]},f.binding=function(e){throw new Error("process.binding is not supported")},f.cwd=function(){return"/"},f.chdir=function(e){throw new Error("process.chdir is not supported")},f.umask=function(){return 0}},function(e,t,n){(function(e,t){(function(e,n){"use strict";function i(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),n=0;n<t.length;n++)t[n]=arguments[n+1];var i={callback:e,args:t};return c[l]=i,s(l),l++}function r(e){delete c[e]}function a(e){var t=e.callback,i=e.args;switch(i.length){case 0:t();break;case 1:t(i[0]);break;case 2:t(i[0],i[1]);break;case 3:t(i[0],i[1],i[2]);break;default:t.apply(n,i)}}function o(e){if(u)setTimeout(o,0,e);else{var t=c[e];if(t){u=!0;try{a(t)}finally{r(e),u=!1}}}}if(!e.setImmediate){var s,l=1,c={},u=!1,d=e.document,f=Object.getPrototypeOf&&Object.getPrototypeOf(e);f=f&&f.setTimeout?f:e,"[object process]"==={}.toString.call(e.process)?function(){s=function(e){t.nextTick(function(){o(e)})}}():!function(){if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}}()?e.MessageChannel?function(){var e=new MessageChannel;e.port1.onmessage=function(e){o(e.data)},s=function(t){e.port2.postMessage(t)}}():d&&"onreadystatechange"in d.createElement("script")?function(){var e=d.documentElement;s=function(t){var n=d.createElement("script");n.onreadystatechange=function(){o(t),n.onreadystatechange=null,e.removeChild(n),n=null},e.appendChild(n)}}():function(){s=function(e){setTimeout(o,0,e)}}():function(){var t="setImmediate$"+Math.random()+"$",n=function(n){n.source===e&&"string"==typeof n.data&&0===n.data.indexOf(t)&&o(+n.data.slice(t.length))};e.addEventListener?e.addEventListener("message",n,!1):e.attachEvent("onmessage",n),s=function(n){e.postMessage(t+n,"*")}}(),f.setImmediate=i,f.clearImmediate=r}})("undefined"==typeof self?void 0===e?this:e:self)}).call(t,n(44),n(165))},function(e,t,n){(function(e){function i(e,t){this._id=e,this._clearFn=t}var r=Function.prototype.apply;t.setTimeout=function(){return new i(r.call(setTimeout,window,arguments),clearTimeout)},t.setInterval=function(){return new i(r.call(setInterval,window,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},i.prototype.unref=i.prototype.ref=function(){},i.prototype.close=function(){this._clearFn.call(window,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout(function(){e._onTimeout&&e._onTimeout()},t))},n(166),t.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==e&&e.setImmediate||this&&this.setImmediate,t.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==e&&e.clearImmediate||this&&this.clearImmediate}).call(t,n(44))},function(e,t,n){var i=n(0)(n(68),n(232),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(69),n(220),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(70),n(226),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(71),n(227),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(72),n(237),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(73),n(229),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(74),n(234),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(75),n(218),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(76),n(208),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(77),n(212),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(78),n(222),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(80),n(221),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(81),n(233),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(82),n(213),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(83),n(215),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(84),n(236),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(85),n(225),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(86),n(205),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(87),n(217),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(88),n(223),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(89),n(207),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(90),n(211),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(91),n(230),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(92),n(214),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(93),n(219),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(95),n(224),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(96),n(206),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(97),n(235),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(98),n(238),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(99),n(228),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(100),n(231),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(101),n(203),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(102),n(204),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(103),n(209),null,null,null);e.exports=i.exports},function(e,t,n){var i=n(0)(n(104),n(210),null,null,null);e.exports=i.exports},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"timepicker control",class:[e.size,{"is-expanded":e.expanded}]},[!e.isMobile||e.inline?n("b-dropdown",{ref:"dropdown",attrs:{position:e.position,disabled:e.disabled,inline:e.inline}},[e.inline?e._e():n("b-input",e._b({ref:"input",attrs:{slot:"trigger",autocomplete:"off",value:e.formatValue(e.dateSelected),placeholder:e.placeholder,size:e.size,icon:e.icon,"icon-pack":e.iconPack,loading:e.loading,disabled:e.disabled,readonly:e.readonly,rounded:e.rounded},on:{focus:function(t){e.$emit("focus",t)},blur:function(t){e.$emit("blur",t)&&e.checkHtml5Validity()}},nativeOn:{change:function(t){e.onChange(t.target.value)}},slot:"trigger"},"b-input",e.$attrs,!1)),e._v(" "),n("b-dropdown-item",{attrs:{disabled:e.disabled,custom:""}},[n("div",{staticClass:"pagination-list"},[n("b-field",[n("b-select",{attrs:{disabled:e.disabled,placeholder:"00"},nativeOn:{change:function(t){e.onHoursChange(t.target.value)}},model:{value:e.hoursSelected,callback:function(t){e.hoursSelected=t},expression:"hoursSelected"}},e._l(e.hours,function(t){return n("option",{key:t.value,attrs:{disabled:e.isHourDisabled(t.value)},domProps:{value:t.value}},[e._v("\n                            "+e._s(t.label)+"\n                        ")])})),e._v(" "),n("b-select",{attrs:{disabled:e.disabled,placeholder:"00"},nativeOn:{change:function(t){e.onMinutesChange(t.target.value)}},model:{value:e.minutesSelected,callback:function(t){e.minutesSelected=t},expression:"minutesSelected"}},e._l(e.minutes,function(t){return n("option",{key:t.value,attrs:{disabled:e.isMinuteDisabled(t.value)},domProps:{value:t.value}},[e._v("\n                            "+e._s(t.label)+"\n                        ")])})),e._v(" "),e.isHourFormat24?e._e():n("b-select",{attrs:{disabled:e.disabled},nativeOn:{change:function(t){e.onMeridienChange(t.target.value)}},model:{value:e.meridienSelected,callback:function(t){e.meridienSelected=t},expression:"meridienSelected"}},e._l(e.meridiens,function(t){return n("option",{key:t,domProps:{value:t}},[e._v("\n                            "+e._s(t)+"\n                        ")])}))],1)],1),e._v(" "),void 0!==e.$slots.default&&e.$slots.default.length?n("footer",{staticClass:"timepicker-footer"},[e._t("default")],2):e._e()])],1):n("b-input",e._b({ref:"input",attrs:{type:"time",autocomplete:"off",value:e.formatHHMMSS(e.value),placeholder:e.placeholder,size:e.size,icon:e.icon,"icon-pack":e.iconPack,loading:e.loading,max:e.formatHHMMSS(e.maxTime),min:e.formatHHMMSS(e.minTime),disabled:e.disabled,readonly:!1},on:{focus:function(t){e.$emit("focus",t)},blur:function(t){e.$emit("blur",t)&&e.checkHtml5Validity()}},nativeOn:{change:function(t){e.onChangeNativePicker(t)}}},"b-input",e.$attrs,!1))],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{"enter-active-class":e.transition.enter,"leave-active-class":e.transition.leave}},[n("div",{directives:[{name:"show",rawName:"v-show",value:e.isActive,expression:"isActive"}],staticClass:"toast",class:[e.type,e.position]},[n("div",{domProps:{innerHTML:e._s(e.message)}})])])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"pagination",class:e.rootClasses},[n("a",{staticClass:"pagination-previous",attrs:{role:"button",href:"#",disabled:!e.hasPrev},on:{click:function(t){t.preventDefault(),e.prev(t)}}},[n("b-icon",{attrs:{icon:"chevron-left",both:""}})],1),e._v(" "),n("a",{staticClass:"pagination-next",attrs:{role:"button",href:"#",disabled:!e.hasNext},on:{click:function(t){t.preventDefault(),e.next(t)}}},[n("b-icon",{attrs:{icon:"chevron-right",both:""}})],1),e._v(" "),e.simple?e._e():n("ul",{staticClass:"pagination-list"},[e.hasFirst?n("li",[n("a",{staticClass:"pagination-link",attrs:{role:"button",href:"#"},on:{click:function(t){t.preventDefault(),e.first(t)}}},[e._v("\n                1\n            ")])]):e._e(),e._v(" "),e.hasFirstEllipsis?n("li",[n("span",{staticClass:"pagination-ellipsis"},[e._v("…")])]):e._e(),e._v(" "),e._l(e.pagesInRange,function(t){return n("li",{key:t.number},[n("a",{staticClass:"pagination-link",class:{"is-current":t.isCurrent},attrs:{role:"button",href:"#"},on:{click:function(e){e.preventDefault(),t.click(e)}}},[e._v("\n                "+e._s(t.number)+"\n            ")])])}),e._v(" "),e.hasLastEllipsis?n("li",[n("span",{staticClass:"pagination-ellipsis"},[e._v("…")])]):e._e(),e._v(" "),e.hasLast?n("li",[n("a",{staticClass:"pagination-link",attrs:{role:"button",href:"#"},on:{click:function(t){t.preventDefault(),e.last(t)}}},[e._v("\n                "+e._s(e.pageCount)+"\n            ")])]):e._e()],2),e._v(" "),e.simple?n("small",{staticClass:"info"},[e._v("\n        "+e._s(e.firstItem)+"-"+e._s(Math.min(e.current*e.perPage,e.total))+" / "+e._s(e.total)+"\n    ")]):e._e()])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{name:e.transitionName}},[n("div",{directives:[{name:"show",rawName:"v-show",value:e.isActive&&e.visible,expression:"isActive && visible"}],staticClass:"tab-item"},[e._t("default")],2)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"control"},[n("label",{ref:"label",staticClass:"b-radio radio button",class:[e.newValue===e.nativeValue?e.type:null,e.size],attrs:{disabled:e.disabled,tabindex:!e.disabled&&0},on:{keydown:function(t){if(!("button"in t)&&e._k(t.keyCode,"enter",13,t.key)&&e._k(t.keyCode,"space",32,t.key))return null;t.preventDefault(),e.$refs.label.click()}}},[e._t("default"),e._v(" "),n("input",{directives:[{name:"model",rawName:"v-model",value:e.newValue,expression:"newValue"}],attrs:{type:"radio",disabled:e.disabled,name:e.name},domProps:{value:e.nativeValue,checked:e._q(e.newValue,e.nativeValue)},on:{change:function(t){e.newValue=e.nativeValue}}})],2)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"dropdown",class:e.rootClasses},[e.inline?e._e():n("div",{ref:"trigger",staticClass:"dropdown-trigger",attrs:{role:"button"},on:{click:function(t){t.stopPropagation(),e.toggle(t)}}},[e._t("trigger")],2),e._v(" "),n("transition",{attrs:{name:"fade"}},[e.isMobileModal?n("div",{directives:[{name:"show",rawName:"v-show",value:e.isActive,expression:"isActive"}],staticClass:"background"}):e._e()]),e._v(" "),n("transition",{attrs:{name:"fade"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:!e.disabled&&(e.isActive||e.hoverable)||e.inline,expression:"(!disabled && (isActive || hoverable)) || inline"}],ref:"dropdownMenu",staticClass:"dropdown-menu"},[n("div",{staticClass:"dropdown-content"},[e._t("default")],2)])])],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("span",{class:[e.newType,e.position,e.size,{tooltip:e.active,"is-square":e.square,"is-animated":e.newAnimated,"is-always":e.always,"is-multiline":e.multilined,"is-dashed":e.dashed}],attrs:{"data-label":e.label}},[e._t("default")],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("label",{staticClass:"upload control"},[e.dragDrop?n("div",{staticClass:"upload-draggable",class:[e.type,{"is-loading":e.loading,"is-disabled":e.disabled,"is-hovered":e.dragDropFocus}],on:{dragover:function(t){t.preventDefault(),e.updateDragDropFocus(!0)},dragleave:function(t){t.preventDefault(),e.updateDragDropFocus(!1)},dragenter:function(t){t.preventDefault(),e.updateDragDropFocus(!0)},drop:function(t){t.preventDefault(),e.onFileChange(t)}}},[e._t("default")],2):[e._t("default")],e._v(" "),n("input",e._b({ref:"input",attrs:{type:"file",multiple:e.multiple,accept:e.accept,disabled:e.disabled},on:{change:e.onFileChange}},"input",e.$attrs,!1))],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"control",class:{"is-expanded":e.expanded,"has-icons-left":e.icon}},[n("span",{staticClass:"select",class:e.spanClasses},[n("select",e._b({directives:[{name:"model",rawName:"v-model",value:e.selected,expression:"selected"}],ref:"select",attrs:{multiple:e.multiple,size:e.nativeSize},on:{blur:function(t){e.$emit("blur",t)&&e.checkHtml5Validity()},focus:function(t){e.$emit("focus",t)},change:function(t){var n=Array.prototype.filter.call(t.target.options,function(e){return e.selected}).map(function(e){return"_value"in e?e._value:e.value});e.selected=t.target.multiple?n:n[0]}}},"select",e.$attrs,!1),[e.placeholder?n("option",{attrs:{selected:"",disabled:"",hidden:""},domProps:{value:null}},[e._v("\n                "+e._s(e.placeholder)+"\n            ")]):e._e(),e._v(" "),e._t("default")],2)]),e._v(" "),e.icon?n("b-icon",{staticClass:"is-left",attrs:{icon:e.icon,pack:e.iconPack,size:e.iconSize}}):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return e.separator?n("hr",{staticClass:"dropdown-divider"}):e.custom||e.hasLink?n("div",{class:e.itemClasses,on:{click:e.selectItem}},[e._t("default")],2):n("a",{staticClass:"dropdown-item",class:e.anchorClasses,on:{click:e.selectItem}},[e._t("default")],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{name:e.animation}},[e.isActive?n("div",{staticClass:"loading-overlay is-active",class:{"is-full-page":e.isFullPage}},[n("div",{staticClass:"loading-background",on:{click:e.cancel}}),e._v(" "),n("div",{staticClass:"loading-icon"})]):e._e()])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("label",{ref:"label",staticClass:"switch",class:[e.size,{"is-disabled":e.disabled}],attrs:{disabled:e.disabled,tabindex:!e.disabled&&0},on:{keydown:function(t){if(!("button"in t)&&e._k(t.keyCode,"enter",13,t.key)&&e._k(t.keyCode,"space",32,t.key))return null;t.preventDefault(),e.$refs.label.click()},mousedown:function(t){e.isMouseDown=!0},mouseup:function(t){e.isMouseDown=!1},mouseout:function(t){e.isMouseDown=!1},blur:function(t){e.isMouseDown=!1}}},[n("input",{directives:[{name:"model",rawName:"v-model",value:e.newValue,expression:"newValue"}],attrs:{type:"checkbox",disabled:e.disabled,name:e.name,"true-value":e.trueValue,"false-value":e.falseValue},domProps:{value:e.nativeValue,checked:Array.isArray(e.newValue)?e._i(e.newValue,e.nativeValue)>-1:e._q(e.newValue,e.trueValue)},on:{click:function(e){e.stopPropagation()},change:function(t){var n=e.newValue,i=t.target,r=i.checked?e.trueValue:e.falseValue;if(Array.isArray(n)){var a=e.nativeValue,o=e._i(n,a);i.checked?o<0&&(e.newValue=n.concat([a])):o>-1&&(e.newValue=n.slice(0,o).concat(n.slice(o+1)))}else e.newValue=r}}}),e._v(" "),n("span",{staticClass:"check",class:[{"is-elastic":e.isMouseDown&&!e.disabled},e.type]}),e._v(" "),n("span",{staticClass:"control-label"},[e._t("default")],2)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{name:"fade"}},[e.isActive?n("article",{staticClass:"message",class:[e.type,e.size]},[e.title?n("header",{staticClass:"message-header"},[n("p",[e._v(e._s(e.title))]),e._v(" "),e.closable?n("button",{staticClass:"delete",attrs:{type:"button"},on:{click:e.close}}):e._e()]):e._e(),e._v(" "),n("section",{staticClass:"message-body"},[n("div",{staticClass:"media"},[e.icon&&e.hasIcon?n("div",{staticClass:"media-left"},[n("b-icon",{class:e.type,attrs:{icon:e.icon,both:"",size:e.newIconSize}})],1):e._e(),e._v(" "),n("div",{staticClass:"media-content"},[e._t("default")],2)])])]):e._e()])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return e.visible?n("td",{class:e.rootClasses,attrs:{"data-label":e.label}},[n("span",[e._t("default")],2)]):e._e()},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("nav",{staticClass:"panel"},[n("div",{staticClass:"panel-heading",class:{"is-collapsible":e.collapsible},on:{click:e.toggle}},[e.header?n("span",{domProps:{innerHTML:e._s(e.header)}}):e._t("header"),e._v(" "),e.collapsible?n("b-icon",{staticClass:"is-pulled-right",attrs:{both:"",icon:e.isOpen?"menu-up":"menu-down"}}):e._e()],2),e._v(" "),n("transition",{attrs:{name:e.animation}},[n("div",{directives:[{name:"show",rawName:"v-show",value:e.isOpen,expression:"isOpen"}],staticClass:"panel-content",class:{"panel-block":!e.hasCustomTemplate}},[e.content?n("div",{domProps:{innerHTML:e._s(e.content)}}):e._t("default")],2)])],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{name:e.animation}},[e.isActive?n("div",{staticClass:"dialog modal is-active",class:e.size},[n("div",{staticClass:"modal-background",on:{click:function(t){e.cancel("outside")}}}),e._v(" "),n("div",{staticClass:"modal-card animation-content"},[e.title?n("header",{staticClass:"modal-card-head"},[n("p",{staticClass:"modal-card-title"},[e._v(e._s(e.title))])]):e._e(),e._v(" "),n("section",{staticClass:"modal-card-body",class:{"is-titleless":!e.title,"is-flex":e.hasIcon}},[n("div",{staticClass:"media"},[e.hasIcon?n("div",{staticClass:"media-left"},[n("b-icon",{attrs:{icon:e.icon?e.icon:e.iconByType,pack:e.iconPack,type:e.type,both:!e.icon,size:"is-large"}})],1):e._e(),e._v(" "),n("div",{staticClass:"media-content"},[n("p",{domProps:{innerHTML:e._s(e.message)}}),e._v(" "),e.hasInput?n("div",{staticClass:"field"},[n("div",{staticClass:"control"},[n("input",e._b({directives:[{name:"model",rawName:"v-model",value:e.prompt,expression:"prompt"}],ref:"input",staticClass:"input",class:{"is-danger":e.validationMessage},domProps:{value:e.prompt},on:{keyup:function(t){if(!("button"in t)&&e._k(t.keyCode,"enter",13,t.key))return null;e.confirm(t)},input:function(t){t.target.composing||(e.prompt=t.target.value)}}},"input",e.inputAttrs,!1))]),e._v(" "),n("p",{staticClass:"help is-danger"},[e._v(e._s(e.validationMessage))])]):e._e()])])]),e._v(" "),n("footer",{staticClass:"modal-card-foot"},[e.showCancel?n("button",{ref:"cancelButton",staticClass:"button",on:{click:function(t){e.cancel("button")}}},[e._v("\n                    "+e._s(e.cancelText)+"\n                ")]):e._e(),e._v(" "),n("button",{ref:"confirmButton",staticClass:"button",class:e.type,on:{click:e.confirm}},[e._v("\n                    "+e._s(e.confirmText)+"\n                ")])])])]):e._e()])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"b-table",class:{"is-loading":e.loading}},[e.mobileCards&&e.hasSortablenewColumns?n("b-table-mobile-sort",{attrs:{"current-sort-column":e.currentSortColumn,"is-asc":e.isAsc,columns:e.newColumns},on:{sort:function(t){return e.sort(t)}}}):e._e(),e._v(" "),n("div",{staticClass:"table-wrapper"},[n("table",{staticClass:"table",class:e.tableClasses,attrs:{tabindex:!!e.focusable&&0},on:{keydown:[function(t){if(!("button"in t)&&e._k(t.keyCode,"up",38,t.key))return null;t.preventDefault(),e.pressedArrow(-1)},function(t){if(!("button"in t)&&e._k(t.keyCode,"down",40,t.key))return null;t.preventDefault(),e.pressedArrow(1)}]}},[e.newColumns.length?n("thead",[n("tr",[e.detailed?n("th",{attrs:{width:"40px"}}):e._e(),e._v(" "),e.checkable?n("th",{staticClass:"checkbox-cell"},[n("b-checkbox",{attrs:{value:e.isAllChecked},nativeOn:{change:function(t){e.checkAll(t)}}})],1):e._e(),e._v(" "),e._l(e.newColumns,function(t,i){return t.visible||void 0===t.visible?n("th",{key:i,class:{"is-current-sort":e.currentSortColumn===t,"is-sortable":t.sortable},style:{width:t.width+"px"},on:{click:function(n){n.stopPropagation(),e.sort(t)}}},[n("div",{staticClass:"th-wrap",class:{"is-numeric":t.numeric,"is-centered":t.centered}},[e.$scopedSlots.header?e._t("header",null,{column:t,index:i}):[e._v(e._s(t.label))],e._v(" "),n("b-icon",{directives:[{name:"show",rawName:"v-show",value:e.currentSortColumn===t,expression:"currentSortColumn === column"}],class:{"is-desc":!e.isAsc},attrs:{icon:"arrow-up",both:"",size:"is-small"}})],2)]):e._e()})],2)]):e._e(),e._v(" "),e.visibleData.length?n("tbody",[e._l(e.visibleData,function(t,i){return[n("tr",{key:i,class:[e.rowClass(t,i),{"is-selected":t===e.selected,"is-checked":e.isRowChecked(t)}],on:{click:function(n){e.selectRow(t)},dblclick:function(n){e.$emit("dblclick",t)}}},[e.detailed?n("td",{staticClass:"chevron-cell"},[e.hasDetailedVisible(t)?n("a",{attrs:{role:"button"},on:{click:function(n){n.stopPropagation(),e.toggleDetails(t)}}},[n("b-icon",{class:{"is-expanded":e.isVisibleDetailRow(t)},attrs:{icon:"chevron-right",both:""}})],1):e._e()]):e._e(),e._v(" "),e.checkable?n("td",{staticClass:"checkbox-cell"},[n("b-checkbox",{attrs:{disabled:!e.isRowCheckable(t),value:e.isRowChecked(t)},nativeOn:{change:function(n){e.checkRow(t)}}})],1):e._e(),e._v(" "),e.$scopedSlots.default?e._t("default",null,{row:t,index:i}):e._l(e.newColumns,function(i){return n("BTableColumn",e._b({key:i.field,attrs:{internal:""}},"BTableColumn",i,!1),[i.renderHtml?n("span",{domProps:{innerHTML:e._s(e.getValueByPath(t,i.field))}}):[e._v("\n                                    "+e._s(e.getValueByPath(t,i.field))+"\n                                ")]],2)})],2),e._v(" "),e.detailed&&e.isVisibleDetailRow(t)?n("tr",{staticClass:"detail"},[n("td",{attrs:{colspan:e.columnCount}},[n("div",{staticClass:"detail-container"},[e._t("detail",null,{row:t,index:i})],2)])]):e._e()]})],2):n("tbody",[n("tr",{staticClass:"is-empty"},[n("td",{attrs:{colspan:e.columnCount}},[e._t("empty")],2)])]),e._v(" "),void 0!==e.$slots.footer?n("tfoot",[n("tr",{staticClass:"table-footer"},[e.hasCustomFooterSlot()?e._t("footer"):n("th",{attrs:{colspan:e.columnCount}},[e._t("footer")],2)],2)]):e._e()])]),e._v(" "),e.checkable||e.paginated?n("div",{staticClass:"level"},[n("div",{staticClass:"level-left"},[e._t("bottom-left")],2),e._v(" "),n("div",{staticClass:"level-right"},[e.paginated?n("div",{staticClass:"level-item"},[n("b-pagination",{attrs:{total:e.newDataTotal,"per-page":e.perPage,simple:e.paginationSimple,size:e.paginationSize,current:e.newCurrentPage},on:{change:e.pageChanged}})],1):e._e()])]):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("label",{ref:"label",staticClass:"b-checkbox checkbox",class:[e.size,{"is-disabled":e.disabled}],attrs:{disabled:e.disabled,tabindex:!e.disabled&&0},on:{keydown:function(t){if(!("button"in t)&&e._k(t.keyCode,"enter",13,t.key)&&e._k(t.keyCode,"space",32,t.key))return null;t.preventDefault(),e.$refs.label.click()}}},[n("input",{directives:[{name:"model",rawName:"v-model",value:e.newValue,expression:"newValue"}],attrs:{type:"checkbox",disabled:e.disabled,name:e.name,"true-value":e.trueValue,"false-value":e.falseValue},domProps:{value:e.nativeValue,checked:Array.isArray(e.newValue)?e._i(e.newValue,e.nativeValue)>-1:e._q(e.newValue,e.trueValue)},on:{change:function(t){var n=e.newValue,i=t.target,r=i.checked?e.trueValue:e.falseValue;if(Array.isArray(n)){var a=e.nativeValue,o=e._i(n,a);i.checked?o<0&&(e.newValue=n.concat([a])):o>-1&&(e.newValue=n.slice(0,o).concat(n.slice(o+1)))}else e.newValue=r}}}),e._v(" "),n("span",{staticClass:"check",class:e.type}),e._v(" "),n("span",{staticClass:"control-label"},[e._t("default")],2)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("span",{staticClass:"icon",class:[e.newType,e.size]},[n("i",{class:[e.newPack,e.newIcon,e.newCustomSize,e.customClass]})])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"field",class:[e.rootClasses,e.fieldType()]},[e.horizontal?n("div",{staticClass:"field-label is-normal",class:e.customClass},[e.label?n("label",{staticClass:"label",attrs:{for:e.labelFor}},[e._v("\n            "+e._s(e.label)+"\n        ")]):e._e()]):[e.label?n("label",{staticClass:"label",class:e.customClass,attrs:{for:e.labelFor}},[e._v("\n            "+e._s(e.label)+"\n        ")]):e._e()],e._v(" "),e.horizontal?n("b-field-body",{attrs:{message:e.newMessage?e.formattedMessage:"",type:e.newType}},[e._t("default")],2):[e._t("default")],e._v(" "),e.newMessage&&!e.horizontal?n("p",{staticClass:"help",class:e.newType,domProps:{innerHTML:e._s(e.formattedMessage)}}):e._e()],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("label",{ref:"label",staticClass:"b-radio radio",class:[e.size,{"is-disabled":e.disabled}],attrs:{disabled:e.disabled,tabindex:!e.disabled&&0},on:{keydown:function(t){if(!("button"in t)&&e._k(t.keyCode,"enter",13,t.key)&&e._k(t.keyCode,"space",32,t.key))return null;t.preventDefault(),e.$refs.label.click()}}},[n("input",{directives:[{name:"model",rawName:"v-model",value:e.newValue,expression:"newValue"}],attrs:{type:"radio",disabled:e.disabled,name:e.name},domProps:{value:e.nativeValue,checked:e._q(e.newValue,e.nativeValue)},on:{change:function(t){e.newValue=e.nativeValue}}}),e._v(" "),n("span",{staticClass:"check",class:e.type}),e._v(" "),n("span",{staticClass:"control-label"},[e._t("default")],2)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"field table-mobile-sort"},[n("div",{staticClass:"field has-addons"},[n("b-select",{attrs:{expanded:""},model:{value:e.mobileSort,callback:function(t){e.mobileSort=t},expression:"mobileSort"}},e._l(e.columns,function(t,i){return t.sortable?n("option",{key:i,domProps:{value:t}},[e._v("\n                "+e._s(t.label)+"\n            ")]):e._e()})),e._v(" "),n("div",{staticClass:"control"},[n("button",{staticClass:"button is-primary",on:{click:e.sort}},[n("b-icon",{directives:[{name:"show",rawName:"v-show",value:e.currentSortColumn===e.mobileSort,expression:"currentSortColumn === mobileSort"}],class:{"is-desc":!e.isAsc},attrs:{icon:"arrow-up",size:"is-small",both:""}})],1)])],1)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{name:"fade"}},[e.isActive?n("article",{staticClass:"notification",class:e.type},[e.closable?n("button",{staticClass:"delete",attrs:{type:"button"},on:{click:e.close}}):e._e(),e._v(" "),n("div",{staticClass:"media"},[e.icon&&e.hasIcon?n("div",{staticClass:"media-left"},[n("b-icon",{attrs:{icon:e.icon,both:"",size:"is-large"}})],1):e._e(),e._v(" "),n("div",{staticClass:"media-content"},[e._t("default")],2)])]):e._e()])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"control"},[n("label",{ref:"label",staticClass:"b-checkbox checkbox button",class:[e.checked?e.type:null,e.size,{"is-disabled":e.disabled}],attrs:{disabled:e.disabled,tabindex:!e.disabled&&0},on:{keydown:function(t){if(!("button"in t)&&e._k(t.keyCode,"enter",13,t.key)&&e._k(t.keyCode,"space",32,t.key))return null;t.preventDefault(),e.$refs.label.click()}}},[e._t("default"),e._v(" "),n("input",{directives:[{name:"model",rawName:"v-model",value:e.newValue,expression:"newValue"}],attrs:{type:"checkbox",disabled:e.disabled,name:e.name},domProps:{value:e.nativeValue,checked:Array.isArray(e.newValue)?e._i(e.newValue,e.nativeValue)>-1:e.newValue},on:{change:function(t){var n=e.newValue,i=t.target,r=!!i.checked;if(Array.isArray(n)){var a=e.nativeValue,o=e._i(n,a);i.checked?o<0&&(e.newValue=n.concat([a])):o>-1&&(e.newValue=n.slice(0,o).concat(n.slice(o+1)))}else e.newValue=r}}})],2)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"collapse"},[n("div",{staticClass:"collapse-trigger",on:{click:e.toggle}},[e._t("trigger",null,{open:e.isOpen})],2),e._v(" "),n("transition",{attrs:{name:e.animation}},[n("div",{directives:[{name:"show",rawName:"v-show",value:e.isOpen,expression:"isOpen"}],staticClass:"collapse-content"},[e._t("default")],2)])],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("div",{staticClass:"tags",class:{"has-addons":e.attached}},[e._t("default")],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("section",{staticClass:"datepicker-table"},[n("header",{staticClass:"datepicker-header"},e._l(e.visibleDayNames,function(t,i){return n("div",{key:i,staticClass:"datepicker-cell"},[e._v("\n            "+e._s(t)+"\n        ")])})),e._v(" "),n("div",{staticClass:"datepicker-body",class:{"has-events":e.hasEvents}},e._l(e.weeksInThisMonth(e.focused.month,e.focused.year),function(t,i){return n("b-datepicker-table-row",{key:i,attrs:{"selected-date":e.value,week:t,month:e.focused.month,"min-date":e.minDate,"max-date":e.maxDate,disabled:e.disabled,"unselectable-dates":e.unselectableDates,"unselectable-days-of-week":e.unselectableDaysOfWeek,"selectable-dates":e.selectableDates,events:e.eventsInThisWeek(t,i),indicators:e.indicators},on:{select:e.updateSelectedDate}})}))])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{"enter-active-class":e.transition.enter,"leave-active-class":e.transition.leave}},[n("div",{directives:[{name:"show",rawName:"v-show",value:e.isActive,expression:"isActive"}],staticClass:"snackbar",class:[e.type,e.position]},[n("p",{staticClass:"text"},[e._v(e._s(e.message))]),e._v(" "),e.actionText?n("div",{staticClass:"action",class:e.type,on:{click:e.action}},[n("button",{staticClass:"button is-dark"},[e._v(e._s(e.actionText))])]):e._e()])])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"taginput control",class:e.rootClasses},[n("div",{staticClass:"taginput-container",class:[e.statusType,e.size,e.containerClasses],attrs:{disabled:e.disabled},on:{click:function(t){e.hasInput&&e.focus(t)}}},[e._l(e.tags,function(t,i){return n("b-tag",{key:i,attrs:{type:e.type,size:e.size,rounded:e.rounded,attached:e.attached,tabstop:!1,disabled:e.disabled,ellipsis:e.ellipsis,closable:""},on:{close:function(t){e.removeTag(i)}}},[e._v("\n            "+e._s(e.getNormalizedTagText(t))+"\n        ")])}),e._v(" "),e.hasInput?n("b-autocomplete",e._b({ref:"autocomplete",attrs:{data:e.data,field:e.field,icon:e.icon,"icon-pack":e.iconPack,maxlength:e.maxlength,"has-counter":!1,size:e.size,disabled:e.disabled,loading:e.loading,"keep-first":""},on:{focus:e.onFocus,blur:e.customOnBlur,select:e.onSelect},nativeOn:{keydown:function(t){e.keydown(t)}},scopedSlots:e._u([{key:e.defaultSlotName,fn:function(t){return[e._t("default",null,{option:t.option,index:t.index})]}}]),model:{value:e.newTag,callback:function(t){e.newTag=t},expression:"newTag"}},"b-autocomplete",e.$attrs,!1),[n("template",{slot:e.emptySlotName},[e._t("empty")],2)],2):e._e()],2),e._v(" "),e.maxtags||e.maxlength?n("p",{staticClass:"help counter"},[e.maxlength&&e.valueLength>0?[e._v("\n            "+e._s(e.valueLength)+" / "+e._s(e.maxlength)+"\n        ")]:e.maxtags?[e._v("\n            "+e._s(e.tagsLength)+" / "+e._s(e.maxtags)+"\n        ")]:e._e()],2):e._e()])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"autocomplete control",class:{"is-expanded":e.expanded}},[n("b-input",e._b({ref:"input",attrs:{size:e.size,loading:e.loading,rounded:e.rounded,icon:e.icon,"icon-pack":e.iconPack,maxlength:e.maxlength,autocomplete:"off"},on:{focus:e.focused,blur:e.onBlur},nativeOn:{keyup:function(t){if(!("button"in t)&&e._k(t.keyCode,"esc",27,t.key))return null;t.preventDefault(),e.isActive=!1},keydown:[function(t){if(!("button"in t)&&e._k(t.keyCode,"tab",9,t.key))return null;e.tabPressed(t)},function(t){if(!("button"in t)&&e._k(t.keyCode,"enter",13,t.key))return null;t.preventDefault(),e.enterPressed(t)},function(t){if(!("button"in t)&&e._k(t.keyCode,"up",38,t.key))return null;t.preventDefault(),e.keyArrows("up")},function(t){if(!("button"in t)&&e._k(t.keyCode,"down",40,t.key))return null;t.preventDefault(),e.keyArrows("down")}]},model:{value:e.newValue,callback:function(t){e.newValue=t},expression:"newValue"}},"b-input",e.$attrs,!1)),e._v(" "),n("transition",{attrs:{name:"fade"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:e.isActive&&(e.data.length>0||e.hasEmptySlot||e.hasHeaderSlot),expression:"isActive && (data.length > 0 || hasEmptySlot || hasHeaderSlot)"}],ref:"dropdown",staticClass:"dropdown-menu",class:{"is-opened-top":!e.isListInViewportVertically}},[n("div",{staticClass:"dropdown-content"},[e.hasHeaderSlot?n("div",{staticClass:"dropdown-item"},[e._t("header")],2):e._e(),e._v(" "),e._l(e.data,function(t,i){return n("a",{key:i,staticClass:"dropdown-item",class:{"is-hovered":t===e.hovered},on:{click:function(n){e.setSelected(t)}}},[e.hasDefaultSlot?e._t("default",null,{option:t,index:i}):n("span",{domProps:{innerHTML:e._s(e.getValue(t,!0))}})],2)}),e._v(" "),0===e.data.length&&e.hasEmptySlot?n("div",{staticClass:"dropdown-item is-disabled"},[e._t("empty")],2):e._e()],2)])])],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"control",class:e.rootClasses},["textarea"!==e.type?n("input",e._b({ref:"input",staticClass:"input",class:e.inputClasses,attrs:{type:e.newType,autocomplete:e.newAutocomplete,maxlength:e.maxlength},domProps:{value:e.newValue},on:{input:e.onInput,blur:e.onBlur,focus:e.onFocus}},"input",e.$attrs,!1)):n("textarea",e._b({ref:"textarea",staticClass:"textarea",class:e.inputClasses,attrs:{maxlength:e.maxlength},domProps:{value:e.newValue},on:{input:e.onInput,blur:e.onBlur,focus:e.onFocus}},"textarea",e.$attrs,!1)),e._v(" "),e.icon?n("b-icon",{staticClass:"is-left",attrs:{icon:e.icon,pack:e.iconPack,size:e.iconSize}}):e._e(),e._v(" "),e.loading||!e.passwordReveal&&!e.statusType?e._e():n("b-icon",{staticClass:"is-right",class:{"is-clickable":e.passwordReveal},attrs:{icon:e.passwordReveal?e.passwordVisibleIcon:e.statusTypeIcon,pack:e.iconPack,size:e.iconSize,type:e.passwordReveal?"is-primary":e.statusType,both:""},nativeOn:{click:function(t){e.togglePasswordVisibility(t)}}}),e._v(" "),e.maxlength&&e.hasCounter&&"number"!==e.type?n("small",{staticClass:"help counter",class:{"is-invisible":!e.isFocused}},[e._v("\n        "+e._s(e.valueLength)+" / "+e._s(e.maxlength)+"\n    ")]):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"datepicker-row"},[e._l(e.week,function(t,i){return[e.selectableDate(t)&&!e.disabled?n("a",{key:i,staticClass:"datepicker-cell",class:[e.classObject(t),{"has-event":e.eventsDateMatch(t)},e.indicators],attrs:{role:"button",href:"#",disabled:e.disabled},on:{click:function(n){n.preventDefault(),e.emitChosenDate(t)},keydown:[function(n){if(!("button"in n)&&e._k(n.keyCode,"enter",13,n.key))return null;n.preventDefault(),e.emitChosenDate(t)},function(n){if(!("button"in n)&&e._k(n.keyCode,"space",32,n.key))return null;n.preventDefault(),e.emitChosenDate(t)}]}},[e._v("\n            "+e._s(t.getDate())+"\n\n            "),e.eventsDateMatch(t)?n("div",{staticClass:"events"},e._l(e.eventsDateMatch(t),function(e,t){return n("div",{key:t,staticClass:"event",class:e.type})})):e._e()]):n("div",{key:i,staticClass:"datepicker-cell",class:e.classObject(t)},[e._v("\n            "+e._s(t.getDate())+"\n        ")])]})],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"b-tabs",class:{"is-fullwidth":e.expanded}},[n("nav",{staticClass:"tabs",class:e.navClasses},[n("ul",e._l(e.tabItems,function(t,i){return n("li",{directives:[{name:"show",rawName:"v-show",value:t.visible,expression:"tabItem.visible"}],key:i,class:{"is-active":e.activeTab===i,"is-disabled":t.disabled}},[n("a",{on:{click:function(t){e.tabClick(i)}}},[t.$slots.header?[n("b-slot-component",{attrs:{component:t,name:"header",tag:"span"}})]:[t.icon?n("b-icon",{attrs:{icon:t.icon,pack:t.iconPack,size:e.size}}):e._e(),e._v(" "),n("span",[e._v(e._s(t.label))])]],2)])}))]),e._v(" "),n("section",{staticClass:"tab-content"},[e._t("default")],2)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{name:e.animation}},[e.isActive?n("div",{staticClass:"modal is-active"},[n("div",{staticClass:"modal-background",on:{click:function(t){e.cancel("outside")}}}),e._v(" "),n("div",{staticClass:"animation-content",class:{"modal-content":!e.hasModalCard},style:{maxWidth:e.newWidth}},[e.component?n(e.component,e._g(e._b({tag:"component",on:{close:e.close}},"component",e.props,!1),e.events)):e.content?n("div",{domProps:{innerHTML:e._s(e.content)}}):e._t("default")],2),e._v(" "),e.showX?n("button",{staticClass:"modal-close is-large",attrs:{type:"button"},on:{click:function(t){e.cancel("x")}}}):e._e()]):e._e()])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"datepicker control",class:[e.size,{"is-expanded":e.expanded}]},[!e.isMobile||e.inline?n("b-dropdown",{ref:"dropdown",attrs:{position:e.position,disabled:e.disabled,inline:e.inline}},[e.inline?e._e():n("b-input",e._b({ref:"input",attrs:{slot:"trigger",autocomplete:"off",value:e.formatValue(e.dateSelected),placeholder:e.placeholder,size:e.size,icon:e.icon,"icon-pack":e.iconPack,rounded:e.rounded,loading:e.loading,disabled:e.disabled,readonly:e.readonly},on:{focus:function(t){e.$emit("focus",t)},blur:function(t){e.$emit("blur",t)&&e.checkHtml5Validity()}},nativeOn:{change:function(t){e.onChange(t.target.value)}},slot:"trigger"},"b-input",e.$attrs,!1)),e._v(" "),n("b-dropdown-item",{attrs:{disabled:e.disabled,custom:""}},[n("header",{staticClass:"datepicker-header"},[void 0!==e.$slots.header&&e.$slots.header.length?[e._t("header")]:n("div",{staticClass:"pagination field is-centered"},[e.isFirstMonth||e.disabled?e._e():n("a",{staticClass:"pagination-previous",attrs:{role:"button",href:"#",disabled:e.disabled},on:{click:function(t){t.preventDefault(),e.decrementMonth(t)},keydown:[function(t){if(!("button"in t)&&e._k(t.keyCode,"enter",13,t.key))return null;t.preventDefault(),e.decrementMonth(t)},function(t){if(!("button"in t)&&e._k(t.keyCode,"space",32,t.key))return null;t.preventDefault(),e.decrementMonth(t)}]}},[n("b-icon",{attrs:{icon:"chevron-left",pack:e.iconPack,both:"",type:"is-primary is-clickable"}})],1),e._v(" "),n("a",{directives:[{name:"show",rawName:"v-show",value:!e.isLastMonth&&!e.disabled,expression:"!isLastMonth && !disabled"}],staticClass:"pagination-next",attrs:{role:"button",href:"#",disabled:e.disabled},on:{click:function(t){t.preventDefault(),e.incrementMonth(t)},keydown:[function(t){if(!("button"in t)&&e._k(t.keyCode,"enter",13,t.key))return null;t.preventDefault(),e.incrementMonth(t)},function(t){if(!("button"in t)&&e._k(t.keyCode,"space",32,t.key))return null;t.preventDefault(),e.incrementMonth(t)}]}},[n("b-icon",{attrs:{icon:"chevron-right",pack:e.iconPack,both:"",type:"is-primary is-clickable"}})],1),e._v(" "),n("div",{staticClass:"pagination-list"},[n("b-field",[n("b-select",{attrs:{disabled:e.disabled},model:{value:e.focusedDateData.month,callback:function(t){e.$set(e.focusedDateData,"month",t)},expression:"focusedDateData.month"}},e._l(e.monthNames,function(t,i){return n("option",{key:t,domProps:{value:i}},[e._v("\n                                    "+e._s(t)+"\n                                ")])})),e._v(" "),n("b-select",{attrs:{disabled:e.disabled},model:{value:e.focusedDateData.year,callback:function(t){e.$set(e.focusedDateData,"year",t)},expression:"focusedDateData.year"}},e._l(e.listOfYears,function(t){return n("option",{key:t,domProps:{value:t}},[e._v("\n                                    "+e._s(t)+"\n                                ")])}))],1)],1)])],2),e._v(" "),n("b-datepicker-table",{attrs:{"day-names":e.dayNames,"month-names":e.monthNames,"first-day-of-week":e.firstDayOfWeek,"min-date":e.minDate,"max-date":e.maxDate,focused:e.focusedDateData,disabled:e.disabled,"unselectable-dates":e.unselectableDates,"unselectable-days-of-week":e.unselectableDaysOfWeek,"selectable-dates":e.selectableDates,events:e.events,indicators:e.indicators},on:{close:function(t){e.$refs.dropdown.isActive=!1}},model:{value:e.dateSelected,callback:function(t){e.dateSelected=t},expression:"dateSelected"}}),e._v(" "),void 0!==e.$slots.default&&e.$slots.default.length?n("footer",{staticClass:"datepicker-footer"},[e._t("default")],2):e._e()],1)],1):n("b-input",e._b({ref:"input",attrs:{type:"date",autocomplete:"off",value:e.formatYYYYMMDD(e.value),placeholder:e.placeholder,size:e.size,icon:e.icon,"icon-pack":e.iconPack,loading:e.loading,max:e.formatYYYYMMDD(e.maxDate),min:e.formatYYYYMMDD(e.minDate),disabled:e.disabled,readonly:!1},on:{focus:function(t){e.$emit("focus",t)},blur:function(t){e.$emit("blur",t)&&e.checkHtml5Validity()}},nativeOn:{change:function(t){e.onChangeNativePicker(t)}}},"b-input",e.$attrs,!1))],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return e.attached&&e.closable?n("div",{staticClass:"tags has-addons"},[n("span",{staticClass:"tag",class:[e.type,e.size,{"is-rounded":e.rounded}]},[n("span",{class:{"has-ellipsis":e.ellipsis}},[e._t("default")],2)]),e._v(" "),n("a",{staticClass:"tag is-delete",class:[e.size,{"is-rounded":e.rounded}],attrs:{role:"button",tabindex:!!e.tabstop&&0,disabled:e.disabled},on:{click:function(t){e.close()},keyup:function(t){if(!("button"in t)&&e._k(t.keyCode,"delete",[8,46],t.key))return null;t.preventDefault(),e.close()}}})]):n("span",{staticClass:"tag",class:[e.type,e.size,{"is-rounded":e.rounded}]},[n("span",{class:{"has-ellipsis":e.ellipsis}},[e._t("default")],2),e._v(" "),e.closable?n("a",{staticClass:"delete is-small",attrs:{role:"button",disabled:e.disabled,tabindex:!!e.tabstop&&0},on:{click:function(t){e.close()},keyup:function(t){if(!("button"in t)&&e._k(t.keyCode,"delete",[8,46],t.key))return null;t.preventDefault(),e.close()}}}):e._e()])},staticRenderFns:[]}},function(e,t,n){e.exports=n(67)}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(46);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1e866916", content, true, {});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@-webkit-keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@-webkit-keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@-webkit-keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@-webkit-keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}\n\n/*! bulma.io v0.7.1 | MIT License | github.com/jgthms/bulma */@-webkit-keyframes spinAround{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes spinAround{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.b-checkbox.checkbox,.b-radio.radio,.breadcrumb,.button,.delete,.file,.icon,.is-unselectable,.modal-close,.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous,.switch,.tabs{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.navbar-link:after,.select:not(.is-multiple):not(.is-loading):after{border:3px solid transparent;border-radius:2px;border-right:0;border-top:0;content:\" \";display:block;height:.625em;margin-top:-.4375em;pointer-events:none;position:absolute;top:50%;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:center;transform-origin:center;width:.625em}.block:not(:last-child),.box:not(:last-child),.breadcrumb:not(:last-child),.content:not(:last-child),.highlight:not(:last-child),.level:not(:last-child),.message:not(:last-child),.notification:not(:last-child),.progress:not(:last-child),.subtitle:not(:last-child),.table-container:not(:last-child),.table:not(:last-child),.tabs:not(:last-child),.title:not(:last-child){margin-bottom:1.5rem}.delete,.modal-close{-moz-appearance:none;-webkit-appearance:none;background-color:hsla(0,0%,4%,.2);border:none;border-radius:290486px;cursor:pointer;display:inline-block;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:0;height:20px;max-height:20px;max-width:20px;min-height:20px;min-width:20px;outline:none;position:relative;vertical-align:top;width:20px}.delete:after,.delete:before,.modal-close:after,.modal-close:before{background-color:#fff;content:\"\";display:block;left:50%;position:absolute;top:50%;-webkit-transform:translateX(-50%) translateY(-50%) rotate(45deg);transform:translateX(-50%) translateY(-50%) rotate(45deg);-webkit-transform-origin:center center;transform-origin:center center}.delete:before,.modal-close:before{height:2px;width:50%}.delete:after,.modal-close:after{height:50%;width:2px}.delete:focus,.delete:hover,.modal-close:focus,.modal-close:hover{background-color:hsla(0,0%,4%,.3)}.delete:active,.modal-close:active{background-color:hsla(0,0%,4%,.4)}.is-small.delete,.is-small.modal-close{height:16px;max-height:16px;max-width:16px;min-height:16px;min-width:16px;width:16px}.is-medium.delete,.is-medium.modal-close{height:24px;max-height:24px;max-width:24px;min-height:24px;min-width:24px;width:24px}.is-large.delete,.is-large.modal-close{height:32px;max-height:32px;max-width:32px;min-height:32px;min-width:32px;width:32px}.b-table.is-loading:after,.button.is-loading:after,.control.is-loading:after,.loader,.loading-overlay .loading-icon:after,.select.is-loading:after,.upload .upload-draggable.is-loading:after{-webkit-animation:spinAround .5s infinite linear;animation:spinAround .5s infinite linear;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em}.dropdown .background,.hero-video,.image.is-1by1 img,.image.is-1by2 img,.image.is-1by3 img,.image.is-2by1 img,.image.is-2by3 img,.image.is-3by1 img,.image.is-3by2 img,.image.is-3by4 img,.image.is-3by5 img,.image.is-4by3 img,.image.is-4by5 img,.image.is-5by3 img,.image.is-5by4 img,.image.is-9by16 img,.image.is-16by9 img,.image.is-square img,.is-overlay,.loading-overlay,.loading-overlay .loading-background,.modal,.modal-background{bottom:0;left:0;position:absolute;right:0;top:0}.button,.file-cta,.file-name,.input,.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous,.select select,.taginput .taginput-container.is-focusable,.textarea{-moz-appearance:none;-webkit-appearance:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:none;box-shadow:none;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1rem;height:2.25em;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;line-height:1.5;padding:calc(.375em - 1px) calc(.625em - 1px);position:relative;vertical-align:top}.button:active,.button:focus,.file-cta:active,.file-cta:focus,.file-name:active,.file-name:focus,.input:active,.input:focus,.is-active.button,.is-active.file-cta,.is-active.file-name,.is-active.input,.is-active.pagination-ellipsis,.is-active.pagination-link,.is-active.pagination-next,.is-active.pagination-previous,.is-active.textarea,.is-focused.button,.is-focused.file-cta,.is-focused.file-name,.is-focused.input,.is-focused.pagination-ellipsis,.is-focused.pagination-link,.is-focused.pagination-next,.is-focused.pagination-previous,.is-focused.textarea,.pagination-ellipsis:active,.pagination-ellipsis:focus,.pagination-link:active,.pagination-link:focus,.pagination-next:active,.pagination-next:focus,.pagination-previous:active,.pagination-previous:focus,.select select.is-active,.select select.is-focused,.select select:active,.select select:focus,.taginput .is-active.taginput-container.is-focusable,.taginput .is-focused.taginput-container.is-focusable,.taginput .taginput-container.is-focusable:active,.taginput .taginput-container.is-focusable:focus,.textarea:active,.textarea:focus{outline:none}.select select[disabled],.taginput [disabled].taginput-container.is-focusable,[disabled].button,[disabled].file-cta,[disabled].file-name,[disabled].input,[disabled].pagination-ellipsis,[disabled].pagination-link,[disabled].pagination-next,[disabled].pagination-previous,[disabled].textarea{cursor:not-allowed}\n\n/*! minireset.css v0.0.3 | MIT License | github.com/jgthms/minireset.css */blockquote,body,dd,dl,dt,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,html,iframe,legend,li,ol,p,pre,textarea,ul{margin:0;padding:0}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}ul{list-style:none}button,input,select,textarea{margin:0}html{-webkit-box-sizing:border-box;box-sizing:border-box}*,:after,:before{-webkit-box-sizing:inherit;box-sizing:inherit}audio,img,video{height:auto;max-width:100%}iframe{border:0}table{border-collapse:collapse;border-spacing:0}td,th{padding:0;text-align:left}html{background-color:#fff;font-size:16px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;min-width:300px;overflow-x:hidden;overflow-y:scroll;text-rendering:optimizeLegibility;-webkit-text-size-adjust:100%;-moz-text-size-adjust:100%;-ms-text-size-adjust:100%;text-size-adjust:100%}article,aside,figure,footer,header,hgroup,section{display:block}body,button,input,select,textarea{font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif}code,pre{-moz-osx-font-smoothing:auto;-webkit-font-smoothing:auto;font-family:monospace}body{color:#4a4a4a;font-size:1rem;font-weight:400;line-height:1.5}a{color:#7957d5;cursor:pointer;text-decoration:none}a strong{color:currentColor}a:hover{color:#363636}code{color:#ff3860;font-size:.875em;font-weight:400;padding:.25em .5em}code,hr{background-color:#f5f5f5}hr{border:none;display:block;height:2px;margin:1.5rem 0}img{height:auto;max-width:100%}input[type=checkbox],input[type=radio]{vertical-align:baseline}small{font-size:.875em}span{font-style:inherit;font-weight:inherit}strong{color:#363636;font-weight:700}pre{-webkit-overflow-scrolling:touch;background-color:#f5f5f5;color:#4a4a4a;font-size:.875em;overflow-x:auto;padding:1.25rem 1.5rem;white-space:pre;word-wrap:normal}pre code{background-color:transparent;color:currentColor;font-size:1em;padding:0}table td,table th{text-align:left;vertical-align:top}table th{color:#363636}.is-clearfix:after{clear:both;content:\" \";display:table}.is-pulled-left{float:left!important}.is-pulled-right{float:right!important}.is-clipped{overflow:hidden!important}.is-size-1{font-size:3rem!important}.is-size-2{font-size:2.5rem!important}.is-size-3{font-size:2rem!important}.is-size-4{font-size:1.5rem!important}.is-size-5{font-size:1.25rem!important}.is-size-6{font-size:1rem!important}.is-size-7{font-size:.75rem!important}@media screen and (max-width:768px){.is-size-1-mobile{font-size:3rem!important}.is-size-2-mobile{font-size:2.5rem!important}.is-size-3-mobile{font-size:2rem!important}.is-size-4-mobile{font-size:1.5rem!important}.is-size-5-mobile{font-size:1.25rem!important}.is-size-6-mobile{font-size:1rem!important}.is-size-7-mobile{font-size:.75rem!important}}@media print,screen and (min-width:769px){.is-size-1-tablet{font-size:3rem!important}.is-size-2-tablet{font-size:2.5rem!important}.is-size-3-tablet{font-size:2rem!important}.is-size-4-tablet{font-size:1.5rem!important}.is-size-5-tablet{font-size:1.25rem!important}.is-size-6-tablet{font-size:1rem!important}.is-size-7-tablet{font-size:.75rem!important}}@media screen and (max-width:1087px){.is-size-1-touch{font-size:3rem!important}.is-size-2-touch{font-size:2.5rem!important}.is-size-3-touch{font-size:2rem!important}.is-size-4-touch{font-size:1.5rem!important}.is-size-5-touch{font-size:1.25rem!important}.is-size-6-touch{font-size:1rem!important}.is-size-7-touch{font-size:.75rem!important}}@media screen and (min-width:1088px){.is-size-1-desktop{font-size:3rem!important}.is-size-2-desktop{font-size:2.5rem!important}.is-size-3-desktop{font-size:2rem!important}.is-size-4-desktop{font-size:1.5rem!important}.is-size-5-desktop{font-size:1.25rem!important}.is-size-6-desktop{font-size:1rem!important}.is-size-7-desktop{font-size:.75rem!important}}@media screen and (min-width:1280px){.is-size-1-widescreen{font-size:3rem!important}.is-size-2-widescreen{font-size:2.5rem!important}.is-size-3-widescreen{font-size:2rem!important}.is-size-4-widescreen{font-size:1.5rem!important}.is-size-5-widescreen{font-size:1.25rem!important}.is-size-6-widescreen{font-size:1rem!important}.is-size-7-widescreen{font-size:.75rem!important}}@media screen and (min-width:1472px){.is-size-1-fullhd{font-size:3rem!important}.is-size-2-fullhd{font-size:2.5rem!important}.is-size-3-fullhd{font-size:2rem!important}.is-size-4-fullhd{font-size:1.5rem!important}.is-size-5-fullhd{font-size:1.25rem!important}.is-size-6-fullhd{font-size:1rem!important}.is-size-7-fullhd{font-size:.75rem!important}}.has-text-centered{text-align:center!important}.has-text-justified{text-align:justify!important}.has-text-left{text-align:left!important}.has-text-right{text-align:right!important}@media screen and (max-width:768px){.has-text-centered-mobile{text-align:center!important}}@media print,screen and (min-width:769px){.has-text-centered-tablet{text-align:center!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-centered-tablet-only{text-align:center!important}}@media screen and (max-width:1087px){.has-text-centered-touch{text-align:center!important}}@media screen and (min-width:1088px){.has-text-centered-desktop{text-align:center!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-centered-desktop-only{text-align:center!important}}@media screen and (min-width:1280px){.has-text-centered-widescreen{text-align:center!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-centered-widescreen-only{text-align:center!important}}@media screen and (min-width:1472px){.has-text-centered-fullhd{text-align:center!important}}@media screen and (max-width:768px){.has-text-justified-mobile{text-align:justify!important}}@media print,screen and (min-width:769px){.has-text-justified-tablet{text-align:justify!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-justified-tablet-only{text-align:justify!important}}@media screen and (max-width:1087px){.has-text-justified-touch{text-align:justify!important}}@media screen and (min-width:1088px){.has-text-justified-desktop{text-align:justify!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-justified-desktop-only{text-align:justify!important}}@media screen and (min-width:1280px){.has-text-justified-widescreen{text-align:justify!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-justified-widescreen-only{text-align:justify!important}}@media screen and (min-width:1472px){.has-text-justified-fullhd{text-align:justify!important}}@media screen and (max-width:768px){.has-text-left-mobile{text-align:left!important}}@media print,screen and (min-width:769px){.has-text-left-tablet{text-align:left!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-left-tablet-only{text-align:left!important}}@media screen and (max-width:1087px){.has-text-left-touch{text-align:left!important}}@media screen and (min-width:1088px){.has-text-left-desktop{text-align:left!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-left-desktop-only{text-align:left!important}}@media screen and (min-width:1280px){.has-text-left-widescreen{text-align:left!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-left-widescreen-only{text-align:left!important}}@media screen and (min-width:1472px){.has-text-left-fullhd{text-align:left!important}}@media screen and (max-width:768px){.has-text-right-mobile{text-align:right!important}}@media print,screen and (min-width:769px){.has-text-right-tablet{text-align:right!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-right-tablet-only{text-align:right!important}}@media screen and (max-width:1087px){.has-text-right-touch{text-align:right!important}}@media screen and (min-width:1088px){.has-text-right-desktop{text-align:right!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-right-desktop-only{text-align:right!important}}@media screen and (min-width:1280px){.has-text-right-widescreen{text-align:right!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-right-widescreen-only{text-align:right!important}}@media screen and (min-width:1472px){.has-text-right-fullhd{text-align:right!important}}.is-capitalized{text-transform:capitalize!important}.is-lowercase{text-transform:lowercase!important}.is-uppercase{text-transform:uppercase!important}.is-italic{font-style:italic!important}.has-text-white{color:#fff!important}a.has-text-white:focus,a.has-text-white:hover{color:#e6e6e6!important}.has-background-white{background-color:#fff!important}.has-text-black{color:#0a0a0a!important}a.has-text-black:focus,a.has-text-black:hover{color:#000!important}.has-background-black{background-color:#0a0a0a!important}.has-text-light{color:#f5f5f5!important}a.has-text-light:focus,a.has-text-light:hover{color:#dbdbdb!important}.has-background-light{background-color:#f5f5f5!important}.has-text-dark{color:#363636!important}a.has-text-dark:focus,a.has-text-dark:hover{color:#1c1c1c!important}.has-background-dark{background-color:#363636!important}.has-text-primary{color:#7957d5!important}a.has-text-primary:focus,a.has-text-primary:hover{color:#5a32c7!important}.has-background-primary{background-color:#7957d5!important}.has-text-link{color:#7957d5!important}a.has-text-link:focus,a.has-text-link:hover{color:#5a32c7!important}.has-background-link{background-color:#7957d5!important}.has-text-info{color:#167df0!important}a.has-text-info:focus,a.has-text-info:hover{color:#0d64c6!important}.has-background-info{background-color:#167df0!important}.has-text-success{color:#23d160!important}a.has-text-success:focus,a.has-text-success:hover{color:#1ca64c!important}.has-background-success{background-color:#23d160!important}.has-text-warning{color:#ffdd57!important}a.has-text-warning:focus,a.has-text-warning:hover{color:#ffd324!important}.has-background-warning{background-color:#ffdd57!important}.has-text-danger{color:#ff3860!important}a.has-text-danger:focus,a.has-text-danger:hover{color:#ff0537!important}.has-background-danger{background-color:#ff3860!important}.has-text-black-bis{color:#121212!important}.has-background-black-bis{background-color:#121212!important}.has-text-black-ter{color:#242424!important}.has-background-black-ter{background-color:#242424!important}.has-text-grey-darker{color:#363636!important}.has-background-grey-darker{background-color:#363636!important}.has-text-grey-dark{color:#4a4a4a!important}.has-background-grey-dark{background-color:#4a4a4a!important}.has-text-grey{color:#7a7a7a!important}.has-background-grey{background-color:#7a7a7a!important}.has-text-grey-light{color:#b5b5b5!important}.has-background-grey-light{background-color:#b5b5b5!important}.has-text-grey-lighter{color:#dbdbdb!important}.has-background-grey-lighter{background-color:#dbdbdb!important}.has-text-white-ter{color:#f5f5f5!important}.has-background-white-ter{background-color:#f5f5f5!important}.has-text-white-bis{color:#fafafa!important}.has-background-white-bis{background-color:#fafafa!important}.has-text-weight-light{font-weight:300!important}.has-text-weight-normal{font-weight:400!important}.has-text-weight-semibold{font-weight:600!important}.has-text-weight-bold{font-weight:700!important}.is-block{display:block!important}@media screen and (max-width:768px){.is-block-mobile{display:block!important}}@media print,screen and (min-width:769px){.is-block-tablet{display:block!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-block-tablet-only{display:block!important}}@media screen and (max-width:1087px){.is-block-touch{display:block!important}}@media screen and (min-width:1088px){.is-block-desktop{display:block!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-block-desktop-only{display:block!important}}@media screen and (min-width:1280px){.is-block-widescreen{display:block!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-block-widescreen-only{display:block!important}}@media screen and (min-width:1472px){.is-block-fullhd{display:block!important}}.is-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}@media screen and (max-width:768px){.is-flex-mobile{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media print,screen and (min-width:769px){.is-flex-tablet{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-flex-tablet-only{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (max-width:1087px){.is-flex-touch{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:1088px){.is-flex-desktop{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-flex-desktop-only{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:1280px){.is-flex-widescreen{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-flex-widescreen-only{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (min-width:1472px){.is-flex-fullhd{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}}.is-inline{display:inline!important}@media screen and (max-width:768px){.is-inline-mobile{display:inline!important}}@media print,screen and (min-width:769px){.is-inline-tablet{display:inline!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-inline-tablet-only{display:inline!important}}@media screen and (max-width:1087px){.is-inline-touch{display:inline!important}}@media screen and (min-width:1088px){.is-inline-desktop{display:inline!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-inline-desktop-only{display:inline!important}}@media screen and (min-width:1280px){.is-inline-widescreen{display:inline!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-inline-widescreen-only{display:inline!important}}@media screen and (min-width:1472px){.is-inline-fullhd{display:inline!important}}.is-inline-block{display:inline-block!important}@media screen and (max-width:768px){.is-inline-block-mobile{display:inline-block!important}}@media print,screen and (min-width:769px){.is-inline-block-tablet{display:inline-block!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-inline-block-tablet-only{display:inline-block!important}}@media screen and (max-width:1087px){.is-inline-block-touch{display:inline-block!important}}@media screen and (min-width:1088px){.is-inline-block-desktop{display:inline-block!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-inline-block-desktop-only{display:inline-block!important}}@media screen and (min-width:1280px){.is-inline-block-widescreen{display:inline-block!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-inline-block-widescreen-only{display:inline-block!important}}@media screen and (min-width:1472px){.is-inline-block-fullhd{display:inline-block!important}}.is-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}@media screen and (max-width:768px){.is-inline-flex-mobile{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media print,screen and (min-width:769px){.is-inline-flex-tablet{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-inline-flex-tablet-only{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (max-width:1087px){.is-inline-flex-touch{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:1088px){.is-inline-flex-desktop{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-inline-flex-desktop-only{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:1280px){.is-inline-flex-widescreen{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-inline-flex-widescreen-only{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media screen and (min-width:1472px){.is-inline-flex-fullhd{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}.is-hidden{display:none!important}@media screen and (max-width:768px){.is-hidden-mobile{display:none!important}}@media print,screen and (min-width:769px){.is-hidden-tablet{display:none!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-hidden-tablet-only{display:none!important}}@media screen and (max-width:1087px){.is-hidden-touch{display:none!important}}@media screen and (min-width:1088px){.is-hidden-desktop{display:none!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-hidden-desktop-only{display:none!important}}@media screen and (min-width:1280px){.is-hidden-widescreen{display:none!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-hidden-widescreen-only{display:none!important}}@media screen and (min-width:1472px){.is-hidden-fullhd{display:none!important}}.is-invisible{visibility:hidden!important}@media screen and (max-width:768px){.is-invisible-mobile{visibility:hidden!important}}@media print,screen and (min-width:769px){.is-invisible-tablet{visibility:hidden!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-invisible-tablet-only{visibility:hidden!important}}@media screen and (max-width:1087px){.is-invisible-touch{visibility:hidden!important}}@media screen and (min-width:1088px){.is-invisible-desktop{visibility:hidden!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-invisible-desktop-only{visibility:hidden!important}}@media screen and (min-width:1280px){.is-invisible-widescreen{visibility:hidden!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-invisible-widescreen-only{visibility:hidden!important}}@media screen and (min-width:1472px){.is-invisible-fullhd{visibility:hidden!important}}.is-marginless{margin:0!important}.is-paddingless{padding:0!important}.is-radiusless{border-radius:0!important}.is-shadowless{-webkit-box-shadow:none!important;box-shadow:none!important}.box{background-color:#fff;border-radius:6px;-webkit-box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);color:#4a4a4a;display:block;padding:1.25rem}a.box:focus,a.box:hover{-webkit-box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px #7957d5;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px #7957d5}a.box:active{-webkit-box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2),0 0 0 1px #7957d5;box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2),0 0 0 1px #7957d5}.button{background-color:#fff;border-color:#dbdbdb;border-width:1px;color:#363636;cursor:pointer;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:calc(.375em - 1px) .75em;text-align:center;white-space:nowrap}.button strong{color:inherit}.button .icon,.button .icon.is-large,.button .icon.is-medium,.button .icon.is-small{height:1.5em;width:1.5em}.button .icon:first-child:not(:last-child){margin-left:calc(-.375em - 1px);margin-right:.1875em}.button .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:calc(-.375em - 1px)}.button .icon:first-child:last-child{margin-left:calc(-.375em - 1px);margin-right:calc(-.375em - 1px)}.button.is-hovered,.button:hover{border-color:#b5b5b5;color:#363636}.button.is-focused,.button:focus{border-color:#7957d5;color:#363636}.button.is-focused:not(:active),.button:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(121,87,213,.25);box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.button.is-active,.button:active{border-color:#4a4a4a;color:#363636}.button.is-text{background-color:transparent;border-color:transparent;color:#4a4a4a;text-decoration:underline}.button.is-text.is-focused,.button.is-text.is-hovered,.button.is-text:focus,.button.is-text:hover{background-color:#f5f5f5;color:#363636}.button.is-text.is-active,.button.is-text:active{background-color:#e8e8e8;color:#363636}.button.is-text[disabled]{background-color:transparent;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-white{background-color:#fff;border-color:transparent;color:#0a0a0a}.button.is-white.is-hovered,.button.is-white:hover{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.button.is-white.is-focused,.button.is-white:focus{border-color:transparent;color:#0a0a0a}.button.is-white.is-focused:not(:active),.button.is-white:focus:not(:active){-webkit-box-shadow:0 0 0 .125em hsla(0,0%,100%,.25);box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.button.is-white.is-active,.button.is-white:active{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.button.is-white[disabled]{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-white.is-inverted{background-color:#0a0a0a;color:#fff}.button.is-white.is-inverted:hover{background-color:#000}.button.is-white.is-inverted[disabled]{background-color:#0a0a0a;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#fff}.button.is-white.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.button.is-white.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-white.is-outlined:focus,.button.is-white.is-outlined:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.button.is-white.is-outlined.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-white.is-outlined[disabled]{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.button.is-white.is-inverted.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.button.is-white.is-inverted.is-outlined:focus,.button.is-white.is-inverted.is-outlined:hover{background-color:#0a0a0a;color:#fff}.button.is-white.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#0a0a0a;-webkit-box-shadow:none;box-shadow:none;color:#0a0a0a}.button.is-black{background-color:#0a0a0a;border-color:transparent;color:#fff}.button.is-black.is-hovered,.button.is-black:hover{background-color:#040404;border-color:transparent;color:#fff}.button.is-black.is-focused,.button.is-black:focus{border-color:transparent;color:#fff}.button.is-black.is-focused:not(:active),.button.is-black:focus:not(:active){-webkit-box-shadow:0 0 0 .125em hsla(0,0%,4%,.25);box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.button.is-black.is-active,.button.is-black:active{background-color:#000;border-color:transparent;color:#fff}.button.is-black[disabled]{background-color:#0a0a0a;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-black.is-inverted{background-color:#fff;color:#0a0a0a}.button.is-black.is-inverted:hover{background-color:#f2f2f2}.button.is-black.is-inverted[disabled]{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#0a0a0a}.button.is-black.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-black.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.button.is-black.is-outlined:focus,.button.is-black.is-outlined:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.button.is-black.is-outlined.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.button.is-black.is-outlined[disabled]{background-color:transparent;border-color:#0a0a0a;-webkit-box-shadow:none;box-shadow:none;color:#0a0a0a}.button.is-black.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-black.is-inverted.is-outlined:focus,.button.is-black.is-inverted.is-outlined:hover{background-color:#fff;color:#0a0a0a}.button.is-black.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.button.is-light{background-color:#f5f5f5;border-color:transparent;color:#363636}.button.is-light.is-hovered,.button.is-light:hover{background-color:#eee;border-color:transparent;color:#363636}.button.is-light.is-focused,.button.is-light:focus{border-color:transparent;color:#363636}.button.is-light.is-focused:not(:active),.button.is-light:focus:not(:active){-webkit-box-shadow:0 0 0 .125em hsla(0,0%,96%,.25);box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.button.is-light.is-active,.button.is-light:active{background-color:#e8e8e8;border-color:transparent;color:#363636}.button.is-light[disabled]{background-color:#f5f5f5;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-light.is-inverted{background-color:#363636;color:#f5f5f5}.button.is-light.is-inverted:hover{background-color:#292929}.button.is-light.is-inverted[disabled]{background-color:#363636;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#f5f5f5}.button.is-light.is-loading:after{border-color:transparent transparent #363636 #363636!important}.button.is-light.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.button.is-light.is-outlined:focus,.button.is-light.is-outlined:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.button.is-light.is-outlined.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.button.is-light.is-outlined[disabled]{background-color:transparent;border-color:#f5f5f5;-webkit-box-shadow:none;box-shadow:none;color:#f5f5f5}.button.is-light.is-inverted.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.button.is-light.is-inverted.is-outlined:focus,.button.is-light.is-inverted.is-outlined:hover{background-color:#363636;color:#f5f5f5}.button.is-light.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#363636;-webkit-box-shadow:none;box-shadow:none;color:#363636}.button.is-dark{background-color:#363636;border-color:transparent;color:#f5f5f5}.button.is-dark.is-hovered,.button.is-dark:hover{background-color:#2f2f2f;border-color:transparent;color:#f5f5f5}.button.is-dark.is-focused,.button.is-dark:focus{border-color:transparent;color:#f5f5f5}.button.is-dark.is-focused:not(:active),.button.is-dark:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(54,54,54,.25);box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.button.is-dark.is-active,.button.is-dark:active{background-color:#292929;border-color:transparent;color:#f5f5f5}.button.is-dark[disabled]{background-color:#363636;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-dark.is-inverted{background-color:#f5f5f5;color:#363636}.button.is-dark.is-inverted:hover{background-color:#e8e8e8}.button.is-dark.is-inverted[disabled]{background-color:#f5f5f5;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#363636}.button.is-dark.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.button.is-dark.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.button.is-dark.is-outlined:focus,.button.is-dark.is-outlined:hover{background-color:#363636;border-color:#363636;color:#f5f5f5}.button.is-dark.is-outlined.is-loading:after{border-color:transparent transparent #363636 #363636!important}.button.is-dark.is-outlined[disabled]{background-color:transparent;border-color:#363636;-webkit-box-shadow:none;box-shadow:none;color:#363636}.button.is-dark.is-inverted.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.button.is-dark.is-inverted.is-outlined:focus,.button.is-dark.is-inverted.is-outlined:hover{background-color:#f5f5f5;color:#363636}.button.is-dark.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#f5f5f5;-webkit-box-shadow:none;box-shadow:none;color:#f5f5f5}.button.is-primary{background-color:#7957d5;border-color:transparent;color:#fff}.button.is-primary.is-hovered,.button.is-primary:hover{background-color:#714dd2;border-color:transparent;color:#fff}.button.is-primary.is-focused,.button.is-primary:focus{border-color:transparent;color:#fff}.button.is-primary.is-focused:not(:active),.button.is-primary:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(121,87,213,.25);box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.button.is-primary.is-active,.button.is-primary:active{background-color:#6943d0;border-color:transparent;color:#fff}.button.is-primary[disabled]{background-color:#7957d5;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-primary.is-inverted{background-color:#fff;color:#7957d5}.button.is-primary.is-inverted:hover{background-color:#f2f2f2}.button.is-primary.is-inverted[disabled]{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#7957d5}.button.is-primary.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-primary.is-outlined{background-color:transparent;border-color:#7957d5;color:#7957d5}.button.is-primary.is-outlined:focus,.button.is-primary.is-outlined:hover{background-color:#7957d5;border-color:#7957d5;color:#fff}.button.is-primary.is-outlined.is-loading:after{border-color:transparent transparent #7957d5 #7957d5!important}.button.is-primary.is-outlined[disabled]{background-color:transparent;border-color:#7957d5;-webkit-box-shadow:none;box-shadow:none;color:#7957d5}.button.is-primary.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-primary.is-inverted.is-outlined:focus,.button.is-primary.is-inverted.is-outlined:hover{background-color:#fff;color:#7957d5}.button.is-primary.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.button.is-link{background-color:#7957d5;border-color:transparent;color:#fff}.button.is-link.is-hovered,.button.is-link:hover{background-color:#714dd2;border-color:transparent;color:#fff}.button.is-link.is-focused,.button.is-link:focus{border-color:transparent;color:#fff}.button.is-link.is-focused:not(:active),.button.is-link:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(121,87,213,.25);box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.button.is-link.is-active,.button.is-link:active{background-color:#6943d0;border-color:transparent;color:#fff}.button.is-link[disabled]{background-color:#7957d5;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-link.is-inverted{background-color:#fff;color:#7957d5}.button.is-link.is-inverted:hover{background-color:#f2f2f2}.button.is-link.is-inverted[disabled]{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#7957d5}.button.is-link.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-link.is-outlined{background-color:transparent;border-color:#7957d5;color:#7957d5}.button.is-link.is-outlined:focus,.button.is-link.is-outlined:hover{background-color:#7957d5;border-color:#7957d5;color:#fff}.button.is-link.is-outlined.is-loading:after{border-color:transparent transparent #7957d5 #7957d5!important}.button.is-link.is-outlined[disabled]{background-color:transparent;border-color:#7957d5;-webkit-box-shadow:none;box-shadow:none;color:#7957d5}.button.is-link.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-link.is-inverted.is-outlined:focus,.button.is-link.is-inverted.is-outlined:hover{background-color:#fff;color:#7957d5}.button.is-link.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.button.is-info{background-color:#167df0;border-color:transparent;color:#fff}.button.is-info.is-hovered,.button.is-info:hover{background-color:#0f77ea;border-color:transparent;color:#fff}.button.is-info.is-focused,.button.is-info:focus{border-color:transparent;color:#fff}.button.is-info.is-focused:not(:active),.button.is-info:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(22,125,240,.25);box-shadow:0 0 0 .125em rgba(22,125,240,.25)}.button.is-info.is-active,.button.is-info:active{background-color:#0e71de;border-color:transparent;color:#fff}.button.is-info[disabled]{background-color:#167df0;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-info.is-inverted{background-color:#fff;color:#167df0}.button.is-info.is-inverted:hover{background-color:#f2f2f2}.button.is-info.is-inverted[disabled]{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#167df0}.button.is-info.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-info.is-outlined{background-color:transparent;border-color:#167df0;color:#167df0}.button.is-info.is-outlined:focus,.button.is-info.is-outlined:hover{background-color:#167df0;border-color:#167df0;color:#fff}.button.is-info.is-outlined.is-loading:after{border-color:transparent transparent #167df0 #167df0!important}.button.is-info.is-outlined[disabled]{background-color:transparent;border-color:#167df0;-webkit-box-shadow:none;box-shadow:none;color:#167df0}.button.is-info.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-info.is-inverted.is-outlined:focus,.button.is-info.is-inverted.is-outlined:hover{background-color:#fff;color:#167df0}.button.is-info.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.button.is-success{background-color:#23d160;border-color:transparent;color:#fff}.button.is-success.is-hovered,.button.is-success:hover{background-color:#22c65b;border-color:transparent;color:#fff}.button.is-success.is-focused,.button.is-success:focus{border-color:transparent;color:#fff}.button.is-success.is-focused:not(:active),.button.is-success:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(35,209,96,.25);box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.button.is-success.is-active,.button.is-success:active{background-color:#20bc56;border-color:transparent;color:#fff}.button.is-success[disabled]{background-color:#23d160;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-success.is-inverted{background-color:#fff;color:#23d160}.button.is-success.is-inverted:hover{background-color:#f2f2f2}.button.is-success.is-inverted[disabled]{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#23d160}.button.is-success.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-success.is-outlined{background-color:transparent;border-color:#23d160;color:#23d160}.button.is-success.is-outlined:focus,.button.is-success.is-outlined:hover{background-color:#23d160;border-color:#23d160;color:#fff}.button.is-success.is-outlined.is-loading:after{border-color:transparent transparent #23d160 #23d160!important}.button.is-success.is-outlined[disabled]{background-color:transparent;border-color:#23d160;-webkit-box-shadow:none;box-shadow:none;color:#23d160}.button.is-success.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-success.is-inverted.is-outlined:focus,.button.is-success.is-inverted.is-outlined:hover{background-color:#fff;color:#23d160}.button.is-success.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.button.is-warning{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-hovered,.button.is-warning:hover{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-focused,.button.is-warning:focus{border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-focused:not(:active),.button.is-warning:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(255,221,87,.25);box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.button.is-warning.is-active,.button.is-warning:active{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning[disabled]{background-color:#ffdd57;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-warning.is-inverted{color:#ffdd57}.button.is-warning.is-inverted,.button.is-warning.is-inverted:hover{background-color:rgba(0,0,0,.7)}.button.is-warning.is-inverted[disabled]{background-color:rgba(0,0,0,.7);border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#ffdd57}.button.is-warning.is-loading:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.button.is-warning.is-outlined{background-color:transparent;border-color:#ffdd57;color:#ffdd57}.button.is-warning.is-outlined:focus,.button.is-warning.is-outlined:hover{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.button.is-warning.is-outlined.is-loading:after{border-color:transparent transparent #ffdd57 #ffdd57!important}.button.is-warning.is-outlined[disabled]{background-color:transparent;border-color:#ffdd57;-webkit-box-shadow:none;box-shadow:none;color:#ffdd57}.button.is-warning.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);color:rgba(0,0,0,.7)}.button.is-warning.is-inverted.is-outlined:focus,.button.is-warning.is-inverted.is-outlined:hover{background-color:rgba(0,0,0,.7);color:#ffdd57}.button.is-warning.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:rgba(0,0,0,.7);-webkit-box-shadow:none;box-shadow:none;color:rgba(0,0,0,.7)}.button.is-danger{background-color:#ff3860;border-color:transparent;color:#fff}.button.is-danger.is-hovered,.button.is-danger:hover{background-color:#ff2b56;border-color:transparent;color:#fff}.button.is-danger.is-focused,.button.is-danger:focus{border-color:transparent;color:#fff}.button.is-danger.is-focused:not(:active),.button.is-danger:focus:not(:active){-webkit-box-shadow:0 0 0 .125em rgba(255,56,96,.25);box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.button.is-danger.is-active,.button.is-danger:active{background-color:#ff1f4b;border-color:transparent;color:#fff}.button.is-danger[disabled]{background-color:#ff3860;border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.button.is-danger.is-inverted{background-color:#fff;color:#ff3860}.button.is-danger.is-inverted:hover{background-color:#f2f2f2}.button.is-danger.is-inverted[disabled]{background-color:#fff;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;color:#ff3860}.button.is-danger.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-danger.is-outlined{background-color:transparent;border-color:#ff3860;color:#ff3860}.button.is-danger.is-outlined:focus,.button.is-danger.is-outlined:hover{background-color:#ff3860;border-color:#ff3860;color:#fff}.button.is-danger.is-outlined.is-loading:after{border-color:transparent transparent #ff3860 #ff3860!important}.button.is-danger.is-outlined[disabled]{background-color:transparent;border-color:#ff3860;-webkit-box-shadow:none;box-shadow:none;color:#ff3860}.button.is-danger.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-danger.is-inverted.is-outlined:focus,.button.is-danger.is-inverted.is-outlined:hover{background-color:#fff;color:#ff3860}.button.is-danger.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;-webkit-box-shadow:none;box-shadow:none;color:#fff}.button.is-small{border-radius:2px;font-size:.75rem}.button.is-medium{font-size:1.25rem}.button.is-large{font-size:1.5rem}.button[disabled]{background-color:#fff;border-color:#dbdbdb;-webkit-box-shadow:none;box-shadow:none;opacity:.5}.button.is-fullwidth{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}.button.is-loading{color:transparent!important;pointer-events:none}.button.is-loading:after{position:absolute;left:calc(50% - 0.5em);top:calc(50% - 0.5em);position:absolute!important}.button.is-static{background-color:#f5f5f5;border-color:#dbdbdb;color:#7a7a7a;-webkit-box-shadow:none;box-shadow:none;pointer-events:none}.button.is-rounded{border-radius:290486px;padding-left:1em;padding-right:1em}.buttons{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.buttons .button{margin-bottom:.5rem}.buttons .button:not(:last-child){margin-right:.5rem}.buttons:last-child{margin-bottom:-.5rem}.buttons:not(:last-child){margin-bottom:1rem}.buttons.has-addons .button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.buttons.has-addons .button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.buttons.has-addons .button:last-child{margin-right:0}.buttons.has-addons .button.is-hovered,.buttons.has-addons .button:hover{z-index:2}.buttons.has-addons .button.is-active,.buttons.has-addons .button.is-focused,.buttons.has-addons .button.is-selected,.buttons.has-addons .button:active,.buttons.has-addons .button:focus{z-index:3}.buttons.has-addons .button.is-active:hover,.buttons.has-addons .button.is-focused:hover,.buttons.has-addons .button.is-selected:hover,.buttons.has-addons .button:active:hover,.buttons.has-addons .button:focus:hover{z-index:4}.buttons.has-addons .button.is-expanded{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.buttons.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.buttons.is-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.container{margin:0 auto;position:relative}@media screen and (min-width:1088px){.container{max-width:960px;width:960px}.container.is-fluid{margin-left:64px;margin-right:64px;max-width:none;width:auto}}@media screen and (max-width:1279px){.container.is-widescreen{max-width:1152px;width:auto}}@media screen and (max-width:1471px){.container.is-fullhd{max-width:1344px;width:auto}}@media screen and (min-width:1280px){.container{max-width:1152px;width:1152px}}@media screen and (min-width:1472px){.container{max-width:1344px;width:1344px}}.content li+li{margin-top:.25em}.content blockquote:not(:last-child),.content dl:not(:last-child),.content ol:not(:last-child),.content p:not(:last-child),.content pre:not(:last-child),.content table:not(:last-child),.content ul:not(:last-child){margin-bottom:1em}.content h1,.content h2,.content h3,.content h4,.content h5,.content h6{color:#363636;font-weight:600;line-height:1.125}.content h1{font-size:2em;margin-bottom:.5em}.content h1:not(:first-child){margin-top:1em}.content h2{font-size:1.75em;margin-bottom:.5714em}.content h2:not(:first-child){margin-top:1.1428em}.content h3{font-size:1.5em;margin-bottom:.6666em}.content h3:not(:first-child){margin-top:1.3333em}.content h4{font-size:1.25em;margin-bottom:.8em}.content h5{font-size:1.125em;margin-bottom:.8888em}.content h6{font-size:1em;margin-bottom:1em}.content blockquote{background-color:#f5f5f5;border-left:5px solid #dbdbdb;padding:1.25em 1.5em}.content ol{list-style:decimal outside}.content ol,.content ul{margin-left:2em;margin-top:1em}.content ul{list-style:disc outside}.content ul ul{list-style-type:circle;margin-top:.5em}.content ul ul ul{list-style-type:square}.content dd{margin-left:2em}.content figure{margin-left:2em;margin-right:2em;text-align:center}.content figure:not(:first-child){margin-top:2em}.content figure:not(:last-child){margin-bottom:2em}.content figure img{display:inline-block}.content figure figcaption{font-style:italic}.content pre{-webkit-overflow-scrolling:touch;overflow-x:auto;padding:1.25em 1.5em;white-space:pre;word-wrap:normal}.content sub,.content sup{font-size:75%}.content table{width:100%}.content table td,.content table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.content table th{color:#363636;text-align:left}.content table thead td,.content table thead th{border-width:0 0 2px;color:#363636}.content table tfoot td,.content table tfoot th{border-width:2px 0 0;color:#363636}.content table tbody tr:last-child td,.content table tbody tr:last-child th{border-bottom-width:0}.content.is-small{font-size:.75rem}.content.is-medium{font-size:1.25rem}.content.is-large{font-size:1.5rem}.input,.taginput .taginput-container.is-focusable,.textarea{background-color:#fff;border-color:#dbdbdb;color:#363636;-webkit-box-shadow:inset 0 1px 2px hsla(0,0%,4%,.1);box-shadow:inset 0 1px 2px hsla(0,0%,4%,.1);max-width:100%;width:100%}.input::-moz-placeholder,.taginput .taginput-container.is-focusable::-moz-placeholder,.textarea::-moz-placeholder{color:rgba(54,54,54,.3)}.input::-webkit-input-placeholder,.taginput .taginput-container.is-focusable::-webkit-input-placeholder,.textarea::-webkit-input-placeholder{color:rgba(54,54,54,.3)}.input:-moz-placeholder,.taginput .taginput-container.is-focusable:-moz-placeholder,.textarea:-moz-placeholder{color:rgba(54,54,54,.3)}.input:-ms-input-placeholder,.taginput .taginput-container.is-focusable:-ms-input-placeholder,.textarea:-ms-input-placeholder{color:rgba(54,54,54,.3)}.input.is-hovered,.input:hover,.taginput .is-hovered.taginput-container.is-focusable,.taginput .taginput-container.is-focusable:hover,.textarea.is-hovered,.textarea:hover{border-color:#b5b5b5}.input.is-active,.input.is-focused,.input:active,.input:focus,.taginput .is-active.taginput-container.is-focusable,.taginput .is-focused.taginput-container.is-focusable,.taginput .taginput-container.is-focusable:active,.taginput .taginput-container.is-focusable:focus,.textarea.is-active,.textarea.is-focused,.textarea:active,.textarea:focus{border-color:#7957d5;-webkit-box-shadow:0 0 0 .125em rgba(121,87,213,.25);box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.input[disabled],.taginput [disabled].taginput-container.is-focusable,.textarea[disabled]{background-color:#f5f5f5;border-color:#f5f5f5;-webkit-box-shadow:none;box-shadow:none;color:#7a7a7a}.input[disabled]::-moz-placeholder,.taginput [disabled].taginput-container.is-focusable::-moz-placeholder,.textarea[disabled]::-moz-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]::-webkit-input-placeholder,.taginput [disabled].taginput-container.is-focusable::-webkit-input-placeholder,.textarea[disabled]::-webkit-input-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]:-moz-placeholder,.taginput [disabled].taginput-container.is-focusable:-moz-placeholder,.textarea[disabled]:-moz-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]:-ms-input-placeholder,.taginput [disabled].taginput-container.is-focusable:-ms-input-placeholder,.textarea[disabled]:-ms-input-placeholder{color:hsla(0,0%,48%,.3)}.input[readonly],.taginput [readonly].taginput-container.is-focusable,.textarea[readonly]{-webkit-box-shadow:none;box-shadow:none}.input.is-white,.taginput .is-white.taginput-container.is-focusable,.textarea.is-white{border-color:#fff}.input.is-white.is-active,.input.is-white.is-focused,.input.is-white:active,.input.is-white:focus,.taginput .is-white.is-active.taginput-container.is-focusable,.taginput .is-white.is-focused.taginput-container.is-focusable,.taginput .is-white.taginput-container.is-focusable:active,.taginput .is-white.taginput-container.is-focusable:focus,.textarea.is-white.is-active,.textarea.is-white.is-focused,.textarea.is-white:active,.textarea.is-white:focus{-webkit-box-shadow:0 0 0 .125em hsla(0,0%,100%,.25);box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.input.is-black,.taginput .is-black.taginput-container.is-focusable,.textarea.is-black{border-color:#0a0a0a}.input.is-black.is-active,.input.is-black.is-focused,.input.is-black:active,.input.is-black:focus,.taginput .is-black.is-active.taginput-container.is-focusable,.taginput .is-black.is-focused.taginput-container.is-focusable,.taginput .is-black.taginput-container.is-focusable:active,.taginput .is-black.taginput-container.is-focusable:focus,.textarea.is-black.is-active,.textarea.is-black.is-focused,.textarea.is-black:active,.textarea.is-black:focus{-webkit-box-shadow:0 0 0 .125em hsla(0,0%,4%,.25);box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.input.is-light,.taginput .is-light.taginput-container.is-focusable,.textarea.is-light{border-color:#f5f5f5}.input.is-light.is-active,.input.is-light.is-focused,.input.is-light:active,.input.is-light:focus,.taginput .is-light.is-active.taginput-container.is-focusable,.taginput .is-light.is-focused.taginput-container.is-focusable,.taginput .is-light.taginput-container.is-focusable:active,.taginput .is-light.taginput-container.is-focusable:focus,.textarea.is-light.is-active,.textarea.is-light.is-focused,.textarea.is-light:active,.textarea.is-light:focus{-webkit-box-shadow:0 0 0 .125em hsla(0,0%,96%,.25);box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.input.is-dark,.taginput .is-dark.taginput-container.is-focusable,.textarea.is-dark{border-color:#363636}.input.is-dark.is-active,.input.is-dark.is-focused,.input.is-dark:active,.input.is-dark:focus,.taginput .is-dark.is-active.taginput-container.is-focusable,.taginput .is-dark.is-focused.taginput-container.is-focusable,.taginput .is-dark.taginput-container.is-focusable:active,.taginput .is-dark.taginput-container.is-focusable:focus,.textarea.is-dark.is-active,.textarea.is-dark.is-focused,.textarea.is-dark:active,.textarea.is-dark:focus{-webkit-box-shadow:0 0 0 .125em rgba(54,54,54,.25);box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.input.is-primary,.taginput .is-primary.taginput-container.is-focusable,.textarea.is-primary{border-color:#7957d5}.input.is-primary.is-active,.input.is-primary.is-focused,.input.is-primary:active,.input.is-primary:focus,.taginput .is-primary.is-active.taginput-container.is-focusable,.taginput .is-primary.is-focused.taginput-container.is-focusable,.taginput .is-primary.taginput-container.is-focusable:active,.taginput .is-primary.taginput-container.is-focusable:focus,.textarea.is-primary.is-active,.textarea.is-primary.is-focused,.textarea.is-primary:active,.textarea.is-primary:focus{-webkit-box-shadow:0 0 0 .125em rgba(121,87,213,.25);box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.input.is-link,.taginput .is-link.taginput-container.is-focusable,.textarea.is-link{border-color:#7957d5}.input.is-link.is-active,.input.is-link.is-focused,.input.is-link:active,.input.is-link:focus,.taginput .is-link.is-active.taginput-container.is-focusable,.taginput .is-link.is-focused.taginput-container.is-focusable,.taginput .is-link.taginput-container.is-focusable:active,.taginput .is-link.taginput-container.is-focusable:focus,.textarea.is-link.is-active,.textarea.is-link.is-focused,.textarea.is-link:active,.textarea.is-link:focus{-webkit-box-shadow:0 0 0 .125em rgba(121,87,213,.25);box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.input.is-info,.taginput .is-info.taginput-container.is-focusable,.textarea.is-info{border-color:#167df0}.input.is-info.is-active,.input.is-info.is-focused,.input.is-info:active,.input.is-info:focus,.taginput .is-info.is-active.taginput-container.is-focusable,.taginput .is-info.is-focused.taginput-container.is-focusable,.taginput .is-info.taginput-container.is-focusable:active,.taginput .is-info.taginput-container.is-focusable:focus,.textarea.is-info.is-active,.textarea.is-info.is-focused,.textarea.is-info:active,.textarea.is-info:focus{-webkit-box-shadow:0 0 0 .125em rgba(22,125,240,.25);box-shadow:0 0 0 .125em rgba(22,125,240,.25)}.input.is-success,.taginput .is-success.taginput-container.is-focusable,.textarea.is-success{border-color:#23d160}.input.is-success.is-active,.input.is-success.is-focused,.input.is-success:active,.input.is-success:focus,.taginput .is-success.is-active.taginput-container.is-focusable,.taginput .is-success.is-focused.taginput-container.is-focusable,.taginput .is-success.taginput-container.is-focusable:active,.taginput .is-success.taginput-container.is-focusable:focus,.textarea.is-success.is-active,.textarea.is-success.is-focused,.textarea.is-success:active,.textarea.is-success:focus{-webkit-box-shadow:0 0 0 .125em rgba(35,209,96,.25);box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.input.is-warning,.taginput .is-warning.taginput-container.is-focusable,.textarea.is-warning{border-color:#ffdd57}.input.is-warning.is-active,.input.is-warning.is-focused,.input.is-warning:active,.input.is-warning:focus,.taginput .is-warning.is-active.taginput-container.is-focusable,.taginput .is-warning.is-focused.taginput-container.is-focusable,.taginput .is-warning.taginput-container.is-focusable:active,.taginput .is-warning.taginput-container.is-focusable:focus,.textarea.is-warning.is-active,.textarea.is-warning.is-focused,.textarea.is-warning:active,.textarea.is-warning:focus{-webkit-box-shadow:0 0 0 .125em rgba(255,221,87,.25);box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.input.is-danger,.taginput .is-danger.taginput-container.is-focusable,.textarea.is-danger{border-color:#ff3860}.input.is-danger.is-active,.input.is-danger.is-focused,.input.is-danger:active,.input.is-danger:focus,.taginput .is-danger.is-active.taginput-container.is-focusable,.taginput .is-danger.is-focused.taginput-container.is-focusable,.taginput .is-danger.taginput-container.is-focusable:active,.taginput .is-danger.taginput-container.is-focusable:focus,.textarea.is-danger.is-active,.textarea.is-danger.is-focused,.textarea.is-danger:active,.textarea.is-danger:focus{-webkit-box-shadow:0 0 0 .125em rgba(255,56,96,.25);box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.input.is-small,.taginput .is-small.taginput-container.is-focusable,.textarea.is-small{border-radius:2px;font-size:.75rem}.input.is-medium,.taginput .is-medium.taginput-container.is-focusable,.textarea.is-medium{font-size:1.25rem}.input.is-large,.taginput .is-large.taginput-container.is-focusable,.textarea.is-large{font-size:1.5rem}.input.is-fullwidth,.taginput .is-fullwidth.taginput-container.is-focusable,.textarea.is-fullwidth{display:block;width:100%}.input.is-inline,.taginput .is-inline.taginput-container.is-focusable,.textarea.is-inline{display:inline;width:auto}.input.is-rounded,.taginput .is-rounded.taginput-container.is-focusable{border-radius:290486px;padding-left:1em;padding-right:1em}.input.is-static,.taginput .is-static.taginput-container.is-focusable{background-color:transparent;border-color:transparent;-webkit-box-shadow:none;box-shadow:none;padding-left:0;padding-right:0}.textarea{display:block;max-width:100%;min-width:100%;padding:.625em;resize:vertical}.textarea:not([rows]){max-height:600px;min-height:120px}.textarea[rows]{height:auto}.textarea.has-fixed-size{resize:none}.checkbox,.radio{cursor:pointer;display:inline-block;line-height:1.25;position:relative}.checkbox input,.radio input{cursor:pointer}.checkbox:hover,.radio:hover{color:#363636}.checkbox[disabled],.radio[disabled]{color:#7a7a7a;cursor:not-allowed}.radio+.radio{margin-left:.5em}.select{display:inline-block;max-width:100%;position:relative;vertical-align:top}.select:not(.is-multiple){height:2.25em}.select:not(.is-multiple):not(.is-loading):after{border-color:#7957d5;right:1.125em;z-index:4}.select.is-rounded select{border-radius:290486px;padding-left:1em}.select select{background-color:#fff;border-color:#dbdbdb;color:#363636;cursor:pointer;display:block;font-size:1em;max-width:100%;outline:none}.select select::-moz-placeholder{color:rgba(54,54,54,.3)}.select select::-webkit-input-placeholder{color:rgba(54,54,54,.3)}.select select:-moz-placeholder{color:rgba(54,54,54,.3)}.select select:-ms-input-placeholder{color:rgba(54,54,54,.3)}.select select.is-hovered,.select select:hover{border-color:#b5b5b5}.select select.is-active,.select select.is-focused,.select select:active,.select select:focus{border-color:#7957d5;-webkit-box-shadow:0 0 0 .125em rgba(121,87,213,.25);box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.select select[disabled]{background-color:#f5f5f5;border-color:#f5f5f5;-webkit-box-shadow:none;box-shadow:none;color:#7a7a7a}.select select[disabled]::-moz-placeholder{color:hsla(0,0%,48%,.3)}.select select[disabled]::-webkit-input-placeholder{color:hsla(0,0%,48%,.3)}.select select[disabled]:-moz-placeholder{color:hsla(0,0%,48%,.3)}.select select[disabled]:-ms-input-placeholder{color:hsla(0,0%,48%,.3)}.select select::-ms-expand{display:none}.select select[disabled]:hover{border-color:#f5f5f5}.select select:not([multiple]){padding-right:2.5em}.select select[multiple]{height:auto;padding:0}.select select[multiple] option{padding:.5em 1em}.select:not(.is-multiple):not(.is-loading):hover:after{border-color:#363636}.select.is-white:not(:hover):after,.select.is-white select{border-color:#fff}.select.is-white select.is-hovered,.select.is-white select:hover{border-color:#f2f2f2}.select.is-white select.is-active,.select.is-white select.is-focused,.select.is-white select:active,.select.is-white select:focus{-webkit-box-shadow:0 0 0 .125em hsla(0,0%,100%,.25);box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.select.is-black:not(:hover):after,.select.is-black select{border-color:#0a0a0a}.select.is-black select.is-hovered,.select.is-black select:hover{border-color:#000}.select.is-black select.is-active,.select.is-black select.is-focused,.select.is-black select:active,.select.is-black select:focus{-webkit-box-shadow:0 0 0 .125em hsla(0,0%,4%,.25);box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.select.is-light:not(:hover):after,.select.is-light select{border-color:#f5f5f5}.select.is-light select.is-hovered,.select.is-light select:hover{border-color:#e8e8e8}.select.is-light select.is-active,.select.is-light select.is-focused,.select.is-light select:active,.select.is-light select:focus{-webkit-box-shadow:0 0 0 .125em hsla(0,0%,96%,.25);box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.select.is-dark:not(:hover):after,.select.is-dark select{border-color:#363636}.select.is-dark select.is-hovered,.select.is-dark select:hover{border-color:#292929}.select.is-dark select.is-active,.select.is-dark select.is-focused,.select.is-dark select:active,.select.is-dark select:focus{-webkit-box-shadow:0 0 0 .125em rgba(54,54,54,.25);box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.select.is-primary:not(:hover):after,.select.is-primary select{border-color:#7957d5}.select.is-primary select.is-hovered,.select.is-primary select:hover{border-color:#6943d0}.select.is-primary select.is-active,.select.is-primary select.is-focused,.select.is-primary select:active,.select.is-primary select:focus{-webkit-box-shadow:0 0 0 .125em rgba(121,87,213,.25);box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.select.is-link:not(:hover):after,.select.is-link select{border-color:#7957d5}.select.is-link select.is-hovered,.select.is-link select:hover{border-color:#6943d0}.select.is-link select.is-active,.select.is-link select.is-focused,.select.is-link select:active,.select.is-link select:focus{-webkit-box-shadow:0 0 0 .125em rgba(121,87,213,.25);box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.select.is-info:not(:hover):after,.select.is-info select{border-color:#167df0}.select.is-info select.is-hovered,.select.is-info select:hover{border-color:#0e71de}.select.is-info select.is-active,.select.is-info select.is-focused,.select.is-info select:active,.select.is-info select:focus{-webkit-box-shadow:0 0 0 .125em rgba(22,125,240,.25);box-shadow:0 0 0 .125em rgba(22,125,240,.25)}.select.is-success:not(:hover):after,.select.is-success select{border-color:#23d160}.select.is-success select.is-hovered,.select.is-success select:hover{border-color:#20bc56}.select.is-success select.is-active,.select.is-success select.is-focused,.select.is-success select:active,.select.is-success select:focus{-webkit-box-shadow:0 0 0 .125em rgba(35,209,96,.25);box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.select.is-warning:not(:hover):after,.select.is-warning select{border-color:#ffdd57}.select.is-warning select.is-hovered,.select.is-warning select:hover{border-color:#ffd83d}.select.is-warning select.is-active,.select.is-warning select.is-focused,.select.is-warning select:active,.select.is-warning select:focus{-webkit-box-shadow:0 0 0 .125em rgba(255,221,87,.25);box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.select.is-danger:not(:hover):after,.select.is-danger select{border-color:#ff3860}.select.is-danger select.is-hovered,.select.is-danger select:hover{border-color:#ff1f4b}.select.is-danger select.is-active,.select.is-danger select.is-focused,.select.is-danger select:active,.select.is-danger select:focus{-webkit-box-shadow:0 0 0 .125em rgba(255,56,96,.25);box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.select.is-small{border-radius:2px;font-size:.75rem}.select.is-medium{font-size:1.25rem}.select.is-large{font-size:1.5rem}.select.is-disabled:after{border-color:#7a7a7a}.select.is-fullwidth,.select.is-fullwidth select{width:100%}.select.is-loading:after{margin-top:0;position:absolute;right:.625em;top:.625em;-webkit-transform:none;transform:none}.select.is-loading.is-small:after{font-size:.75rem}.select.is-loading.is-medium:after{font-size:1.25rem}.select.is-loading.is-large:after{font-size:1.5rem}.file{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;position:relative}.file.is-white .file-cta{background-color:#fff;border-color:transparent;color:#0a0a0a}.file.is-white.is-hovered .file-cta,.file.is-white:hover .file-cta{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.file.is-white.is-focused .file-cta,.file.is-white:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em hsla(0,0%,100%,.25);box-shadow:0 0 .5em hsla(0,0%,100%,.25);color:#0a0a0a}.file.is-white.is-active .file-cta,.file.is-white:active .file-cta{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.file.is-black .file-cta{background-color:#0a0a0a;border-color:transparent;color:#fff}.file.is-black.is-hovered .file-cta,.file.is-black:hover .file-cta{background-color:#040404;border-color:transparent;color:#fff}.file.is-black.is-focused .file-cta,.file.is-black:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em hsla(0,0%,4%,.25);box-shadow:0 0 .5em hsla(0,0%,4%,.25);color:#fff}.file.is-black.is-active .file-cta,.file.is-black:active .file-cta{background-color:#000;border-color:transparent;color:#fff}.file.is-light .file-cta{background-color:#f5f5f5;border-color:transparent;color:#363636}.file.is-light.is-hovered .file-cta,.file.is-light:hover .file-cta{background-color:#eee;border-color:transparent;color:#363636}.file.is-light.is-focused .file-cta,.file.is-light:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em hsla(0,0%,96%,.25);box-shadow:0 0 .5em hsla(0,0%,96%,.25);color:#363636}.file.is-light.is-active .file-cta,.file.is-light:active .file-cta{background-color:#e8e8e8;border-color:transparent;color:#363636}.file.is-dark .file-cta{background-color:#363636;border-color:transparent;color:#f5f5f5}.file.is-dark.is-hovered .file-cta,.file.is-dark:hover .file-cta{background-color:#2f2f2f;border-color:transparent;color:#f5f5f5}.file.is-dark.is-focused .file-cta,.file.is-dark:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(54,54,54,.25);box-shadow:0 0 .5em rgba(54,54,54,.25);color:#f5f5f5}.file.is-dark.is-active .file-cta,.file.is-dark:active .file-cta{background-color:#292929;border-color:transparent;color:#f5f5f5}.file.is-primary .file-cta{background-color:#7957d5;border-color:transparent;color:#fff}.file.is-primary.is-hovered .file-cta,.file.is-primary:hover .file-cta{background-color:#714dd2;border-color:transparent;color:#fff}.file.is-primary.is-focused .file-cta,.file.is-primary:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(121,87,213,.25);box-shadow:0 0 .5em rgba(121,87,213,.25);color:#fff}.file.is-primary.is-active .file-cta,.file.is-primary:active .file-cta{background-color:#6943d0;border-color:transparent;color:#fff}.file.is-link .file-cta{background-color:#7957d5;border-color:transparent;color:#fff}.file.is-link.is-hovered .file-cta,.file.is-link:hover .file-cta{background-color:#714dd2;border-color:transparent;color:#fff}.file.is-link.is-focused .file-cta,.file.is-link:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(121,87,213,.25);box-shadow:0 0 .5em rgba(121,87,213,.25);color:#fff}.file.is-link.is-active .file-cta,.file.is-link:active .file-cta{background-color:#6943d0;border-color:transparent;color:#fff}.file.is-info .file-cta{background-color:#167df0;border-color:transparent;color:#fff}.file.is-info.is-hovered .file-cta,.file.is-info:hover .file-cta{background-color:#0f77ea;border-color:transparent;color:#fff}.file.is-info.is-focused .file-cta,.file.is-info:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(22,125,240,.25);box-shadow:0 0 .5em rgba(22,125,240,.25);color:#fff}.file.is-info.is-active .file-cta,.file.is-info:active .file-cta{background-color:#0e71de;border-color:transparent;color:#fff}.file.is-success .file-cta{background-color:#23d160;border-color:transparent;color:#fff}.file.is-success.is-hovered .file-cta,.file.is-success:hover .file-cta{background-color:#22c65b;border-color:transparent;color:#fff}.file.is-success.is-focused .file-cta,.file.is-success:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(35,209,96,.25);box-shadow:0 0 .5em rgba(35,209,96,.25);color:#fff}.file.is-success.is-active .file-cta,.file.is-success:active .file-cta{background-color:#20bc56;border-color:transparent;color:#fff}.file.is-warning .file-cta{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-warning.is-hovered .file-cta,.file.is-warning:hover .file-cta{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-warning.is-focused .file-cta,.file.is-warning:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(255,221,87,.25);box-shadow:0 0 .5em rgba(255,221,87,.25);color:rgba(0,0,0,.7)}.file.is-warning.is-active .file-cta,.file.is-warning:active .file-cta{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-danger .file-cta{background-color:#ff3860;border-color:transparent;color:#fff}.file.is-danger.is-hovered .file-cta,.file.is-danger:hover .file-cta{background-color:#ff2b56;border-color:transparent;color:#fff}.file.is-danger.is-focused .file-cta,.file.is-danger:focus .file-cta{border-color:transparent;-webkit-box-shadow:0 0 .5em rgba(255,56,96,.25);box-shadow:0 0 .5em rgba(255,56,96,.25);color:#fff}.file.is-danger.is-active .file-cta,.file.is-danger:active .file-cta{background-color:#ff1f4b;border-color:transparent;color:#fff}.file.is-small{font-size:.75rem}.file.is-medium{font-size:1.25rem}.file.is-medium .file-icon .fa{font-size:21px}.file.is-large{font-size:1.5rem}.file.is-large .file-icon .fa{font-size:28px}.file.has-name .file-cta{border-bottom-right-radius:0;border-top-right-radius:0}.file.has-name .file-name{border-bottom-left-radius:0;border-top-left-radius:0}.file.has-name.is-empty .file-cta{border-radius:4px}.file.has-name.is-empty .file-name{display:none}.file.is-boxed .file-cta,.file.is-boxed .file-label{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.file.is-boxed .file-cta{height:auto;padding:1em 3em}.file.is-boxed .file-name{border-width:0 1px 1px}.file.is-boxed .file-icon{height:1.5em;width:1.5em}.file.is-boxed .file-icon .fa{font-size:21px}.file.is-boxed.is-small .file-icon .fa{font-size:14px}.file.is-boxed.is-medium .file-icon .fa{font-size:28px}.file.is-boxed.is-large .file-icon .fa{font-size:35px}.file.is-boxed.has-name .file-cta{border-radius:4px 4px 0 0}.file.is-boxed.has-name .file-name{border-radius:0 0 4px 4px;border-width:0 1px 1px}.file.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.file.is-fullwidth .file-label{width:100%}.file.is-fullwidth .file-name{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:none}.file.is-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.file.is-right .file-cta{border-radius:0 4px 4px 0}.file.is-right .file-name{border-radius:4px 0 0 4px;border-width:1px 0 1px 1px;-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.file-label{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;overflow:hidden;position:relative}.file-label:hover .file-cta{background-color:#eee;color:#363636}.file-label:hover .file-name{border-color:#d5d5d5}.file-label:active .file-cta{background-color:#e8e8e8;color:#363636}.file-label:active .file-name{border-color:#cfcfcf}.file-input{height:.01em;left:0;outline:none;position:absolute;top:0;width:.01em}.file-cta,.file-name{border-color:#dbdbdb;border-radius:4px;font-size:1em;padding-left:1em;padding-right:1em;white-space:nowrap}.file-cta{background-color:#f5f5f5;color:#4a4a4a}.file-name{border-color:#dbdbdb;border-style:solid;border-width:1px 1px 1px 0;display:block;max-width:16em;overflow:hidden;text-align:left;text-overflow:ellipsis}.file-icon{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:1em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:.5em;width:1em}.file-icon .fa{font-size:14px}.label{color:#363636;display:block;font-size:1rem;font-weight:700}.label:not(:last-child){margin-bottom:.5em}.label.is-small{font-size:.75rem}.label.is-medium{font-size:1.25rem}.label.is-large{font-size:1.5rem}.help{display:block;font-size:.75rem;margin-top:.25rem}.help.is-white{color:#fff}.help.is-black{color:#0a0a0a}.help.is-light{color:#f5f5f5}.help.is-dark{color:#363636}.help.is-link,.help.is-primary{color:#7957d5}.help.is-info{color:#167df0}.help.is-success{color:#23d160}.help.is-warning{color:#ffdd57}.help.is-danger{color:#ff3860}.field:not(:last-child){margin-bottom:.75rem}.field.has-addons{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.field.has-addons .control:not(:last-child){margin-right:-1px}.field.has-addons .control:not(:first-child):not(:last-child) .button,.field.has-addons .control:not(:first-child):not(:last-child) .input,.field.has-addons .control:not(:first-child):not(:last-child) .select select,.field.has-addons .control:not(:first-child):not(:last-child) .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:not(:first-child):not(:last-child) .taginput-container.is-focusable{border-radius:0}.field.has-addons .control:first-child .button,.field.has-addons .control:first-child .input,.field.has-addons .control:first-child .select select,.field.has-addons .control:first-child .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:first-child .taginput-container.is-focusable{border-bottom-right-radius:0;border-top-right-radius:0}.field.has-addons .control:last-child .button,.field.has-addons .control:last-child .input,.field.has-addons .control:last-child .select select,.field.has-addons .control:last-child .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:last-child .taginput-container.is-focusable{border-bottom-left-radius:0;border-top-left-radius:0}.field.has-addons .control .button.is-hovered,.field.has-addons .control .button:hover,.field.has-addons .control .input.is-hovered,.field.has-addons .control .input:hover,.field.has-addons .control .select select.is-hovered,.field.has-addons .control .select select:hover,.field.has-addons .control .taginput .is-hovered.taginput-container.is-focusable,.field.has-addons .control .taginput .taginput-container.is-focusable:hover,.taginput .field.has-addons .control .is-hovered.taginput-container.is-focusable,.taginput .field.has-addons .control .taginput-container.is-focusable:hover{z-index:2}.field.has-addons .control .button.is-active,.field.has-addons .control .button.is-focused,.field.has-addons .control .button:active,.field.has-addons .control .button:focus,.field.has-addons .control .input.is-active,.field.has-addons .control .input.is-focused,.field.has-addons .control .input:active,.field.has-addons .control .input:focus,.field.has-addons .control .select select.is-active,.field.has-addons .control .select select.is-focused,.field.has-addons .control .select select:active,.field.has-addons .control .select select:focus,.field.has-addons .control .taginput .is-active.taginput-container.is-focusable,.field.has-addons .control .taginput .is-focused.taginput-container.is-focusable,.field.has-addons .control .taginput .taginput-container.is-focusable:active,.field.has-addons .control .taginput .taginput-container.is-focusable:focus,.taginput .field.has-addons .control .is-active.taginput-container.is-focusable,.taginput .field.has-addons .control .is-focused.taginput-container.is-focusable,.taginput .field.has-addons .control .taginput-container.is-focusable:active,.taginput .field.has-addons .control .taginput-container.is-focusable:focus{z-index:3}.field.has-addons .control .button.is-active:hover,.field.has-addons .control .button.is-focused:hover,.field.has-addons .control .button:active:hover,.field.has-addons .control .button:focus:hover,.field.has-addons .control .input.is-active:hover,.field.has-addons .control .input.is-focused:hover,.field.has-addons .control .input:active:hover,.field.has-addons .control .input:focus:hover,.field.has-addons .control .select select.is-active:hover,.field.has-addons .control .select select.is-focused:hover,.field.has-addons .control .select select:active:hover,.field.has-addons .control .select select:focus:hover,.field.has-addons .control .taginput .is-active.taginput-container.is-focusable:hover,.field.has-addons .control .taginput .is-focused.taginput-container.is-focusable:hover,.field.has-addons .control .taginput .taginput-container.is-focusable:active:hover,.field.has-addons .control .taginput .taginput-container.is-focusable:focus:hover,.taginput .field.has-addons .control .is-active.taginput-container.is-focusable:hover,.taginput .field.has-addons .control .is-focused.taginput-container.is-focusable:hover,.taginput .field.has-addons .control .taginput-container.is-focusable:active:hover,.taginput .field.has-addons .control .taginput-container.is-focusable:focus:hover{z-index:4}.field.has-addons .control.is-expanded{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.field.has-addons.has-addons-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.field.has-addons.has-addons-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.field.has-addons.has-addons-fullwidth .control{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0}.field.is-grouped{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.field.is-grouped>.control{-ms-flex-negative:0;flex-shrink:0}.field.is-grouped>.control:not(:last-child){margin-bottom:0;margin-right:.75rem}.field.is-grouped>.control.is-expanded{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.field.is-grouped.is-grouped-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.field.is-grouped.is-grouped-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.field.is-grouped.is-grouped-multiline{-ms-flex-wrap:wrap;flex-wrap:wrap}.field.is-grouped.is-grouped-multiline>.control:last-child,.field.is-grouped.is-grouped-multiline>.control:not(:last-child){margin-bottom:.75rem}.field.is-grouped.is-grouped-multiline:last-child{margin-bottom:-.75rem}.field.is-grouped.is-grouped-multiline:not(:last-child){margin-bottom:0}@media print,screen and (min-width:769px){.field.is-horizontal{display:-webkit-box;display:-ms-flexbox;display:flex}}.field-label .label{font-size:inherit}@media screen and (max-width:768px){.field-label{margin-bottom:.5rem}}@media print,screen and (min-width:769px){.field-label{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;margin-right:1.5rem;text-align:right}.field-label.is-small{font-size:.75rem;padding-top:.375em}.field-label.is-normal{padding-top:.375em}.field-label.is-medium{font-size:1.25rem;padding-top:.375em}.field-label.is-large{font-size:1.5rem;padding-top:.375em}}.field-body .field .field{margin-bottom:0}@media print,screen and (min-width:769px){.field-body{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:5;-ms-flex-positive:5;flex-grow:5;-ms-flex-negative:1;flex-shrink:1}.field-body .field{margin-bottom:0}.field-body>.field{-ms-flex-negative:1;flex-shrink:1}.field-body>.field:not(.is-narrow){-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.field-body>.field:not(:last-child){margin-right:.75rem}}.control{font-size:1rem;position:relative;text-align:left}.control.has-icon .icon{color:#dbdbdb;height:2.25em;pointer-events:none;position:absolute;top:0;width:2.25em;z-index:4}.control.has-icon .input:focus+.icon,.control.has-icon .taginput .taginput-container.is-focusable:focus+.icon,.taginput .control.has-icon .taginput-container.is-focusable:focus+.icon{color:#7a7a7a}.control.has-icon .input.is-small+.icon,.control.has-icon .taginput .is-small.taginput-container.is-focusable+.icon,.taginput .control.has-icon .is-small.taginput-container.is-focusable+.icon{font-size:.75rem}.control.has-icon .input.is-medium+.icon,.control.has-icon .taginput .is-medium.taginput-container.is-focusable+.icon,.taginput .control.has-icon .is-medium.taginput-container.is-focusable+.icon{font-size:1.25rem}.control.has-icon .input.is-large+.icon,.control.has-icon .taginput .is-large.taginput-container.is-focusable+.icon,.taginput .control.has-icon .is-large.taginput-container.is-focusable+.icon{font-size:1.5rem}.control.has-icon:not(.has-icon-right) .icon{left:0}.control.has-icon:not(.has-icon-right) .input,.control.has-icon:not(.has-icon-right) .taginput .taginput-container.is-focusable,.taginput .control.has-icon:not(.has-icon-right) .taginput-container.is-focusable{padding-left:2.25em}.control.has-icon.has-icon-right .icon{right:0}.control.has-icon.has-icon-right .input,.control.has-icon.has-icon-right .taginput .taginput-container.is-focusable,.taginput .control.has-icon.has-icon-right .taginput-container.is-focusable{padding-right:2.25em}.control.has-icons-left .input:focus~.icon,.control.has-icons-left .select:focus~.icon,.control.has-icons-left .taginput .taginput-container.is-focusable:focus~.icon,.control.has-icons-right .input:focus~.icon,.control.has-icons-right .select:focus~.icon,.control.has-icons-right .taginput .taginput-container.is-focusable:focus~.icon,.taginput .control.has-icons-left .taginput-container.is-focusable:focus~.icon,.taginput .control.has-icons-right .taginput-container.is-focusable:focus~.icon{color:#7a7a7a}.control.has-icons-left .input.is-small~.icon,.control.has-icons-left .select.is-small~.icon,.control.has-icons-left .taginput .is-small.taginput-container.is-focusable~.icon,.control.has-icons-right .input.is-small~.icon,.control.has-icons-right .select.is-small~.icon,.control.has-icons-right .taginput .is-small.taginput-container.is-focusable~.icon,.taginput .control.has-icons-left .is-small.taginput-container.is-focusable~.icon,.taginput .control.has-icons-right .is-small.taginput-container.is-focusable~.icon{font-size:.75rem}.control.has-icons-left .input.is-medium~.icon,.control.has-icons-left .select.is-medium~.icon,.control.has-icons-left .taginput .is-medium.taginput-container.is-focusable~.icon,.control.has-icons-right .input.is-medium~.icon,.control.has-icons-right .select.is-medium~.icon,.control.has-icons-right .taginput .is-medium.taginput-container.is-focusable~.icon,.taginput .control.has-icons-left .is-medium.taginput-container.is-focusable~.icon,.taginput .control.has-icons-right .is-medium.taginput-container.is-focusable~.icon{font-size:1.25rem}.control.has-icons-left .input.is-large~.icon,.control.has-icons-left .select.is-large~.icon,.control.has-icons-left .taginput .is-large.taginput-container.is-focusable~.icon,.control.has-icons-right .input.is-large~.icon,.control.has-icons-right .select.is-large~.icon,.control.has-icons-right .taginput .is-large.taginput-container.is-focusable~.icon,.taginput .control.has-icons-left .is-large.taginput-container.is-focusable~.icon,.taginput .control.has-icons-right .is-large.taginput-container.is-focusable~.icon{font-size:1.5rem}.control.has-icons-left .icon,.control.has-icons-right .icon{color:#dbdbdb;height:2.25em;pointer-events:none;position:absolute;top:0;width:2.25em;z-index:4}.control.has-icons-left .input,.control.has-icons-left .select select,.control.has-icons-left .taginput .taginput-container.is-focusable,.taginput .control.has-icons-left .taginput-container.is-focusable{padding-left:2.25em}.control.has-icons-left .icon.is-left{left:0}.control.has-icons-right .input,.control.has-icons-right .select select,.control.has-icons-right .taginput .taginput-container.is-focusable,.taginput .control.has-icons-right .taginput-container.is-focusable{padding-right:2.25em}.control.has-icons-right .icon.is-right{right:0}.control.is-loading:after{position:absolute!important;right:.625em;top:.625em;z-index:4}.control.is-loading.is-small:after{font-size:.75rem}.control.is-loading.is-medium:after{font-size:1.25rem}.control.is-loading.is-large:after{font-size:1.5rem}.icon{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:1.5rem;width:1.5rem}.icon.is-small{height:1rem;width:1rem}.icon.is-medium{height:2rem;width:2rem}.icon.is-large{height:3rem;width:3rem}.image{display:block;position:relative}.image img{display:block;height:auto;width:100%}.image img.is-rounded{border-radius:290486px}.image.is-1by1 img,.image.is-1by2 img,.image.is-1by3 img,.image.is-2by1 img,.image.is-2by3 img,.image.is-3by1 img,.image.is-3by2 img,.image.is-3by4 img,.image.is-3by5 img,.image.is-4by3 img,.image.is-4by5 img,.image.is-5by3 img,.image.is-5by4 img,.image.is-9by16 img,.image.is-16by9 img,.image.is-square img{height:100%;width:100%}.image.is-1by1,.image.is-square{padding-top:100%}.image.is-5by4{padding-top:80%}.image.is-4by3{padding-top:75%}.image.is-3by2{padding-top:66.6666%}.image.is-5by3{padding-top:60%}.image.is-16by9{padding-top:56.25%}.image.is-2by1{padding-top:50%}.image.is-3by1{padding-top:33.3333%}.image.is-4by5{padding-top:125%}.image.is-3by4{padding-top:133.3333%}.image.is-2by3{padding-top:150%}.image.is-3by5{padding-top:166.6666%}.image.is-9by16{padding-top:177.7777%}.image.is-1by2{padding-top:200%}.image.is-1by3{padding-top:300%}.image.is-16x16{height:16px;width:16px}.image.is-24x24{height:24px;width:24px}.image.is-32x32{height:32px;width:32px}.image.is-48x48{height:48px;width:48px}.image.is-64x64{height:64px;width:64px}.image.is-96x96{height:96px;width:96px}.image.is-128x128{height:128px;width:128px}.notification{background-color:#f5f5f5;border-radius:4px;padding:1.25rem 2.5rem 1.25rem 1.5rem;position:relative}.notification a:not(.button){color:currentColor;text-decoration:underline}.notification strong{color:currentColor}.notification code,.notification pre{background:#fff}.notification pre code{background:transparent}.notification>.delete{position:absolute;right:.5rem;top:.5rem}.notification .content,.notification .subtitle,.notification .title{color:currentColor}.notification.is-white{background-color:#fff;color:#0a0a0a}.notification.is-black{background-color:#0a0a0a;color:#fff}.notification.is-light{background-color:#f5f5f5;color:#363636}.notification.is-dark{background-color:#363636;color:#f5f5f5}.notification.is-link,.notification.is-primary{background-color:#7957d5;color:#fff}.notification.is-info{background-color:#167df0;color:#fff}.notification.is-success{background-color:#23d160;color:#fff}.notification.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.notification.is-danger{background-color:#ff3860;color:#fff}.progress{-moz-appearance:none;-webkit-appearance:none;border:none;border-radius:290486px;display:block;height:1rem;overflow:hidden;padding:0;width:100%}.progress::-webkit-progress-bar{background-color:#dbdbdb}.progress::-webkit-progress-value{background-color:#4a4a4a}.progress::-moz-progress-bar{background-color:#4a4a4a}.progress::-ms-fill{background-color:#4a4a4a;border:none}.progress.is-white::-webkit-progress-value{background-color:#fff}.progress.is-white::-moz-progress-bar{background-color:#fff}.progress.is-white::-ms-fill{background-color:#fff}.progress.is-black::-webkit-progress-value{background-color:#0a0a0a}.progress.is-black::-moz-progress-bar{background-color:#0a0a0a}.progress.is-black::-ms-fill{background-color:#0a0a0a}.progress.is-light::-webkit-progress-value{background-color:#f5f5f5}.progress.is-light::-moz-progress-bar{background-color:#f5f5f5}.progress.is-light::-ms-fill{background-color:#f5f5f5}.progress.is-dark::-webkit-progress-value{background-color:#363636}.progress.is-dark::-moz-progress-bar{background-color:#363636}.progress.is-dark::-ms-fill{background-color:#363636}.progress.is-primary::-webkit-progress-value{background-color:#7957d5}.progress.is-primary::-moz-progress-bar{background-color:#7957d5}.progress.is-primary::-ms-fill{background-color:#7957d5}.progress.is-link::-webkit-progress-value{background-color:#7957d5}.progress.is-link::-moz-progress-bar{background-color:#7957d5}.progress.is-link::-ms-fill{background-color:#7957d5}.progress.is-info::-webkit-progress-value{background-color:#167df0}.progress.is-info::-moz-progress-bar{background-color:#167df0}.progress.is-info::-ms-fill{background-color:#167df0}.progress.is-success::-webkit-progress-value{background-color:#23d160}.progress.is-success::-moz-progress-bar{background-color:#23d160}.progress.is-success::-ms-fill{background-color:#23d160}.progress.is-warning::-webkit-progress-value{background-color:#ffdd57}.progress.is-warning::-moz-progress-bar{background-color:#ffdd57}.progress.is-warning::-ms-fill{background-color:#ffdd57}.progress.is-danger::-webkit-progress-value{background-color:#ff3860}.progress.is-danger::-moz-progress-bar{background-color:#ff3860}.progress.is-danger::-ms-fill{background-color:#ff3860}.progress.is-small{height:.75rem}.progress.is-medium{height:1.25rem}.progress.is-large{height:1.5rem}.table{background-color:#fff;color:#363636}.table td,.table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.table td.is-white,.table th.is-white{background-color:#fff;border-color:#fff;color:#0a0a0a}.table td.is-black,.table th.is-black{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.table td.is-light,.table th.is-light{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.table td.is-dark,.table th.is-dark{background-color:#363636;border-color:#363636;color:#f5f5f5}.table td.is-link,.table td.is-primary,.table th.is-link,.table th.is-primary{background-color:#7957d5;border-color:#7957d5;color:#fff}.table td.is-info,.table th.is-info{background-color:#167df0;border-color:#167df0;color:#fff}.table td.is-success,.table th.is-success{background-color:#23d160;border-color:#23d160;color:#fff}.table td.is-warning,.table th.is-warning{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.table td.is-danger,.table th.is-danger{background-color:#ff3860;border-color:#ff3860;color:#fff}.table td.is-narrow,.table th.is-narrow{white-space:nowrap;width:1%}.table td.is-selected,.table th.is-selected{background-color:#7957d5;color:#fff}.table td.is-selected a,.table td.is-selected strong,.table th.is-selected a,.table th.is-selected strong{color:currentColor}.table th{color:#363636;text-align:left}.table tr.is-selected{background-color:#7957d5;color:#fff}.table tr.is-selected a,.table tr.is-selected strong{color:currentColor}.table tr.is-selected td,.table tr.is-selected th{border-color:#fff;color:currentColor}.table thead td,.table thead th{border-width:0 0 2px;color:#363636}.table tfoot td,.table tfoot th{border-width:2px 0 0;color:#363636}.table tbody tr:last-child td,.table tbody tr:last-child th{border-bottom-width:0}.table.is-bordered td,.table.is-bordered th{border-width:1px}.table.is-bordered tr:last-child td,.table.is-bordered tr:last-child th{border-bottom-width:1px}.table.is-fullwidth{width:100%}.table.is-hoverable tbody tr:not(.is-selected):hover{background-color:#fafafa}.table.is-hoverable.is-striped tbody tr:not(.is-selected):hover{background-color:#f5f5f5}.table.is-narrow td,.table.is-narrow th{padding:.25em .5em}.table.is-striped tbody tr:not(.is-selected):nth-child(2n){background-color:#fafafa}.table-container{-webkit-overflow-scrolling:touch;overflow:auto;overflow-y:hidden;max-width:100%}.tags{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.tags .tag{margin-bottom:.5rem}.tags .tag:not(:last-child){margin-right:.5rem}.tags:last-child{margin-bottom:-.5rem}.tags:not(:last-child){margin-bottom:1rem}.tags.has-addons .tag{margin-right:0}.tags.has-addons .tag:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.tags.has-addons .tag:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.tags.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.tags.is-centered .tag{margin-right:.25rem;margin-left:.25rem}.tags.is-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.tags.is-right .tag:not(:first-child){margin-left:.5rem}.tags.is-right .tag:not(:last-child){margin-right:0}.tag:not(body){-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f5f5f5;border-radius:4px;color:#4a4a4a;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:.75rem;height:2em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1.5;padding-left:.75em;padding-right:.75em;white-space:nowrap}.tag:not(body) .delete{margin-left:.25rem;margin-right:-.375rem}.tag:not(body).is-white{background-color:#fff;color:#0a0a0a}.tag:not(body).is-black{background-color:#0a0a0a;color:#fff}.tag:not(body).is-light{background-color:#f5f5f5;color:#363636}.tag:not(body).is-dark{background-color:#363636;color:#f5f5f5}.tag:not(body).is-link,.tag:not(body).is-primary{background-color:#7957d5;color:#fff}.tag:not(body).is-info{background-color:#167df0;color:#fff}.tag:not(body).is-success{background-color:#23d160;color:#fff}.tag:not(body).is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.tag:not(body).is-danger{background-color:#ff3860;color:#fff}.tag:not(body).is-medium{font-size:1rem}.tag:not(body).is-large{font-size:1.25rem}.tag:not(body) .icon:first-child:not(:last-child){margin-left:-.375em;margin-right:.1875em}.tag:not(body) .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:-.375em}.tag:not(body) .icon:first-child:last-child{margin-left:-.375em;margin-right:-.375em}.tag:not(body).is-delete{margin-left:1px;padding:0;position:relative;width:2em}.tag:not(body).is-delete:after,.tag:not(body).is-delete:before{background-color:currentColor;content:\"\";display:block;left:50%;position:absolute;top:50%;-webkit-transform:translateX(-50%) translateY(-50%) rotate(45deg);transform:translateX(-50%) translateY(-50%) rotate(45deg);-webkit-transform-origin:center center;transform-origin:center center}.tag:not(body).is-delete:before{height:1px;width:50%}.tag:not(body).is-delete:after{height:50%;width:1px}.tag:not(body).is-delete:focus,.tag:not(body).is-delete:hover{background-color:#e8e8e8}.tag:not(body).is-delete:active{background-color:#dbdbdb}.tag:not(body).is-rounded{border-radius:290486px}a.tag:hover{text-decoration:underline}.subtitle,.title{word-break:break-word}.subtitle em,.subtitle span,.title em,.title span{font-weight:inherit}.subtitle sub,.subtitle sup,.title sub,.title sup{font-size:.75em}.subtitle .tag,.title .tag{vertical-align:middle}.title{color:#363636;font-size:2rem;font-weight:600;line-height:1.125}.title strong{color:inherit;font-weight:inherit}.title+.highlight{margin-top:-.75rem}.title:not(.is-spaced)+.subtitle{margin-top:-1.25rem}.title.is-1{font-size:3rem}.title.is-2{font-size:2.5rem}.title.is-3{font-size:2rem}.title.is-4{font-size:1.5rem}.title.is-5{font-size:1.25rem}.title.is-6{font-size:1rem}.title.is-7{font-size:.75rem}.subtitle{color:#4a4a4a;font-size:1.25rem;font-weight:400;line-height:1.25}.subtitle strong{color:#363636;font-weight:600}.subtitle:not(.is-spaced)+.title{margin-top:-1.25rem}.subtitle.is-1{font-size:3rem}.subtitle.is-2{font-size:2.5rem}.subtitle.is-3{font-size:2rem}.subtitle.is-4{font-size:1.5rem}.subtitle.is-5{font-size:1.25rem}.subtitle.is-6{font-size:1rem}.subtitle.is-7{font-size:.75rem}.heading{display:block;font-size:11px;letter-spacing:1px;margin-bottom:5px;text-transform:uppercase}.highlight{font-weight:400;max-width:100%;overflow:hidden;padding:0}.highlight pre{overflow:auto;max-width:100%}.number{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f5f5f5;border-radius:290486px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1.25rem;height:2em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:1.5rem;min-width:2.5em;padding:.25rem .5rem;text-align:center;vertical-align:top}.breadcrumb{font-size:1rem;white-space:nowrap}.breadcrumb a{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#7957d5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 .75em}.breadcrumb a:hover{color:#363636}.breadcrumb li{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.breadcrumb li:first-child a{padding-left:0}.breadcrumb li.is-active a{color:#363636;cursor:default;pointer-events:none}.breadcrumb li+li:before{color:#b5b5b5;content:\"/\"}.breadcrumb ol,.breadcrumb ul{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.breadcrumb .icon:first-child{margin-right:.5em}.breadcrumb .icon:last-child{margin-left:.5em}.breadcrumb.is-centered ol,.breadcrumb.is-centered ul{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.breadcrumb.is-right ol,.breadcrumb.is-right ul{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.breadcrumb.is-small{font-size:.75rem}.breadcrumb.is-medium{font-size:1.25rem}.breadcrumb.is-large{font-size:1.5rem}.breadcrumb.has-arrow-separator li+li:before{content:\"\\2192\"}.breadcrumb.has-bullet-separator li+li:before{content:\"\\2022\"}.breadcrumb.has-dot-separator li+li:before{content:\"\\B7\"}.breadcrumb.has-succeeds-separator li+li:before{content:\"\\227B\"}.card{background-color:#fff;-webkit-box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);color:#4a4a4a;max-width:100%;position:relative}.card-header{background-color:none;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-shadow:0 1px 2px hsla(0,0%,4%,.1);box-shadow:0 1px 2px hsla(0,0%,4%,.1)}.card-header,.card-header-title{display:-webkit-box;display:-ms-flexbox;display:flex}.card-header-title{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#363636;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-weight:700;padding:.75rem}.card-header-icon,.card-header-title.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.card-header-icon{-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;padding:.75rem}.card-image{display:block;position:relative}.card-content{background-color:none;padding:1.5rem}.card-footer{background-color:none;border-top:1px solid #dbdbdb;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.card-footer,.card-footer-item{display:-webkit-box;display:-ms-flexbox;display:flex}.card-footer-item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:.75rem}.card-footer-item:not(:last-child){border-right:1px solid #dbdbdb}.card .media:not(:last-child){margin-bottom:.75rem}.dropdown{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;position:relative;vertical-align:top}.dropdown.is-active .dropdown-menu,.dropdown.is-hoverable:hover .dropdown-menu{display:block}.dropdown.is-right .dropdown-menu{left:auto;right:0}.dropdown.is-up .dropdown-menu{bottom:100%;padding-bottom:4px;padding-top:0;top:auto}.dropdown-menu{display:none;left:0;min-width:12rem;padding-top:4px;position:absolute;top:100%;z-index:20}.dropdown-content{background-color:#fff;border-radius:4px;-webkit-box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);padding-bottom:.5rem;padding-top:.5rem}.dropdown-item,.dropdown .dropdown-menu .has-link a{color:#4a4a4a;display:block;font-size:.875rem;line-height:1.5;padding:.375rem 1rem;position:relative}.dropdown .dropdown-menu .has-link a,a.dropdown-item{padding-right:3rem;white-space:nowrap}.dropdown .dropdown-menu .has-link a:hover,a.dropdown-item:hover{background-color:#f5f5f5;color:#0a0a0a}.dropdown .dropdown-menu .has-link a.is-active,a.dropdown-item.is-active{background-color:#7957d5;color:#fff}.dropdown-divider{background-color:#dbdbdb;border:none;display:block;height:1px;margin:.5rem 0}.level{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.level code{border-radius:4px}.level img{display:inline-block;vertical-align:top}.level.is-mobile,.level.is-mobile .level-left,.level.is-mobile .level-right{display:-webkit-box;display:-ms-flexbox;display:flex}.level.is-mobile .level-left+.level-right{margin-top:0}.level.is-mobile .level-item{margin-right:.75rem}.level.is-mobile .level-item:not(:last-child){margin-bottom:0}.level.is-mobile .level-item:not(.is-narrow){-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}@media print,screen and (min-width:769px){.level{display:-webkit-box;display:-ms-flexbox;display:flex}.level>.level-item:not(.is-narrow){-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.level-item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.level-item .subtitle,.level-item .title{margin-bottom:0}@media screen and (max-width:768px){.level-item:not(:last-child){margin-bottom:.75rem}}.level-left,.level-right{-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.level-left .level-item.is-flexible,.level-right .level-item.is-flexible{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}@media print,screen and (min-width:769px){.level-left .level-item:not(:last-child),.level-right .level-item:not(:last-child){margin-right:.75rem}}.level-left{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}@media screen and (max-width:768px){.level-left+.level-right{margin-top:1.5rem}}@media print,screen and (min-width:769px){.level-left{display:-webkit-box;display:-ms-flexbox;display:flex}}.level-right{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}@media print,screen and (min-width:769px){.level-right{display:-webkit-box;display:-ms-flexbox;display:flex}}.media{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex;text-align:left}.media .content:not(:last-child){margin-bottom:.75rem}.media .media{border-top:1px solid hsla(0,0%,86%,.5);display:-webkit-box;display:-ms-flexbox;display:flex;padding-top:.75rem}.media .media .content:not(:last-child),.media .media .control:not(:last-child){margin-bottom:.5rem}.media .media .media{padding-top:.5rem}.media .media .media+.media{margin-top:.5rem}.media+.media{border-top:1px solid hsla(0,0%,86%,.5);margin-top:1rem;padding-top:1rem}.media.is-large+.media{margin-top:1.5rem;padding-top:1.5rem}.media-left,.media-right{-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.media-left{margin-right:1rem}.media-right{margin-left:1rem}.media-content{-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;text-align:left}.menu{font-size:1rem}.menu.is-small{font-size:.75rem}.menu.is-medium{font-size:1.25rem}.menu.is-large{font-size:1.5rem}.menu-list{line-height:1.25}.menu-list a{border-radius:2px;color:#4a4a4a;display:block;padding:.5em .75em}.menu-list a:hover{background-color:#f5f5f5;color:#363636}.menu-list a.is-active{background-color:#7957d5;color:#fff}.menu-list li ul{border-left:1px solid #dbdbdb;margin:.75em;padding-left:.75em}.menu-label{color:#7a7a7a;font-size:.75em;letter-spacing:.1em;text-transform:uppercase}.menu-label:not(:first-child){margin-top:1em}.menu-label:not(:last-child){margin-bottom:1em}.message{background-color:#f5f5f5;border-radius:4px;font-size:1rem}.message strong{color:currentColor}.message a:not(.button):not(.tag){color:currentColor;text-decoration:underline}.message.is-small{font-size:.75rem}.message.is-medium{font-size:1.25rem}.message.is-large{font-size:1.5rem}.message.is-white{background-color:#fff}.message.is-white .message-header{background-color:#fff;color:#0a0a0a}.message.is-white .message-body{border-color:#fff;color:#4d4d4d}.message.is-black{background-color:#fafafa}.message.is-black .message-header{background-color:#0a0a0a;color:#fff}.message.is-black .message-body{border-color:#0a0a0a;color:#090909}.message.is-light{background-color:#fafafa}.message.is-light .message-header{background-color:#f5f5f5;color:#363636}.message.is-light .message-body{border-color:#f5f5f5;color:#505050}.message.is-dark{background-color:#fafafa}.message.is-dark .message-header{background-color:#363636;color:#f5f5f5}.message.is-dark .message-body{border-color:#363636;color:#2a2a2a}.message.is-primary{background-color:#f8f7fd}.message.is-primary .message-header{background-color:#7957d5;color:#fff}.message.is-primary .message-body{border-color:#7957d5;color:#5534ae}.message.is-link{background-color:#f8f7fd}.message.is-link .message-header{background-color:#7957d5;color:#fff}.message.is-link .message-body{border-color:#7957d5;color:#5534ae}.message.is-info{background-color:#f5fafe}.message.is-info .message-header{background-color:#167df0;color:#fff}.message.is-info .message-body{border-color:#167df0;color:#115199}.message.is-success{background-color:#f6fef9}.message.is-success .message-header{background-color:#23d160;color:#fff}.message.is-success .message-body{border-color:#23d160;color:#0e301a}.message.is-warning{background-color:#fffdf5}.message.is-warning .message-header{background-color:#ffdd57;color:rgba(0,0,0,.7)}.message.is-warning .message-body{border-color:#ffdd57;color:#3b3108}.message.is-danger{background-color:#fff5f7}.message.is-danger .message-header{background-color:#ff3860;color:#fff}.message.is-danger .message-body{border-color:#ff3860;color:#cd0930}.message-header{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#4a4a4a;border-radius:4px 4px 0 0;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;font-weight:700;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;line-height:1.25;padding:.75em 1em;position:relative}.message-header .delete{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;margin-left:.75em}.message-header+.message-body{border-width:0;border-top-left-radius:0;border-top-right-radius:0}.message-body{border-color:#dbdbdb;border-radius:4px;border-style:solid;border-width:0 0 0 4px;color:#4a4a4a;padding:1.25em 1.5em}.message-body code,.message-body pre{background-color:#fff}.message-body pre code{background-color:transparent}.modal{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:none;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;position:fixed;z-index:40}.modal.is-active{display:-webkit-box;display:-ms-flexbox;display:flex}.modal-background{background-color:hsla(0,0%,4%,.86)}.modal-card,.modal-content{margin:0 20px;max-height:calc(100vh - 160px);overflow:auto;position:relative;width:100%}@media print,screen and (min-width:769px){.modal-card,.modal-content{margin:0 auto;max-height:calc(100vh - 40px);width:640px}}.modal-close{background:none;height:40px;position:fixed;right:20px;top:20px;width:40px}.modal-card{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;max-height:calc(100vh - 40px);overflow:hidden}.modal-card,.modal-card-foot,.modal-card-head{display:-webkit-box;display:-ms-flexbox;display:flex}.modal-card-foot,.modal-card-head{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f5f5f5;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:20px;position:relative}.modal-card-head{border-bottom:1px solid #dbdbdb;border-top-left-radius:6px;border-top-right-radius:6px}.modal-card-title{color:#363636;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;font-size:1.5rem;line-height:1}.modal-card-foot{border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:1px solid #dbdbdb}.modal-card-foot .button:not(:last-child){margin-right:10px}.modal-card-body{-webkit-overflow-scrolling:touch;background-color:#fff;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto;padding:20px}.navbar{background-color:#fff;min-height:3.25rem;position:relative;z-index:30}.navbar.is-white{background-color:#fff;color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link,.navbar.is-white .navbar-brand>.navbar-item{color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link.is-active,.navbar.is-white .navbar-brand .navbar-link:hover,.navbar.is-white .navbar-brand>a.navbar-item.is-active,.navbar.is-white .navbar-brand>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link:after{border-color:#0a0a0a}@media screen and (min-width:1088px){.navbar.is-white .navbar-end .navbar-link,.navbar.is-white .navbar-end>.navbar-item,.navbar.is-white .navbar-start .navbar-link,.navbar.is-white .navbar-start>.navbar-item{color:#0a0a0a}.navbar.is-white .navbar-end .navbar-link.is-active,.navbar.is-white .navbar-end .navbar-link:hover,.navbar.is-white .navbar-end>a.navbar-item.is-active,.navbar.is-white .navbar-end>a.navbar-item:hover,.navbar.is-white .navbar-start .navbar-link.is-active,.navbar.is-white .navbar-start .navbar-link:hover,.navbar.is-white .navbar-start>a.navbar-item.is-active,.navbar.is-white .navbar-start>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-end .navbar-link:after,.navbar.is-white .navbar-start .navbar-link:after{border-color:#0a0a0a}.navbar.is-white .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-white .navbar-item.has-dropdown:hover .navbar-link{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-dropdown a.navbar-item.is-active{background-color:#fff;color:#0a0a0a}}.navbar.is-black{background-color:#0a0a0a;color:#fff}.navbar.is-black .navbar-brand .navbar-link,.navbar.is-black .navbar-brand>.navbar-item{color:#fff}.navbar.is-black .navbar-brand .navbar-link.is-active,.navbar.is-black .navbar-brand .navbar-link:hover,.navbar.is-black .navbar-brand>a.navbar-item.is-active,.navbar.is-black .navbar-brand>a.navbar-item:hover{background-color:#000;color:#fff}.navbar.is-black .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-black .navbar-end .navbar-link,.navbar.is-black .navbar-end>.navbar-item,.navbar.is-black .navbar-start .navbar-link,.navbar.is-black .navbar-start>.navbar-item{color:#fff}.navbar.is-black .navbar-end .navbar-link.is-active,.navbar.is-black .navbar-end .navbar-link:hover,.navbar.is-black .navbar-end>a.navbar-item.is-active,.navbar.is-black .navbar-end>a.navbar-item:hover,.navbar.is-black .navbar-start .navbar-link.is-active,.navbar.is-black .navbar-start .navbar-link:hover,.navbar.is-black .navbar-start>a.navbar-item.is-active,.navbar.is-black .navbar-start>a.navbar-item:hover{background-color:#000;color:#fff}.navbar.is-black .navbar-end .navbar-link:after,.navbar.is-black .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-black .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-black .navbar-item.has-dropdown:hover .navbar-link{background-color:#000;color:#fff}.navbar.is-black .navbar-dropdown a.navbar-item.is-active{background-color:#0a0a0a;color:#fff}}.navbar.is-light{background-color:#f5f5f5;color:#363636}.navbar.is-light .navbar-brand .navbar-link,.navbar.is-light .navbar-brand>.navbar-item{color:#363636}.navbar.is-light .navbar-brand .navbar-link.is-active,.navbar.is-light .navbar-brand .navbar-link:hover,.navbar.is-light .navbar-brand>a.navbar-item.is-active,.navbar.is-light .navbar-brand>a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-brand .navbar-link:after{border-color:#363636}@media screen and (min-width:1088px){.navbar.is-light .navbar-end .navbar-link,.navbar.is-light .navbar-end>.navbar-item,.navbar.is-light .navbar-start .navbar-link,.navbar.is-light .navbar-start>.navbar-item{color:#363636}.navbar.is-light .navbar-end .navbar-link.is-active,.navbar.is-light .navbar-end .navbar-link:hover,.navbar.is-light .navbar-end>a.navbar-item.is-active,.navbar.is-light .navbar-end>a.navbar-item:hover,.navbar.is-light .navbar-start .navbar-link.is-active,.navbar.is-light .navbar-start .navbar-link:hover,.navbar.is-light .navbar-start>a.navbar-item.is-active,.navbar.is-light .navbar-start>a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-end .navbar-link:after,.navbar.is-light .navbar-start .navbar-link:after{border-color:#363636}.navbar.is-light .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-light .navbar-item.has-dropdown:hover .navbar-link{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#363636}}.navbar.is-dark{background-color:#363636;color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link,.navbar.is-dark .navbar-brand>.navbar-item{color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link.is-active,.navbar.is-dark .navbar-brand .navbar-link:hover,.navbar.is-dark .navbar-brand>a.navbar-item.is-active,.navbar.is-dark .navbar-brand>a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link:after{border-color:#f5f5f5}@media screen and (min-width:1088px){.navbar.is-dark .navbar-end .navbar-link,.navbar.is-dark .navbar-end>.navbar-item,.navbar.is-dark .navbar-start .navbar-link,.navbar.is-dark .navbar-start>.navbar-item{color:#f5f5f5}.navbar.is-dark .navbar-end .navbar-link.is-active,.navbar.is-dark .navbar-end .navbar-link:hover,.navbar.is-dark .navbar-end>a.navbar-item.is-active,.navbar.is-dark .navbar-end>a.navbar-item:hover,.navbar.is-dark .navbar-start .navbar-link.is-active,.navbar.is-dark .navbar-start .navbar-link:hover,.navbar.is-dark .navbar-start>a.navbar-item.is-active,.navbar.is-dark .navbar-start>a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-end .navbar-link:after,.navbar.is-dark .navbar-start .navbar-link:after{border-color:#f5f5f5}.navbar.is-dark .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-dark .navbar-item.has-dropdown:hover .navbar-link{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-dropdown a.navbar-item.is-active{background-color:#363636;color:#f5f5f5}}.navbar.is-primary{background-color:#7957d5;color:#fff}.navbar.is-primary .navbar-brand .navbar-link,.navbar.is-primary .navbar-brand>.navbar-item{color:#fff}.navbar.is-primary .navbar-brand .navbar-link.is-active,.navbar.is-primary .navbar-brand .navbar-link:hover,.navbar.is-primary .navbar-brand>a.navbar-item.is-active,.navbar.is-primary .navbar-brand>a.navbar-item:hover{background-color:#6943d0;color:#fff}.navbar.is-primary .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-primary .navbar-end .navbar-link,.navbar.is-primary .navbar-end>.navbar-item,.navbar.is-primary .navbar-start .navbar-link,.navbar.is-primary .navbar-start>.navbar-item{color:#fff}.navbar.is-primary .navbar-end .navbar-link.is-active,.navbar.is-primary .navbar-end .navbar-link:hover,.navbar.is-primary .navbar-end>a.navbar-item.is-active,.navbar.is-primary .navbar-end>a.navbar-item:hover,.navbar.is-primary .navbar-start .navbar-link.is-active,.navbar.is-primary .navbar-start .navbar-link:hover,.navbar.is-primary .navbar-start>a.navbar-item.is-active,.navbar.is-primary .navbar-start>a.navbar-item:hover{background-color:#6943d0;color:#fff}.navbar.is-primary .navbar-end .navbar-link:after,.navbar.is-primary .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link{background-color:#6943d0;color:#fff}.navbar.is-primary .navbar-dropdown a.navbar-item.is-active{background-color:#7957d5;color:#fff}}.navbar.is-link{background-color:#7957d5;color:#fff}.navbar.is-link .navbar-brand .navbar-link,.navbar.is-link .navbar-brand>.navbar-item{color:#fff}.navbar.is-link .navbar-brand .navbar-link.is-active,.navbar.is-link .navbar-brand .navbar-link:hover,.navbar.is-link .navbar-brand>a.navbar-item.is-active,.navbar.is-link .navbar-brand>a.navbar-item:hover{background-color:#6943d0;color:#fff}.navbar.is-link .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-link .navbar-end .navbar-link,.navbar.is-link .navbar-end>.navbar-item,.navbar.is-link .navbar-start .navbar-link,.navbar.is-link .navbar-start>.navbar-item{color:#fff}.navbar.is-link .navbar-end .navbar-link.is-active,.navbar.is-link .navbar-end .navbar-link:hover,.navbar.is-link .navbar-end>a.navbar-item.is-active,.navbar.is-link .navbar-end>a.navbar-item:hover,.navbar.is-link .navbar-start .navbar-link.is-active,.navbar.is-link .navbar-start .navbar-link:hover,.navbar.is-link .navbar-start>a.navbar-item.is-active,.navbar.is-link .navbar-start>a.navbar-item:hover{background-color:#6943d0;color:#fff}.navbar.is-link .navbar-end .navbar-link:after,.navbar.is-link .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-link .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-link .navbar-item.has-dropdown:hover .navbar-link{background-color:#6943d0;color:#fff}.navbar.is-link .navbar-dropdown a.navbar-item.is-active{background-color:#7957d5;color:#fff}}.navbar.is-info{background-color:#167df0;color:#fff}.navbar.is-info .navbar-brand .navbar-link,.navbar.is-info .navbar-brand>.navbar-item{color:#fff}.navbar.is-info .navbar-brand .navbar-link.is-active,.navbar.is-info .navbar-brand .navbar-link:hover,.navbar.is-info .navbar-brand>a.navbar-item.is-active,.navbar.is-info .navbar-brand>a.navbar-item:hover{background-color:#0e71de;color:#fff}.navbar.is-info .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-info .navbar-end .navbar-link,.navbar.is-info .navbar-end>.navbar-item,.navbar.is-info .navbar-start .navbar-link,.navbar.is-info .navbar-start>.navbar-item{color:#fff}.navbar.is-info .navbar-end .navbar-link.is-active,.navbar.is-info .navbar-end .navbar-link:hover,.navbar.is-info .navbar-end>a.navbar-item.is-active,.navbar.is-info .navbar-end>a.navbar-item:hover,.navbar.is-info .navbar-start .navbar-link.is-active,.navbar.is-info .navbar-start .navbar-link:hover,.navbar.is-info .navbar-start>a.navbar-item.is-active,.navbar.is-info .navbar-start>a.navbar-item:hover{background-color:#0e71de;color:#fff}.navbar.is-info .navbar-end .navbar-link:after,.navbar.is-info .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-info .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-info .navbar-item.has-dropdown:hover .navbar-link{background-color:#0e71de;color:#fff}.navbar.is-info .navbar-dropdown a.navbar-item.is-active{background-color:#167df0;color:#fff}}.navbar.is-success{background-color:#23d160;color:#fff}.navbar.is-success .navbar-brand .navbar-link,.navbar.is-success .navbar-brand>.navbar-item{color:#fff}.navbar.is-success .navbar-brand .navbar-link.is-active,.navbar.is-success .navbar-brand .navbar-link:hover,.navbar.is-success .navbar-brand>a.navbar-item.is-active,.navbar.is-success .navbar-brand>a.navbar-item:hover{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-success .navbar-end .navbar-link,.navbar.is-success .navbar-end>.navbar-item,.navbar.is-success .navbar-start .navbar-link,.navbar.is-success .navbar-start>.navbar-item{color:#fff}.navbar.is-success .navbar-end .navbar-link.is-active,.navbar.is-success .navbar-end .navbar-link:hover,.navbar.is-success .navbar-end>a.navbar-item.is-active,.navbar.is-success .navbar-end>a.navbar-item:hover,.navbar.is-success .navbar-start .navbar-link.is-active,.navbar.is-success .navbar-start .navbar-link:hover,.navbar.is-success .navbar-start>a.navbar-item.is-active,.navbar.is-success .navbar-start>a.navbar-item:hover{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-end .navbar-link:after,.navbar.is-success .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-success .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-success .navbar-item.has-dropdown:hover .navbar-link{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-dropdown a.navbar-item.is-active{background-color:#23d160;color:#fff}}.navbar.is-warning{background-color:#ffdd57}.navbar.is-warning,.navbar.is-warning .navbar-brand .navbar-link,.navbar.is-warning .navbar-brand>.navbar-item{color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-brand .navbar-link.is-active,.navbar.is-warning .navbar-brand .navbar-link:hover,.navbar.is-warning .navbar-brand>a.navbar-item.is-active,.navbar.is-warning .navbar-brand>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-brand .navbar-link:after{border-color:rgba(0,0,0,.7)}@media screen and (min-width:1088px){.navbar.is-warning .navbar-end .navbar-link,.navbar.is-warning .navbar-end>.navbar-item,.navbar.is-warning .navbar-start .navbar-link,.navbar.is-warning .navbar-start>.navbar-item{color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-end .navbar-link.is-active,.navbar.is-warning .navbar-end .navbar-link:hover,.navbar.is-warning .navbar-end>a.navbar-item.is-active,.navbar.is-warning .navbar-end>a.navbar-item:hover,.navbar.is-warning .navbar-start .navbar-link.is-active,.navbar.is-warning .navbar-start .navbar-link:hover,.navbar.is-warning .navbar-start>a.navbar-item.is-active,.navbar.is-warning .navbar-start>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-end .navbar-link:after,.navbar.is-warning .navbar-start .navbar-link:after{border-color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-warning .navbar-item.has-dropdown:hover .navbar-link{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-dropdown a.navbar-item.is-active{background-color:#ffdd57;color:rgba(0,0,0,.7)}}.navbar.is-danger{background-color:#ff3860;color:#fff}.navbar.is-danger .navbar-brand .navbar-link,.navbar.is-danger .navbar-brand>.navbar-item{color:#fff}.navbar.is-danger .navbar-brand .navbar-link.is-active,.navbar.is-danger .navbar-brand .navbar-link:hover,.navbar.is-danger .navbar-brand>a.navbar-item.is-active,.navbar.is-danger .navbar-brand>a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-danger .navbar-end .navbar-link,.navbar.is-danger .navbar-end>.navbar-item,.navbar.is-danger .navbar-start .navbar-link,.navbar.is-danger .navbar-start>.navbar-item{color:#fff}.navbar.is-danger .navbar-end .navbar-link.is-active,.navbar.is-danger .navbar-end .navbar-link:hover,.navbar.is-danger .navbar-end>a.navbar-item.is-active,.navbar.is-danger .navbar-end>a.navbar-item:hover,.navbar.is-danger .navbar-start .navbar-link.is-active,.navbar.is-danger .navbar-start .navbar-link:hover,.navbar.is-danger .navbar-start>a.navbar-item.is-active,.navbar.is-danger .navbar-start>a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-end .navbar-link:after,.navbar.is-danger .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-danger .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-danger .navbar-item.has-dropdown:hover .navbar-link{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-dropdown a.navbar-item.is-active{background-color:#ff3860;color:#fff}}.navbar>.container{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;min-height:3.25rem;width:100%}.navbar.has-shadow{-webkit-box-shadow:0 2px 0 0 #f5f5f5;box-shadow:0 2px 0 0 #f5f5f5}.navbar.is-fixed-bottom,.navbar.is-fixed-top{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom{bottom:0}.navbar.is-fixed-bottom.has-shadow{-webkit-box-shadow:0 -2px 0 0 #f5f5f5;box-shadow:0 -2px 0 0 #f5f5f5}.navbar.is-fixed-top{top:0}body.has-navbar-fixed-top,html.has-navbar-fixed-top{padding-top:3.25rem}body.has-navbar-fixed-bottom,html.has-navbar-fixed-bottom{padding-bottom:3.25rem}.navbar-brand,.navbar-tabs{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;min-height:3.25rem}.navbar-brand a.navbar-item:hover{background-color:transparent}.navbar-tabs{-webkit-overflow-scrolling:touch;max-width:100vw;overflow-x:auto;overflow-y:hidden}.navbar-burger{cursor:pointer;display:block;height:3.25rem;position:relative;width:3.25rem;margin-left:auto}.navbar-burger span{background-color:currentColor;display:block;height:1px;left:calc(50% - 8px);position:absolute;-webkit-transform-origin:center;transform-origin:center;-webkit-transition-duration:86ms;transition-duration:86ms;-webkit-transition-property:background-color,opacity,-webkit-transform;transition-property:background-color,opacity,-webkit-transform;transition-property:background-color,opacity,transform;transition-property:background-color,opacity,transform,-webkit-transform;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out;width:16px}.navbar-burger span:first-child{top:calc(50% - 6px)}.navbar-burger span:nth-child(2){top:calc(50% - 1px)}.navbar-burger span:nth-child(3){top:calc(50% + 4px)}.navbar-burger:hover{background-color:rgba(0,0,0,.05)}.navbar-burger.is-active span:first-child{-webkit-transform:translateY(5px) rotate(45deg);transform:translateY(5px) rotate(45deg)}.navbar-burger.is-active span:nth-child(2){opacity:0}.navbar-burger.is-active span:nth-child(3){-webkit-transform:translateY(-5px) rotate(-45deg);transform:translateY(-5px) rotate(-45deg)}.navbar-menu{display:none}.navbar-item,.navbar-link{color:#4a4a4a;display:block;line-height:1.5;padding:.5rem .75rem;position:relative}.navbar-item .icon:only-child,.navbar-link .icon:only-child{margin-left:-.25rem;margin-right:-.25rem}.navbar-link,a.navbar-item{cursor:pointer}.navbar-link.is-active,.navbar-link:hover,a.navbar-item.is-active,a.navbar-item:hover{background-color:#fafafa;color:#7957d5}.navbar-item{display:block;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.navbar-item img{max-height:1.75rem}.navbar-item.has-dropdown{padding:0}.navbar-item.is-expanded{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.navbar-item.is-tab{border-bottom:1px solid transparent;min-height:3.25rem;padding-bottom:calc(.5rem - 1px)}.navbar-item.is-tab.is-active,.navbar-item.is-tab:hover{background-color:transparent;border-bottom-color:#7957d5}.navbar-item.is-tab.is-active{border-bottom-style:solid;border-bottom-width:3px;color:#7957d5;padding-bottom:calc(.5rem - 3px)}.navbar-content{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.navbar-link{padding-right:2.5em}.navbar-link:after{border-color:#7957d5;margin-top:-.375em;right:1.125em}.navbar-dropdown{font-size:.875rem;padding-bottom:.5rem;padding-top:.5rem}.navbar-dropdown .navbar-item{padding-left:1.5rem;padding-right:1.5rem}.navbar-divider{background-color:#f5f5f5;border:none;display:none;height:2px;margin:.5rem 0}@media screen and (max-width:1087px){.navbar>.container{display:block}.navbar-brand .navbar-item,.navbar-tabs .navbar-item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.navbar-link:after{display:none}.navbar-menu{background-color:#fff;-webkit-box-shadow:0 8px 16px hsla(0,0%,4%,.1);box-shadow:0 8px 16px hsla(0,0%,4%,.1);padding:.5rem 0}.navbar-menu.is-active{display:block}.navbar.is-fixed-bottom-touch,.navbar.is-fixed-top-touch{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom-touch{bottom:0}.navbar.is-fixed-bottom-touch.has-shadow{-webkit-box-shadow:0 -2px 3px hsla(0,0%,4%,.1);box-shadow:0 -2px 3px hsla(0,0%,4%,.1)}.navbar.is-fixed-top-touch{top:0}.navbar.is-fixed-top-touch .navbar-menu,.navbar.is-fixed-top .navbar-menu{-webkit-overflow-scrolling:touch;max-height:calc(100vh - 3.25rem);overflow:auto}body.has-navbar-fixed-top-touch,html.has-navbar-fixed-top-touch{padding-top:3.25rem}body.has-navbar-fixed-bottom-touch,html.has-navbar-fixed-bottom-touch{padding-bottom:3.25rem}}@media screen and (min-width:1088px){.navbar,.navbar-end,.navbar-menu,.navbar-start{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex}.navbar{min-height:3.25rem}.navbar.is-spaced{padding:1rem 2rem}.navbar.is-spaced .navbar-end,.navbar.is-spaced .navbar-start{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.navbar.is-spaced .navbar-link,.navbar.is-spaced a.navbar-item{border-radius:4px}.navbar.is-transparent .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:hover .navbar-link,.navbar.is-transparent .navbar-link.is-active,.navbar.is-transparent .navbar-link:hover,.navbar.is-transparent a.navbar-item.is-active,.navbar.is-transparent a.navbar-item:hover{background-color:transparent!important}.navbar.is-transparent .navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.navbar.is-transparent .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#7957d5}.navbar-burger{display:none}.navbar-item,.navbar-link{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.navbar-item,.navbar-link{display:-webkit-box;display:-ms-flexbox;display:flex}.navbar-item.has-dropdown{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.navbar-item.has-dropdown-up .navbar-link:after{-webkit-transform:rotate(135deg) translate(.25em,-.25em);transform:rotate(135deg) translate(.25em,-.25em)}.navbar-item.has-dropdown-up .navbar-dropdown{border-bottom:2px solid #dbdbdb;border-radius:6px 6px 0 0;border-top:none;bottom:100%;-webkit-box-shadow:0 -8px 8px hsla(0,0%,4%,.1);box-shadow:0 -8px 8px hsla(0,0%,4%,.1);top:auto}.navbar-item.is-active .navbar-dropdown,.navbar-item.is-hoverable:hover .navbar-dropdown{display:block}.navbar-item.is-active .navbar-dropdown.is-boxed,.navbar-item.is-hoverable:hover .navbar-dropdown.is-boxed,.navbar.is-spaced .navbar-item.is-active .navbar-dropdown,.navbar.is-spaced .navbar-item.is-hoverable:hover .navbar-dropdown{opacity:1;pointer-events:auto;-webkit-transform:translateY(0);transform:translateY(0)}.navbar-menu{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0}.navbar-start{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin-right:auto}.navbar-end{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-left:auto}.navbar-dropdown{background-color:#fff;border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:2px solid #dbdbdb;-webkit-box-shadow:0 8px 8px hsla(0,0%,4%,.1);box-shadow:0 8px 8px hsla(0,0%,4%,.1);display:none;font-size:.875rem;left:0;min-width:100%;position:absolute;top:100%;z-index:20}.navbar-dropdown .navbar-item{padding:.375rem 1rem;white-space:nowrap}.navbar-dropdown a.navbar-item{padding-right:3rem}.navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#7957d5}.navbar-dropdown.is-boxed,.navbar.is-spaced .navbar-dropdown{border-radius:6px;border-top:none;-webkit-box-shadow:0 8px 8px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);box-shadow:0 8px 8px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);display:block;opacity:0;pointer-events:none;top:calc(100% + -4px);-webkit-transform:translateY(-5px);transform:translateY(-5px);-webkit-transition-duration:86ms;transition-duration:86ms;-webkit-transition-property:opacity,-webkit-transform;transition-property:opacity,-webkit-transform;transition-property:opacity,transform;transition-property:opacity,transform,-webkit-transform}.navbar-dropdown.is-right{left:auto;right:0}.navbar-divider{display:block}.container>.navbar .navbar-brand,.navbar>.container .navbar-brand{margin-left:-1rem}.container>.navbar .navbar-menu,.navbar>.container .navbar-menu{margin-right:-1rem}.navbar.is-fixed-bottom-desktop,.navbar.is-fixed-top-desktop{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom-desktop{bottom:0}.navbar.is-fixed-bottom-desktop.has-shadow{-webkit-box-shadow:0 -2px 3px hsla(0,0%,4%,.1);box-shadow:0 -2px 3px hsla(0,0%,4%,.1)}.navbar.is-fixed-top-desktop{top:0}body.has-navbar-fixed-top-desktop,html.has-navbar-fixed-top-desktop{padding-top:3.25rem}body.has-navbar-fixed-bottom-desktop,html.has-navbar-fixed-bottom-desktop{padding-bottom:3.25rem}body.has-spaced-navbar-fixed-top,html.has-spaced-navbar-fixed-top{padding-top:5.25rem}body.has-spaced-navbar-fixed-bottom,html.has-spaced-navbar-fixed-bottom{padding-bottom:5.25rem}.navbar-link.is-active,a.navbar-item.is-active{color:#0a0a0a}.navbar-link.is-active:not(:hover),a.navbar-item.is-active:not(:hover){background-color:transparent}.navbar-item.has-dropdown.is-active .navbar-link,.navbar-item.has-dropdown:hover .navbar-link{background-color:#fafafa}}.pagination{font-size:1rem;margin:-.25rem}.pagination.is-small{font-size:.75rem}.pagination.is-medium{font-size:1.25rem}.pagination.is-large{font-size:1.5rem}.pagination.is-rounded .pagination-next,.pagination.is-rounded .pagination-previous{padding-left:1em;padding-right:1em;border-radius:290486px}.pagination.is-rounded .pagination-link{border-radius:290486px}.pagination,.pagination-list{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous{font-size:1em;padding-left:.5em;padding-right:.5em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:.25rem;text-align:center}.pagination-link,.pagination-next,.pagination-previous{border-color:#dbdbdb;color:#363636;min-width:2.25em}.pagination-link:hover,.pagination-next:hover,.pagination-previous:hover{border-color:#b5b5b5;color:#363636}.pagination-link:focus,.pagination-next:focus,.pagination-previous:focus{border-color:#7957d5}.pagination-link:active,.pagination-next:active,.pagination-previous:active{-webkit-box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2);box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2)}.pagination-link[disabled],.pagination-next[disabled],.pagination-previous[disabled]{background-color:#dbdbdb;border-color:#dbdbdb;-webkit-box-shadow:none;box-shadow:none;color:#7a7a7a;opacity:.5}.pagination-next,.pagination-previous{padding-left:.75em;padding-right:.75em;white-space:nowrap}.pagination-link.is-current{background-color:#7957d5;border-color:#7957d5;color:#fff}.pagination-ellipsis{color:#b5b5b5;pointer-events:none}.pagination-list{-ms-flex-wrap:wrap;flex-wrap:wrap}@media screen and (max-width:768px){.pagination{-ms-flex-wrap:wrap;flex-wrap:wrap}.pagination-list li,.pagination-next,.pagination-previous{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}}@media print,screen and (min-width:769px){.pagination-list{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.pagination-previous{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.pagination-next{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.pagination{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.pagination.is-centered .pagination-previous{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.pagination.is-centered .pagination-list{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.pagination.is-centered .pagination-next{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.pagination.is-right .pagination-previous{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.pagination.is-right .pagination-next{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.pagination.is-right .pagination-list{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}}.panel{font-size:1rem}.panel:not(:last-child){margin-bottom:1.5rem}.panel-block,.panel-heading,.panel-tabs{border-bottom:1px solid #dbdbdb;border-left:1px solid #dbdbdb;border-right:1px solid #dbdbdb}.panel-block:first-child,.panel-heading:first-child,.panel-tabs:first-child{border-top:1px solid #dbdbdb}.panel-heading{background-color:#f5f5f5;border-radius:4px 4px 0 0;color:#363636;font-size:1.25em;font-weight:300;line-height:1.25;padding:.5em .75em}.panel-tabs{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.875em;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.panel-tabs a{border-bottom:1px solid #dbdbdb;margin-bottom:-1px;padding:.5em}.panel-tabs a.is-active{border-bottom-color:#4a4a4a;color:#363636}.panel-list a{color:#4a4a4a}.panel-list a:hover{color:#7957d5}.panel-block{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#363636;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:.5em .75em}.panel-block input[type=checkbox]{margin-right:.75em}.panel-block>.control{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;width:100%}.panel-block.is-wrapped{-ms-flex-wrap:wrap;flex-wrap:wrap}.panel-block.is-active{border-left-color:#7957d5;color:#363636}.panel-block.is-active .panel-icon{color:#7957d5}a.panel-block,label.panel-block{cursor:pointer}a.panel-block:hover,label.panel-block:hover{background-color:#f5f5f5}.panel-icon{display:inline-block;font-size:14px;height:1em;line-height:1em;text-align:center;vertical-align:top;width:1em;color:#7a7a7a;margin-right:.75em}.panel-icon .fa{font-size:inherit;line-height:inherit}.tabs{-webkit-overflow-scrolling:touch;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;font-size:1rem;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;overflow:hidden;overflow-x:auto;white-space:nowrap}.tabs,.tabs a{display:-webkit-box;display:-ms-flexbox;display:flex}.tabs a{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;color:#4a4a4a;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:-1px;padding:.5em 1em;vertical-align:top}.tabs a:hover{border-bottom-color:#363636;color:#363636}.tabs li{display:block}.tabs li.is-active a{border-bottom-color:#7957d5;color:#7957d5}.tabs ul{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.tabs ul.is-center,.tabs ul.is-left{padding-right:.75em}.tabs ul.is-center{-webkit-box-flex:0;-ms-flex:none;flex:none;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-left:.75em}.tabs ul.is-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-left:.75em}.tabs .icon:first-child{margin-right:.5em}.tabs .icon:last-child{margin-left:.5em}.tabs.is-centered ul{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.tabs.is-right ul{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.tabs.is-boxed a{border:1px solid transparent;border-radius:4px 4px 0 0}.tabs.is-boxed a:hover{background-color:#f5f5f5;border-bottom-color:#dbdbdb}.tabs.is-boxed li.is-active a{background-color:#fff;border-color:#dbdbdb;border-bottom-color:transparent!important}.tabs.is-fullwidth li{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0}.tabs.is-toggle a{border:1px solid #dbdbdb;margin-bottom:0;position:relative}.tabs.is-toggle a:hover{background-color:#f5f5f5;border-color:#b5b5b5;z-index:2}.tabs.is-toggle li+li{margin-left:-1px}.tabs.is-toggle li:first-child a{border-radius:4px 0 0 4px}.tabs.is-toggle li:last-child a{border-radius:0 4px 4px 0}.tabs.is-toggle li.is-active a{background-color:#7957d5;border-color:#7957d5;color:#fff;z-index:1}.tabs.is-toggle ul{border-bottom:none}.tabs.is-toggle.is-toggle-rounded li:first-child a{border-bottom-left-radius:290486px;border-top-left-radius:290486px;padding-left:1.25em}.tabs.is-toggle.is-toggle-rounded li:last-child a{border-bottom-right-radius:290486px;border-top-right-radius:290486px;padding-right:1.25em}.tabs.is-small{font-size:.75rem}.tabs.is-medium{font-size:1.25rem}.tabs.is-large{font-size:1.5rem}.column{display:block;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;padding:.75rem}.columns.is-mobile>.column.is-full,.columns.is-mobile>.column.is-narrow{-webkit-box-flex:0;-ms-flex:none;flex:none}.columns.is-mobile>.column.is-full{width:100%}.columns.is-mobile>.column.is-three-quarters{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.columns.is-mobile>.column.is-two-thirds{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.columns.is-mobile>.column.is-half{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.columns.is-mobile>.column.is-one-third{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.columns.is-mobile>.column.is-one-quarter{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.columns.is-mobile>.column.is-one-fifth{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.columns.is-mobile>.column.is-two-fifths{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.columns.is-mobile>.column.is-three-fifths{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.columns.is-mobile>.column.is-four-fifths{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.columns.is-mobile>.column.is-offset-three-quarters{margin-left:75%}.columns.is-mobile>.column.is-offset-two-thirds{margin-left:66.6666%}.columns.is-mobile>.column.is-offset-half{margin-left:50%}.columns.is-mobile>.column.is-offset-one-third{margin-left:33.3333%}.columns.is-mobile>.column.is-offset-one-quarter{margin-left:25%}.columns.is-mobile>.column.is-offset-one-fifth{margin-left:20%}.columns.is-mobile>.column.is-offset-two-fifths{margin-left:40%}.columns.is-mobile>.column.is-offset-three-fifths{margin-left:60%}.columns.is-mobile>.column.is-offset-four-fifths{margin-left:80%}.columns.is-mobile>.column.is-1{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.33333%}.columns.is-mobile>.column.is-offset-1{margin-left:8.33333%}.columns.is-mobile>.column.is-2{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.66667%}.columns.is-mobile>.column.is-offset-2{margin-left:16.66667%}.columns.is-mobile>.column.is-3{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.columns.is-mobile>.column.is-offset-3{margin-left:25%}.columns.is-mobile>.column.is-4{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.33333%}.columns.is-mobile>.column.is-offset-4{margin-left:33.33333%}.columns.is-mobile>.column.is-5{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.66667%}.columns.is-mobile>.column.is-offset-5{margin-left:41.66667%}.columns.is-mobile>.column.is-6{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.columns.is-mobile>.column.is-offset-6{margin-left:50%}.columns.is-mobile>.column.is-7{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.33333%}.columns.is-mobile>.column.is-offset-7{margin-left:58.33333%}.columns.is-mobile>.column.is-8{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.66667%}.columns.is-mobile>.column.is-offset-8{margin-left:66.66667%}.columns.is-mobile>.column.is-9{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.columns.is-mobile>.column.is-offset-9{margin-left:75%}.columns.is-mobile>.column.is-10{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.33333%}.columns.is-mobile>.column.is-offset-10{margin-left:83.33333%}.columns.is-mobile>.column.is-11{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.66667%}.columns.is-mobile>.column.is-offset-11{margin-left:91.66667%}.columns.is-mobile>.column.is-12{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.columns.is-mobile>.column.is-offset-12{margin-left:100%}@media screen and (max-width:768px){.column.is-full-mobile,.column.is-narrow-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none}.column.is-full-mobile{width:100%}.column.is-three-quarters-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-two-thirds-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.column.is-half-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-one-third-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.column.is-one-quarter-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-one-fifth-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.column.is-two-fifths-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.column.is-three-fifths-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.column.is-four-fifths-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.column.is-offset-three-quarters-mobile{margin-left:75%}.column.is-offset-two-thirds-mobile{margin-left:66.6666%}.column.is-offset-half-mobile{margin-left:50%}.column.is-offset-one-third-mobile{margin-left:33.3333%}.column.is-offset-one-quarter-mobile{margin-left:25%}.column.is-offset-one-fifth-mobile{margin-left:20%}.column.is-offset-two-fifths-mobile{margin-left:40%}.column.is-offset-three-fifths-mobile{margin-left:60%}.column.is-offset-four-fifths-mobile{margin-left:80%}.column.is-1-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.33333%}.column.is-offset-1-mobile{margin-left:8.33333%}.column.is-2-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.66667%}.column.is-offset-2-mobile{margin-left:16.66667%}.column.is-3-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-offset-3-mobile{margin-left:25%}.column.is-4-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.33333%}.column.is-offset-4-mobile{margin-left:33.33333%}.column.is-5-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.66667%}.column.is-offset-5-mobile{margin-left:41.66667%}.column.is-6-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-offset-6-mobile{margin-left:50%}.column.is-7-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.33333%}.column.is-offset-7-mobile{margin-left:58.33333%}.column.is-8-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.66667%}.column.is-offset-8-mobile{margin-left:66.66667%}.column.is-9-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-offset-9-mobile{margin-left:75%}.column.is-10-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.33333%}.column.is-offset-10-mobile{margin-left:83.33333%}.column.is-11-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.66667%}.column.is-offset-11-mobile{margin-left:91.66667%}.column.is-12-mobile{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.column.is-offset-12-mobile{margin-left:100%}}@media print,screen and (min-width:769px){.column.is-full,.column.is-full-tablet,.column.is-narrow,.column.is-narrow-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none}.column.is-full,.column.is-full-tablet{width:100%}.column.is-three-quarters,.column.is-three-quarters-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-two-thirds,.column.is-two-thirds-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.column.is-half,.column.is-half-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-one-third,.column.is-one-third-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.column.is-one-quarter,.column.is-one-quarter-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-one-fifth,.column.is-one-fifth-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.column.is-two-fifths,.column.is-two-fifths-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.column.is-three-fifths,.column.is-three-fifths-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.column.is-four-fifths,.column.is-four-fifths-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.column.is-offset-three-quarters,.column.is-offset-three-quarters-tablet{margin-left:75%}.column.is-offset-two-thirds,.column.is-offset-two-thirds-tablet{margin-left:66.6666%}.column.is-offset-half,.column.is-offset-half-tablet{margin-left:50%}.column.is-offset-one-third,.column.is-offset-one-third-tablet{margin-left:33.3333%}.column.is-offset-one-quarter,.column.is-offset-one-quarter-tablet{margin-left:25%}.column.is-offset-one-fifth,.column.is-offset-one-fifth-tablet{margin-left:20%}.column.is-offset-two-fifths,.column.is-offset-two-fifths-tablet{margin-left:40%}.column.is-offset-three-fifths,.column.is-offset-three-fifths-tablet{margin-left:60%}.column.is-offset-four-fifths,.column.is-offset-four-fifths-tablet{margin-left:80%}.column.is-1,.column.is-1-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.33333%}.column.is-offset-1,.column.is-offset-1-tablet{margin-left:8.33333%}.column.is-2,.column.is-2-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.66667%}.column.is-offset-2,.column.is-offset-2-tablet{margin-left:16.66667%}.column.is-3,.column.is-3-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-offset-3,.column.is-offset-3-tablet{margin-left:25%}.column.is-4,.column.is-4-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.33333%}.column.is-offset-4,.column.is-offset-4-tablet{margin-left:33.33333%}.column.is-5,.column.is-5-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.66667%}.column.is-offset-5,.column.is-offset-5-tablet{margin-left:41.66667%}.column.is-6,.column.is-6-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-offset-6,.column.is-offset-6-tablet{margin-left:50%}.column.is-7,.column.is-7-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.33333%}.column.is-offset-7,.column.is-offset-7-tablet{margin-left:58.33333%}.column.is-8,.column.is-8-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.66667%}.column.is-offset-8,.column.is-offset-8-tablet{margin-left:66.66667%}.column.is-9,.column.is-9-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-offset-9,.column.is-offset-9-tablet{margin-left:75%}.column.is-10,.column.is-10-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.33333%}.column.is-offset-10,.column.is-offset-10-tablet{margin-left:83.33333%}.column.is-11,.column.is-11-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.66667%}.column.is-offset-11,.column.is-offset-11-tablet{margin-left:91.66667%}.column.is-12,.column.is-12-tablet{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.column.is-offset-12,.column.is-offset-12-tablet{margin-left:100%}}@media screen and (max-width:1087px){.column.is-full-touch,.column.is-narrow-touch{-webkit-box-flex:0;-ms-flex:none;flex:none}.column.is-full-touch{width:100%}.column.is-three-quarters-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-two-thirds-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.column.is-half-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-one-third-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.column.is-one-quarter-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-one-fifth-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.column.is-two-fifths-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.column.is-three-fifths-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.column.is-four-fifths-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.column.is-offset-three-quarters-touch{margin-left:75%}.column.is-offset-two-thirds-touch{margin-left:66.6666%}.column.is-offset-half-touch{margin-left:50%}.column.is-offset-one-third-touch{margin-left:33.3333%}.column.is-offset-one-quarter-touch{margin-left:25%}.column.is-offset-one-fifth-touch{margin-left:20%}.column.is-offset-two-fifths-touch{margin-left:40%}.column.is-offset-three-fifths-touch{margin-left:60%}.column.is-offset-four-fifths-touch{margin-left:80%}.column.is-1-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.33333%}.column.is-offset-1-touch{margin-left:8.33333%}.column.is-2-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.66667%}.column.is-offset-2-touch{margin-left:16.66667%}.column.is-3-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-offset-3-touch{margin-left:25%}.column.is-4-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.33333%}.column.is-offset-4-touch{margin-left:33.33333%}.column.is-5-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.66667%}.column.is-offset-5-touch{margin-left:41.66667%}.column.is-6-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-offset-6-touch{margin-left:50%}.column.is-7-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.33333%}.column.is-offset-7-touch{margin-left:58.33333%}.column.is-8-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.66667%}.column.is-offset-8-touch{margin-left:66.66667%}.column.is-9-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-offset-9-touch{margin-left:75%}.column.is-10-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.33333%}.column.is-offset-10-touch{margin-left:83.33333%}.column.is-11-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.66667%}.column.is-offset-11-touch{margin-left:91.66667%}.column.is-12-touch{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.column.is-offset-12-touch{margin-left:100%}}@media screen and (min-width:1088px){.column.is-full-desktop,.column.is-narrow-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none}.column.is-full-desktop{width:100%}.column.is-three-quarters-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-two-thirds-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.column.is-half-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-one-third-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.column.is-one-quarter-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-one-fifth-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.column.is-two-fifths-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.column.is-three-fifths-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.column.is-four-fifths-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.column.is-offset-three-quarters-desktop{margin-left:75%}.column.is-offset-two-thirds-desktop{margin-left:66.6666%}.column.is-offset-half-desktop{margin-left:50%}.column.is-offset-one-third-desktop{margin-left:33.3333%}.column.is-offset-one-quarter-desktop{margin-left:25%}.column.is-offset-one-fifth-desktop{margin-left:20%}.column.is-offset-two-fifths-desktop{margin-left:40%}.column.is-offset-three-fifths-desktop{margin-left:60%}.column.is-offset-four-fifths-desktop{margin-left:80%}.column.is-1-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.33333%}.column.is-offset-1-desktop{margin-left:8.33333%}.column.is-2-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.66667%}.column.is-offset-2-desktop{margin-left:16.66667%}.column.is-3-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-offset-3-desktop{margin-left:25%}.column.is-4-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.33333%}.column.is-offset-4-desktop{margin-left:33.33333%}.column.is-5-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.66667%}.column.is-offset-5-desktop{margin-left:41.66667%}.column.is-6-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-offset-6-desktop{margin-left:50%}.column.is-7-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.33333%}.column.is-offset-7-desktop{margin-left:58.33333%}.column.is-8-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.66667%}.column.is-offset-8-desktop{margin-left:66.66667%}.column.is-9-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-offset-9-desktop{margin-left:75%}.column.is-10-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.33333%}.column.is-offset-10-desktop{margin-left:83.33333%}.column.is-11-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.66667%}.column.is-offset-11-desktop{margin-left:91.66667%}.column.is-12-desktop{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.column.is-offset-12-desktop{margin-left:100%}}@media screen and (min-width:1280px){.column.is-full-widescreen,.column.is-narrow-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none}.column.is-full-widescreen{width:100%}.column.is-three-quarters-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-two-thirds-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.column.is-half-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-one-third-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.column.is-one-quarter-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-one-fifth-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.column.is-two-fifths-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.column.is-three-fifths-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.column.is-four-fifths-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.column.is-offset-three-quarters-widescreen{margin-left:75%}.column.is-offset-two-thirds-widescreen{margin-left:66.6666%}.column.is-offset-half-widescreen{margin-left:50%}.column.is-offset-one-third-widescreen{margin-left:33.3333%}.column.is-offset-one-quarter-widescreen{margin-left:25%}.column.is-offset-one-fifth-widescreen{margin-left:20%}.column.is-offset-two-fifths-widescreen{margin-left:40%}.column.is-offset-three-fifths-widescreen{margin-left:60%}.column.is-offset-four-fifths-widescreen{margin-left:80%}.column.is-1-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.33333%}.column.is-offset-1-widescreen{margin-left:8.33333%}.column.is-2-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.66667%}.column.is-offset-2-widescreen{margin-left:16.66667%}.column.is-3-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-offset-3-widescreen{margin-left:25%}.column.is-4-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.33333%}.column.is-offset-4-widescreen{margin-left:33.33333%}.column.is-5-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.66667%}.column.is-offset-5-widescreen{margin-left:41.66667%}.column.is-6-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-offset-6-widescreen{margin-left:50%}.column.is-7-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.33333%}.column.is-offset-7-widescreen{margin-left:58.33333%}.column.is-8-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.66667%}.column.is-offset-8-widescreen{margin-left:66.66667%}.column.is-9-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-offset-9-widescreen{margin-left:75%}.column.is-10-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.33333%}.column.is-offset-10-widescreen{margin-left:83.33333%}.column.is-11-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.66667%}.column.is-offset-11-widescreen{margin-left:91.66667%}.column.is-12-widescreen{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.column.is-offset-12-widescreen{margin-left:100%}}@media screen and (min-width:1472px){.column.is-full-fullhd,.column.is-narrow-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none}.column.is-full-fullhd{width:100%}.column.is-three-quarters-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-two-thirds-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.6666%}.column.is-half-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-one-third-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.3333%}.column.is-one-quarter-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-one-fifth-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:20%}.column.is-two-fifths-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:40%}.column.is-three-fifths-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:60%}.column.is-four-fifths-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:80%}.column.is-offset-three-quarters-fullhd{margin-left:75%}.column.is-offset-two-thirds-fullhd{margin-left:66.6666%}.column.is-offset-half-fullhd{margin-left:50%}.column.is-offset-one-third-fullhd{margin-left:33.3333%}.column.is-offset-one-quarter-fullhd{margin-left:25%}.column.is-offset-one-fifth-fullhd{margin-left:20%}.column.is-offset-two-fifths-fullhd{margin-left:40%}.column.is-offset-three-fifths-fullhd{margin-left:60%}.column.is-offset-four-fifths-fullhd{margin-left:80%}.column.is-1-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:8.33333%}.column.is-offset-1-fullhd{margin-left:8.33333%}.column.is-2-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:16.66667%}.column.is-offset-2-fullhd{margin-left:16.66667%}.column.is-3-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:25%}.column.is-offset-3-fullhd{margin-left:25%}.column.is-4-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:33.33333%}.column.is-offset-4-fullhd{margin-left:33.33333%}.column.is-5-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:41.66667%}.column.is-offset-5-fullhd{margin-left:41.66667%}.column.is-6-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:50%}.column.is-offset-6-fullhd{margin-left:50%}.column.is-7-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:58.33333%}.column.is-offset-7-fullhd{margin-left:58.33333%}.column.is-8-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:66.66667%}.column.is-offset-8-fullhd{margin-left:66.66667%}.column.is-9-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:75%}.column.is-offset-9-fullhd{margin-left:75%}.column.is-10-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:83.33333%}.column.is-offset-10-fullhd{margin-left:83.33333%}.column.is-11-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:91.66667%}.column.is-offset-11-fullhd{margin-left:91.66667%}.column.is-12-fullhd{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%}.column.is-offset-12-fullhd{margin-left:100%}}.columns{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.columns:last-child{margin-bottom:-.75rem}.columns:not(:last-child){margin-bottom:0.75rem}.columns.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.columns.is-gapless{margin-left:0;margin-right:0;margin-top:0}.columns.is-gapless>.column{margin:0;padding:0!important}.columns.is-gapless:not(:last-child){margin-bottom:1.5rem}.columns.is-gapless:last-child{margin-bottom:0}.columns.is-mobile{display:-webkit-box;display:-ms-flexbox;display:flex}.columns.is-multiline{-ms-flex-wrap:wrap;flex-wrap:wrap}.columns.is-vcentered{-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media print,screen and (min-width:769px){.columns:not(.is-desktop){display:-webkit-box;display:-ms-flexbox;display:flex}}@media screen and (min-width:1088px){.columns.is-desktop{display:-webkit-box;display:-ms-flexbox;display:flex}}.columns.is-variable{--columnGap:0.75rem;margin-left:calc(-1 * var(--columnGap));margin-right:calc(-1 * var(--columnGap))}.columns.is-variable .column{padding-left:var(--columnGap);padding-right:var(--columnGap)}.columns.is-variable.is-0{--columnGap:0rem}.columns.is-variable.is-1{--columnGap:0.25rem}.columns.is-variable.is-2{--columnGap:0.5rem}.columns.is-variable.is-3{--columnGap:0.75rem}.columns.is-variable.is-4{--columnGap:1rem}.columns.is-variable.is-5{--columnGap:1.25rem}.columns.is-variable.is-6{--columnGap:1.5rem}.columns.is-variable.is-7{--columnGap:1.75rem}.columns.is-variable.is-8{--columnGap:2rem}.tile{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:block;-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-height:-webkit-min-content;min-height:-moz-min-content;min-height:min-content}.tile.is-ancestor{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.tile.is-ancestor:last-child{margin-bottom:-.75rem}.tile.is-ancestor:not(:last-child){margin-bottom:.75rem}.tile.is-child{margin:0!important}.tile.is-parent{padding:.75rem}.tile.is-vertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.tile.is-vertical>.tile.is-child:not(:last-child){margin-bottom:1.5rem!important}@media print,screen and (min-width:769px){.tile:not(.is-child){display:-webkit-box;display:-ms-flexbox;display:flex}.tile.is-1{width:8.33333%}.tile.is-1,.tile.is-2{-webkit-box-flex:0;-ms-flex:none;flex:none}.tile.is-2{width:16.66667%}.tile.is-3{width:25%}.tile.is-3,.tile.is-4{-webkit-box-flex:0;-ms-flex:none;flex:none}.tile.is-4{width:33.33333%}.tile.is-5{width:41.66667%}.tile.is-5,.tile.is-6{-webkit-box-flex:0;-ms-flex:none;flex:none}.tile.is-6{width:50%}.tile.is-7{width:58.33333%}.tile.is-7,.tile.is-8{-webkit-box-flex:0;-ms-flex:none;flex:none}.tile.is-8{width:66.66667%}.tile.is-9{width:75%}.tile.is-9,.tile.is-10{-webkit-box-flex:0;-ms-flex:none;flex:none}.tile.is-10{width:83.33333%}.tile.is-11{width:91.66667%}.tile.is-11,.tile.is-12{-webkit-box-flex:0;-ms-flex:none;flex:none}.tile.is-12{width:100%}}.hero{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.hero .navbar{background:none}.hero .tabs ul{border-bottom:none}.hero.is-white{background-color:#fff;color:#0a0a0a}.hero.is-white a:not(.button):not(.dropdown-item):not(.dropdown .dropdown-menu .has-link a):not(.tag),.hero.is-white strong{color:inherit}.hero.is-white .title{color:#0a0a0a}.hero.is-white .subtitle{color:hsla(0,0%,4%,.9)}.hero.is-white .subtitle a:not(.button),.hero.is-white .subtitle strong{color:#0a0a0a}@media screen and (max-width:1087px){.hero.is-white .navbar-menu{background-color:#fff}}.hero.is-white .navbar-item,.hero.is-white .navbar-link{color:hsla(0,0%,4%,.7)}.hero.is-white .navbar-link.is-active,.hero.is-white .navbar-link:hover,.hero.is-white a.navbar-item.is-active,.hero.is-white a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.hero.is-white .tabs a{color:#0a0a0a;opacity:.9}.hero.is-white .tabs a:hover,.hero.is-white .tabs li.is-active a{opacity:1}.hero.is-white .tabs.is-boxed a,.hero.is-white .tabs.is-toggle a{color:#0a0a0a}.hero.is-white .tabs.is-boxed a:hover,.hero.is-white .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-white .tabs.is-boxed li.is-active a,.hero.is-white .tabs.is-boxed li.is-active a:hover,.hero.is-white .tabs.is-toggle li.is-active a,.hero.is-white .tabs.is-toggle li.is-active a:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.hero.is-white.is-bold{background-image:linear-gradient(141deg,#e6e6e6,#fff 71%,#fff)}@media screen and (max-width:768px){.hero.is-white.is-bold .navbar-menu{background-image:linear-gradient(141deg,#e6e6e6,#fff 71%,#fff)}}.hero.is-black{background-color:#0a0a0a;color:#fff}.hero.is-black a:not(.button):not(.dropdown-item):not(.dropdown .dropdown-menu .has-link a):not(.tag),.hero.is-black strong{color:inherit}.hero.is-black .title{color:#fff}.hero.is-black .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-black .subtitle a:not(.button),.hero.is-black .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-black .navbar-menu{background-color:#0a0a0a}}.hero.is-black .navbar-item,.hero.is-black .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-black .navbar-link.is-active,.hero.is-black .navbar-link:hover,.hero.is-black a.navbar-item.is-active,.hero.is-black a.navbar-item:hover{background-color:#000;color:#fff}.hero.is-black .tabs a{color:#fff;opacity:.9}.hero.is-black .tabs a:hover,.hero.is-black .tabs li.is-active a{opacity:1}.hero.is-black .tabs.is-boxed a,.hero.is-black .tabs.is-toggle a{color:#fff}.hero.is-black .tabs.is-boxed a:hover,.hero.is-black .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-black .tabs.is-boxed li.is-active a,.hero.is-black .tabs.is-boxed li.is-active a:hover,.hero.is-black .tabs.is-toggle li.is-active a,.hero.is-black .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.hero.is-black.is-bold{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}@media screen and (max-width:768px){.hero.is-black.is-bold .navbar-menu{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}}.hero.is-light{background-color:#f5f5f5;color:#363636}.hero.is-light a:not(.button):not(.dropdown-item):not(.dropdown .dropdown-menu .has-link a):not(.tag),.hero.is-light strong{color:inherit}.hero.is-light .title{color:#363636}.hero.is-light .subtitle{color:rgba(54,54,54,.9)}.hero.is-light .subtitle a:not(.button),.hero.is-light .subtitle strong{color:#363636}@media screen and (max-width:1087px){.hero.is-light .navbar-menu{background-color:#f5f5f5}}.hero.is-light .navbar-item,.hero.is-light .navbar-link{color:rgba(54,54,54,.7)}.hero.is-light .navbar-link.is-active,.hero.is-light .navbar-link:hover,.hero.is-light a.navbar-item.is-active,.hero.is-light a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.hero.is-light .tabs a{color:#363636;opacity:.9}.hero.is-light .tabs a:hover,.hero.is-light .tabs li.is-active a{opacity:1}.hero.is-light .tabs.is-boxed a,.hero.is-light .tabs.is-toggle a{color:#363636}.hero.is-light .tabs.is-boxed a:hover,.hero.is-light .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-light .tabs.is-boxed li.is-active a,.hero.is-light .tabs.is-boxed li.is-active a:hover,.hero.is-light .tabs.is-toggle li.is-active a,.hero.is-light .tabs.is-toggle li.is-active a:hover{background-color:#363636;border-color:#363636;color:#f5f5f5}.hero.is-light.is-bold{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}@media screen and (max-width:768px){.hero.is-light.is-bold .navbar-menu{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}}.hero.is-dark{background-color:#363636;color:#f5f5f5}.hero.is-dark a:not(.button):not(.dropdown-item):not(.dropdown .dropdown-menu .has-link a):not(.tag),.hero.is-dark strong{color:inherit}.hero.is-dark .title{color:#f5f5f5}.hero.is-dark .subtitle{color:hsla(0,0%,96%,.9)}.hero.is-dark .subtitle a:not(.button),.hero.is-dark .subtitle strong{color:#f5f5f5}@media screen and (max-width:1087px){.hero.is-dark .navbar-menu{background-color:#363636}}.hero.is-dark .navbar-item,.hero.is-dark .navbar-link{color:hsla(0,0%,96%,.7)}.hero.is-dark .navbar-link.is-active,.hero.is-dark .navbar-link:hover,.hero.is-dark a.navbar-item.is-active,.hero.is-dark a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.hero.is-dark .tabs a{color:#f5f5f5;opacity:.9}.hero.is-dark .tabs a:hover,.hero.is-dark .tabs li.is-active a{opacity:1}.hero.is-dark .tabs.is-boxed a,.hero.is-dark .tabs.is-toggle a{color:#f5f5f5}.hero.is-dark .tabs.is-boxed a:hover,.hero.is-dark .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-dark .tabs.is-boxed li.is-active a,.hero.is-dark .tabs.is-boxed li.is-active a:hover,.hero.is-dark .tabs.is-toggle li.is-active a,.hero.is-dark .tabs.is-toggle li.is-active a:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.hero.is-dark.is-bold{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}@media screen and (max-width:768px){.hero.is-dark.is-bold .navbar-menu{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}}.hero.is-primary{background-color:#7957d5;color:#fff}.hero.is-primary a:not(.button):not(.dropdown-item):not(.dropdown .dropdown-menu .has-link a):not(.tag),.hero.is-primary strong{color:inherit}.hero.is-primary .title{color:#fff}.hero.is-primary .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-primary .subtitle a:not(.button),.hero.is-primary .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-primary .navbar-menu{background-color:#7957d5}}.hero.is-primary .navbar-item,.hero.is-primary .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-primary .navbar-link.is-active,.hero.is-primary .navbar-link:hover,.hero.is-primary a.navbar-item.is-active,.hero.is-primary a.navbar-item:hover{background-color:#6943d0;color:#fff}.hero.is-primary .tabs a{color:#fff;opacity:.9}.hero.is-primary .tabs a:hover,.hero.is-primary .tabs li.is-active a{opacity:1}.hero.is-primary .tabs.is-boxed a,.hero.is-primary .tabs.is-toggle a{color:#fff}.hero.is-primary .tabs.is-boxed a:hover,.hero.is-primary .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-primary .tabs.is-boxed li.is-active a,.hero.is-primary .tabs.is-boxed li.is-active a:hover,.hero.is-primary .tabs.is-toggle li.is-active a,.hero.is-primary .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#7957d5}.hero.is-primary.is-bold{background-image:linear-gradient(141deg,#3725d4,#7957d5 71%,#9b67df)}@media screen and (max-width:768px){.hero.is-primary.is-bold .navbar-menu{background-image:linear-gradient(141deg,#3725d4,#7957d5 71%,#9b67df)}}.hero.is-link{background-color:#7957d5;color:#fff}.hero.is-link a:not(.button):not(.dropdown-item):not(.dropdown .dropdown-menu .has-link a):not(.tag),.hero.is-link strong{color:inherit}.hero.is-link .title{color:#fff}.hero.is-link .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-link .subtitle a:not(.button),.hero.is-link .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-link .navbar-menu{background-color:#7957d5}}.hero.is-link .navbar-item,.hero.is-link .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-link .navbar-link.is-active,.hero.is-link .navbar-link:hover,.hero.is-link a.navbar-item.is-active,.hero.is-link a.navbar-item:hover{background-color:#6943d0;color:#fff}.hero.is-link .tabs a{color:#fff;opacity:.9}.hero.is-link .tabs a:hover,.hero.is-link .tabs li.is-active a{opacity:1}.hero.is-link .tabs.is-boxed a,.hero.is-link .tabs.is-toggle a{color:#fff}.hero.is-link .tabs.is-boxed a:hover,.hero.is-link .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-link .tabs.is-boxed li.is-active a,.hero.is-link .tabs.is-boxed li.is-active a:hover,.hero.is-link .tabs.is-toggle li.is-active a,.hero.is-link .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#7957d5}.hero.is-link.is-bold{background-image:linear-gradient(141deg,#3725d4,#7957d5 71%,#9b67df)}@media screen and (max-width:768px){.hero.is-link.is-bold .navbar-menu{background-image:linear-gradient(141deg,#3725d4,#7957d5 71%,#9b67df)}}.hero.is-info{background-color:#167df0;color:#fff}.hero.is-info a:not(.button):not(.dropdown-item):not(.dropdown .dropdown-menu .has-link a):not(.tag),.hero.is-info strong{color:inherit}.hero.is-info .title{color:#fff}.hero.is-info .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-info .subtitle a:not(.button),.hero.is-info .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-info .navbar-menu{background-color:#167df0}}.hero.is-info .navbar-item,.hero.is-info .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-info .navbar-link.is-active,.hero.is-info .navbar-link:hover,.hero.is-info a.navbar-item.is-active,.hero.is-info a.navbar-item:hover{background-color:#0e71de;color:#fff}.hero.is-info .tabs a{color:#fff;opacity:.9}.hero.is-info .tabs a:hover,.hero.is-info .tabs li.is-active a{opacity:1}.hero.is-info .tabs.is-boxed a,.hero.is-info .tabs.is-toggle a{color:#fff}.hero.is-info .tabs.is-boxed a:hover,.hero.is-info .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-info .tabs.is-boxed li.is-active a,.hero.is-info .tabs.is-boxed li.is-active a:hover,.hero.is-info .tabs.is-toggle li.is-active a,.hero.is-info .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#167df0}.hero.is-info.is-bold{background-image:linear-gradient(141deg,#0286d1,#167df0 71%,#2868f7)}@media screen and (max-width:768px){.hero.is-info.is-bold .navbar-menu{background-image:linear-gradient(141deg,#0286d1,#167df0 71%,#2868f7)}}.hero.is-success{background-color:#23d160;color:#fff}.hero.is-success a:not(.button):not(.dropdown-item):not(.dropdown .dropdown-menu .has-link a):not(.tag),.hero.is-success strong{color:inherit}.hero.is-success .title{color:#fff}.hero.is-success .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-success .subtitle a:not(.button),.hero.is-success .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-success .navbar-menu{background-color:#23d160}}.hero.is-success .navbar-item,.hero.is-success .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-success .navbar-link.is-active,.hero.is-success .navbar-link:hover,.hero.is-success a.navbar-item.is-active,.hero.is-success a.navbar-item:hover{background-color:#20bc56;color:#fff}.hero.is-success .tabs a{color:#fff;opacity:.9}.hero.is-success .tabs a:hover,.hero.is-success .tabs li.is-active a{opacity:1}.hero.is-success .tabs.is-boxed a,.hero.is-success .tabs.is-toggle a{color:#fff}.hero.is-success .tabs.is-boxed a:hover,.hero.is-success .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-success .tabs.is-boxed li.is-active a,.hero.is-success .tabs.is-boxed li.is-active a:hover,.hero.is-success .tabs.is-toggle li.is-active a,.hero.is-success .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#23d160}.hero.is-success.is-bold{background-image:linear-gradient(141deg,#12af2f,#23d160 71%,#2ce28a)}@media screen and (max-width:768px){.hero.is-success.is-bold .navbar-menu{background-image:linear-gradient(141deg,#12af2f,#23d160 71%,#2ce28a)}}.hero.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.hero.is-warning a:not(.button):not(.dropdown-item):not(.dropdown .dropdown-menu .has-link a):not(.tag),.hero.is-warning strong{color:inherit}.hero.is-warning .title{color:rgba(0,0,0,.7)}.hero.is-warning .subtitle{color:rgba(0,0,0,.9)}.hero.is-warning .subtitle a:not(.button),.hero.is-warning .subtitle strong{color:rgba(0,0,0,.7)}@media screen and (max-width:1087px){.hero.is-warning .navbar-menu{background-color:#ffdd57}}.hero.is-warning .navbar-item,.hero.is-warning .navbar-link{color:rgba(0,0,0,.7)}.hero.is-warning .navbar-link.is-active,.hero.is-warning .navbar-link:hover,.hero.is-warning a.navbar-item.is-active,.hero.is-warning a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.hero.is-warning .tabs a{color:rgba(0,0,0,.7);opacity:.9}.hero.is-warning .tabs a:hover,.hero.is-warning .tabs li.is-active a{opacity:1}.hero.is-warning .tabs.is-boxed a,.hero.is-warning .tabs.is-toggle a{color:rgba(0,0,0,.7)}.hero.is-warning .tabs.is-boxed a:hover,.hero.is-warning .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-warning .tabs.is-boxed li.is-active a,.hero.is-warning .tabs.is-boxed li.is-active a:hover,.hero.is-warning .tabs.is-toggle li.is-active a,.hero.is-warning .tabs.is-toggle li.is-active a:hover{background-color:rgba(0,0,0,.7);border-color:rgba(0,0,0,.7);color:#ffdd57}.hero.is-warning.is-bold{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}@media screen and (max-width:768px){.hero.is-warning.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}}.hero.is-danger{background-color:#ff3860;color:#fff}.hero.is-danger a:not(.button):not(.dropdown-item):not(.dropdown .dropdown-menu .has-link a):not(.tag),.hero.is-danger strong{color:inherit}.hero.is-danger .title{color:#fff}.hero.is-danger .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-danger .subtitle a:not(.button),.hero.is-danger .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-danger .navbar-menu{background-color:#ff3860}}.hero.is-danger .navbar-item,.hero.is-danger .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-danger .navbar-link.is-active,.hero.is-danger .navbar-link:hover,.hero.is-danger a.navbar-item.is-active,.hero.is-danger a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.hero.is-danger .tabs a{color:#fff;opacity:.9}.hero.is-danger .tabs a:hover,.hero.is-danger .tabs li.is-active a{opacity:1}.hero.is-danger .tabs.is-boxed a,.hero.is-danger .tabs.is-toggle a{color:#fff}.hero.is-danger .tabs.is-boxed a:hover,.hero.is-danger .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-danger .tabs.is-boxed li.is-active a,.hero.is-danger .tabs.is-boxed li.is-active a:hover,.hero.is-danger .tabs.is-toggle li.is-active a,.hero.is-danger .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#ff3860}.hero.is-danger.is-bold{background-image:linear-gradient(141deg,#ff0561,#ff3860 71%,#ff5257)}@media screen and (max-width:768px){.hero.is-danger.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ff0561,#ff3860 71%,#ff5257)}}.hero.is-small .hero-body{padding-bottom:1.5rem;padding-top:1.5rem}@media print,screen and (min-width:769px){.hero.is-medium .hero-body{padding-bottom:9rem;padding-top:9rem}}@media print,screen and (min-width:769px){.hero.is-large .hero-body{padding-bottom:18rem;padding-top:18rem}}.hero.is-fullheight .hero-body,.hero.is-halfheight .hero-body{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.hero.is-fullheight .hero-body>.container,.hero.is-halfheight .hero-body>.container{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.hero.is-halfheight{min-height:50vh}.hero.is-fullheight{min-height:100vh}.hero-video{overflow:hidden}.hero-video video{left:50%;min-height:100%;min-width:100%;position:absolute;top:50%;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0)}.hero-video.is-transparent{opacity:.3}@media screen and (max-width:768px){.hero-video{display:none}}.hero-buttons{margin-top:1.5rem}@media screen and (max-width:768px){.hero-buttons .button{display:-webkit-box;display:-ms-flexbox;display:flex}.hero-buttons .button:not(:last-child){margin-bottom:.75rem}}@media print,screen and (min-width:769px){.hero-buttons{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.hero-buttons .button:not(:last-child){margin-right:1.5rem}}.hero-foot,.hero-head{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}.hero-body,.hero-foot,.hero-head{-ms-flex-negative:0;flex-shrink:0}.hero-body{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.hero-body,.section{padding:3rem 1.5rem}@media screen and (min-width:1088px){.section.is-medium{padding:9rem 1.5rem}.section.is-large{padding:18rem 1.5rem}}.footer{background-color:#fafafa;padding:3rem 1.5rem 6rem}.is-noscroll{position:fixed;overflow-y:hidden;width:100%;bottom:0}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.fadeOutDown{-webkit-animation-name:fadeOutDown;animation-name:fadeOutDown}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{-webkit-animation-name:fadeIn;animation-name:fadeIn}@keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInDown{-webkit-animation-name:fadeInDown;animation-name:fadeInDown}@keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInUp{-webkit-animation-name:fadeInUp;animation-name:fadeInUp}.fade-enter-active,.fade-leave-active{-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out}.fade-enter,.fade-leave-to{opacity:0}.zoom-in-enter-active,.zoom-in-leave-active{-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out}.zoom-in-enter-active .animation-content,.zoom-in-leave-active .animation-content{-webkit-transition:-webkit-transform .15s ease-out;transition:-webkit-transform .15s ease-out;transition:transform .15s ease-out;transition:transform .15s ease-out,-webkit-transform .15s ease-out}.zoom-in-enter,.zoom-in-leave-active{opacity:0}.zoom-in-enter .animation-content,.zoom-in-leave-active .animation-content{-webkit-transform:scale(.95);transform:scale(.95)}.zoom-out-enter-active,.zoom-out-leave-active{-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out}.zoom-out-enter-active .animation-content,.zoom-out-leave-active .animation-content{-webkit-transition:-webkit-transform .15s ease-out;transition:-webkit-transform .15s ease-out;transition:transform .15s ease-out;transition:transform .15s ease-out,-webkit-transform .15s ease-out}.zoom-out-enter,.zoom-out-leave-active{opacity:0}.zoom-out-enter .animation-content,.zoom-out-leave-active .animation-content{-webkit-transform:scale(1.05);transform:scale(1.05)}.slide-next-enter-active,.slide-next-leave-active,.slide-prev-enter-active,.slide-prev-leave-active{-webkit-transition:-webkit-transform .25s cubic-bezier(.785,.135,.15,.86);transition:-webkit-transform .25s cubic-bezier(.785,.135,.15,.86);transition:transform .25s cubic-bezier(.785,.135,.15,.86);transition:transform .25s cubic-bezier(.785,.135,.15,.86),-webkit-transform .25s cubic-bezier(.785,.135,.15,.86)}.slide-next-enter,.slide-prev-leave-to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);position:absolute;width:100%}.slide-next-leave-to,.slide-prev-enter{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);position:absolute;width:100%}.autocomplete{position:relative}.autocomplete .dropdown-menu{display:block;min-width:100%}.autocomplete .dropdown-menu.is-opened-top{top:auto;bottom:100%}.autocomplete .dropdown-content{overflow:auto;max-height:200px}.autocomplete .dropdown-item.is-hovered,.autocomplete .dropdown .dropdown-menu .has-link a.is-hovered,.dropdown .dropdown-menu .has-link .autocomplete a.is-hovered{background:#f5f5f5;color:#0a0a0a}.autocomplete .dropdown-item.is-disabled,.autocomplete .dropdown .dropdown-menu .has-link a.is-disabled,.dropdown .dropdown-menu .has-link .autocomplete a.is-disabled{opacity:.5;cursor:not-allowed}.autocomplete.is-small{border-radius:2px;font-size:.75rem}.autocomplete.is-medium{font-size:1.25rem}.autocomplete.is-large{font-size:1.5rem}.b-checkbox.checkbox{outline:none;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.b-checkbox.checkbox+.checkbox{margin-left:.5em}.b-checkbox.checkbox input[type=checkbox]{display:none}.b-checkbox.checkbox input[type=checkbox]+.check{width:1.25em;height:1.25em;-ms-flex-negative:0;flex-shrink:0;border-radius:4px;border:2px solid #7a7a7a;-webkit-transition:background .15s ease-out;transition:background .15s ease-out}.b-checkbox.checkbox input[type=checkbox]:checked+.check{background:#7957d5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#7957d5}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-white{background:#fff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%230a0a0a'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#fff}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-black{background:#0a0a0a url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#0a0a0a}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-light{background:#f5f5f5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23363636'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#f5f5f5}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-dark{background:#363636 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23f5f5f5'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#363636}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-link,.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-primary{background:#7957d5 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#7957d5}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-info{background:#167df0 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#167df0}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-success{background:#23d160 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#23d160}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-warning{background:#ffdd57 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='rgba(0,0,0,.7)'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ffdd57}.b-checkbox.checkbox input[type=checkbox]:checked+.check.is-danger{background:#ff3860 url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50%;border-color:#ff3860}.b-checkbox.checkbox .control-label{padding-left:.5em}.b-checkbox.checkbox[disabled]{opacity:.5}.b-checkbox.checkbox:hover input[type=checkbox]+.check{border-color:#7957d5}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-white{border-color:#fff}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-black{border-color:#0a0a0a}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-light{border-color:#f5f5f5}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-dark{border-color:#363636}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-link,.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-primary{border-color:#7957d5}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-info{border-color:#167df0}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-success{border-color:#23d160}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-warning{border-color:#ffdd57}.b-checkbox.checkbox:hover input[type=checkbox]+.check.is-danger{border-color:#ff3860}.b-checkbox.checkbox:focus input[type=checkbox]+.check{-webkit-box-shadow:0 0 .5em hsla(0,0%,48%,.8);box-shadow:0 0 .5em hsla(0,0%,48%,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check{-webkit-box-shadow:0 0 .5em rgba(121,87,213,.8);box-shadow:0 0 .5em rgba(121,87,213,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-white{-webkit-box-shadow:0 0 .5em hsla(0,0%,100%,.8);box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-black{-webkit-box-shadow:0 0 .5em hsla(0,0%,4%,.8);box-shadow:0 0 .5em hsla(0,0%,4%,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-light{-webkit-box-shadow:0 0 .5em hsla(0,0%,96%,.8);box-shadow:0 0 .5em hsla(0,0%,96%,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-dark{-webkit-box-shadow:0 0 .5em rgba(54,54,54,.8);box-shadow:0 0 .5em rgba(54,54,54,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-link,.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-primary{-webkit-box-shadow:0 0 .5em rgba(121,87,213,.8);box-shadow:0 0 .5em rgba(121,87,213,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-info{-webkit-box-shadow:0 0 .5em rgba(22,125,240,.8);box-shadow:0 0 .5em rgba(22,125,240,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-success{-webkit-box-shadow:0 0 .5em rgba(35,209,96,.8);box-shadow:0 0 .5em rgba(35,209,96,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-warning{-webkit-box-shadow:0 0 .5em rgba(255,221,87,.8);box-shadow:0 0 .5em rgba(255,221,87,.8)}.b-checkbox.checkbox:focus input[type=checkbox]:checked+.check.is-danger{-webkit-box-shadow:0 0 .5em rgba(255,56,96,.8);box-shadow:0 0 .5em rgba(255,56,96,.8)}.b-checkbox.checkbox.is-small{border-radius:2px;font-size:.75rem}.b-checkbox.checkbox.is-medium{font-size:1.25rem}.b-checkbox.checkbox.is-large{font-size:1.5rem}.collapse .collapse-trigger{display:inline;cursor:pointer}.collapse .collapse-content{display:inherit}.datepicker{font-size:.875rem}.datepicker .dropdown,.datepicker .dropdown-trigger{width:100%}.datepicker .dropdown-item,.datepicker .dropdown .dropdown-menu .has-link a,.dropdown .dropdown-menu .has-link .datepicker a{font-size:inherit}.datepicker .datepicker-header{padding-bottom:.875rem;margin-bottom:.875rem;border-bottom:1px solid #dbdbdb}.datepicker .datepicker-footer{padding-top:.875rem;border-top:1px solid #dbdbdb}.datepicker .datepicker-table{display:table;margin:0 auto .875rem}.datepicker .datepicker-table .datepicker-cell{text-align:center;vertical-align:middle;display:table-cell;border-radius:4px;padding:.5rem .75rem}.datepicker .datepicker-table .datepicker-header{display:table-header-group}.datepicker .datepicker-table .datepicker-header .datepicker-cell{color:#7a7a7a;font-weight:600}.datepicker .datepicker-table .datepicker-body{display:table-row-group}.datepicker .datepicker-table .datepicker-body .datepicker-row{display:table-row}.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-unselectable{color:#b5b5b5}.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-today{border:1px solid rgba(121,87,213,.5)}.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selectable{color:#4a4a4a}.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selectable:focus:not(.is-selected),.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selectable:hover:not(.is-selected){background-color:#f5f5f5;color:#0a0a0a;cursor:pointer}.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selected{background-color:#7957d5;color:#fff}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell{padding:.3rem .75rem .75rem}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event{position:relative}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events{bottom:.425rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;left:0;padding:0 .35rem;position:absolute;width:100%}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-white{background-color:#fff}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-black{background-color:#0a0a0a}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-light{background-color:#f5f5f5}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-dark{background-color:#363636}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-link,.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-primary{background-color:#7957d5}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-info{background-color:#167df0}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-success{background-color:#23d160}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-warning{background-color:#ffdd57}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-danger{background-color:#ff3860}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event.dots .event{border-radius:50%;height:.35em;margin:0 .1em;width:.35em}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event.bars .event{height:.25em;width:100%}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.is-selected{overflow:hidden}.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.is-selected .events .event.is-primary{background-color:#aa94e4}.datepicker.is-small{border-radius:2px;font-size:.75rem}.datepicker.is-medium{font-size:1.25rem}.datepicker.is-large{font-size:1.5rem}@media screen and (min-width:769px) and (max-width:1087px){.datepicker .datepicker-table .datepicker-cell{padding:.75rem 1rem}}@media screen and (max-width:768px){.datepicker .datepicker-table .datepicker-cell{padding:.25rem .5rem}}.dialog .modal-card{max-width:460px;width:auto}.dialog .modal-card .modal-card-head{font-size:1.25rem;font-weight:600}.dialog .modal-card .modal-card-body .field{margin-top:16px}.dialog .modal-card .modal-card-body.is-titleless{border-top-left-radius:6px;border-top-right-radius:6px}.dialog .modal-card .modal-card-foot{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.dialog .modal-card .modal-card-foot .button{display:inline;min-width:5em;font-weight:600}@media print,screen and (min-width:769px){.dialog .modal-card{min-width:320px}}.dialog.is-small .button,.dialog.is-small .input,.dialog.is-small .modal-card,.dialog.is-small .taginput .taginput-container.is-focusable,.taginput .dialog.is-small .taginput-container.is-focusable{border-radius:2px;font-size:.75rem}.dialog.is-medium .button,.dialog.is-medium .input,.dialog.is-medium .modal-card,.dialog.is-medium .taginput .taginput-container.is-focusable,.taginput .dialog.is-medium .taginput-container.is-focusable{font-size:1.25rem}.dialog.is-large .button,.dialog.is-large .input,.dialog.is-large .modal-card,.dialog.is-large .taginput .taginput-container.is-focusable,.taginput .dialog.is-large .taginput-container.is-focusable{font-size:1.5rem}.dropdown+.dropdown{margin-left:.5em}.dropdown .background{position:fixed;background-color:hsla(0,0%,4%,.86);z-index:10;cursor:pointer}@media screen and (min-width:1088px){.dropdown .background{display:none}}.dropdown .dropdown-menu .dropdown-item.is-disabled,.dropdown .dropdown-menu .has-link a.is-disabled{cursor:not-allowed}.dropdown .dropdown-menu .dropdown-item.is-disabled:hover,.dropdown .dropdown-menu .has-link a.is-disabled:hover{background:inherit;color:inherit}.dropdown .dropdown-menu .has-link a{padding-right:3rem;white-space:nowrap}.dropdown:not(.is-disabled) .dropdown-menu .dropdown-item.is-disabled,.dropdown:not(.is-disabled) .dropdown-menu .has-link a.is-disabled{opacity:.5}.dropdown .navbar-item{height:100%}.dropdown.is-disabled{opacity:.5;cursor:not-allowed}.dropdown.is-disabled .dropdown-trigger{pointer-events:none}.dropdown.is-inline .dropdown-menu{position:static;display:inline-block;padding:0}.dropdown.is-top-right .dropdown-menu{top:auto;bottom:100%}.dropdown.is-top-left .dropdown-menu{top:auto;bottom:100%;right:0;left:auto}.dropdown.is-bottom-left .dropdown-menu{right:0;left:auto}@media screen and (max-width:1087px){.dropdown.is-mobile-modal .dropdown-menu{position:fixed;width:calc(100vw - 40px);max-width:460px;max-height:calc(100vh - 120px);top:25%!important;left:50%!important;bottom:auto!important;right:auto!important;-webkit-transform:translate3d(-50%,-25%,0);transform:translate3d(-50%,-25%,0);white-space:normal;overflow-y:auto}.dropdown.is-mobile-modal .dropdown-menu .dropdown-item,.dropdown.is-mobile-modal .dropdown-menu .has-link a{padding:1rem 1.5rem}}.label{font-weight:600}.field.is-grouped .field{-ms-flex-negative:0;flex-shrink:0}.field.is-grouped .field+.field{margin-left:.75rem}.field.is-grouped .field.is-expanded{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.field.has-addons .control:first-child .control .button,.field.has-addons .control:first-child .control .input,.field.has-addons .control:first-child .control .select select,.field.has-addons .control:first-child .control .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:first-child .control .taginput-container.is-focusable{border-bottom-left-radius:4px;border-top-left-radius:4px}.field.has-addons .control:last-child .control .button,.field.has-addons .control:last-child .control .input,.field.has-addons .control:last-child .control .select select,.field.has-addons .control:last-child .control .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control:last-child .control .taginput-container.is-focusable{border-bottom-right-radius:4px;border-top-right-radius:4px}.field.has-addons .control .control .button,.field.has-addons .control .control .input,.field.has-addons .control .control .select select,.field.has-addons .control .control .taginput .taginput-container.is-focusable,.taginput .field.has-addons .control .control .taginput-container.is-focusable{border-radius:0}.control .help.counter{float:right;margin-left:.5em}.control .icon.is-clickable{pointer-events:auto;cursor:pointer}.icon{cursor:inherit}.icon svg{background-color:transparent;fill:currentColor;stroke-width:0;stroke:currentColor;pointer-events:none;width:1.5rem;height:1.5rem}.loading-overlay{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:none;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;z-index:999}.loading-overlay.is-active{display:-webkit-box;display:-ms-flexbox;display:flex}.loading-overlay.is-full-page{position:fixed}.loading-overlay.is-full-page .loading-icon:after{top:calc(50% - 2.5em);left:calc(50% - 2.5em);width:5em;height:5em}.loading-overlay .loading-background{background:#7f7f7f;background:hsla(0,0%,100%,.5)}.loading-overlay .loading-icon{position:relative}.loading-overlay .loading-icon:after{position:absolute;top:calc(50% - 1.5em);left:calc(50% - 1.5em);width:3em;height:3em;border-width:.25em}.message .media,.notification .media{padding-top:0;border:0}.notification>.delete{right:.5rem!important;top:.5rem!important}.modal .animation-content{margin:0 20px}.modal .animation-content .modal-card{margin:0}@media screen and (max-width:768px){.modal .animation-content{width:100%}}.notices{position:fixed;display:-webkit-box;display:-ms-flexbox;display:flex;top:0;bottom:0;left:0;right:0;padding:2em;overflow:hidden;z-index:1000;pointer-events:none}.notices .toast{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-animation-duration:.15s;animation-duration:.15s;margin:.5em 0;text-align:center;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);border-radius:2em;padding:.75em 1.5em;pointer-events:auto;opacity:.92}.notices .toast.is-white{color:#0a0a0a;background:#fff}.notices .toast.is-black{color:#fff;background:#0a0a0a}.notices .toast.is-light{color:#363636;background:#f5f5f5}.notices .toast.is-dark{color:#f5f5f5;background:#363636}.notices .toast.is-link,.notices .toast.is-primary{color:#fff;background:#7957d5}.notices .toast.is-info{color:#fff;background:#167df0}.notices .toast.is-success{color:#fff;background:#23d160}.notices .toast.is-warning{color:rgba(0,0,0,.7);background:#ffdd57}.notices .toast.is-danger{color:#fff;background:#ff3860}.notices .snackbar{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around;-webkit-animation-duration:.15s;animation-duration:.15s;margin:.5em 0;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);box-shadow:0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);border-radius:4px;pointer-events:auto;background:#363636;color:#f5f5f5;min-height:3em}.notices .snackbar .text{padding:.5em 1em}.notices .snackbar .action{margin-left:auto;padding:.5em;padding-left:0}.notices .snackbar .action .button{font-weight:600;text-transform:uppercase}.notices .snackbar .action.is-white .button{color:#fff}.notices .snackbar .action.is-black .button{color:#0a0a0a}.notices .snackbar .action.is-light .button{color:#f5f5f5}.notices .snackbar .action.is-dark .button{color:#363636}.notices .snackbar .action.is-link .button,.notices .snackbar .action.is-primary .button{color:#7957d5}.notices .snackbar .action.is-info .button{color:#167df0}.notices .snackbar .action.is-success .button{color:#23d160}.notices .snackbar .action.is-warning .button{color:#ffdd57}.notices .snackbar .action.is-danger .button{color:#ff3860}@media screen and (max-width:768px){.notices .snackbar{width:100%;margin:0;border-radius:0}}@media print,screen and (min-width:769px){.notices .snackbar{min-width:350px;max-width:600px;overflow:hidden}}.notices .snackbar.is-bottom,.notices .snackbar.is-top,.notices .toast.is-bottom,.notices .toast.is-top{-ms-flex-item-align:center;align-self:center}.notices .snackbar.is-bottom-right,.notices .snackbar.is-top-right,.notices .toast.is-bottom-right,.notices .toast.is-top-right{-ms-flex-item-align:end;align-self:flex-end}.notices .snackbar.is-bottom-left,.notices .snackbar.is-top-left,.notices .toast.is-bottom-left,.notices .toast.is-top-left{-ms-flex-item-align:start;align-self:flex-start}.notices .snackbar.is-toast,.notices .toast.is-toast{opacity:.92}.notices.is-top{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.notices.is-bottom{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.notices.has-custom-container{position:absolute}@media screen and (max-width:768px){.notices{padding:0;position:fixed!important}}.pagination .pagination-next,.pagination .pagination-previous{padding-left:.25em;padding-right:.25em}.pagination .pagination-next.is-disabled,.pagination .pagination-previous.is-disabled{pointer-events:none;cursor:not-allowed;opacity:.5}.pagination.is-simple{-webkit-box-pack:normal;-ms-flex-pack:normal;justify-content:normal}.pagination .is-current{pointer-events:none;cursor:not-allowed}.panel .panel-heading.is-collapsible{cursor:pointer}.panel .panel-content{width:100%}.b-radio.radio{outline:none;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.b-radio.radio+.radio{margin-left:.5em}.b-radio.radio input[type=radio]{display:none}.b-radio.radio input[type=radio]+.check{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:1.25em;height:1.25em;border:2px solid #7a7a7a;border-radius:50%;-webkit-transition:background .15s ease-out;transition:background .15s ease-out}.b-radio.radio input[type=radio]+.check:before{content:\"\";border-radius:50%;width:.625em;height:.625em;background:#7957d5;-webkit-transform:scale(0);transform:scale(0);-webkit-transition:-webkit-transform .15s ease-out;transition:-webkit-transform .15s ease-out;transition:transform .15s ease-out;transition:transform .15s ease-out,-webkit-transform .15s ease-out}.b-radio.radio input[type=radio]+.check.is-white:before{background:#fff}.b-radio.radio input[type=radio]+.check.is-black:before{background:#0a0a0a}.b-radio.radio input[type=radio]+.check.is-light:before{background:#f5f5f5}.b-radio.radio input[type=radio]+.check.is-dark:before{background:#363636}.b-radio.radio input[type=radio]+.check.is-link:before,.b-radio.radio input[type=radio]+.check.is-primary:before{background:#7957d5}.b-radio.radio input[type=radio]+.check.is-info:before{background:#167df0}.b-radio.radio input[type=radio]+.check.is-success:before{background:#23d160}.b-radio.radio input[type=radio]+.check.is-warning:before{background:#ffdd57}.b-radio.radio input[type=radio]+.check.is-danger:before{background:#ff3860}.b-radio.radio input[type=radio]:checked+.check{border-color:#7957d5}.b-radio.radio input[type=radio]:checked+.check.is-white{border-color:#fff}.b-radio.radio input[type=radio]:checked+.check.is-black{border-color:#0a0a0a}.b-radio.radio input[type=radio]:checked+.check.is-light{border-color:#f5f5f5}.b-radio.radio input[type=radio]:checked+.check.is-dark{border-color:#363636}.b-radio.radio input[type=radio]:checked+.check.is-link,.b-radio.radio input[type=radio]:checked+.check.is-primary{border-color:#7957d5}.b-radio.radio input[type=radio]:checked+.check.is-info{border-color:#167df0}.b-radio.radio input[type=radio]:checked+.check.is-success{border-color:#23d160}.b-radio.radio input[type=radio]:checked+.check.is-warning{border-color:#ffdd57}.b-radio.radio input[type=radio]:checked+.check.is-danger{border-color:#ff3860}.b-radio.radio input[type=radio]:checked+.check:before{-webkit-transform:scale(1);transform:scale(1)}.b-radio.radio .control-label{padding-left:.5em}.b-radio.radio[disabled]{opacity:.5}.b-radio.radio:hover input[type=radio]+.check{border-color:#7957d5}.b-radio.radio:hover input[type=radio]+.check.is-white{border-color:#fff}.b-radio.radio:hover input[type=radio]+.check.is-black{border-color:#0a0a0a}.b-radio.radio:hover input[type=radio]+.check.is-light{border-color:#f5f5f5}.b-radio.radio:hover input[type=radio]+.check.is-dark{border-color:#363636}.b-radio.radio:hover input[type=radio]+.check.is-link,.b-radio.radio:hover input[type=radio]+.check.is-primary{border-color:#7957d5}.b-radio.radio:hover input[type=radio]+.check.is-info{border-color:#167df0}.b-radio.radio:hover input[type=radio]+.check.is-success{border-color:#23d160}.b-radio.radio:hover input[type=radio]+.check.is-warning{border-color:#ffdd57}.b-radio.radio:hover input[type=radio]+.check.is-danger{border-color:#ff3860}.b-radio.radio:focus input[type=radio]+.check{-webkit-box-shadow:0 0 .5em hsla(0,0%,48%,.8);box-shadow:0 0 .5em hsla(0,0%,48%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check{-webkit-box-shadow:0 0 .5em rgba(121,87,213,.8);box-shadow:0 0 .5em rgba(121,87,213,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-white{-webkit-box-shadow:0 0 .5em hsla(0,0%,100%,.8);box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-black{-webkit-box-shadow:0 0 .5em hsla(0,0%,4%,.8);box-shadow:0 0 .5em hsla(0,0%,4%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-light{-webkit-box-shadow:0 0 .5em hsla(0,0%,96%,.8);box-shadow:0 0 .5em hsla(0,0%,96%,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-dark{-webkit-box-shadow:0 0 .5em rgba(54,54,54,.8);box-shadow:0 0 .5em rgba(54,54,54,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-link,.b-radio.radio:focus input[type=radio]:checked+.check.is-primary{-webkit-box-shadow:0 0 .5em rgba(121,87,213,.8);box-shadow:0 0 .5em rgba(121,87,213,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-info{-webkit-box-shadow:0 0 .5em rgba(22,125,240,.8);box-shadow:0 0 .5em rgba(22,125,240,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-success{-webkit-box-shadow:0 0 .5em rgba(35,209,96,.8);box-shadow:0 0 .5em rgba(35,209,96,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-warning{-webkit-box-shadow:0 0 .5em rgba(255,221,87,.8);box-shadow:0 0 .5em rgba(255,221,87,.8)}.b-radio.radio:focus input[type=radio]:checked+.check.is-danger{-webkit-box-shadow:0 0 .5em rgba(255,56,96,.8);box-shadow:0 0 .5em rgba(255,56,96,.8)}.b-radio.radio.is-small{border-radius:2px;font-size:.75rem}.b-radio.radio.is-medium{font-size:1.25rem}.b-radio.radio.is-large{font-size:1.5rem}.select select{padding-right:2.5em}.select select option{color:#4a4a4a;padding:.25em .5em}.select select option:disabled{cursor:not-allowed;opacity:.5}.select select optgroup{color:#b5b5b5;font-weight:400;font-style:normal;padding:.25em 0}.select.is-empty select{color:hsla(0,0%,48%,.7)}.switch{cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.switch+.switch{margin-left:.5em}.switch input[type=checkbox]{display:none}.switch input[type=checkbox]+.check{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:2.75em;height:1.575em;padding:.2em;background:#b5b5b5;border-radius:1em;-webkit-transition:background .15s ease-out;transition:background .15s ease-out}.switch input[type=checkbox]+.check:before{content:\"\";border-radius:1em;width:1.175em;height:1.175em;background:#f5f5f5;-webkit-box-shadow:0 3px 1px 0 rgba(0,0,0,.05),0 2px 2px 0 rgba(0,0,0,.1),0 3px 3px 0 rgba(0,0,0,.05);box-shadow:0 3px 1px 0 rgba(0,0,0,.05),0 2px 2px 0 rgba(0,0,0,.1),0 3px 3px 0 rgba(0,0,0,.05);-webkit-transition:width .15s ease-out,-webkit-transform .15s ease-out;transition:width .15s ease-out,-webkit-transform .15s ease-out;transition:transform .15s ease-out,width .15s ease-out;transition:transform .15s ease-out,width .15s ease-out,-webkit-transform .15s ease-out;will-change:transform}.switch input[type=checkbox]+.check.is-elastic:before{width:1.75em}.switch input[type=checkbox]:checked+.check{background:#7957d5}.switch input[type=checkbox]:checked+.check.is-white{background:#fff}.switch input[type=checkbox]:checked+.check.is-black{background:#0a0a0a}.switch input[type=checkbox]:checked+.check.is-light{background:#f5f5f5}.switch input[type=checkbox]:checked+.check.is-dark{background:#363636}.switch input[type=checkbox]:checked+.check.is-link,.switch input[type=checkbox]:checked+.check.is-primary{background:#7957d5}.switch input[type=checkbox]:checked+.check.is-info{background:#167df0}.switch input[type=checkbox]:checked+.check.is-success{background:#23d160}.switch input[type=checkbox]:checked+.check.is-warning{background:#ffdd57}.switch input[type=checkbox]:checked+.check.is-danger{background:#ff3860}.switch input[type=checkbox]:checked+.check:before{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.switch input[type=checkbox]:checked+.check.is-elastic:before{-webkit-transform:translate3d(36.36364%,0,0);transform:translate3d(36.36364%,0,0)}.switch .control-label{padding-left:.5em}.switch:hover input[type=checkbox]+.check{background:hsla(0,0%,71%,.9)}.switch:hover input[type=checkbox]:checked+.check{background:rgba(121,87,213,.9)}.switch:hover input[type=checkbox]:checked+.check.is-white{background:hsla(0,0%,100%,.9)}.switch:hover input[type=checkbox]:checked+.check.is-black{background:hsla(0,0%,4%,.9)}.switch:hover input[type=checkbox]:checked+.check.is-light{background:hsla(0,0%,96%,.9)}.switch:hover input[type=checkbox]:checked+.check.is-dark{background:rgba(54,54,54,.9)}.switch:hover input[type=checkbox]:checked+.check.is-link,.switch:hover input[type=checkbox]:checked+.check.is-primary{background:rgba(121,87,213,.9)}.switch:hover input[type=checkbox]:checked+.check.is-info{background:rgba(22,125,240,.9)}.switch:hover input[type=checkbox]:checked+.check.is-success{background:rgba(35,209,96,.9)}.switch:hover input[type=checkbox]:checked+.check.is-warning{background:rgba(255,221,87,.9)}.switch:hover input[type=checkbox]:checked+.check.is-danger{background:rgba(255,56,96,.9)}.switch:focus{outline:none}.switch:focus input[type=checkbox]+.check{-webkit-box-shadow:0 0 .5em hsla(0,0%,48%,.6);box-shadow:0 0 .5em hsla(0,0%,48%,.6)}.switch:focus input[type=checkbox]:checked+.check{-webkit-box-shadow:0 0 .5em rgba(121,87,213,.8);box-shadow:0 0 .5em rgba(121,87,213,.8)}.switch:focus input[type=checkbox]:checked+.check.is-white{-webkit-box-shadow:0 0 .5em hsla(0,0%,100%,.8);box-shadow:0 0 .5em hsla(0,0%,100%,.8)}.switch:focus input[type=checkbox]:checked+.check.is-black{-webkit-box-shadow:0 0 .5em hsla(0,0%,4%,.8);box-shadow:0 0 .5em hsla(0,0%,4%,.8)}.switch:focus input[type=checkbox]:checked+.check.is-light{-webkit-box-shadow:0 0 .5em hsla(0,0%,96%,.8);box-shadow:0 0 .5em hsla(0,0%,96%,.8)}.switch:focus input[type=checkbox]:checked+.check.is-dark{-webkit-box-shadow:0 0 .5em rgba(54,54,54,.8);box-shadow:0 0 .5em rgba(54,54,54,.8)}.switch:focus input[type=checkbox]:checked+.check.is-link,.switch:focus input[type=checkbox]:checked+.check.is-primary{-webkit-box-shadow:0 0 .5em rgba(121,87,213,.8);box-shadow:0 0 .5em rgba(121,87,213,.8)}.switch:focus input[type=checkbox]:checked+.check.is-info{-webkit-box-shadow:0 0 .5em rgba(22,125,240,.8);box-shadow:0 0 .5em rgba(22,125,240,.8)}.switch:focus input[type=checkbox]:checked+.check.is-success{-webkit-box-shadow:0 0 .5em rgba(35,209,96,.8);box-shadow:0 0 .5em rgba(35,209,96,.8)}.switch:focus input[type=checkbox]:checked+.check.is-warning{-webkit-box-shadow:0 0 .5em rgba(255,221,87,.8);box-shadow:0 0 .5em rgba(255,221,87,.8)}.switch:focus input[type=checkbox]:checked+.check.is-danger{-webkit-box-shadow:0 0 .5em rgba(255,56,96,.8);box-shadow:0 0 .5em rgba(255,56,96,.8)}.switch.is-small{border-radius:2px;font-size:.75rem}.switch.is-medium{font-size:1.25rem}.switch.is-large{font-size:1.5rem}.switch[disabled]{opacity:.5;cursor:not-allowed;color:#7a7a7a}.table-wrapper .table{margin-bottom:0}.table-wrapper:not(:last-child){margin-bottom:1.5rem}@media screen and (max-width:1087px){.table-wrapper{overflow-x:auto}}.b-table{-webkit-transition:opacity 86ms ease-out;transition:opacity 86ms ease-out}@media print,screen and (min-width:769px){.b-table .table-mobile-sort{display:none}}.b-table .icon{-webkit-transition:opacity 86ms ease-out,-webkit-transform .15s ease-out;transition:opacity 86ms ease-out,-webkit-transform .15s ease-out;transition:transform .15s ease-out,opacity 86ms ease-out;transition:transform .15s ease-out,opacity 86ms ease-out,-webkit-transform .15s ease-out}.b-table .icon.is-desc{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.b-table .icon.is-expanded{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.b-table .table{width:100%;border:1px solid transparent;border-radius:4px;border-collapse:separate}.b-table .table th{font-weight:600}.b-table .table th .th-wrap{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.b-table .table th .th-wrap .icon{margin-left:.5rem;margin-right:0;font-size:1rem}.b-table .table th .th-wrap.is-numeric{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;text-align:right}.b-table .table th .th-wrap.is-numeric .icon{margin-left:0;margin-right:.5rem}.b-table .table th .th-wrap.is-centered{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}.b-table .table th.is-current-sort{border-color:#7a7a7a;font-weight:700}.b-table .table th.is-sortable:hover{border-color:#7a7a7a}.b-table .table th.is-sortable,.b-table .table th.is-sortable .th-wrap{cursor:pointer}.b-table .table tr.is-selected .checkbox input:checked+.check{background:#fff url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%237957d5'/%3E%3C/svg%3E\") no-repeat 50%}.b-table .table tr.is-selected .checkbox input+.check{border-color:#fff}.b-table .table tr.is-empty:hover{background-color:transparent}.b-table .table .chevron-cell{vertical-align:middle}.b-table .table .checkbox-cell{width:40px}.b-table .table .checkbox-cell .checkbox{vertical-align:middle}.b-table .table .checkbox-cell .checkbox .check{-webkit-transition:none;transition:none}.b-table .table tr.detail{-webkit-box-shadow:inset 0 1px 3px #dbdbdb;box-shadow:inset 0 1px 3px #dbdbdb;background:#fafafa}.b-table .table tr.detail .detail-container{padding:1rem}.b-table .table:focus{border-color:#7957d5;-webkit-box-shadow:0 0 0 .125em rgba(121,87,213,.25);box-shadow:0 0 0 .125em rgba(121,87,213,.25)}.b-table .table.is-bordered th.is-current-sort,.b-table .table.is-bordered th.is-sortable:hover{border-color:#dbdbdb;background:#f5f5f5}@media screen and (max-width:768px){.b-table .table.has-mobile-cards thead{display:none}.b-table .table.has-mobile-cards tfoot th{border:0;display:inherit}.b-table .table.has-mobile-cards tr{-webkit-box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);max-width:100%;position:relative;display:block}.b-table .table.has-mobile-cards tr td{border:0;display:inherit}.b-table .table.has-mobile-cards tr td:last-child{border-bottom:0}.b-table .table.has-mobile-cards tr:not(:last-child){margin-bottom:1rem}.b-table .table.has-mobile-cards tr:not([class*=is-]){background:inherit}.b-table .table.has-mobile-cards tr:not([class*=is-]):hover{background-color:inherit}.b-table .table.has-mobile-cards tr.detail{margin-top:-1rem}.b-table .table.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td{display:-webkit-box;display:-ms-flexbox;display:flex;width:auto;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;text-align:right;border-bottom:1px solid #f5f5f5}.b-table .table.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td:before{content:attr(data-label);font-weight:600;padding-right:.5em;text-align:left}}.b-table .level{padding-bottom:1.5rem}.b-table.is-loading{position:relative;pointer-events:none;opacity:.5}.b-table.is-loading:after{position:absolute;top:4em;left:calc(50% - 2.5em);width:5em;height:5em;border-width:.25em}.b-tabs .tabs{margin-bottom:0;-ms-flex-negative:0;flex-shrink:0}.b-tabs .is-disabled{pointer-events:none;cursor:not-allowed;opacity:.5}.b-tabs .tab-content{position:relative;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:1rem}.b-tabs .tab-content .tab-item{-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:auto;flex-basis:auto}.b-tabs:not(:last-child){margin-bottom:1.5rem}.b-tabs.is-fullwidth{width:100%}.tag .has-ellipsis{max-width:10em;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.taginput .taginput-container.is-focusable{padding-bottom:0;padding-top:calc(.275em - 1px);-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;height:auto;cursor:text}.taginput .taginput-container>.tag,.taginput .taginput-container>.tags{margin-bottom:calc(.275em - 1px);font-size:.9em;height:1.7em}.taginput .taginput-container>.tag .tag,.taginput .taginput-container>.tags .tag{margin-bottom:0;font-size:.9em;height:1.7em}.taginput .taginput-container>.tag:not(:last-child),.taginput .taginput-container>.tags:not(:last-child){margin-right:.275rem}.taginput .taginput-container .autocomplete{-webkit-box-flex:1;-ms-flex:1;flex:1}.taginput .taginput-container .autocomplete input{height:1.7em;margin-bottom:calc(.275em - 1px);padding-top:0;padding-bottom:0;border:none;-webkit-box-shadow:none;box-shadow:none;min-width:8em}.taginput .taginput-container .autocomplete input:focus{-webkit-box-shadow:none!important;box-shadow:none!important}.taginput .taginput-container .autocomplete .icon{height:1.7em}.timepicker .dropdown,.timepicker .dropdown-trigger{width:100%}.dropdown .dropdown-menu .has-link .timepicker a,.timepicker .dropdown-item,.timepicker .dropdown .dropdown-menu .has-link a{font-size:inherit}.timepicker .timepicker-footer{padding-top:.875rem}.timepicker .control .select{font-size:2.5rem}.timepicker .control .select select{font-weight:600;padding-right:calc(.625em - 1px)}.timepicker .control .select select option{font-size:1.5rem}.timepicker .control .select select option:disabled{color:hsla(0,0%,48%,.7)}.timepicker .control .select:after{display:none}.timepicker .control:first-child .select select{border-right:none}.timepicker .control:first-child .select:before{content:\":\";color:#b5b5b5;display:inline-block;position:absolute;z-index:6;font-size:3rem;right:-.325rem;top:.25rem}.timepicker .control:nth-child(2) .select select{border-left:none}.timepicker.is-small{border-radius:2px;font-size:.75rem}.timepicker.is-medium{font-size:1.25rem}.timepicker.is-large{font-size:1.5rem}.tooltip{position:relative;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.tooltip.is-top:after,.tooltip.is-top:before{top:auto;right:auto;bottom:calc(100% + 5px + 2px);left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.tooltip.is-top.is-white:before{border-top:5px solid #fff}.tooltip.is-top.is-black:before,.tooltip.is-top.is-white:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.tooltip.is-top.is-black:before{border-top:5px solid #0a0a0a}.tooltip.is-top.is-light:before{border-top:5px solid #f5f5f5}.tooltip.is-top.is-dark:before,.tooltip.is-top.is-light:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.tooltip.is-top.is-dark:before{border-top:5px solid #363636}.tooltip.is-top.is-link:before,.tooltip.is-top.is-primary:before{border-top:5px solid #7957d5;border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.tooltip.is-top.is-info:before{border-top:5px solid #167df0}.tooltip.is-top.is-info:before,.tooltip.is-top.is-success:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.tooltip.is-top.is-success:before{border-top:5px solid #23d160}.tooltip.is-top.is-warning:before{border-top:5px solid #ffdd57}.tooltip.is-top.is-danger:before,.tooltip.is-top.is-warning:before{border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px)}.tooltip.is-top.is-danger:before{border-top:5px solid #ff3860}.tooltip.is-top.is-multiline.is-small:after{width:180px}.tooltip.is-top.is-multiline.is-medium:after{width:240px}.tooltip.is-top.is-multiline.is-large:after{width:300px}.tooltip.is-right:after,.tooltip.is-right:before{top:50%;right:auto;bottom:auto;left:calc(100% + 5px + 2px);-webkit-transform:translateY(-50%);transform:translateY(-50%)}.tooltip.is-right.is-white:before{border-right:5px solid #fff}.tooltip.is-right.is-black:before,.tooltip.is-right.is-white:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.tooltip.is-right.is-black:before{border-right:5px solid #0a0a0a}.tooltip.is-right.is-light:before{border-right:5px solid #f5f5f5}.tooltip.is-right.is-dark:before,.tooltip.is-right.is-light:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.tooltip.is-right.is-dark:before{border-right:5px solid #363636}.tooltip.is-right.is-link:before,.tooltip.is-right.is-primary:before{border-top:5px solid transparent;border-right:5px solid #7957d5;border-bottom:5px solid transparent;left:calc(100% + 2px)}.tooltip.is-right.is-info:before{border-right:5px solid #167df0}.tooltip.is-right.is-info:before,.tooltip.is-right.is-success:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.tooltip.is-right.is-success:before{border-right:5px solid #23d160}.tooltip.is-right.is-warning:before{border-right:5px solid #ffdd57}.tooltip.is-right.is-danger:before,.tooltip.is-right.is-warning:before{border-top:5px solid transparent;border-bottom:5px solid transparent;left:calc(100% + 2px)}.tooltip.is-right.is-danger:before{border-right:5px solid #ff3860}.tooltip.is-right.is-multiline.is-small:after{width:180px}.tooltip.is-right.is-multiline.is-medium:after{width:240px}.tooltip.is-right.is-multiline.is-large:after{width:300px}.tooltip.is-bottom:after,.tooltip.is-bottom:before{top:calc(100% + 5px + 2px);right:auto;bottom:auto;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.tooltip.is-bottom.is-white:before{border-bottom:5px solid #fff}.tooltip.is-bottom.is-black:before,.tooltip.is-bottom.is-white:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.tooltip.is-bottom.is-black:before{border-bottom:5px solid #0a0a0a}.tooltip.is-bottom.is-light:before{border-bottom:5px solid #f5f5f5}.tooltip.is-bottom.is-dark:before,.tooltip.is-bottom.is-light:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.tooltip.is-bottom.is-dark:before{border-bottom:5px solid #363636}.tooltip.is-bottom.is-link:before,.tooltip.is-bottom.is-primary:before{border-right:5px solid transparent;border-bottom:5px solid #7957d5;border-left:5px solid transparent;top:calc(100% + 2px)}.tooltip.is-bottom.is-info:before{border-bottom:5px solid #167df0}.tooltip.is-bottom.is-info:before,.tooltip.is-bottom.is-success:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.tooltip.is-bottom.is-success:before{border-bottom:5px solid #23d160}.tooltip.is-bottom.is-warning:before{border-bottom:5px solid #ffdd57}.tooltip.is-bottom.is-danger:before,.tooltip.is-bottom.is-warning:before{border-right:5px solid transparent;border-left:5px solid transparent;top:calc(100% + 2px)}.tooltip.is-bottom.is-danger:before{border-bottom:5px solid #ff3860}.tooltip.is-bottom.is-multiline.is-small:after{width:180px}.tooltip.is-bottom.is-multiline.is-medium:after{width:240px}.tooltip.is-bottom.is-multiline.is-large:after{width:300px}.tooltip.is-left:after,.tooltip.is-left:before{top:50%;right:calc(100% + 5px + 2px);bottom:auto;left:auto;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.tooltip.is-left.is-white:before{border-left:5px solid #fff}.tooltip.is-left.is-black:before,.tooltip.is-left.is-white:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.tooltip.is-left.is-black:before{border-left:5px solid #0a0a0a}.tooltip.is-left.is-light:before{border-left:5px solid #f5f5f5}.tooltip.is-left.is-dark:before,.tooltip.is-left.is-light:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.tooltip.is-left.is-dark:before{border-left:5px solid #363636}.tooltip.is-left.is-link:before,.tooltip.is-left.is-primary:before{border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #7957d5;right:calc(100% + 2px)}.tooltip.is-left.is-info:before{border-left:5px solid #167df0}.tooltip.is-left.is-info:before,.tooltip.is-left.is-success:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.tooltip.is-left.is-success:before{border-left:5px solid #23d160}.tooltip.is-left.is-warning:before{border-left:5px solid #ffdd57}.tooltip.is-left.is-danger:before,.tooltip.is-left.is-warning:before{border-top:5px solid transparent;border-bottom:5px solid transparent;right:calc(100% + 2px)}.tooltip.is-left.is-danger:before{border-left:5px solid #ff3860}.tooltip.is-left.is-multiline.is-small:after{width:180px}.tooltip.is-left.is-multiline.is-medium:after{width:240px}.tooltip.is-left.is-multiline.is-large:after{width:300px}.tooltip:after,.tooltip:before{position:absolute;content:\"\";opacity:0;visibility:hidden;pointer-events:none}.tooltip:before{z-index:889}.tooltip:after{content:attr(data-label);width:auto;padding:.35rem .75rem;border-radius:6px;font-size:.85rem;font-weight:400;-webkit-box-shadow:0 1px 2px 1px rgba(0,1,0,.2);box-shadow:0 1px 2px 1px rgba(0,1,0,.2);z-index:888;white-space:nowrap}.tooltip:not([data-label=\"\"]):hover:after,.tooltip:not([data-label=\"\"]):hover:before{opacity:1;visibility:visible}.tooltip.is-white:after{background:#fff;color:#0a0a0a}.tooltip.is-black:after{background:#0a0a0a;color:#fff}.tooltip.is-light:after{background:#f5f5f5;color:#363636}.tooltip.is-dark:after{background:#363636;color:#f5f5f5}.tooltip.is-link:after,.tooltip.is-primary:after{background:#7957d5;color:#fff}.tooltip.is-info:after{background:#167df0;color:#fff}.tooltip.is-success:after{background:#23d160;color:#fff}.tooltip.is-warning:after{background:#ffdd57;color:rgba(0,0,0,.7)}.tooltip.is-danger:after{background:#ff3860;color:#fff}.tooltip:not([data-label=\"\"]).is-always:after,.tooltip:not([data-label=\"\"]).is-always:before{opacity:1;visibility:visible}.tooltip.is-multiline:after{display:flex-block;text-align:center;white-space:normal}.tooltip.is-dashed{border-bottom:1px dashed #b5b5b5;cursor:default}.tooltip.is-square:after{border-radius:0}.tooltip.is-animated:after,.tooltip.is-animated:before{-webkit-transition:opacity 86ms ease-out,visibility 86ms ease-out;transition:opacity 86ms ease-out,visibility 86ms ease-out}.upload{position:relative}.upload input[type=file]{position:absolute;top:0;left:0;width:100%;opacity:0;outline:none;z-index:-1}.upload .upload-draggable{display:inline-block;cursor:pointer;padding:.25em;border:1px dashed #b5b5b5;border-radius:6px}.upload .upload-draggable.is-disabled{opacity:.5;cursor:not-allowed}.upload .upload-draggable.is-loading{position:relative;pointer-events:none;opacity:.5}.upload .upload-draggable.is-loading:after{top:0;left:calc(50% - 1.5em);width:3em;height:3em;border-width:.25em}.upload .upload-draggable.is-hovered.is-white,.upload .upload-draggable:hover.is-white{border-color:#fff;background:hsla(0,0%,100%,.05)}.upload .upload-draggable.is-hovered.is-black,.upload .upload-draggable:hover.is-black{border-color:#0a0a0a;background:hsla(0,0%,4%,.05)}.upload .upload-draggable.is-hovered.is-light,.upload .upload-draggable:hover.is-light{border-color:#f5f5f5;background:hsla(0,0%,96%,.05)}.upload .upload-draggable.is-hovered.is-dark,.upload .upload-draggable:hover.is-dark{border-color:#363636;background:rgba(54,54,54,.05)}.upload .upload-draggable.is-hovered.is-link,.upload .upload-draggable.is-hovered.is-primary,.upload .upload-draggable:hover.is-link,.upload .upload-draggable:hover.is-primary{border-color:#7957d5;background:rgba(121,87,213,.05)}.upload .upload-draggable.is-hovered.is-info,.upload .upload-draggable:hover.is-info{border-color:#167df0;background:rgba(22,125,240,.05)}.upload .upload-draggable.is-hovered.is-success,.upload .upload-draggable:hover.is-success{border-color:#23d160;background:rgba(35,209,96,.05)}.upload .upload-draggable.is-hovered.is-warning,.upload .upload-draggable:hover.is-warning{border-color:#ffdd57;background:rgba(255,221,87,.05)}.upload .upload-draggable.is-hovered.is-danger,.upload .upload-draggable:hover.is-danger{border-color:#ff3860;background:rgba(255,56,96,.05)}", ""]);

// exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(48).polyfill();


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.5+7f2b526d
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var TRY_CATCH_ERROR = { error: null };

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    TRY_CATCH_ERROR.error = error;
    return TRY_CATCH_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === TRY_CATCH_ERROR) {
      reject(promise, TRY_CATCH_ERROR.error);
      TRY_CATCH_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Generated by CoffeeScript 1.10.0
(function() {
  var Card, QJ, extend, payment,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  __webpack_require__(50);

  QJ = __webpack_require__(12);

  payment = __webpack_require__(52);

  extend = __webpack_require__(53);

  Card = (function() {
    var bindVal;

    Card.prototype.initializedDataAttr = "data-jp-card-initialized";

    Card.prototype.cardTemplate = '' + '<div class="jp-card-container">' + '<div class="jp-card">' + '<div class="jp-card-front">' + '<div class="jp-card-logo jp-card-elo">' + '<div class="e">e</div>' + '<div class="l">l</div>' + '<div class="o">o</div>' + '</div>' + '<div class="jp-card-logo jp-card-visa">Visa</div>' + '<div class="jp-card-logo jp-card-visaelectron">Visa<div class="elec">Electron</div></div>' + '<div class="jp-card-logo jp-card-mastercard">Mastercard</div>' + '<div class="jp-card-logo jp-card-maestro">Maestro</div>' + '<div class="jp-card-logo jp-card-amex"></div>' + '<div class="jp-card-logo jp-card-discover">discover</div>' + '<div class="jp-card-logo jp-card-dinersclub"></div>' + '<div class="jp-card-logo jp-card-dankort"><div class="dk"><div class="d"></div><div class="k"></div></div></div>' + '<div class="jp-card-logo jp-card-jcb">' + '<div class="j">J</div>' + '<div class="c">C</div>' + '<div class="b">B</div>' + '</div>' + '<div class="jp-card-lower">' + '<div class="jp-card-shiny"></div>' + '<div class="jp-card-cvc jp-card-display">{{cvc}}</div>' + '<div class="jp-card-number jp-card-display">{{number}}</div>' + '<div class="jp-card-name jp-card-display">{{name}}</div>' + '<div class="jp-card-expiry jp-card-display" data-before="{{monthYear}}" data-after="{{validDate}}">{{expiry}}</div>' + '</div>' + '</div>' + '<div class="jp-card-back">' + '<div class="jp-card-bar"></div>' + '<div class="jp-card-cvc jp-card-display">{{cvc}}</div>' + '<div class="jp-card-shiny"></div>' + '</div>' + '</div>' + '</div>';

    Card.prototype.template = function(tpl, data) {
      return tpl.replace(/\{\{(.*?)\}\}/g, function(match, key, str) {
        return data[key];
      });
    };

    Card.prototype.cardTypes = ['jp-card-amex', 'jp-card-dankort', 'jp-card-dinersclub', 'jp-card-discover', 'jp-card-jcb', 'jp-card-laser', 'jp-card-maestro', 'jp-card-mastercard', 'jp-card-unionpay', 'jp-card-visa', 'jp-card-visaelectron', 'jp-card-elo'];

    Card.prototype.defaults = {
      formatting: true,
      formSelectors: {
        numberInput: 'input[name="number"]',
        expiryInput: 'input[name="expiry"]',
        cvcInput: 'input[name="cvc"]',
        nameInput: 'input[name="name"]'
      },
      cardSelectors: {
        cardContainer: '.jp-card-container',
        card: '.jp-card',
        numberDisplay: '.jp-card-number',
        expiryDisplay: '.jp-card-expiry',
        cvcDisplay: '.jp-card-cvc',
        nameDisplay: '.jp-card-name'
      },
      messages: {
        validDate: 'valid\nthru',
        monthYear: 'month/year'
      },
      placeholders: {
        number: '&bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull;',
        cvc: '&bull;&bull;&bull;',
        expiry: '&bull;&bull;/&bull;&bull;',
        name: 'Full Name'
      },
      masks: {
        cardNumber: false
      },
      classes: {
        valid: 'jp-card-valid',
        invalid: 'jp-card-invalid'
      },
      debug: false
    };

    function Card(opts) {
      this.maskCardNumber = bind(this.maskCardNumber, this);
      var toInitialize;
      this.options = extend(true, this.defaults, opts);
      if (!this.options.form) {
        console.log("Please provide a form");
        return;
      }
      this.$el = QJ(this.options.form);
      if (!this.options.container) {
        console.log("Please provide a container");
        return;
      }
      this.$container = QJ(this.options.container);
      toInitialize = QJ.isDOMElement(this.$container) ? this.$container : this.$container[0];
      if (toInitialize.getAttribute(this.initializedDataAttr)) {
        return;
      }
      toInitialize.setAttribute(this.initializedDataAttr, true);
      this.render();
      this.attachHandlers();
      this.handleInitialPlaceholders();
    }

    Card.prototype.render = function() {
      var $cardContainer, baseWidth, name, obj, ref, ref1, selector, ua;
      QJ.append(this.$container, this.template(this.cardTemplate, extend({}, this.options.messages, this.options.placeholders)));
      ref = this.options.cardSelectors;
      for (name in ref) {
        selector = ref[name];
        this["$" + name] = QJ.find(this.$container, selector);
      }
      ref1 = this.options.formSelectors;
      for (name in ref1) {
        selector = ref1[name];
        selector = this.options[name] ? this.options[name] : selector;
        obj = QJ.find(this.$el, selector);
        if (!obj.length && this.options.debug) {
          console.error("Card can't find a " + name + " in your form.");
        }
        this["$" + name] = obj;
      }
      if (this.options.formatting) {
        Payment.formatCardNumber(this.$numberInput);
        Payment.formatCardCVC(this.$cvcInput);
        Payment.formatCardExpiry(this.$expiryInput);
      }
      if (this.options.width) {
        $cardContainer = QJ(this.options.cardSelectors.cardContainer)[0];
        baseWidth = parseInt($cardContainer.clientWidth || window.getComputedStyle($cardContainer).width);
        $cardContainer.style.transform = "scale(" + (this.options.width / baseWidth) + ")";
      }
      if (typeof navigator !== "undefined" && navigator !== null ? navigator.userAgent : void 0) {
        ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
          QJ.addClass(this.$card, 'jp-card-safari');
        }
      }
      if (/MSIE 10\./i.test(navigator.userAgent)) {
        QJ.addClass(this.$card, 'jp-card-ie-10');
      }
      if (/rv:11.0/i.test(navigator.userAgent)) {
        return QJ.addClass(this.$card, 'jp-card-ie-11');
      }
    };

    Card.prototype.attachHandlers = function() {
      var expiryFilters, numberInputFilters;
      numberInputFilters = [this.validToggler('cardNumber')];
      if (this.options.masks.cardNumber) {
        numberInputFilters.push(this.maskCardNumber);
      }
      bindVal(this.$numberInput, this.$numberDisplay, {
        fill: false,
        filters: numberInputFilters
      });
      QJ.on(this.$numberInput, 'payment.cardType', this.handle('setCardType'));
      expiryFilters = [
        function(val) {
          return val.replace(/(\s+)/g, '');
        }
      ];
      expiryFilters.push(this.validToggler('cardExpiry'));
      bindVal(this.$expiryInput, this.$expiryDisplay, {
        join: function(text) {
          if (text[0].length === 2 || text[1]) {
            return "/";
          } else {
            return "";
          }
        },
        filters: expiryFilters
      });
      bindVal(this.$cvcInput, this.$cvcDisplay, {
        filters: this.validToggler('cardCVC')
      });
      QJ.on(this.$cvcInput, 'focus', this.handle('flipCard'));
      QJ.on(this.$cvcInput, 'blur', this.handle('unflipCard'));
      return bindVal(this.$nameInput, this.$nameDisplay, {
        fill: false,
        filters: this.validToggler('cardHolderName'),
        join: ' '
      });
    };

    Card.prototype.handleInitialPlaceholders = function() {
      var el, name, ref, results, selector;
      ref = this.options.formSelectors;
      results = [];
      for (name in ref) {
        selector = ref[name];
        el = this["$" + name];
        if (QJ.val(el)) {
          QJ.trigger(el, 'paste');
          results.push(setTimeout(function() {
            return QJ.trigger(el, 'keyup');
          }));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    Card.prototype.handle = function(fn) {
      return (function(_this) {
        return function(e) {
          var args;
          args = Array.prototype.slice.call(arguments);
          args.unshift(e.target);
          return _this.handlers[fn].apply(_this, args);
        };
      })(this);
    };

    Card.prototype.validToggler = function(validatorName) {
      var isValid;
      if (validatorName === "cardExpiry") {
        isValid = function(val) {
          var objVal;
          objVal = Payment.fns.cardExpiryVal(val);
          return Payment.fns.validateCardExpiry(objVal.month, objVal.year);
        };
      } else if (validatorName === "cardCVC") {
        isValid = (function(_this) {
          return function(val) {
            return Payment.fns.validateCardCVC(val, _this.cardType);
          };
        })(this);
      } else if (validatorName === "cardNumber") {
        isValid = function(val) {
          return Payment.fns.validateCardNumber(val);
        };
      } else if (validatorName === "cardHolderName") {
        isValid = function(val) {
          return val !== "";
        };
      }
      return (function(_this) {
        return function(val, $in, $out) {
          var result;
          result = isValid(val);
          _this.toggleValidClass($in, result);
          _this.toggleValidClass($out, result);
          return val;
        };
      })(this);
    };

    Card.prototype.toggleValidClass = function(el, test) {
      QJ.toggleClass(el, this.options.classes.valid, test);
      return QJ.toggleClass(el, this.options.classes.invalid, !test);
    };

    Card.prototype.maskCardNumber = function(val, el, out) {
      var mask, numbers;
      mask = this.options.masks.cardNumber;
      numbers = val.split(' ');
      if (numbers.length >= 3) {
        numbers.forEach(function(item, idx) {
          if (idx !== numbers.length - 1) {
            return numbers[idx] = numbers[idx].replace(/\d/g, mask);
          }
        });
        return numbers.join(' ');
      } else {
        return val.replace(/\d/g, mask);
      }
    };

    Card.prototype.handlers = {
      setCardType: function($el, e) {
        var cardType;
        cardType = e.data;
        if (!QJ.hasClass(this.$card, cardType)) {
          QJ.removeClass(this.$card, 'jp-card-unknown');
          QJ.removeClass(this.$card, this.cardTypes.join(' '));
          QJ.addClass(this.$card, "jp-card-" + cardType);
          QJ.toggleClass(this.$card, 'jp-card-identified', cardType !== 'unknown');
          return this.cardType = cardType;
        }
      },
      flipCard: function() {
        return QJ.addClass(this.$card, 'jp-card-flipped');
      },
      unflipCard: function() {
        return QJ.removeClass(this.$card, 'jp-card-flipped');
      }
    };

    bindVal = function(el, out, opts) {
      var joiner, o, outDefaults;
      if (opts == null) {
        opts = {};
      }
      opts.fill = opts.fill || false;
      opts.filters = opts.filters || [];
      if (!(opts.filters instanceof Array)) {
        opts.filters = [opts.filters];
      }
      opts.join = opts.join || "";
      if (!(typeof opts.join === "function")) {
        joiner = opts.join;
        opts.join = function() {
          return joiner;
        };
      }
      outDefaults = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = out.length; j < len; j++) {
          o = out[j];
          results.push(o.textContent);
        }
        return results;
      })();
      QJ.on(el, 'focus', function() {
        return QJ.addClass(out, 'jp-card-focused');
      });
      QJ.on(el, 'blur', function() {
        return QJ.removeClass(out, 'jp-card-focused');
      });
      QJ.on(el, 'keyup change paste', function(e) {
        var elem, filter, i, j, join, k, len, len1, outEl, outVal, ref, results, val;
        val = (function() {
          var j, len, results;
          results = [];
          for (j = 0, len = el.length; j < len; j++) {
            elem = el[j];
            results.push(QJ.val(elem));
          }
          return results;
        })();
        join = opts.join(val);
        val = val.join(join);
        if (val === join) {
          val = "";
        }
        ref = opts.filters;
        for (j = 0, len = ref.length; j < len; j++) {
          filter = ref[j];
          val = filter(val, el, out);
        }
        results = [];
        for (i = k = 0, len1 = out.length; k < len1; i = ++k) {
          outEl = out[i];
          if (opts.fill) {
            outVal = val + outDefaults[i].substring(val.length);
          } else {
            outVal = val || outDefaults[i];
          }
          results.push(outEl.textContent = outVal);
        }
        return results;
      });
      return el;
    };

    return Card;

  })();

  module.exports = Card;

  global.Card = Card;

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(51);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0e1c0aa5", content, true, {});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".jp-card.jp-card-safari.jp-card-identified .jp-card-back:before,.jp-card.jp-card-safari.jp-card-identified .jp-card-front:before{background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),-webkit-linear-gradient(-245deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%);background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),linear-gradient(-25deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%)}.jp-card.jp-card-ie-10.jp-card-flipped,.jp-card.jp-card-ie-11.jp-card-flipped{-webkit-transform:0deg;-moz-transform:0deg;-ms-transform:0deg;-o-transform:0deg;transform:0deg}.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-back,.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-front,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-back,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-front{-webkit-transform:rotateY(0deg);-moz-transform:rotateY(0deg);-ms-transform:rotateY(0deg);-o-transform:rotateY(0deg);transform:rotateY(0deg)}.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-back:after,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-back:after{left:18%}.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-back .jp-card-cvc,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-back .jp-card-cvc{-webkit-transform:rotateY(180deg);-moz-transform:rotateY(180deg);-ms-transform:rotateY(180deg);-o-transform:rotateY(180deg);transform:rotateY(180deg);left:5%}.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-back .jp-card-shiny,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-back .jp-card-shiny{left:84%}.jp-card.jp-card-ie-10.jp-card-flipped .jp-card-back .jp-card-shiny:after,.jp-card.jp-card-ie-11.jp-card-flipped .jp-card-back .jp-card-shiny:after{left:-480%;-webkit-transform:rotateY(180deg);-moz-transform:rotateY(180deg);-ms-transform:rotateY(180deg);-o-transform:rotateY(180deg);transform:rotateY(180deg)}.jp-card.jp-card-ie-10.jp-card-amex .jp-card-back,.jp-card.jp-card-ie-11.jp-card-amex .jp-card-back{display:none}.jp-card-logo{height:36px;width:60px;font-style:italic}.jp-card-logo,.jp-card-logo:after,.jp-card-logo:before{box-sizing:border-box}.jp-card-logo.jp-card-amex{text-transform:uppercase;font-size:4px;font-weight:700;color:#fff;background-image:repeating-radial-gradient(circle at center,#fff 1px,#999 2px);border:1px solid #eee}.jp-card-logo.jp-card-amex:after,.jp-card-logo.jp-card-amex:before{width:28px;display:block;position:absolute;left:16px}.jp-card-logo.jp-card-amex:before{height:28px;content:\"american\";top:3px;text-align:left;padding-left:2px;padding-top:11px;background:#267ac3}.jp-card-logo.jp-card-amex:after{content:\"express\";bottom:11px;text-align:right;padding-right:2px}.jp-card.jp-card-amex.jp-card-flipped{-webkit-transform:none;-moz-transform:none;-ms-transform:none;-o-transform:none;transform:none}.jp-card.jp-card-amex.jp-card-identified .jp-card-back:before,.jp-card.jp-card-amex.jp-card-identified .jp-card-front:before{background-color:#108168}.jp-card.jp-card-amex.jp-card-identified .jp-card-front .jp-card-logo.jp-card-amex{opacity:1}.jp-card.jp-card-amex.jp-card-identified .jp-card-front .jp-card-cvc{visibility:visible}.jp-card.jp-card-amex.jp-card-identified .jp-card-front:after{opacity:1}.jp-card-logo.jp-card-discover{background:#f60;color:#111;text-transform:uppercase;font-style:normal;font-weight:700;font-size:10px;text-align:center;overflow:hidden;z-index:1;padding-top:9px;letter-spacing:.03em;border:1px solid #eee}.jp-card-logo.jp-card-discover:after,.jp-card-logo.jp-card-discover:before{content:\" \";display:block;position:absolute}.jp-card-logo.jp-card-discover:before{background:#fff;width:200px;height:200px;border-radius:200px;bottom:-5%;right:-80%;z-index:-1}.jp-card-logo.jp-card-discover:after{width:8px;height:8px;border-radius:4px;top:10px;left:27px;background-color:#f60;background-image:-webkit-radial-gradient(#f60,#fff);background-image:radial-gradient(#f60,#fff);content:\"network\";font-size:4px;line-height:24px;text-indent:-7px}.jp-card .jp-card-front .jp-card-logo.jp-card-discover{right:12%;top:18%}.jp-card.jp-card-discover.jp-card-identified .jp-card-back:before,.jp-card.jp-card-discover.jp-card-identified .jp-card-front:before{background-color:#86b8cf}.jp-card.jp-card-discover.jp-card-identified .jp-card-logo.jp-card-discover{opacity:1}.jp-card.jp-card-discover.jp-card-identified .jp-card-front:after{-webkit-transition:.4s;-moz-transition:.4s;transition:.4s;content:\" \";display:block;background-color:#f60;background-image:-webkit-linear-gradient(#f60,#ffa366,#f60);background-image:linear-gradient(#f60,#ffa366,#f60);height:50px;width:50px;border-radius:25px;position:absolute;left:100%;top:15%;margin-left:-25px;box-shadow:inset 1px 1px 3px 1px rgba(0,0,0,.5)}.jp-card-logo.jp-card-visa{text-transform:uppercase;color:#fff;text-align:center;font-weight:700;font-size:24px;line-height:18px;margin-top:5px}.jp-card-logo.jp-card-visa:after,.jp-card-logo.jp-card-visa:before{content:\" \";display:block;width:100%;height:25%}.jp-card-logo.jp-card-visa:before{position:absolute;left:-4px;width:0;height:0;border-style:solid;border-width:0 12px 6px 0;border-color:transparent #fff transparent transparent}.jp-card.jp-card-visa.jp-card-identified .jp-card-back:before,.jp-card.jp-card-visa.jp-card-identified .jp-card-front:before{background-color:#191278}.jp-card.jp-card-visa.jp-card-identified .jp-card-logo.jp-card-visa{opacity:1;box-shadow:none}.jp-card-logo.jp-card-visaelectron{background:#fff;text-transform:uppercase;color:#1a1876;text-align:center;font-weight:700;font-size:15px;line-height:18px}.jp-card-logo.jp-card-visaelectron:after,.jp-card-logo.jp-card-visaelectron:before{content:\" \";display:block;width:100%;height:25%}.jp-card-logo.jp-card-visaelectron:before{background:#1a1876}.jp-card-logo.jp-card-visaelectron:after{background:#e79800}.jp-card-logo.jp-card-visaelectron .elec{float:right;font-family:arial;font-size:9px;margin-right:1px;margin-top:-5px;text-transform:none}.jp-card.jp-card-visaelectron.jp-card-identified .jp-card-back:before,.jp-card.jp-card-visaelectron.jp-card-identified .jp-card-front:before{background-color:#191278}.jp-card.jp-card-visaelectron.jp-card-identified .jp-card-logo.jp-card-visaelectron{opacity:1}.jp-card-logo.jp-card-mastercard{color:#fff;font-style:normal;text-transform:lowercase;font-weight:700;text-align:center;font-size:9px;line-height:84px;z-index:1;text-shadow:1px 1px rgba(0,0,0,.6)}.jp-card-logo.jp-card-mastercard:after,.jp-card-logo.jp-card-mastercard:before{content:\" \";display:block;width:36px;top:0;position:absolute;height:36px;border-radius:18px}.jp-card-logo.jp-card-mastercard:before{left:0;background:#eb001b;z-index:-1;opacity:.9}.jp-card-logo.jp-card-mastercard:after{right:0;background:#ff5f00;z-index:-2}.jp-card.jp-card-mastercard.jp-card-identified .jp-card-back .jp-card-logo.jp-card-mastercard,.jp-card.jp-card-mastercard.jp-card-identified .jp-card-front .jp-card-logo.jp-card-mastercard{box-shadow:none}.jp-card.jp-card-mastercard.jp-card-identified .jp-card-back:before,.jp-card.jp-card-mastercard.jp-card-identified .jp-card-front:before{background-color:#0061a8}.jp-card.jp-card-mastercard.jp-card-identified .jp-card-logo.jp-card-mastercard{opacity:1}.jp-card-logo.jp-card-maestro{color:#fff;font-style:normal;text-transform:lowercase;font-weight:700;text-align:center;font-size:14px;line-height:84px;z-index:1;text-shadow:1px 1px rgba(0,0,0,.6)}.jp-card-logo.jp-card-maestro:after,.jp-card-logo.jp-card-maestro:before{content:\" \";display:block;width:36px;top:0;position:absolute;height:36px;border-radius:18px}.jp-card-logo.jp-card-maestro:before{left:0;background:#eb001b;z-index:-2}.jp-card-logo.jp-card-maestro:after{right:0;background:#00a2e5;z-index:-1;opacity:.8}.jp-card.jp-card-maestro.jp-card-identified .jp-card-back .jp-card-logo.jp-card-maestro,.jp-card.jp-card-maestro.jp-card-identified .jp-card-front .jp-card-logo.jp-card-maestro{box-shadow:none}.jp-card.jp-card-maestro.jp-card-identified .jp-card-back:before,.jp-card.jp-card-maestro.jp-card-identified .jp-card-front:before{background-color:#0b2c5f}.jp-card.jp-card-maestro.jp-card-identified .jp-card-logo.jp-card-maestro{opacity:1}.jp-card-logo.jp-card-dankort{width:60px;height:36px;padding:3px;border-radius:8px;border:1px solid #000;background-color:#fff}.jp-card-logo.jp-card-dankort .dk{position:relative;width:100%;height:100%;overflow:hidden}.jp-card-logo.jp-card-dankort .dk:before{background-color:#ed1c24;content:\"\";position:absolute;width:100%;height:100%;display:block;border-radius:6px}.jp-card-logo.jp-card-dankort .dk:after{content:\"\";position:absolute;top:50%;margin-top:-7.7px;right:0;width:0;height:0;border-style:solid;border-width:7px 7px 10px 0;border-color:transparent #ed1c24 transparent transparent;z-index:1}.jp-card-logo.jp-card-dankort .d,.jp-card-logo.jp-card-dankort .k{position:absolute;top:50%;width:50%;display:block;height:15.4px;margin-top:-7.7px;background:#fff}.jp-card-logo.jp-card-dankort .d{left:0;border-radius:0 8px 10px 0}.jp-card-logo.jp-card-dankort .d:before{content:\"\";position:absolute;top:50%;left:50%;display:block;background:#ed1c24;border-radius:2px 4px 6px 0;height:5px;width:7px;margin:-3px 0 0 -4px}.jp-card-logo.jp-card-dankort .k{right:0}.jp-card-logo.jp-card-dankort .k:after,.jp-card-logo.jp-card-dankort .k:before{content:\"\";position:absolute;right:50%;width:0;height:0;border-style:solid;margin-right:-1px}.jp-card-logo.jp-card-dankort .k:before{top:0;border-width:8px 5px 0 0;border-color:#ed1c24 transparent transparent}.jp-card-logo.jp-card-dankort .k:after{bottom:0;border-width:0 5px 8px 0;border-color:transparent transparent #ed1c24}.jp-card.jp-card-dankort.jp-card-identified .jp-card-back:before,.jp-card.jp-card-dankort.jp-card-identified .jp-card-front:before{background-color:#0055c7}.jp-card.jp-card-dankort.jp-card-identified .jp-card-logo.jp-card-dankort{opacity:1}.jp-card-logo.jp-card-elo{height:50px;width:50px;border-radius:100%;background:#000;color:#fff;text-align:center;text-transform:lowercase;font-size:21px;font-style:normal;letter-spacing:1px;font-weight:700;padding-top:13px}.jp-card-logo.jp-card-elo .e,.jp-card-logo.jp-card-elo .l,.jp-card-logo.jp-card-elo .o{display:inline-block;position:relative}.jp-card-logo.jp-card-elo .e{-webkit-transform:rotate(-15deg);-moz-transform:rotate(-15deg);-ms-transform:rotate(-15deg);-o-transform:rotate(-15deg);transform:rotate(-15deg)}.jp-card-logo.jp-card-elo .o{position:relative;display:inline-block;width:12px;height:12px;right:0;top:7px;border-radius:100%;background-image:-webkit-linear-gradient(#ff0 50%,red 0);background-image:linear-gradient(#ff0 50%,red 0);-webkit-transform:rotate(40deg);-moz-transform:rotate(40deg);-ms-transform:rotate(40deg);-o-transform:rotate(40deg);transform:rotate(40deg);text-indent:-9999px}.jp-card-logo.jp-card-elo .o:before{content:\"\";position:absolute;width:49%;height:49%;background:#000;border-radius:100%;text-indent:-99999px;top:25%;left:25%}.jp-card.jp-card-elo.jp-card-identified .jp-card-back:before,.jp-card.jp-card-elo.jp-card-identified .jp-card-front:before{background-color:#6f6969}.jp-card.jp-card-elo.jp-card-identified .jp-card-logo.jp-card-elo{opacity:1}.jp-card-logo.jp-card-jcb{background-color:#fff;font-style:normal;color:#fff;width:50px;padding:2px 0 0 2px}.jp-card-logo.jp-card-jcb,.jp-card-logo.jp-card-jcb>div{border-radius:5px 0 5px 0;-moz-border-radius:5px 0 5px 0;-webkit-border-radius:5px 0 5px 0}.jp-card-logo.jp-card-jcb>div{width:15px;margin-right:1px;display:inline-block;text-align:center;text-shadow:1px 1px rgba(0,0,0,.6)}.jp-card-logo.jp-card-jcb>div:after,.jp-card-logo.jp-card-jcb>div:before{content:\" \";display:block;height:8px}.jp-card-logo.jp-card-jcb>div.j{background-color:#000063;background-image:-webkit-linear-gradient(left,#000063,#008cff);background-image:linear-gradient(90deg,#000063,#008cff)}.jp-card-logo.jp-card-jcb>div.c{background-color:#630000;background-image:-webkit-linear-gradient(left,#630000,#ff008d);background-image:linear-gradient(90deg,#630000,#ff008d)}.jp-card-logo.jp-card-jcb>div.b{background-color:#006300;background-image:-webkit-linear-gradient(left,#006300,#0f0);background-image:linear-gradient(90deg,#006300,#0f0)}.jp-card.jp-card-jcb.jp-card-identified .jp-card-back:before,.jp-card.jp-card-jcb.jp-card-identified .jp-card-front:before{background-color:#cb8000}.jp-card.jp-card-jcb.jp-card-identified .jp-card-logo.jp-card-jcb{opacity:1;box-shadow:none}.jp-card-logo.jp-card-dinersclub{font-family:serif;height:40px;width:100px;color:#fff;font-size:17px;font-style:normal;letter-spacing:1px}.jp-card-logo.jp-card-dinersclub:after,.jp-card-logo.jp-card-dinersclub:before{display:block;position:relative}.jp-card-logo.jp-card-dinersclub:before{content:\"Diners Club\"}.jp-card-logo.jp-card-dinersclub:after{content:\"International\";text-transform:uppercase;font-size:.6em}.jp-card.jp-card-dinersclub .jp-card-front .jp-card-logo{box-shadow:none!important}.jp-card.jp-card-dinersclub.jp-card-identified .jp-card-back:before,.jp-card.jp-card-dinersclub.jp-card-identified .jp-card-front:before{background-color:#999}.jp-card.jp-card-dinersclub.jp-card-identified .jp-card-logo.jp-card-dinersclub{opacity:1}.jp-card-container{-webkit-perspective:1000px;-moz-perspective:1000px;perspective:1000px;width:350px;max-width:100%;height:200px;margin:auto;z-index:1;position:relative}.jp-card{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;line-height:1;position:relative;width:100%;height:100%;min-width:315px;border-radius:10px;-webkit-transform-style:preserve-3d;-moz-transform-style:preserve-3d;-ms-transform-style:preserve-3d;-o-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transition:all .4s linear;-moz-transition:all .4s linear;transition:all .4s linear}.jp-card>*,.jp-card>:after,.jp-card>:before{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}.jp-card.jp-card-flipped{-webkit-transform:rotateY(180deg);-moz-transform:rotateY(180deg);-ms-transform:rotateY(180deg);-o-transform:rotateY(180deg);transform:rotateY(180deg)}.jp-card .jp-card-back,.jp-card .jp-card-front{-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform-style:preserve-3d;-moz-transform-style:preserve-3d;-ms-transform-style:preserve-3d;-o-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transition:all .4s linear;-moz-transition:all .4s linear;transition:all .4s linear;width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden;border-radius:10px;background:#ddd}.jp-card .jp-card-back:before,.jp-card .jp-card-front:before{content:\" \";display:block;position:absolute;width:100%;height:100%;top:0;left:0;opacity:0;border-radius:10px;-webkit-transition:all .4s ease;-moz-transition:all .4s ease;transition:all .4s ease}.jp-card .jp-card-back:after,.jp-card .jp-card-front:after{content:\" \";display:block}.jp-card .jp-card-back .jp-card-display,.jp-card .jp-card-front .jp-card-display{color:#fff;font-weight:400;opacity:.5;-webkit-transition:opacity .4s linear;-moz-transition:opacity .4s linear;transition:opacity .4s linear}.jp-card .jp-card-back .jp-card-display.jp-card-focused,.jp-card .jp-card-front .jp-card-display.jp-card-focused{opacity:1;font-weight:700}.jp-card .jp-card-back .jp-card-cvc,.jp-card .jp-card-front .jp-card-cvc{font-family:Bitstream Vera Sans Mono,Consolas,Courier,monospace;font-size:14px}.jp-card .jp-card-back .jp-card-shiny,.jp-card .jp-card-front .jp-card-shiny{width:50px;height:35px;border-radius:5px;background:#ccc;position:relative}.jp-card .jp-card-back .jp-card-shiny:before,.jp-card .jp-card-front .jp-card-shiny:before{content:\" \";display:block;width:70%;height:60%;border-top-right-radius:5px;border-bottom-right-radius:5px;background:#d9d9d9;position:absolute;top:20%}.jp-card .jp-card-front .jp-card-logo{position:absolute;opacity:0;right:5%;top:8%;-webkit-transition:.4s;-moz-transition:.4s;transition:.4s}.jp-card .jp-card-front .jp-card-lower{width:80%;position:absolute;left:10%;bottom:30px}@media only screen and (max-width:480px){.jp-card .jp-card-front .jp-card-lower{width:90%;left:5%}}.jp-card .jp-card-front .jp-card-lower .jp-card-cvc{visibility:hidden;float:right;position:relative;bottom:5px}.jp-card .jp-card-front .jp-card-lower .jp-card-number{font-family:Bitstream Vera Sans Mono,Consolas,Courier,monospace;font-size:24px;clear:both;margin-bottom:30px}.jp-card .jp-card-front .jp-card-lower .jp-card-expiry{font-family:Bitstream Vera Sans Mono,Consolas,Courier,monospace;letter-spacing:0;position:relative;float:right;width:25%}.jp-card .jp-card-front .jp-card-lower .jp-card-expiry:after,.jp-card .jp-card-front .jp-card-lower .jp-card-expiry:before{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-weight:700;font-size:7px;white-space:pre;display:block;opacity:.5}.jp-card .jp-card-front .jp-card-lower .jp-card-expiry:before{content:attr(data-before);margin-bottom:2px;font-size:7px;text-transform:uppercase}.jp-card .jp-card-front .jp-card-lower .jp-card-expiry:after{position:absolute;content:attr(data-after);text-align:right;right:100%;margin-right:5px;margin-top:2px;bottom:0}.jp-card .jp-card-front .jp-card-lower .jp-card-name{text-transform:uppercase;font-family:Bitstream Vera Sans Mono,Consolas,Courier,monospace;font-size:20px;max-height:45px;position:absolute;bottom:0;width:190px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:horizontal;overflow:hidden;text-overflow:ellipsis}.jp-card .jp-card-back{-webkit-transform:rotateY(180deg);-moz-transform:rotateY(180deg);-ms-transform:rotateY(180deg);-o-transform:rotateY(180deg);transform:rotateY(180deg)}.jp-card .jp-card-back .jp-card-bar{background-color:#444;background-image:-webkit-linear-gradient(#444,#333);background-image:linear-gradient(#444,#333);width:100%;height:20%;position:absolute;top:10%}.jp-card .jp-card-back:after{content:\" \";display:block;background-color:#fff;background-image:-webkit-linear-gradient(#fff,#fff);background-image:linear-gradient(#fff,#fff);width:80%;height:16%;position:absolute;top:40%;left:2%}.jp-card .jp-card-back .jp-card-cvc{position:absolute;top:40%;left:85%;-webkit-transition-delay:.6s;-moz-transition-delay:.6s;transition-delay:.6s}.jp-card .jp-card-back .jp-card-shiny{position:absolute;top:66%;left:2%}.jp-card .jp-card-back .jp-card-shiny:after{content:\"This card has been issued by Jesse Pollak and is licensed for anyone to use anywhere for free. It comes with no warranty. For support issues, please visit: github.com/jessepollak/card.\";position:absolute;left:120%;top:5%;color:#fff;font-size:7px;width:230px;opacity:.5}.jp-card.jp-card-identified{box-shadow:0 0 20px rgba(0,0,0,.3)}.jp-card.jp-card-identified .jp-card-back,.jp-card.jp-card-identified .jp-card-front{background-color:#000;background-color:rgba(0,0,0,.5)}.jp-card.jp-card-identified .jp-card-back:before,.jp-card.jp-card-identified .jp-card-front:before{-webkit-transition:all .4s ease;-moz-transition:all .4s ease;transition:all .4s ease;background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 30% 30%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 70% 70%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 90% 20%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 15% 80%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),-webkit-linear-gradient(-245deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%);background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 30% 30%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 70% 70%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 90% 20%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-radial-gradient(circle at 15% 80%,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),linear-gradient(-25deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%);opacity:1}.jp-card.jp-card-identified .jp-card-back .jp-card-logo,.jp-card.jp-card-identified .jp-card-front .jp-card-logo{box-shadow:0 0 0 2px hsla(0,0%,100%,.3)}.jp-card.jp-card-identified.no-radial-gradient .jp-card-back:before,.jp-card.jp-card-identified.no-radial-gradient .jp-card-front:before{background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),-webkit-linear-gradient(-245deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%);background-image:repeating-linear-gradient(45deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(135deg,hsla(0,0%,100%,.05) 1px,hsla(0,0%,100%,0) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.03) 4px),repeating-linear-gradient(90deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),repeating-linear-gradient(210deg,hsla(0,0%,100%,0) 1px,hsla(0,0%,100%,.03) 2px,hsla(0,0%,100%,.04) 3px,hsla(0,0%,100%,.05) 4px),linear-gradient(-25deg,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.2) 70%,hsla(0,0%,100%,0) 90%)}", ""]);

// exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Generated by CoffeeScript 1.10.0
(function() {
  var Payment, QJ, cardFromNumber, cardFromType, cards, defaultFormat, formatBackCardNumber, formatBackExpiry, formatCardNumber, formatExpiry, formatForwardExpiry, formatForwardSlash, formatMonthExpiry, hasTextSelected, luhnCheck, reFormatCardNumber, restrictCVC, restrictCardNumber, restrictCombinedExpiry, restrictExpiry, restrictMonthExpiry, restrictNumeric, restrictYearExpiry, setCardType,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  QJ = __webpack_require__(12);

  defaultFormat = /(\d{1,4})/g;

  cards = [
    {
      type: 'amex',
      pattern: /^3[47]/,
      format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
      length: [15],
      cvcLength: [4],
      luhn: true
    }, {
      type: 'dankort',
      pattern: /^5019/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'hipercard',
      pattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
      format: defaultFormat,
      length: [14, 15, 16, 17, 18, 19],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'dinersclub',
      pattern: /^(36|38|30[0-5])/,
      format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
      length: [14],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'discover',
      pattern: /^(6011|65|64[4-9]|622)/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'jcb',
      pattern: /^35/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'laser',
      pattern: /^(6706|6771|6709)/,
      format: defaultFormat,
      length: [16, 17, 18, 19],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'maestro',
      pattern: /^(5018|5020|5038|6304|6703|6708|6759|676[1-3])/,
      format: defaultFormat,
      length: [12, 13, 14, 15, 16, 17, 18, 19],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'mastercard',
      pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'unionpay',
      pattern: /^62/,
      format: defaultFormat,
      length: [16, 17, 18, 19],
      cvcLength: [3],
      luhn: false
    }, {
      type: 'visaelectron',
      pattern: /^4(026|17500|405|508|844|91[37])/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'elo',
      pattern: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|4(0[5-9]|3[0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8])|9([2-6][0-9]|7[0-8])|541|700|720|901)|651652|655000|655021)/,
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'visa',
      pattern: /^4/,
      format: defaultFormat,
      length: [13, 16, 19],
      cvcLength: [3],
      luhn: true
    }
  ];

  cardFromNumber = function(num) {
    var card, j, len;
    num = (num + '').replace(/\D/g, '');
    for (j = 0, len = cards.length; j < len; j++) {
      card = cards[j];
      if (card.pattern.test(num)) {
        return card;
      }
    }
  };

  cardFromType = function(type) {
    var card, j, len;
    for (j = 0, len = cards.length; j < len; j++) {
      card = cards[j];
      if (card.type === type) {
        return card;
      }
    }
  };

  luhnCheck = function(num) {
    var digit, digits, j, len, odd, sum;
    odd = true;
    sum = 0;
    digits = (num + '').split('').reverse();
    for (j = 0, len = digits.length; j < len; j++) {
      digit = digits[j];
      digit = parseInt(digit, 10);
      if ((odd = !odd)) {
        digit *= 2;
      }
      if (digit > 9) {
        digit -= 9;
      }
      sum += digit;
    }
    return sum % 10 === 0;
  };

  hasTextSelected = function(target) {
    var e, error, ref;
    try {
      if ((target.selectionStart != null) && target.selectionStart !== target.selectionEnd) {
        return true;
      }
      if ((typeof document !== "undefined" && document !== null ? (ref = document.selection) != null ? ref.createRange : void 0 : void 0) != null) {
        if (document.selection.createRange().text) {
          return true;
        }
      }
    } catch (error) {
      e = error;
    }
    return false;
  };

  reFormatCardNumber = function(e) {
    return setTimeout((function(_this) {
      return function() {
        var target, value;
        target = e.target;
        value = QJ.val(target);
        value = Payment.fns.formatCardNumber(value);
        QJ.val(target, value);
        return QJ.trigger(target, 'change');
      };
    })(this));
  };

  formatCardNumber = function(maxLength) {
    return function(e) {
      var card, digit, i, j, len, length, re, target, upperLength, upperLengths, value;
      digit = String.fromCharCode(e.which);
      if (!/^\d+$/.test(digit)) {
        return;
      }
      target = e.target;
      value = QJ.val(target);
      card = cardFromNumber(value + digit);
      length = (value.replace(/\D/g, '') + digit).length;
      upperLengths = [16];
      if (card) {
        upperLengths = card.length;
      }
      if (maxLength) {
        upperLengths = upperLengths.filter(function(x) {
          return x <= maxLength;
        });
      }
      for (i = j = 0, len = upperLengths.length; j < len; i = ++j) {
        upperLength = upperLengths[i];
        if (length >= upperLength && upperLengths[i + 1]) {
          continue;
        }
        if (length >= upperLength) {
          return;
        }
      }
      if (hasTextSelected(target)) {
        return;
      }
      if (card && card.type === 'amex') {
        re = /^(\d{4}|\d{4}\s\d{6})$/;
      } else {
        re = /(?:^|\s)(\d{4})$/;
      }
      if (re.test(value)) {
        e.preventDefault();
        QJ.val(target, value + ' ' + digit);
        return QJ.trigger(target, 'change');
      }
    };
  };

  formatBackCardNumber = function(e) {
    var target, value;
    target = e.target;
    value = QJ.val(target);
    if (e.meta) {
      return;
    }
    if (e.which !== 8) {
      return;
    }
    if (hasTextSelected(target)) {
      return;
    }
    if (/\d\s$/.test(value)) {
      e.preventDefault();
      QJ.val(target, value.replace(/\d\s$/, ''));
      return QJ.trigger(target, 'change');
    } else if (/\s\d?$/.test(value)) {
      e.preventDefault();
      QJ.val(target, value.replace(/\s\d?$/, ''));
      return QJ.trigger(target, 'change');
    }
  };

  formatExpiry = function(e) {
    var digit, target, val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    target = e.target;
    val = QJ.val(target) + digit;
    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
      e.preventDefault();
      QJ.val(target, "0" + val + " / ");
      return QJ.trigger(target, 'change');
    } else if (/^\d\d$/.test(val)) {
      e.preventDefault();
      QJ.val(target, val + " / ");
      return QJ.trigger(target, 'change');
    }
  };

  formatMonthExpiry = function(e) {
    var digit, target, val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    target = e.target;
    val = QJ.val(target) + digit;
    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
      e.preventDefault();
      QJ.val(target, "0" + val);
      return QJ.trigger(target, 'change');
    } else if (/^\d\d$/.test(val)) {
      e.preventDefault();
      QJ.val(target, "" + val);
      return QJ.trigger(target, 'change');
    }
  };

  formatForwardExpiry = function(e) {
    var digit, target, val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    target = e.target;
    val = QJ.val(target);
    if (/^\d\d$/.test(val)) {
      QJ.val(target, val + " / ");
      return QJ.trigger(target, 'change');
    }
  };

  formatForwardSlash = function(e) {
    var slash, target, val;
    slash = String.fromCharCode(e.which);
    if (slash !== '/') {
      return;
    }
    target = e.target;
    val = QJ.val(target);
    if (/^\d$/.test(val) && val !== '0') {
      QJ.val(target, "0" + val + " / ");
      return QJ.trigger(target, 'change');
    }
  };

  formatBackExpiry = function(e) {
    var target, value;
    if (e.metaKey) {
      return;
    }
    target = e.target;
    value = QJ.val(target);
    if (e.which !== 8) {
      return;
    }
    if (hasTextSelected(target)) {
      return;
    }
    if (/\d(\s|\/)+$/.test(value)) {
      e.preventDefault();
      QJ.val(target, value.replace(/\d(\s|\/)*$/, ''));
      return QJ.trigger(target, 'change');
    } else if (/\s\/\s?\d?$/.test(value)) {
      e.preventDefault();
      QJ.val(target, value.replace(/\s\/\s?\d?$/, ''));
      return QJ.trigger(target, 'change');
    }
  };

  restrictNumeric = function(e) {
    var input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return e.preventDefault();
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    if (!/[\d\s]/.test(input)) {
      return e.preventDefault();
    }
  };

  restrictCardNumber = function(maxLength) {
    return function(e) {
      var card, digit, length, target, value;
      target = e.target;
      digit = String.fromCharCode(e.which);
      if (!/^\d+$/.test(digit)) {
        return;
      }
      if (hasTextSelected(target)) {
        return;
      }
      value = (QJ.val(target) + digit).replace(/\D/g, '');
      card = cardFromNumber(value);
      length = 16;
      if (card) {
        length = card.length[card.length.length - 1];
      }
      if (maxLength) {
        length = Math.min(length, maxLength);
      }
      if (!(value.length <= length)) {
        return e.preventDefault();
      }
    };
  };

  restrictExpiry = function(e, length) {
    var digit, target, value;
    target = e.target;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    if (hasTextSelected(target)) {
      return;
    }
    value = QJ.val(target) + digit;
    value = value.replace(/\D/g, '');
    if (value.length > length) {
      return e.preventDefault();
    }
  };

  restrictCombinedExpiry = function(e) {
    return restrictExpiry(e, 6);
  };

  restrictMonthExpiry = function(e) {
    return restrictExpiry(e, 2);
  };

  restrictYearExpiry = function(e) {
    return restrictExpiry(e, 4);
  };

  restrictCVC = function(e) {
    var digit, target, val;
    target = e.target;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    if (hasTextSelected(target)) {
      return;
    }
    val = QJ.val(target) + digit;
    if (!(val.length <= 4)) {
      return e.preventDefault();
    }
  };

  setCardType = function(e) {
    var allTypes, card, cardType, target, val;
    target = e.target;
    val = QJ.val(target);
    cardType = Payment.fns.cardType(val) || 'unknown';
    if (!QJ.hasClass(target, cardType)) {
      allTypes = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = cards.length; j < len; j++) {
          card = cards[j];
          results.push(card.type);
        }
        return results;
      })();
      QJ.removeClass(target, 'unknown');
      QJ.removeClass(target, allTypes.join(' '));
      QJ.addClass(target, cardType);
      QJ.toggleClass(target, 'identified', cardType !== 'unknown');
      return QJ.trigger(target, 'payment.cardType', cardType);
    }
  };

  Payment = (function() {
    function Payment() {}

    Payment.fns = {
      cardExpiryVal: function(value) {
        var month, prefix, ref, year;
        value = value.replace(/\s/g, '');
        ref = value.split('/', 2), month = ref[0], year = ref[1];
        if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
          prefix = (new Date).getFullYear();
          prefix = prefix.toString().slice(0, 2);
          year = prefix + year;
        }
        month = parseInt(month, 10);
        year = parseInt(year, 10);
        return {
          month: month,
          year: year
        };
      },
      validateCardNumber: function(num) {
        var card, ref;
        num = (num + '').replace(/\s+|-/g, '');
        if (!/^\d+$/.test(num)) {
          return false;
        }
        card = cardFromNumber(num);
        if (!card) {
          return false;
        }
        return (ref = num.length, indexOf.call(card.length, ref) >= 0) && (card.luhn === false || luhnCheck(num));
      },
      validateCardExpiry: function(month, year) {
        var currentTime, expiry, prefix, ref, ref1;
        if (typeof month === 'object' && 'month' in month) {
          ref = month, month = ref.month, year = ref.year;
        } else if (typeof month === 'string' && indexOf.call(month, '/') >= 0) {
          ref1 = Payment.fns.cardExpiryVal(month), month = ref1.month, year = ref1.year;
        }
        if (!(month && year)) {
          return false;
        }
        month = QJ.trim(month);
        year = QJ.trim(year);
        if (!/^\d+$/.test(month)) {
          return false;
        }
        if (!/^\d+$/.test(year)) {
          return false;
        }
        month = parseInt(month, 10);
        if (!(month && month <= 12)) {
          return false;
        }
        if (year.length === 2) {
          prefix = (new Date).getFullYear();
          prefix = prefix.toString().slice(0, 2);
          year = prefix + year;
        }
        expiry = new Date(year, month);
        currentTime = new Date;
        expiry.setMonth(expiry.getMonth() - 1);
        expiry.setMonth(expiry.getMonth() + 1, 1);
        return expiry > currentTime;
      },
      validateCardCVC: function(cvc, type) {
        var ref, ref1;
        cvc = QJ.trim(cvc);
        if (!/^\d+$/.test(cvc)) {
          return false;
        }
        if (type && cardFromType(type)) {
          return ref = cvc.length, indexOf.call((ref1 = cardFromType(type)) != null ? ref1.cvcLength : void 0, ref) >= 0;
        } else {
          return cvc.length >= 3 && cvc.length <= 4;
        }
      },
      cardType: function(num) {
        var ref;
        if (!num) {
          return null;
        }
        return ((ref = cardFromNumber(num)) != null ? ref.type : void 0) || null;
      },
      formatCardNumber: function(num) {
        var card, groups, ref, upperLength;
        card = cardFromNumber(num);
        if (!card) {
          return num;
        }
        upperLength = card.length[card.length.length - 1];
        num = num.replace(/\D/g, '');
        num = num.slice(0, upperLength);
        if (card.format.global) {
          return (ref = num.match(card.format)) != null ? ref.join(' ') : void 0;
        } else {
          groups = card.format.exec(num);
          if (groups == null) {
            return;
          }
          groups.shift();
          groups = groups.filter(function(n) {
            return n;
          });
          return groups.join(' ');
        }
      }
    };

    Payment.restrictNumeric = function(el) {
      return QJ.on(el, 'keypress', restrictNumeric);
    };

    Payment.cardExpiryVal = function(el) {
      return Payment.fns.cardExpiryVal(QJ.val(el));
    };

    Payment.formatCardCVC = function(el) {
      Payment.restrictNumeric(el);
      QJ.on(el, 'keypress', restrictCVC);
      return el;
    };

    Payment.formatCardExpiry = function(el) {
      var month, year;
      Payment.restrictNumeric(el);
      if (el.length && el.length === 2) {
        month = el[0], year = el[1];
        this.formatCardExpiryMultiple(month, year);
      } else {
        QJ.on(el, 'keypress', restrictCombinedExpiry);
        QJ.on(el, 'keypress', formatExpiry);
        QJ.on(el, 'keypress', formatForwardSlash);
        QJ.on(el, 'keypress', formatForwardExpiry);
        QJ.on(el, 'keydown', formatBackExpiry);
      }
      return el;
    };

    Payment.formatCardExpiryMultiple = function(month, year) {
      QJ.on(month, 'keypress', restrictMonthExpiry);
      QJ.on(month, 'keypress', formatMonthExpiry);
      return QJ.on(year, 'keypress', restrictYearExpiry);
    };

    Payment.formatCardNumber = function(el, maxLength) {
      Payment.restrictNumeric(el);
      QJ.on(el, 'keypress', restrictCardNumber(maxLength));
      QJ.on(el, 'keypress', formatCardNumber(maxLength));
      QJ.on(el, 'keydown', formatBackCardNumber);
      QJ.on(el, 'keyup blur', setCardType);
      QJ.on(el, 'paste', reFormatCardNumber);
      QJ.on(el, 'input', reFormatCardNumber);
      return el;
    };

    Payment.getCardArray = function() {
      return cards;
    };

    Payment.setCardArray = function(cardArray) {
      cards = cardArray;
      return true;
    };

    Payment.addToCardArray = function(cardObject) {
      return cards.push(cardObject);
    };

    Payment.removeFromCardArray = function(type) {
      var key, value;
      for (key in cards) {
        value = cards[key];
        if (value.type === type) {
          cards.splice(key, 1);
        }
      }
      return true;
    };

    return Payment;

  })();

  module.exports = Payment;

  global.Payment = Payment;

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(54);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * node.extend
 * Copyright 2011, John Resig
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * @fileoverview
 * Port of jQuery.extend that actually works on node.js
 */
var is = __webpack_require__(55);

var extend = function extend() {
  var target = arguments[0] || {};
  var i = 1;
  var length = arguments.length;
  var deep = false;
  var options, name, src, copy, copyIsArray, clone;

  // Handle a deep copy situation
  if (typeof target === 'boolean') {
    deep = target;
    target = arguments[1] || {};
    // skip the boolean and the target
    i = 2;
  }

  // Handle case when target is a string or something (possible in deep copy)
  if (typeof target !== 'object' && !is.fn(target)) {
    target = {};
  }

  for (; i < length; i++) {
    // Only deal with non-null/undefined values
    options = arguments[i];
    if (options != null) {
      if (typeof options === 'string') {
        options = options.split('');
      }
      // Extend the base object
      for (name in options) {
        src = target[name];
        copy = options[name];

        // Prevent never-ending loop
        if (target === copy) {
          continue;
        }

        // Recurse if we're merging plain objects or arrays
        if (deep && copy && (is.hash(copy) || (copyIsArray = is.array(copy)))) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && is.array(src) ? src : [];
          } else {
            clone = src && is.hash(src) ? src : {};
          }

          // Never move original objects, clone them
          target[name] = extend(deep, clone, copy);

        // Don't bring in undefined values
        } else if (typeof copy !== 'undefined') {
          target[name] = copy;
        }
      }
    }
  }

  // Return the modified object
  return target;
};

/**
 * @public
 */
extend.version = '1.1.3';

/**
 * Exports module.
 */
module.exports = extend;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* globals window, HTMLElement */



/**!
 * is
 * the definitive JavaScript type testing library
 *
 * @copyright 2013-2014 Enrico Marino / Jordan Harband
 * @license MIT
 */

var objProto = Object.prototype;
var owns = objProto.hasOwnProperty;
var toStr = objProto.toString;
var symbolValueOf;
if (typeof Symbol === 'function') {
  symbolValueOf = Symbol.prototype.valueOf;
}
var isActualNaN = function (value) {
  return value !== value;
};
var NON_HOST_TYPES = {
  'boolean': 1,
  number: 1,
  string: 1,
  undefined: 1
};

var base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
var hexRegex = /^[A-Fa-f0-9]+$/;

/**
 * Expose `is`
 */

var is = {};

/**
 * Test general.
 */

/**
 * is.type
 * Test if `value` is a type of `type`.
 *
 * @param {Mixed} value value to test
 * @param {String} type type
 * @return {Boolean} true if `value` is a type of `type`, false otherwise
 * @api public
 */

is.a = is.type = function (value, type) {
  return typeof value === type;
};

/**
 * is.defined
 * Test if `value` is defined.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if 'value' is defined, false otherwise
 * @api public
 */

is.defined = function (value) {
  return typeof value !== 'undefined';
};

/**
 * is.empty
 * Test if `value` is empty.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is empty, false otherwise
 * @api public
 */

is.empty = function (value) {
  var type = toStr.call(value);
  var key;

  if (type === '[object Array]' || type === '[object Arguments]' || type === '[object String]') {
    return value.length === 0;
  }

  if (type === '[object Object]') {
    for (key in value) {
      if (owns.call(value, key)) {
        return false;
      }
    }
    return true;
  }

  return !value;
};

/**
 * is.equal
 * Test if `value` is equal to `other`.
 *
 * @param {Mixed} value value to test
 * @param {Mixed} other value to compare with
 * @return {Boolean} true if `value` is equal to `other`, false otherwise
 */

is.equal = function equal(value, other) {
  if (value === other) {
    return true;
  }

  var type = toStr.call(value);
  var key;

  if (type !== toStr.call(other)) {
    return false;
  }

  if (type === '[object Object]') {
    for (key in value) {
      if (!is.equal(value[key], other[key]) || !(key in other)) {
        return false;
      }
    }
    for (key in other) {
      if (!is.equal(value[key], other[key]) || !(key in value)) {
        return false;
      }
    }
    return true;
  }

  if (type === '[object Array]') {
    key = value.length;
    if (key !== other.length) {
      return false;
    }
    while (key--) {
      if (!is.equal(value[key], other[key])) {
        return false;
      }
    }
    return true;
  }

  if (type === '[object Function]') {
    return value.prototype === other.prototype;
  }

  if (type === '[object Date]') {
    return value.getTime() === other.getTime();
  }

  return false;
};

/**
 * is.hosted
 * Test if `value` is hosted by `host`.
 *
 * @param {Mixed} value to test
 * @param {Mixed} host host to test with
 * @return {Boolean} true if `value` is hosted by `host`, false otherwise
 * @api public
 */

is.hosted = function (value, host) {
  var type = typeof host[value];
  return type === 'object' ? !!host[value] : !NON_HOST_TYPES[type];
};

/**
 * is.instance
 * Test if `value` is an instance of `constructor`.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is an instance of `constructor`
 * @api public
 */

is.instance = is['instanceof'] = function (value, constructor) {
  return value instanceof constructor;
};

/**
 * is.nil / is.null
 * Test if `value` is null.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is null, false otherwise
 * @api public
 */

is.nil = is['null'] = function (value) {
  return value === null;
};

/**
 * is.undef / is.undefined
 * Test if `value` is undefined.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is undefined, false otherwise
 * @api public
 */

is.undef = is.undefined = function (value) {
  return typeof value === 'undefined';
};

/**
 * Test arguments.
 */

/**
 * is.args
 * Test if `value` is an arguments object.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is an arguments object, false otherwise
 * @api public
 */

is.args = is.arguments = function (value) {
  var isStandardArguments = toStr.call(value) === '[object Arguments]';
  var isOldArguments = !is.array(value) && is.arraylike(value) && is.object(value) && is.fn(value.callee);
  return isStandardArguments || isOldArguments;
};

/**
 * Test array.
 */

/**
 * is.array
 * Test if 'value' is an array.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is an array, false otherwise
 * @api public
 */

is.array = Array.isArray || function (value) {
  return toStr.call(value) === '[object Array]';
};

/**
 * is.arguments.empty
 * Test if `value` is an empty arguments object.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is an empty arguments object, false otherwise
 * @api public
 */
is.args.empty = function (value) {
  return is.args(value) && value.length === 0;
};

/**
 * is.array.empty
 * Test if `value` is an empty array.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is an empty array, false otherwise
 * @api public
 */
is.array.empty = function (value) {
  return is.array(value) && value.length === 0;
};

/**
 * is.arraylike
 * Test if `value` is an arraylike object.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is an arguments object, false otherwise
 * @api public
 */

is.arraylike = function (value) {
  return !!value && !is.bool(value)
    && owns.call(value, 'length')
    && isFinite(value.length)
    && is.number(value.length)
    && value.length >= 0;
};

/**
 * Test boolean.
 */

/**
 * is.bool
 * Test if `value` is a boolean.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is a boolean, false otherwise
 * @api public
 */

is.bool = is['boolean'] = function (value) {
  return toStr.call(value) === '[object Boolean]';
};

/**
 * is.false
 * Test if `value` is false.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is false, false otherwise
 * @api public
 */

is['false'] = function (value) {
  return is.bool(value) && Boolean(Number(value)) === false;
};

/**
 * is.true
 * Test if `value` is true.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is true, false otherwise
 * @api public
 */

is['true'] = function (value) {
  return is.bool(value) && Boolean(Number(value)) === true;
};

/**
 * Test date.
 */

/**
 * is.date
 * Test if `value` is a date.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is a date, false otherwise
 * @api public
 */

is.date = function (value) {
  return toStr.call(value) === '[object Date]';
};

/**
 * is.date.valid
 * Test if `value` is a valid date.
 *
 * @param {Mixed} value value to test
 * @returns {Boolean} true if `value` is a valid date, false otherwise
 */
is.date.valid = function (value) {
  return is.date(value) && !isNaN(Number(value));
};

/**
 * Test element.
 */

/**
 * is.element
 * Test if `value` is an html element.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is an HTML Element, false otherwise
 * @api public
 */

is.element = function (value) {
  return value !== undefined
    && typeof HTMLElement !== 'undefined'
    && value instanceof HTMLElement
    && value.nodeType === 1;
};

/**
 * Test error.
 */

/**
 * is.error
 * Test if `value` is an error object.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is an error object, false otherwise
 * @api public
 */

is.error = function (value) {
  return toStr.call(value) === '[object Error]';
};

/**
 * Test function.
 */

/**
 * is.fn / is.function (deprecated)
 * Test if `value` is a function.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is a function, false otherwise
 * @api public
 */

is.fn = is['function'] = function (value) {
  var isAlert = typeof window !== 'undefined' && value === window.alert;
  if (isAlert) {
    return true;
  }
  var str = toStr.call(value);
  return str === '[object Function]' || str === '[object GeneratorFunction]' || str === '[object AsyncFunction]';
};

/**
 * Test number.
 */

/**
 * is.number
 * Test if `value` is a number.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is a number, false otherwise
 * @api public
 */

is.number = function (value) {
  return toStr.call(value) === '[object Number]';
};

/**
 * is.infinite
 * Test if `value` is positive or negative infinity.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is positive or negative Infinity, false otherwise
 * @api public
 */
is.infinite = function (value) {
  return value === Infinity || value === -Infinity;
};

/**
 * is.decimal
 * Test if `value` is a decimal number.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is a decimal number, false otherwise
 * @api public
 */

is.decimal = function (value) {
  return is.number(value) && !isActualNaN(value) && !is.infinite(value) && value % 1 !== 0;
};

/**
 * is.divisibleBy
 * Test if `value` is divisible by `n`.
 *
 * @param {Number} value value to test
 * @param {Number} n dividend
 * @return {Boolean} true if `value` is divisible by `n`, false otherwise
 * @api public
 */

is.divisibleBy = function (value, n) {
  var isDividendInfinite = is.infinite(value);
  var isDivisorInfinite = is.infinite(n);
  var isNonZeroNumber = is.number(value) && !isActualNaN(value) && is.number(n) && !isActualNaN(n) && n !== 0;
  return isDividendInfinite || isDivisorInfinite || (isNonZeroNumber && value % n === 0);
};

/**
 * is.integer
 * Test if `value` is an integer.
 *
 * @param value to test
 * @return {Boolean} true if `value` is an integer, false otherwise
 * @api public
 */

is.integer = is['int'] = function (value) {
  return is.number(value) && !isActualNaN(value) && value % 1 === 0;
};

/**
 * is.maximum
 * Test if `value` is greater than 'others' values.
 *
 * @param {Number} value value to test
 * @param {Array} others values to compare with
 * @return {Boolean} true if `value` is greater than `others` values
 * @api public
 */

is.maximum = function (value, others) {
  if (isActualNaN(value)) {
    throw new TypeError('NaN is not a valid value');
  } else if (!is.arraylike(others)) {
    throw new TypeError('second argument must be array-like');
  }
  var len = others.length;

  while (--len >= 0) {
    if (value < others[len]) {
      return false;
    }
  }

  return true;
};

/**
 * is.minimum
 * Test if `value` is less than `others` values.
 *
 * @param {Number} value value to test
 * @param {Array} others values to compare with
 * @return {Boolean} true if `value` is less than `others` values
 * @api public
 */

is.minimum = function (value, others) {
  if (isActualNaN(value)) {
    throw new TypeError('NaN is not a valid value');
  } else if (!is.arraylike(others)) {
    throw new TypeError('second argument must be array-like');
  }
  var len = others.length;

  while (--len >= 0) {
    if (value > others[len]) {
      return false;
    }
  }

  return true;
};

/**
 * is.nan
 * Test if `value` is not a number.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is not a number, false otherwise
 * @api public
 */

is.nan = function (value) {
  return !is.number(value) || value !== value;
};

/**
 * is.even
 * Test if `value` is an even number.
 *
 * @param {Number} value value to test
 * @return {Boolean} true if `value` is an even number, false otherwise
 * @api public
 */

is.even = function (value) {
  return is.infinite(value) || (is.number(value) && value === value && value % 2 === 0);
};

/**
 * is.odd
 * Test if `value` is an odd number.
 *
 * @param {Number} value value to test
 * @return {Boolean} true if `value` is an odd number, false otherwise
 * @api public
 */

is.odd = function (value) {
  return is.infinite(value) || (is.number(value) && value === value && value % 2 !== 0);
};

/**
 * is.ge
 * Test if `value` is greater than or equal to `other`.
 *
 * @param {Number} value value to test
 * @param {Number} other value to compare with
 * @return {Boolean}
 * @api public
 */

is.ge = function (value, other) {
  if (isActualNaN(value) || isActualNaN(other)) {
    throw new TypeError('NaN is not a valid value');
  }
  return !is.infinite(value) && !is.infinite(other) && value >= other;
};

/**
 * is.gt
 * Test if `value` is greater than `other`.
 *
 * @param {Number} value value to test
 * @param {Number} other value to compare with
 * @return {Boolean}
 * @api public
 */

is.gt = function (value, other) {
  if (isActualNaN(value) || isActualNaN(other)) {
    throw new TypeError('NaN is not a valid value');
  }
  return !is.infinite(value) && !is.infinite(other) && value > other;
};

/**
 * is.le
 * Test if `value` is less than or equal to `other`.
 *
 * @param {Number} value value to test
 * @param {Number} other value to compare with
 * @return {Boolean} if 'value' is less than or equal to 'other'
 * @api public
 */

is.le = function (value, other) {
  if (isActualNaN(value) || isActualNaN(other)) {
    throw new TypeError('NaN is not a valid value');
  }
  return !is.infinite(value) && !is.infinite(other) && value <= other;
};

/**
 * is.lt
 * Test if `value` is less than `other`.
 *
 * @param {Number} value value to test
 * @param {Number} other value to compare with
 * @return {Boolean} if `value` is less than `other`
 * @api public
 */

is.lt = function (value, other) {
  if (isActualNaN(value) || isActualNaN(other)) {
    throw new TypeError('NaN is not a valid value');
  }
  return !is.infinite(value) && !is.infinite(other) && value < other;
};

/**
 * is.within
 * Test if `value` is within `start` and `finish`.
 *
 * @param {Number} value value to test
 * @param {Number} start lower bound
 * @param {Number} finish upper bound
 * @return {Boolean} true if 'value' is is within 'start' and 'finish'
 * @api public
 */
is.within = function (value, start, finish) {
  if (isActualNaN(value) || isActualNaN(start) || isActualNaN(finish)) {
    throw new TypeError('NaN is not a valid value');
  } else if (!is.number(value) || !is.number(start) || !is.number(finish)) {
    throw new TypeError('all arguments must be numbers');
  }
  var isAnyInfinite = is.infinite(value) || is.infinite(start) || is.infinite(finish);
  return isAnyInfinite || (value >= start && value <= finish);
};

/**
 * Test object.
 */

/**
 * is.object
 * Test if `value` is an object.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is an object, false otherwise
 * @api public
 */
is.object = function (value) {
  return toStr.call(value) === '[object Object]';
};

/**
 * is.primitive
 * Test if `value` is a primitive.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is a primitive, false otherwise
 * @api public
 */
is.primitive = function isPrimitive(value) {
  if (!value) {
    return true;
  }
  if (typeof value === 'object' || is.object(value) || is.fn(value) || is.array(value)) {
    return false;
  }
  return true;
};

/**
 * is.hash
 * Test if `value` is a hash - a plain object literal.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is a hash, false otherwise
 * @api public
 */

is.hash = function (value) {
  return is.object(value) && value.constructor === Object && !value.nodeType && !value.setInterval;
};

/**
 * Test regexp.
 */

/**
 * is.regexp
 * Test if `value` is a regular expression.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is a regexp, false otherwise
 * @api public
 */

is.regexp = function (value) {
  return toStr.call(value) === '[object RegExp]';
};

/**
 * Test string.
 */

/**
 * is.string
 * Test if `value` is a string.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if 'value' is a string, false otherwise
 * @api public
 */

is.string = function (value) {
  return toStr.call(value) === '[object String]';
};

/**
 * Test base64 string.
 */

/**
 * is.base64
 * Test if `value` is a valid base64 encoded string.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if 'value' is a base64 encoded string, false otherwise
 * @api public
 */

is.base64 = function (value) {
  return is.string(value) && (!value.length || base64Regex.test(value));
};

/**
 * Test base64 string.
 */

/**
 * is.hex
 * Test if `value` is a valid hex encoded string.
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if 'value' is a hex encoded string, false otherwise
 * @api public
 */

is.hex = function (value) {
  return is.string(value) && (!value.length || hexRegex.test(value));
};

/**
 * is.symbol
 * Test if `value` is an ES6 Symbol
 *
 * @param {Mixed} value value to test
 * @return {Boolean} true if `value` is a Symbol, false otherise
 * @api public
 */

is.symbol = function (value) {
  return typeof Symbol === 'function' && toStr.call(value) === '[object Symbol]' && typeof symbolValueOf.call(value) === 'symbol';
};

module.exports = is;


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export install */
/* unused harmony export use */
/* unused harmony export directive */
/* unused harmony export mixin */
/* unused harmony export mapFields */
/* unused harmony export Validator */
/* unused harmony export ErrorBag */
/* unused harmony export Rules */
/* unused harmony export ErrorComponent */
/* unused harmony export version */
/**
  * vee-validate v2.1.0-beta.8
  * (c) 2018 Abdelrahman Awad
  * @license MIT
  */
// 

var supportsPassive = true;

var detectPassiveSupport = function () {
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get () {
        supportsPassive = true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {
    supportsPassive = false;
  }
  return supportsPassive;
};

var addEventListener = function (el, eventName, cb) {
  el.addEventListener(eventName, cb, supportsPassive ? { passive: true } : false);
};

var isTextInput = function (el) {
  return includes(['text', 'password', 'search', 'email', 'tel', 'url', 'textarea'], el.type);
};

var isCheckboxOrRadioInput = function (el) {
  return includes(['radio', 'checkbox'], el.type);
};

var isDateInput = function (el) {
  return includes(['date', 'week', 'month', 'datetime-local', 'time'], el.type);
};

/**
 * Gets the data attribute. the name must be kebab-case.
 */
var getDataAttribute = function (el, name) { return el.getAttribute(("data-vv-" + name)); };

/**
 * Checks if the values are either null or undefined.
 */
var isNullOrUndefined = function () {
  var values = [], len = arguments.length;
  while ( len-- ) values[ len ] = arguments[ len ];

  return values.every(function (value) {
    return value === null || value === undefined;
  });
};

/**
 * Creates the default flags object.
 */
var createFlags = function () { return ({
  untouched: true,
  touched: false,
  dirty: false,
  pristine: true,
  valid: null,
  invalid: null,
  validated: false,
  pending: false,
  required: false,
  changed: false
}); };

/**
 * Shallow object comparison.
 */
var isEqual = function (lhs, rhs) {
  if (lhs instanceof RegExp && rhs instanceof RegExp) {
    return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
  }

  if (Array.isArray(lhs) && Array.isArray(rhs)) {
    if (lhs.length !== rhs.length) { return false; }

    for (var i = 0; i < lhs.length; i++) {
      if (!isEqual(lhs[i], rhs[i])) {
        return false;
      }
    }

    return true;
  }

  // if both are objects, compare each key recursively.
  if (isObject(lhs) && isObject(rhs)) {
    return Object.keys(lhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    }) && Object.keys(rhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    });
  }

  return lhs === rhs;
};

/**
 * Determines the input field scope.
 */
var getScope = function (el) {
  var scope = getDataAttribute(el, 'scope');
  if (isNullOrUndefined(scope)) {
    var form = getForm(el);

    if (form) {
      scope = getDataAttribute(form, 'scope');
    }
  }

  return !isNullOrUndefined(scope) ? scope : null;
};

/**
 * Get the closest form element.
 */
var getForm = function (el) {
  if (isNullOrUndefined(el)) { return null; }

  if (el.tagName === 'FORM') { return el; }

  if (!isNullOrUndefined(el.form)) { return el.form; }

  return !isNullOrUndefined(el.parentNode) ? getForm(el.parentNode) : null;
};

/**
 * Gets the value in an object safely.
 */
var getPath = function (path, target, def) {
  if ( def === void 0 ) def = undefined;

  if (!path || !target) { return def; }

  var value = target;
  path.split('.').every(function (prop) {
    if (prop in value) {
      value = value[prop];

      return true;
    }

    value = def;

    return false;
  });

  return value;
};

/**
 * Checks if path exists within an object.
 */
var hasPath = function (path, target) {
  var obj = target;
  return path.split('.').every(function (prop) {
    if (prop in obj) {
      obj = obj[prop];

      return true;
    }

    return false;
  });
};

/**
 * Parses a rule string expression.
 */
var parseRule = function (rule) {
  var params = [];
  var name = rule.split(':')[0];

  if (includes(rule, ':')) {
    params = rule.split(':').slice(1).join(':').split(',');
  }

  return { name: name, params: params };
};

/**
 * Debounces a function.
 */
var debounce = function (fn, wait, immediate, token) {
  if ( wait === void 0 ) wait = 0;
  if ( immediate === void 0 ) immediate = false;
  if ( token === void 0 ) token = { cancelled: false };

  if (wait === 0) {
    return fn;
  }

  var timeout;

  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var later = function () {
      timeout = null;

      if (!immediate && !token.cancelled) { fn.apply(void 0, args); }
    };
    /* istanbul ignore next */
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    /* istanbul ignore next */
    if (callNow) { fn.apply(void 0, args); }
  };
};

/**
 * Appends a rule definition to a list of rules.
 */
var appendRule = function (rule, rules) {
  if (!rules) {
    return rule;
  }

  if (!rule) {
    return rules;
  }

  if (typeof rules === 'string') {
    return (rules + "|" + rule);
  }

  return assign({}, rules, normalizeRules(rule));
};

/**
 * Normalizes the given rules expression.
 */
var normalizeRules = function (rules) {
  // if falsy value return an empty object.
  if (!rules) {
    return {};
  }

  if (isObject(rules)) {
    // $FlowFixMe
    return Object.keys(rules).reduce(function (prev, curr) {
      var params = [];
      // $FlowFixMe
      if (rules[curr] === true) {
        params = [];
      } else if (Array.isArray(rules[curr])) {
        params = rules[curr];
      } else {
        params = [rules[curr]];
      }

      // $FlowFixMe
      if (rules[curr] !== false) {
        prev[curr] = params;
      }

      return prev;
    }, {});
  }

  if (typeof rules !== 'string') {
    warn('rules must be either a string or an object.');
    return {};
  }

  return rules.split('|').reduce(function (prev, rule) {
    var parsedRule = parseRule(rule);
    if (!parsedRule.name) {
      return prev;
    }

    prev[parsedRule.name] = parsedRule.params;
    return prev;
  }, {});
};

/**
 * Emits a warning to the console.
 */
var warn = function (message) {
  console.warn(("[vee-validate] " + message)); // eslint-disable-line
};

/**
 * Creates a branded error object.
 */
var createError = function (message) { return new Error(("[vee-validate] " + message)); };

/**
 * Checks if the value is an object.
 */
var isObject = function (obj) { return obj !== null && obj && typeof obj === 'object' && ! Array.isArray(obj); };

/**
 * Checks if a function is callable.
 */
var isCallable = function (func) { return typeof func === 'function'; };

/**
 * Check if element has the css class on it.
 */
var hasClass = function (el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  }

  return !!el.className.match(new RegExp(("(\\s|^)" + className + "(\\s|$)")));
};

/**
 * Adds the provided css className to the element.
 */
var addClass = function (el, className) {
  if (el.classList) {
    el.classList.add(className);
    return;
  }

  if (!hasClass(el, className)) {
    el.className += " " + className;
  }
};

/**
 * Remove the provided css className from the element.
 */
var removeClass = function (el, className) {
  if (el.classList) {
    el.classList.remove(className);
    return;
  }

  if (hasClass(el, className)) {
    var reg = new RegExp(("(\\s|^)" + className + "(\\s|$)"));
    el.className = el.className.replace(reg, ' ');
  }
};

/**
 * Adds or removes a class name on the input depending on the status flag.
 */
var toggleClass = function (el, className, status) {
  if (!el || !className) { return; }

  if (Array.isArray(className)) {
    className.forEach(function (item) { return toggleClass(el, item, status); });
    return;
  }

  if (status) {
    return addClass(el, className);
  }

  removeClass(el, className);
};

/**
 * Converts an array-like object to array, provides a simple polyfill for Array.from
 */
var toArray = function (arrayLike) {
  if (isCallable(Array.from)) {
    return Array.from(arrayLike);
  }

  var array = [];
  var length = arrayLike.length;
  /* istanbul ignore next */
  for (var i = 0; i < length; i++) {
    array.push(arrayLike[i]);
  }

  /* istanbul ignore next */
  return array;
};

/**
 * Assign polyfill from the mdn.
 */
var assign = function (target) {
  var others = [], len = arguments.length - 1;
  while ( len-- > 0 ) others[ len ] = arguments[ len + 1 ];

  /* istanbul ignore else */
  if (isCallable(Object.assign)) {
    return Object.assign.apply(Object, [ target ].concat( others ));
  }

  /* istanbul ignore next */
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  /* istanbul ignore next */
  var to = Object(target);
  /* istanbul ignore next */
  others.forEach(function (arg) {
    // Skip over if undefined or null
    if (arg != null) {
      Object.keys(arg).forEach(function (key) {
        to[key] = arg[key];
      });
    }
  });
  /* istanbul ignore next */
  return to;
};

var id = 0;
var idTemplate = '{id}';

/**
 * Generates a unique id.
 */
var uniqId = function () {
  // handle too many uses of uniqId, although unlikely.
  if (id >= 9999) {
    id = 0;
    // shift the template.
    idTemplate = idTemplate.replace('{id}', '_{id}');
  }

  id++;
  var newId = idTemplate.replace('{id}', String(id));

  return newId;
};

/**
 * finds the first element that satisfies the predicate callback, polyfills array.find
 */
var find = function (arrayLike, predicate) {
  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
  for (var i = 0; i < array.length; i++) {
    if (predicate(array[i])) {
      return array[i];
    }
  }

  return undefined;
};

var isBuiltInComponent = function (vnode) {
  if (!vnode) {
    return false;
  }

  var tag = vnode.componentOptions.tag;

  return /^(keep-alive|transition|transition-group)$/.test(tag);
};

var makeEventsArray = function (events) {
  return (typeof events === 'string' && events.length) ? events.split('|') : [];
};

var makeDelayObject = function (events, delay, delayConfig) {
  if (typeof delay === 'number') {
    return events.reduce(function (prev, e) {
      prev[e] = delay;
      return prev;
    }, {});
  }

  return events.reduce(function (prev, e) {
    if (typeof delay === 'object' && e in delay) {
      prev[e] = delay[e];
      return prev;
    }

    if (typeof delayConfig === 'number') {
      prev[e] = delayConfig;
      return prev;
    }

    prev[e] = (delayConfig && delayConfig[e]) || 0;

    return prev;
  }, {});
};

var deepParseInt = function (input) {
  if (typeof input === 'number') { return input; }

  if (typeof input === 'string') { return parseInt(input); }

  var map = {};
  for (var element in input) {
    map[element] = parseInt(input[element]);
  }

  return map;
};

var merge = function (target, source) {
  if (! (isObject(target) && isObject(source))) {
    return target;
  }

  Object.keys(source).forEach(function (key) {
    var obj, obj$1;

    if (isObject(source[key])) {
      if (! target[key]) {
        assign(target, ( obj = {}, obj[key] = {}, obj ));
      }

      merge(target[key], source[key]);
      return;
    }

    assign(target, ( obj$1 = {}, obj$1[key] = source[key], obj$1 ));
  });

  return target;
};

var fillRulesFromElement = function (el, rules) {
  if (el.required) {
    rules = appendRule('required', rules);
  }

  if (isTextInput(el)) {
    if (el.type === 'email') {
      rules = appendRule(("email" + (el.multiple ? ':multiple' : '')), rules);
    }

    if (el.pattern) {
      rules = appendRule(("regex:" + (el.pattern)), rules);
    }

    // 524288 is the max on some browsers and test environments.
    if (el.maxLength >= 0 && el.maxLength < 524288) {
      rules = appendRule(("max:" + (el.maxLength)), rules);
    }

    if (el.minLength > 0) {
      rules = appendRule(("min:" + (el.minLength)), rules);
    }

    return rules;
  }

  if (el.type === 'number') {
    rules = appendRule('decimal', rules);
    if (el.min !== '') {
      rules = appendRule(("min_value:" + (el.min)), rules);
    }

    if (el.max !== '') {
      rules = appendRule(("max_value:" + (el.max)), rules);
    }

    return rules;
  }

  if (isDateInput(el)) {
    var timeFormat = el.step && Number(el.step) < 60 ? 'HH:mm:ss' : 'HH:mm';

    if (el.type === 'date') {
      return appendRule('date_format:YYYY-MM-DD', rules);
    }

    if (el.type === 'datetime-local') {
      return appendRule(("date_format:YYYY-MM-DDT" + timeFormat), rules);
    }

    if (el.type === 'month') {
      return appendRule('date_format:YYYY-MM', rules);
    }

    if (el.type === 'week') {
      return appendRule('date_format:YYYY-[W]WW', rules);
    }

    if (el.type === 'time') {
      return appendRule(("date_format:" + timeFormat), rules);
    }
  }

  return rules;
};

var values = function (obj) {
  if (isCallable(Object.values)) {
    return Object.values(obj);
  }

  // fallback to keys()
  /* istanbul ignore next */
  return obj[Object.keys(obj)[0]];
};

var parseSelector = function (selector) {
  var rule = null;
  if (includes(selector, ':')) {
    rule = selector.split(':').pop();
    selector = selector.replace((":" + rule), '');
  }

  if (selector[0] === '#') {
    return {
      id: selector.slice(1),
      rule: rule,
      name: null,
      scope: null
    };
  }

  var scope = null;
  var name = selector;
  if (includes(selector, '.')) {
    var parts = selector.split('.');
    scope = parts[0];
    name = parts.slice(1).join('.');
  }

  return {
    id: null,
    scope: scope,
    name: name,
    rule: rule
  };
};

var includes = function (collection, item) {
  return collection.indexOf(item) !== -1;
};

// 

var LOCALE = 'en';

var Dictionary = function Dictionary (dictionary) {
  if ( dictionary === void 0 ) dictionary = {};

  this.container = {};
  this.merge(dictionary);
};

var prototypeAccessors = { locale: { configurable: true } };

prototypeAccessors.locale.get = function () {
  return LOCALE;
};

prototypeAccessors.locale.set = function (value) {
  LOCALE = value || 'en';
};

Dictionary.prototype.hasLocale = function hasLocale (locale) {
  return !!this.container[locale];
};

Dictionary.prototype.setDateFormat = function setDateFormat (locale, format) {
  if (!this.container[locale]) {
    this.container[locale] = {};
  }

  this.container[locale].dateFormat = format;
};

Dictionary.prototype.getDateFormat = function getDateFormat (locale) {
  if (!this.container[locale] || !this.container[locale].dateFormat) {
    return null;
  }

  return this.container[locale].dateFormat;
};

Dictionary.prototype.getMessage = function getMessage (locale, key, data) {
  var message = null;
  if (!this.hasMessage(locale, key)) {
    message = this._getDefaultMessage(locale);
  } else {
    message = this.container[locale].messages[key];
  }

  return isCallable(message) ? message.apply(void 0, data) : message;
};

/**
 * Gets a specific message for field. falls back to the rule message.
 */
Dictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
  if (!this.hasLocale(locale)) {
    return this.getMessage(locale, key, data);
  }

  var dict = this.container[locale].custom && this.container[locale].custom[field];
  if (!dict || !dict[key]) {
    return this.getMessage(locale, key, data);
  }

  var message = dict[key];
  return isCallable(message) ? message.apply(void 0, data) : message;
};

Dictionary.prototype._getDefaultMessage = function _getDefaultMessage (locale) {
  if (this.hasMessage(locale, '_default')) {
    return this.container[locale].messages._default;
  }

  return this.container.en.messages._default;
};

Dictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
    if ( fallback === void 0 ) fallback = '';

  if (!this.hasAttribute(locale, key)) {
    return fallback;
  }

  return this.container[locale].attributes[key];
};

Dictionary.prototype.hasMessage = function hasMessage (locale, key) {
  return !! (
    this.hasLocale(locale) &&
          this.container[locale].messages &&
          this.container[locale].messages[key]
  );
};

Dictionary.prototype.hasAttribute = function hasAttribute (locale, key) {
  return !! (
    this.hasLocale(locale) &&
          this.container[locale].attributes &&
          this.container[locale].attributes[key]
  );
};

Dictionary.prototype.merge = function merge$1 (dictionary) {
  merge(this.container, dictionary);
};

Dictionary.prototype.setMessage = function setMessage (locale, key, message) {
  if (! this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }

  this.container[locale].messages[key] = message;
};

Dictionary.prototype.setAttribute = function setAttribute (locale, key, attribute) {
  if (! this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }

  this.container[locale].attributes[key] = attribute;
};

Object.defineProperties( Dictionary.prototype, prototypeAccessors );

// 

var normalizeValue = function (value) {
  if (isObject(value)) {
    return Object.keys(value).reduce(function (prev, key) {
      prev[key] = normalizeValue(value[key]);

      return prev;
    }, {});
  }

  if (isCallable(value)) {
    return value('{0}', ['{1}', '{2}', '{3}']);
  }

  return value;
};

var normalizeFormat = function (locale) {
  // normalize messages
  var dictionary = {};
  if (locale.messages) {
    dictionary.messages = normalizeValue(locale.messages);
  }

  if (locale.custom) {
    dictionary.custom = normalizeValue(locale.custom);
  }

  if (locale.attributes) {
    dictionary.attributes = locale.attributes;
  }

  if (!isNullOrUndefined(locale.dateFormat)) {
    dictionary.dateFormat = locale.dateFormat;
  }

  return dictionary;
};

var I18nDictionary = function I18nDictionary (i18n, rootKey) {
  this.i18n = i18n;
  this.rootKey = rootKey;
};

var prototypeAccessors$1 = { locale: { configurable: true } };

prototypeAccessors$1.locale.get = function () {
  return this.i18n.locale;
};

prototypeAccessors$1.locale.set = function (value) {
  warn('Cannot set locale from the validator when using vue-i18n, use i18n.locale setter instead');
};

I18nDictionary.prototype.getDateFormat = function getDateFormat (locale) {
  return this.i18n.getDateTimeFormat(locale || this.locale);
};

I18nDictionary.prototype.setDateFormat = function setDateFormat (locale, value) {
  this.i18n.setDateTimeFormat(locale || this.locale, value);
};

I18nDictionary.prototype.getMessage = function getMessage (locale, key, data) {
  var path = (this.rootKey) + ".messages." + key;
  if (!this.i18n.te(path)) {
    return this.i18n.t(((this.rootKey) + ".messages._default"), locale, data);
  }

  return this.i18n.t(path, locale, data);
};

I18nDictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
    if ( fallback === void 0 ) fallback = '';

  var path = (this.rootKey) + ".attributes." + key;
  if (!this.i18n.te(path)) {
    return fallback;
  }

  return this.i18n.t(path, locale);
};

I18nDictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
  var path = (this.rootKey) + ".custom." + field + "." + key;
  if (this.i18n.te(path)) {
    return this.i18n.t(path, locale, data);
  }

  return this.getMessage(locale, key, data);
};

I18nDictionary.prototype.merge = function merge$1 (dictionary) {
    var this$1 = this;

  Object.keys(dictionary).forEach(function (localeKey) {
      var obj;

    // i18n doesn't deep merge
    // first clone the existing locale (avoid mutations to locale)
    var clone = merge({}, getPath((localeKey + "." + (this$1.rootKey)), this$1.i18n.messages, {}));
    // Merge cloned locale with new one
    var locale = merge(clone, normalizeFormat(dictionary[localeKey]));
    this$1.i18n.mergeLocaleMessage(localeKey, ( obj = {}, obj[this$1.rootKey] = locale, obj ));
    if (locale.dateFormat) {
      this$1.i18n.setDateTimeFormat(localeKey, locale.dateFormat);
    }
  });
};

I18nDictionary.prototype.setMessage = function setMessage (locale, key, value) {
    var obj, obj$1;

  this.merge(( obj$1 = {}, obj$1[locale] = {
      messages: ( obj = {}, obj[key] = value, obj )
    }, obj$1 ));
};

I18nDictionary.prototype.setAttribute = function setAttribute (locale, key, value) {
    var obj, obj$1;

  this.merge(( obj$1 = {}, obj$1[locale] = {
      attributes: ( obj = {}, obj[key] = value, obj )
    }, obj$1 ));
};

Object.defineProperties( I18nDictionary.prototype, prototypeAccessors$1 );

// 

var defaultConfig = {
  locale: 'en',
  delay: 0,
  errorBagName: 'errors',
  dictionary: null,
  strict: true,
  fieldsBagName: 'fields',
  classes: false,
  classNames: null,
  events: 'input',
  inject: true,
  fastExit: true,
  aria: true,
  validity: false,
  i18n: null,
  i18nRootKey: 'validation'
};

var currentConfig = assign({}, defaultConfig);
var dependencies = {
  dictionary: new Dictionary({
    en: {
      messages: {},
      attributes: {},
      custom: {}
    }
  })
};

var Config = function Config () {};

var staticAccessors = { default: { configurable: true },current: { configurable: true } };

staticAccessors.default.get = function () {
  return defaultConfig;
};

staticAccessors.current.get = function () {
  return currentConfig;
};

Config.dependency = function dependency (key) {
  return dependencies[key];
};

/**
 * Merges the config with a new one.
 */
Config.merge = function merge$$1 (config) {
  currentConfig = assign({}, currentConfig, config);
  if (currentConfig.i18n) {
    Config.register('dictionary', new I18nDictionary(currentConfig.i18n, currentConfig.i18nRootKey));
  }
};

/**
 * Registers a dependency.
 */
Config.register = function register (key, value) {
  dependencies[key] = value;
};

/**
 * Resolves the working config from a Vue instance.
 */
Config.resolve = function resolve (context) {
  var selfConfig = getPath('$options.$_veeValidate', context, {});

  return assign({}, Config.current, selfConfig);
};

Object.defineProperties( Config, staticAccessors );

// 

var ErrorBag = function ErrorBag (errorBag, id) {
  if ( errorBag === void 0 ) errorBag = null;
  if ( id === void 0 ) id = null;

  this.vmId = id || null;
  // make this bag a mirror of the provided one, sharing the same items reference.
  if (errorBag && errorBag instanceof ErrorBag) {
    this.items = errorBag.items;
  } else {
    this.items = [];
  }
};

ErrorBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
    var this$1 = this;

  var index = 0;
  return {
    next: function () {
      return { value: this$1.items[index++], done: index > this$1.items.length };
    }
  };
};

/**
 * Adds an error to the internal array.
 */
ErrorBag.prototype.add = function add (error) {
    var ref;

  (ref = this.items).push.apply(
    ref, this._normalizeError(error)
  );
};

/**
 * Normalizes passed errors to an error array.
 */
ErrorBag.prototype._normalizeError = function _normalizeError (error) {
    var this$1 = this;

  if (Array.isArray(error)) {
    return error.map(function (e) {
      e.scope = !isNullOrUndefined(e.scope) ? e.scope : null;
      e.vmId = !isNullOrUndefined(e.vmId) ? e.vmId : (this$1.vmId || null);

      return e;
    });
  }

  error.scope = !isNullOrUndefined(error.scope) ? error.scope : null;
  error.vmId = !isNullOrUndefined(error.vmId) ? error.vmId : (this.vmId || null);

  return [error];
};

/**
 * Regenrates error messages if they have a generator function.
 */
ErrorBag.prototype.regenerate = function regenerate () {
  this.items.forEach(function (i) {
    i.msg = isCallable(i.regenerate) ? i.regenerate() : i.msg;
  });
};

/**
 * Updates a field error with the new field scope.
 */
ErrorBag.prototype.update = function update (id, error) {
  var item = find(this.items, function (i) { return i.id === id; });
  if (!item) {
    return;
  }

  var idx = this.items.indexOf(item);
  this.items.splice(idx, 1);
  item.scope = error.scope;
  this.items.push(item);
};

/**
 * Gets all error messages from the internal array.
 */
ErrorBag.prototype.all = function all (scope) {
    var this$1 = this;

  var filterFn = function (item) {
    var matchesScope = true;
    var matchesVM = true;
    if (!isNullOrUndefined(scope)) {
      matchesScope = item.scope === scope;
    }

    if (!isNullOrUndefined(this$1.vmId)) {
      matchesVM = item.vmId === this$1.vmId;
    }

    return matchesVM && matchesScope;
  };

  return this.items.filter(filterFn).map(function (e) { return e.msg; });
};

/**
 * Checks if there are any errors in the internal array.
 */
ErrorBag.prototype.any = function any (scope) {
    var this$1 = this;

  var filterFn = function (item) {
    var matchesScope = true;
    if (!isNullOrUndefined(scope)) {
      matchesScope = item.scope === scope;
    }

    if (!isNullOrUndefined(this$1.vmId)) {
      matchesScope = item.vmId === this$1.vmId;
    }

    return matchesScope;
  };

  return !!this.items.filter(filterFn).length;
};

/**
 * Removes all items from the internal array.
 */
ErrorBag.prototype.clear = function clear (scope) {
    var this$1 = this;

  var matchesVM = isNullOrUndefined(this.vmId) ? function () { return true; } : function (i) { return i.vmId === this$1.vmId; };
  if (isNullOrUndefined(scope)) {
    scope = null;
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (matchesVM(this$1.items[i]) && this$1.items[i].scope === scope) {
      this$1.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Collects errors into groups or for a specific field.
 */
ErrorBag.prototype.collect = function collect (field, scope, map) {
    var this$1 = this;
    if ( map === void 0 ) map = true;

  var isSingleField = !isNullOrUndefined(field) && !field.includes('*');
  var groupErrors = function (items) {
    var errors = items.reduce(function (collection, error) {
      if (!isNullOrUndefined(this$1.vmId) && error.vmId !== this$1.vmId) {
        return collection;
      }

      if (!collection[error.field]) {
        collection[error.field] = [];
      }

      collection[error.field].push(map ? error.msg : error);

      return collection;
    }, {});

    // reduce the collection to be a single array.
    if (isSingleField) {
      return values(errors)[0] || [];
    }

    return errors;
  };

  if (isNullOrUndefined(field)) {
    return groupErrors(this.items);
  }

  var selector = isNullOrUndefined(scope) ? String(field) : (scope + "." + field);
  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;

  var collected = this.items.reduce(function (prev, curr) {
    if (isPrimary(curr)) {
      prev.primary.push(curr);
    }

    if (isAlt(curr)) {
      prev.alt.push(curr);
    }

    return prev;
  }, { primary: [], alt: [] });

  collected = collected.primary.length ? collected.primary : collected.alt;

  return groupErrors(collected);
};

/**
 * Gets the internal array length.
 */
ErrorBag.prototype.count = function count () {
    var this$1 = this;

  if (this.vmId) {
    return this.items.filter(function (e) { return e.vmId === this$1.vmId; }).length;
  }

  return this.items.length;
};

/**
 * Finds and fetches the first error message for the specified field id.
 */
ErrorBag.prototype.firstById = function firstById (id) {
  var error = find(this.items, function (i) { return i.id === id; });

  return error ? error.msg : undefined;
};

/**
 * Gets the first error message for a specific field.
 */
ErrorBag.prototype.first = function first (field, scope) {
    if ( scope === void 0 ) scope = null;

  var selector = isNullOrUndefined(scope) ? field : (scope + "." + field);
  var match = this._match(selector);

  return match && match.msg;
};

/**
 * Returns the first error rule for the specified field
 */
ErrorBag.prototype.firstRule = function firstRule (field, scope) {
  var errors = this.collect(field, scope, false);

  return (errors.length && errors[0].rule) || undefined;
};

/**
 * Checks if the internal array has at least one error for the specified field.
 */
ErrorBag.prototype.has = function has (field, scope) {
    if ( scope === void 0 ) scope = null;

  return !!this.first(field, scope);
};

/**
 * Gets the first error message for a specific field and a rule.
 */
ErrorBag.prototype.firstByRule = function firstByRule (name, rule, scope) {
    if ( scope === void 0 ) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) { return e.rule === rule; })[0];

  return (error && error.msg) || undefined;
};

/**
 * Gets the first error message for a specific field that not match the rule.
 */
ErrorBag.prototype.firstNot = function firstNot (name, rule, scope) {
    if ( rule === void 0 ) rule = 'required';
    if ( scope === void 0 ) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) { return e.rule !== rule; })[0];

  return (error && error.msg) || undefined;
};

/**
 * Removes errors by matching against the id or ids.
 */
ErrorBag.prototype.removeById = function removeById (id) {
    var this$1 = this;

  var condition = function (item) { return item.id === id; };
  if (Array.isArray(id)) {
    condition = function (item) { return id.indexOf(item.id) !== -1; };
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (condition(this$1.items[i])) {
      this$1.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Removes all error messages associated with a specific field.
 */
ErrorBag.prototype.remove = function remove (field, scope, vmId) {
    var this$1 = this;

  if (isNullOrUndefined(field)) {
    return;
  }

  var selector = isNullOrUndefined(scope) ? String(field) : (scope + "." + field);
  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
  var shouldRemove = function (item) {
    if (isNullOrUndefined(vmId)) { return isPrimary(item); }

    return isPrimary(item) && item.vmId === vmId;
  };

  for (var i = 0; i < this.items.length; ++i) {
    if (shouldRemove(this$1.items[i])) {
      this$1.items.splice(i, 1);
      --i;
    }
  }
};

ErrorBag.prototype._makeCandidateFilters = function _makeCandidateFilters (selector) {
    var this$1 = this;

  var matchesRule = function () { return true; };
  var matchesScope = function () { return true; };
  var matchesName = function () { return true; };
  var matchesVM = function () { return true; };

  var ref = parseSelector(selector);
    var id = ref.id;
    var rule = ref.rule;
    var scope = ref.scope;
    var name = ref.name;

  if (rule) {
    matchesRule = function (item) { return item.rule === rule; };
  }

  // match by id, can be combined with rule selection.
  if (id) {
    return {
      isPrimary: function (item) { return matchesRule(item) && (function (item) { return id === item.id; }); },
      isAlt: function () { return false; }
    };
  }

  if (isNullOrUndefined(scope)) {
    // if no scope specified, make sure the found error has no scope.
    matchesScope = function (item) { return isNullOrUndefined(item.scope); };
  } else {
    matchesScope = function (item) { return item.scope === scope; };
  }

  if (!isNullOrUndefined(name) && name !== '*') {
    matchesName = function (item) { return item.field === name; };
  }

  if (!isNullOrUndefined(this.vmId)) {
    matchesVM = function (item) { return item.vmId === this$1.vmId; };
  }

  // matches the first candidate.
  var isPrimary = function (item) {
    return matchesVM(item) && matchesName(item) && matchesRule(item) && matchesScope(item);
  };

  // matches a second candidate, which is a field with a name containing the '.' character.
  var isAlt = function (item) {
    return matchesVM(item) && matchesRule(item) && item.field === (scope + "." + name);
  };

  return {
    isPrimary: isPrimary,
    isAlt: isAlt
  };
};

ErrorBag.prototype._match = function _match (selector) {
  if (isNullOrUndefined(selector)) {
    return undefined;
  }

  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;

  return this.items.reduce(function (prev, item, idx, arr) {
    var isLast = idx === arr.length - 1;
    if (prev.primary) {
      return isLast ? prev.primary : prev;
    }

    if (isPrimary(item)) {
      prev.primary = item;
    }

    if (isAlt(item)) {
      prev.alt = item;
    }

    // keep going.
    if (!isLast) {
      return prev;
    }

    return prev.primary || prev.alt;
  }, {});
};

/**
 * Generates the options required to construct a field.
 */
var Resolver = function Resolver () {};

Resolver.generate = function generate (el, binding, vnode) {
  var model = Resolver.resolveModel(binding, vnode);
  var options = Config.resolve(vnode.context);

  return {
    name: Resolver.resolveName(el, vnode),
    el: el,
    listen: !binding.modifiers.disable,
    bails: binding.modifiers.bails ? true : (binding.modifiers.continues === true ? false : undefined),
    scope: Resolver.resolveScope(el, binding, vnode),
    vm: Resolver.makeVM(vnode.context),
    expression: binding.value,
    component: vnode.componentInstance,
    classes: options.classes,
    classNames: options.classNames,
    getter: Resolver.resolveGetter(el, vnode, model),
    events: Resolver.resolveEvents(el, vnode) || options.events,
    model: model,
    delay: Resolver.resolveDelay(el, vnode, options),
    rules: Resolver.resolveRules(el, binding, vnode),
    immediate: !!binding.modifiers.initial || !!binding.modifiers.immediate,
    validity: options.validity,
    aria: options.aria,
    initialValue: Resolver.resolveInitialValue(vnode)
  };
};

Resolver.getCtorConfig = function getCtorConfig (vnode) {
  if (!vnode.componentInstance) { return null; }

  var config = getPath('componentInstance.$options.$_veeValidate', vnode);

  return config;
};

/**
 * Resolves the rules defined on an element.
 */
Resolver.resolveRules = function resolveRules (el, binding, vnode) {
  var rules = '';
  if (!binding.value && (!binding || !binding.expression)) {
    rules = getDataAttribute(el, 'rules');
  }

  if (binding.value && includes(['string', 'object'], typeof binding.value.rules)) {
    rules = binding.value.rules;
  } else if (binding.value) {
    rules = binding.value;
  }

  if (vnode.componentInstance) {
    return rules;
  }

  return fillRulesFromElement(el, rules);
};

/**
 * @param {*} vnode
 */
Resolver.resolveInitialValue = function resolveInitialValue (vnode) {
  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });

  return model && model.value;
};

/**
 * Creates a non-circular partial VM instance from a Vue instance.
 * @param {*} vm
 */
Resolver.makeVM = function makeVM (vm) {
  return {
    get $el () {
      return vm.$el;
    },
    get $refs () {
      return vm.$refs;
    },
    $watch: vm.$watch ? vm.$watch.bind(vm) : function () {},
    $validator: vm.$validator ? {
      errors: vm.$validator.errors,
      validate: vm.$validator.validate.bind(vm.$validator),
      update: vm.$validator.update.bind(vm.$validator)
    } : null
  };
};

/**
 * Resolves the delay value.
 * @param {*} el
 * @param {*} vnode
 * @param {Object} options
 */
Resolver.resolveDelay = function resolveDelay (el, vnode, options) {
  var delay = getDataAttribute(el, 'delay');
  var globalDelay = (options && 'delay' in options) ? options.delay : 0;

  if (!delay && vnode.componentInstance && vnode.componentInstance.$attrs) {
    delay = vnode.componentInstance.$attrs['data-vv-delay'];
  }

  if (!isObject(globalDelay)) {
    return deepParseInt(delay || globalDelay);
  }

  if (!isNullOrUndefined(delay)) {
    globalDelay.input = delay;
  }

  return deepParseInt(globalDelay);
};

/**
 * Resolves the events to validate in response to.
 * @param {*} el
 * @param {*} vnode
 */
Resolver.resolveEvents = function resolveEvents (el, vnode) {
  // resolve it from the root element.
  var events = getDataAttribute(el, 'validate-on');

  // resolve from data-vv-validate-on if its a vue component.
  if (!events && vnode.componentInstance && vnode.componentInstance.$attrs) {
    events = vnode.componentInstance.$attrs['data-vv-validate-on'];
  }

  // resolve it from $_veeValidate options.
  if (!events && vnode.componentInstance) {
    var config = Resolver.getCtorConfig(vnode);
    events = config && config.events;
  }

  if (!events && Config.current.events) {
    events = Config.current.events;
  }

  // resolve the model event if its configured for custom components.
  if (events && vnode.componentInstance && includes(events, 'input')) {
    var ref = vnode.componentInstance.$options.model || { event: 'input' };
      var event = ref.event;
    // if the prop was configured but not the model.
    if (!event) {
      return events;
    }

    events = events.replace('input', event);
  }

  return events;
};

/**
 * Resolves the scope for the field.
 * @param {*} el
 * @param {*} binding
 */
Resolver.resolveScope = function resolveScope (el, binding, vnode) {
    if ( vnode === void 0 ) vnode = {};

  var scope = null;
  if (vnode.componentInstance && isNullOrUndefined(scope)) {
    scope = vnode.componentInstance.$attrs && vnode.componentInstance.$attrs['data-vv-scope'];
  }

  return !isNullOrUndefined(scope) ? scope : getScope(el);
};

/**
 * Checks if the node directives contains a v-model or a specified arg.
 * Args take priority over models.
 *
 * @return {Object}
 */
Resolver.resolveModel = function resolveModel (binding, vnode) {
  if (binding.arg) {
    return { expression: binding.arg };
  }

  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });
  if (!model) {
    return null;
  }

  // https://github.com/vuejs/vue/blob/dev/src/core/util/lang.js#L26
  var watchable = !/[^\w.$]/.test(model.expression) && hasPath(model.expression, vnode.context);
  var lazy = !!(model.modifiers && model.modifiers.lazy);

  if (!watchable) {
    return { expression: null, lazy: lazy };
  }

  return { expression: model.expression, lazy: lazy };
};

/**
 * Resolves the field name to trigger validations.
 * @return {String} The field name.
 */
Resolver.resolveName = function resolveName (el, vnode) {
  var name = getDataAttribute(el, 'name');

  if (!name && !vnode.componentInstance) {
    return el.name;
  }

  if (!name && vnode.componentInstance && vnode.componentInstance.$attrs) {
    name = vnode.componentInstance.$attrs['data-vv-name'] || vnode.componentInstance.$attrs['name'];
  }

  if (!name && vnode.componentInstance) {
    var config = Resolver.getCtorConfig(vnode);
    if (config && isCallable(config.name)) {
      var boundGetter = config.name.bind(vnode.componentInstance);

      return boundGetter();
    }

    return vnode.componentInstance.name;
  }

  return name;
};

/**
 * Returns a value getter input type.
 */
Resolver.resolveGetter = function resolveGetter (el, vnode, model) {
  if (model && model.expression) {
    return function () {
      return getPath(model.expression, vnode.context);
    };
  }

  if (vnode.componentInstance) {
    var path = getDataAttribute(el, 'value-path') || (vnode.componentInstance.$attrs && vnode.componentInstance.$attrs['data-vv-value-path']);
    if (path) {
      return function () {
        return getPath(path, vnode.componentInstance);
      };
    }

    var config = Resolver.getCtorConfig(vnode);
    if (config && isCallable(config.value)) {
      var boundGetter = config.value.bind(vnode.componentInstance);

      return function () {
        return boundGetter();
      };
    }

    var ref = vnode.componentInstance.$options.model || { prop: 'value' };
      var prop = ref.prop;

    return function () {
      return vnode.componentInstance[prop];
    };
  }

  switch (el.type) {
  case 'checkbox': return function () {
    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));

    els = toArray(els).filter(function (el) { return el.checked; });
    if (!els.length) { return undefined; }

    return els.map(function (checkbox) { return checkbox.value; });
  };
  case 'radio': return function () {
    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
    var elm = find(els, function (el) { return el.checked; });

    return elm && elm.value;
  };
  case 'file': return function (context) {
    return toArray(el.files);
  };
  case 'select-multiple': return function () {
    return toArray(el.options).filter(function (opt) { return opt.selected; }).map(function (opt) { return opt.value; });
  };
  default: return function () {
    return el && el.value;
  };
  }
};

// 

var RULES = {};
var STRICT_MODE = true;

var Validator = function Validator (validations, options) {
  if ( options === void 0 ) options = { fastExit: true };

  this.strict = STRICT_MODE;
  this.errors = new ErrorBag();
  this.fields = new FieldBag();
  this._createFields(validations);
  this.paused = false;
  this.fastExit = !isNullOrUndefined(options && options.fastExit) ? options.fastExit : true;
};

var prototypeAccessors$2 = { rules: { configurable: true },flags: { configurable: true },dictionary: { configurable: true },_vm: { configurable: true },locale: { configurable: true } };
var staticAccessors$1 = { rules: { configurable: true },dictionary: { configurable: true },locale: { configurable: true } };

staticAccessors$1.rules.get = function () {
  return RULES;
};

prototypeAccessors$2.rules.get = function () {
  return RULES;
};

prototypeAccessors$2.flags.get = function () {
  return this.fields.items.reduce(function (acc, field) {
      var obj;

    if (field.scope) {
      acc[("$" + (field.scope))] = ( obj = {}, obj[field.name] = field.flags, obj );

      return acc;
    }

    acc[field.name] = field.flags;

    return acc;
  }, {});
};

/**
 * Getter for the dictionary.
 */
prototypeAccessors$2.dictionary.get = function () {
  return Config.dependency('dictionary');
};

staticAccessors$1.dictionary.get = function () {
  return Config.dependency('dictionary');
};

prototypeAccessors$2._vm.get = function () {
  return Config.dependency('vm');
};

/**
 * Getter for the current locale.
 */
prototypeAccessors$2.locale.get = function () {
  return Validator.locale;
};

/**
 * Setter for the validator locale.
 */
prototypeAccessors$2.locale.set = function (value) {
  Validator.locale = value;
};

staticAccessors$1.locale.get = function () {
  return this.dictionary.locale;
};

/**
 * Setter for the validator locale.
 */
staticAccessors$1.locale.set = function (value) {
  var hasChanged = value !== Validator.dictionary.locale;
  Validator.dictionary.locale = value;
  if (hasChanged && Config.dependency('vm')) {
    Config.dependency('vm').$emit('localeChanged');
  }
};

/**
 * Static constructor.
 */
Validator.create = function create (validations, options) {
  return new Validator(validations, options);
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.extend = function extend (name, validator, options) {
    if ( options === void 0 ) options = {};

  Validator._guardExtend(name, validator);
  Validator._merge(name, {
    validator: validator,
    options: assign({}, { hasTarget: false, immediate: true }, options || {})
  });
};

/**
 * Removes a rule from the list of validators.
 */
Validator.remove = function remove (name) {
  delete RULES[name];
};

/**
 * Checks if the given rule name is a rule that targets other fields.
 */
Validator.isTargetRule = function isTargetRule (name) {
  return !!RULES[name] && RULES[name].options.hasTarget;
};

/**
 * Sets the operating mode for all newly created validators.
 * strictMode = true: Values without a rule are invalid and cause failure.
 * strictMode = false: Values without a rule are valid and are skipped.
 */
Validator.setStrictMode = function setStrictMode (strictMode) {
    if ( strictMode === void 0 ) strictMode = true;

  STRICT_MODE = strictMode;
};

/**
 * Adds and sets the current locale for the validator.
 */
Validator.prototype.localize = function localize (lang, dictionary) {
  Validator.localize(lang, dictionary);
};

/**
 * Adds and sets the current locale for the validator.
 */
Validator.localize = function localize (lang, dictionary) {
    var obj;

  if (isObject(lang)) {
    Validator.dictionary.merge(lang);
    return;
  }

  // merge the dictionary.
  if (dictionary) {
    var locale = lang || dictionary.name;
    dictionary = assign({}, dictionary);
    Validator.dictionary.merge(( obj = {}, obj[locale] = dictionary, obj ));
  }

  if (lang) {
    // set the locale.
    Validator.locale = lang;
  }
};

/**
 * Registers a field to be validated.
 */
Validator.prototype.attach = function attach (fieldOpts) {
  // fixes initial value detection with v-model and select elements.
  var value = fieldOpts.initialValue;
  var field = new Field(fieldOpts);
  this.fields.push(field);

  // validate the field initially
  if (field.immediate) {
    this.validate(("#" + (field.id)), value || field.value, { vmId: fieldOpts.vmId });
  } else {
    this._validate(field, value || field.value, { initial: true }).then(function (result) {
      field.flags.valid = result.valid;
      field.flags.invalid = !result.valid;
    });
  }

  return field;
};

/**
 * Sets the flags on a field.
 */
Validator.prototype.flag = function flag (name, flags, uid) {
    if ( uid === void 0 ) uid = null;

  var field = this._resolveField(name, undefined, uid);
  if (!field || !flags) {
    return;
  }

  field.setFlags(flags);
};

/**
 * Removes a field from the validator.
 */
Validator.prototype.detach = function detach (name, scope, uid) {
  var field = isCallable(name.destroy) ? name : this._resolveField(name, scope, uid);
  if (!field) { return; }

  field.destroy();
  this.errors.remove(field.name, field.scope, field.vmId);
  this.fields.remove(field);
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.prototype.extend = function extend (name, validator, options) {
    if ( options === void 0 ) options = {};

  Validator.extend(name, validator, options);
};

Validator.prototype.reset = function reset (matcher) {
    var this$1 = this;

  // two ticks
  return this._vm.$nextTick().then(function () {
    return this$1._vm.$nextTick();
  }).then(function () {
    this$1.fields.filter(matcher).forEach(function (field) {
      field.reset(); // reset field flags.
      this$1.errors.remove(field.name, field.scope);
    });
  });
};

/**
 * Updates a field, updating both errors and flags.
 */
Validator.prototype.update = function update (id, ref) {
    var scope = ref.scope;

  var field = this._resolveField(("#" + id));
  if (!field) { return; }

  // remove old scope.
  this.errors.update(id, { scope: scope });
};

/**
 * Removes a rule from the list of validators.
 */
Validator.prototype.remove = function remove (name) {
  Validator.remove(name);
};

/**
 * Validates a value against a registered field validations.
 */
Validator.prototype.validate = function validate (fieldDescriptor, value, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  // overload to validate all.
  if (isNullOrUndefined(fieldDescriptor)) {
    return this.validateScopes({ silent: silent, vmId: vmId });
  }

  // overload to validate scope-less fields.
  if (fieldDescriptor === '*') {
    return this.validateAll(undefined, { silent: silent, vmId: vmId });
  }

  // if scope validation was requested.
  if (/^(.+)\.\*$/.test(fieldDescriptor)) {
    var matched = fieldDescriptor.match(/^(.+)\.\*$/)[1];
    return this.validateAll(matched);
  }

  var field = this._resolveField(fieldDescriptor);
  if (!field) {
    return this._handleFieldNotFound(name);
  }

  if (!silent) { field.flags.pending = true; }
  if (value === undefined) {
    value = field.value;
  }

  return this._validate(field, value).then(function (result) {
    if (!silent) {
      this$1._handleValidationResults([result], vmId);
    }

    return result.valid;
  });
};

/**
 * Pauses the validator.
 */
Validator.prototype.pause = function pause () {
  this.paused = true;

  return this;
};

/**
 * Resumes the validator.
 */
Validator.prototype.resume = function resume () {
  this.paused = false;

  return this;
};

/**
 * Validates each value against the corresponding field validations.
 */
Validator.prototype.validateAll = function validateAll (values$$1, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  var matcher = null;
  var providedValues = false;

  if (typeof values$$1 === 'string') {
    matcher = { scope: values$$1, vmId: vmId };
  } else if (isObject(values$$1)) {
    matcher = Object.keys(values$$1).map(function (key) {
      return { name: key, vmId: vmId, scope: null };
    });
    providedValues = true;
  } else if (Array.isArray(values$$1)) {
    matcher = values$$1.map(function (key) {
      return { name: key, vmId: vmId };
    });
  } else {
    matcher = { scope: null, vmId: vmId };
  }

  return Promise.all(
    this.fields.filter(matcher).map(function (field) { return this$1._validate(field, providedValues ? values$$1[field.name] : field.value); })
  ).then(function (results) {
    if (!silent) {
      this$1._handleValidationResults(results, vmId);
    }

    return results.every(function (t) { return t.valid; });
  });
};

/**
 * Validates all scopes.
 */
Validator.prototype.validateScopes = function validateScopes (ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  return Promise.all(
    this.fields.filter({ vmId: vmId }).map(function (field) { return this$1._validate(field, field.value); })
  ).then(function (results) {
    if (!silent) {
      this$1._handleValidationResults(results, vmId);
    }

    return results.every(function (t) { return t.valid; });
  });
};

/**
 * Validates a value against the rules.
 */
Validator.prototype.verify = function verify (value, rules) {
  var field = { name: '{field}', rules: normalizeRules(rules) };

  return this._validate(field, value).then(function (result) {
    return { valid: result.valid, errors: result.errors.map(function (e) { return e.msg; }) };
  });
};

/**
 * Perform cleanup.
 */
Validator.prototype.destroy = function destroy () {
  this._vm.$off('localeChanged');
};

/**
 * Creates the fields to be validated.
 */
Validator.prototype._createFields = function _createFields (validations) {
    var this$1 = this;

  if (!validations) { return; }

  Object.keys(validations).forEach(function (field) {
    var options = assign({}, { name: field, rules: validations[field] });
    this$1.attach(options);
  });
};

/**
 * Date rules need the existence of a format, so date_format must be supplied.
 */
Validator.prototype._getDateFormat = function _getDateFormat (validations) {
  var format = null;
  if (validations.date_format && Array.isArray(validations.date_format)) {
    format = validations.date_format[0];
  }

  return format || this.dictionary.getDateFormat(this.locale);
};

/**
 * Formats an error message for field and a rule.
 */
Validator.prototype._formatErrorMessage = function _formatErrorMessage (field, rule, data, targetName) {
    if ( data === void 0 ) data = {};
    if ( targetName === void 0 ) targetName = null;

  var name = this._getFieldDisplayName(field);
  var params = this._getLocalizedParams(rule, targetName);

  return this.dictionary.getFieldMessage(this.locale, field.name, rule.name, [name, params, data]);
};

/**
 * Translates the parameters passed to the rule (mainly for target fields).
 */
Validator.prototype._getLocalizedParams = function _getLocalizedParams (rule, targetName) {
    if ( targetName === void 0 ) targetName = null;

  if (rule.options.hasTarget && rule.params && rule.params[0]) {
    var localizedName = targetName || this.dictionary.getAttribute(this.locale, rule.params[0], rule.params[0]);
    return [localizedName].concat(rule.params.slice(1));
  }

  return rule.params;
};

/**
 * Resolves an appropriate display name, first checking 'data-as' or the registered 'prettyName'
 */
Validator.prototype._getFieldDisplayName = function _getFieldDisplayName (field) {
  return field.alias || this.dictionary.getAttribute(this.locale, field.name, field.name);
};

/**
 * Tests a single input value against a rule.
 */
Validator.prototype._test = function _test (field, value, rule) {
    var this$1 = this;

  var validator = RULES[rule.name] ? RULES[rule.name].validate : null;
  var params = Array.isArray(rule.params) ? toArray(rule.params) : [];
  var targetName = null;
  if (!validator || typeof validator !== 'function') {
    return Promise.reject(createError(("No such validator '" + (rule.name) + "' exists.")));
  }

  // has field dependencies.
  if (rule.options.hasTarget) {
    var target = find(field.dependencies, function (d) { return d.name === rule.name; });
    if (target) {
      targetName = target.field.alias;
      params = [target.field.value].concat(params.slice(1));
    }
  } else if (rule.name === 'required' && field.rejectsFalse) {
    // invalidate false if no args were specified and the field rejects false by default.
    params = params.length ? params : [true];
  }

  if (rule.options.isDate) {
    var dateFormat = this._getDateFormat(field.rules);
    if (rule.name !== 'date_format') {
      params.push(dateFormat);
    }
  }

  var result = validator(value, params);

  // If it is a promise.
  if (isCallable(result.then)) {
    return result.then(function (values$$1) {
      var allValid = true;
      var data = {};
      if (Array.isArray(values$$1)) {
        allValid = values$$1.every(function (t) { return (isObject(t) ? t.valid : t); });
      } else { // Is a single object/boolean.
        allValid = isObject(values$$1) ? values$$1.valid : values$$1;
        data = values$$1.data;
      }

      return {
        valid: allValid,
        errors: allValid ? [] : [this$1._createFieldError(field, rule, data, targetName)]
      };
    });
  }

  if (!isObject(result)) {
    result = { valid: result, data: {} };
  }

  return {
    valid: result.valid,
    errors: result.valid ? [] : [this._createFieldError(field, rule, result.data, targetName)]
  };
};

/**
 * Merges a validator object into the RULES and Messages.
 */
Validator._merge = function _merge (name, ref) {
    var validator = ref.validator;
    var options = ref.options;

  var validate = isCallable(validator) ? validator : validator.validate;
  if (validator.getMessage) {
    Validator.dictionary.setMessage(Validator.locale, name, validator.getMessage);
  }

  RULES[name] = {
    validate: validate,
    options: options
  };
};

/**
 * Guards from extension violations.
 */
Validator._guardExtend = function _guardExtend (name, validator) {
  if (isCallable(validator)) {
    return;
  }

  if (!isCallable(validator.validate)) {
    throw createError(
      ("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.")
    );
  }
};

/**
 * Creates a Field Error Object.
 */
Validator.prototype._createFieldError = function _createFieldError (field, rule, data, targetName) {
    var this$1 = this;

  return {
    id: field.id,
    vmId: field.vmId,
    field: field.name,
    msg: this._formatErrorMessage(field, rule, data, targetName),
    rule: rule.name,
    scope: field.scope,
    regenerate: function () {
      return this$1._formatErrorMessage(field, rule, data, targetName);
    }
  };
};

/**
 * Tries different strategies to find a field.
 */
Validator.prototype._resolveField = function _resolveField (name, scope, uid) {
  if (name[0] === '#') {
    return this.fields.find({ id: name.slice(1) });
  }

  if (!isNullOrUndefined(scope)) {
    return this.fields.find({ name: name, scope: scope, vmId: uid });
  }

  if (includes(name, '.')) {
    var ref = name.split('.');
      var fieldScope = ref[0];
      var fieldName = ref.slice(1);
    var field = this.fields.find({ name: fieldName.join('.'), scope: fieldScope, vmId: uid });
    if (field) {
      return field;
    }
  }

  return this.fields.find({ name: name, scope: null, vmId: uid });
};

/**
 * Handles when a field is not found depending on the strict flag.
 */
Validator.prototype._handleFieldNotFound = function _handleFieldNotFound (name, scope) {
  if (!this.strict) { return Promise.resolve(true); }

  var fullName = isNullOrUndefined(scope) ? name : ("" + (!isNullOrUndefined(scope) ? scope + '.' : '') + name);

  return Promise.reject(createError(
    ("Validating a non-existent field: \"" + fullName + "\". Use \"attach()\" first.")
  ));
};

/**
 * Handles validation results.
 */
Validator.prototype._handleValidationResults = function _handleValidationResults (results, vmId) {
    var this$1 = this;

  var matchers = results.map(function (result) { return ({ id: result.id }); });
  this.errors.removeById(matchers.map(function (m) { return m.id; }));
  // remove by name and scope to remove any custom errors added.
  results.forEach(function (result) {
    this$1.errors.remove(result.field, result.scope, vmId);
  });
  var allErrors = results.reduce(function (prev, curr) {
    prev.push.apply(prev, curr.errors);

    return prev;
  }, []);

  this.errors.add(allErrors);

  // handle flags.
  this.fields.filter(matchers).forEach(function (field) {
    var result = find(results, function (r) { return r.id === field.id; });
    field.setFlags({
      pending: false,
      valid: result.valid,
      validated: true
    });
  });
};

Validator.prototype._shouldSkip = function _shouldSkip (field, value) {
  // field is configured to run through the pipeline regardless
  if (field.bails === false) {
    return false;
  }

  // disabled fields are skipped
  if (field.isDisabled) {
    return true;
  }

  // skip if the field is not required and has an empty value.
  return !field.isRequired && (isNullOrUndefined(value) || value === '');
};

Validator.prototype._shouldBail = function _shouldBail (field, value) {
  // if the field was configured explicitly.
  if (field.bails !== undefined) {
    return field.bails;
  }

  return this.fastExit;
};

/**
 * Starts the validation process.
 */
Validator.prototype._validate = function _validate (field, value, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var initial = ref.initial;

  if (this._shouldSkip(field, value)) {
    return Promise.resolve({ valid: true, id: field.id, field: field.name, scope: field.scope, errors: [] });
  }

  var promises = [];
  var errors = [];
  var isExitEarly = false;
  // use of '.some()' is to break iteration in middle by returning true
  Object.keys(field.rules).filter(function (rule) {
    if (!initial || !RULES[rule]) { return true; }

    return RULES[rule].options.immediate;
  }).some(function (rule) {
    var ruleOptions = RULES[rule] ? RULES[rule].options : {};
    var result = this$1._test(field, value, { name: rule, params: field.rules[rule], options: ruleOptions });
    if (isCallable(result.then)) {
      promises.push(result);
    } else if (!result.valid && this$1._shouldBail(field, value)) {
      errors.push.apply(errors, result.errors);
      isExitEarly = true;
    } else {
      // promisify the result.
      promises.push(new Promise(function (resolve) { return resolve(result); }));
    }

    return isExitEarly;
  });

  if (isExitEarly) {
    return Promise.resolve({ valid: false, errors: errors, id: field.id, field: field.name, scope: field.scope });
  }

  return Promise.all(promises).then(function (results) {
    return results.reduce(function (prev, v) {
        var ref;

      if (!v.valid) {
        (ref = prev.errors).push.apply(ref, v.errors);
      }

      prev.valid = prev.valid && v.valid;

      return prev;
    }, { valid: true, errors: errors, id: field.id, field: field.name, scope: field.scope });
  });
};

Object.defineProperties( Validator.prototype, prototypeAccessors$2 );
Object.defineProperties( Validator, staticAccessors$1 );

// 

var DEFAULT_OPTIONS = {
  targetOf: null,
  immediate: false,
  scope: null,
  listen: true,
  name: null,
  rules: {},
  vm: null,
  classes: false,
  validity: true,
  aria: true,
  events: 'input|blur',
  delay: 0,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  }
};

var Field = function Field (options) {
  if ( options === void 0 ) options = {};

  this.id = uniqId();
  this.el = options.el;
  this.updated = false;
  this.dependencies = [];
  this.vmId = options.vmId;
  this.watchers = [];
  this.events = [];
  this.delay = 0;
  this.rules = {};
  this._cacheId(options);
  this.classNames = assign({}, DEFAULT_OPTIONS.classNames);
  options = assign({}, DEFAULT_OPTIONS, options);
  this._delay = !isNullOrUndefined(options.delay) ? options.delay : 0; // cache initial delay
  this.validity = options.validity;
  this.aria = options.aria;
  this.flags = createFlags();
  this.vm = options.vm;
  this.componentInstance = options.component;
  this.ctorConfig = this.componentInstance ? getPath('$options.$_veeValidate', this.componentInstance) : undefined;
  this.update(options);
  // set initial value.
  this.initialValue = this.value;
  this.updated = false;
};

var prototypeAccessors$3 = { validator: { configurable: true },isRequired: { configurable: true },isDisabled: { configurable: true },alias: { configurable: true },value: { configurable: true },bails: { configurable: true },rejectsFalse: { configurable: true } };

prototypeAccessors$3.validator.get = function () {
  if (!this.vm || !this.vm.$validator) {
    return { validate: function () {} };
  }

  return this.vm.$validator;
};

prototypeAccessors$3.isRequired.get = function () {
  return !!this.rules.required;
};

prototypeAccessors$3.isDisabled.get = function () {
  return !!(this.componentInstance && this.componentInstance.disabled) || !!(this.el && this.el.disabled);
};

/**
 * Gets the display name (user-friendly name).
 */
prototypeAccessors$3.alias.get = function () {
  if (this._alias) {
    return this._alias;
  }

  var alias = null;
  if (this.el) {
    alias = getDataAttribute(this.el, 'as');
  }

  if (!alias && this.componentInstance) {
    return this.componentInstance.$attrs && this.componentInstance.$attrs['data-vv-as'];
  }

  return alias;
};

/**
 * Gets the input value.
 */

prototypeAccessors$3.value.get = function () {
  if (!isCallable(this.getter)) {
    return undefined;
  }

  return this.getter();
};

prototypeAccessors$3.bails.get = function () {
  return this._bails;
};

/**
 * If the field rejects false as a valid value for the required rule.
 */

prototypeAccessors$3.rejectsFalse.get = function () {
  if (this.componentInstance && this.ctorConfig) {
    return !!this.ctorConfig.rejectsFalse;
  }

  if (!this.el) {
    return false;
  }

  return this.el.type === 'checkbox';
};

/**
 * Determines if the instance matches the options provided.
 */
Field.prototype.matches = function matches (options) {
    var this$1 = this;

  if (!options) {
    return true;
  }

  if (options.id) {
    return this.id === options.id;
  }

  var matchesComponentId = isNullOrUndefined(options.vmId) ? function () { return true; } : function (id) { return id === this$1.vmId; };
  if (!matchesComponentId(options.vmId)) {
    return false;
  }

  if (options.name === undefined && options.scope === undefined) {
    return true;
  }

  if (options.scope === undefined) {
    return this.name === options.name;
  }

  if (options.name === undefined) {
    return this.scope === options.scope;
  }

  return options.name === this.name && options.scope === this.scope;
};

/**
 * Caches the field id.
 */
Field.prototype._cacheId = function _cacheId (options) {
  if (this.el && !options.targetOf) {
    this.el._veeValidateId = this.id;
  }
};

/**
 * Updates the field with changed data.
 */
Field.prototype.update = function update (options) {
  this.targetOf = options.targetOf || null;
  this.immediate = options.immediate || this.immediate || false;

  // update errors scope if the field scope was changed.
  if (!isNullOrUndefined(options.scope) && options.scope !== this.scope && isCallable(this.validator.update)) {
    this.validator.update(this.id, { scope: options.scope });
  }
  this.scope = !isNullOrUndefined(options.scope) ? options.scope
    : !isNullOrUndefined(this.scope) ? this.scope : null;
  this.name = (!isNullOrUndefined(options.name) ? String(options.name) : options.name) || this.name || null;
  this.rules = options.rules !== undefined ? normalizeRules(options.rules) : this.rules;
  this._bails = options.bails !== undefined ? options.bails : this._bails;
  this.model = options.model || this.model;
  this.listen = options.listen !== undefined ? options.listen : this.listen;
  this.classes = (options.classes || this.classes || false) && !this.componentInstance;
  this.classNames = isObject(options.classNames) ? merge(this.classNames, options.classNames) : this.classNames;
  this.getter = isCallable(options.getter) ? options.getter : this.getter;
  this._alias = options.alias || this._alias;
  this.events = (options.events) ? makeEventsArray(options.events) : this.events;
  this.delay = makeDelayObject(this.events, options.delay || this.delay, this._delay);
  this.updateDependencies();
  this.addActionListeners();

  if (false) {
    warn('A field is missing a "name" or "data-vv-name" attribute');
  }

  // update required flag flags
  if (options.rules !== undefined) {
    this.flags.required = this.isRequired;
  }

  // validate if it was validated before and field was updated and there was a rules mutation.
  if (this.flags.validated && options.rules !== undefined && this.updated) {
    this.validator.validate(("#" + (this.id)));
  }

  this.updated = true;
  this.addValueListeners();

  // no need to continue.
  if (!this.el) {
    return;
  }
  this.updateClasses();
  this.updateAriaAttrs();
};

/**
 * Resets field flags and errors.
 */
Field.prototype.reset = function reset () {
    var this$1 = this;

  if (this._cancellationToken) {
    this._cancellationToken.cancelled = true;
    delete this._cancellationToken;
  }

  var defaults = createFlags();
  Object.keys(this.flags).filter(function (flag) { return flag !== 'required'; }).forEach(function (flag) {
    this$1.flags[flag] = defaults[flag];
  });

  this.addActionListeners();
  this.updateClasses();
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Sets the flags and their negated counterparts, and updates the classes and re-adds action listeners.
 */
Field.prototype.setFlags = function setFlags (flags) {
    var this$1 = this;

  var negated = {
    pristine: 'dirty',
    dirty: 'pristine',
    valid: 'invalid',
    invalid: 'valid',
    touched: 'untouched',
    untouched: 'touched'
  };

  Object.keys(flags).forEach(function (flag) {
    this$1.flags[flag] = flags[flag];
    // if it has a negation and was not specified, set it as well.
    if (negated[flag] && flags[negated[flag]] === undefined) {
      this$1.flags[negated[flag]] = !flags[flag];
    }
  });

  if (
    flags.untouched !== undefined ||
    flags.touched !== undefined ||
    flags.dirty !== undefined ||
    flags.pristine !== undefined
  ) {
    this.addActionListeners();
  }
  this.updateClasses();
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Determines if the field requires references to target fields.
*/
Field.prototype.updateDependencies = function updateDependencies () {
    var this$1 = this;

  // reset dependencies.
  this.dependencies.forEach(function (d) { return d.field.destroy(); });
  this.dependencies = [];

  // we get the selectors for each field.
  var fields = Object.keys(this.rules).reduce(function (prev, r) {
    if (Validator.isTargetRule(r)) {
      prev.push({ selector: this$1.rules[r][0], name: r });
    }

    return prev;
  }, []);

  if (!fields.length || !this.vm || !this.vm.$el) { return; }

  // must be contained within the same component, so we use the vm root element constrain our dom search.
  fields.forEach(function (ref$1) {
      var selector = ref$1.selector;
      var name = ref$1.name;

    var ref = this$1.vm.$refs[selector];
    var el = Array.isArray(ref) ? ref[0] : ref;
    if (!el) {
      return;
    }

    var options = {
      vm: this$1.vm,
      classes: this$1.classes,
      classNames: this$1.classNames,
      delay: this$1.delay,
      scope: this$1.scope,
      events: this$1.events.join('|'),
      immediate: this$1.immediate,
      targetOf: this$1.id
    };

    // probably a component.
    if (isCallable(el.$watch)) {
      options.component = el;
      options.el = el.$el;
      options.getter = Resolver.resolveGetter(el.$el, el.$vnode);
    } else {
      options.el = el;
      options.getter = Resolver.resolveGetter(el, {});
    }

    this$1.dependencies.push({ name: name, field: new Field(options) });
  });
};

/**
 * Removes listeners.
 */
Field.prototype.unwatch = function unwatch (tag) {
    if ( tag === void 0 ) tag = null;

  if (!tag) {
    this.watchers.forEach(function (w) { return w.unwatch(); });
    this.watchers = [];
    return;
  }

  this.watchers.filter(function (w) { return tag.test(w.tag); }).forEach(function (w) { return w.unwatch(); });
  this.watchers = this.watchers.filter(function (w) { return !tag.test(w.tag); });
};

/**
 * Updates the element classes depending on each field flag status.
 */
Field.prototype.updateClasses = function updateClasses () {
    var this$1 = this;

  if (!this.classes || this.isDisabled) { return; }
  var applyClasses = function (el) {
    toggleClass(el, this$1.classNames.dirty, this$1.flags.dirty);
    toggleClass(el, this$1.classNames.pristine, this$1.flags.pristine);
    toggleClass(el, this$1.classNames.touched, this$1.flags.touched);
    toggleClass(el, this$1.classNames.untouched, this$1.flags.untouched);
    // make sure we don't set any classes if the state is undetermined.
    if (!isNullOrUndefined(this$1.flags.valid) && this$1.flags.validated) {
      toggleClass(el, this$1.classNames.valid, this$1.flags.valid);
    }

    if (!isNullOrUndefined(this$1.flags.invalid) && this$1.flags.validated) {
      toggleClass(el, this$1.classNames.invalid, this$1.flags.invalid);
    }
  };

  if (!isCheckboxOrRadioInput(this.el)) {
    applyClasses(this.el);
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(applyClasses);
};

/**
 * Adds the listeners required for automatic classes and some flags.
 */
Field.prototype.addActionListeners = function addActionListeners () {
    var this$1 = this;

  // remove previous listeners.
  this.unwatch(/class/);

  if (!this.el) { return; }

  var onBlur = function () {
    this$1.flags.touched = true;
    this$1.flags.untouched = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.touched, true);
      toggleClass(this$1.el, this$1.classNames.untouched, false);
    }

    // only needed once.
    this$1.unwatch(/^class_blur$/);
  };

  var inputEvent = isTextInput(this.el) ? 'input' : 'change';
  var onInput = function () {
    this$1.flags.dirty = true;
    this$1.flags.pristine = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.pristine, false);
      toggleClass(this$1.el, this$1.classNames.dirty, true);
    }

    // only needed once.
    this$1.unwatch(/^class_input$/);
  };

  if (this.componentInstance && isCallable(this.componentInstance.$once)) {
    this.componentInstance.$once('input', onInput);
    this.componentInstance.$once('blur', onBlur);
    this.watchers.push({
      tag: 'class_input',
      unwatch: function () {
        this$1.componentInstance.$off('input', onInput);
      }
    });
    this.watchers.push({
      tag: 'class_blur',
      unwatch: function () {
        this$1.componentInstance.$off('blur', onBlur);
      }
    });
    return;
  }

  if (!this.el) { return; }

  addEventListener(this.el, inputEvent, onInput);
  // Checkboxes and radio buttons on Mac don't emit blur naturally, so we listen on click instead.
  var blurEvent = isCheckboxOrRadioInput(this.el) ? 'change' : 'blur';
  addEventListener(this.el, blurEvent, onBlur);
  this.watchers.push({
    tag: 'class_input',
    unwatch: function () {
      this$1.el.removeEventListener(inputEvent, onInput);
    }
  });

  this.watchers.push({
    tag: 'class_blur',
    unwatch: function () {
      this$1.el.removeEventListener(blurEvent, onBlur);
    }
  });
};

Field.prototype.checkValueChanged = function checkValueChanged () {
  // handle some people initialize the value to null, since text inputs have empty string value.
  if (this.initialValue === null && this.value === '' && isTextInput(this.el)) {
    return false;
  }

  return this.value !== this.initialValue;
};

/**
 * Determines the suitable primary event to listen for.
 */
Field.prototype._determineInputEvent = function _determineInputEvent () {
  // if its a custom component, use the customized model event or the input event.
  if (this.componentInstance) {
    return (this.componentInstance.$options.model && this.componentInstance.$options.model.event) || 'input';
  }

  if (this.model) {
    return this.model.lazy ? 'change' : 'input';
  }

  if (isTextInput(this.el)) {
    return 'input';
  }

  return 'change';
};

/**
 * Determines the list of events to listen to.
 */
Field.prototype._determineEventList = function _determineEventList (defaultInputEvent) {
  // if no event is configured, or it is a component or a text input then respect the user choice.
  if (!this.events.length || this.componentInstance || isTextInput(this.el)) {
    return [].concat( this.events );
  }

  // force suitable event for non-text type fields.
  return this.events.map(function (e) {
    if (e === 'input') {
      return defaultInputEvent;
    }

    return e;
  });
};

/**
 * Adds the listeners required for validation.
 */
Field.prototype.addValueListeners = function addValueListeners () {
    var this$1 = this;

  this.unwatch(/^input_.+/);
  if (!this.listen || !this.el) { return; }

  var token = { cancelled: false };
  var fn = this.targetOf ? function () {
    this$1.flags.changed = this$1.checkValueChanged();    this$1.validator.validate(("#" + (this$1.targetOf)));
  } : function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    // if its a DOM event, resolve the value, otherwise use the first parameter as the value.
    if (args.length === 0 || (isCallable(Event) && args[0] instanceof Event) || (args[0] && args[0].srcElement)) {
      args[0] = this$1.value;
    }

    this$1.flags.changed = this$1.checkValueChanged();
    this$1.validator.validate(("#" + (this$1.id)), args[0]);
  };

  var inputEvent = this._determineInputEvent();
  var events = this._determineEventList(inputEvent);

  // if there is a model and an on input validation is requested.
  if (this.model && includes(events, inputEvent)) {
    var ctx = null;
    var expression = this.model.expression;
    // if its watchable from the context vm.
    if (this.model.expression) {
      ctx = this.vm;
      expression = this.model.expression;
    }

    // watch it from the custom component vm instead.
    if (!expression && this.componentInstance && this.componentInstance.$options.model) {
      ctx = this.componentInstance;
      expression = this.componentInstance.$options.model.prop || 'value';
    }

    if (ctx && expression) {
      var debouncedFn = debounce(fn, this.delay[inputEvent], false, token);
      var unwatch = ctx.$watch(expression, function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

        this$1.flags.pending = true;
        this$1._cancellationToken = token;
        debouncedFn.apply(void 0, args);
      });
      this.watchers.push({
        tag: 'input_model',
        unwatch: unwatch
      });

      // filter out input event as it is already handled by the watcher API.
      events = events.filter(function (e) { return e !== inputEvent; });
    }
  }

  // Add events.
  events.forEach(function (e) {
    var debouncedFn = debounce(fn, this$1.delay[e], false, token);
    var validate = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      this$1.flags.pending = true;
      this$1._cancellationToken = token;
      debouncedFn.apply(void 0, args);
    };

    this$1._addComponentEventListener(e, validate);
    this$1._addHTMLEventListener(e, validate);
  });
};

Field.prototype._addComponentEventListener = function _addComponentEventListener (evt, validate) {
    var this$1 = this;

  if (!this.componentInstance) { return; }

  this.componentInstance.$on(evt, validate);
  this.watchers.push({
    tag: 'input_vue',
    unwatch: function () {
      this$1.componentInstance.$off(evt, validate);
    }
  });
};

Field.prototype._addHTMLEventListener = function _addHTMLEventListener (evt, validate) {
    var this$1 = this;

  if (!this.el || this.componentInstance) { return; }

  // listen for the current element.
  var addListener = function (el) {
    addEventListener(el, evt, validate);
    this$1.watchers.push({
      tag: 'input_native',
      unwatch: function () {
        el.removeEventListener(evt, validate);
      }
    });
  };

  addListener(this.el);
  if (!isCheckboxOrRadioInput(this.el)) {
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(function (el) {
    // skip if it is added by v-validate and is not the current element.
    if (el._veeValidateId && el !== this$1.el) {
      return;
    }

    addListener(el);
  });
};

/**
 * Updates aria attributes on the element.
 */
Field.prototype.updateAriaAttrs = function updateAriaAttrs () {
    var this$1 = this;

  if (!this.aria || !this.el || !isCallable(this.el.setAttribute)) { return; }

  var applyAriaAttrs = function (el) {
    el.setAttribute('aria-required', this$1.isRequired ? 'true' : 'false');
    el.setAttribute('aria-invalid', this$1.flags.invalid ? 'true' : 'false');
  };

  if (!isCheckboxOrRadioInput(this.el)) {
    applyAriaAttrs(this.el);
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(applyAriaAttrs);
};

/**
 * Updates the custom validity for the field.
 */
Field.prototype.updateCustomValidity = function updateCustomValidity () {
  if (!this.validity || !this.el || !isCallable(this.el.setCustomValidity) || !this.validator.errors) { return; }

  this.el.setCustomValidity(this.flags.valid ? '' : (this.validator.errors.firstById(this.id) || ''));
};

/**
 * Removes all listeners.
 */
Field.prototype.destroy = function destroy () {
  // ignore the result of any ongoing validation.
  if (this._cancellationToken) {
    this._cancellationToken.cancelled = true;
  }

  this.unwatch();
  this.dependencies.forEach(function (d) { return d.field.destroy(); });
  this.dependencies = [];
};

Object.defineProperties( Field.prototype, prototypeAccessors$3 );

// 

var FieldBag = function FieldBag (items) {
  if ( items === void 0 ) items = [];

  this.items = items || [];
};

var prototypeAccessors$4 = { length: { configurable: true } };

FieldBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
    var this$1 = this;

  var index = 0;
  return {
    next: function () {
      return { value: this$1.items[index++], done: index > this$1.items.length };
    }
  };
};

/**
 * Gets the current items length.
 */

prototypeAccessors$4.length.get = function () {
  return this.items.length;
};

/**
 * Finds the first field that matches the provided matcher object.
 */
FieldBag.prototype.find = function find$1 (matcher) {
  return find(this.items, function (item) { return item.matches(matcher); });
};

/**
 * Filters the items down to the matched fields.
 */
FieldBag.prototype.filter = function filter (matcher) {
  // multiple matchers to be tried.
  if (Array.isArray(matcher)) {
    return this.items.filter(function (item) { return matcher.some(function (m) { return item.matches(m); }); });
  }

  return this.items.filter(function (item) { return item.matches(matcher); });
};

/**
 * Maps the field items using the mapping function.
 */
FieldBag.prototype.map = function map (mapper) {
  return this.items.map(mapper);
};

/**
 * Finds and removes the first field that matches the provided matcher object, returns the removed item.
 */
FieldBag.prototype.remove = function remove (matcher) {
  var item = null;
  if (matcher instanceof Field) {
    item = matcher;
  } else {
    item = this.find(matcher);
  }

  if (!item) { return null; }

  var index = this.items.indexOf(item);
  this.items.splice(index, 1);

  return item;
};

/**
 * Adds a field item to the list.
 */
FieldBag.prototype.push = function push (item) {
  if (! (item instanceof Field)) {
    throw createError('FieldBag only accepts instances of Field that has an id defined.');
  }

  if (!item.id) {
    throw createError('Field id must be defined.');
  }

  if (this.find({ id: item.id })) {
    throw createError(("Field with id " + (item.id) + " is already added."));
  }

  this.items.push(item);
};

Object.defineProperties( FieldBag.prototype, prototypeAccessors$4 );

var ScopedValidator = function ScopedValidator (base, vm) {
  this.id = vm._uid;
  this._base = base;
  this._paused = false;

  // create a mirror bag with limited component scope.
  this.errors = new ErrorBag(base.errors, this.id);
};

var prototypeAccessors$5 = { flags: { configurable: true },rules: { configurable: true },fields: { configurable: true },dictionary: { configurable: true },locale: { configurable: true } };

prototypeAccessors$5.flags.get = function () {
    var this$1 = this;

  return this._base.fields.items.filter(function (f) { return f.vmId === this$1.id; }).reduce(function (acc, field) {
    if (field.scope) {
      if (!acc[("$" + (field.scope))]) {
        acc[("$" + (field.scope))] = {};
      }

      acc[("$" + (field.scope))][field.name] = field.flags;
    }

    acc[field.name] = field.flags;

    return acc;
  }, {});
};

prototypeAccessors$5.rules.get = function () {
  return this._base.rules;
};

prototypeAccessors$5.fields.get = function () {
  return new FieldBag(this._base.fields.filter({ vmId: this.id }));
};

prototypeAccessors$5.dictionary.get = function () {
  return this._base.dictionary;
};

prototypeAccessors$5.locale.get = function () {
  return this._base.locale;
};

prototypeAccessors$5.locale.set = function (val) {
  this._base.locale = val;
};

ScopedValidator.prototype.localize = function localize () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).localize.apply(ref, args);
};

ScopedValidator.prototype.update = function update () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).update.apply(ref, args);
};

ScopedValidator.prototype.attach = function attach (opts) {
  var attachOpts = assign({}, opts, { vmId: this.id });

  return this._base.attach(attachOpts);
};

ScopedValidator.prototype.pause = function pause () {
  this._paused = true;
};

ScopedValidator.prototype.resume = function resume () {
  this._paused = false;
};

ScopedValidator.prototype.remove = function remove (ruleName) {
  return this._base.remove(ruleName);
};

ScopedValidator.prototype.detach = function detach () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).detach.apply(ref, args.concat( [this.id] ));
};

ScopedValidator.prototype.extend = function extend () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).extend.apply(ref, args);
};

ScopedValidator.prototype.validate = function validate (descriptor, value, opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validate(descriptor, value, assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.validateAll = function validateAll (values$$1, opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validateAll(values$$1, assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.validateScopes = function validateScopes (opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validateScopes(assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.destroy = function destroy () {
  delete this.id;
  delete this._base;
};

ScopedValidator.prototype.reset = function reset (matcher) {
  return this._base.reset(Object.assign({}, matcher || {}, { vmId: this.id }));
};

ScopedValidator.prototype.flag = function flag () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).flag.apply(ref, args.concat( [this.id] ));
};

Object.defineProperties( ScopedValidator.prototype, prototypeAccessors$5 );

// 

/**
 * Checks if a parent validator instance was requested.
 */
var requestsValidator = function (injections) {
  if (isObject(injections) && injections.$validator) {
    return true;
  }

  return false;
};

var mixin = {
  provide: function provide () {
    if (this.$validator && !isBuiltInComponent(this.$vnode)) {
      return {
        $validator: this.$validator
      };
    }

    return {};
  },
  beforeCreate: function beforeCreate () {
    // if built in do nothing.
    if (isBuiltInComponent(this.$vnode)) {
      return;
    }

    // if its a root instance set the config if it exists.
    if (!this.$parent) {
      Config.merge(this.$options.$_veeValidate || {});
    }

    var options = Config.resolve(this);

    // if its a root instance, inject anyways, or if it requested a new instance.
    if (!this.$parent || (this.$options.$_veeValidate && /new/.test(this.$options.$_veeValidate.validator))) {
      this.$validator = new ScopedValidator(Config.dependency('validator'), this);
    }

    var requested = requestsValidator(this.$options.inject);

    // if automatic injection is enabled and no instance was requested.
    if (! this.$validator && options.inject && !requested) {
      this.$validator = new ScopedValidator(Config.dependency('validator'), this);
    }

    // don't inject errors or fieldBag as no validator was resolved.
    if (! requested && ! this.$validator) {
      return;
    }

    // There is a validator but it isn't injected, mark as reactive.
    if (!requested && this.$validator) {
      var Vue = this.$options._base; // the vue constructor.
      Vue.util.defineReactive(this.$validator, 'errors', this.$validator.errors);
    }

    if (! this.$options.computed) {
      this.$options.computed = {};
    }

    this.$options.computed[options.errorBagName || 'errors'] = function errorBagGetter () {
      return this.$validator.errors;
    };
    this.$options.computed[options.fieldsBagName || 'fields'] = function fieldBagGetter () {
      return this.$validator.fields.items.reduce(function (acc, field) {
        if (field.scope) {
          if (!acc[("$" + (field.scope))]) {
            acc[("$" + (field.scope))] = {};
          }

          acc[("$" + (field.scope))][field.name] = field.flags;

          return acc;
        }

        acc[field.name] = field.flags;

        return acc;
      }, {});
    };
  },
  beforeDestroy: function beforeDestroy () {
    if (this.$validator && this._uid === this.$validator.id) {
      this.$validator.errors.clear(); // remove errors generated by this component.
    }
  }
};

// 

/**
 * Finds the requested field by id from the context object.
 */
function findField (el, context) {
  if (!context || !context.$validator) {
    return null;
  }

  return context.$validator.fields.find({ id: el._veeValidateId });
}
var directive = {
  bind: function bind (el, binding, vnode) {
    var validator = vnode.context.$validator;
    if (!validator) {
      if (false) {
        warn("No validator instance is present on vm, did you forget to inject '$validator'?");
      }

      return;
    }

    var fieldOptions = Resolver.generate(el, binding, vnode);
    validator.attach(fieldOptions);
  },
  inserted: function inserted (el, binding, vnode) {
    var field = findField(el, vnode.context);
    var scope = Resolver.resolveScope(el, binding, vnode);

    // skip if scope hasn't changed.
    if (!field || scope === field.scope) { return; }

    // only update scope.
    field.update({ scope: scope });

    // allows the field to re-evaluated once more in the update hook.
    field.updated = false;
  },
  update: function update (el, binding, vnode) {
    var field = findField(el, vnode.context);

    // make sure we don't do unneccasary work if no important change was done.
    if (!field || (field.updated && isEqual(binding.value, binding.oldValue))) { return; }
    var scope = Resolver.resolveScope(el, binding, vnode);
    var rules = Resolver.resolveRules(el, binding, vnode);

    field.update({
      scope: scope,
      rules: rules
    });
  },
  unbind: function unbind (el, binding, ref) {
    var context = ref.context;

    var field = findField(el, context);
    if (!field) { return; }

    context.$validator.detach(field);
  }
};

var Vue;

function install (_Vue, options) {
  if ( options === void 0 ) options = {};

  if (Vue && _Vue === Vue) {
    if (false) {
      warn('already installed, Vue.use(VeeValidate) should only be called once.');
    }
    return;
  }

  detectPassiveSupport();
  Vue = _Vue;
  var validator = new Validator(null, options);
  var localVue = new Vue({
    data: function () { return ({
      errors: validator.errors,
      fields: validator.fields
    }); }
  });
  Config.register('vm', localVue);
  Config.register('validator', validator);
  Config.merge(options);

  var ref = Config.current;
  var dictionary = ref.dictionary;
  var i18n = ref.i18n;

  if (dictionary) {
    validator.localize(dictionary); // merge the dictionary.
  }

  var onLocaleChanged = function () {
    validator.errors.regenerate();
  };

  // watch locale changes using localVue instance or i18n.
  if (!i18n) {
    if (typeof window !== 'undefined') {
      localVue.$on('localeChanged', onLocaleChanged);
    }
  } else {
    i18n._vm.$watch('locale', onLocaleChanged);
  }

  if (!i18n && options.locale) {
    validator.localize(options.locale); // set the locale
  }

  Validator.setStrictMode(Config.current.strict);

  Vue.mixin(mixin);
  Vue.directive('validate', directive);
}

/**
 * Formates file size.
 *
 * @param {Number|String} size
 */
var formatFileSize = function (size) {
  var units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var threshold = 1024;
  size = Number(size) * threshold;
  var i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
  return (((size / Math.pow(threshold, i)).toFixed(2) * 1) + " " + (units[i]));
};

/**
 * Checks if vee-validate is defined globally.
 */
var isDefinedGlobally = function () {
  return typeof VeeValidate !== 'undefined';
};

var obj;

var messages = {
  _default: function (field) { return ("The " + field + " value is not valid."); },
  after: function (field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return ("The " + field + " must be after " + (inclusion ? 'or equal to ' : '') + target + ".");
},
  alpha_dash: function (field) { return ("The " + field + " field may contain alpha-numeric characters as well as dashes and underscores."); },
  alpha_num: function (field) { return ("The " + field + " field may only contain alpha-numeric characters."); },
  alpha_spaces: function (field) { return ("The " + field + " field may only contain alphabetic characters as well as spaces."); },
  alpha: function (field) { return ("The " + field + " field may only contain alphabetic characters."); },
  before: function (field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return ("The " + field + " must be before " + (inclusion ? 'or equal to ' : '') + target + ".");
},
  between: function (field, ref) {
    var min = ref[0];
    var max = ref[1];

    return ("The " + field + " field must be between " + min + " and " + max + ".");
},
  confirmed: function (field) { return ("The " + field + " confirmation does not match."); },
  credit_card: function (field) { return ("The " + field + " field is invalid."); },
  date_between: function (field, ref) {
    var min = ref[0];
    var max = ref[1];

    return ("The " + field + " must be between " + min + " and " + max + ".");
},
  date_format: function (field, ref) {
    var format = ref[0];

    return ("The " + field + " must be in the format " + format + ".");
},
  decimal: function (field, ref) {
    if ( ref === void 0 ) ref = [];
    var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';

    return ("The " + field + " field must be numeric and may contain " + (!decimals || decimals === '*' ? '' : decimals) + " decimal points.");
},
  digits: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field must be numeric and exactly contain " + length + " digits.");
},
  dimensions: function (field, ref) {
    var width = ref[0];
    var height = ref[1];

    return ("The " + field + " field must be " + width + " pixels by " + height + " pixels.");
},
  email: function (field) { return ("The " + field + " field must be a valid email."); },
  ext: function (field) { return ("The " + field + " field must be a valid file."); },
  image: function (field) { return ("The " + field + " field must be an image."); },
  included: function (field) { return ("The " + field + " field must be a valid value."); },
  integer: function (field) { return ("The " + field + " field must be an integer."); },
  ip: function (field) { return ("The " + field + " field must be a valid ip address."); },
  length: function (field, ref) {
    var length = ref[0];
    var max = ref[1];

    if (max) {
      return ("The " + field + " length must be between " + length + " and " + max + ".");
    }

    return ("The " + field + " length must be " + length + ".");
  },
  max: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field may not be greater than " + length + " characters.");
},
  max_value: function (field, ref) {
    var max = ref[0];

    return ("The " + field + " field must be " + max + " or less.");
},
  mimes: function (field) { return ("The " + field + " field must have a valid file type."); },
  min: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field must be at least " + length + " characters.");
},
  min_value: function (field, ref) {
    var min = ref[0];

    return ("The " + field + " field must be " + min + " or more.");
},
  excluded: function (field) { return ("The " + field + " field must be a valid value."); },
  numeric: function (field) { return ("The " + field + " field may only contain numeric characters."); },
  regex: function (field) { return ("The " + field + " field format is invalid."); },
  required: function (field) { return ("The " + field + " field is required."); },
  size: function (field, ref) {
    var size = ref[0];

    return ("The " + field + " size must be less than " + (formatFileSize(size)) + ".");
},
  url: function (field) { return ("The " + field + " field is not a valid URL."); }
};

var locale = {
  name: 'en',
  messages: messages,
  attributes: {}
};

if (isDefinedGlobally()) {
  // eslint-disable-next-line
  VeeValidate.Validator.localize(( obj = {}, obj[locale.name] = locale, obj ));
}

// 

function use (plugin, options) {
  if ( options === void 0 ) options = {};

  if (!isCallable(plugin)) {
    return warn('The plugin must be a callable function');
  }

  plugin({ Validator: Validator, ErrorBag: ErrorBag, Rules: Validator.rules }, options);
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var patterns = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/, // 0 additional digits
    /^([+-]\d{3})$/, // 1 additional digit
    /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/, // 0 additional digits
    /^([+-]\d{5})/, // 1 additional digit
    /^([+-]\d{6})/ // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // timezone tokens
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument is null, it is treated as an invalid date.
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {*} argument - the value to convert
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate (argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  if (argument === null) {
    return new Date(NaN)
  }

  var options = dirtyOptions || {};

  var additionalDigits = options.additionalDigits === undefined ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2')
  }

  // Clone the date
  if (argument instanceof Date) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone);
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = new Date(timestamp + time).getTimezoneOffset();
      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset();
    }

    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimeter);
  var timeString;

  if (patterns.plainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date
  }

  // YYYY-MM
  token = patterns.MM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    date.setUTCFullYear(year, month);
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = patterns.DDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);
    date.setUTCFullYear(year, 0, dayOfYear);
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = patterns.MMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);
    date.setUTCFullYear(year, month, day);
    return date
  }

  // YYYY-Www or YYYYWww
  token = patterns.Www.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = patterns.WwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = patterns.HH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = patterns.HHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = patterns.HHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token;
  var absoluteOffset;

  // Z
  token = patterns.timezoneZ.exec(timezoneString);
  if (token) {
    return 0
  }

  // ±hh
  token = patterns.timezoneHH.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = patterns.timezoneHHMM.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var timestamp = toDate(dirtyDate, dirtyOptions).getTime();
  var amount = Number(dirtyAmount);
  return new Date(timestamp + amount)
}

function cloneObject (dirtyObject) {
  dirtyObject = dirtyObject || {};
  var object = {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      object[property] = dirtyObject[property];
    }
  }

  return object
}

var MILLISECONDS_IN_MINUTE$2 = 60000;

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$2, dirtyOptions)
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid('2014-02-31')
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  return !isNaN(date)
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },

  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },

  halfAMinute: 'half a minute',

  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },

  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },

  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },

  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },

  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },

  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },

  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },

  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },

  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },

  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },

  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

function formatDistance (token, count, options) {
  options = options || {};

  var result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result
    } else {
      return result + ' ago'
    }
  }

  return result
}

var tokensToBeShortedPattern = /MMMM|MM|DD|dddd/g;

function buildShortLongFormat (format) {
  return format.replace(tokensToBeShortedPattern, function (token) {
    return token.slice(1)
  })
}

/**
 * @name buildFormatLongFn
 * @category Locale Helpers
 * @summary Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
 *
 * @description
 * Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
 * Returns a function which takes one of the following tokens as the argument:
 * `'LTS'`, `'LT'`, `'L'`, `'LL'`, `'LLL'`, `'l'`, `'ll'`, `'lll'`, `'llll'`
 * and returns a long format string written as `format` token strings.
 * See [format]{@link https://date-fns.org/docs/format}
 *
 * `'l'`, `'ll'`, `'lll'` and `'llll'` formats are built automatically
 * by shortening some of the tokens from corresponding unshortened formats
 * (e.g., if `LL` is `'MMMM DD YYYY'` then `ll` will be `MMM D YYYY`)
 *
 * @param {Object} obj - the object with long formats written as `format` token strings
 * @param {String} obj.LT - time format: hours and minutes
 * @param {String} obj.LTS - time format: hours, minutes and seconds
 * @param {String} obj.L - short date format: numeric day, month and year
 * @param {String} [obj.l] - short date format: numeric day, month and year (shortened)
 * @param {String} obj.LL - long date format: day, month in words, and year
 * @param {String} [obj.ll] - long date format: day, month in words, and year (shortened)
 * @param {String} obj.LLL - long date and time format
 * @param {String} [obj.lll] - long date and time format (shortened)
 * @param {String} obj.LLLL - long date, time and weekday format
 * @param {String} [obj.llll] - long date, time and weekday format (shortened)
 * @returns {Function} `formatLong` property of the locale
 *
 * @example
 * // For `en-US` locale:
 * locale.formatLong = buildFormatLongFn({
 *   LT: 'h:mm aa',
 *   LTS: 'h:mm:ss aa',
 *   L: 'MM/DD/YYYY',
 *   LL: 'MMMM D YYYY',
 *   LLL: 'MMMM D YYYY h:mm aa',
 *   LLLL: 'dddd, MMMM D YYYY h:mm aa'
 * })
 */
function buildFormatLongFn (obj) {
  var formatLongLocale = {
    LTS: obj.LTS,
    LT: obj.LT,
    L: obj.L,
    LL: obj.LL,
    LLL: obj.LLL,
    LLLL: obj.LLLL,
    l: obj.l || buildShortLongFormat(obj.L),
    ll: obj.ll || buildShortLongFormat(obj.LL),
    lll: obj.lll || buildShortLongFormat(obj.LLL),
    llll: obj.llll || buildShortLongFormat(obj.LLLL)
  };

  return function (token) {
    return formatLongLocale[token]
  }
}

var formatLong = buildFormatLongFn({
  LT: 'h:mm aa',
  LTS: 'h:mm:ss aa',
  L: 'MM/DD/YYYY',
  LL: 'MMMM D YYYY',
  LLL: 'MMMM D YYYY h:mm aa',
  LLLL: 'dddd, MMMM D YYYY h:mm aa'
});

var formatRelativeLocale = {
  lastWeek: '[last] dddd [at] LT',
  yesterday: '[yesterday at] LT',
  today: '[today at] LT',
  tomorrow: '[tomorrow at] LT',
  nextWeek: 'dddd [at] LT',
  other: 'L'
};

function formatRelative (token, date, baseDate, options) {
  return formatRelativeLocale[token]
}

/**
 * @name buildLocalizeFn
 * @category Locale Helpers
 * @summary Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale.
 *
 * @description
 * Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale
 * used by `format` function.
 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
 *
 * `localize.weekday` function takes the weekday index as argument (0 - Sunday).
 * `localize.month` takes the month index (0 - January).
 * `localize.timeOfDay` takes the hours. Use `indexCallback` to convert them to an array index (see example).
 *
 * @param {Object} values - the object with arrays of values
 * @param {String} defaultType - the default type for the localize function
 * @param {Function} [indexCallback] - the callback which takes the resulting function argument
 *   and converts it into value array index
 * @returns {Function} the resulting function
 *
 * @example
 * var timeOfDayValues = {
 *   uppercase: ['AM', 'PM'],
 *   lowercase: ['am', 'pm'],
 *   long: ['a.m.', 'p.m.']
 * }
 * locale.localize.timeOfDay = buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
 *   // 0 is a.m. array index, 1 is p.m. array index
 *   return (hours / 12) >= 1 ? 1 : 0
 * })
 * locale.localize.timeOfDay(16, {type: 'uppercase'}) //=> 'PM'
 * locale.localize.timeOfDay(5) //=> 'a.m.'
 */
function buildLocalizeFn (values, defaultType, indexCallback) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var type = options.type ? String(options.type) : defaultType;
    var valuesArray = values[type] || values[defaultType];
    var index = indexCallback ? indexCallback(Number(dirtyIndex)) : Number(dirtyIndex);
    return valuesArray[index]
  }
}

/**
 * @name buildLocalizeArrayFn
 * @category Locale Helpers
 * @summary Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
 *
 * @description
 * Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
 *
 * @param {Object} values - the object with arrays of values
 * @param {String} defaultType - the default type for the localize function
 * @returns {Function} the resulting function
 *
 * @example
 * var weekdayValues = {
 *   narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
 *   short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
 *   long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
 * }
 * locale.localize.weekdays = buildLocalizeArrayFn(weekdayValues, 'long')
 * locale.localize.weekdays({type: 'narrow'}) //=> ['Su', 'Mo', ...]
 * locale.localize.weekdays() //=> ['Sunday', 'Monday', ...]
 */
function buildLocalizeArrayFn (values, defaultType) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var type = options.type ? String(options.type) : defaultType;
    return values[type] || values[defaultType]
  }
}

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var weekdayValues = {
  narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};

var monthValues = {
  short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  long: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};

// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
// Use the system which is used the most commonly in the locale.
// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
//
//   var timeOfDayValues = {
//     any: ['in the night', 'in the morning', 'in the afternoon', 'in the evening']
//   }
//
// And later:
//
//   var localize = {
//     // The callback takes the hours as the argument and returns the array index
//     timeOfDay: buildLocalizeFn(timeOfDayValues, 'any', function (hours) {
//       if (hours >= 17) {
//         return 3
//       } else if (hours >= 12) {
//         return 2
//       } else if (hours >= 4) {
//         return 1
//       } else {
//         return 0
//       }
//     }),
//     timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'any')
//   }
var timeOfDayValues = {
  uppercase: ['AM', 'PM'],
  lowercase: ['am', 'pm'],
  long: ['a.m.', 'p.m.']
};

function ordinalNumber (dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
  // 'dayOfMonth' or 'dayOfWeek'

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

var localize = {
  ordinalNumber: ordinalNumber,
  weekday: buildLocalizeFn(weekdayValues, 'long'),
  weekdays: buildLocalizeArrayFn(weekdayValues, 'long'),
  month: buildLocalizeFn(monthValues, 'long'),
  months: buildLocalizeArrayFn(monthValues, 'long'),
  timeOfDay: buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
    return (hours / 12) >= 1 ? 1 : 0
  }),
  timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'long')
};

/**
 * @name buildMatchFn
 * @category Locale Helpers
 * @summary Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale.
 *
 * @description
 * Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale used by `parse` function.
 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
 * The result of the match function will be passed into corresponding parser function
 * (`match.weekday`, `match.month` or `match.timeOfDay` respectively. See `buildParseFn`).
 *
 * @param {Object} values - the object with RegExps
 * @param {String} defaultType - the default type for the match function
 * @returns {Function} the resulting function
 *
 * @example
 * var matchWeekdaysPatterns = {
 *   narrow: /^(su|mo|tu|we|th|fr|sa)/i,
 *   short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
 *   long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
 * }
 * locale.match.weekdays = buildMatchFn(matchWeekdaysPatterns, 'long')
 * locale.match.weekdays('Sunday', {type: 'narrow'}) //=> ['Su', 'Su', ...]
 * locale.match.weekdays('Sunday') //=> ['Sunday', 'Sunday', ...]
 */
function buildMatchFn (patterns, defaultType) {
  return function (dirtyString, dirtyOptions) {
    var options = dirtyOptions || {};
    var type = options.type ? String(options.type) : defaultType;
    var pattern = patterns[type] || patterns[defaultType];
    var string = String(dirtyString);
    return string.match(pattern)
  }
}

/**
 * @name buildParseFn
 * @category Locale Helpers
 * @summary Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale.
 *
 * @description
 * Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale used by `parse` function.
 * The argument of the resulting function is the result of the corresponding match function
 * (`match.weekdays`, `match.months` or `match.timesOfDay` respectively. See `buildMatchFn`).
 *
 * @param {Object} values - the object with arrays of RegExps
 * @param {String} defaultType - the default type for the parser function
 * @returns {Function} the resulting function
 *
 * @example
 * var parseWeekdayPatterns = {
 *   any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
 * }
 * locale.match.weekday = buildParseFn(matchWeekdaysPatterns, 'long')
 * var matchResult = locale.match.weekdays('Friday')
 * locale.match.weekday(matchResult) //=> 5
 */
function buildParseFn (patterns, defaultType) {
  return function (matchResult, dirtyOptions) {
    var options = dirtyOptions || {};
    var type = options.type ? String(options.type) : defaultType;
    var patternsArray = patterns[type] || patterns[defaultType];
    var string = matchResult[1];

    return patternsArray.findIndex(function (pattern) {
      return pattern.test(string)
    })
  }
}

/**
 * @name buildMatchPatternFn
 * @category Locale Helpers
 * @summary Build match function from a single RegExp.
 *
 * @description
 * Build match function from a single RegExp.
 * Usually used for building `match.ordinalNumbers` property of the locale.
 *
 * @param {Object} pattern - the RegExp
 * @returns {Function} the resulting function
 *
 * @example
 * locale.match.ordinalNumbers = buildMatchPatternFn(/^(\d+)(th|st|nd|rd)?/i)
 * locale.match.ordinalNumbers('3rd') //=> ['3rd', '3', 'rd', ...]
 */
function buildMatchPatternFn (pattern) {
  return function (dirtyString) {
    var string = String(dirtyString);
    return string.match(pattern)
  }
}

/**
 * @name parseDecimal
 * @category Locale Helpers
 * @summary Parses the match result into decimal number.
 *
 * @description
 * Parses the match result into decimal number.
 * Uses the string matched with the first set of parentheses of match RegExp.
 *
 * @param {Array} matchResult - the object returned by matching function
 * @returns {Number} the parsed value
 *
 * @example
 * locale.match = {
 *   ordinalNumbers: (dirtyString) {
 *     return String(dirtyString).match(/^(\d+)(th|st|nd|rd)?/i)
 *   },
 *   ordinalNumber: parseDecimal
 * }
 */
function parseDecimal (matchResult) {
  return parseInt(matchResult[1], 10)
}

var matchOrdinalNumbersPattern = /^(\d+)(th|st|nd|rd)?/i;

var matchWeekdaysPatterns = {
  narrow: /^(su|mo|tu|we|th|fr|sa)/i,
  short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};

var parseWeekdayPatterns = {
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};

var matchMonthsPatterns = {
  short: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  long: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};

var parseMonthPatterns = {
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};

// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
// Use the system which is used the most commonly in the locale.
// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
//
//   var matchTimesOfDayPatterns = {
//     long: /^((in the)? (night|morning|afternoon|evening?))/i
//   }
//
//   var parseTimeOfDayPatterns = {
//     any: [/(night|morning)/i, /(afternoon|evening)/i]
//   }
var matchTimesOfDayPatterns = {
  short: /^(am|pm)/i,
  long: /^([ap]\.?\s?m\.?)/i
};

var parseTimeOfDayPatterns = {
  any: [/^a/i, /^p/i]
};

var match = {
  ordinalNumbers: buildMatchPatternFn(matchOrdinalNumbersPattern),
  ordinalNumber: parseDecimal,
  weekdays: buildMatchFn(matchWeekdaysPatterns, 'long'),
  weekday: buildParseFn(parseWeekdayPatterns, 'any'),
  months: buildMatchFn(matchMonthsPatterns, 'long'),
  month: buildParseFn(parseMonthPatterns, 'any'),
  timesOfDay: buildMatchFn(matchTimesOfDayPatterns, 'long'),
  timeOfDay: buildParseFn(parseTimeOfDayPatterns, 'any')
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 */
var locale$1 = {
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};

var MILLISECONDS_IN_DAY$1 = 86400000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCDayOfYear (dirtyDate, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = 1;

  var date = toDate(dirtyDate, dirtyOptions);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear (dirtyDate, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();

  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear, dirtyOptions);

  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear (dirtyDate, dirtyOptions) {
  var year = getUTCISOWeekYear(dirtyDate, dirtyOptions);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary, dirtyOptions);
  return date
}

var MILLISECONDS_IN_WEEK$2 = 604800000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeek (dirtyDate, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var diff = startOfUTCISOWeek(date, dirtyOptions).getTime() - startOfUTCISOWeekYear(date, dirtyOptions).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getUTCMonth() + 1
  },

  // Month: 1st, 2nd, ..., 12th
  'Mo': function (date, options) {
    var month = date.getUTCMonth() + 1;
    return options.locale.localize.ordinalNumber(month, {unit: 'month'})
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getUTCMonth() + 1, 2)
  },

  // Month: Jan, Feb, ..., Dec
  'MMM': function (date, options) {
    return options.locale.localize.month(date.getUTCMonth(), {type: 'short'})
  },

  // Month: January, February, ..., December
  'MMMM': function (date, options) {
    return options.locale.localize.month(date.getUTCMonth(), {type: 'long'})
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getUTCMonth() + 1) / 3)
  },

  // Quarter: 1st, 2nd, 3rd, 4th
  'Qo': function (date, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    return options.locale.localize.ordinalNumber(quarter, {unit: 'quarter'})
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getUTCDate()
  },

  // Day of month: 1st, 2nd, ..., 31st
  'Do': function (date, options) {
    return options.locale.localize.ordinalNumber(date.getUTCDate(), {unit: 'dayOfMonth'})
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getUTCDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getUTCDayOfYear(date)
  },

  // Day of year: 1st, 2nd, ..., 366th
  'DDDo': function (date, options) {
    return options.locale.localize.ordinalNumber(getUTCDayOfYear(date), {unit: 'dayOfYear'})
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getUTCDayOfYear(date), 3)
  },

  // Day of week: Su, Mo, ..., Sa
  'dd': function (date, options) {
    return options.locale.localize.weekday(date.getUTCDay(), {type: 'narrow'})
  },

  // Day of week: Sun, Mon, ..., Sat
  'ddd': function (date, options) {
    return options.locale.localize.weekday(date.getUTCDay(), {type: 'short'})
  },

  // Day of week: Sunday, Monday, ..., Saturday
  'dddd': function (date, options) {
    return options.locale.localize.weekday(date.getUTCDay(), {type: 'long'})
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getUTCDay()
  },

  // Day of week: 0th, 1st, 2nd, ..., 6th
  'do': function (date, options) {
    return options.locale.localize.ordinalNumber(date.getUTCDay(), {unit: 'dayOfWeek'})
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getUTCDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getUTCISOWeek(date)
  },

  // ISO week: 1st, 2nd, ..., 53th
  'Wo': function (date, options) {
    return options.locale.localize.ordinalNumber(getUTCISOWeek(date), {unit: 'isoWeek'})
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getUTCISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getUTCFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getUTCFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getUTCISOWeekYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getUTCISOWeekYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getUTCHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getUTCHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getUTCHours();
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getUTCMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getUTCMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getUTCSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getUTCSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getUTCMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getUTCMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getUTCMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date, options) {
    var originalDate = options._originalDate || date;
    return formatTimezone(originalDate.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date, options) {
    var originalDate = options._originalDate || date;
    return formatTimezone(originalDate.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date, options) {
    var originalDate = options._originalDate || date;
    return Math.floor(originalDate.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date, options) {
    var originalDate = options._originalDate || date;
    return originalDate.getTime()
  },

  // AM, PM
  'A': function (date, options) {
    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'uppercase'})
  },

  // am, pm
  'a': function (date, options) {
    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'lowercase'})
  },

  // a.m., p.m.
  'aa': function (date, options) {
    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'long'})
  }
};

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return output
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function addUTCMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var amount = Number(dirtyAmount);
  date.setUTCMinutes(date.getUTCMinutes() + amount);
  return date
}

var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
var defaultFormattingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 * | Long format             | LT    | 05:30 a.m.                       |
 * |                         | LTS   | 05:30:15 a.m.                    |
 * |                         | L     | 07/02/1995                       |
 * |                         | l     | 7/2/1995                         |
 * |                         | LL    | July 2 1995                      |
 * |                         | ll    | Jul 2 1995                       |
 * |                         | LLL   | July 2 1995 05:30 a.m.           |
 * |                         | lll   | Jul 2 1995 05:30 a.m.            |
 * |                         | LLLL  | Sunday, July 2 1995 05:30 a.m.   |
 * |                         | llll  | Sun, Jul 2 1995 05:30 a.m.       |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};

  var locale = options.locale || locale$1;

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property')
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property')
  }

  var localeFormatters = locale.formatters || {};
  var formattingTokensRegExp = locale.formattingTokensRegExp || defaultFormattingTokensRegExp;
  var formatLong = locale.formatLong;

  var originalDate = toDate(dirtyDate, options);

  if (!isValid(originalDate, options)) {
    return 'Invalid Date'
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = originalDate.getTimezoneOffset();
  var utcDate = addUTCMinutes(originalDate, -timezoneOffset, options);

  var formatterOptions = cloneObject(options);
  formatterOptions.locale = locale;
  formatterOptions.formatters = formatters;

  // When UTC functions will be implemented, options._originalDate will likely be a part of public API.
  // Right now, please don't use it in locales. If you have to use an original date,
  // please restore it from `date`, adding a timezone offset to it.
  formatterOptions._originalDate = originalDate;

  var result = formatStr
    .replace(longFormattingTokensRegExp, function (substring) {
      if (substring[0] === '[') {
        return substring
      }

      if (substring[0] === '\\') {
        return cleanEscapedString(substring)
      }

      return formatLong(substring)
    })
    .replace(formattingTokensRegExp, function (substring) {
      var formatter = localeFormatters[substring] || formatters[substring];

      if (formatter) {
        return formatter(utcDate, formatterOptions)
      } else {
        return cleanEscapedString(substring)
      }
    });

  return result
}

function cleanEscapedString (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the mintues subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount);
  return addMinutes(dirtyDate, -amount, dirtyOptions)
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() > dateToCompare.getTime()
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() < dateToCompare.getTime()
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual$1 (dirtyLeftDate, dirtyRightDate, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = toDate(dirtyLeftDate, dirtyOptions);
  var dateRight = toDate(dirtyRightDate, dirtyOptions);
  return dateLeft.getTime() === dateRight.getTime()
}

var patterns$1 = {
  'M': /^(1[0-2]|0?\d)/, // 0 to 12
  'D': /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  'DDD': /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  'W': /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  'YYYY': /^(\d{1,4})/, // 0 to 9999
  'H': /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  'm': /^([0-5]?\d)/, // 0 to 59
  'Z': /^([+-])(\d{2}):(\d{2})/,
  'ZZ': /^([+-])(\d{2})(\d{2})/,
  singleDigit: /^(\d)/,
  twoDigits: /^(\d{2})/,
  threeDigits: /^(\d{3})/,
  fourDigits: /^(\d{4})/,
  anyDigits: /^(\d+)/
};

function parseDecimal$1 (matchResult) {
  return parseInt(matchResult[1], 10)
}

var parsers = {
  // Year: 00, 01, ..., 99
  'YY': {
    unit: 'twoDigitYear',
    match: patterns$1.twoDigits,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult)
    }
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': {
    unit: 'year',
    match: patterns$1.YYYY,
    parse: parseDecimal$1
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': {
    unit: 'isoYear',
    match: patterns$1.twoDigits,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) + 1900
    }
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': {
    unit: 'isoYear',
    match: patterns$1.YYYY,
    parse: parseDecimal$1
  },

  // Quarter: 1, 2, 3, 4
  'Q': {
    unit: 'quarter',
    match: patterns$1.singleDigit,
    parse: parseDecimal$1
  },

  // Ordinal quarter
  'Qo': {
    unit: 'quarter',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'quarter'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'quarter'})
    }
  },

  // Month: 1, 2, ..., 12
  'M': {
    unit: 'month',
    match: patterns$1.M,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) - 1
    }
  },

  // Ordinal month
  'Mo': {
    unit: 'month',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'month'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'month'}) - 1
    }
  },

  // Month: 01, 02, ..., 12
  'MM': {
    unit: 'month',
    match: patterns$1.twoDigits,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) - 1
    }
  },

  // Month: Jan, Feb, ..., Dec
  'MMM': {
    unit: 'month',
    match: function (string, options) {
      return options.locale.match.months(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.month(matchResult, {type: 'short'})
    }
  },

  // Month: January, February, ..., December
  'MMMM': {
    unit: 'month',
    match: function (string, options) {
      return options.locale.match.months(string, {type: 'long'}) ||
        options.locale.match.months(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.month(matchResult, {type: 'long'});

      if (parseResult == null) {
        parseResult = options.locale.match.month(matchResult, {type: 'short'});
      }

      return parseResult
    }
  },

  // ISO week: 1, 2, ..., 53
  'W': {
    unit: 'isoWeek',
    match: patterns$1.W,
    parse: parseDecimal$1
  },

  // Ordinal ISO week
  'Wo': {
    unit: 'isoWeek',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'isoWeek'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'isoWeek'})
    }
  },

  // ISO week: 01, 02, ..., 53
  'WW': {
    unit: 'isoWeek',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // Day of week: 0, 1, ..., 6
  'd': {
    unit: 'dayOfWeek',
    match: patterns$1.singleDigit,
    parse: parseDecimal$1
  },

  // Ordinal day of week
  'do': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfWeek'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfWeek'})
    }
  },

  // Day of week: Su, Mo, ..., Sa
  'dd': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.weekdays(string, {type: 'narrow'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.weekday(matchResult, {type: 'narrow'})
    }
  },

  // Day of week: Sun, Mon, ..., Sat
  'ddd': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.weekdays(string, {type: 'short'}) ||
        options.locale.match.weekdays(string, {type: 'narrow'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.weekday(matchResult, {type: 'short'});

      if (parseResult == null) {
        parseResult = options.locale.match.weekday(matchResult, {type: 'narrow'});
      }

      return parseResult
    }
  },

  // Day of week: Sunday, Monday, ..., Saturday
  'dddd': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.weekdays(string, {type: 'long'}) ||
        options.locale.match.weekdays(string, {type: 'short'}) ||
        options.locale.match.weekdays(string, {type: 'narrow'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.weekday(matchResult, {type: 'long'});

      if (parseResult == null) {
        parseResult = options.locale.match.weekday(matchResult, {type: 'short'});

        if (parseResult == null) {
          parseResult = options.locale.match.weekday(matchResult, {type: 'narrow'});
        }
      }

      return parseResult
    }
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': {
    unit: 'dayOfISOWeek',
    match: patterns$1.singleDigit,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult)
    }
  },

  // Day of month: 1, 2, ..., 31
  'D': {
    unit: 'dayOfMonth',
    match: patterns$1.D,
    parse: parseDecimal$1
  },

  // Ordinal day of month
  'Do': {
    unit: 'dayOfMonth',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfMonth'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfMonth'})
    }
  },

  // Day of month: 01, 02, ..., 31
  'DD': {
    unit: 'dayOfMonth',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // Day of year: 1, 2, ..., 366
  'DDD': {
    unit: 'dayOfYear',
    match: patterns$1.DDD,
    parse: parseDecimal$1
  },

  // Ordinal day of year
  'DDDo': {
    unit: 'dayOfYear',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfYear'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfYear'})
    }
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': {
    unit: 'dayOfYear',
    match: patterns$1.threeDigits,
    parse: parseDecimal$1
  },

  // AM, PM
  'A': {
    unit: 'timeOfDay',
    match: function (string, options) {
      return options.locale.match.timesOfDay(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.timeOfDay(matchResult, {type: 'short'})
    }
  },

  // a.m., p.m.
  'aa': {
    unit: 'timeOfDay',
    match: function (string, options) {
      return options.locale.match.timesOfDay(string, {type: 'long'}) ||
        options.locale.match.timesOfDay(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.timeOfDay(matchResult, {type: 'long'});

      if (parseResult == null) {
        parseResult = options.locale.match.timeOfDay(matchResult, {type: 'short'});
      }

      return parseResult
    }
  },

  // Hour: 0, 1, ... 23
  'H': {
    unit: 'hours',
    match: patterns$1.H,
    parse: parseDecimal$1
  },

  // Hour: 00, 01, ..., 23
  'HH': {
    unit: 'hours',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // Hour: 1, 2, ..., 12
  'h': {
    unit: 'timeOfDayHours',
    match: patterns$1.M,
    parse: parseDecimal$1
  },

  // Hour: 01, 02, ..., 12
  'hh': {
    unit: 'timeOfDayHours',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // Minute: 0, 1, ..., 59
  'm': {
    unit: 'minutes',
    match: patterns$1.m,
    parse: parseDecimal$1
  },

  // Minute: 00, 01, ..., 59
  'mm': {
    unit: 'minutes',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // Second: 0, 1, ..., 59
  's': {
    unit: 'seconds',
    match: patterns$1.m,
    parse: parseDecimal$1
  },

  // Second: 00, 01, ..., 59
  'ss': {
    unit: 'seconds',
    match: patterns$1.twoDigits,
    parse: parseDecimal$1
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': {
    unit: 'milliseconds',
    match: patterns$1.singleDigit,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) * 100
    }
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': {
    unit: 'milliseconds',
    match: patterns$1.twoDigits,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) * 10
    }
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': {
    unit: 'milliseconds',
    match: patterns$1.threeDigits,
    parse: parseDecimal$1
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': {
    unit: 'timezone',
    match: patterns$1.Z,
    parse: function (matchResult) {
      var sign = matchResult[1];
      var hours = parseInt(matchResult[2], 10);
      var minutes = parseInt(matchResult[3], 10);
      var absoluteOffset = hours * 60 + minutes;
      return (sign === '+') ? absoluteOffset : -absoluteOffset
    }
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': {
    unit: 'timezone',
    match: patterns$1.ZZ,
    parse: function (matchResult) {
      var sign = matchResult[1];
      var hours = parseInt(matchResult[2], 10);
      var minutes = parseInt(matchResult[3], 10);
      var absoluteOffset = hours * 60 + minutes;
      return (sign === '+') ? absoluteOffset : -absoluteOffset
    }
  },

  // Seconds timestamp: 512969520
  'X': {
    unit: 'timestamp',
    match: patterns$1.anyDigits,
    parse: function (matchResult) {
      return parseDecimal$1(matchResult) * 1000
    }
  },

  // Milliseconds timestamp: 512969520900
  'x': {
    unit: 'timestamp',
    match: patterns$1.anyDigits,
    parse: parseDecimal$1
  }
};

parsers['a'] = parsers['A'];

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCDay (dirtyDate, dirtyDay, dirtyOptions) {
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var day = Number(dirtyDay);

  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISODay (dirtyDate, dirtyDay, dirtyOptions) {
  var day = Number(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate, dirtyOptions);
  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeek (dirtyDate, dirtyISOWeek, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var isoWeek = Number(dirtyISOWeek);
  var diff = getUTCISOWeek(date, dirtyOptions) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date
}

var MILLISECONDS_IN_DAY$3 = 86400000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeekYear (dirtyDate, dirtyISOYear, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions);
  var isoYear = Number(dirtyISOYear);
  var dateStartOfYear = startOfUTCISOWeekYear(date, dirtyOptions);
  var diff = Math.floor((date.getTime() - dateStartOfYear.getTime()) / MILLISECONDS_IN_DAY$3);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(isoYear, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  date = startOfUTCISOWeekYear(fourthOfJanuary, dirtyOptions);
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

var MILLISECONDS_IN_MINUTE$6 = 60000;

function setTimeOfDay (hours, timeOfDay) {
  var isAM = timeOfDay === 0;

  if (isAM) {
    if (hours === 12) {
      return 0
    }
  } else {
    if (hours !== 12) {
      return 12 + hours
    }
  }

  return hours
}

var units = {
  twoDigitYear: {
    priority: 10,
    set: function (dateValues, value) {
      var century = Math.floor(dateValues.date.getUTCFullYear() / 100);
      var year = century * 100 + value;
      dateValues.date.setUTCFullYear(year, 0, 1);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  year: {
    priority: 10,
    set: function (dateValues, value) {
      dateValues.date.setUTCFullYear(value, 0, 1);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  isoYear: {
    priority: 10,
    set: function (dateValues, value, options) {
      dateValues.date = startOfUTCISOWeekYear(setUTCISOWeekYear(dateValues.date, value, options), options);
      return dateValues
    }
  },

  quarter: {
    priority: 20,
    set: function (dateValues, value) {
      dateValues.date.setUTCMonth((value - 1) * 3, 1);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  month: {
    priority: 30,
    set: function (dateValues, value) {
      dateValues.date.setUTCMonth(value, 1);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  isoWeek: {
    priority: 40,
    set: function (dateValues, value, options) {
      dateValues.date = startOfUTCISOWeek(setUTCISOWeek(dateValues.date, value, options), options);
      return dateValues
    }
  },

  dayOfWeek: {
    priority: 50,
    set: function (dateValues, value, options) {
      dateValues.date = setUTCDay(dateValues.date, value, options);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  dayOfISOWeek: {
    priority: 50,
    set: function (dateValues, value, options) {
      dateValues.date = setUTCISODay(dateValues.date, value, options);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  dayOfMonth: {
    priority: 50,
    set: function (dateValues, value) {
      dateValues.date.setUTCDate(value);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  dayOfYear: {
    priority: 50,
    set: function (dateValues, value) {
      dateValues.date.setUTCMonth(0, value);
      dateValues.date.setUTCHours(0, 0, 0, 0);
      return dateValues
    }
  },

  timeOfDay: {
    priority: 60,
    set: function (dateValues, value, options) {
      dateValues.timeOfDay = value;
      return dateValues
    }
  },

  hours: {
    priority: 70,
    set: function (dateValues, value, options) {
      dateValues.date.setUTCHours(value, 0, 0, 0);
      return dateValues
    }
  },

  timeOfDayHours: {
    priority: 70,
    set: function (dateValues, value, options) {
      var timeOfDay = dateValues.timeOfDay;
      if (timeOfDay != null) {
        value = setTimeOfDay(value, timeOfDay);
      }
      dateValues.date.setUTCHours(value, 0, 0, 0);
      return dateValues
    }
  },

  minutes: {
    priority: 80,
    set: function (dateValues, value) {
      dateValues.date.setUTCMinutes(value, 0, 0);
      return dateValues
    }
  },

  seconds: {
    priority: 90,
    set: function (dateValues, value) {
      dateValues.date.setUTCSeconds(value, 0);
      return dateValues
    }
  },

  milliseconds: {
    priority: 100,
    set: function (dateValues, value) {
      dateValues.date.setUTCMilliseconds(value);
      return dateValues
    }
  },

  timezone: {
    priority: 110,
    set: function (dateValues, value) {
      dateValues.date = new Date(dateValues.date.getTime() - value * MILLISECONDS_IN_MINUTE$6);
      return dateValues
    }
  },

  timestamp: {
    priority: 120,
    set: function (dateValues, value) {
      dateValues.date = new Date(value);
      return dateValues
    }
  }
};

var TIMEZONE_UNIT_PRIORITY = 110;
var MILLISECONDS_IN_MINUTE$7 = 60000;

var longFormattingTokensRegExp$1 = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
var defaultParsingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format.
 *
 * Accepted format tokens:
 * | Unit                    | Priority | Token | Input examples                   |
 * |-------------------------|----------|-------|----------------------------------|
 * | Year                    | 10       | YY    | 00, 01, ..., 99                  |
 * |                         |          | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | 10       | GG    | 00, 01, ..., 99                  |
 * |                         |          | GGGG  | 1900, 1901, ..., 2099            |
 * | Quarter                 | 20       | Q     | 1, 2, 3, 4                       |
 * |                         |          | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Month                   | 30       | M     | 1, 2, ..., 12                    |
 * |                         |          | Mo    | 1st, 2nd, ..., 12th              |
 * |                         |          | MM    | 01, 02, ..., 12                  |
 * |                         |          | MMM   | Jan, Feb, ..., Dec               |
 * |                         |          | MMMM  | January, February, ..., December |
 * | ISO week                | 40       | W     | 1, 2, ..., 53                    |
 * |                         |          | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         |          | WW    | 01, 02, ..., 53                  |
 * | Day of week             | 50       | d     | 0, 1, ..., 6                     |
 * |                         |          | do    | 0th, 1st, ..., 6th               |
 * |                         |          | dd    | Su, Mo, ..., Sa                  |
 * |                         |          | ddd   | Sun, Mon, ..., Sat               |
 * |                         |          | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | 50       | E     | 1, 2, ..., 7                     |
 * | Day of month            | 50       | D     | 1, 2, ..., 31                    |
 * |                         |          | Do    | 1st, 2nd, ..., 31st              |
 * |                         |          | DD    | 01, 02, ..., 31                  |
 * | Day of year             | 50       | DDD   | 1, 2, ..., 366                   |
 * |                         |          | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         |          | DDDD  | 001, 002, ..., 366               |
 * | Time of day             | 60       | A     | AM, PM                           |
 * |                         |          | a     | am, pm                           |
 * |                         |          | aa    | a.m., p.m.                       |
 * | Hour                    | 70       | H     | 0, 1, ... 23                     |
 * |                         |          | HH    | 00, 01, ... 23                   |
 * | Time of day hour        | 70       | h     | 1, 2, ..., 12                    |
 * |                         |          | hh    | 01, 02, ..., 12                  |
 * | Minute                  | 80       | m     | 0, 1, ..., 59                    |
 * |                         |          | mm    | 00, 01, ..., 59                  |
 * | Second                  | 90       | s     | 0, 1, ..., 59                    |
 * |                         |          | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | 100      | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | 100      | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | 100      | SSS   | 000, 001, ..., 999               |
 * | Timezone                | 110      | Z     | -01:00, +00:00, ... +12:00       |
 * |                         |          | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | 120      | X     | 512969520                        |
 * | Milliseconds timestamp  | 120      | x     | 512969520900                     |
 *
 * Values will be assigned to the date in the ascending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `baseDate` which works as a context of parsing.
 *
 * `baseDate` must be passed for correct work of the function.
 * If you're not sure which `baseDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/DD/YYYY', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `baseDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * Also, `parse` unfolds long formats like those in [format]{@link https://date-fns.org/docs/format}:
 * | Token | Input examples                 |
 * |-------|--------------------------------|
 * | LT    | 05:30 a.m.                     |
 * | LTS   | 05:30:15 a.m.                  |
 * | L     | 07/02/1995                     |
 * | l     | 7/2/1995                       |
 * | LL    | July 2 1995                    |
 * | ll    | Jul 2 1995                     |
 * | LLL   | July 2 1995 05:30 a.m.         |
 * | lll   | Jul 2 1995 05:30 a.m.          |
 * | LLLL  | Sunday, July 2 1995 05:30 a.m. |
 * | llll  | Sun, Jul 2 1995 05:30 a.m.     |
 *
 * The characters wrapped in square brackets in the format string are escaped.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `baseDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|String|Number} baseDate - the date to took the missing higher priority values from
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse(
 *   '02/11/2014',
 *   'MM/DD/YYYY',
 *   new Date()
 * )
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in English locale in the context of 2010 year:
 * import eoLocale from 'date-fns/locale/eo'
 * var result = parse(
 *   '28-a de februaro',
 *   'Do [de] MMMM',
 *   new Date(2010, 0, 1)
 *   {locale: eoLocale}
 * )
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse (dirtyDateString, dirtyFormatString, dirtyBaseDate, dirtyOptions) {
  if (arguments.length < 3) {
    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present')
  }

  var dateString = String(dirtyDateString);
  var options = dirtyOptions || {};

  var weekStartsOn = options.weekStartsOn === undefined ? 0 : Number(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var locale = options.locale || locale$1;
  var localeParsers = locale.parsers || {};
  var localeUnits = locale.units || {};

  if (!locale.match) {
    throw new RangeError('locale must contain match property')
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property')
  }

  var formatString = String(dirtyFormatString)
    .replace(longFormattingTokensRegExp$1, function (substring) {
      if (substring[0] === '[') {
        return substring
      }

      if (substring[0] === '\\') {
        return cleanEscapedString$1(substring)
      }

      return locale.formatLong(substring)
    });

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyBaseDate, options)
    } else {
      return new Date(NaN)
    }
  }

  var subFnOptions = cloneObject(options);
  subFnOptions.locale = locale;

  var tokens = formatString.match(locale.parsingTokensRegExp || defaultParsingTokensRegExp);
  var tokensLength = tokens.length;

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    set: dateToSystemTimezone,
    index: 0
  }];

  var i;
  for (i = 0; i < tokensLength; i++) {
    var token = tokens[i];
    var parser = localeParsers[token] || parsers[token];
    if (parser) {
      var matchResult;

      if (parser.match instanceof RegExp) {
        matchResult = parser.match.exec(dateString);
      } else {
        matchResult = parser.match(dateString, subFnOptions);
      }

      if (!matchResult) {
        return new Date(NaN)
      }

      var unitName = parser.unit;
      var unit = localeUnits[unitName] || units[unitName];

      setters.push({
        priority: unit.priority,
        set: unit.set,
        value: parser.parse(matchResult, subFnOptions),
        index: setters.length
      });

      var substring = matchResult[0];
      dateString = dateString.slice(substring.length);
    } else {
      var head = tokens[i].match(/^\[.*]$/) ? tokens[i].replace(/^\[|]$/g, '') : tokens[i];
      if (dateString.indexOf(head) === 0) {
        dateString = dateString.slice(head.length);
      } else {
        return new Date(NaN)
      }
    }
  }

  var uniquePrioritySetters = setters
    .map(function (setter) {
      return setter.priority
    })
    .sort(function (a, b) {
      return a - b
    })
    .filter(function (priority, index, array) {
      return array.indexOf(priority) === index
    })
    .map(function (priority) {
      return setters
        .filter(function (setter) {
          return setter.priority === priority
        })
        .reverse()
    })
    .map(function (setterArray) {
      return setterArray[0]
    });

  var date = toDate(dirtyBaseDate, options);

  if (isNaN(date)) {
    return new Date(NaN)
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
  var utcDate = subMinutes(date, date.getTimezoneOffset());

  var dateValues = {date: utcDate};

  var settersLength = uniquePrioritySetters.length;
  for (i = 0; i < settersLength; i++) {
    var setter = uniquePrioritySetters[i];
    dateValues = setter.set(dateValues, setter.value, subFnOptions);
  }

  return dateValues.date
}

function dateToSystemTimezone (dateValues) {
  var date = dateValues.date;
  var time = date.getTime();

  // Get the system timezone offset at (moment of time - offset)
  var offset = date.getTimezoneOffset();

  // Get the system timezone offset at the exact moment of time
  offset = new Date(time + offset * MILLISECONDS_IN_MINUTE$7).getTimezoneOffset();

  // Convert date in timezone "UTC+00:00" to the system timezone
  dateValues.date = new Date(time + offset * MILLISECONDS_IN_MINUTE$7);

  return dateValues
}

function cleanEscapedString$1 (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

// 

/**
 * Custom parse behavior on top of date-fns parse function.
 */
function parseDate$1 (date, format$$1) {
  if (typeof date !== 'string') {
    return isValid(date) ? date : null;
  }

  var parsed = parse(date, format$$1, new Date());

  // if date is not valid or the formatted output after parsing does not match
  // the string value passed in (avoids overflows)
  if (!isValid(parsed) || format(parsed, format$$1) !== date) {
    return null;
  }

  return parsed;
}

var afterValidator = function (value, ref) {
  var otherValue = ref[0];
  var inclusion = ref[1];
  var format$$1 = ref[2];

  if (typeof format$$1 === 'undefined') {
    format$$1 = inclusion;
    inclusion = false;
  }
  value = parseDate$1(value, format$$1);
  otherValue = parseDate$1(otherValue, format$$1);

  // if either is not valid.
  if (!value || !otherValue) {
    return false;
  }

  return isAfter(value, otherValue) || (inclusion && isEqual$1(value, otherValue));
};

var options = {
  hasTarget: true,
  isDate: true
};

var after = {
  validate: afterValidator,
  options: options
};

/**
 * Some Alpha Regex helpers.
 * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
 */

var alpha = {
  en: /^[A-Z]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[A-ZÆØÅ]*$/i,
  de: /^[A-ZÄÖÜß]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[А-ЯЁ]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[A-ZČĆŽŠĐ]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/
};

var alphaSpaces = {
  en: /^[A-Z\s]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
  da: /^[A-ZÆØÅ\s]*$/i,
  de: /^[A-ZÄÖÜß\s]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
  ru: /^[А-ЯЁ\s]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
  sr: /^[A-ZČĆŽŠĐ\s]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/
};

var alphanumeric = {
  en: /^[0-9A-Z]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[0-9A-ZÆØÅ]$/i,
  de: /^[0-9A-ZÄÖÜß]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[0-9А-ЯЁ]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/
};

var alphaDash = {
  en: /^[0-9A-Z_-]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
  da: /^[0-9A-ZÆØÅ_-]*$/i,
  de: /^[0-9A-ZÄÖÜß_-]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
  ru: /^[0-9А-ЯЁ_-]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/
};

var validate = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var locale = ref[0]; if ( locale === void 0 ) locale = null;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alpha).some(function (loc) { return alpha[loc].test(value); });
  }

  return (alpha[locale] || alpha.en).test(value);
};

var alpha$1 = {
  validate: validate
};

var validate$1 = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var locale = ref[0]; if ( locale === void 0 ) locale = null;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$1(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
  }

  return (alphaDash[locale] || alphaDash.en).test(value);
};

var alpha_dash = {
  validate: validate$1
};

var validate$2 = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var locale = ref[0]; if ( locale === void 0 ) locale = null;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$2(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
  }

  return (alphanumeric[locale] || alphanumeric.en).test(value);
};

var alpha_num = {
  validate: validate$2
};

var validate$3 = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var locale = ref[0]; if ( locale === void 0 ) locale = null;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$3(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
  }

  return (alphaSpaces[locale] || alphaSpaces.en).test(value);
};

var alpha_spaces = {
  validate: validate$3
};

var validate$4 = function (value, ref) {
  var otherValue = ref[0];
  var inclusion = ref[1];
  var format$$1 = ref[2];

  if (typeof format$$1 === 'undefined') {
    format$$1 = inclusion;
    inclusion = false;
  }
  value = parseDate$1(value, format$$1);
  otherValue = parseDate$1(otherValue, format$$1);

  // if either is not valid.
  if (!value || !otherValue) {
    return false;
  }

  return isBefore(value, otherValue) || (inclusion && isEqual$1(value, otherValue));
};

var options$1 = {
  hasTarget: true,
  isDate: true
};

var before = {
  validate: validate$4,
  options: options$1
};

var validate$5 = function (value, ref) {
  var min = ref[0];
  var max = ref[1];

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$5(val, [min, max]); });
  }

  return Number(min) <= value && Number(max) >= value;
};

var between = {
  validate: validate$5
};

var validate$6 = function (value, other) { return String(value) === String(other); };
var options$2 = {
  hasTarget: true
};

var confirmed = {
  validate: validate$6,
  options: options$2
};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var assertString_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];
});

unwrapExports(assertString_1);

var isCreditCard_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCreditCard;



var _assertString2 = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString2.default)(str);
  var sanitized = str.replace(/[- ]+/g, '');
  if (!creditCard.test(sanitized)) {
    return false;
  }
  var sum = 0;
  var digit = void 0;
  var tmpNum = void 0;
  var shouldDouble = void 0;
  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);
    if (shouldDouble) {
      tmpNum *= 2;
      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }
    shouldDouble = !shouldDouble;
  }
  return !!(sum % 10 === 0 ? sanitized : false);
}
module.exports = exports['default'];
});

var isCreditCard = unwrapExports(isCreditCard_1);

var validate$7 = function (value) { return isCreditCard(String(value)); };

var credit_card = {
  validate: validate$7
};

var validate$8 = function (value, params) {
  var assign, assign$1;

  var min$$1;
  var max$$1;
  var format$$1;
  var inclusivity = '()';

  if (params.length > 3) {
    (assign = params, min$$1 = assign[0], max$$1 = assign[1], inclusivity = assign[2], format$$1 = assign[3]);
  } else {
    (assign$1 = params, min$$1 = assign$1[0], max$$1 = assign$1[1], format$$1 = assign$1[2]);
  }

  var minDate = parseDate$1(String(min$$1), format$$1);
  var maxDate = parseDate$1(String(max$$1), format$$1);
  var dateVal = parseDate$1(String(value), format$$1);

  if (!minDate || !maxDate || !dateVal) {
    return false;
  }

  if (inclusivity === '()') {
    return isAfter(dateVal, minDate) && isBefore(dateVal, maxDate);
  }

  if (inclusivity === '(]') {
    return isAfter(dateVal, minDate) && (isEqual$1(dateVal, maxDate) || isBefore(dateVal, maxDate));
  }

  if (inclusivity === '[)') {
    return isBefore(dateVal, maxDate) && (isEqual$1(dateVal, minDate) || isAfter(dateVal, minDate));
  }

  return isEqual$1(dateVal, maxDate) || isEqual$1(dateVal, minDate) ||
    (isBefore(dateVal, maxDate) && isAfter(dateVal, minDate));
};

var options$3 = {
  isDate: true
};

var date_between = {
  validate: validate$8,
  options: options$3
};

var validate$9 = function (value, ref) {
  var format = ref[0];

  return !!parseDate$1(value, format);
};

var options$4 = {
  isDate: true
};

var date_format = {
  validate: validate$9,
  options: options$4
};

var validate$a = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';
  var separator = ref[1]; if ( separator === void 0 ) separator = '.';

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$a(val, [decimals, separator]); });
  }

  if (value === null || value === undefined || value === '') {
    return true;
  }

  // if is 0.
  if (Number(decimals) === 0) {
    return /^-?\d*$/.test(value);
  }

  var regexPart = decimals === '*' ? '+' : ("{1," + decimals + "}");
  var regex = new RegExp(("^-?\\d*(\\" + separator + "\\d" + regexPart + ")?$"));

  if (! regex.test(value)) {
    return false;
  }

  var parsedValue = parseFloat(value);

  // eslint-disable-next-line
    return parsedValue === parsedValue;
};

var decimal = {
  validate: validate$a
};

var validate$b = function (value, ref) {
  var length = ref[0];

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$b(val, [length]); });
  }
  var strVal = String(value);

  return /^[0-9]*$/.test(strVal) && strVal.length === Number(length);
};

var digits = {
  validate: validate$b
};

var validateImage = function (file, width, height) {
  var URL = window.URL || window.webkitURL;
  return new Promise(function (resolve) {
    var image = new Image();
    image.onerror = function () { return resolve({ valid: false }); };
    image.onload = function () { return resolve({
      valid: image.width === Number(width) && image.height === Number(height)
    }); };

    image.src = URL.createObjectURL(file);
  });
};

var validate$c = function (files, ref) {
  var width = ref[0];
  var height = ref[1];

  var list = [];
  for (var i = 0; i < files.length; i++) {
    // if file is not an image, reject.
    if (! /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
      return false;
    }

    list.push(files[i]);
  }

  return Promise.all(list.map(function (file) { return validateImage(file, width, height); }));
};

var dimensions = {
  validate: validate$c
};

var merge_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];
});

unwrapExports(merge_1);

var isByteLength_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isByteLength;



var _assertString2 = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];
});

unwrapExports(isByteLength_1);

var isFQDN_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;



var _assertString2 = _interopRequireDefault(assertString_1);



var _merge2 = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFQDN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  for (var i = 0; i < parts.length; i++) {
    if (parts[i].length > 63) {
      return false;
    }
  }
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    // disallow spaces
    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }
  for (var part, _i = 0; _i < parts.length; _i++) {
    part = parts[_i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];
});

unwrapExports(isFQDN_1);

var isIP_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;



var _assertString2 = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
var ipv6Block = /^[0-9A-F]{1,4}$/i;

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  (0, _assertString2.default)(str);
  version = String(version);
  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  } else if (version === '4') {
    if (!ipv4Maybe.test(str)) {
      return false;
    }
    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  } else if (version === '6') {
    var blocks = str.split(':');
    var foundOmissionBlock = false; // marker to indicate ::

    // At least some OS accept the last 32 bits of an IPv6 address
    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
    // and '::a.b.c.d' is deprecated, but also valid.
    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

    if (blocks.length > expectedNumberOfBlocks) {
      return false;
    }
    // initial or final ::
    if (str === '::') {
      return true;
    } else if (str.substr(0, 2) === '::') {
      blocks.shift();
      blocks.shift();
      foundOmissionBlock = true;
    } else if (str.substr(str.length - 2) === '::') {
      blocks.pop();
      blocks.pop();
      foundOmissionBlock = true;
    }

    for (var i = 0; i < blocks.length; ++i) {
      // test for a :: which can not be at the string start/end
      // since those cases have been handled above
      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
        if (foundOmissionBlock) {
          return false; // multiple :: in address
        }
        foundOmissionBlock = true;
      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) ; else if (!ipv6Block.test(blocks[i])) {
        return false;
      }
    }
    if (foundOmissionBlock) {
      return blocks.length >= 1;
    }
    return blocks.length === expectedNumberOfBlocks;
  }
  return false;
}
module.exports = exports['default'];
});

var isIP = unwrapExports(isIP_1);

var isEmail_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;



var _assertString2 = _interopRequireDefault(assertString_1);



var _merge2 = _interopRequireDefault(merge_1);



var _isByteLength2 = _interopRequireDefault(isByteLength_1);



var _isFQDN2 = _interopRequireDefault(isFQDN_1);



var _isIP2 = _interopRequireDefault(isIP_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();

  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase();

    // Removing sub-address from username before gmail validation
    var username = user.split('+')[0];

    // Dots are not included in gmail length restriction
    if (!(0, _isByteLength2.default)(username.replace('.', ''), { min: 6, max: 30 })) {
      return false;
    }

    var _user_parts = username.split('.');
    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    if (!options.allow_ip_domain) {
      return false;
    }

    if (!(0, _isIP2.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }

      var noBracketdomain = domain.substr(1, domain.length - 2);

      if (noBracketdomain.length === 0 || !(0, _isIP2.default)(noBracketdomain)) {
        return false;
      }
    }
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];
});

var isEmail = unwrapExports(isEmail_1);

var validate$d = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var multiple = ref[0]; if ( multiple === void 0 ) multiple = false;

  if (multiple) {
    value = value.split(',').map(function (emailStr) { return emailStr.trim(); });
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return isEmail(String(val)); });
  }

  return isEmail(String(value));
};

var email = {
  validate: validate$d
};

var validate$e = function (value, options) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$e(val, options); });
  }

  return toArray(options).some(function (item) {
    // eslint-disable-next-line
    return item == value;
  });
};

var included = {
  validate: validate$e
};

var validate$f = function () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return !validate$e.apply(void 0, args);
};

var excluded = {
  validate: validate$f
};

var validate$g = function (files, extensions) {
  var regex = new RegExp((".(" + (extensions.join('|')) + ")$"), 'i');

  return files.every(function (file) { return regex.test(file.name); });
};

var ext = {
  validate: validate$g
};

var validate$h = function (files) { return files.every(function (file) { return /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name); }); };

var image = {
  validate: validate$h
};

var validate$i = function (value) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
  }

  return /^-?[0-9]+$/.test(String(value));
};

var integer = {
  validate: validate$i
};

var validate$j = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var version = ref[0]; if ( version === void 0 ) version = 4;

  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return isIP(val, version); });
  }

  return isIP(value, version);
};

var ip = {
  validate: validate$j
};

var validate$k = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var other = ref[0];

  return value === other;
};

var is = {
  validate: validate$k
};

var validate$l = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var other = ref[0];

  return value !== other;
};

var is_not = {
  validate: validate$l
};

/**
 * @param {Array|String} value
 * @param {Number} length
 * @param {Number} max
 */
var compare = function (value, length, max) {
  if (max === undefined) {
    return value.length === length;
  }

  // cast to number.
  max = Number(max);

  return value.length >= length && value.length <= max;
};

var validate$m = function (value, ref) {
  var length = ref[0];
  var max = ref[1]; if ( max === void 0 ) max = undefined;

  length = Number(length);
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value === 'number') {
    value = String(value);
  }

  if (!value.length) {
    value = toArray(value);
  }

  return compare(value, length, max);
};

var length = {
  validate: validate$m
};

var validate$n = function (value, ref) {
  var length = ref[0];

  if (value === undefined || value === null) {
    return length >= 0;
  }

  return String(value).length <= length;
};

var max$1 = {
  validate: validate$n
};

var validate$o = function (value, ref) {
  var max = ref[0];

  if (Array.isArray(value) || value === null || value === undefined || value === '') {
    return false;
  }

  return Number(value) <= max;
};

var max_value = {
  validate: validate$o
};

var validate$p = function (files, mimes) {
  var regex = new RegExp(((mimes.join('|').replace('*', '.+')) + "$"), 'i');

  return files.every(function (file) { return regex.test(file.type); });
};

var mimes = {
  validate: validate$p
};

var validate$q = function (value, ref) {
  var length = ref[0];

  if (value === undefined || value === null) {
    return false;
  }
  return String(value).length >= length;
};

var min$1 = {
  validate: validate$q
};

var validate$r = function (value, ref) {
  var min = ref[0];

  if (Array.isArray(value) || value === null || value === undefined || value === '') {
    return false;
  }

  return Number(value) >= min;
};

var min_value = {
  validate: validate$r
};

var validate$s = function (value) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return /^[0-9]+$/.test(String(val)); });
  }

  return /^[0-9]+$/.test(String(value));
};

var numeric = {
  validate: validate$s
};

var validate$t = function (value, ref) {
  var regex = ref[0];
  var flags = ref.slice(1);

  if (regex instanceof RegExp) {
    return regex.test(value);
  }

  return new RegExp(regex, flags).test(String(value));
};

var regex = {
  validate: validate$t
};

var validate$u = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var invalidateFalse = ref[0]; if ( invalidateFalse === void 0 ) invalidateFalse = false;

  if (Array.isArray(value)) {
    return !!value.length;
  }

  // incase a field considers `false` as an empty value like checkboxes.
  if (value === false && invalidateFalse) {
    return false;
  }

  if (value === undefined || value === null) {
    return false;
  }

  return !!String(value).trim().length;
};

var required = {
  validate: validate$u
};

var validate$v = function (files, ref) {
  var size = ref[0];

  if (isNaN(size)) {
    return false;
  }

  var nSize = Number(size) * 1024;
  for (var i = 0; i < files.length; i++) {
    if (files[i].size > nSize) {
      return false;
    }
  }

  return true;
};

var size = {
  validate: validate$v
};

var isURL_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isURL;



var _assertString2 = _interopRequireDefault(assertString_1);



var _isFQDN2 = _interopRequireDefault(isFQDN_1);



var _isIP2 = _interopRequireDefault(isIP_1);



var _merge2 = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false
};

var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];
    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }
  return false;
}

function isURL(url, options) {
  (0, _assertString2.default)(url);
  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
    return false;
  }
  if (url.indexOf('mailto:') === 0) {
    return false;
  }
  options = (0, _merge2.default)(options, default_url_options);
  var protocol = void 0,
      auth = void 0,
      host = void 0,
      hostname = void 0,
      port = void 0,
      port_str = void 0,
      split = void 0,
      ipv6 = void 0;

  split = url.split('#');
  url = split.shift();

  split = url.split('?');
  url = split.shift();

  split = url.split('://');
  if (split.length > 1) {
    protocol = split.shift();
    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (url.substr(0, 2) === '//') {
    if (!options.allow_protocol_relative_urls) {
      return false;
    }
    split[0] = url.substr(2);
  }
  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');
  if (split.length > 1) {
    auth = split.shift();
    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }
  }
  hostname = split.join('@');

  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);
  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();
    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null) {
    port = parseInt(port_str, 10);
    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  }

  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
    return false;
  }
  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}
module.exports = exports['default'];
});

var isURL = unwrapExports(isURL_1);

var validate$w = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var requireProtocol = ref[0]; if ( requireProtocol === void 0 ) requireProtocol = false;

  var options = { require_protocol: !!requireProtocol, allow_underscores: true };
  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return isURL(val, options); });
  }

  return isURL(value, options);
};

var url = {
  validate: validate$w
};

/* eslint-disable camelcase */

var Rules = /*#__PURE__*/Object.freeze({
  after: after,
  alpha_dash: alpha_dash,
  alpha_num: alpha_num,
  alpha_spaces: alpha_spaces,
  alpha: alpha$1,
  before: before,
  between: between,
  confirmed: confirmed,
  credit_card: credit_card,
  date_between: date_between,
  date_format: date_format,
  decimal: decimal,
  digits: digits,
  dimensions: dimensions,
  email: email,
  ext: ext,
  image: image,
  included: included,
  integer: integer,
  length: length,
  ip: ip,
  is_not: is_not,
  is: is,
  max: max$1,
  max_value: max_value,
  mimes: mimes,
  min: min$1,
  min_value: min_value,
  excluded: excluded,
  numeric: numeric,
  regex: regex,
  required: required,
  size: size,
  url: url
});

// 

var normalize = function (fields) {
  if (Array.isArray(fields)) {
    return fields.reduce(function (prev, curr) {
      if (includes(curr, '.')) {
        prev[curr.split('.')[1]] = curr;
      } else {
        prev[curr] = curr;
      }

      return prev;
    }, {});
  }

  return fields;
};

// Combines two flags using either AND or OR depending on the flag type.
var combine = function (lhs, rhs) {
  var mapper = {
    pristine: function (lhs, rhs) { return lhs && rhs; },
    dirty: function (lhs, rhs) { return lhs || rhs; },
    touched: function (lhs, rhs) { return lhs || rhs; },
    untouched: function (lhs, rhs) { return lhs && rhs; },
    valid: function (lhs, rhs) { return lhs && rhs; },
    invalid: function (lhs, rhs) { return lhs || rhs; },
    pending: function (lhs, rhs) { return lhs || rhs; },
    required: function (lhs, rhs) { return lhs || rhs; },
    validated: function (lhs, rhs) { return lhs && rhs; }
  };

  return Object.keys(mapper).reduce(function (flags, flag) {
    flags[flag] = mapper[flag](lhs[flag], rhs[flag]);

    return flags;
  }, {});
};

var mapScope = function (scope, deep) {
  if ( deep === void 0 ) deep = true;

  return Object.keys(scope).reduce(function (flags, field) {
    if (!flags) {
      flags = assign({}, scope[field]);
      return flags;
    }

    // scope.
    var isScope = field.indexOf('$') === 0;
    if (deep && isScope) {
      return combine(mapScope(scope[field]), flags);
    } else if (!deep && isScope) {
      return flags;
    }

    flags = combine(flags, scope[field]);

    return flags;
  }, null);
};

/**
 * Maps fields to computed functions.
 */
var mapFields = function (fields) {
  if (!fields) {
    return function () {
      return mapScope(this.$validator.flags);
    };
  }

  var normalized = normalize(fields);
  return Object.keys(normalized).reduce(function (prev, curr) {
    var field = normalized[curr];
    prev[curr] = function mappedField () {
      // if field exists
      if (this.$validator.flags[field]) {
        return this.$validator.flags[field];
      }

      // scopeless fields were selected.
      if (normalized[curr] === '*') {
        return mapScope(this.$validator.flags, false);
      }

      // if it has a scope defined
      var index = field.indexOf('.');
      if (index <= 0) {
        return {};
      }

      var ref = field.split('.');
      var scope = ref[0];
      var name = ref.slice(1);

      scope = this.$validator.flags[("$" + scope)];
      name = name.join('.');

      // an entire scope was selected: scope.*
      if (name === '*' && scope) {
        return mapScope(scope);
      }

      if (scope && scope[name]) {
        return scope[name];
      }

      return {};
    };

    return prev;
  }, {});
};

var ErrorComponent = {
  name: 'vv-error',
  inject: ['$validator'],
  functional: true,
  props: {
    for: {
      type: String,
      required: true
    },
    tag: {
      type: String,
      default: 'span'
    }
  },
  render: function render (createElement, ref) {
    var props = ref.props;
    var injections = ref.injections;

    return createElement(props.tag, injections.$validator.errors.first(props.for));
  }
};

var version = '2.1.0-beta.8';

var rulesPlugin = function (ref) {
  var Validator$$1 = ref.Validator;

  Object.keys(Rules).forEach(function (rule) {
    Validator$$1.extend(rule, Rules[rule].validate, Rules[rule].options);
  });

  // Merge the english messages.
  Validator$$1.localize('en', locale);
};

use(rulesPlugin);

var index_esm = {
  install: install,
  use: use,
  directive: directive,
  mixin: mixin,
  mapFields: mapFields,
  Validator: Validator,
  ErrorBag: ErrorBag,
  ErrorComponent: ErrorComponent,
  Rules: Rules,
  version: version
};

/* unused harmony default export */ var _unused_webpack_default_export = (index_esm);



/***/ })
/******/ ]);


// WEBPACK FOOTER //
// payment.js